require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/0901f308fb0d72f9d34224d34ba4a664/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0901f308fb0d72f9d34224d34ba4a664'] = async function fn_0901f308fb0d72f9d34224d34ba4a664(Style, Component, View) {
var Counter;


  for (var count2 = 0; count2 < 1; count2++) {
    Counter = 1;
    for (var count = 0; count < 100; count++) {
      Component['opacity'] = Counter;
      await new Promise(r => setTimeout(r, 10 || 0));
      Counter = Counter - 0.01;
    }
  }
  Component['display'] = View;

}

})
define('./functions/2095d3aa27169d6e2d2b41e2265ee3f8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2095d3aa27169d6e2d2b41e2265ee3f8'] = async function fn_2095d3aa27169d6e2d2b41e2265ee3f8(Centre, Tangent) {
var Points, Calculated___Area, Calculated___Circumference, Distance, Object2, _CE_BB2, _CF_862, _CE_BB2ATAN2, _CE_BB1, _CF_861, _CE_B4, _CE_98, Co_ordiante_1, Co_ordiante_2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Co_ordiante_1 = Centre;
  Co_ordiante_2 = Tangent;
  Distance = (await (async function(lat1, lat2, lon1, lon2) {
  	const R = 6371e3; // metres
  	const φ1 = lat1 * Math.PI/180; // φ, λ in radians
  	const φ2 = lat2 * Math.PI/180;
  	const Δφ = (lat2-lat1) * Math.PI/180;
  	const Δλ = (lon2-lon1) * Math.PI/180;
  	
  	const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
  	          Math.cos(φ1) * Math.cos(φ2) *
  	          Math.sin(Δλ/2) * Math.sin(Δλ/2);
  	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  	
  	const d = R * c; // in metres
  	
  	return R * c
  })((getObjectProperty(Co_ordiante_1, 'lat')), (getObjectProperty(Co_ordiante_2, 'lat')), (getObjectProperty(Co_ordiante_1, 'lng')), (getObjectProperty(Co_ordiante_2, 'lng'))));
  Calculated___Circumference = 2 * Math.PI * Distance;
  Calculated___Area = (Math.PI * Distance * Distance) / 10000;
  _CE_B4 = (Distance / 17.5) / 6371;
  _CE_98 = 5;
  _CF_861 = (getObjectProperty(Co_ordiante_1, 'lat'));
  _CE_BB1 = (getObjectProperty(Co_ordiante_1, 'lng'));
  Points = [];
  for (var count = 0; count < 36; count++) {
    _CE_98 = _CE_98 + 10;
    _CF_862 = Math.asin(Math.sin(_CF_861 / 180 * Math.PI) * Math.cos(_CE_B4 / 180 * Math.PI) + Math.cos(_CF_861 / 180 * Math.PI) * Math.sin(_CE_B4 / 180 * Math.PI) * Math.cos(_CE_98 / 180 * Math.PI)) / Math.PI * 180;
    _CE_BB2ATAN2 = Math.atan((Math.cos(_CE_B4 / 180 * Math.PI) - Math.sin(_CF_861 / 180 * Math.PI) * Math.sin(_CF_862 / 180 * Math.PI)) / (Math.sin(_CE_98 / 180 * Math.PI) * Math.sin(_CE_B4 / 180 * Math.PI) * Math.cos(_CF_861 / 180 * Math.PI))) / Math.PI * 180;
    _CE_BB2 = _CE_BB1 + (_CE_BB2ATAN2 > 0 ? _CE_BB2ATAN2 - 90 : _CE_BB2ATAN2 + 90);
    Object2 = ({ 'lat': _CF_862,'lng': _CE_BB2 });
    addItemToList(Points, Object2);
  }

return ({ 'Radius': Distance,'Calculated - Circumference': Calculated___Circumference,'Calculated - Area': Calculated___Area,'Points': Points })
}

})
define('./functions/233da43c13d3c6c2d0ff3d9fb1718932/code.js', () => { 

BackendlessUI.Functions.Custom['fn_233da43c13d3c6c2d0ff3d9fb1718932'] = function fn_233da43c13d3c6c2d0ff3d9fb1718932(List) {
var List;


  if (List.length > 1) {
    List = List.reduce(function(x, y) {return x + y;}) / (List.length - 1);
  } else {
    List = 0;
  }

return List
}

})
define('./functions/2c2a6db614083db668e75636ea250fab/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'] = async function fn_2c2a6db614083db668e75636ea250fab(FIComponent, FIStyle, FIView, FOComponent, FOStyle, FOView) {
var Counter_FO, Counter_FI;


  FIComponent['display'] = FIView;
  FIStyle['opacity'] = 0;
  for (var count2 = 0; count2 < 1; count2++) {
    Counter_FI = 0;
    Counter_FO = 1;
    for (var count = 0; count < 100; count++) {
      FIStyle['opacity'] = Counter_FI;
      FOStyle['opacity'] = Counter_FO;
      await new Promise(r => setTimeout(r, 10 || 0));
      Counter_FI = Counter_FI + 0.01;
      Counter_FO = Counter_FO - 0.01;
    }
  }
  FOComponent['display'] = FOView;

}

})
define('./functions/30e6b79b85ff0a1d11773b745fc245aa/code.js', () => { 

BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa'] = async function fn_30e6b79b85ff0a1d11773b745fc245aa(directory) {
var userId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  userId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));

return (['users/',userId,'/',directory].join(''))
}

})
define('./functions/338b2d52d76f0736d2c3d885025856c8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_338b2d52d76f0736d2c3d885025856c8'] = function fn_338b2d52d76f0736d2c3d885025856c8(Input) {
var Rating;


  if (Input >= 1) {
    Rating = 5;
  } else if (Input < 1 && Input >= 0.98) {
    Rating = 4.5;
  } else if (Input < 0.98 && Input >= 0.96) {
    Rating = 4;
  } else if (Input < 0.96 && Input >= 0.94) {
    Rating = 3.5;
  } else if (Input < 0.94 && Input >= 0.92) {
    Rating = 3;
  } else if (Input < 0.92 && Input >= 0.9) {
    Rating = 2.5;
  } else if (Input < 0.9 && Input >= 0.88) {
    Rating = 2;
  } else if (Input < 0.88 && Input >= 0.86) {
    Rating = 1.5;
  } else if (Input < 0.86 && Input >= 0.84) {
    Rating = 1;
  } else if (Input < 0.84 && Input >= 0.82) {
    Rating = 0.5;
  } else if (Input < 0.82 && Input >= 0.8) {
    Rating = 0;
  }

return Rating
}

})
define('./functions/33cce918875b0e28ea229e91af2ba0ad/code.js', () => { 

BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'] = async function fn_33cce918875b0e28ea229e91af2ba0ad(Value) {
var Result;


  if (Value != null) {
    Result = (await (async function(value) {
    	if(typeof value !== 'number') {
    	  value = 0
    	}

    	return value.toFixed(2)
    })(Value));
  } else {
    Result = 0;
  }

return Result
}

})
define('./functions/38898908f9a3f68f3d3d2147bdb6d901/code.js', () => { 

BackendlessUI.Functions.Custom['fn_38898908f9a3f68f3d3d2147bdb6d901'] = function fn_38898908f9a3f68f3d3d2147bdb6d901(PageData) {
  PageData['Split_Del_Saver'] = true;

}

})
define('./functions/3e8b0b6172bbd0d7c17c4684ebc3473e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'] = function fn_3e8b0b6172bbd0d7c17c4684ebc3473e(Number) {
var Item;


  if (typeof Number === 'number' && !isNaN(Number)) {
    Item = Number;
  } else {
    Item = 0;
  }

return Item
}

})
define('./functions/40231e2dd0378fd17972815199986b28/code.js', () => { 

BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'] = function fn_40231e2dd0378fd17972815199986b28(addData) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



return (getObjectProperty(addData, 'currentUser'))
}

})
define('./functions/424c6f8b8fa9ba1fc714c1e2f3a1d685/code.js', () => { 

BackendlessUI.Functions.Custom['fn_424c6f8b8fa9ba1fc714c1e2f3a1d685'] = function fn_424c6f8b8fa9ba1fc714c1e2f3a1d685() {
var Start_Date;


  Start_Date = (new Date());
  Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
  Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
  Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
  Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
  Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));

return Start_Date
}

})
define('./functions/4b39e0eb366f2da977a48c7d4f818dc3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4b39e0eb366f2da977a48c7d4f818dc3'] = async function fn_4b39e0eb366f2da977a48c7d4f818dc3(List, Value) {
var Label, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Label = (getObjectProperty(((await asyncListFilter(List, async (item) => {


   return ((getObjectProperty(item, 'value')) == Value);
  }))[0]), 'label'));

return Label
}

})
define('./functions/503b7283234c81cc315a940c67023c2b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b'] = async function fn_503b7283234c81cc315a940c67023c2b(TableName, WhereClause) {
var resultList, j, tableList, offSet, pagesQuantity, i, numberOfObjects;


  resultList = [];
  numberOfObjects = (await Backendless.Data.of(TableName).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(WhereClause)));
  pagesQuantity = Math.ceil(numberOfObjects / 100);
  offSet = 0;
  var i_inc = 1;
  if (1 > pagesQuantity) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= pagesQuantity : i >= pagesQuantity; i += i_inc) {
    tableList = (await Backendless.Data.of(TableName).find(Backendless.DataQueryBuilder.create().setWhereClause(WhereClause).setPageSize(100).setOffset(offSet)));
    offSet = offSet + 100;
    for (var j_index in tableList) {
      j = tableList[j_index];
      resultList.push(j);
    }
  }

return resultList
}

})
define('./functions/518de41fac043aee8b8e5d4a87521873/code.js', () => { 

BackendlessUI.Functions.Custom['fn_518de41fac043aee8b8e5d4a87521873'] = async function fn_518de41fac043aee8b8e5d4a87521873(TableName, WhereClause, Column) {
var resultList, j, tableList, offSet, item, pagesQuantity, i, numberOfObjects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}


  resultList = [];
  numberOfObjects = (await Backendless.Data.of(TableName).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(WhereClause)));
  pagesQuantity = Math.ceil(numberOfObjects / 100);
  offSet = 0;
  var i_inc = 1;
  if (1 > pagesQuantity) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= pagesQuantity : i >= pagesQuantity; i += i_inc) {
    tableList = (await Promise.all((await Backendless.Data.of(TableName).find(Backendless.DataQueryBuilder.create().setWhereClause(WhereClause).setPageSize(100).setOffset(offSet))).map(async item => {; return (getObjectProperty(item, Column));})));
    offSet = offSet + 100;
    for (var j_index in tableList) {
      j = tableList[j_index];
      resultList.push(j);
    }
  }

return (mathMean(resultList))
}

})
define('./functions/563cfd7972fc898993eff99c8bed6189/code.js', () => { 

BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189'] = function fn_563cfd7972fc898993eff99c8bed6189(Input) {
var Viewer, Value, error;


  try {
    Value = Input;

  } catch (error) {

  } finally {
    if (error) {
      Value = null;
    } else {
      Value = Input;
    }

  }
  if (Value === null) {
    Viewer = false;
  } else {
    Viewer = Input;
  }

return Viewer
}

})
define('./functions/5a16854754a90b444dc8e7a6d99bb9e3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3'] = async function fn_5a16854754a90b444dc8e7a6d99bb9e3() {
var currentUser;


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (currentUser) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }

return currentUser
}

})
define('./functions/73996a4c829e78cd078929cb97ed2201/code.js', () => { 

BackendlessUI.Functions.Custom['fn_73996a4c829e78cd078929cb97ed2201'] = function fn_73996a4c829e78cd078929cb97ed2201(List) {
var Average, Sum, Counter, Total;


  Total = List.length;
  Counter = -1;
  Sum = 0;
  var repeat_end = List.length + 1;
  for (var count = 0; count < repeat_end; count++) {
    Counter = Counter + 1;
    Sum = Sum + ((typeof (List[(Counter - 1)]) === 'undefined') ? 0 : List[(Counter - 1)]);
  }
  Average = Sum / List.length;

return ((typeof Average === 'number' && !isNaN(Average)) ? Average : 1)
}

})
define('./functions/86b3261fa8d72ca7ec7ec6b239853d39/code.js', () => { 

BackendlessUI.Functions.Custom['fn_86b3261fa8d72ca7ec7ec6b239853d39'] = async function fn_86b3261fa8d72ca7ec7ec6b239853d39(List, Value) {
var Label, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Label = (await asyncListFilter(List, async (item) => {


   return ((getObjectProperty(item, 'value')) == Value || (getObjectProperty(item, 'objectId')) == Value);
  }))[0];

return Label
}

})
define('./functions/8944e9a7ffd2170577737788990e9b43/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8944e9a7ffd2170577737788990e9b43'] = async function fn_8944e9a7ffd2170577737788990e9b43(List) {
var Polyline, Step_3, Counter, NCoord, Coordinate, Number2, j, Step_2, Step_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    Step_1 = [];
    Step_2 = [];
    Step_3 = [];
    var j_list = (getObjectProperty(((getObjectProperty(((getObjectProperty(List, 'routes'))[0]), 'legs'))[0]), 'steps'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      addItemToList(Step_1, (await (async function(Data) {
      	function decode() {
      	  var encodedPolyline = Data;
      	  var coords = polyline.toGeoJSON(encodedPolyline);
      	  return coords
      	}
      	
      	var polyline = {};
      	
      	function encode(current, previous, factor) {
      	  current = Math.round(current * factor);
      	  previous = Math.round(previous * factor);
      	  var coordinate = current - previous;
      	  coordinate <<= 1;
      	  if (current - previous < 0) {
      	    coordinate = ~coordinate;
      	  }
      	  var output = '';
      	  while (coordinate >= 0x20) {
      	    output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
      	    coordinate >>= 5;
      	  }
      	  output += String.fromCharCode(coordinate + 63);
      	  return output;
      	}
      	
      	polyline.decode = function(str, precision) {
      	  var index = 0,
      	    lat = 0,
      	    lng = 0,
      	    coordinates = [],
      	    shift = 0,
      	    result = 0,
      	    byte = null,
      	    latitude_change,
      	    longitude_change,
      	    factor = Math.pow(10, precision || 5);
      	
      	  while (index < str.length) {
      	
      	    byte = null;
      	    shift = 0;
      	    result = 0;
      	
      	    do {
      	      byte = str.charCodeAt(index++) - 63;
      	      result |= (byte & 0x1f) << shift;
      	      shift += 5;
      	    } while (byte >= 0x20);
      	
      	    latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
      	
      	    shift = result = 0;
      	
      	    do {
      	      byte = str.charCodeAt(index++) - 63;
      	      result |= (byte & 0x1f) << shift;
      	      shift += 5;
      	    } while (byte >= 0x20);
      	
      	    longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
      	
      	    lat += latitude_change;
      	    lng += longitude_change;
      	
      	    coordinates.push([lat / factor, lng / factor]);
      	  }
      	
      	  return coordinates;
      	};
      	
      	
      	polyline.encode = function(coordinates, precision) {
      	  if (!coordinates.length) {
      	    return '';
      	  }
      	
      	  var factor = Math.pow(10, precision || 5),
      	    output = encode(coordinates[0][0], 0, factor) + encode(coordinates[0][1], 0, factor);
      	
      	  for (var i = 1; i < coordinates.length; i++) {
      	    var a = coordinates[i],
      	      b = coordinates[i - 1];
      	    output += encode(a[0], b[0], factor);
      	    output += encode(a[1], b[1], factor);
      	  }
      	
      	  return output;
      	};
      	
      	function flipped(coords) {
      	  var flipped = [];
      	  for (var i = 0; i < coords.length; i++) {
      	    flipped.push(coords[i].slice().reverse());
      	  }
      	  return flipped;
      	}
      	
      	polyline.fromGeoJSON = function(geojson, precision) {
      	  if (geojson && geojson.type === 'Feature') {
      	    geojson = geojson.geometry;
      	  }
      	  if (!geojson || geojson.type !== 'LineString') {
      	    throw new Error('Input must be a GeoJSON LineString');
      	  }
      	  return polyline.encode(flipped(geojson.coordinates), precision);
      	};
      	
      	polyline.toGeoJSON = function(str, precision) {
      	  var coords = polyline.decode(str, precision);
      	  return {
      	    type: 'LineString',
      	    coordinates: flipped(coords)
      	  };
      	};
      	
      	if (typeof module === 'object' && module.exports) {
      	  module.exports = polyline;
      	}
      	return decode()
      })((getObjectProperty((getObjectProperty(j, 'polyline')), 'points')))));
    }
    for (var j_index2 in Step_1) {
      j = Step_1[j_index2];
      addItemToList(Step_2, (getObjectProperty(j, 'coordinates')));
    }
    for (var j_index3 in Step_2) {
      j = Step_2[j_index3];
      Coordinate = ({ 'lat': j.slice(-1)[0],'lng': j[0] });
      addItemToList(Step_3, Coordinate);
    }
    Counter = Step_3.length;
    Number2 = Counter;
    for (var count = 0; count < Number2; count++) {
      Coordinate = Step_3[(Counter - 1)];
      NCoord = ({ 'lat': (getObjectProperty(Coordinate, 'lat')),'lng': (getObjectProperty(Coordinate, 'lng')) });
      addItemToList(Step_3, NCoord);
      Counter = Counter - 1;
    }

  } catch (error) {

  }
  Polyline = [({ 'description': 'Polygon','polygon': ({ 'boundary': ({ 'points': Step_3 }) }) })];

return Polyline
}

})
define('./functions/8ae41fdafafb2c62472ee008f644d7b7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8ae41fdafafb2c62472ee008f644d7b7'] = function fn_8ae41fdafafb2c62472ee008f644d7b7(pickupLocationGeoCode, waypoints, dropoffLocationGeoCode) {
return (pickupLocationGeoCode && dropoffLocationGeoCode && waypoints && !!waypoints.length ? ([pickupLocationGeoCode].concat((waypoints.concat(dropoffLocationGeoCode)))) : (pickupLocationGeoCode && !dropoffLocationGeoCode && waypoints && !!waypoints.length ? ([pickupLocationGeoCode].concat(waypoints)) : (pickupLocationGeoCode && dropoffLocationGeoCode && (!waypoints || !waypoints.length) ? ([pickupLocationGeoCode].concat(dropoffLocationGeoCode)) : (!pickupLocationGeoCode && dropoffLocationGeoCode && waypoints && !!waypoints.length ? (waypoints.concat(dropoffLocationGeoCode)) : (!pickupLocationGeoCode && !dropoffLocationGeoCode && waypoints && !!waypoints.length ? waypoints : (!pickupLocationGeoCode && dropoffLocationGeoCode && (!waypoints || !waypoints.length) ? [dropoffLocationGeoCode] : (pickupLocationGeoCode && !dropoffLocationGeoCode && (!waypoints || !waypoints.length) ? [pickupLocationGeoCode] : [])))))))
}

})
define('./functions/8fe2c41e87941e6bf7e3c4388133e6b9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8fe2c41e87941e6bf7e3c4388133e6b9'] = async function fn_8fe2c41e87941e6bf7e3c4388133e6b9(Data) {
var Polyline, newlist, Counter, Number2, Data, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Data = (await (async function(Data) {
  	function decode() {
  	  var encodedPolyline = Data;
  	  var coords = polyline.toGeoJSON(encodedPolyline);
  	  return coords
  	}
  	
  	var polyline = {};
  	
  	function encode(current, previous, factor) {
  	  current = Math.round(current * factor);
  	  previous = Math.round(previous * factor);
  	  var coordinate = current - previous;
  	  coordinate <<= 1;
  	  if (current - previous < 0) {
  	    coordinate = ~coordinate;
  	  }
  	  var output = '';
  	  while (coordinate >= 0x20) {
  	    output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
  	    coordinate >>= 5;
  	  }
  	  output += String.fromCharCode(coordinate + 63);
  	  return output;
  	}
  	
  	/**
  	 * Decodes to a [latitude, longitude] coordinates array.
  	 *
  	 * This is adapted from the implementation in Project-OSRM.
  	 *
  	 * @param {String} str
  	 * @param {Number} precision
  	 * @returns {Array}
  	 *
  	 * @see https://github.com/Project-OSRM/osrm-frontend/blob/master/WebContent/routing/OSRM.RoutingGeometry.js
  	 */
  	polyline.decode = function(str, precision) {
  	  var index = 0,
  	    lat = 0,
  	    lng = 0,
  	    coordinates = [],
  	    shift = 0,
  	    result = 0,
  	    byte = null,
  	    latitude_change,
  	    longitude_change,
  	    factor = Math.pow(10, precision || 5);
  	
  	  // Coordinates have variable length when encoded, so just keep
  	  // track of whether we've hit the end of the string. In each
  	  // loop iteration, a single coordinate is decoded.
  	  while (index < str.length) {
  	
  	    // Reset shift, result, and byte
  	    byte = null;
  	    shift = 0;
  	    result = 0;
  	
  	    do {
  	      byte = str.charCodeAt(index++) - 63;
  	      result |= (byte & 0x1f) << shift;
  	      shift += 5;
  	    } while (byte >= 0x20);
  	
  	    latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
  	
  	    shift = result = 0;
  	
  	    do {
  	      byte = str.charCodeAt(index++) - 63;
  	      result |= (byte & 0x1f) << shift;
  	      shift += 5;
  	    } while (byte >= 0x20);
  	
  	    longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
  	
  	    lat += latitude_change;
  	    lng += longitude_change;
  	
  	    coordinates.push([lat / factor, lng / factor]);
  	  }
  	
  	  return coordinates;
  	};
  	
  	/**
  	 * Encodes the given [latitude, longitude] coordinates array.
  	 *
  	 * @param {Array.<Array.<Number>>} coordinates
  	 * @param {Number} precision
  	 * @returns {String}
  	 */
  	polyline.encode = function(coordinates, precision) {
  	  if (!coordinates.length) {
  	    return '';
  	  }
  	
  	  var factor = Math.pow(10, precision || 5),
  	    output = encode(coordinates[0][0], 0, factor) + encode(coordinates[0][1], 0, factor);
  	
  	  for (var i = 1; i < coordinates.length; i++) {
  	    var a = coordinates[i],
  	      b = coordinates[i - 1];
  	    output += encode(a[0], b[0], factor);
  	    output += encode(a[1], b[1], factor);
  	  }
  	
  	  return output;
  	};
  	
  	function flipped(coords) {
  	  var flipped = [];
  	  for (var i = 0; i < coords.length; i++) {
  	    flipped.push(coords[i].slice().reverse());
  	  }
  	  return flipped;
  	}
  	
  	/**
  	 * Encodes a GeoJSON LineString feature/geometry.
  	 *
  	 * @param {Object} geojson
  	 * @param {Number} precision
  	 * @returns {String}
  	 */
  	polyline.fromGeoJSON = function(geojson, precision) {
  	  if (geojson && geojson.type === 'Feature') {
  	    geojson = geojson.geometry;
  	  }
  	  if (!geojson || geojson.type !== 'LineString') {
  	    throw new Error('Input must be a GeoJSON LineString');
  	  }
  	  return polyline.encode(flipped(geojson.coordinates), precision);
  	};
  	
  	/**
  	 * Decodes to a GeoJSON LineString geometry.
  	 *
  	 * @param {String} str
  	 * @param {Number} precision
  	 * @returns {Object}
  	 */
  	polyline.toGeoJSON = function(str, precision) {
  	  var coords = polyline.decode(str, precision);
  	  return {
  	    type: 'LineString',
  	    coordinates: flipped(coords)
  	  };
  	};
  	
  	if (typeof module === 'object' && module.exports) {
  	  module.exports = polyline;
  	}
  	return decode()
  })(Data));
  newlist = (await Promise.all((getObjectProperty(Data, 'coordinates')).map(async item => {; return ({ 'lat': item.slice(-1)[0] * 1,'lng': item[0] * 1 });})));
  Number2 = (getObjectProperty(Data, 'coordinates')).length;
  Counter = 0;
  for (var count = 0; count < Number2; count++) {
    addItemToList(newlist, ({ 'lat': (getObjectProperty(Data, 'coordinates'))[((Number2 - Counter) - 1)].slice(-1)[0],'lng': (getObjectProperty(Data, 'coordinates'))[((Number2 - Counter) - 1)][0] }));
    Counter = Counter + 1;
  }
  Polyline = [({ 'description': 'Polygon','polygon': ({ 'boundary': ({ 'points': newlist }) }) })];

return Polyline
}

})
define('./functions/959136bc4dfffa1b1bd15eec67ff865e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_959136bc4dfffa1b1bd15eec67ff865e'] = async function fn_959136bc4dfffa1b1bd15eec67ff865e(Component) {
var Item_List, properties, Where, tableName, filePath, j, Component, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Component = Component;
  Item_List = [];
  Where = (getObjectProperty(Component, 'whereClause'));
  properties = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns')).map(async item => {; return (getObjectProperty(item, 'field'));})));
  tableName = (getObjectProperty(Component, 'tableName'));
  filePath = String(getObjectProperty(Component, 'title')) + String('.csv');
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    Item_List[(getObjectProperty(j, 'field'))] = (getObjectProperty(j, 'title'));
  }
  delete Item_List['Passer'];
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': filePath,'tableName': tableName,'tableOptions': ({ 'where': Where,'properties': properties,'columnsMapping': Item_List,'excludeProps': ['objectId'] }),'csvOptions': ({ 'header': true }) })), true, undefined);

return 
}

})
define('./functions/9d16097ae78a0d52d96578bbdaa806aa/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9d16097ae78a0d52d96578bbdaa806aa'] = function fn_9d16097ae78a0d52d96578bbdaa806aa() {
return 
}

})
define('./functions/9da8ac82c3ec900f5251d58b721f4ed3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9da8ac82c3ec900f5251d58b721f4ed3'] = async function fn_9da8ac82c3ec900f5251d58b721f4ed3(Number, Region) {
var Number2;

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  Number2 = Number;
  if (Number.startsWith('0')) {
    Number2 = String(Region) + String(subsequenceFromStartLast((await BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2'](Number2)), 1));
  } else if (Number.startsWith('27')) {
    Number2 = String(Region) + String(subsequenceFromStartLast((await BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2'](Number2)), 2));
  } else if (Number.startsWith('+27')) {
    Number2 = (await BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2'](Number2));
  }

return Number2
}

})
define('./functions/a7af3aa731542a76201f20db37cbac51/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a7af3aa731542a76201f20db37cbac51'] = function fn_a7af3aa731542a76201f20db37cbac51(Test) {
return 
}

})
define('./functions/aefda8814882c0a621c48f6e160c7939/code.js', () => { 

BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'] = function fn_aefda8814882c0a621c48f6e160c7939(Value) {
var Rounded_Value;


  Rounded_Value = Math.round(Value * 100) / 100;

return Rounded_Value
}

})
define('./functions/b54552cd90056da4f155342a64faba0d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b54552cd90056da4f155342a64faba0d'] = function fn_b54552cd90056da4f155342a64faba0d(Value) {
var Value, error;


  try {
    Value = Value;

  } catch (error) {

  } finally {
    if (error) {
      Value = 0;
    }

  }

return Value
}

})
define('./functions/b663eef37391bd58152362432bc5f0bd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b663eef37391bd58152362432bc5f0bd'] = function fn_b663eef37391bd58152362432bc5f0bd(Input) {
var list;



return list
}

})
define('./functions/bdd3f9226ef42fe6ac4eb15c13fc5c19/code.js', () => { 

BackendlessUI.Functions.Custom['fn_bdd3f9226ef42fe6ac4eb15c13fc5c19'] = async function fn_bdd3f9226ef42fe6ac4eb15c13fc5c19(Company, Component, Secondary_Data, Drawer, A) {
var Passer, Title, Component, List_Items, Company, List_Item, j, Columns;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  Company = (await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10)))[0];
  Component = Component;
  List_Items = [];
  List_Item = ({ [`Test`]: null });
  var Columns_list = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns'));
  for (var Columns_index in Columns_list) {
    Columns = Columns_list[Columns_index];
    List_Item[(getObjectProperty(Columns, 'title'))] = (getObjectProperty(Columns, 'title'));
  }
  delete List_Item['Test'];
  addItemToList(List_Items, List_Item);
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'data'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    List_Item = ({ [`Test`]: null });
    var Columns_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns'));
    for (var Columns_index2 in Columns_list2) {
      Columns = Columns_list2[Columns_index2];
      List_Item[(getObjectProperty(Columns, 'title'))] = ((getObjectProperty(j, (getObjectProperty(Columns, 'field')))) == null ? '-' : (getObjectProperty(j, (getObjectProperty(Columns, 'field')))));
    }
    delete List_Item['Test'];
    addItemToList(List_Items, List_Item);
  }
  console.log(getObjectProperty(Secondary_Data, 'Rebate'));
  Title = (generateUUID().long());
  Passer = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'556004'}/data-output/${Title}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': ({ [`Logo`]: ((getObjectProperty(Company, 'Company_Logo')) === null) ? null : (getObjectProperty(Company, 'Company_Logo')),[`Company`]: (getObjectProperty(Company, 'Company')),[`Date`]: String((new Date()).toLocaleDateString()),[`Time`]: String((new Date()).toLocaleTimeString()),[`line_items`]: List_Items,[`Barcode`]: undefined,[`Header`]: (getObjectProperty(Component, 'title')),[`Cost`]: (getObjectProperty(Secondary_Data, 'Cost')),[`Litres`]: (getObjectProperty(Secondary_Data, 'Litres')),[`Meter_Diff`]: (getObjectProperty(Secondary_Data, 'Meter_Diff')),[`Mileage_Diff`]: (getObjectProperty(Secondary_Data, 'Mileage_Diff')),[`Rebate`]: (getObjectProperty(Secondary_Data, 'Rebate')) }) }));
  console.log(getObjectProperty(Passer, 'fileUrl'));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(Passer, 'fileUrl')), true, undefined);

}

})
define('./functions/c2d5df2fba6f39d269674764c0156051/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'] = async function fn_c2d5df2fba6f39d269674764c0156051(Company, Component) {
var Passer, Component, Title, List_Items, Company, List_Item, j, Columns;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  Company = (await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10)))[0];
  Component = Component;
  List_Items = [];
  List_Item = ({ [`Test`]: null });
  var Columns_list = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns'));
  for (var Columns_index in Columns_list) {
    Columns = Columns_list[Columns_index];
    List_Item[(getObjectProperty(Columns, 'title'))] = (getObjectProperty(Columns, 'title'));
  }
  delete List_Item['Test'];
  addItemToList(List_Items, List_Item);
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'data'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    List_Item = ({ [`Test`]: null });
    var Columns_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns'));
    for (var Columns_index2 in Columns_list2) {
      Columns = Columns_list2[Columns_index2];
      List_Item[(getObjectProperty(Columns, 'title'))] = ((getObjectProperty(j, (getObjectProperty(Columns, 'field')))) == null ? '-' : (getObjectProperty(j, (getObjectProperty(Columns, 'field')))));
    }
    delete List_Item['Test'];
    addItemToList(List_Items, List_Item);
  }
  Title = (generateUUID().long());
  Passer = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'556004'}/data-output/${Title}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': ({ [`Logo`]: ((getObjectProperty(Company, 'Company_Logo')) === null) ? null : (getObjectProperty(Company, 'Company_Logo')),[`Company`]: (getObjectProperty(Company, 'Company')),[`Date`]: String((new Date()).toLocaleDateString()),[`Time`]: String((new Date()).toLocaleTimeString()),[`line_items`]: List_Items,[`Barcode`]: undefined,[`Header`]: (getObjectProperty(Component, 'title')) }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(Passer, 'fileUrl')), true, undefined);

}

})
define('./functions/ce7be3665c1a526a99758d6c3def3799/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ce7be3665c1a526a99758d6c3def3799'] = async function fn_ce7be3665c1a526a99758d6c3def3799(Points) {
var Result, Actual_Perimeter, Co_ordiante_2, Co_ordiante_1, Counter, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (Points.length > 2) {
    Counter = 0;
    Actual_Perimeter = 0;
    for (var j_index in Points) {
      j = Points[j_index];
      Counter = Counter + 1;
      Co_ordiante_1 = Points[(Counter - 1)];
      if (Points.length == Counter) {
        Co_ordiante_2 = Points[0];
      } else {
        Co_ordiante_2 = Points[((Counter + 1) - 1)];
      }
      Actual_Perimeter = Actual_Perimeter + (await (async function(lat1, lat2, lon1, lon2) {
      	const R = 6371e3; // metres
      	const φ1 = lat1 * Math.PI/180; // φ, λ in radians
      	const φ2 = lat2 * Math.PI/180;
      	const Δφ = (lat2-lat1) * Math.PI/180;
      	const Δλ = (lon2-lon1) * Math.PI/180;
      	
      	const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
      	          Math.cos(φ1) * Math.cos(φ2) *
      	          Math.sin(Δλ/2) * Math.sin(Δλ/2);
      	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      	
      	const d = R * c; // in metres
      	
      	return R * c
      })((getObjectProperty(Co_ordiante_1, 'lat')), (getObjectProperty(Co_ordiante_2, 'lat')), (getObjectProperty(Co_ordiante_1, 'lng')), (getObjectProperty(Co_ordiante_2, 'lng'))));
    }
    Result = Actual_Perimeter < 0 ? Actual_Perimeter * -1 : Actual_Perimeter;
  } else {
    Result = 0;
  }

return Result
}

})
define('./functions/d3e8372ef47fc584b377b1b7d7feacb1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d3e8372ef47fc584b377b1b7d7feacb1'] = async function fn_d3e8372ef47fc584b377b1b7d7feacb1(TableName, WhereClause, Column) {
var resultList, error, j, tableList, offSet, item, pagesQuantity, i, numberOfObjects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    resultList = [];
    numberOfObjects = (await Backendless.Data.of(TableName).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(WhereClause)));
    pagesQuantity = Math.ceil(numberOfObjects / 100);
    offSet = 0;
    var i_inc = 1;
    if (1 > pagesQuantity) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= pagesQuantity : i >= pagesQuantity; i += i_inc) {
      tableList = (await Promise.all((await Backendless.Data.of(TableName).find(Backendless.DataQueryBuilder.create().setWhereClause(WhereClause).setPageSize(100).setOffset(offSet))).map(async item => {; return (getObjectProperty(item, Column));})));
      offSet = offSet + 100;
      for (var j_index in tableList) {
        j = tableList[j_index];
        resultList.push(j);
      }
    }

  } catch (error) {

  } finally {
    if (error) {
      resultList = [0, 0, 0];
    }

  }

return (resultList.reduce(function(x, y) {return x + y;}))
}

})
define('./functions/d96847d1093fd875b491b9b680ebf2a2/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2'] = async function fn_d96847d1093fd875b491b9b680ebf2a2(Text) {
return (await (async function(Text) {
	var str = Text;
	const allSpacesRemoved = str.replaceAll(' ', '');
	
	return allSpacesRemoved
})(Text))
}

})
define('./functions/db2a94a2683ef72bc8ce14f58ffa2916/code.js', () => { 

BackendlessUI.Functions.Custom['fn_db2a94a2683ef72bc8ce14f58ffa2916'] = function fn_db2a94a2683ef72bc8ce14f58ffa2916(Value, Decimals) {
return (Math.round(Decimals * Math.pow(10,Value + 1)) / Math.pow(10,Value + 1))
}

})
define('./functions/e02a005b825c1b5f2d431f15836a4cf5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e02a005b825c1b5f2d431f15836a4cf5'] = async function fn_e02a005b825c1b5f2d431f15836a4cf5(addData) {
var Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Customer = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));

return Customer
}

})
define('./functions/e64d2d6c337f7843b7a85a3ed54b83cf/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e64d2d6c337f7843b7a85a3ed54b83cf'] = async function fn_e64d2d6c337f7843b7a85a3ed54b83cf(Component) {
var columnsMapping, properties, Where, tableName, filePath, j, Component, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Component = Component;
  columnsMapping = ({ 'Passer': null });
  Where = (getObjectProperty(Component, 'whereClause'));
  properties = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns')).map(async item => {; return (getObjectProperty(item, 'field'));})));
  tableName = (getObjectProperty(Component, 'tableName'));
  filePath = String(getObjectProperty(Component, 'title')) + String('.csv');
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    columnsMapping[(getObjectProperty(j, 'field'))] = (getObjectProperty(j, 'title'));
  }
  delete columnsMapping['Passer'];
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': filePath,'tableName': tableName,'tableOptions': ({ 'where': Where,'properties': properties,'columnsMapping': columnsMapping,'excludeProps': ['objectId'] }),'csvOptions': ({ 'header': true }) })), true, undefined);

}

})
define('./functions/eca5321dc52b7917c149a843e84805c7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_eca5321dc52b7917c149a843e84805c7'] = function fn_eca5321dc52b7917c149a843e84805c7(x, y) {
var Result;


  Result = Math.atan(y / x) / Math.PI * 180;

return Result
}

})
define('./functions/f1bf64c5c5a6dd6f25dd14c4bf39499e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f1bf64c5c5a6dd6f25dd14c4bf39499e'] = async function fn_f1bf64c5c5a6dd6f25dd14c4bf39499e(Style, Component, View) {
var Counter;


  Component['display'] = View;
  for (var count2 = 0; count2 < 1; count2++) {
    Counter = 0;
    for (var count = 0; count < 100; count++) {
      Style['opacity'] = Counter;
      await new Promise(r => setTimeout(r, 10 || 0));
      console.log(Counter);
      Counter = Counter + 0.01;
    }
  }

}

})
define('./functions/f3398cab771c7281f65827bb29f68e26/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'] = async function fn_f3398cab771c7281f65827bb29f68e26(appData) {
var currentUser, error, errorCode;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](appData))) {
    try {
      currentUser = (await Backendless.UserService.getCurrentUser(false));

    } catch (error) {
      errorCode = (getObjectProperty(error, 'code'));
      if (errorCode == 3064) {
        await Backendless.UserService.logout();
      }
      console.log(error);

    }
    appData['currentUser'] = currentUser;
  }

}

})
define('./functions/f7839a0ba6eb54c7a482388cb6acdbe8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f7839a0ba6eb54c7a482388cb6acdbe8'] = async function fn_f7839a0ba6eb54c7a482388cb6acdbe8(origin, destination, waypoints, AvoidInRoutes, trip) {
var dir;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (origin && destination) {
    if (waypoints) {
      dir = (await Backendless.Request.post(`${Backendless.appPath}/services/MapAPIServices/directions`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'avoid': AvoidInRoutes,'origin': origin,'waypoints': waypoints,'destination': destination,'units': 'metric' }));
    } else {
      dir = (await Backendless.Request.post(`${Backendless.appPath}/services/MapAPIServices/directions`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'avoid': AvoidInRoutes,'origin': origin,'waypoints': waypoints,'destination': destination,'units': 'metric' }));
    }
    console.log('dir from function');
    console.log(dir);
    trip['distance'] = (getObjectProperty(((getObjectProperty(((getObjectProperty(dir, 'routes'))[0]), 'legs'))[0]), 'distance'));
    console.log('distance from function');
    console.log(getObjectProperty(trip, 'distance'));
    trip['duration'] = (getObjectProperty(((getObjectProperty(((getObjectProperty(dir, 'routes'))[0]), 'legs'))[0]), 'duration'));
    console.log('duration from function');
    console.log(getObjectProperty(trip, 'duration'));
  }

}

})
define('./functions/fa967009987c607bdead79e8a14b3d7d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_fa967009987c607bdead79e8a14b3d7d'] = async function fn_fa967009987c607bdead79e8a14b3d7d(TableName, WhereClause, Column, Sort) {
var resultList, j, tableList, offSet, item, pagesQuantity, i, numberOfObjects;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  resultList = [];
  numberOfObjects = (await Backendless.Data.of(TableName).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(WhereClause)));
  pagesQuantity = Math.ceil(numberOfObjects / 100);
  offSet = 0;
  var i_inc = 1;
  if (1 > pagesQuantity) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= pagesQuantity : i >= pagesQuantity; i += i_inc) {
    tableList = (await Promise.all((await Backendless.Data.of(TableName).find(Backendless.DataQueryBuilder.create().setWhereClause(WhereClause).setSortBy(([Column,' ',Sort].join(''))).setPageSize(100).setOffset(offSet))).map(async item => {; return (getObjectProperty(item, Column));})));
    offSet = offSet + 100;
    for (var j_index in tableList) {
      j = tableList[j_index];
      resultList.push(j);
    }
  }

return resultList
}

})
define('./pages/404/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/Add_Fuel_Office/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('e773c60132fec7187286c791e4ed5eba', (await asyncListSort((await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Horse_Registration')),[`value`]: (getObjectProperty(item, 'objectId')) });}))), 1, async (item) => {


   return (getObjectProperty(item, 'label'));
  })));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('f9efc741480f51522de7a8d80393cf25', (await asyncListSort((await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' ','AND User_level = \'Driver\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'displayName')),[`value`]: (getObjectProperty(item, 'objectId')) });}))), 1, async (item) => {


   return (getObjectProperty(item, 'label'));
  })));

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Add_Fuel_Office/components/23eef22b5c313da3b0c90962a99b42c5/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), 'image')))

  },
  /* handler:onDisplayAssignment *//* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('Posts'))

  },
  /* handler:onDirectoryAssignment */
/* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split('.').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment *//* content */
}));

define('./pages/Add_Fuel_Office/components/609885542943085abe1a49544fbddf5c/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Owner, item, Horse_Reg, Trailer3_Reg, Trailer2_Reg, Trailer1_Reg, Horse_Data, Driver, Horse, Trailers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Driver = (await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f9efc741480f51522de7a8d80393cf25')),'\''].join(''))).setPageSize(10)))[0];
  Horse_Data = (await Backendless.Data.of('Vehicles').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e773c60132fec7187286c791e4ed5eba')), ));
  Horse_Reg = (getObjectProperty(Horse_Data, 'Horse_Registration'));
  Trailers = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',Horse_Reg,'\''].join(''))).setPageSize(100)));
  try {
    Trailer1_Reg = (getObjectProperty((Trailers[0]), 'Trailer_Registration'));

  } catch (error) {

  }
  try {
    Trailer2_Reg = (getObjectProperty((Trailers[0]), 'Trailer_Registration'));

  } catch (error) {

  }
  try {
    Trailer3_Reg = (getObjectProperty((Trailers[1]), 'Trailer_Registration'));

  } catch (error) {

  }
  if ((getObjectProperty(___arguments.context.pageData, 'Other_Expense')) == 'Other') {
    if ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 8000 && (getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
      if (!(getObjectProperty(___arguments.context.dataModel, 'SubmitFuel'))) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65231cd243ff11bef9c77719b028e65f', true);
        ___arguments.context.dataModel['SubmitFuel'] = true;
        Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
        ___arguments.context.pageData['NewFuel'] = (await Backendless.Data.of('Other').save( ({ [`Ideal_Fuel_Consumption`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty((await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), )), 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0],[`Type`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e71b44983f265212b5131fc8fb4dc417')),[`Driver`]: (getObjectProperty((await Backendless.Data.of('Users').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f9efc741480f51522de7a8d80393cf25')), )), 'displayName')),[`Registration`]: (getObjectProperty(Horse, 'Horse_Registration')),[`Mileage_Differential`]: (getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')),[`image`]: (getObjectProperty(___arguments.context.dataModel, 'image')),[`description`]: (getObjectProperty(___arguments.context.dataModel, 'description')),[`Outlet`]: (getObjectProperty(___arguments.context.dataModel, 'garage')),[`mileage`]: (getObjectProperty(___arguments.context.dataModel, 'mileage')),[`cost`]: (getObjectProperty(___arguments.context.dataModel, 'cost')) }) ));
        ___arguments.context.pageData['Selected_Reg'] = (getObjectProperty(___arguments.context.pageData, 'Got_Mileage'));
        await Backendless.Data.of('Other').setRelation((getObjectProperty(___arguments.context.pageData, 'NewFuel')), 'reg', [(getObjectProperty(___arguments.context.pageData, 'Selected_Reg'))]);
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Post', undefined);
      }
    } else {
      ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible_Mileage';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('576155c6897967125f086d6bf7d5885a', true);
    }
  } else {
    if ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 8000 && (getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
      if (!(getObjectProperty(___arguments.context.dataModel, 'SubmitFuel'))) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65231cd243ff11bef9c77719b028e65f', true);
        Owner = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
        ___arguments.context.dataModel['SubmitFuel'] = true;
        ___arguments.context.pageData['NewFuel'] = (await Backendless.Data.of('Fuel').save( ({ [`reg_objectId`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e773c60132fec7187286c791e4ed5eba')),[`ownerId`]: Owner,[`Gain_Loss`]: (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(___arguments.context.dataModel, 'cost')) / (getObjectProperty(___arguments.context.dataModel, 'litres'))) * (((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty((await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), )), 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0]) - (getObjectProperty(___arguments.context.dataModel, 'cost'))))),[`Ideal_Fuel_Consumption`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty((await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), )), 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0],[`Driver`]: (getObjectProperty(Driver, 'displayName')),[`Registration`]: Horse_Reg,[`Fuel_Consumption`]: ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))) / (getObjectProperty(___arguments.context.dataModel, 'litres')),[`Mileage_Differential`]: (getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')),[`image`]: (getObjectProperty(___arguments.context.dataModel, 'image')),[`description`]: (getObjectProperty(___arguments.context.dataModel, 'description')),[`garage`]: (getObjectProperty(___arguments.context.dataModel, 'garage')),[`mileage`]: (getObjectProperty(___arguments.context.dataModel, 'mileage')),[`litres`]: (getObjectProperty(___arguments.context.dataModel, 'litres')),[`cost`]: (getObjectProperty(___arguments.context.dataModel, 'cost')),[`location`]: undefined,[`Horse_Registration`]: Horse_Reg,[`Contractor_Km_Rate`]: (getObjectProperty(Driver, 'Contractor_Km_Rate')),[`Good_Driving_Rate`]: (getObjectProperty(Driver, 'Good_Driving_Rate')) }) ));
        ___arguments.context.pageData['Selected_Reg'] = (getObjectProperty(___arguments.context.pageData, 'Got_Mileage'));
        Horse_Data['Current_Mileage'] = (((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Reg')), 'Current_Mileage')));
        await Backendless.Data.of('Vehicles').save( Horse_Data );
        await Backendless.Data.of('Fuel').setRelation((getObjectProperty(___arguments.context.pageData, 'NewFuel')), 'reg', [Horse_Data]);
        try {
          await Backendless.Data.of('Tyres').bulkUpsert( (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',Horse_Reg,'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Current_Mileage`]: (getObjectProperty(item, 'Current_Mileage')) + ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))),[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: Owner });}))) );

        } catch (error) {

        }
        try {
          await Backendless.Data.of('Tyres').bulkUpsert( (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',Trailer1_Reg,'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Current_Mileage`]: (getObjectProperty(item, 'Current_Mileage')) + ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))),[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: Owner });}))) );

        } catch (error) {

        }
        try {
          await Backendless.Data.of('Tyres').bulkUpsert( (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',Trailer2_Reg,'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Current_Mileage`]: (getObjectProperty(item, 'Current_Mileage')) + ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))),[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: Owner });}))) );

        } catch (error) {

        }
        try {
          await Backendless.Data.of('Tyres').bulkUpsert( (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',Trailer3_Reg,'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Current_Mileage`]: (getObjectProperty(item, 'Current_Mileage')) + ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))),[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: Owner });}))) );

        } catch (error) {

        }
        try {
          await Backendless.Data.of('Trailers').bulkUpsert( (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',Horse_Reg,'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Current_Mileage`]: (getObjectProperty(item, 'Current_Mileage')) + ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))),[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: Owner });}))) );

        } catch (error) {

        }
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
      }
    } else {
      ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible_Mileage';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('576155c6897967125f086d6bf7d5885a', true);
    }
  }

  },
  /* handler:onSubmit *//* handler:onBeforeUnmount */
  async onBeforeUnmount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Fuel').setRelation((getObjectProperty(___arguments.context.pageData, 'NewFuel')), 'reg', [(getObjectProperty(___arguments.context.pageData, 'Registration'))]);

  },
  /* handler:onBeforeUnmount */
  /* content */
}));

define('./pages/Add_Fuel_Office/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Add_Fuel_Office/components/cb53911dc178fd277a2316cbfb1eca43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var CurrentCustomer, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData));
  if (currentUser) {
    CurrentCustomer = (getObjectProperty(currentUser, 'Customer'));
    ___arguments.context.pageData['CustomerSelect'] = CurrentCustomer;
  }

  return CurrentCustomer

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Add_Fuel_Office/components/c77e57e7785a639b6d3b1b738466e375/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Add_Fuel_Office/components/1c26b77fa5bfe57c7a573909c7f97ace/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'));
  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 8000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 8000 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
  }
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b51538c6481c1ab759c677a7fe82f142')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Add_Fuel_Office/components/98946b7835a5ef6d2b63071bc2528187/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Last3_FC'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Add_Fuel_Office/components/89aa8f06c6495d53dd6dd069a2389c3d/bundle.js', [], () => ({
  /* content */

  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage')) == 'Incompatible Mileage')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/Add_Fuel_Office/components/4a0712b6dd5de72eb53179fd3bcef1e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Add_Fuel_Office/components/5aee54c7652c6eec08788f7ffabb0a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Truck_Ideal_Fuel_Consumption'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Add_Fuel_Office/components/62bfbb1142a79853e9f1c5cf543cdd48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e773c60132fec7187286c791e4ed5eba', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63d89ac4b5aa4d910a77e6670f43fc6f', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63d89ac4b5aa4d910a77e6670f43fc6f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21ac9fb4c41519b2bc0ebd87ff1dbbb2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62bfbb1142a79853e9f1c5cf543cdd48', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9efc741480f51522de7a8d80393cf25', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('094257daf1a51969e1e3b92e0e050784', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('407f7d03fdee41b57c6be559cdfecb5a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc26e6835c72d6d29aff4f7d086251f9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f26784897427ee179733302c972db1df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b51538c6481c1ab759c677a7fe82f142', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76fc74658706e3dcc8454c3a13d783dc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Add_Fuel_Office/components/21ac9fb4c41519b2bc0ebd87ff1dbbb2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Other_Expense'] = 'Other';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e773c60132fec7187286c791e4ed5eba', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63d89ac4b5aa4d910a77e6670f43fc6f', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63d89ac4b5aa4d910a77e6670f43fc6f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9efc741480f51522de7a8d80393cf25', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62bfbb1142a79853e9f1c5cf543cdd48', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21ac9fb4c41519b2bc0ebd87ff1dbbb2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e71b44983f265212b5131fc8fb4dc417', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('407f7d03fdee41b57c6be559cdfecb5a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc26e6835c72d6d29aff4f7d086251f9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a1c149946837aec55d5308b6ed77cde', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76fc74658706e3dcc8454c3a13d783dc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb5ada8e9d94fa6a225cc5aa02236794', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Add_Fuel_Office/components/76fc74658706e3dcc8454c3a13d783dc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb5ada8e9d94fa6a225cc5aa02236794')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Add_Fuel_Office/components/e773c60132fec7187286c791e4ed5eba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Active_Truck, Ideal_FC, item, Last_3_Lt, Last_3_MD, Last_Mileage_Of_This_Truck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Active_Truck = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments.value,'\''].join(''))).setPageSize(100)))[0];
  ___arguments.context.pageData['Got_Mileage'] = (getObjectProperty(Active_Truck, 'objectId'));
  Last_Mileage_Of_This_Truck = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('mileage').setPageSize(100))).map(async item => {; return ({ 'Last Mileage': (getObjectProperty(item, 'mileage')) });})));
  ___arguments.context.pageData['Final_Last_Mileage'] = (Last_Mileage_Of_This_Truck.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_Mileage'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_Mileage')), 'Last Mileage'))));
  Last_3_MD = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Mileage Differential': (getObjectProperty(item, 'Mileage_Differential')) });})));
  ___arguments.context.pageData['Final_Last_MD_1'] = (Last_3_MD.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_MD_1'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_1')), 'Mileage Differential'));
  ___arguments.context.pageData['Final_Last_MD_2'] = (Last_3_MD.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_MD_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_2')), 'Mileage Differential'))));
  ___arguments.context.pageData['Final_Last_MD_3'] = (Last_3_MD.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_MD_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_3')), 'Mileage Differential'))));
  ___arguments.context.pageData['Got_LT'] = undefined;
  Last_3_Lt = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Last Litres ': (getObjectProperty(item, 'litres')) });})));
  ___arguments.context.pageData['Final_Last_LT_1'] = (Last_3_Lt.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_LT_1'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_1')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_2'] = (Last_3_Lt.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_LT_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_2')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_3'] = (Last_3_Lt.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_LT_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_3')), 'Last Litres '))));
  ___arguments.context.pageData['Last3_FC'] = (Math.round((((getObjectProperty(___arguments.context.pageData, 'Reflected_MD_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_1'))) / ((getObjectProperty(___arguments.context.pageData, 'Reflected_LT_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_1')))) * 1000) / 1000);
  Ideal_FC = (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Ideal_Fuel_Consumption': (getObjectProperty(item, 'Ideal_Fuel_Consumption')) });})));
  ___arguments.context.pageData['Truck_Ideal_Fuel_Consumption'] = (getObjectProperty((Ideal_FC.slice(-1)[0]), 'Ideal_Fuel_Consumption'));
  ___arguments.context.pageData['New_Reg'] = Active_Truck;
  ___arguments.context.pageData['Final_New_Reg'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Reg')), 'Horse_Registration'));
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63d89ac4b5aa4d910a77e6670f43fc6f', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Add_Loads_Office/components/0fec6c027fd1aa122d3e05e33ff8922e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    var Customers, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Customers = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('740b7f86a872d36bf62b05467dcbcca7', Customers);

  },
  /* handler:onBeforeMount */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Customer, item, New_Horse, New_Load, Trailer_1, Trailer_2, Trailer_3;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  New_Load = (await Backendless.Data.of('Loads').save( ({ [`ownerId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),[`Contractor_Tonnage_Rate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Driver')), 'Contractor_Tonnage_Rate')),[`Tonnage_Target_Rate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Driver')), 'Tonnage_Target_Rate')),[`Rate_Per_Km`]: (getObjectProperty(___arguments.context.dataModel, 'R/Km')),[`Rate_Per_Tonne`]: (getObjectProperty(___arguments.context.dataModel, 'R/T')),[`Driver`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Driver')), 'Call_Sign')),[`Planned_Tonnage`]: (getObjectProperty(___arguments.context.dataModel, 'tonnage')),[`Load_Point_Mileage`]: (getObjectProperty(___arguments.context.dataModel, 'load_mileage')),[`Delivery_Point_Mileage`]: (getObjectProperty(___arguments.context.dataModel, 'Delivery_Mileage')),[`Split_Load_Reference`]: (getObjectProperty(___arguments.context.dataModel, 'Split_Load_Reference')),[`Horse_Registration`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Truck')), 'Horse_Registration')),[`Customer_Name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'Customer')),[`tonnage`]: (getObjectProperty(___arguments.context.dataModel, 'tonnage')),[`Status`]: 'Delivered',[`Completion_Status`]: 1,[`Split_Load`]: (getObjectProperty(___arguments.context.dataModel, 'Split_Load_Load_Number')),[`Planned_Load`]: (getObjectProperty(___arguments.context.dataModel, 'Load_Time')),[`Planned_Delivery_Date_Time`]: (getObjectProperty(___arguments.context.dataModel, 'Del_Time')),[`Planned_Delivery`]: (getObjectProperty(___arguments.context.dataModel, 'Del_Time')),[`Customer`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'Customer')),[`load_reference`]: (getObjectProperty(___arguments.context.dataModel, 'reference')),[`Product`]: (typeof (getObjectProperty(___arguments.context.dataModel, 'Detailed Product')) === 'undefined') || ((getObjectProperty(___arguments.context.dataModel, 'Detailed Product')) === null) || (getObjectProperty(___arguments.context.dataModel, 'Detailed Product')) == false ? (getObjectProperty(___arguments.context.dataModel, 'Product')) : (JSON.stringify((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f715b503892da6fc67093e58df4b14be')).map(async item => {; return ({ [`Product`]: (getObjectProperty(item, 'Product')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage')),[`Rate`]: (getObjectProperty(item, 'Rate')),[`Value`]: (getObjectProperty(item, 'Tonnage')) * (getObjectProperty(item, 'Rate')) });}))))),[`tonnage`]: (getObjectProperty(___arguments.context.dataModel, 'tonnage')),[`load_point`]: (getObjectProperty(___arguments.context.dataModel, 'load_point')),[`delivery_point`]: (getObjectProperty(___arguments.context.dataModel, 'delivery_point')),[`mileage`]: undefined,[`Mileage_Differential`]: (getObjectProperty(___arguments.context.dataModel, 'Delivery_Mileage')) - (getObjectProperty(___arguments.context.dataModel, 'load_mileage')) }) ));
  Customer = [(getObjectProperty(___arguments.context.pageData, 'Selected_Customer'))];
  await Backendless.Data.of('Loads').addRelation(New_Load, 'Customer', Customer);
  New_Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Truck')), 'objectId')), ));
  Trailer_1 = (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Truck')), 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)))[0];
  Trailer_2 = (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Truck')), 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)))[0];
  Trailer_3 = (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Truck')), 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)))[0];
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [New_Horse]);
  try {
    await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_1', [Trailer_1]);
    await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_2', [Trailer_2]);
    await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_3', [Trailer_3]);

  } catch (error) {

  }
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/Add_Loads_Office/components/6d6de0728aefd5535b274ee9b82428b7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Home', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/Add_Loads_Office/components/28a1743c6a47b40427fcaded8e0ba6e1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['New_Customer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Load_Planner')) == null) {
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      Disabler = true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Viewed_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if (Disabler == null) {
      Disabler = false;
    }
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/Add_Loads_Office/components/87af0188fb652b37bb8611da9363244d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item, New_Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  New_Customer = (await Backendless.Data.of('Tier_2_Customer').save( ({ 'Customer': (getObjectProperty(___arguments.context.pageData, 'New_Customer')),'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('740b7f86a872d36bf62b05467dcbcca7', (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16f4229cb89cfc2ad7879b753428ba0b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12d8f306970b92d3b555c167adcc21f6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('87af0188fb652b37bb8611da9363244d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('740b7f86a872d36bf62b05467dcbcca7', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Add_Loads_Office/components/740b7f86a872d36bf62b05467dcbcca7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      ___arguments.context.pageData['Selected_Customer'] = (await Backendless.Data.of('Tier_2_Customer').findById(___arguments.value, ));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Add_Loads_Office/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('4a6601d61afdb1199442fb69bb945238', (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Horse_Registration').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Horse_Registration')),[`value`]: (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('a7aed43406cfd837a03b653919131251', (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employee.ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Call_Sign').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Call_Sign')),[`value`]: (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('740b7f86a872d36bf62b05467dcbcca7', (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Customer')),[`value`]: (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Add_Loads_Office/components/16f4229cb89cfc2ad7879b753428ba0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('87af0188fb652b37bb8611da9363244d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16f4229cb89cfc2ad7879b753428ba0b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12d8f306970b92d3b555c167adcc21f6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('740b7f86a872d36bf62b05467dcbcca7', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Add_Loads_Office/components/4a6601d61afdb1199442fb69bb945238/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      ___arguments.context.pageData['Truck'] = (await Backendless.Data.of('Vehicles').findById(___arguments.value, ));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Add_Loads_Office/components/5a7169894bba68180b91a32c98a7453a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var Locker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage')) <= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load_mileage')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage')) != null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1d677efb8b2eb7bdc3e905f05ed3ae4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1d677efb8b2eb7bdc3e905f05ed3ae4', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Add_Loads_Office/components/12d8f306970b92d3b555c167adcc21f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16f4229cb89cfc2ad7879b753428ba0b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('87af0188fb652b37bb8611da9363244d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12d8f306970b92d3b555c167adcc21f6', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Add_Loads_Office/components/a7aed43406cfd837a03b653919131251/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.pageData['Driver'] = (await Backendless.Data.of('Employees').findById(___arguments.value, ));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Add_Loads_Office/components/cfd1672c2413d43a81bfe1a54bcd55fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('0fec6c027fd1aa122d3e05e33ff8922e');
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('740b7f86a872d36bf62b05467dcbcca7', null);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('4a6601d61afdb1199442fb69bb945238', null);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a7aed43406cfd837a03b653919131251', null);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0fec6c027fd1aa122d3e05e33ff8922e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0fec6c027fd1aa122d3e05e33ff8922e', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Add_Loads_Office/components/493c1678a479b6bb23aff64c31f5f477/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((typeof ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e') === 'undefined') || (___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e') === null)) {
      Viewer = false;
    } else if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Detailed Product')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Detailed Product')) === null) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Detailed Product')) == false) {
      Viewer = false;
    } else {
      Viewer = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Detailed Product'));
    }

  } catch (error) {
    console.log(error);

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Add_Loads_Office/components/1afc0b1821cf64b60ce6c22b207c3934/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list, New_List;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  New_List = [];
  var repeat_end = ___arguments.value * 1;
  for (var count = 0; count < repeat_end; count++) {
    addItemToList(New_List, ({ [`Tonnage`]: undefined,[`Rate`]: undefined,[`Product`]: undefined }));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f715b503892da6fc67093e58df4b14be', New_List);
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f715b503892da6fc67093e58df4b14be'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Add_Loads_Office/components/49279d9bcc5c9b475c71f9a75f3f6c59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f715b503892da6fc67093e58df4b14be'));
  console.log(JSON.stringify(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f715b503892da6fc67093e58df4b14be'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('027fdb7d6c83289921ece238b26e2f46', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b84a4ee3b1f1f34b62b243e578b1818c', false);
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  ___arguments.context.pageData['location'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  ___arguments.context.pageData['UserDriver'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName'));
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('b84a4ee3b1f1f34b62b243e578b1818c', (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Horse_Registration')),[`value`]: (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('027fdb7d6c83289921ece238b26e2f46', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b84a4ee3b1f1f34b62b243e578b1818c', true);

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Board_Truck/components/23eef22b5c313da3b0c90962a99b42c5/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), 'image')))

  },
  /* handler:onDisplayAssignment *//* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('Posts'))

  },
  /* handler:onDirectoryAssignment */
/* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split('.').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment *//* content */
}));

define('./pages/Board_Truck/components/609885542943085abe1a49544fbddf5c/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Horse_Targets, Selected_Horse, Active_Horse, Selected_Driver;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.dataModel, 'SubmitFuel'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4c55077c32b474ae00609eab428e3ae', true);
    ___arguments.context.dataModel['SubmitFuel'] = true;
    ___arguments.context.pageData['New_Fuel_Dump'] = (await Backendless.Data.of('Driver_Mileage_Dumps').save( ({ [`First_Mileage_On_Rig`]: (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')),[`Mileage_Differential`]: (getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')),[`Fuel_Consumption`]: (getObjectProperty(___arguments.context.pageData, 'Last3_FC')),[`Last_Mileage_On_Rig`]: (getObjectProperty(___arguments.context.dataModel, 'mileage')),[`Horse_Ideal_FC`]: (getObjectProperty(___arguments.context.pageData, 'Truck_Ideal_Fuel_Consumption')),[`Dash_Slip`]: (getObjectProperty(___arguments.context.dataModel, 'image')),[`location`]: (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lng'))).setY((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lat')))) }) ));
    Selected_Horse = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['Horse_Steer_Tare'] = (7700 * (getObjectProperty(Selected_Horse, 'Steer_Axle_Number')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare')) > 23100) {
      ___arguments.context.pageData['Horse_Steer_Tare'] = 23100;
    }
    ___arguments.context.pageData['Horse_Drive1_Tare'] = (8000 * (getObjectProperty(Selected_Horse, 'Drive_Axle_Number_Single_Wheels')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) > 24000) {
      ___arguments.context.pageData['Horse_Drive1_Tare'] = 24000;
    }
    ___arguments.context.pageData['Horse_Drive2_Tare'] = (9000 * (getObjectProperty(Selected_Horse, 'Drive_Axle_Number_Double_Wheels')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) > 24000) {
      ___arguments.context.pageData['Horse_Drive2_Tare'] = 24000;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'T1_Payload')) == 'undefined ') {
      ___arguments.context.pageData['T1_Payload'] = 0;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'T2_Payload')) == 'undefined ') {
      ___arguments.context.pageData['T2_Payload'] = 0;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'T3_Payload')) == 'undefined ') {
      ___arguments.context.pageData['T3_Payload'] = 0;
    }
    ___arguments.context.pageData['H_Tare'] = (getObjectProperty(Selected_Horse, 'Tare_Weight'));
    ___arguments.context.pageData['H_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare'))) - (getObjectProperty(___arguments.context.pageData, 'H_Tare')));
    ___arguments.context.pageData['Current_Payload'] = ((getObjectProperty(___arguments.context.pageData, 'H_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T1_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T2_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T3_Payload')));
    if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare')) > 56000) {
      ___arguments.context.pageData['Tare_Combine'] = ((getObjectProperty(___arguments.context.pageData, 'H_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
      ___arguments.context.pageData['Current_Payload'] = (56000 - (getObjectProperty(___arguments.context.pageData, 'Tare_Combine')));
    }
    ___arguments.context.pageData['Current_Payload_Final'] = ((getObjectProperty(___arguments.context.pageData, 'Current_Payload')) / 1000);
    await Backendless.Data.of('Driver_Mileage_Dumps').setRelation((getObjectProperty(___arguments.context.pageData, 'New_Fuel_Dump')), 'Horse_Registration', [(getObjectProperty(Selected_Horse, 'objectId'))]);
    ___arguments.context.pageData['Username'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName'));
    Selected_Driver = (await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Call_Sign = \'',(getObjectProperty(___arguments.context.pageData, 'Username')),'\''].join(''))).setPageSize(10)))[0];
    Selected_Driver['Currently_Aboard'] = (getObjectProperty(Selected_Horse, 'Horse_Registration'));
    await Backendless.Data.of('Employees').save( Selected_Driver );
    await Backendless.Data.of('Driver_Mileage_Dumps').setRelation((getObjectProperty(___arguments.context.pageData, 'New_Fuel_Dump')), 'Driver', [(getObjectProperty(Selected_Driver, 'objectId'))]);
    Active_Horse = (await Backendless.Data.of('Vehicles').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b84a4ee3b1f1f34b62b243e578b1818c')), ));
    await Backendless.Data.of('Vehicles').setRelation(Active_Horse, 'Driver_1', [(getObjectProperty(Selected_Driver, 'objectId'))]);
    Horse_Targets = (await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.Horse_Registration = \'',(getObjectProperty(Selected_Horse, 'Horse_Registration')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['Tonnage_Override'] = (getObjectProperty(Horse_Targets, 'Tonnage_Override'));
    Active_Horse['Current_Driver'] = (getObjectProperty(___arguments.context.pageData, 'Username'));
    await Backendless.Data.of('Vehicles').save( Active_Horse );
    if ((getObjectProperty(___arguments.context.pageData, 'Tonnage_Override')) == null) {
      Selected_Horse['Payload'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      Selected_Horse['Current_Driver'] = (getObjectProperty(___arguments.context.pageData, 'UserDriver'));
      await Backendless.Data.of('Vehicles').save( Selected_Horse );
      Horse_Targets['Permissible_Tonnage'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      await Backendless.Data.of('Targets').save( Horse_Targets );
    } else {
      Selected_Horse['Current_Driver'] = (getObjectProperty(___arguments.context.pageData, 'UserDriver'));
      await Backendless.Data.of('Vehicles').save( Selected_Horse );
      Horse_Targets['Permissible_Tonnage'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      Horse_Targets['Tonnage_Override'] = null;
      await Backendless.Data.of('Targets').save( Horse_Targets );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
  }

  },
  /* handler:onSubmit *//* handler:onBeforeUnmount */
  async onBeforeUnmount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Fuel').setRelation((getObjectProperty(___arguments.context.pageData, 'NewFuel')), 'reg', [(getObjectProperty(___arguments.context.pageData, 'Registration'))]);

  },
  /* handler:onBeforeUnmount */
  /* content */
}));

define('./pages/Board_Truck/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck/components/cb53911dc178fd277a2316cbfb1eca43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var CurrentCustomer, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData));
  if (currentUser) {
    CurrentCustomer = (getObjectProperty(currentUser, 'Customer'));
    ___arguments.context.pageData['CustomerSelect'] = CurrentCustomer;
  }

  return CurrentCustomer

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Board_Truck/components/b84a4ee3b1f1f34b62b243e578b1818c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Active_Truck, Ideal_FC, item, Last_3_Lt, Last_3_MD, Last_Mileage_Of_This_Truck, Trailer_1, Trailer_1_Detail, Trailer_2, Trailer_2_Detail, Trailer_3, Trailer_3_Detail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b84a4ee3b1f1f34b62b243e578b1818c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', true);
  ___arguments.context.pageData['Got_Mileage'] = ___arguments.value;
  Active_Truck = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(10))).slice(-1)[0];
  Last_Mileage_Of_This_Truck = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('mileage').setPageSize(100))).map(async item => {; return ({ 'Last Mileage': (getObjectProperty(item, 'mileage')) });})));
  ___arguments.context.pageData['Final_Last_Mileage'] = (Last_Mileage_Of_This_Truck.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_Mileage'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_Mileage')), 'Last Mileage'))));
  Ideal_FC = (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Ideal_Fuel_Consumption': (getObjectProperty(item, 'Ideal_Fuel_Consumption')) });})));
  ___arguments.context.pageData['Truck_Ideal_Fuel_Consumption'] = (getObjectProperty((Ideal_FC.slice(-1)[0]), 'Ideal_Fuel_Consumption'));
  ___arguments.context.pageData['New_Reg'] = (await Backendless.Data.of('Vehicles ').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b84a4ee3b1f1f34b62b243e578b1818c')), Backendless.DataQueryBuilder.create().setProperties('Horse_Registration')));
  ___arguments.context.pageData['Final_New_Reg'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Reg')), 'Horse_Registration'));
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('094257daf1a51969e1e3b92e0e050784', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', true);
  Last_3_MD = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Mileage Differential': (getObjectProperty(item, 'Mileage_Differential')) });})));
  ___arguments.context.pageData['Final_Last_MD_1'] = (Last_3_MD.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_MD_1'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_1')), 'Mileage Differential'));
  ___arguments.context.pageData['Final_Last_MD_2'] = (Last_3_MD.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_MD_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_2')), 'Mileage Differential'))));
  ___arguments.context.pageData['Final_Last_MD_3'] = (Last_3_MD.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_MD_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_3')), 'Mileage Differential'))));
  ___arguments.context.pageData['Got_LT'] = ___arguments.value;
  Last_3_Lt = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Last Litres ': (getObjectProperty(item, 'litres')) });})));
  ___arguments.context.pageData['Final_Last_LT_1'] = (Last_3_Lt.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_LT_1'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_1')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_2'] = (Last_3_Lt.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_LT_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_2')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_3'] = (Last_3_Lt.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_LT_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_3')), 'Last Litres '))));
  ___arguments.context.pageData['Last3_FC'] = (Math.round((((getObjectProperty(___arguments.context.pageData, 'Reflected_MD_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_1'))) / ((getObjectProperty(___arguments.context.pageData, 'Reflected_LT_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_1')))) * 1000) / 1000);
  if ((getObjectProperty(Active_Truck, 'Trailer_1_Confirm')) == 'Hitched') {
    Trailer_1 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(Active_Truck, 'Trailer1_Reg')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['Trailer_1_Object'] = Trailer_1;
    Trailer_1_Detail = (getObjectProperty(Trailer_1, 'Trailer_Registration'));
    ___arguments.context.pageData['T1_CLDW'] = (9000 * (getObjectProperty(Trailer_1, 'Axle_Number_Double_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) > 24000) {
      ___arguments.context.pageData['T1_CLDW'] = 24000;
    }
    ___arguments.context.pageData['T1_CLSW'] = (8000 * (getObjectProperty(Trailer_1, 'Axle_Number_Single_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) > 24000) {
      ___arguments.context.pageData['T1_CLSW'] = 24000;
    }
    ___arguments.context.pageData['T1_Tare'] = (getObjectProperty(Trailer_1, 'Tare'));
    ___arguments.context.pageData['T1_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T1_Tare')));
    ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;
  } else {
    Trailer_1_Detail = 'None';
    ___arguments.context.pageData['T1_CLDW'] = 0;
    ___arguments.context.pageData['T1_CLSW'] = 0;
    ___arguments.context.pageData['T1_Tare'] = 0;
    ___arguments.context.pageData['T1_Payload'] = 0;
    ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;
  }
  if ((getObjectProperty(Active_Truck, 'Trailer_2_Confirm')) == 'Hitched') {
    Trailer_2 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(Active_Truck, 'Trailer2_Reg')),'\''].join(''))).setPageSize(10)))[0];
    Trailer_2_Detail = (getObjectProperty(Trailer_2, 'Trailer_Registration'));
    ___arguments.context.pageData['Trailer_2_Object'] = Trailer_2;
    ___arguments.context.pageData['T2_CLDW'] = (9000 * (getObjectProperty(Trailer_2, 'Axle_Number_Double_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) > 24000) {
      ___arguments.context.pageData['T2_CLDW'] = 24000;
    }
    ___arguments.context.pageData['T2_CLSW'] = (8000 * (getObjectProperty(Trailer_2, 'Axle_Number_Single_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) > 24000) {
      ___arguments.context.pageData['T2_CLSW'] = 24000;
    }
    ___arguments.context.pageData['T2_Tare'] = (getObjectProperty(Trailer_2, 'Tare'));
    ___arguments.context.pageData['T2_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T2_Tare')));
    ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;
  } else {
    Trailer_2_Detail = 'None';
    ___arguments.context.pageData['T2_CLDW'] = 0;
    ___arguments.context.pageData['T2_CLSW'] = 0;
    ___arguments.context.pageData['T2_Tare'] = 0;
    ___arguments.context.pageData['T2_Payload'] = 0;
    ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;
  }
  if ((getObjectProperty(Active_Truck, 'Trailer_3_Confirm')) == 'Hitched') {
    Trailer_3 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(Active_Truck, 'Trailer3_Reg')),'\''].join(''))).setPageSize(10)))[0];
    Trailer_3_Detail = (getObjectProperty(Trailer_3, 'Trailer_Registration'));
    ___arguments.context.pageData['Trailer_3_Object'] = Trailer_3;
    ___arguments.context.pageData['T3_CLDW'] = (9000 * (getObjectProperty(Trailer_3, 'Axle_Number_Double_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) > 24000) {
      ___arguments.context.pageData['T3_CLDW'] = 24000;
    }
    ___arguments.context.pageData['T3_CLSW'] = (8000 * (getObjectProperty(Trailer_3, 'Axle_Number_Single_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) > 24000) {
      ___arguments.context.pageData['T3_CLSW'] = 24000;
    }
    ___arguments.context.pageData['T3_Tare'] = (getObjectProperty(Trailer_3, 'Tare'));
    ___arguments.context.pageData['T3_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
    ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;
  } else {
    Trailer_3_Detail = 'None';
    ___arguments.context.pageData['T3_CLDW'] = 0;
    ___arguments.context.pageData['T3_CLSW'] = 0;
    ___arguments.context.pageData['T3_Tare'] = 0;
    ___arguments.context.pageData['T3_Payload'] = 0;
    ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Board_Truck/components/c77e57e7785a639b6d3b1b738466e375/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Board_Truck/components/1c26b77fa5bfe57c7a573909c7f97ace/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
    await new Promise(r => setTimeout(r, 600 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', true);
  }

  },
  /* handler:onChange */
  /* handler:onBlur */
  onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', true);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/Board_Truck/components/4a0712b6dd5de72eb53179fd3bcef1e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Board_Truck/components/5aee54c7652c6eec08788f7ffabb0a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Truck_Ideal_Fuel_Consumption'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Board_Truck/components/e7c53c751d45a82a8c66319a2fb3a9ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Board_Truck/components/77e673caff9505f12e09fb9545cba7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('094257daf1a51969e1e3b92e0e050784', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('407f7d03fdee41b57c6be559cdfecb5a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', false);
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) == 'None' && (getObjectProperty(___arguments.context.pageData, 'Trailer_2')) == 'None' && (getObjectProperty(___arguments.context.pageData, 'Trailer_3')) == 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55c34211478125c39dda96b2ac32d9d7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_2')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_3')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck/components/160aa861c90b95da1c393679d5aca13e/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var Trailer_1_Detail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_1'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Board_Truck/components/dde9807dfa1d1185dbd8d5b98e77dbb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', true);
  }
  if (___arguments.value == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', false);
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', true);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_2')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_3')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', true);
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Board_Truck/components/183ce27a8636e037382490975dbfd1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_2'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Board_Truck/components/11b12f25adcc0e1cf3130774e586e192/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var Trailer_3_Details;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_3'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Board_Truck/components/0283b96d7d565ee14b92ac32030844fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var New_Trailer_1, item, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dccb7a3a45361a7b2e6fbc328ba74cc', true);
  New_Trailer_1 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_1['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  if (New_Trailer_1 != ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('0283b96d7d565ee14b92ac32030844fe'))) {
    New_Trailer_1 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
    await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Board_Truck/components/ada52d13b9a3be49565e4c18a5362d07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Trailer_1_Old, Current_Truck, Trailer_1_Relation, Trailer_1_Unhitch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1166669e06b3fc8679ac9c6955dadb9a', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('0283b96d7d565ee14b92ac32030844fe', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer1_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_1_Relation = (await Backendless.Data.of('Vehicles').loadRelations(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b84a4ee3b1f1f34b62b243e578b1818c')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_1_ID'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Trailer_1_Object')), 'objectId'));
  Trailer_1_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_1_ID')), ));
  Trailer_1_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_1_Unhitch );
  Trailer_1_Old = Trailer_1_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer1_Registration', Trailer_1_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T1_CLDW'] = 0;
  ___arguments.context.pageData['T1_CLSW'] = 0;
  ___arguments.context.pageData['T1_Tare'] = 0;
  ___arguments.context.pageData['T1_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1166669e06b3fc8679ac9c6955dadb9a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck/components/8f4b8e227d3820bd939239829ee53539/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Current_Truck, item, LiveUser, Trailer_2_Old, Trailer_2_Relation, Trailer_2_Unhitch, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d384be688fc657be933b9fddcd814dce', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('fbbef77ab7a3d1795aa3424ad2143abf', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer2_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_2_Relation = (await Backendless.Data.of('Vehicles').loadRelations(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b84a4ee3b1f1f34b62b243e578b1818c')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_2_ID'] = (getObjectProperty((Trailer_2_Relation[0]), 'objectId'));
  Trailer_2_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_2_ID')), ));
  Trailer_2_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_2_Unhitch );
  Trailer_2_Old = Trailer_2_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer2_Registration', Trailer_2_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T2_CLDW'] = 0;
  ___arguments.context.pageData['T2_CLSW'] = 0;
  ___arguments.context.pageData['T2_Tare'] = 0;
  ___arguments.context.pageData['T2_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d384be688fc657be933b9fddcd814dce', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck/components/fef4b50eb5a671c325a4c283c0264acf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Trailer_3_Old, Current_Truck, Trailer_3_Relation, Trailer_3_Unhitch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07531ae6e333a2a27efedf7a201674e5', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('ada6857aafb61354249cf2a84e757fba', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer3_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_3_Relation = (await Backendless.Data.of('Vehicles').loadRelations(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b84a4ee3b1f1f34b62b243e578b1818c')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_3_ID'] = (getObjectProperty((Trailer_3_Relation[0]), 'objectId'));
  Trailer_3_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_3_ID')), ));
  Trailer_3_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_3_Unhitch );
  Trailer_3_Old = Trailer_3_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer3_Registration', Trailer_3_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T3_CLDW'] = 0;
  ___arguments.context.pageData['T3_CLSW'] = 0;
  ___arguments.context.pageData['T3_Tare'] = 0;
  ___arguments.context.pageData['T3_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07531ae6e333a2a27efedf7a201674e5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck/components/fbbef77ab7a3d1795aa3424ad2143abf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var New_Trailer_2, item, LiveUser, New_Trailer_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('854783575616ac3945377bc9a3351554', true);
  New_Trailer_2 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_2['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  await Backendless.Data.of('Trailers').save( New_Trailer_2 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  if (New_Trailer_2 != ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fbbef77ab7a3d1795aa3424ad2143abf'))) {
    New_Trailer_2 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
    await Backendless.Data.of('Trailers').save( New_Trailer_2 );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Board_Truck/components/ada6857aafb61354249cf2a84e757fba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var New_Trailer_3, item, LiveUser, New_Trailer_2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24098d0a08e6fa674dd707faf2571277', true);
  New_Trailer_3 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_3['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  await Backendless.Data.of('Trailers').save( New_Trailer_3 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  if (New_Trailer_3 != ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ada6857aafb61354249cf2a84e757fba'))) {
    New_Trailer_3 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
    await Backendless.Data.of('Trailers').save( New_Trailer_3 );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Board_Truck/components/5dccb7a3a45361a7b2e6fbc328ba74cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Trailer_1_Detail, New_Trailer_1, Active_Truck, Load_1, Active_Loads;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dccb7a3a45361a7b2e6fbc328ba74cc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1166669e06b3fc8679ac9c6955dadb9a', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_1 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('0283b96d7d565ee14b92ac32030844fe')), ));
  New_Trailer_1['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  Active_Truck['Trailer1_Reg'] = (getObjectProperty(New_Trailer_1, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  Active_Loads = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_1.objectId = \'',(getObjectProperty(New_Trailer_1, 'objectId')),'\'  AND Status = \'Loaded\''].join(''))).setPageSize(10)));
  try {
    Load_1 = Active_Loads[0];
    Load_1['Horse_Registration'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
    await Backendless.Data.of('Loads').save( Load_1 );
    await Backendless.Data.of('Loads').setRelation(Load_1, 'Horse', [Active_Truck]);

  } catch (error) {

  }
  ___arguments.context.pageData['T1_CLDW'] = (9000 * (getObjectProperty(New_Trailer_1, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) > 24000) {
    ___arguments.context.pageData['T1_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T1_CLSW'] = (8000 * (getObjectProperty(New_Trailer_1, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) > 24000) {
    ___arguments.context.pageData['T1_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T1_Tare'] = (getObjectProperty(New_Trailer_1, 'Tare'));
  ___arguments.context.pageData['T1_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T1_Tare')));
  New_Trailer_1 = (await Backendless.Data.of('Trailers').save( New_Trailer_1 ));
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer1_Registration', [New_Trailer_1]);
  try {
    Trailer_1_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_1_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;

  }
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1166669e06b3fc8679ac9c6955dadb9a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck/components/854783575616ac3945377bc9a3351554/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Trailer_2_Detail, New_Trailer_2, Active_Truck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('854783575616ac3945377bc9a3351554', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d384be688fc657be933b9fddcd814dce', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_2 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fbbef77ab7a3d1795aa3424ad2143abf')), ));
  console.log(New_Trailer_2);
  New_Trailer_2['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  Active_Truck['Trailer2_Reg'] = (getObjectProperty(New_Trailer_2, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_2 );
  ___arguments.context.pageData['T2_CLDW'] = (9000 * (getObjectProperty(New_Trailer_2, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) > 24000) {
    ___arguments.context.pageData['T2_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T2_CLSW'] = (8000 * (getObjectProperty(New_Trailer_2, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) > 24000) {
    ___arguments.context.pageData['T2_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T2_Tare'] = (getObjectProperty(New_Trailer_2, 'Tare'));
  ___arguments.context.pageData['T2_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T2_Tare')));
  New_Trailer_2 = (await Backendless.Data.of('Trailers').save( New_Trailer_2 ));
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer2_Registration', [New_Trailer_2]);
  try {
    Trailer_2_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_2_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;

  }
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d384be688fc657be933b9fddcd814dce', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck/components/24098d0a08e6fa674dd707faf2571277/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, New_Trailer_3, Trailer_3_Detail, Active_Truck, Trailer_2_Detail, New_Trailer_2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24098d0a08e6fa674dd707faf2571277', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07531ae6e333a2a27efedf7a201674e5', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_3 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ada6857aafb61354249cf2a84e757fba')), ));
  New_Trailer_3['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  Active_Truck['Trailer3_Reg'] = (getObjectProperty(New_Trailer_3, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_3 );
  ___arguments.context.pageData['T3_CLDW'] = (9000 * (getObjectProperty(New_Trailer_3, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) > 24000) {
    ___arguments.context.pageData['T3_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T3_CLSW'] = (8000 * (getObjectProperty(New_Trailer_3, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) > 24000) {
    ___arguments.context.pageData['T3_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T3_Tare'] = (getObjectProperty(New_Trailer_3, 'Tare'));
  ___arguments.context.pageData['T3_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
  New_Trailer_3 = (await Backendless.Data.of('Trailers').save( New_Trailer_3 ));
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer3_Registration', [New_Trailer_3]);
  try {
    Trailer_3_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_3_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;

  }
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07531ae6e333a2a27efedf7a201674e5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck/components/84e129d24e4b43fa3fc34472e9d4ae64/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Board_Truck_Office/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('027fdb7d6c83289921ece238b26e2f46', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b84a4ee3b1f1f34b62b243e578b1818c', false);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('b2ab57aef5c69be8ddb4360d53d662fc', (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employee.ownerId = \'',LiveUser,'\'','And Warehouse_Status = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Call_Sign')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('b84a4ee3b1f1f34b62b243e578b1818c', (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Horse_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('027fdb7d6c83289921ece238b26e2f46', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b84a4ee3b1f1f34b62b243e578b1818c', true);

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Board_Truck_Office/components/23eef22b5c313da3b0c90962a99b42c5/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), 'image')))

  },
  /* handler:onDisplayAssignment *//* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('Posts'))

  },
  /* handler:onDirectoryAssignment */
/* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split('.').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment *//* content */
}));

define('./pages/Board_Truck_Office/components/609885542943085abe1a49544fbddf5c/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Active_Horse, Selected_Driver, Selected_Horse, Horse_Targets, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.dataModel, 'SubmitFuel'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a4c55077c32b474ae00609eab428e3ae', true);
    ___arguments.context.dataModel['SubmitFuel'] = true;
    ___arguments.context.pageData['New_Fuel_Dump'] = (await Backendless.Data.of('Driver_Mileage_Dumps').save( ({ 'First_Mileage_On_Rig': (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')),'Mileage_Differential': (getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')),'Fuel_Consumption': (getObjectProperty(___arguments.context.pageData, 'Last3_FC')),'Last_Mileage_On_Rig': (getObjectProperty(___arguments.context.dataModel, 'mileage')),'Horse_Ideal_FC': (getObjectProperty(___arguments.context.pageData, 'Horse_Ideal_FC')),'Dash_Slip': (getObjectProperty(___arguments.context.dataModel, 'image')),'location': undefined }) ));
    Selected_Horse = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['Horse_Steer_Tare'] = (7700 * (getObjectProperty(Selected_Horse, 'Steer_Axle_Number')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare')) > 23100) {
      ___arguments.context.pageData['Horse_Steer_Tare'] = 23100;
    }
    ___arguments.context.pageData['Horse_Drive1_Tare'] = (8000 * (getObjectProperty(Selected_Horse, 'Drive_Axle_Number_Single_Wheels')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) > 24000) {
      ___arguments.context.pageData['Horse_Drive1_Tare'] = 24000;
    }
    ___arguments.context.pageData['Horse_Drive2_Tare'] = (9000 * (getObjectProperty(Selected_Horse, 'Drive_Axle_Number_Double_Wheels')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) > 24000) {
      ___arguments.context.pageData['Horse_Drive2_Tare'] = 24000;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'T1_Payload')) == 'undefined ') {
      ___arguments.context.pageData['T1_Payload'] = 0;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'T2_Payload')) == 'undefined ') {
      ___arguments.context.pageData['T2_Payload'] = 0;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'T3_Payload')) == 'undefined ') {
      ___arguments.context.pageData['T3_Payload'] = 0;
    }
    ___arguments.context.pageData['H_Tare'] = (getObjectProperty(Selected_Horse, 'Tare_Weight'));
    ___arguments.context.pageData['H_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare'))) - (getObjectProperty(___arguments.context.pageData, 'H_Tare')));
    ___arguments.context.pageData['Current_Payload'] = ((getObjectProperty(___arguments.context.pageData, 'H_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T1_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T2_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T3_Payload')));
    if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare')) > 56000) {
      ___arguments.context.pageData['Tare_Combine'] = ((getObjectProperty(___arguments.context.pageData, 'H_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
      ___arguments.context.pageData['Current_Payload'] = (56000 - (getObjectProperty(___arguments.context.pageData, 'Tare_Combine')));
    }
    ___arguments.context.pageData['Current_Payload_Final'] = ((getObjectProperty(___arguments.context.pageData, 'Current_Payload')) / 1000);
    Horse_Targets = (await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.Horse_Registration = \'',(getObjectProperty(Selected_Horse, 'Horse_Registration')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['Tonnage_Override'] = (getObjectProperty(Horse_Targets, 'Tonnage_Override'));
    if ((getObjectProperty(___arguments.context.pageData, 'Tonnage_Override')) == null) {
      Selected_Horse['Payload'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      await Backendless.Data.of('Vehicles').save( Selected_Horse );
      Horse_Targets['Permissible_Tonnage'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      await Backendless.Data.of('Targets').save( Horse_Targets );
    } else {
      await Backendless.Data.of('Vehicles').save( Selected_Horse );
      Horse_Targets['Permissible_Tonnage'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      Horse_Targets['Tonnage_Override'] = null;
      await Backendless.Data.of('Targets').save( Horse_Targets );
    }
    await Backendless.Data.of('Driver_Mileage_Dumps').setRelation((getObjectProperty(___arguments.context.pageData, 'New_Fuel_Dump')), 'Horse_Registration', [(getObjectProperty(Selected_Horse, 'objectId'))]);
    Selected_Driver = (await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Selected_Driver')),'\''].join(''))).setPageSize(10)))[0];
    Active_Horse = (await Backendless.Data.of('Vehicles').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b84a4ee3b1f1f34b62b243e578b1818c')), ));
    Selected_Driver['Currently_Aboard'] = (getObjectProperty(Active_Horse, 'Horse_Registration'));
    await Backendless.Data.of('Employees').save( Selected_Driver );
    await Backendless.Data.of('Driver_Mileage_Dumps').setRelation((getObjectProperty(___arguments.context.pageData, 'New_Fuel_Dump')), 'Driver', [(getObjectProperty(Selected_Driver, 'objectId'))]);
    await Backendless.Data.of('Vehicles').setRelation(Active_Horse, 'Driver_1', [(getObjectProperty(Selected_Driver, 'objectId'))]);
    Active_Horse['Current_Driver'] = (getObjectProperty(Selected_Driver, 'Call_Sign'));
    console.log((await Backendless.Data.of('Vehicles').save( Active_Horse )));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
  }

  },
  /* handler:onSubmit *//* handler:onBeforeUnmount */
  async onBeforeUnmount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Fuel').setRelation((getObjectProperty(___arguments.context.pageData, 'NewFuel')), 'reg', [(getObjectProperty(___arguments.context.pageData, 'Registration'))]);

  },
  /* handler:onBeforeUnmount */
  /* content */
}));

define('./pages/Board_Truck_Office/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck_Office/components/cb53911dc178fd277a2316cbfb1eca43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var CurrentCustomer, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData));
  if (currentUser) {
    CurrentCustomer = (getObjectProperty(currentUser, 'Customer'));
    ___arguments.context.pageData['CustomerSelect'] = CurrentCustomer;
  }

  return CurrentCustomer

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Board_Truck_Office/components/b84a4ee3b1f1f34b62b243e578b1818c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Trailer_3_Detail, Trailer_3, Active_Truck, Trailer_2_Detail, Trailer_2, Trailer_1_Detail, Trailer_1, Last_3_Lt, item, Last_3_MD, Last_Mileage_Of_This_Truck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b84a4ee3b1f1f34b62b243e578b1818c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', true);
  ___arguments.context.pageData['Got_Mileage'] = ___arguments.value;
  Active_Truck = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(10))).slice(-1)[0];
  ___arguments.context.pageData['Horse_Ideal_FC'] = (getObjectProperty(((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(10))).slice(-1)[0]), 'Ideal_Fuel_Consumption'));
  ___arguments.context.pageData['Active_Truck_Data'] = Active_Truck;
  Last_Mileage_Of_This_Truck = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('mileage').setPageSize(100))).map(async item => {; return ({ 'Last Mileage': (getObjectProperty(item, 'mileage')) });})));
  console.log(Last_Mileage_Of_This_Truck);
  ___arguments.context.pageData['Final_Last_Mileage'] = (Last_Mileage_Of_This_Truck.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_Mileage'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_Mileage')), 'Last Mileage'))));
  console.log(getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'));
  ___arguments.context.pageData['New_Reg'] = (await Backendless.Data.of('Vehicles ').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b84a4ee3b1f1f34b62b243e578b1818c')), Backendless.DataQueryBuilder.create().setProperties('Horse_Registration')));
  ___arguments.context.pageData['Final_New_Reg'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Reg')), 'Horse_Registration'));
  await new Promise(r => setTimeout(r, 500 || 0));
  Last_3_MD = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Mileage Differential': (getObjectProperty(item, 'Mileage_Differential')) });})));
  ___arguments.context.pageData['Final_Last_MD_1'] = (Last_3_MD.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_MD_1'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_1')), 'Mileage Differential'));
  ___arguments.context.pageData['Final_Last_MD_2'] = (Last_3_MD.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_MD_2'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_2')), 'Mileage Differential'));
  ___arguments.context.pageData['Final_Last_MD_3'] = (Last_3_MD.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_MD_3'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_3')), 'Mileage Differential'));
  Last_3_Lt = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Last Litres ': (getObjectProperty(item, 'litres')) });})));
  ___arguments.context.pageData['Final_Last_LT_1'] = (Last_3_Lt.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_LT_1'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_1')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_2'] = (Last_3_Lt.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_LT_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_2')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_3'] = (Last_3_Lt.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_LT_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_3')), 'Last Litres '))));
  ___arguments.context.pageData['Last3_FC'] = (Math.round((((getObjectProperty(___arguments.context.pageData, 'Reflected_MD_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_1'))) / ((getObjectProperty(___arguments.context.pageData, 'Reflected_LT_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_1')))) * 1000) / 1000);
  console.log(getObjectProperty(___arguments.context.pageData, 'Last3_FC'));
  if ((getObjectProperty(Active_Truck, 'Trailer_1_Confirm')) == 'Hitched') {
    Trailer_1_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));
    Trailer_1 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',Trailer_1_Detail,'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['T1_CLDW'] = (9000 * (getObjectProperty(Trailer_1, 'Axle_Number_Double_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) > 24000) {
      ___arguments.context.pageData['T1_CLDW'] = 24000;
    }
    ___arguments.context.pageData['T1_CLSW'] = (8000 * (getObjectProperty(Trailer_1, 'Axle_Number_Single_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) > 24000) {
      ___arguments.context.pageData['T1_CLSW'] = 24000;
    }
    ___arguments.context.pageData['T1_Tare'] = (getObjectProperty(Trailer_1, 'Tare'));
    ___arguments.context.pageData['T1_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T1_Tare')));
    ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;
  } else {
    Trailer_1_Detail = 'None';
    ___arguments.context.pageData['T1_CLDW'] = 0;
    ___arguments.context.pageData['T1_CLSW'] = 0;
    ___arguments.context.pageData['T1_Tare'] = 0;
    ___arguments.context.pageData['T1_Payload'] = 0;
    ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;
  }
  if ((getObjectProperty(Active_Truck, 'Trailer_2_Confirm')) == 'Hitched') {
    Trailer_2_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));
    Trailer_2 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',Trailer_2_Detail,'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['T2_CLDW'] = (9000 * (getObjectProperty(Trailer_2, 'Axle_Number_Double_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) > 24000) {
      ___arguments.context.pageData['T2_CLDW'] = 24000;
    }
    ___arguments.context.pageData['T2_CLSW'] = (8000 * (getObjectProperty(Trailer_2, 'Axle_Number_Single_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) > 24000) {
      ___arguments.context.pageData['T2_CLSW'] = 24000;
    }
    ___arguments.context.pageData['T2_Tare'] = (getObjectProperty(Trailer_2, 'Tare'));
    ___arguments.context.pageData['T2_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T2_Tare')));
    ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;
  } else {
    Trailer_2_Detail = 'None';
    ___arguments.context.pageData['T2_CLDW'] = 0;
    ___arguments.context.pageData['T2_CLSW'] = 0;
    ___arguments.context.pageData['T2_Tare'] = 0;
    ___arguments.context.pageData['T2_Payload'] = 0;
    ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;
  }
  if ((getObjectProperty(Active_Truck, 'Trailer_3_Confirm')) == 'Hitched') {
    Trailer_3_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));
    Trailer_3 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',Trailer_3_Detail,'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['T3_CLDW'] = (9000 * (getObjectProperty(Trailer_3, 'Axle_Number_Double_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) > 24000) {
      ___arguments.context.pageData['T3_CLDW'] = 24000;
    }
    ___arguments.context.pageData['T3_CLSW'] = (8000 * (getObjectProperty(Trailer_3, 'Axle_Number_Single_Wheel')));
    if ((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) > 24000) {
      ___arguments.context.pageData['T3_CLSW'] = 24000;
    }
    ___arguments.context.pageData['T3_Tare'] = (getObjectProperty(Trailer_3, 'Tare'));
    ___arguments.context.pageData['T3_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
    ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;
  } else {
    Trailer_3_Detail = 'None';
    ___arguments.context.pageData['T3_CLDW'] = 0;
    ___arguments.context.pageData['T3_CLSW'] = 0;
    ___arguments.context.pageData['T3_Tare'] = 0;
    ___arguments.context.pageData['T3_Payload'] = 0;
    ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('094257daf1a51969e1e3b92e0e050784', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Board_Truck_Office/components/c77e57e7785a639b6d3b1b738466e375/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Board_Truck_Office/components/1c26b77fa5bfe57c7a573909c7f97ace/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
    await new Promise(r => setTimeout(r, 600 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', true);
  }

  },
  /* handler:onChange */
  /* handler:onBlur */
  onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', true);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/Board_Truck_Office/components/4a0712b6dd5de72eb53179fd3bcef1e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Board_Truck_Office/components/5aee54c7652c6eec08788f7ffabb0a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Horse_Ideal_FC'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Board_Truck_Office/components/e7c53c751d45a82a8c66319a2fb3a9ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Board_Truck_Office/components/77e673caff9505f12e09fb9545cba7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b2ab57aef5c69be8ddb4360d53d662fc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('094257daf1a51969e1e3b92e0e050784', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('407f7d03fdee41b57c6be559cdfecb5a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', false);
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) == 'None' && (getObjectProperty(___arguments.context.pageData, 'Trailer_2')) == 'None' && (getObjectProperty(___arguments.context.pageData, 'Trailer_3')) == 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55c34211478125c39dda96b2ac32d9d7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_2')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_3')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck_Office/components/160aa861c90b95da1c393679d5aca13e/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var Trailer_1_Detail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_1'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Board_Truck_Office/components/dde9807dfa1d1185dbd8d5b98e77dbb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', true);
  }
  if (___arguments.value == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', false);
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', true);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_2')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_3')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', true);
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Board_Truck_Office/components/183ce27a8636e037382490975dbfd1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_2'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Board_Truck_Office/components/11b12f25adcc0e1cf3130774e586e192/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var Trailer_3_Details;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_3'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Board_Truck_Office/components/0283b96d7d565ee14b92ac32030844fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, LiveUser, New_Trailer_1, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dccb7a3a45361a7b2e6fbc328ba74cc', true);
  New_Trailer_1 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_1['Currently_On'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Active_Truck_Data')), 'Horse_Registration'));
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Board_Truck_Office/components/ada52d13b9a3be49565e4c18a5362d07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Current_Truck, item, LiveUser, Trailer_1_Old, Trailer_1_Relation, Trailer_1_Unhitch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1166669e06b3fc8679ac9c6955dadb9a', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('0283b96d7d565ee14b92ac32030844fe', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer1_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_1_Relation = (await Backendless.Data.of('Vehicles').loadRelations(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b84a4ee3b1f1f34b62b243e578b1818c')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_1_ID'] = (getObjectProperty((Trailer_1_Relation[0]), 'objectId'));
  Trailer_1_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_1_ID')), ));
  Trailer_1_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_1_Unhitch );
  Trailer_1_Old = Trailer_1_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer1_Registration', Trailer_1_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T1_CLDW'] = 0;
  ___arguments.context.pageData['T1_CLSW'] = 0;
  ___arguments.context.pageData['T1_Tare'] = 0;
  ___arguments.context.pageData['T1_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1166669e06b3fc8679ac9c6955dadb9a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck_Office/components/8f4b8e227d3820bd939239829ee53539/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Current_Truck, item, LiveUser, Trailer_1_Old, Trailer_1_Unhitch, Trailer_2_Old, Trailer_2_Relation, Trailer_2_Unhitch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d384be688fc657be933b9fddcd814dce', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('fbbef77ab7a3d1795aa3424ad2143abf', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer2_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_2_Relation = (await Backendless.Data.of('Vehicles').loadRelations(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b84a4ee3b1f1f34b62b243e578b1818c')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_2_ID'] = (getObjectProperty((Trailer_2_Relation[0]), 'objectId'));
  Trailer_2_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_2_ID')), ));
  Trailer_2_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_2_Unhitch );
  Trailer_2_Old = Trailer_2_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer2_Registration', Trailer_2_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T2_CLDW'] = 0;
  ___arguments.context.pageData['T2_CLSW'] = 0;
  ___arguments.context.pageData['T2_Tare'] = 0;
  ___arguments.context.pageData['T2_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d384be688fc657be933b9fddcd814dce', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck_Office/components/fef4b50eb5a671c325a4c283c0264acf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Current_Truck, item, LiveUser, Trailer_2_Old, Trailer_2_Unhitch, Trailer_3_Old, Trailer_3_Relation, Trailer_3_Unhitch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07531ae6e333a2a27efedf7a201674e5', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('ada6857aafb61354249cf2a84e757fba', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer3_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_3_Relation = (await Backendless.Data.of('Vehicles').loadRelations(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b84a4ee3b1f1f34b62b243e578b1818c')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_3_ID'] = (getObjectProperty((Trailer_3_Relation[0]), 'objectId'));
  Trailer_3_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_3_ID')), ));
  Trailer_3_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_3_Unhitch );
  Trailer_3_Old = Trailer_3_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer3_Registration', Trailer_3_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T3_CLDW'] = 0;
  ___arguments.context.pageData['T3_CLSW'] = 0;
  ___arguments.context.pageData['T3_Tare'] = 0;
  ___arguments.context.pageData['T3_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07531ae6e333a2a27efedf7a201674e5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck_Office/components/fbbef77ab7a3d1795aa3424ad2143abf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var New_Trailer_2, item, LiveUser, New_Trailer_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('854783575616ac3945377bc9a3351554', true);
  New_Trailer_2 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_2['Currently_On'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Active_Truck_Data')), 'Horse_Registration'));
  await Backendless.Data.of('Trailers').save( New_Trailer_2 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Board_Truck_Office/components/ada6857aafb61354249cf2a84e757fba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var New_Trailer_3, item, LiveUser, New_Trailer_2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24098d0a08e6fa674dd707faf2571277', true);
  New_Trailer_3 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_2['Currently_On'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Active_Truck_Data')), 'Horse_Registration'));
  await Backendless.Data.of('Trailers').save( New_Trailer_3 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Board_Truck_Office/components/5dccb7a3a45361a7b2e6fbc328ba74cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Trailer_1, item, LiveUser, Trailer_1_Detail, Active_Truck, Load_1, Active_Loads;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dccb7a3a45361a7b2e6fbc328ba74cc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1166669e06b3fc8679ac9c6955dadb9a', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_1 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('0283b96d7d565ee14b92ac32030844fe')), ));
  New_Trailer_1['Currently_On'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  Active_Truck['Trailer1_Reg'] = (getObjectProperty(New_Trailer_1, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  Active_Loads = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_1.objectId = \'',(getObjectProperty(New_Trailer_1, 'objectId')),'\'  AND Status = \'Loaded\''].join(''))).setPageSize(10)));
  try {
    Load_1 = Active_Loads[0];
    Load_1['Horse_Registration'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
    await Backendless.Data.of('Loads').save( Load_1 );
    await Backendless.Data.of('Loads').setRelation(Load_1, 'Horse', [Active_Truck]);

  } catch (error) {

  }
  ___arguments.context.pageData['T1_CLDW'] = (9000 * (getObjectProperty(New_Trailer_1, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) > 24000) {
    ___arguments.context.pageData['T1_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T1_CLSW'] = (8000 * (getObjectProperty(New_Trailer_1, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) > 24000) {
    ___arguments.context.pageData['T1_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T1_Tare'] = (getObjectProperty(New_Trailer_1, 'Tare'));
  ___arguments.context.pageData['T1_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T1_Tare')));
  New_Trailer_1 = (await Backendless.Data.of('Trailers').save( New_Trailer_1 ));
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer1_Registration', [New_Trailer_1]);
  try {
    Trailer_1_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_1_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;

  }
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1166669e06b3fc8679ac9c6955dadb9a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck_Office/components/854783575616ac3945377bc9a3351554/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Trailer_2_Detail, New_Trailer_2, Active_Truck, New_Trailer_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('854783575616ac3945377bc9a3351554', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d384be688fc657be933b9fddcd814dce', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_2 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fbbef77ab7a3d1795aa3424ad2143abf')), ));
  New_Trailer_2['Currently_On'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  Active_Truck['Trailer2_Reg'] = (getObjectProperty(New_Trailer_2, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  ___arguments.context.pageData['T2_CLDW'] = (9000 * (getObjectProperty(New_Trailer_2, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) > 24000) {
    ___arguments.context.pageData['T2_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T2_CLSW'] = (8000 * (getObjectProperty(New_Trailer_2, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) > 24000) {
    ___arguments.context.pageData['T2_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T2_Tare'] = (getObjectProperty(New_Trailer_2, 'Tare'));
  ___arguments.context.pageData['T2_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T2_Tare')));
  New_Trailer_2 = (await Backendless.Data.of('Trailers').save( New_Trailer_2 ));
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer2_Registration', [New_Trailer_2]);
  try {
    Trailer_2_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_2_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;

  }
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d384be688fc657be933b9fddcd814dce', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck_Office/components/24098d0a08e6fa674dd707faf2571277/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, New_Trailer_3, Trailer_3_Detail, Active_Truck, Trailer_2_Detail, New_Trailer_2, New_Trailer_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24098d0a08e6fa674dd707faf2571277', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07531ae6e333a2a27efedf7a201674e5', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_3 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ada6857aafb61354249cf2a84e757fba')), ));
  New_Trailer_3['Currently_On'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  Active_Truck['Trailer3_Reg'] = (getObjectProperty(New_Trailer_3, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_3 );
  ___arguments.context.pageData['T3_CLDW'] = (9000 * (getObjectProperty(New_Trailer_3, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) > 24000) {
    ___arguments.context.pageData['T3_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T3_CLSW'] = (8000 * (getObjectProperty(New_Trailer_3, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) > 24000) {
    ___arguments.context.pageData['T3_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T3_Tare'] = (getObjectProperty(New_Trailer_3, 'Tare'));
  ___arguments.context.pageData['T3_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
  New_Trailer_3 = (await Backendless.Data.of('Trailers').save( New_Trailer_3 ));
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer3_Registration', [New_Trailer_3]);
  try {
    Trailer_3_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_3_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;

  }
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07531ae6e333a2a27efedf7a201674e5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Board_Truck_Office/components/84e129d24e4b43fa3fc34472e9d4ae64/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Board_Truck_Office/components/b2ab57aef5c69be8ddb4360d53d662fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['Selected_Driver'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Broker_Overview/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var RGBA, Slider_Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['RGBA'] = 1;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c55832ef99386143591bbb014b56e9ec', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f721a95416cef718eec3a707efe7148c', false);
  for (var count = 0; count < 100; count++) {
    RGBA = (getObjectProperty(___arguments.context.pageData, 'RGBA')) - 0.01;
    ___arguments.context.pageData['RGBA'] = RGBA;
    console.log(['rgba(0, 0, 0, ',RGBA,')'].join(''));
    await new Promise(r => setTimeout(r, 1 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6'))['backgroundColor'] = (['rgba(0, 0, 0, ',RGBA,')'].join(''));
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', false);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f721a95416cef718eec3a707efe7148c', true);
  ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  ___arguments.context.pageData['Company'] = ((await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10)))[0]);
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  if (!(await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  await do_something();

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Broker_Overview/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/b612d3b3061d799155f81a9286caaa69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['DataImageText'] = null;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Image_3'] = null;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Image_4'] = null;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Image_2'] = null;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Image_1'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53f230669892fe6b194f76a8870f0abd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d597703187b9be4d8c221ffbb4cbf787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4dd8521bf16fc894bf3b8278977f29e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/cf2d5a1bc5dfeba8a9db31784a714f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Images_View'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Broker_Overview/components/41f553479872cab9abf931ef3b0b2e47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Image_1'] = null;
  ___arguments.context.pageData['Image_2'] = null;
  ___arguments.context.pageData['Image_3'] = null;
  ___arguments.context.pageData['Image_3'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/daa89079a11340a16fc711568858863d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Image_Text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Image_1')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_2')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_3')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_4')) == null) {
    Image_Text = 'No Images Available';
  } else {
    Image_Text = (getObjectProperty(___arguments.context.pageData, 'DataImageText'));
  }

  return Image_Text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Broker_Overview/components/e23b96acd1879198dc2f19e4e90eb0e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/b7649fc62cc8a1432e22311afd238672/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/2fae753c674e30dff7e7456114e29c61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/cd7e08f865dbe001d7579334b4752399/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/53f230669892fe6b194f76a8870f0abd/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Completion_Status = \'1\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Broker_Overview/components/d597703187b9be4d8c221ffbb4cbf787/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Completion_Status = \'0\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Broker_Overview/components/4dd8521bf16fc894bf3b8278977f29e7/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Broker_Overview/components/5657405aa51342ecda98075493b5ff6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d597703187b9be4d8c221ffbb4cbf787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53f230669892fe6b194f76a8870f0abd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4dd8521bf16fc894bf3b8278977f29e7', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/c894589c9b12ecb80e85835103fe082b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d597703187b9be4d8c221ffbb4cbf787', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53f230669892fe6b194f76a8870f0abd', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4dd8521bf16fc894bf3b8278977f29e7', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/31b1a5be72b558142e7f983f0932c39e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d597703187b9be4d8c221ffbb4cbf787', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('53f230669892fe6b194f76a8870f0abd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4dd8521bf16fc894bf3b8278977f29e7', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/8f6e4a81b1838ce85fd5489320ba2254/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4dd8521bf16fc894bf3b8278977f29e7');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('53f230669892fe6b194f76a8870f0abd');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('d597703187b9be4d8c221ffbb4cbf787');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/6e7acdffc0ceee99b3d3b621f2db7067/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == false) {
    ___arguments.context.pageData['WS_Hamburger_View'] = true;
  } else {
    ___arguments.context.pageData['WS_Hamburger_View'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Broker_Overview/components/0a74c72eef9270791482e6fc33ea93dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Broker_Overview/components/81261c456bfff72600117f12981ff09a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CPK_Overview/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Fleet_Item, item, error, Tyre, Driver_Filter, Salary;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('576155c6897967125f086d6bf7d5885a'))['opacity'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);
  ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Slider'] = 0;
  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  ___arguments.context.pageData['Start_Date'] = (await BackendlessUI.Functions.Custom['fn_424c6f8b8fa9ba1fc714c1e2f3a1d685']());
  ___arguments.context.pageData['End_Date'] = (new Date());
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  if (!(await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  Salary = (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employer.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return item;})));
  Fleet_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  item['Targets'] = ((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100)))[0]);
    item['Fuel_Data'] = (await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(6)));
    item['Horse_FI'] = ((getObjectProperty(item, 'Depreciation')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Fixed_Monthly_Sundry_Fee')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Tracking_Fee')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);
    item['Trailers_FI'] = (((getObjectProperty(item, 'Trailer1_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer2_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer3_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0));
    item['Driver'] = ((await asyncListFilter(Salary, async (Driver_Filter) => {


     return ((getObjectProperty(item, 'Current_Driver')) == (getObjectProperty(Driver_Filter, 'Call_Sign')));
    }))[0]);
    item['Per_Km_M_Plan_FI'] = ((getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Maintenance_Plan_Rate_per_Km')) : 0);
    item['ATE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}));
    try {
      item['Tyre_CPK'] = (await BackendlessUI.Functions.Custom['fn_d3e8372ef47fc584b377b1b7d7feacb1']('Tyres', (['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',((getObjectProperty(item, 'Trailer1_Reg')) === null) ? ' ' : [' OR Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''),((getObjectProperty(item, 'Trailer2_Reg')) === null) ? ' ' : [' OR Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''),((getObjectProperty(item, 'Trailer3_Reg')) === null) ? ' ' : [' OR Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join('')].join('')), 'Expected_CPK'));

    } catch (error) {

    } finally {
      if (error) {
        item['Tyre_CPK'] = 0;
      }

    }
    item['Tyre_CPK'] = ((typeof (getObjectProperty(item, 'Tyre_CPK')) === 'undefined') ? 0 : (getObjectProperty(item, 'Tyre_CPK')));
    console.log(getObjectProperty(item, 'Fuel_Data'));
  ; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`Horse_Registration`]: (getObjectProperty(item, 'Fleet_ID')),[`Horse_ID`]: (getObjectProperty(item, 'Horse_Registration')),[`License_Notice_FI`]: (getObjectProperty(item, 'Trailer1_Reg')),[`License_PDP_FI`]: (getObjectProperty(item, 'Trailer2_Reg')),[`Trailer_3_FI`]: (getObjectProperty(item, 'Trailer3_Reg')),[`Driver_1`]: (typeof (getObjectProperty(item, 'Driver')) === 'undefined') ? 'None' : (getObjectProperty((getObjectProperty(item, 'Driver')), 'Call_Sign')),[`Service_Notice`]: (getObjectProperty(item, 'Horse_FI')) / (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target')),[`Current_Mileage`]: (getObjectProperty(item, 'Trailers_FI')) / (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target')),[`Distance_Traveled`]: mathMean(await Promise.all((getObjectProperty(item, 'Fuel_Data')).map(async item => {; return (getObjectProperty(item, 'R_Per_Litre'));}))) / ((await Promise.all((getObjectProperty(item, 'Fuel_Data')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all((getObjectProperty(item, 'Fuel_Data')).map(async item => {; return (getObjectProperty(item, 'litres'));}))).reduce(function(x, y) {return x + y;})),[`Mileage_Target_Completion`]: (typeof (getObjectProperty(item, 'Driver')) === 'undefined') ? 0 : ((getObjectProperty((getObjectProperty(item, 'Driver')), 'Basic_Salary')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Contractor_Tonnage_Rate')) * (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Tonnage_Target')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Tonnage_Target_Rate')) * (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Tonnage_Target')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Contractor_Km_Rate')) * (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Good_Driving_Rate')) * (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Bargaining_Council_And_Union_Levies')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Medical_Aid')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Provident_And_Pension_Fund'))) / (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target')),[`Ideal_KM/L`]: (getObjectProperty(item, 'Tyre_CPK')),[`Actual_KM/L`]: (getObjectProperty(item, 'Maintenance_Plan_Rate_per_Km')),[`Status`]: (getObjectProperty(item, 'Per_Km_Toll_Rate_R')),[`Fuel_Cost`]: (getObjectProperty((getObjectProperty(item, 'Targets')), 'Drawings_Per_KM')),[`Price_Per_Litre`]: (getObjectProperty((getObjectProperty(item, 'Targets')), 'Drawings_Per_KM')) + (getObjectProperty(item, 'Per_Km_Toll_Rate_R')) + (getObjectProperty(item, 'Maintenance_Plan_Rate_per_Km')) + (getObjectProperty(item, 'Tyre_CPK')) + ((typeof (getObjectProperty(item, 'Driver')) === 'undefined') ? 0 : ((getObjectProperty((getObjectProperty(item, 'Driver')), 'Basic_Salary')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Contractor_Tonnage_Rate')) * (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Tonnage_Target')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Tonnage_Target_Rate')) * (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Tonnage_Target')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Contractor_Km_Rate')) * (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Good_Driving_Rate')) * (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Bargaining_Council_And_Union_Levies')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Medical_Aid')) + (getObjectProperty((getObjectProperty(item, 'Driver')), 'Provident_And_Pension_Fund'))) / (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target'))) + (((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target')) / ((await Promise.all((getObjectProperty(item, 'Fuel_Data')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all((getObjectProperty(item, 'Fuel_Data')).map(async item => {; return (getObjectProperty(item, 'litres'));}))).reduce(function(x, y) {return x + y;}))) * mathMean(await Promise.all((getObjectProperty(item, 'Fuel_Data')).map(async item => {; return (getObjectProperty(item, 'R_Per_Litre'));})))) / (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target')) + (getObjectProperty(item, 'Trailers_FI')) / (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target')) + (getObjectProperty(item, 'Horse_FI')) / (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Mileage_Target')),[`FC`]: (addItemToList((await Promise.all((getObjectProperty(item, 'Fuel_Data')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((getObjectProperty(item, 'Fuel_Data')).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}) });})));
  ___arguments.context.pageData['Fleet_List'] = Fleet_Item;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', Fleet_Item);
  await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('576155c6897967125f086d6bf7d5885a')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('576155c6897967125f086d6bf7d5885a')), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6')), false);

  },
  /* handler:onEnter *//* content */
}));

define('./pages/CPK_Overview/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CPK_Overview/components/0e0200c11cbcde7cbdf70a0e7988a0d4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  onStyleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Service_Notice')) == 'Service Due') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0e0200c11cbcde7cbdf70a0e7988a0d4'))['color'] = 'yellow';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Service_Notice'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/aadffa177e03469667c81325f5b42c65/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  onStyleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status')) == 'Consumption Error') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aadffa177e03469667c81325f5b42c65'))['color'] = 'Red';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/0a44b4c1e9cc4e8486e1847d8d0cadf9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a44b4c1e9cc4e8486e1847d8d0cadf9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64abcaf5ca5e80f2a7f4740b69d9c91c', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6ac9db8ea16e94f2f8edec3e1a5ecae', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CPK_Overview/components/64abcaf5ca5e80f2a7f4740b69d9c91c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6ac9db8ea16e94f2f8edec3e1a5ecae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64abcaf5ca5e80f2a7f4740b69d9c91c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a44b4c1e9cc4e8486e1847d8d0cadf9', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CPK_Overview/components/84e399febbb69c6906ae14f2c7c899ab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '2Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/56a25647cafe65f486633cb8f338c2bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '3Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/83d3c61a37097477378eec49bf9d1e25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '4Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/07c2624860b79354fab219fa499b6d86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '5Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/34f478020a4af087eb9943b716f9c834/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '6Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/6471c6fa4c29c02f8b820496dfb980a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '7Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/090849a9211b46a9558969e764f374a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '8Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/6f2295db02fe4d353ffed4f8eab182d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '9Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/60f8c62d363af106cf134b052cfd3ccf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '11Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/d9395a792f543e413ce89701e4cd9812/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '12Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/8096fb55ff9c027bc50ec5ae514327e5/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.dataModel['Driver_Check'] = false;
  ___arguments.context.dataModel['2Check'] = false;
  ___arguments.context.dataModel['3Check'] = true;
  ___arguments.context.dataModel['4Check'] = true;
  ___arguments.context.dataModel['5Check'] = true;
  ___arguments.context.dataModel['6Check'] = true;
  ___arguments.context.dataModel['7Check'] = true;
  ___arguments.context.dataModel['8Check'] = true;
  ___arguments.context.dataModel['9Check'] = true;
  ___arguments.context.dataModel['10Check'] = true;
  ___arguments.context.dataModel['11Check'] = true;
  ___arguments.context.dataModel['12Check'] = true;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/CPK_Overview/components/61348c3229e7b3dd8bd8d9aca2e7a152/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Driver_Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['2Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['3Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['4Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['5Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['6Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['7Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['8Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['9Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['10Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['11Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['12Check'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CPK_Overview/components/5d06b9c2de2c2d3611890ad594edbeca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Driver_Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['2Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['3Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['4Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['5Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['6Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['7Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['8Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['9Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['10Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['11Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['12Check'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CPK_Overview/components/925b10b7d7771db46af2b6552be4830d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Driver_1'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/3025cc740c2e6016986db7acc957c12b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Current_Mileage'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/aaef52abada4847a42bf68ef573f6c2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/483935bcdd8a4b7ee73d9737828eadf6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/ec11a4cf1741c56fb1dbeb4378d2d577/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Ideal_KM/L')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/4d49a09a5761ea0b09fbd0c721873fd1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Actual_KM/L')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/27bc8b1642aef057a32c0b55204abd98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Fuel_Cost')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/f861780d9d1af912b4020aef7e7bdce9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/2511457a9f3112079b0a9b69e8999208/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Driver_Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['2Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['3Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['4Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['5Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['6Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['7Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['8Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['9Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['10Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['11Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['12Check'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CPK_Overview/components/cfd1a8d15b5d8338effd0cd62e03efb8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), 'Driver_Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/83b780247efdbba766cfc424d6cae4b1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['CPKPrint'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	var print_div = document.getElementById("Data_Panel");
  	var print_area = window.open('Test');
  	print_area.document.write(print_div.innerHTML);
  	print_area.document.close();
  	print_area.focus();
  	print_area.print();
  	print_area.close();
  })();
  ___arguments.context.pageData['CPKPrint'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CPK_Overview/components/57e9c23f5edc37ce0cfa5fb18c8e4d51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/1e1ebd2dec99f6e42aeef67812e4ce24/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre')) - ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/6a5aa80616998844b088ae861fd83fd6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'undefined') && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'undefined')) {
    Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')))));
  } else {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'undefined') && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP'))))) {
      Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'FC'))))));
    } else {
      if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'undefined')) {
        Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'FC'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC'))))));
      } else {
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP'))))) {
          Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC'))))));
        }
      }
    }
  }
  ___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f')['New_FC'] = Result;

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'New_FC'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/58cecbd1fafbe6474ac27ced24ff43b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Fuel, Toll, Salary;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'undefined') && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'undefined')) {
    Fuel = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled'));
  } else {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'undefined') && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP'))))) {
      Fuel = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'FC'));
    } else {
      if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'undefined')) {
        Fuel = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'FC'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC'));
      } else {
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP'))))) {
          Fuel = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC'));
        }
      }
    }
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'undefined') {
    Toll = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status'));
  } else if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TT')) === 'undefined')) {
    Toll = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status'));
  } else if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TT')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TT'))))) {
    Toll = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TT')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL'));
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'undefined') {
    Salary = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion'));
  } else if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TS')) === 'undefined')) {
    Salary = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion'));
  } else if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TS')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TS'))))) {
    Salary = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TS')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL'));
  }

  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((typeof (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre')) - ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion')))) + Salary + Toll + Fuel) === 'number' && !isNaN((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre')) - ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion')))) + Salary + Toll + Fuel))) ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre')) - ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion')))) + Salary + Toll + Fuel : 0)))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/84699b26228a34288924e9cf16ec3b4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'CV'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/49f46609e45d305eced67cbf55c8cc82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f')['CV'] = true;
  await new Promise(r => setTimeout(r, 50 || 0));
  console.log((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1d48a20340f600c465a56c67b30b0f15'))));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c93eb2a784095b496c0b197873cd1528'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c93eb2a784095b496c0b197873cd1528'))['width'] = (((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1d48a20340f600c465a56c67b30b0f15')))) + 15);
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c93eb2a784095b496c0b197873cd1528'));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1d48a20340f600c465a56c67b30b0f15'));
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['CALCA'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'CV')) == false || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'CV')) === 'undefined')) {
    Result = true;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'CV')) == true) {
    Result = false;
  }

  return Result

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/2806f905cf35bb9716c9118f8cadafba/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f')['CV'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['CALCA'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c93eb2a784095b496c0b197873cd1528'))['width'] = 40;
  ___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f')['EFC'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f')['EFP'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f')['TL'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f')['TT'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f')['TS'] = undefined;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'CV')) == true) {
    Result = true;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'CV')) == false || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'CV')) === 'undefined')) {
    Result = false;
  }

  return Result

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/1d48a20340f600c465a56c67b30b0f15/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), 'CALCA')) == false || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), 'CALCA')) === 'undefined')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1d48a20340f600c465a56c67b30b0f15'))['minWidth'] = 40;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1d48a20340f600c465a56c67b30b0f15'))['minWidth'] = 305;
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'CPKPrint')) == true) {
    Result = false;
  } else {
    Result = true;
  }

  return Result

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/c93eb2a784095b496c0b197873cd1528/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'CPKPrint')) == true) {
    Result = false;
  } else {
    Result = true;
  }

  return Result

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/065190dbc8b73492201eb7a8b003d281/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Salary, Toll, Fuel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'undefined') && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'undefined')) {
    Fuel = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled'));
  } else {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'undefined') && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP'))))) {
      Fuel = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'FC'));
    } else {
      if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'undefined')) {
        Fuel = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'FC'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC'));
      } else {
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP'))))) {
          Fuel = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFP')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'EFC'));
        }
      }
    }
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'undefined') {
    Toll = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status'));
  } else if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TT')) === 'undefined')) {
    Toll = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status'));
  } else if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TT')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TT'))))) {
    Toll = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TT')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL'));
  }
  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'undefined') {
    Salary = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion'));
  } else if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TS')) === 'undefined')) {
    Salary = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion'));
  } else if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TS')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TS'))))) {
    Salary = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TS')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL'));
  }

  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((typeof (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre')) - ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion')))) + Salary + Toll + Fuel) === 'number' && !isNaN((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre')) - ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion')))) + Salary + Toll + Fuel))) ? ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')))) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'TL')) * (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre')) - ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion')))) + Salary + Toll + Fuel) : 0) : 0)))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/CPK_Overview/components/d5f1ae5fd387fb9f0f9825e4a648e9d5/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f1ae5fd387fb9f0f9825e4a648e9d5'))['height'] = (((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('576155c6897967125f086d6bf7d5885a')))) - (((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11dbdea2a25c0f7eab7971f1a11ab81b')))) + ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4988910c45687433446403b7665377cb'))))));
  console.log(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f1ae5fd387fb9f0f9825e4a648e9d5')), 'height'));

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Customer List'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Customers', (String('Type = \'Agri\' AND ownerId IS NOT NULL')))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Data_Agri/components/ef5acae12e61521d98479b54fc7de58d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (((getObjectProperty(___arguments.context.pageData, 'Customer List')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'Customer List')) === 'undefined')) {
    List = [];
  } else {
    List = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'Customer List')), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    }));
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Customer'] = ((await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',___arguments.value,'\''].join(''))).setPageSize(10)))[0]);
  console.log(getObjectProperty(___arguments.context.pageData, 'Customer'));
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('13bc90ed7be2b9d272dad3dc2929824f');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('477a1379e2c55fff2ed13a2f7d6350c2');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2d76a6354992d5ea1a96b7d745a78a1d');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('986d8da2d46655163b5f379877b76b15');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('d6a4c173e30c6bcefe3e9856d3e22eb5');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('d6a4c173e30c6bcefe3e9856d3e22eb5');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('ad22d639ee432a2d1e9fa4f12c4db7e3');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('0cf18049da451f55525a53d6312cc6fa');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4ea66d47482bc0950159e40e86a9f654');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('9c7a4478c6bffa36e9e7723f5daa6309');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('b6d29ab98859ee4fbfd13123d87c3f45');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Data_Agri/components/13bc90ed7be2b9d272dad3dc2929824f/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/477a1379e2c55fff2ed13a2f7d6350c2/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['Employer.ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/2d76a6354992d5ea1a96b7d745a78a1d/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/986d8da2d46655163b5f379877b76b15/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/d6a4c173e30c6bcefe3e9856d3e22eb5/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/ad22d639ee432a2d1e9fa4f12c4db7e3/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/4ea66d47482bc0950159e40e86a9f654/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/0cf18049da451f55525a53d6312cc6fa/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/9316aa53662a146f7df94309115902b2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function Clearer() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13bc90ed7be2b9d272dad3dc2929824f', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('477a1379e2c55fff2ed13a2f7d6350c2', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d76a6354992d5ea1a96b7d745a78a1d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('986d8da2d46655163b5f379877b76b15', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d6a4c173e30c6bcefe3e9856d3e22eb5', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad22d639ee432a2d1e9fa4f12c4db7e3', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0cf18049da451f55525a53d6312cc6fa', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ea66d47482bc0950159e40e86a9f654', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c7a4478c6bffa36e9e7723f5daa6309', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d29ab98859ee4fbfd13123d87c3f45', false);

  } catch (error) {
    console.log(error);

  }
  try {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14bed0bfa0a6f1f170e1ff6ca6b4114f');

  } catch (error) {
    console.log(error);

  }
  try {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('002706680e79bcae62834e5b7dcadec8');

  } catch (error) {
    console.log(error);

  }
}


  if (___arguments.value == 'Company Details') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13bc90ed7be2b9d272dad3dc2929824f', true);
  } else if (___arguments.value == 'Employees') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('477a1379e2c55fff2ed13a2f7d6350c2', true);
  } else if (___arguments.value == 'Fuel') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d76a6354992d5ea1a96b7d745a78a1d', true);
  } else if (___arguments.value == 'Off Farm Fuel') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('986d8da2d46655163b5f379877b76b15', true);
  } else if (___arguments.value == 'Farming Logs') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d6a4c173e30c6bcefe3e9856d3e22eb5', true);
  } else if (___arguments.value == 'Job Cards') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad22d639ee432a2d1e9fa4f12c4db7e3', true);
  } else if (___arguments.value == 'Users') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0cf18049da451f55525a53d6312cc6fa', true);
  } else if (___arguments.value == 'Vehicles') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ea66d47482bc0950159e40e86a9f654', true);
  } else if (___arguments.value == 'Bowsers') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c7a4478c6bffa36e9e7723f5daa6309', true);
  } else if (___arguments.value == 'Bowser Fills') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d29ab98859ee4fbfd13123d87c3f45', true);
  } else if (___arguments.value == 'Add Assets') {
    await Clearer();
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('14bed0bfa0a6f1f170e1ff6ca6b4114f');
  } else if (___arguments.value == 'Add Contractor') {
    await Clearer();
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('002706680e79bcae62834e5b7dcadec8');
  } else if (___arguments.value == 'Add Existing Clients') {
    await Clearer();
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('d1edba841b2a90875a0e57e808626f4e');
  } else if (___arguments.value == 'Add Applications ') {
    await Clearer();
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('69fa4736c7af05ef18d44a848895de3a');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Data_Agri/components/a5840434af29cca128f9110ddc3e073d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  Backendless.Users.setCurrentUser((
      await Backendless.Data.of( Backendless.User ).findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')))
  ), (
      await Backendless.Data.of( Backendless.User ).findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')))
  ));
  ___arguments.context.appData['Selected Cusomer'] = (
      await Backendless.Data.of( Backendless.User ).findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')))
  );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home_Agri', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/120ed1bebd7f5eb6784a711fcda735c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Delete Code'] = (generateUUID().short());
  console.log(getObjectProperty(___arguments.context.pageData, 'Delete Code'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4b4caa643a3c1f8839df5a124fab0329');
  console.log((await Backendless.Request.post(`${Backendless.appPath}/services/Twilio/sendMessage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'phoneNumber': '+27631925960','message': (getObjectProperty(___arguments.context.pageData, 'Delete Code')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/e5a3db84ea3557fc12c7327acce6a449/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');
  Customer = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('ef5acae12e61521d98479b54fc7de58d')), async (item) => {


   return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) == (getObjectProperty(item, 'value')));
  }))[0];
  console.log((await Backendless.Data.of('AAA_EMERGENCY_AAA').bulkDelete( (['Customer = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Bowser_Fills').bulkDelete( (['Company = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Bowsers').bulkDelete( (['ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Farming_Job_Card').bulkDelete( (['Company = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Farming_Log').bulkDelete( (['Company = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Fuel_Log').bulkDelete( (['Company = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Agri_Fuel_Log_Off_Farm').bulkDelete( (['Company = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Vehicles').bulkDelete( (['ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Customers').bulkDelete( (['ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Driver_Mileage_Dumps').bulkDelete( (['Horse_Registration.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Employees').bulkDelete( (['Employer.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Fuel').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Load_Neg').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Loads').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Locations').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Other').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Repairs_Maintenance').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Targets').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Targets').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Tier_2_Customer').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Trailers').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Tyres').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Vehicles').bulkDelete( (['ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('users').bulkDelete( (['ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  ___arguments.context.pageData['Customer List'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Customers', null)).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company')) });})));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4b4caa643a3c1f8839df5a124fab0329');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Entered Code')) == (getObjectProperty(___arguments.context.pageData, 'Delete Code'))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/e0f39d1996ade13583c3793b27df290a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Entered Code'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Data_Agri/components/051f78ac5605833185fd501f75915ad1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Company, Driver, Director, Display_Name, Customer, Director_Email, Driver_Counter, Bowser_attendants__, Director_Name, Created_Customer, Client, Client_Counter, Client__, Truck, Truck_Counter, Truck__, Trailer, Trailer_Counter, Bowsers, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Director_Function() {
  Director = (await Backendless.UserService.register( new Backendless.User({ 'email': Director_Email,'password': '1234','Account_Type': 'Agri','Agri_Farm_Log': 'Yes','Agri_Log_Book': 'Yes','User_level': 'Director','Customer': Customer,'displayName': Director_Name,'ownerId': undefined }) ));
  Director['ownerId'] = (getObjectProperty(Director, 'objectId'));
  await Backendless.Data.of('Users').save( Director );
  console.log(Director);
}

/**
 * Describe this function...
 */
async function Clients() {
  Client_Counter = 0;
  for (var count = 0; count < Client__; count++) {
    Client_Counter = Client_Counter + 1;
    Display_Name = String('Customer 000') + String(Client_Counter);
    Client = (await Backendless.UserService.register( new Backendless.User({ 'email': (await (async function(Text) {
    	const D = Text
    	const result = D.split(" ").join("");
    	return result
    })(([Display_Name,'@',(await (async function(Text) {
    	const D = Text
    	const result = D.split(" ").join("");
    	return result
    })(Customer)).toLowerCase(),Director_Email.slice(((Director_Email.indexOf('.') + 1) - 1), Director_Email.length)].join('')))).toLowerCase(),'password': '1234','Account_Type': 'Agri','Agri_Farm_Log': 'Yes','Agri_Log_Book': 'Yes','User_level': 'Director','Customer': Display_Name,'displayName': Display_Name,'ownerId': undefined }) ));
    Client['ownerId'] = (getObjectProperty(Client, 'objectId'));
    await Backendless.Data.of('Users').save( Client );
    Created_Customer = (await Backendless.Data.of('Customers').save( ({ [`Company`]: Display_Name,[`Type`]: 'Agri',[`ownerId`]: (getObjectProperty(Client, 'ownerId')) }) ));
    await Backendless.Data.of('Customers').setRelation(Created_Customer, 'AGRI_Contractors', [Company]);
    await Backendless.Data.of('Customers').addRelation(Company, 'AGRI_Clients', [Created_Customer]);
  }
}

/**
 * Describe this function...
 */
async function Company_Function() {
  Company = (await Backendless.Data.of('Customers').save( ({ [`Company`]: Customer,[`Type`]: 'Agri',[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
}

/**
 * Describe this function...
 */
async function Trailer_Function() {
  Trailer_Counter = 0;
  for (var count2 = 0; count2 < Bowsers; count2++) {
    Trailer_Counter = Trailer_Counter + 1;
    Trailer = (await Backendless.Data.of('AGRI_Bowsers').save( ({ [`ownerId`]: (getObjectProperty(Director, 'objectId')),[`Name`]: [Customer.slice(0, 3),' B 000',Trailer_Counter].join('') }) ));
    await Backendless.Data.of('AGRI_Bowsers').setRelation(Trailer, 'Company', [Company]);
  }
}

/**
 * Describe this function...
 */
async function Truck_Function() {
  Truck_Counter = 0;
  for (var count3 = 0; count3 < Truck__; count3++) {
    Truck_Counter = Truck_Counter + 1;
    Truck = (await Backendless.Data.of('AGRI_Vehicles').save( ({ [`ownerId`]: (getObjectProperty(Director, 'objectId')),[`Registration`]: [Customer.slice(0, 3),' H 000',Truck_Counter].join('') }) ));
    await Backendless.Data.of('AGRI_Vehicles').setRelation(Truck, 'Company', [Company]);
  }
}

/**
 * Describe this function...
 */
async function Attendant_Function() {
  Driver_Counter = 0;
  for (var count4 = 0; count4 < Bowser_attendants__; count4++) {
    Driver_Counter = Driver_Counter + 1;
    Display_Name = String('Driver') + String(Driver_Counter);
    Driver = (await Backendless.UserService.register( new Backendless.User({ 'email': [Display_Name,'@',(await (async function(Text) {
    	const D = Text
    	const result = D.split(" ").join("");
    	return result
    })(Customer)).toLowerCase(),Director_Email.slice(((Director_Email.lastIndexOf('.') + 1) - 1), Director_Email.length)].join('').toLowerCase(),'password': '1234','AA_Rated_Driver': true,'Account_Type': 'Agri','Agri_Farm_Log': 'Yes','Agri_Log_Book': 'Yes','Customer': Customer,'displayName': Display_Name,'User_level': 'Bowser','ownerId': (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Users').setRelation(Driver, 'Details', [Company]);
  }
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');
  Director_Email = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), 'Director Email')).toLowerCase();
  Director_Name = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), 'Director Name'));
  Customer = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), 'Company Name'));
  Bowser_attendants__ = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), '# Employees'));
  Truck__ = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), '# Vehicles'));
  Bowsers = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), '# Bowsers'));
  await Director_Function();
  await Company_Function();
  await Backendless.Data.of('Users').setRelation(Director, 'Details', [Company]);
  await Truck_Function();
  await Trailer_Function();
  await Attendant_Function();
  ___arguments.context.pageData['Customer List'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Customers', (String('Type = \'Agri\' AND ownerId IS NOT NULL')))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company')) });})));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('6affc138aba9061e445d5cc86c4d4dee');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/cbed3faa8f3d5bc9cac453965c23c0db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('6affc138aba9061e445d5cc86c4d4dee');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/6f28dca51b54ef864fbdb1c35b31f9c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Company, Driver, Director, Display_Name, Customer, Director_Email, Driver_Counter, Driver__, Company_Name__2_, item, Client__, Trailer__, Truck__, Initial_Director, Director_Name, Created_Customer, Client, Client_Counter, Trailer, Trailer_Counter, Truck, Truck_Counter;

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Driver_Function() {
  Driver_Counter = mathRandomInt(5000, 10000);
  for (var count = 0; count < Driver__; count++) {
    Driver_Counter = Driver_Counter + 1;
    Display_Name = String('Driver') + String(Driver_Counter);
    Driver = (await Backendless.UserService.register( new Backendless.User({ 'email': [Display_Name,'@',(await (async function(Text) {
    	const D = Text
    	const result = D.split(" ").join("");
    	return result
    })(Customer)).toLowerCase(),Director_Email.slice(((Director_Email.lastIndexOf('.') + 1) - 1), Director_Email.length)].join('').toLowerCase(),'password': '1234','AA_Rated_Driver': true,'Account_Type': 'Agri','Agri_Farm_Log': 'Yes','Agri_Log_Book': 'Yes','Customer': Customer,'displayName': Display_Name,'User_level': 'Bowser','ownerId': (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Users').setRelation(Driver, 'Details', [Company]);
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Company_Function() {
  Company_Name__2_ = (getObjectProperty(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('ef5acae12e61521d98479b54fc7de58d')), async (item) => {


   return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) == (getObjectProperty(item, 'value')));
  }))[0]), 'label'));
  Company = (await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Company = \'',Company_Name__2_,'\''].join(''))).setPageSize(10)))[0];
}

/**
 * Describe this function...
 */
async function Clients() {
  Client_Counter = mathRandomInt(5000, 10000);
  for (var count2 = 0; count2 < Client__; count2++) {
    Client_Counter = Client_Counter + 1;
    Display_Name = String('Customer 000') + String(Client_Counter);
    Client = (await Backendless.UserService.register( new Backendless.User({ 'email': (await (async function(Text) {
    	const D = Text
    	const result = D.split(" ").join("");
    	return result
    })(([Display_Name,'@',(await (async function(Text) {
    	const D = Text
    	const result = D.split(" ").join("");
    	return result
    })(Customer)).toLowerCase(),Director_Email.slice(((Director_Email.indexOf('.') + 1) - 1), Director_Email.length)].join('')))).toLowerCase(),'password': '1234','Account_Type': 'Agri','Agri_Farm_Log': 'Yes','Agri_Log_Book': 'Yes','User_level': 'Director','Customer': Display_Name,'displayName': Display_Name,'ownerId': undefined }) ));
    Client['ownerId'] = (getObjectProperty(Client, 'objectId'));
    await Backendless.Data.of('Users').save( Client );
    Created_Customer = (await Backendless.Data.of('Customers').save( ({ [`Company`]: Display_Name,[`Type`]: 'Agri',[`ownerId`]: (getObjectProperty(Client, 'ownerId')) }) ));
    await Backendless.Data.of('Customers').setRelation(Created_Customer, 'AGRI_Contractors', [Company]);
    await Backendless.Data.of('Customers').addRelation(Company, 'AGRI_Clients', [Created_Customer]);
  }
}

/**
 * Describe this function...
 */
async function Trailer_Function() {
  Trailer_Counter = mathRandomInt(5000, 10000);
  for (var count3 = 0; count3 < Trailer__; count3++) {
    Trailer_Counter = Trailer_Counter + 1;
    Trailer = (await Backendless.Data.of('AGRI_Bowsers').save( ({ [`ownerId`]: (getObjectProperty(Director, 'objectId')),[`Name`]: [Customer.slice(0, 3),' B 000',Trailer_Counter].join('') }) ));
    await Backendless.Data.of('AGRI_Bowsers').setRelation(Trailer, 'Company', [Company]);
  }
}

/**
 * Describe this function...
 */
async function Truck_Function() {
  Truck_Counter = mathRandomInt(5000, 10000);
  for (var count4 = 0; count4 < Truck__; count4++) {
    Truck_Counter = Truck_Counter + 1;
    Truck = (await Backendless.Data.of('AGRI_Vehicles').save( ({ [`ownerId`]: (getObjectProperty(Director, 'objectId')),[`Registration`]: [Customer.slice(0, 3),' H 000',Truck_Counter].join('') }) ));
    await Backendless.Data.of('AGRI_Vehicles').setRelation(Truck, 'Company', [Company]);
  }
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');
  Initial_Director = (
      await Backendless.Data.of( Backendless.User ).findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')))
  );
  Director = Initial_Director;
  Director_Email = (getObjectProperty(Initial_Director, 'email'));
  Director_Name = (getObjectProperty(Initial_Director, 'displayName'));
  Customer = (getObjectProperty(Initial_Director, 'Customer'));
  Driver__ = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1e0cbdf6e5b566f1dff77c4b560fad66'), '# Attendants'));
  Truck__ = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1e0cbdf6e5b566f1dff77c4b560fad66'), '# Vehicles'));
  Trailer__ = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1e0cbdf6e5b566f1dff77c4b560fad66'), '# Bowsers'));
  await Company_Function();
  await Truck_Function();
  await Trailer_Function();
  await Driver_Function();
  ___arguments.context.pageData['Customer List'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Customers', (String('Type = \'Agri\' AND ownerId IS NOT NULL')))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company')) });})));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14bed0bfa0a6f1f170e1ff6ca6b4114f');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/9c7a4478c6bffa36e9e7723f5daa6309/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/b6d29ab98859ee4fbfd13123d87c3f45/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/31f62593825b1bf5e34bbca8a58fcb89/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (((getObjectProperty(___arguments.context.pageData, 'Customer List')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'Customer List')) === 'undefined')) {
    List = [];
  } else {
    List = (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customer List')), async (item) => {


     return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) != (getObjectProperty(item, 'value')));
    })), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    }));
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/d1d64eeca989064ca102c5c867dfa59f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Contractor, Client, item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('002706680e79bcae62834e5b7dcadec8');
  Client = (await Backendless.Data.of('Customers').findById((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customer List')), async (item) => {


   return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) == (getObjectProperty(item, 'value')));
  }))[0]), 'objectId')), ));
  Contractor = (await Backendless.Data.of('Customers').findById((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customer List')), async (item) => {


   return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('31f62593825b1bf5e34bbca8a58fcb89')) == (getObjectProperty(item, 'value')));
  }))[0]), 'objectId')), ));
  await Backendless.Data.of('Customers').addRelation(Contractor, 'AGRI_Clients', [Client]);
  await Backendless.Data.of('Customers').addRelation(Client, 'AGRI_Contractors', [Contractor]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('002706680e79bcae62834e5b7dcadec8');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/822fdc3ec6c956940caeea3396f17772/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (((getObjectProperty(___arguments.context.pageData, 'Customer List')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'Customer List')) === 'undefined')) {
    List = [];
  } else {
    List = (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customer List')), async (item) => {


     return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) != (getObjectProperty(item, 'value')));
    })), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    }));
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/8a7bdcf88773aff8f39187fb1c5e8352/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Contractor, Client, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');
  Contractor = (await Backendless.Data.of('Customers').findById((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customer List')), async (item) => {


   return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) == (getObjectProperty(item, 'value')));
  }))[0]), 'objectId')), ));
  Client = (await Backendless.Data.of('Customers').findById((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customer List')), async (item) => {


   return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('822fdc3ec6c956940caeea3396f17772')) == (getObjectProperty(item, 'value')));
  }))[0]), 'objectId')), ));
  await Backendless.Data.of('Customers').addRelation(Contractor, 'AGRI_Clients', [Client]);
  await Backendless.Data.of('Customers').addRelation(Client, 'AGRI_Contractors', [Contractor]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('002706680e79bcae62834e5b7dcadec8');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/75789fd9eceb65824e4bbebb60a2ea44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Set Contractor Changes')) == 'Add') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/c3d11021dff51606ae05cdc25107b3dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Set Contractor Changes')) == 'Delete') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/f6d81d5c15986555af8cfec8ceff244c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Set Contractor Changes'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Data_Agri/components/95880733eaf1f169304df10ec43e6f76/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Set Client Changes'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Data_Agri/components/40adc5e552d9317128afcb96489e3089/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Set Client Changes')) == 'Add') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/e40856493526fe86511c4ee289fb3dcf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Set Client Changes')) == 'Delete') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/d8713a5951989f6586eb510ef04310dc/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (((getObjectProperty(___arguments.context.pageData, 'Customer List')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'Customer List')) === 'undefined')) {
    List = [];
  } else {
    List = (await Promise.all((getObjectProperty((await Backendless.Data.of('Customers').findById((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customer List')), async (item) => {


     return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) == (getObjectProperty(item, 'value')));
    }))[0]), 'objectId')), Backendless.DataQueryBuilder.create().setRelated(['AGRI_Contractors']))), 'AGRI_Contractors')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Company')) });})));
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/cc27a4858f5f7a5581ef7ac510699424/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Contractor, Client, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('002706680e79bcae62834e5b7dcadec8');
  console.log(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customer List')), async (item) => {


   return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) == (getObjectProperty(item, 'value')));
  }));
  Client = (await Backendless.Data.of('Customers').findById((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customer List')), async (item) => {


   return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) == (getObjectProperty(item, 'value')));
  }))[0]), 'objectId')), ));
  Contractor = (await Backendless.Data.of('Customers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d8713a5951989f6586eb510ef04310dc')), ));
  await Backendless.Data.of('Customers').deleteRelation(Contractor, 'AGRI_Clients', [Client]);
  await Backendless.Data.of('Customers').deleteRelation(Client, 'AGRI_Contractors', [Contractor]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('002706680e79bcae62834e5b7dcadec8');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/bf6fa51423c389534c6f358746778eb5/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (((getObjectProperty(___arguments.context.pageData, 'Customer List')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'Customer List')) === 'undefined')) {
    List = [];
  } else {
    List = (await Promise.all((getObjectProperty((await Backendless.Data.of('Customers').findById((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customer List')), async (item) => {


     return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) == (getObjectProperty(item, 'value')));
    }))[0]), 'objectId')), Backendless.DataQueryBuilder.create().setRelated(['AGRI_Clients']))), 'AGRI_Clients')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Company')) });})));
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/ae4bf1d14da7210f3a8e788b8831b705/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Contractor, Client, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Client = (await Backendless.Data.of('Customers').findById((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customer List')), async (item) => {


   return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) == (getObjectProperty(item, 'value')));
  }))[0]), 'objectId')), ));
  console.log(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('bf6fa51423c389534c6f358746778eb5')));
  Contractor = (await Backendless.Data.of('Customers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('bf6fa51423c389534c6f358746778eb5')), ));
  await Backendless.Data.of('Customers').deleteRelation(Contractor, 'AGRI_Clients', [Client]);
  await Backendless.Data.of('Customers').deleteRelation(Client, 'AGRI_Contractors', [Contractor]);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d1edba841b2a90875a0e57e808626f4e');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/e2c355661b644308893bc042a12523bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Customer')), 'Agri_Applications'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Data_Agri/components/258a4e2e7fa3e3b560b648aa38ee53bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Customer')), 'Agri_Applications')), ___arguments.context.getComponentDataStoreByUid('e0abf686faa9db14c458e76c79a4d8d8'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/395c5bfdafcdc7b505e796da8878cd0d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Customer')), 'Agri_Applications')), ({ [`value`]: 'New Application',[`label`]: 'New Application' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/f2e3215f87aee6782714ad43e2d41ffe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Customer = (getObjectProperty(___arguments.context.pageData, 'Customer'));
  Customer['Agri_Applications'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('e2c355661b644308893bc042a12523bd'));
  await Backendless.Data.of('Customers').save( Customer );
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('69fa4736c7af05ef18d44a848895de3a');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Agri/components/3e2e3f14912689fbb53d4d0ea0e638ee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('e0abf686faa9db14c458e76c79a4d8d8')['label'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Data_Agri/components/868bc64c6a12b2d6d383784dec756591/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('69fa4736c7af05ef18d44a848895de3a');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Builder/components/66e237bd2ffaea09759c83614da42418/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Company, Driver, Employee_Data, Director, Driver_Counter, Customer, Display_Name, Director_Email, Driver__, Trailer__, Truck__, Tier2, Trailer, Trailer_Counter, Truck, First_Load, First_Fuel, Target, Truck_Counter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Driver_Function() {
  Driver_Counter = 0;
  for (var count = 0; count < Driver__; count++) {
    Driver_Counter = Driver_Counter + 1;
    Display_Name = String('Driver') + String(Driver_Counter);
    Driver = (await Backendless.UserService.register( new Backendless.User({ 'email': [Display_Name,'@',Customer,Director_Email.slice(((Director_Email.indexOf('.') + 1) - 1), Director_Email.length)].join('').toLowerCase(),'password': '1234','AA_Rated_Driver': true,'Account_Type': 'Com','AP_addFuel': true,'AP_addLoad': true,'AP_Board_Truck': true,'AP_Leave_Truck': true,'AP_Swap_Trailer': true,'AP_swapTyre': true,'Cellphone': undefined,'Customer': Customer,'displayName': Display_Name,'Phone_Number': undefined,'User_level': 'Driver','ownerId': (getObjectProperty(Director, 'objectId')) }) ));
    Employee_Data = (await Backendless.Data.of('Employees').save( ({ [`Call_Sign`]: Display_Name,[`Company_ID`]: [Customer.slice(0, 3),' E 000',Driver_Counter].join(''),[`Employee_Position`]: 'Driver',[`ownerId`]: (getObjectProperty(Driver, 'objectId')) }) ));
    await Backendless.Data.of('Employees').setRelation(Employee_Data, 'Employer', [Director]);
    await Backendless.Data.of('Employees').setRelation(Employee_Data, 'Employee', [Driver]);
    await Backendless.Data.of('Users').setRelation(Driver, 'Employee_Details', [Employee_Data]);
    await Backendless.Data.of('Users').setRelation(Driver, 'Details', [Company]);
  }
}

/**
 * Describe this function...
 */
async function Director_Function() {
  Director = (await Backendless.UserService.register( new Backendless.User({ 'email': Director_Email,'password': '1234','AA_Home_Page_Icon_View': undefined,'Account_Type': undefined,'AP_Add_Fuel_Office': undefined,'AP_Add_Loads_Office': undefined,'AP_Board_Truck_Office': undefined,'AP_Broker_Overview': undefined,'AP_CPK_Overview': undefined,'AP_Financial_Overview': undefined,'AP_Fleet_Overview': undefined,'AP_Leave_Truck_Office': undefined,'AP_Load_Planner': undefined,'AP_Maintenance_Hub_Web': undefined,'AP_Salary_Overview': undefined,'AP_Swap_Trailer_Office': undefined,'AP_Targets': undefined,'Broker_level': undefined,'Cellphone': undefined,'Customer': undefined,'displayName': undefined,'Manager': undefined,'Phone_Number': undefined,'User_level': undefined }) ));
}

/**
 * Describe this function...
 */
async function Company_Function() {
  Company = (await Backendless.Data.of('Customers').save( ({ [`Company`]: Customer,[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
  Tier2 = (await Backendless.Data.of('Tier_2_Customer').save( ({ [`Customer`]: 'Test',[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
}

/**
 * Describe this function...
 */
async function Truck_Function() {
  Truck_Counter = 0;
  for (var count2 = 0; count2 < Truck__; count2++) {
    Truck_Counter = Truck_Counter + 1;
    Truck = (await Backendless.Data.of('Vehicles').save( ({ [`Annual_License_Fee`]: 0,[`Company`]: Customer,[`Current_Mileage`]: 0,[`Depreciation`]: 0,[`Drive_Axle_Number_Double_Wheels`]: '2',[`Fixed_Maintenance_Plan_Cost`]: 0,[`Fixed_Monthly_Sundry_Fee`]: 0,[`Fleet_ID`]: [Customer.slice(0, 3),' H 000',Truck_Counter].join(''),[`Horse_Registration`]: [Customer.slice(0, 3),' H 000',Truck_Counter].join(''),[`Installment`]: 0,[`Insurance_Premium`]: 0,[`Last_Delivery_Point_Mileage`]: 0,[`Last_Service_Mileage`]: 0,[`Last_Service_Scheduled`]: 0,[`License_Expiry_Date`]: (new Date()),[`Load_Planner_Name`]: undefined,[`Load_Planner_objectId`]: undefined,[`Maintenance_Plan_Rate_per_Km`]: 0,[`Payload`]: 0,[`Per_Km_Maintenance_Plan`]: 'No',[`Per_Km_Toll_Rate`]: 'No',[`Per_Km_Toll_Rate_R`]: 0,[`Service_Interval`]: 15000,[`Service_Warning_Duration_in_KM`]: 2000,[`Status`]: 'Active',[`Steer_Axle_Number`]: '1',[`System_Inception_Mileage`]: 0,[`Tare_Weight`]: 5000,[`Tracking_Fee`]: 0,[`Truck_Planning`]: 'Unplanned',[`Year`]: 2020,[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    Target = (await Backendless.Data.of('Targets').save( ({ [`Commission_Rate`]: 0,[`Ideal_Fuel_Consumption`]: 2,[`Ideal_Rate_Per_Km`]: 20,[`Ideal_Rate_Per_Tonne`]: 200,[`Load_Tolerance`]: 1,[`Monthly_Mileage_Target`]: 15000,[`Monthly_Profit_Target`]: 15000,[`Monthly_Tonnage_Target`]: 2000,[`Permissible_Tonnage`]: 3,[`Projected_Tyre_CPK`]: 1,[`Registration_objectId`]: (getObjectProperty(Truck, 'objectId')),[`Tonnage_Override`]: 3,[`Vehicle_Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Vehicles').setRelation(Truck, 'Owner', [Director]);
    await Backendless.Data.of('Vehicles').setRelation(Truck, 'Tonnage_Override', [Target]);
    await Backendless.Data.of('Targets').setRelation(Target, 'Registration', [Truck]);
    First_Fuel = (await Backendless.Data.of('Fuel').save( ({ [`Contractor_Km_Rate`]: 0,[`cost`]: 0,[`description`]: 'Initiation',[`Fuel_Consumption`]: 2,[`Fuel_Count`]: 1,[`Gain_Loss`]: 0,[`garage`]: 'Initiation',[`Good_Driving_Rate`]: 0,[`Horse_Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`Ideal_Fuel_Consumption`]: 2,[`litres`]: 0,[`mileage`]: 0,[`Mileage_Differential`]: 0,[`reg_objectId`]: (getObjectProperty(Truck, 'objectId')),[`Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Fuel').setRelation(First_Fuel, 'reg', [Truck]);
    First_Load = (await Backendless.Data.of('Loads').save( ({ [`Last_Delivered_Mileage`]: 0,[`Load_Point_Mileage`]: 0,[`Delivery_Point_Mileage`]: 0,[`Completion_Status`]: '1',[`delivery_point`]: 'Initiation',[`Contractor_Tonnage_Rate`]: 0,[`Customer_Name`]: 'Initiation',[`Horse_Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`label`]: 'Initiation',[`load_point`]: 'Initiation',[`Mileage_Differential`]: 0,[`Payload`]: 3,[`Product`]: 'Initiation',[`Status`]: 'Delivered',[`tonnage`]: 3,[`tonnage_Delivery`]: 3,[`Tonnage_Target_Rate`]: 3,[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Loads').setRelation(First_Load, 'Customer', [Tier2]);
    await Backendless.Data.of('Loads').setRelation(First_Load, 'Horse', [Truck]);
  }
}

/**
 * Describe this function...
 */
async function Trailer_Function() {
  Trailer_Counter = 0;
  for (var count3 = 0; count3 < Trailer__; count3++) {
    Trailer_Counter = Trailer_Counter + 1;
    Trailer = (await Backendless.Data.of('Trailers').save( ({ [`Annual_License_Fee`]: 0,[`Axle_Number_Double_Wheel`]: '2',[`Axle_Number_Single_Wheel`]: undefined,[`Current_Mileage`]: 0,[`Fixed_Maintenance_Plan_Cost`]: 0,[`Fleet_ID`]: [Customer.slice(0, 3),' T 000',Trailer_Counter].join(''),[`Installment`]: 0,[`Insurance_Premium`]: 0,[`Last_Service_Mileage`]: 0,[`Last_Service_Scheduled`]: 0,[`License_Expirey_Date`]: (new Date()),[`Monthly_Depreciation`]: 0,[`Service_Interval`]: 50000,[`Service_Warning_Duration`]: 5000,[`System_Inception_Mileage`]: 0,[`Tare`]: 5000,[`Tracking`]: 0,[`Trailer_Position`]: 'T1',[`Trailer_Registration`]: [Customer.slice(0, 3),' T 000',Trailer_Counter].join(''),[`Trailer_Status`]: 'Active',[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Trailers').setRelation(Trailer, 'Owner', [Director]);
  }
}


  Director_Email = 'raymond@fif.co.za'.toLowerCase();
  Customer = 'fif';
  Driver__ = 15;
  Truck__ = 20;
  Trailer__ = 16;
  await Director_Function();
  await Company_Function();
  await Backendless.Data.of('Users').setRelation(Director, 'Details', [Company]);
  await Truck_Function();
  await Trailer_Function();
  await Driver_Function();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Com/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Customer List'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Customers', (String('Type = \'Com\'')))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company')) });})));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Data_Com/components/ef5acae12e61521d98479b54fc7de58d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (((getObjectProperty(___arguments.context.pageData, 'Customer List')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'Customer List')) === 'undefined')) {
    List = [];
  } else {
    List = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'Customer List')), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    }));
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;


  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('13bc90ed7be2b9d272dad3dc2929824f');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('477a1379e2c55fff2ed13a2f7d6350c2');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2d76a6354992d5ea1a96b7d745a78a1d');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('986d8da2d46655163b5f379877b76b15');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('d6a4c173e30c6bcefe3e9856d3e22eb5');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('d6a4c173e30c6bcefe3e9856d3e22eb5');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('ad22d639ee432a2d1e9fa4f12c4db7e3');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('0cf18049da451f55525a53d6312cc6fa');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4ea66d47482bc0950159e40e86a9f654');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Data_Com/components/13bc90ed7be2b9d272dad3dc2929824f/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Com/components/477a1379e2c55fff2ed13a2f7d6350c2/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['Employer.ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Com/components/2d76a6354992d5ea1a96b7d745a78a1d/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Com/components/986d8da2d46655163b5f379877b76b15/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Com/components/d6a4c173e30c6bcefe3e9856d3e22eb5/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Com/components/ad22d639ee432a2d1e9fa4f12c4db7e3/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data_Com/components/4ea66d47482bc0950159e40e86a9f654/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onObjectUpdate */
  async ['onObjectUpdate'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    console.log((await Backendless.Data.of('Fuel').bulkUpdate( (['Registration = \'',(getObjectProperty(___arguments.oldObject, 'Horse_Registration')),'\''].join('')), ({ [`Registration`]: (getObjectProperty(___arguments.newObject, 'Horse_Registration')) }) )));

  } catch (error) {
    console.log(error);

  }
  try {
    console.log((await Backendless.Data.of('Loads').bulkUpdate( (['Horse_Registration = \'',(getObjectProperty(___arguments.oldObject, 'Horse_Registration')),'\''].join('')), ({ [`Horse_Registration`]: (getObjectProperty(___arguments.newObject, 'Horse_Registration')) }) )));

  } catch (error) {
    console.log(error);

  }
  try {
    console.log((await Backendless.Data.of('Tyres').bulkUpdate( (['Currently_On = \'',(getObjectProperty(___arguments.oldObject, 'Horse_Registration')),'\''].join('')), ({ [`Currently_On`]: (getObjectProperty(___arguments.newObject, 'Horse_Registration')) }) )));

  } catch (error) {
    console.log(error);

  }
  try {
    console.log((await Backendless.Data.of('Tyres').bulkUpdate( (['Currently_On = \'',(getObjectProperty(___arguments.oldObject, 'Horse_Registration')),'\''].join('')), ({ [`Currently_On`]: (getObjectProperty(___arguments.newObject, 'Horse_Registration')) }) )));

  } catch (error) {
    console.log(error);

  }
  try {
    console.log((await Backendless.Data.of('Trailers').bulkUpdate( (['Currently_On = \'',(getObjectProperty(___arguments.oldObject, 'Horse_Registration')),'\''].join('')), ({ [`Currently_On`]: (getObjectProperty(___arguments.newObject, 'Horse_Registration')) }) )));

  } catch (error) {
    console.log(error);

  }
  try {
    console.log((await Backendless.Data.of('Targets').bulkUpdate( (['Vehicle_Registration = \'',(getObjectProperty(___arguments.oldObject, 'Horse_Registration')),'\''].join('')), ({ [`Vehicle_Registration`]: (getObjectProperty(___arguments.newObject, 'Horse_Registration')) }) )));

  } catch (error) {
    console.log(error);

  }
  try {
    console.log((await Backendless.Data.of('Repairs_Maintenance').bulkUpdate( (['Registration_Horse = \'',(getObjectProperty(___arguments.oldObject, 'Horse_Registration')),'\''].join('')), ({ [`Registration_Horse`]: (getObjectProperty(___arguments.newObject, 'Horse_Registration')) }) )));

  } catch (error) {
    console.log(error);

  }
  try {
    console.log((await Backendless.Data.of('Other').bulkUpdate( (['Registration = \'',(getObjectProperty(___arguments.oldObject, 'Horse_Registration')),'\''].join('')), ({ [`Registration`]: (getObjectProperty(___arguments.newObject, 'Horse_Registration')) }) )));

  } catch (error) {
    console.log(error);

  }
  try {
    console.log((await Backendless.Data.of('Employees').bulkUpdate( (['Currently_Aboard = \'',(getObjectProperty(___arguments.oldObject, 'Horse_Registration')),'\''].join('')), ({ [`Currently_Aboard`]: (getObjectProperty(___arguments.newObject, 'Horse_Registration')) }) )));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onObjectUpdate */
  /* content */
}))

define('./pages/Data_Com/components/0cf18049da451f55525a53d6312cc6fa/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;


  if ((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === null) || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) === 'undefined')) {
    Clause = null;
  } else {
    Clause = ['ownerId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onObjectUpdate */
  async ['onObjectUpdate'](___arguments) {
    var Employee, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Employee = (await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId  = \'',(getObjectProperty(___arguments.oldObject, 'objectId')),'\''].join(''))).setPageSize(10)))[0];

  } catch (error) {
    console.log(error);

  }
  try {
    Employee['Call_Sign'] = (getObjectProperty(___arguments.newObject, 'displayName'));

  } catch (error) {
    console.log(error);

  }
  try {
    await Backendless.Data.of('Employees').save(Employee, true);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onObjectUpdate */
  /* content */
}))

define('./pages/Data_Com/components/9316aa53662a146f7df94309115902b2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function Clearer() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13bc90ed7be2b9d272dad3dc2929824f', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('477a1379e2c55fff2ed13a2f7d6350c2', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d76a6354992d5ea1a96b7d745a78a1d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('986d8da2d46655163b5f379877b76b15', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d6a4c173e30c6bcefe3e9856d3e22eb5', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad22d639ee432a2d1e9fa4f12c4db7e3', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0cf18049da451f55525a53d6312cc6fa', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ea66d47482bc0950159e40e86a9f654', false);

  } catch (error) {
    console.log(error);

  }
  try {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14bed0bfa0a6f1f170e1ff6ca6b4114f');

  } catch (error) {
    console.log(error);

  }
}


  if (___arguments.value == 'Company') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13bc90ed7be2b9d272dad3dc2929824f', true);
  } else if (___arguments.value == 'Employees') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('477a1379e2c55fff2ed13a2f7d6350c2', true);
  } else if (___arguments.value == 'Fuel') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d76a6354992d5ea1a96b7d745a78a1d', true);
  } else if (___arguments.value == 'Loads') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('986d8da2d46655163b5f379877b76b15', true);
  } else if (___arguments.value == 'Targets') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d6a4c173e30c6bcefe3e9856d3e22eb5', true);
  } else if (___arguments.value == 'Trailers') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ad22d639ee432a2d1e9fa4f12c4db7e3', true);
  } else if (___arguments.value == 'Users') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0cf18049da451f55525a53d6312cc6fa', true);
  } else if (___arguments.value == 'Vehicles') {
    await Clearer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ea66d47482bc0950159e40e86a9f654', true);
  } else if (___arguments.value == 'Add Assets') {
    await Clearer();
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('14bed0bfa0a6f1f170e1ff6ca6b4114f');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Data_Com/components/a5840434af29cca128f9110ddc3e073d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  Backendless.Users.setCurrentUser((
      await Backendless.Data.of( Backendless.User ).findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')))
  ), (
      await Backendless.Data.of( Backendless.User ).findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')))
  ));
  ___arguments.context.appData['Selected Cusomer'] = (
      await Backendless.Data.of( Backendless.User ).findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')))
  );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Com/components/120ed1bebd7f5eb6784a711fcda735c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Delete Code'] = (generateUUID().short());
  console.log(getObjectProperty(___arguments.context.pageData, 'Delete Code'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4b4caa643a3c1f8839df5a124fab0329');
  console.log((await Backendless.Request.post(`${Backendless.appPath}/services/Twilio/sendMessage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'phoneNumber': '+27631925960','message': (getObjectProperty(___arguments.context.pageData, 'Delete Code')) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Com/components/e5a3db84ea3557fc12c7327acce6a449/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');
  Customer = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('ef5acae12e61521d98479b54fc7de58d')), async (item) => {


   return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) == (getObjectProperty(item, 'value')));
  }))[0];
  console.log((await Backendless.Data.of('AAA_EMERGENCY_AAA').bulkDelete( (['Customer = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Bowser_Fills').bulkDelete( (['Company = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Bowsers').bulkDelete( (['ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Farming_Job_Card').bulkDelete( (['Company = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Farming_Log').bulkDelete( (['Company = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Fuel_Log').bulkDelete( (['Company = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Agri_Fuel_Log_Off_Farm').bulkDelete( (['Company = \'',(getObjectProperty(Customer, 'label')),'\''].join('')) )));
  console.log((await Backendless.Data.of('AGRI_Vehicles').bulkDelete( (['ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Customers').bulkDelete( (['ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Driver_Mileage_Dumps').bulkDelete( (['Horse_Registration.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Employees').bulkDelete( (['Employer.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Fuel').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Load_Neg').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Loads').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Locations').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Other').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Repairs_Maintenance').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Targets').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Targets').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Tier_2_Customer').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Trailers').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Tyres').bulkDelete( (['ownerId.ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('Vehicles').bulkDelete( (['ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  console.log((await Backendless.Data.of('users').bulkDelete( (['ownerId = \'',(getObjectProperty(Customer, 'value')),'\''].join('')) )));
  ___arguments.context.pageData['Customer List'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Customers', null)).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company')) });})));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4b4caa643a3c1f8839df5a124fab0329');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Entered Code')) == (getObjectProperty(___arguments.context.pageData, 'Delete Code'))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Data_Com/components/e0f39d1996ade13583c3793b27df290a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Entered Code'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Data_Com/components/051f78ac5605833185fd501f75915ad1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Company, Customer, Director, Director_Email, Director_Name, Display_Name, Driver, Driver__, Driver_Counter, Employee_Data, First_Fuel, First_Load, item, Target, Tier2, Trailer, Trailer__, Trailer_Counter, Truck, Truck__, Truck_Counter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Company_Function() {
  Company = (await Backendless.Data.of('Customers').save( ({ [`Company`]: Customer,[`Type`]: 'Com',[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
  Tier2 = (await Backendless.Data.of('Tier_2_Customer').save( ({ [`Customer`]: 'Test',[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
}

/**
 * Describe this function...
 */
async function Director_Function() {
  Director = (await Backendless.UserService.register( new Backendless.User({ 'email': Director_Email,'password': '1234','Account_Type': 'Com','AP_Add_Fuel_Office': true,'AP_Add_Loads_Office': true,'AP_Board_Truck_Office': true,'AP_Broker_Overview': true,'AP_CPK_Overview': true,'AP_Financial_Overview': true,'AP_Fleet_Overview': true,'AP_Leave_Truck_Office': true,'AP_Load_Planner': true,'AP_Maintenance_Hub_Web': true,'AP_Salary_Overview': true,'AP_Swap_Trailer_Office': true,'AP_Targets': true,'Broker_level': 'Director','Customer': Customer,'displayName': Director_Name,'User_level': 'Director' }) ));
  Director['ownerId'] = (getObjectProperty(Director, 'objectId'));
  await Backendless.Data.of('Users').save( Director );
}

/**
 * Describe this function...
 */
async function Truck_Function() {
  Truck_Counter = 0;
  for (var count = 0; count < Truck__; count++) {
    Truck_Counter = Truck_Counter + 1;
    Truck = (await Backendless.Data.of('Vehicles').save( ({ [`Annual_License_Fee`]: 0,[`Company`]: Customer,[`Current_Mileage`]: 0,[`Depreciation`]: 0,[`Drive_Axle_Number_Double_Wheels`]: '2',[`Fixed_Maintenance_Plan_Cost`]: 0,[`Fixed_Monthly_Sundry_Fee`]: 0,[`Fleet_ID`]: [Customer.slice(0, 3),' H 000',Truck_Counter].join(''),[`Horse_Registration`]: [Customer.slice(0, 3),' H 000',Truck_Counter].join(''),[`Installment`]: 0,[`Insurance_Premium`]: 0,[`Last_Delivery_Point_Mileage`]: 0,[`Last_Service_Mileage`]: 0,[`Last_Service_Scheduled`]: 0,[`License_Expiry_Date`]: (new Date()),[`Load_Planner_Name`]: undefined,[`Load_Planner_objectId`]: undefined,[`Maintenance_Plan_Rate_per_Km`]: 0,[`Payload`]: 0,[`Per_Km_Maintenance_Plan`]: 'No',[`Per_Km_Toll_Rate`]: 'No',[`Per_Km_Toll_Rate_R`]: 0,[`Service_Interval`]: 15000,[`Service_Warning_Duration_in_KM`]: 2000,[`Status`]: 'Active',[`Steer_Axle_Number`]: '1',[`System_Inception_Mileage`]: 0,[`Tare_Weight`]: 5000,[`Tracking_Fee`]: 0,[`Truck_Planning`]: 'Unplanned',[`Year`]: 2020,[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    Target = (await Backendless.Data.of('Targets').save( ({ [`Commission_Rate`]: 0,[`Ideal_Fuel_Consumption`]: 2,[`Ideal_Rate_Per_Km`]: 20,[`Ideal_Rate_Per_Tonne`]: 200,[`Load_Tolerance`]: 1,[`Monthly_Mileage_Target`]: 15000,[`Monthly_Profit_Target`]: 15000,[`Monthly_Tonnage_Target`]: 2000,[`Permissible_Tonnage`]: 3,[`Projected_Tyre_CPK`]: 1,[`Registration_objectId`]: (getObjectProperty(Truck, 'objectId')),[`Tonnage_Override`]: 3,[`Vehicle_Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Vehicles').setRelation(Truck, 'Owner', [Director]);
    await Backendless.Data.of('Vehicles').setRelation(Truck, 'Tonnage_Override', [Target]);
    await Backendless.Data.of('Targets').setRelation(Target, 'Registration', [Truck]);
    First_Fuel = (await Backendless.Data.of('Fuel').save( ({ [`Contractor_Km_Rate`]: 0,[`cost`]: 0,[`description`]: 'Initiation',[`Fuel_Consumption`]: 2,[`Fuel_Count`]: 1,[`Gain_Loss`]: 0,[`garage`]: 'Initiation',[`Good_Driving_Rate`]: 0,[`Horse_Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`Ideal_Fuel_Consumption`]: 2,[`litres`]: 0,[`mileage`]: 0,[`Mileage_Differential`]: 0,[`reg_objectId`]: (getObjectProperty(Truck, 'objectId')),[`Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Fuel').setRelation(First_Fuel, 'reg', [Truck]);
    First_Load = (await Backendless.Data.of('Loads').save( ({ [`Last_Delivered_Mileage`]: 0,[`Load_Point_Mileage`]: 0,[`Delivery_Point_Mileage`]: 0,[`Completion_Status`]: '1',[`delivery_point`]: 'Initiation',[`Contractor_Tonnage_Rate`]: 0,[`Customer_Name`]: 'Initiation',[`Horse_Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`label`]: 'Initiation',[`load_point`]: 'Initiation',[`Mileage_Differential`]: 0,[`Payload`]: 3,[`Product`]: 'Initiation',[`Status`]: 'Delivered',[`tonnage`]: 3,[`tonnage_Delivery`]: 3,[`Tonnage_Target_Rate`]: 3,[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Loads').setRelation(First_Load, 'Customer', [Tier2]);
    await Backendless.Data.of('Loads').setRelation(First_Load, 'Horse', [Truck]);
  }
}

/**
 * Describe this function...
 */
async function Driver_Function() {
  Driver_Counter = 0;
  for (var count2 = 0; count2 < Driver__; count2++) {
    Driver_Counter = Driver_Counter + 1;
    Display_Name = String('Driver') + String(Driver_Counter);
    Driver = (await Backendless.UserService.register( new Backendless.User({ 'email': [Display_Name,'@',(await (async function(Text) {
    	const D = Text
    	const result = D.split(" ").join("");
    	return result
    })(Customer)).toLowerCase(),Director_Email.slice(((Director_Email.indexOf('.') + 1) - 1), Director_Email.length)].join('').toLowerCase(),'password': '1234','AA_Rated_Driver': true,'Account_Type': 'Com','AP_addFuel': true,'AP_addLoad': true,'AP_Board_Truck': true,'AP_Leave_Truck': true,'AP_Swap_Trailer': true,'AP_swapTyre': true,'Cellphone': undefined,'Customer': Customer,'displayName': Display_Name,'Phone_Number': undefined,'User_level': 'Driver','ownerId': (getObjectProperty(Director, 'objectId')) }) ));
    Employee_Data = (await Backendless.Data.of('Employees').save( ({ [`Call_Sign`]: Display_Name,[`Company_ID`]: [Customer.slice(0, 3),' E 000',Driver_Counter].join(''),[`Employee_Position`]: 'Driver',[`ownerId`]: (getObjectProperty(Driver, 'objectId')) }) ));
    await Backendless.Data.of('Employees').setRelation(Employee_Data, 'Employer', [Director]);
    await Backendless.Data.of('Employees').setRelation(Employee_Data, 'Employee', [Driver]);
    await Backendless.Data.of('Users').setRelation(Driver, 'Employee_Details', [Employee_Data]);
    await Backendless.Data.of('Users').setRelation(Driver, 'Details', [Company]);
  }
}

/**
 * Describe this function...
 */
async function Trailer_Function() {
  Trailer_Counter = 0;
  for (var count3 = 0; count3 < Trailer__; count3++) {
    Trailer_Counter = Trailer_Counter + 1;
    Trailer = (await Backendless.Data.of('Trailers').save( ({ [`Annual_License_Fee`]: 0,[`Axle_Number_Double_Wheel`]: '2',[`Axle_Number_Single_Wheel`]: undefined,[`Current_Mileage`]: 0,[`Fixed_Maintenance_Plan_Cost`]: 0,[`Fleet_ID`]: [Customer.slice(0, 3),' T 000',Trailer_Counter].join(''),[`Installment`]: 0,[`Insurance_Premium`]: 0,[`Last_Service_Mileage`]: 0,[`Last_Service_Scheduled`]: 0,[`License_Expirey_Date`]: (new Date()),[`Monthly_Depreciation`]: 0,[`Service_Interval`]: 50000,[`Service_Warning_Duration`]: 5000,[`System_Inception_Mileage`]: 0,[`Tare`]: 5000,[`Tracking`]: 0,[`Trailer_Position`]: 'T1',[`Trailer_Registration`]: [Customer.slice(0, 3),' T 000',Trailer_Counter].join(''),[`Trailer_Status`]: 'Active',[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Trailers').setRelation(Trailer, 'Owner', [Director]);
  }
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');
  Director_Email = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), 'Director Email')).toLowerCase();
  Director_Name = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), 'Director Name'));
  Customer = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), 'Company Name'));
  Driver__ = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), '# Drivers'));
  Truck__ = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), '# Trucks'));
  Trailer__ = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e1d1d341d7dda7ca354858529c3bb8bd'), '# Trailers'));
  await Director_Function();
  await Company_Function();
  await Backendless.Data.of('Users').setRelation(Director, 'Details', [Company]);
  await Truck_Function();
  await Trailer_Function();
  await Driver_Function();
  ___arguments.context.pageData['Customer List'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Customers', null)).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company')) });})));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('6affc138aba9061e445d5cc86c4d4dee');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Com/components/cbed3faa8f3d5bc9cac453965c23c0db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('6affc138aba9061e445d5cc86c4d4dee');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Data_Com/components/6f28dca51b54ef864fbdb1c35b31f9c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Trailer__, Truck__, Driver__, Initial_Director, Customer, Director_Name, Director_Email, Director, Company, Tier2, Company_Name__2_, Driver, Employee_Data, Driver_Counter, Display_Name, Truck, First_Load, First_Fuel, Target, Truck_Counter, Trailer, Trailer_Counter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Company_Function() {
  Company_Name__2_ = (getObjectProperty(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('ef5acae12e61521d98479b54fc7de58d')), async (item) => {


   return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')) == (getObjectProperty(item, 'value')));
  }))[0]), 'label'));
  Company = (await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Company = \'',Company_Name__2_,'\''].join(''))).setPageSize(10)))[0];
  console.log(Company);
  console.log(getObjectProperty(Company, 'ownerId'));
  Tier2 = (await Backendless.Data.of('Tier_2_Customer').save( ({ [`Customer`]: 'Test',[`ownerId`]: (getObjectProperty(Company, 'ownerId')) }) ));
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

/**
 * Describe this function...
 */
async function Driver_Function() {
  Driver_Counter = mathRandomInt(5000, 10000);
  for (var count = 0; count < Driver__; count++) {
    Driver_Counter = Driver_Counter + 1;
    Display_Name = String('Driver') + String(Driver_Counter);
    Driver = (await Backendless.UserService.register( new Backendless.User({ 'email': (await (async function(Text) {
    	const D = Text
    	const result = D.split(" ").join("");
    	return result
    })(([Display_Name,'@',(await (async function(Text) {
    	const D = Text
    	const result = D.split(" ").join("");
    	return result
    })((await (async function(Text) {
    	const D = Text
    	const result = D.replace(/([,"'0-9\-.~!@#$%^&*()_+=–’`{}\[\]\|\\:;"<>\/?])+/g, '').replace(/^(-)+|(-)+$/g,'');
    	return result
    })(Customer)))).toLowerCase(),Director_Email.slice(((Director_Email.indexOf('.') + 1) - 1), Director_Email.length)].join('').toLowerCase()))),'password': '1234','AA_Rated_Driver': true,'Account_Type': 'Com','AP_addFuel': true,'AP_addLoad': true,'AP_Board_Truck': true,'AP_Leave_Truck': true,'AP_Swap_Trailer': true,'AP_swapTyre': true,'Cellphone': undefined,'Customer': Customer,'displayName': Display_Name,'Phone_Number': undefined,'User_level': 'Driver','ownerId': (getObjectProperty(Director, 'objectId')) }) ));
    Employee_Data = (await Backendless.Data.of('Employees').save( ({ [`Call_Sign`]: Display_Name,[`Company_ID`]: [Customer.slice(0, 3),' E 000',Driver_Counter].join(''),[`Employee_Position`]: 'Driver',[`ownerId`]: (getObjectProperty(Driver, 'objectId')) }) ));
    await Backendless.Data.of('Employees').setRelation(Employee_Data, 'Employer', [Director]);
    await Backendless.Data.of('Employees').setRelation(Employee_Data, 'Employee', [Driver]);
    await Backendless.Data.of('Users').setRelation(Driver, 'Employee_Details', [Employee_Data]);
    await Backendless.Data.of('Users').setRelation(Driver, 'Details', [Company]);
  }
}

/**
 * Describe this function...
 */
async function Truck_Function() {
  Truck_Counter = mathRandomInt(5000, 10000);
  for (var count2 = 0; count2 < Truck__; count2++) {
    Truck_Counter = Truck_Counter + 1;
    Truck = (await Backendless.Data.of('Vehicles').save( ({ [`Annual_License_Fee`]: 0,[`Company`]: Customer,[`Current_Mileage`]: 0,[`Depreciation`]: 0,[`Drive_Axle_Number_Double_Wheels`]: '2',[`Fixed_Maintenance_Plan_Cost`]: 0,[`Fixed_Monthly_Sundry_Fee`]: 0,[`Fleet_ID`]: [Customer.slice(0, 3),' H 000',Truck_Counter].join(''),[`Horse_Registration`]: [Customer.slice(0, 3),' H 000',Truck_Counter].join(''),[`Installment`]: 0,[`Insurance_Premium`]: 0,[`Last_Delivery_Point_Mileage`]: 0,[`Last_Service_Mileage`]: 0,[`Last_Service_Scheduled`]: 0,[`License_Expiry_Date`]: (new Date()),[`Load_Planner_Name`]: undefined,[`Load_Planner_objectId`]: undefined,[`Maintenance_Plan_Rate_per_Km`]: 0,[`Payload`]: 0,[`Per_Km_Maintenance_Plan`]: 'No',[`Per_Km_Toll_Rate`]: 'No',[`Per_Km_Toll_Rate_R`]: 0,[`Service_Interval`]: 15000,[`Service_Warning_Duration_in_KM`]: 2000,[`Status`]: 'Active',[`Steer_Axle_Number`]: '1',[`System_Inception_Mileage`]: 0,[`Tare_Weight`]: 5000,[`Tracking_Fee`]: 0,[`Truck_Planning`]: 'Unplanned',[`Year`]: 2020,[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    Target = (await Backendless.Data.of('Targets').save( ({ [`Commission_Rate`]: 0,[`Ideal_Fuel_Consumption`]: 2,[`Ideal_Rate_Per_Km`]: 20,[`Ideal_Rate_Per_Tonne`]: 200,[`Load_Tolerance`]: 1,[`Monthly_Mileage_Target`]: 15000,[`Monthly_Profit_Target`]: 15000,[`Monthly_Tonnage_Target`]: 2000,[`Permissible_Tonnage`]: 3,[`Projected_Tyre_CPK`]: 1,[`Registration_objectId`]: (getObjectProperty(Truck, 'objectId')),[`Tonnage_Override`]: 3,[`Vehicle_Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Vehicles').setRelation(Truck, 'Owner', [Director]);
    await Backendless.Data.of('Vehicles').setRelation(Truck, 'Tonnage_Override', [Target]);
    await Backendless.Data.of('Targets').setRelation(Target, 'Registration', [Truck]);
    First_Fuel = (await Backendless.Data.of('Fuel').save( ({ [`Contractor_Km_Rate`]: 0,[`cost`]: 0,[`description`]: 'Initiation',[`Fuel_Consumption`]: 2,[`Fuel_Count`]: 1,[`Gain_Loss`]: 0,[`garage`]: 'Initiation',[`Good_Driving_Rate`]: 0,[`Horse_Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`Ideal_Fuel_Consumption`]: 2,[`litres`]: 0,[`mileage`]: 0,[`Mileage_Differential`]: 0,[`reg_objectId`]: (getObjectProperty(Truck, 'objectId')),[`Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Fuel').setRelation(First_Fuel, 'reg', [Truck]);
    First_Load = (await Backendless.Data.of('Loads').save( ({ [`Last_Delivered_Mileage`]: 0,[`Load_Point_Mileage`]: 0,[`Delivery_Point_Mileage`]: 0,[`Completion_Status`]: '1',[`delivery_point`]: 'Initiation',[`Contractor_Tonnage_Rate`]: 0,[`Customer_Name`]: 'Initiation',[`Horse_Registration`]: (getObjectProperty(Truck, 'Horse_Registration')),[`label`]: 'Initiation',[`load_point`]: 'Initiation',[`Mileage_Differential`]: 0,[`Payload`]: 3,[`Product`]: 'Initiation',[`Status`]: 'Delivered',[`tonnage`]: 3,[`tonnage_Delivery`]: 3,[`Tonnage_Target_Rate`]: 3,[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Loads').setRelation(First_Load, 'Customer', [Tier2]);
    await Backendless.Data.of('Loads').setRelation(First_Load, 'Horse', [Truck]);
  }
}

/**
 * Describe this function...
 */
async function Trailer_Function() {
  Trailer_Counter = mathRandomInt(5000, 10000);
  for (var count3 = 0; count3 < Trailer__; count3++) {
    Trailer_Counter = Trailer_Counter + 1;
    Trailer = (await Backendless.Data.of('Trailers').save( ({ [`Annual_License_Fee`]: 0,[`Axle_Number_Double_Wheel`]: '2',[`Axle_Number_Single_Wheel`]: undefined,[`Current_Mileage`]: 0,[`Fixed_Maintenance_Plan_Cost`]: 0,[`Fleet_ID`]: [Customer.slice(0, 3),' T 000',Trailer_Counter].join(''),[`Installment`]: 0,[`Insurance_Premium`]: 0,[`Last_Service_Mileage`]: 0,[`Last_Service_Scheduled`]: 0,[`License_Expirey_Date`]: (new Date()),[`Monthly_Depreciation`]: 0,[`Service_Interval`]: 50000,[`Service_Warning_Duration`]: 5000,[`System_Inception_Mileage`]: 0,[`Tare`]: 5000,[`Tracking`]: 0,[`Trailer_Position`]: 'T1',[`Trailer_Registration`]: [Customer.slice(0, 3),' T 000',Trailer_Counter].join(''),[`Trailer_Status`]: 'Active',[`ownerId`]: (getObjectProperty(Director, 'objectId')) }) ));
    await Backendless.Data.of('Trailers').setRelation(Trailer, 'Owner', [Director]);
  }
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');
  Initial_Director = (
      await Backendless.Data.of( Backendless.User ).findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ef5acae12e61521d98479b54fc7de58d')))
  );
  Director = Initial_Director;
  Director_Email = (getObjectProperty(Initial_Director, 'email'));
  Director_Name = (getObjectProperty(Initial_Director, 'displayName'));
  Customer = (getObjectProperty(Initial_Director, 'Customer'));
  Driver__ = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1e0cbdf6e5b566f1dff77c4b560fad66'), '# Drivers'));
  Truck__ = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1e0cbdf6e5b566f1dff77c4b560fad66'), '# Trucks'));
  Trailer__ = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1e0cbdf6e5b566f1dff77c4b560fad66'), '# Trailers'));
  await Company_Function();
  await Truck_Function();
  await Trailer_Function();
  await Driver_Function();
  ___arguments.context.pageData['Customer List'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Customers', null)).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company')) });})));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('14bed0bfa0a6f1f170e1ff6ca6b4114f');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c16e82ea1ce7801ebc5aa3346fc79db');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Fleet_Item, item, Tyre, error, Driver_Filter, Salary, Start_Date, Tonnage_Total;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function do_something4() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);
  ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Slider'] = 0;
  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  if (!(await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
  Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
  Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
  Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
  Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
  ___arguments.context.pageData['Start_Date'] = Start_Date;
  ___arguments.context.pageData['End_Date'] = (new Date());
  Salary = (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employer.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return item;})));
  Fleet_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  item['Targets'] = ((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100)))[0]);
    item['Horse_FI'] = ((getObjectProperty(item, 'Depreciation')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Fixed_Monthly_Sundry_Fee')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Tracking_Fee')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);
    item['Trailers_FI'] = (((getObjectProperty(item, 'Trailer1_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer2_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer3_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0));
    item['Per_Km_TR_FI'] = ((getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_Toll_Rate_R')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);
    try {
      item['Salary/Wages_FI'] = (getObjectProperty(((await asyncListFilter(Salary, async (Driver_Filter) => {


       return ((getObjectProperty(item, 'Current_Driver')) == (getObjectProperty(Driver_Filter, 'Call_Sign')));
      }))[0]), 'Total'));

    } catch (error) {
      if (error) {
        item['Salary/Wages_FI'] = 0;
      }

    }
    item['Per_Km_M_Plan_FI'] = ((getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Maintenance_Plan_Rate_per_Km')) : 0);
    item['ATE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}));
  ; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`Horse_Registration`]: (getObjectProperty(item, 'Fleet_ID')),[`Horse_ID`]: (getObjectProperty(item, 'Horse_Registration')),[`License_Notice_FI`]: (getObjectProperty(item, 'Trailer1_Reg')),[`License_PDP_FI`]: (getObjectProperty(item, 'Trailer2_Reg')),[`Trailer_3_FI`]: (getObjectProperty(item, 'Trailer3_Reg')),[`Driver_1`]: (getObjectProperty(item, 'Horse_FI')),[`Service_Notice`]: (getObjectProperty(item, 'Trailers_FI')),[`Current_Mileage`]: (getObjectProperty(item, 'Diesel_FI')),[`Distance_Traveled`]: (getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_TR_FI')) : 0,[`Mileage_Target_Completion`]: (getObjectProperty(item, 'Toll_Fees_FI')),[`Ideal_KM/L`]: (getObjectProperty(item, 'Salary/Wages_FI')),[`Actual_KM/L`]: (getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_M_Plan_FI')) : 0,[`Status`]: (getObjectProperty(item, 'MRH_FI')),[`Fuel_Cost`]: (getObjectProperty(item, 'ATE_FI')),[`Price_Per_Litre`]: (getObjectProperty(item, 'PTE_FI')),[`Fuel_Cost_Per_Km`]: (getObjectProperty(item, 'Projected_Commission_FI')),[`Gain/loss_Driving_Style`]: (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')),[`Total_Tonnage`]: (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))) / (getObjectProperty(item, 'Distance'))))),[`Litres_Filled`]: (getObjectProperty(item, 'Turnover_FI')),[`Target_Tonnage_Completion`]: (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')),[`Permissible_Tonnage`]: (getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))),[`Average_Tonnage`]: (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')))) / (getObjectProperty(item, 'Distance'))))),[`Gain/Loss_Loading`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_MI`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Loss_On_Mileage_In_Money'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_TO`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GainLoss_On_Load'));}))), 0)).reduce(function(x, y) {return x + y;}),[`License_Notice_T1_FI`]: undefined,[`License_Notice_T2_FI`]: undefined,[`License_Notice_T3_FI`]: undefined,[`License_Notice_Trailers_FI`]: undefined,[`Service_Warning_Duration_in_KM`]: undefined,[`Service_Interval`]: undefined });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', Fleet_Item);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', false);
}

/**
 * Describe this function...
 */
async function Page_Loader() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c55832ef99386143591bbb014b56e9ec', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('223497f79e8f94bac1476e487b09d448', true);
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('576155c6897967125f086d6bf7d5885a'))['opacity'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);
  ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  if (!(await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  Start_Date = (new Date());
  Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
  Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
  Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
  Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
  Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
  ___arguments.context.pageData['Start_Date'] = Start_Date;
  ___arguments.context.pageData['End_Date'] = (new Date());
  Salary = (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employer.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Name`]: (getObjectProperty(item, 'Name')),[`Call_Sign`]: (getObjectProperty(item, 'Call_Sign')),[`Employee_Details`]: item,[`Basic_Salary`]: (getObjectProperty(item, 'Basic_Salary')),[`Contractor_Km_Payment`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`GD_Payment`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Contractor_Tonnage_Pay`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Tonnage_Target_Pay`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Total`]: (getObjectProperty(item, 'Basic_Salary')) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (getObjectProperty(item, 'Bargaining_Council_And_Union_Levies')) + (getObjectProperty(item, 'Provident_And_Pension_Fund')) + (getObjectProperty(item, 'Medical_Aid')) });})));
  Fleet_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  item['Distance'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Targets'] = ((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100)))[0]);
    item['Horse_FI'] = ((getObjectProperty(item, 'Depreciation')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Fixed_Monthly_Sundry_Fee')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Tracking_Fee')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);
    item['Trailers_FI'] = (((getObjectProperty(item, 'Trailer1_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer2_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer3_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0));
    item['Other_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Diesel_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Distance'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Per_Km_TR_FI'] = ((getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_Toll_Rate_R')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);
    item['Toll_Fees_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Type = \'Toll\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    try {
      item['Salary/Wages_FI'] = (getObjectProperty(((await asyncListFilter(Salary, async (Driver_Filter) => {


       return ((getObjectProperty(item, 'Current_Driver')) == (getObjectProperty(Driver_Filter, 'Call_Sign')));
      }))[0]), 'Total'));

    } catch (error) {
      if (error) {
        item['Salary/Wages_FI'] = 0;
      }

    }
    item['Per_Km_M_Plan_FI'] = ((getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Maintenance_Plan_Rate_per_Km')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);
    item['MRH_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Horse = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['ATE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Tyre_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['PTE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Projected_Commission_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((getObjectProperty(Tonnage_Total, 'Load_Value')) * (1 + (getObjectProperty((getObjectProperty(item, 'Targets')), 'Commission_Rate')) / 100) - (getObjectProperty(Tonnage_Total, 'Load_Value')))));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Turnover_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (getObjectProperty(Tonnage_Total, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;}));
  ; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`Horse_Registration`]: (getObjectProperty(item, 'Fleet_ID')),[`Horse_ID`]: (getObjectProperty(item, 'Horse_Registration')),[`License_Notice_FI`]: (getObjectProperty(item, 'Trailer1_Reg')),[`License_PDP_FI`]: (getObjectProperty(item, 'Trailer2_Reg')),[`Trailer_3_FI`]: (getObjectProperty(item, 'Trailer3_Reg')),[`Driver_1`]: (getObjectProperty(item, 'Horse_FI')),[`Service_Notice`]: (getObjectProperty(item, 'Trailers_FI')),[`Current_Mileage`]: (getObjectProperty(item, 'Diesel_FI')),[`Distance_Traveled`]: (getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_TR_FI')) : 0,[`Mileage_Target_Completion`]: (getObjectProperty(item, 'Toll_Fees_FI')),[`Ideal_KM/L`]: (getObjectProperty(item, 'Salary/Wages_FI')),[`Actual_KM/L`]: (getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_M_Plan_FI')) : 0,[`Status`]: (getObjectProperty(item, 'MRH_FI')),[`Fuel_Cost`]: (getObjectProperty(item, 'ATE_FI')),[`Price_Per_Litre`]: (getObjectProperty(item, 'ATE_FI')) * (getObjectProperty(item, 'Distance')),[`Fuel_Cost_Per_Km`]: (getObjectProperty(item, 'Projected_Commission_FI')),[`Gain/loss_Driving_Style`]: (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + (getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')),[`Total_Tonnage`]: (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + 0 + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))) / (getObjectProperty(item, 'Distance'))))),[`Litres_Filled`]: (getObjectProperty(item, 'Turnover_FI')),[`Target_Tonnage_Completion`]: (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')),[`Permissible_Tonnage`]: (getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + (getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))),[`Average_Tonnage`]: (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + (getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')))) / (getObjectProperty(item, 'Distance'))))),[`Gain/Loss_Loading`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_MI`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Loss_On_Mileage_In_Money'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_TO`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GainLoss_On_Load'));}))), 0)).reduce(function(x, y) {return x + y;}),[`License_Notice_T1_FI`]: (getObjectProperty(item, 'Turnover_FI')) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}),[`License_Notice_T2_FI`]: (getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + 0 + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))),[`License_Notice_T3_FI`]: undefined,[`License_Notice_Trailers_FI`]: undefined,[`Service_Warning_Duration_in_KM`]: (getObjectProperty(item, 'Other_FI')),[`Service_Interval`]: (getObjectProperty(item, 'Tyre_FI')) });})));
  console.log(Fleet_Item);
  await Page_Loader();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', Fleet_Item);
  await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('576155c6897967125f086d6bf7d5885a')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('576155c6897967125f086d6bf7d5885a')), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6')), false);

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Financial_Overview/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/a326c6adc603ee1603ce948afd16bbdf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var Start_Date;


  Start_Date = (new Date(___arguments.value));
  ___arguments.context.pageData['Start_Date'] = Start_Date;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Start_Date'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/8093a66253eb9b76d76778f92314ad6c/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'End_Date'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    var End_Date;


  End_Date = (new Date(___arguments.value));
  ___arguments.context.pageData['End_Date'] = End_Date;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Financial_Overview/components/0e0200c11cbcde7cbdf70a0e7988a0d4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  onStyleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Service_Notice')) == 'Service Due') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0e0200c11cbcde7cbdf70a0e7988a0d4'))['color'] = 'yellow';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Service_Notice')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/aadffa177e03469667c81325f5b42c65/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  onStyleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status')) == 'Consumption Error') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aadffa177e03469667c81325f5b42c65'))['color'] = 'Red';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/7f9680277fe89cfde26b11be22d7b3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f37262471d731fed615a69b8a7feee5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e876a682297ad47ecb1dbf78e6d1187', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b2bc27fa06d5a8393c547c8476593d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('824ee37956d5968a8b75e9d22edf9b49', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/9bf3c6a806384ffef5c401cba2012dae/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var Where_Clause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Images_View'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Image_1'] = (getObjectProperty(___arguments.selectedRecord, 'image'));
  ___arguments.context.pageData['DataImageText'] = (['Fuel Slip','Submitted on ',(new Date((getObjectProperty(___arguments.selectedRecord, 'created'))))].join(''));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Financial_Overview/components/f0f9a9f35c243f15ec01cdac7cf4f714/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  onStyleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')) < 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0f9a9f35c243f15ec01cdac7cf4f714'))['color'] = 'red';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')) > 10000) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0f9a9f35c243f15ec01cdac7cf4f714'))['color'] = 'orange';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Load_Data_Title'] = (['  (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_Registration')),')',' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_ID'))].join(''));
  ___arguments.context.pageData['Load_Data_Whereclause'] = (['Horse.objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'objectId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'','1','\''].join(''));
  console.log(getObjectProperty(___arguments.context.pageData, 'objectId'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/b612d3b3061d799155f81a9286caaa69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f37262471d731fed615a69b8a7feee5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e876a682297ad47ecb1dbf78e6d1187', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b2bc27fa06d5a8393c547c8476593d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('824ee37956d5968a8b75e9d22edf9b49', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/cd59d51714ea0c8c11d3a6513c131c19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f37262471d731fed615a69b8a7feee5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e876a682297ad47ecb1dbf78e6d1187', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b2bc27fa06d5a8393c547c8476593d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('824ee37956d5968a8b75e9d22edf9b49', false);
  ___arguments.context.pageData['Fuel_Data_Title'] = ' Fleet';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/e33968170893649d4367ac61f15e5408/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Images_View'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Image_1'] = (getObjectProperty(___arguments.selectedRecord, 'Profile_Photo'));
  ___arguments.context.pageData['Image_2'] = (getObjectProperty(___arguments.selectedRecord, 'ID_Attachment'));
  ___arguments.context.pageData['Image_3'] = (getObjectProperty(___arguments.selectedRecord, 'License_Attachment'));
  ___arguments.context.pageData['DataImageText'] = (String(getObjectProperty(___arguments.selectedRecord, 'Name')) + String('\'s Images'));

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Employer.ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/ced40fcb6eaca79e0d3f45b91eae6dec/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/dae9c96ab8a4f5a20f5691e5f5af5af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f37262471d731fed615a69b8a7feee5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e876a682297ad47ecb1dbf78e6d1187', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b2bc27fa06d5a8393c547c8476593d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('824ee37956d5968a8b75e9d22edf9b49', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/c11adb9f109d6ffa0e951148f41ad97a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f37262471d731fed615a69b8a7feee5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e876a682297ad47ecb1dbf78e6d1187', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b2bc27fa06d5a8393c547c8476593d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('824ee37956d5968a8b75e9d22edf9b49', false);
  ___arguments.context.pageData['Sundry_Data_Whereclause'] = (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/0a44b4c1e9cc4e8486e1847d8d0cadf9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a44b4c1e9cc4e8486e1847d8d0cadf9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64abcaf5ca5e80f2a7f4740b69d9c91c', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6ac9db8ea16e94f2f8edec3e1a5ecae', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/64abcaf5ca5e80f2a7f4740b69d9c91c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6ac9db8ea16e94f2f8edec3e1a5ecae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64abcaf5ca5e80f2a7f4740b69d9c91c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a44b4c1e9cc4e8486e1847d8d0cadf9', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/84e399febbb69c6906ae14f2c7c899ab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), 'Driver_Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/56a25647cafe65f486633cb8f338c2bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '3Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/83d3c61a37097477378eec49bf9d1e25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '4Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/07c2624860b79354fab219fa499b6d86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '5Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/34f478020a4af087eb9943b716f9c834/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '6Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/6471c6fa4c29c02f8b820496dfb980a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '7Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/090849a9211b46a9558969e764f374a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '8Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/6f2295db02fe4d353ffed4f8eab182d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '9Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/acf1d60d39370e881c2c2f3b9d848899/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '10Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/60f8c62d363af106cf134b052cfd3ccf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '11Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/d9395a792f543e413ce89701e4cd9812/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '12Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/f2932fb984a63989fe3fe2428f36664f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '13Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/b53852c6a7463b394fd5a0e7c0b36fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '14Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/c71e513692df5bc82a142eda2ca42795/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '15Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/38baaf59f6ab264c9ea3080349d674e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '16Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/be2ae87e6ee90ea59c8c6dc4ab57a9fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '17Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/4a522b097016d63ab1b90bec89512ac5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '18Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/b42d6b87bb41d83c316dbce64e6bdf8d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '19Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/d18be616a10fad5c6bc9a15927bfba34/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '20Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/8096fb55ff9c027bc50ec5ae514327e5/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.dataModel['Driver_Check'] = false;
  ___arguments.context.dataModel['2Check'] = true;
  ___arguments.context.dataModel['3Check'] = false;
  ___arguments.context.dataModel['4Check'] = true;
  ___arguments.context.dataModel['5Check'] = false;
  ___arguments.context.dataModel['6Check'] = false;
  ___arguments.context.dataModel['7Check'] = true;
  ___arguments.context.dataModel['8Check'] = false;
  ___arguments.context.dataModel['9Check'] = true;
  ___arguments.context.dataModel['10Check'] = false;
  ___arguments.context.dataModel['11Check'] = false;
  ___arguments.context.dataModel['12Check'] = false;
  ___arguments.context.dataModel['13Check'] = false;
  ___arguments.context.dataModel['14Check'] = true;
  ___arguments.context.dataModel['15Check'] = false;
  ___arguments.context.dataModel['16Check'] = false;
  ___arguments.context.dataModel['17Check'] = true;
  ___arguments.context.dataModel['18Check'] = false;
  ___arguments.context.dataModel['19Check'] = false;
  ___arguments.context.dataModel['20Check'] = false;
  ___arguments.context.dataModel['21Check'] = false;

  },
  /* handler:onMounted */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/61348c3229e7b3dd8bd8d9aca2e7a152/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Driver_Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['99Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['2Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['3Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['4Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['5Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['6Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['7Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['8Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['9Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['10Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['11Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['12Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['13Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['14Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['15Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['16Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['17Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['18Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['19Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['20Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['21Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['32Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['76Check'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/5d06b9c2de2c2d3611890ad594edbeca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Driver_Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['99Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['2Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['3Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['4Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['5Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['7Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['8Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['9Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['10Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['11Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['12Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['13Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['14Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['15Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['16Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['17Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['18Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['19Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['20Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['21Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['32Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['32Check'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/cf2d5a1bc5dfeba8a9db31784a714f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Images_View'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/41f553479872cab9abf931ef3b0b2e47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Image_1'] = null;
  ___arguments.context.pageData['Image_2'] = null;
  ___arguments.context.pageData['Image_3'] = null;
  ___arguments.context.pageData['Image_3'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/daa89079a11340a16fc711568858863d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Image_Text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Image_1')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_2')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_3')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_4')) == null) {
    Image_Text = 'No Images Available';
  } else {
    Image_Text = (getObjectProperty(___arguments.context.pageData, 'DataImageText'));
  }

  return Image_Text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/e23b96acd1879198dc2f19e4e90eb0e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/b7649fc62cc8a1432e22311afd238672/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/2fae753c674e30dff7e7456114e29c61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/cd7e08f865dbe001d7579334b4752399/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/0b73ad5cfaaa72ce77521be7926ba1ed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_MI')))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Load_Data_Title'] = (['  (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_Registration')),')',' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_ID'))].join(''));
  ___arguments.context.pageData['Load_Data_Whereclause'] = (['Horse.objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'objectId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'','1','\''].join(''));
  console.log(getObjectProperty(___arguments.context.pageData, 'objectId'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/2293200484b94fe91df355938d366f0a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Fleet_Item, item, Tonnage_Total, Tyre, error, Driver_Filter, Salary;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Page_Loader() {
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', true);
  Salary = (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employer.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Name`]: (getObjectProperty(item, 'Name')),[`Call_Sign`]: (getObjectProperty(item, 'Call_Sign')),[`Employee_Details`]: item,[`Basic_Salary`]: (getObjectProperty(item, 'Basic_Salary')),[`Contractor_Km_Payment`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`GD_Payment`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Contractor_Tonnage_Pay`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Tonnage_Target_Pay`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Total`]: (getObjectProperty(item, 'Basic_Salary')) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (getObjectProperty(item, 'Bargaining_Council_And_Union_Levies')) + (getObjectProperty(item, 'Provident_And_Pension_Fund')) + (getObjectProperty(item, 'Medical_Aid')) });})));
  Fleet_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  item['Distance'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Targets'] = ((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100)))[0]);
    item['Horse_FI'] = ((getObjectProperty(item, 'Depreciation')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Fixed_Monthly_Sundry_Fee')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Tracking_Fee')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);
    item['Trailers_FI'] = (((getObjectProperty(item, 'Trailer1_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer2_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer3_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0));
    item['Other_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Diesel_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Distance'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Per_Km_TR_FI'] = ((getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_Toll_Rate_R')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);
    item['Toll_Fees_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Type = \'Toll\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    try {
      item['Salary/Wages_FI'] = (getObjectProperty(((await asyncListFilter(Salary, async (Driver_Filter) => {


       return ((getObjectProperty(item, 'Current_Driver')) == (getObjectProperty(Driver_Filter, 'Call_Sign')));
      }))[0]), 'Total'));

    } catch (error) {
      if (error) {
        item['Salary/Wages_FI'] = 0;
      }

    }
    item['Per_Km_M_Plan_FI'] = ((getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Maintenance_Plan_Rate_per_Km')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);
    item['MRH_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Horse = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['ATE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Tyre_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['PTE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Projected_Commission_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((getObjectProperty(Tonnage_Total, 'Load_Value')) * (1 + (getObjectProperty((getObjectProperty(item, 'Targets')), 'Commission_Rate')) / 100) - (getObjectProperty(Tonnage_Total, 'Load_Value')))));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Turnover_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (getObjectProperty(Tonnage_Total, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;}));
  ; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`Horse_Registration`]: (getObjectProperty(item, 'Fleet_ID')),[`Horse_ID`]: (getObjectProperty(item, 'Horse_Registration')),[`License_Notice_FI`]: (getObjectProperty(item, 'Trailer1_Reg')),[`License_PDP_FI`]: (getObjectProperty(item, 'Trailer2_Reg')),[`Trailer_3_FI`]: (getObjectProperty(item, 'Trailer3_Reg')),[`Driver_1`]: (getObjectProperty(item, 'Horse_FI')),[`Service_Notice`]: (getObjectProperty(item, 'Trailers_FI')),[`Current_Mileage`]: (getObjectProperty(item, 'Diesel_FI')),[`Distance_Traveled`]: (getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_TR_FI')) : 0,[`Mileage_Target_Completion`]: (getObjectProperty(item, 'Toll_Fees_FI')),[`Ideal_KM/L`]: (getObjectProperty(item, 'Salary/Wages_FI')),[`Actual_KM/L`]: (getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_M_Plan_FI')) : 0,[`Status`]: (getObjectProperty(item, 'MRH_FI')),[`Fuel_Cost`]: (getObjectProperty(item, 'ATE_FI')),[`Price_Per_Litre`]: (getObjectProperty(item, 'ATE_FI')) * (getObjectProperty(item, 'Distance')),[`Fuel_Cost_Per_Km`]: (getObjectProperty(item, 'Projected_Commission_FI')),[`Gain/loss_Driving_Style`]: (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + (getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')),[`Total_Tonnage`]: (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + 0 + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))) / (getObjectProperty(item, 'Distance'))))),[`Litres_Filled`]: (getObjectProperty(item, 'Turnover_FI')),[`Target_Tonnage_Completion`]: (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')),[`Permissible_Tonnage`]: (getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + (getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))),[`Average_Tonnage`]: (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + (getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')))) / (getObjectProperty(item, 'Distance'))))),[`Gain/Loss_Loading`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_MI`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Loss_On_Mileage_In_Money'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_TO`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GainLoss_On_Load'));}))), 0)).reduce(function(x, y) {return x + y;}),[`License_Notice_T1_FI`]: (getObjectProperty(item, 'Turnover_FI')) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}),[`License_Notice_T2_FI`]: (getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + 0 + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))),[`License_Notice_T3_FI`]: undefined,[`License_Notice_Trailers_FI`]: undefined,[`Service_Warning_Duration_in_KM`]: (getObjectProperty(item, 'Other_FI')),[`Service_Interval`]: (getObjectProperty(item, 'Tyre_FI')) });})));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', Fleet_Item);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/4fd56b24502950d50b95a5ee0f44fb9b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '21Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/b72284f6b022c296181f820fc75e8068/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Color;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Permissible_Tonnage')) > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b72284f6b022c296181f820fc75e8068'))['color'] = 'Green';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Permissible_Tonnage')) == 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b72284f6b022c296181f820fc75e8068'))['color'] = 'Yello';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Permissible_Tonnage')) < 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b72284f6b022c296181f820fc75e8068'))['color'] = 'Red';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Permissible_Tonnage'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/925b10b7d7771db46af2b6552be4830d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Driver_1'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/3025cc740c2e6016986db7acc957c12b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Current_Mileage')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/aaef52abada4847a42bf68ef573f6c2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/483935bcdd8a4b7ee73d9737828eadf6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/ec11a4cf1741c56fb1dbeb4378d2d577/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Ideal_KM/L'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/4d49a09a5761ea0b09fbd0c721873fd1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Actual_KM/L'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/27bc8b1642aef057a32c0b55204abd98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Fuel_Cost')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/f861780d9d1af912b4020aef7e7bdce9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/a9ff27240a081e57eeac944d8c37a83f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Fuel_Cost_Per_Km'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/0dab29db9916ae196e1aa35627669346/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/loss_Driving_Style'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/f07c258c685e882135823fac66eb50ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Total_Tonnage')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/28d3d17533c271b33778415f030448aa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Litres_Filled'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/8098c4eb61e4d46fceda522dd1ce5a72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Target_Tonnage_Completion')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/25cd314e2df875269493018a8c466ab8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Average_Tonnage')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/e4a9ec58c517248bb6433615c3d87526/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_TO'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/2ffc18be84c1ff96bfc62efa50e87562/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Driver_1'));}))).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/c249ecccdcadf6b1a655da72175e18e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Service_Notice'));}))).reduce(function(x, y) {return x + y;})))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/153b80cf487fabfde0d8db0faada55b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var error, item, Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Current_Mileage'));}))).reduce(function(x, y) {return x + y;})))));

  } catch (error) {

  } finally {
    if (error) {
      Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](0)));
    }

  }

  return Result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/ec483d9d0063345d9a6acec3cdf904a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Result, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Distance_Traveled'));}))).reduce(function(x, y) {return x + y;})))));

  } catch (error) {

  } finally {
    if (error) {
      Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](0)));
    }

  }

  return Result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/7fc7940dbf7890a294152f7c915d5178/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var error, item, Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Mileage_Target_Completion'));}))).reduce(function(x, y) {return x + y;})))));

  } catch (error) {

  } finally {
    if (error) {
      Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](0)));
    }

  }

  return Result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/d07e36a70a519f8317ff82d80961e012/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var error, item, Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Ideal_KM/L'));}))).reduce(function(x, y) {return x + y;})))));

  } catch (error) {

  } finally {
    if (error) {
      Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](0)));
    }

  }

  return Result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/ba7c4d0d3b1c13a97d877ceb6d511199/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Actual_KM/L'));}))).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/00a9cd53657425d6a7b4be1a5de46153/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var error, item, Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Status'));}))).reduce(function(x, y) {return x + y;})))));

  } catch (error) {

  } finally {
    if (error) {
      Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](0)));
    }

  }

  return Result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/1ff63ddb32fb4177d54d831d1498156d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var error, item, Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Fuel_Cost'));}))).reduce(function(x, y) {return x + y;})))));

  } catch (error) {

  } finally {
    if (error) {
      Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](0)));
    }

  }

  return Result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/27b29265336f43f7e41dbcf10dad64ad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Price_Per_Litre'));}))).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/e556ae895d44a0fb0933fdb45a4c46a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Fuel_Cost_Per_Km'));}))).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/63a8c36f4d9ddf977122b2c2ba921d7d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var error, item, Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Gain/loss_Driving_Style'));}))).reduce(function(x, y) {return x + y;})))));

  } catch (error) {

  } finally {
    if (error) {
      Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](0)));
    }

  }

  return Result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/b16e6adfe9ab369eb8746d7266b18477/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Total_Tonnage'));}))).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/04ff580530418cd257c53fdcd1e1bccc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var error, item, Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Litres_Filled'));}))).reduce(function(x, y) {return x + y;})))));

  } catch (error) {

  } finally {
    if (error) {
      Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](0)));
    }

  }

  return Result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/a90203e793cbb2a414b3e553a6423b79/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Target_Tonnage_Completion'));}))).reduce(function(x, y) {return x + y;})))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/d7a933578278bfa59cf81628908f1929/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var error, item, Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Permissible_Tonnage'));}))).reduce(function(x, y) {return x + y;})))));

  } catch (error) {

  } finally {
    if (error) {
      Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](0)));
    }

  }

  return Result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/86e77e836445d755d0d2073cb944924a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Average_Tonnage'));}))).reduce(function(x, y) {return x + y;})))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/27ea5daad2d4b60252aa2287656e810b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Gain/Loss_Loading'));}))).reduce(function(x, y) {return x + y;})))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/8598f802e355b223540cdbc60187ab3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Gain/Loss_Loading_MI'));}))).reduce(function(x, y) {return x + y;})))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/e7250edfe4a90f846bb1631b1b16b974/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Gain/Loss_Loading_TO'));}))).reduce(function(x, y) {return x + y;})))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/caf712b9ffa9f5f6607e90a10a5db945/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Planned_Delivery_Date_Time >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND Planned_Delivery_Date_Time <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Images_View'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Image_1'] = (getObjectProperty(___arguments.selectedRecord, 'image'));
  ___arguments.context.pageData['Image_2'] = (getObjectProperty(___arguments.selectedRecord, 'image1'));
  ___arguments.context.pageData['Image_3'] = (getObjectProperty(___arguments.selectedRecord, 'image2'));
  ___arguments.context.pageData['Image_4'] = (getObjectProperty(___arguments.selectedRecord, 'image3'));
  ___arguments.context.pageData['DataImageText'] = (['Load Image','Submitted on ',(new Date((getObjectProperty(___arguments.selectedRecord, 'created'))))].join(''));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Financial_Overview/components/eea528ad20e95664fdbed91cca7dfe59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f37262471d731fed615a69b8a7feee5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e876a682297ad47ecb1dbf78e6d1187', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b2bc27fa06d5a8393c547c8476593d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('824ee37956d5968a8b75e9d22edf9b49', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/f6678554caa30d2dc9e779f7e9b32377/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f37262471d731fed615a69b8a7feee5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e876a682297ad47ecb1dbf78e6d1187', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b2bc27fa06d5a8393c547c8476593d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('824ee37956d5968a8b75e9d22edf9b49', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/f256eb84a9c7d2dd1a0fe4afe15b54e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Service_Interval'));}))).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/367688a46de4c694b5563255d32c825b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Service_Interval'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/5ed56cb457c50e3c6e11ae27add244c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '12Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/e8c201b7d122cb697ab5f6add892859a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == false) {
    ___arguments.context.pageData['WS_Hamburger_View'] = true;
  } else {
    ___arguments.context.pageData['WS_Hamburger_View'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/2af4968a3c7b354f09df0a995a425226/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/929c7cf56dbf8521112bb1ca0042f308/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	var print_div = document.getElementById("Data_Panel");
  	var print_area = window.open('Test');
  	print_area.document.write(print_div.innerHTML);
  	print_area.document.close();
  	print_area.focus();
  	print_area.print();
  	print_area.close();
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/7346af9315029b75ec99a04d8732d875/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Fleet_Item, item, Tonnage_Total, Tyre, error, Driver_Filter, Salary, Date_Factor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Page_Loader() {
}


  Date_Factor = Math.ceil((((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()) - ((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf())) / 86400000);
  ___arguments.context.pageData['Set Date - Loader'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('223497f79e8f94bac1476e487b09d448', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0f899906090dc3dcacfee2ea50ba2492', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', null);
  Salary = (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employer.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Name`]: (getObjectProperty(item, 'Name')),[`Call_Sign`]: (getObjectProperty(item, 'Call_Sign')),[`Employee_Details`]: item,[`Basic_Salary`]: (getObjectProperty(item, 'Basic_Salary')),[`Contractor_Km_Payment`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`GD_Payment`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Contractor_Tonnage_Pay`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Tonnage_Target_Pay`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Total`]: (getObjectProperty(item, 'Basic_Salary')) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (getObjectProperty(item, 'Bargaining_Council_And_Union_Levies')) + (getObjectProperty(item, 'Provident_And_Pension_Fund')) + (getObjectProperty(item, 'Medical_Aid')) });})));
  Fleet_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  item['Distance'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Targets'] = ((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100)))[0]);
    item['Horse_FI'] = ((getObjectProperty(item, 'Depreciation')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Fixed_Monthly_Sundry_Fee')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Tracking_Fee')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);
    item['Trailers_FI'] = (((getObjectProperty(item, 'Trailer1_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer2_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer3_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0));
    item['Other_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Diesel_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Distance'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Per_Km_TR_FI'] = ((getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_Toll_Rate_R')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);
    item['Toll_Fees_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Type = \'Toll\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    try {
      item['Salary/Wages_FI'] = (getObjectProperty(((await asyncListFilter(Salary, async (Driver_Filter) => {


       return ((getObjectProperty(item, 'Current_Driver')) == (getObjectProperty(Driver_Filter, 'Call_Sign')));
      }))[0]), 'Total'));

    } catch (error) {
      if (error) {
        item['Salary/Wages_FI'] = 0;
      }

    }
    item['Per_Km_M_Plan_FI'] = ((getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Maintenance_Plan_Rate_per_Km')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);
    item['MRH_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Horse = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['ATE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Tyre_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['PTE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Projected_Commission_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((getObjectProperty(Tonnage_Total, 'Load_Value')) * (1 + (getObjectProperty((getObjectProperty(item, 'Targets')), 'Commission_Rate')) / 100) - (getObjectProperty(Tonnage_Total, 'Load_Value')))));}))), 0)).reduce(function(x, y) {return x + y;}));
    item['Turnover_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (getObjectProperty(Tonnage_Total, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;}));
  ; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`Horse_Registration`]: (getObjectProperty(item, 'Fleet_ID')),[`Horse_ID`]: (getObjectProperty(item, 'Horse_Registration')),[`License_Notice_FI`]: (getObjectProperty(item, 'Trailer1_Reg')),[`License_PDP_FI`]: (getObjectProperty(item, 'Trailer2_Reg')),[`Trailer_3_FI`]: (getObjectProperty(item, 'Trailer3_Reg')),[`Driver_1`]: (getObjectProperty(item, 'Horse_FI')),[`Service_Notice`]: (getObjectProperty(item, 'Trailers_FI')),[`Current_Mileage`]: (getObjectProperty(item, 'Diesel_FI')),[`Distance_Traveled`]: (getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_TR_FI')) : 0,[`Mileage_Target_Completion`]: (getObjectProperty(item, 'Toll_Fees_FI')),[`Ideal_KM/L`]: (getObjectProperty(item, 'Salary/Wages_FI')),[`Actual_KM/L`]: (getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_M_Plan_FI')) : 0,[`Status`]: (getObjectProperty(item, 'MRH_FI')),[`Fuel_Cost`]: (getObjectProperty(item, 'ATE_FI')),[`Price_Per_Litre`]: (getObjectProperty(item, 'ATE_FI')) * (getObjectProperty(item, 'Distance')),[`Fuel_Cost_Per_Km`]: (getObjectProperty(item, 'Projected_Commission_FI')),[`Gain/loss_Driving_Style`]: (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + (getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')),[`Total_Tonnage`]: (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + 0 + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))) / (getObjectProperty(item, 'Distance'))))),[`Litres_Filled`]: (getObjectProperty(item, 'Turnover_FI')),[`Target_Tonnage_Completion`]: (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')),[`Permissible_Tonnage`]: (getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + (getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))),[`Average_Tonnage`]: (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + (getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')))) / (getObjectProperty(item, 'Distance'))))),[`Gain/Loss_Loading`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_MI`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Loss_On_Mileage_In_Money'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_TO`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GainLoss_On_Load'));}))), 0)).reduce(function(x, y) {return x + y;}),[`License_Notice_T1_FI`]: (getObjectProperty(item, 'Turnover_FI')) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}),[`License_Notice_T2_FI`]: (getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty(item, 'Other_FI')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + 0 + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))),[`License_Notice_T3_FI`]: undefined,[`License_Notice_Trailers_FI`]: undefined,[`Service_Warning_Duration_in_KM`]: (getObjectProperty(item, 'Other_FI')),[`Service_Interval`]: (getObjectProperty(item, 'Tyre_FI')) });})));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', Fleet_Item);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('223497f79e8f94bac1476e487b09d448', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0f899906090dc3dcacfee2ea50ba2492', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', false);
  ___arguments.context.pageData['Set Date - Loader'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/8f37262471d731fed615a69b8a7feee5/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/2dc8d7cc1d318cc2e99771f8ec2dc454/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f37262471d731fed615a69b8a7feee5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e876a682297ad47ecb1dbf78e6d1187', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b2bc27fa06d5a8393c547c8476593d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('824ee37956d5968a8b75e9d22edf9b49', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/f78898e656b50e7c04ced227782169ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f37262471d731fed615a69b8a7feee5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e876a682297ad47ecb1dbf78e6d1187', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b2bc27fa06d5a8393c547c8476593d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('824ee37956d5968a8b75e9d22edf9b49', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/b968d726530d95a44e0af623505aa53e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('caf712b9ffa9f5f6607e90a10a5db945', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f37262471d731fed615a69b8a7feee5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e876a682297ad47ecb1dbf78e6d1187', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b2bc27fa06d5a8393c547c8476593d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('824ee37956d5968a8b75e9d22edf9b49', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/0e876a682297ad47ecb1dbf78e6d1187/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/22b2bc27fa06d5a8393c547c8476593d/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/5a52e7d3585404ad1a3cfd05ab7ecfc2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'](null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8f37262471d731fed615a69b8a7feee5')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Financial_Overview/components/fbc13132067a7a446b6d9547b31a9ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/1f875f370c392bdfd80eda023e0c97fd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'License_Notice_T1_FI')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'License_Notice_T1_FI')))) ? (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'License_Notice_T1_FI')))) : '0.00'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/717a3776e508cb184c163b914e77843f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((typeof ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'License_Notice_T1_FI'));}))).reduce(function(x, y) {return x + y;})) === 'number' && !isNaN(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'License_Notice_T1_FI'));}))).reduce(function(x, y) {return x + y;})))) ? (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'License_Notice_T1_FI'));}))).reduce(function(x, y) {return x + y;})))) : '0.00'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/1d2b85ddc33d310d0a1a888e0196ff98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '99Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/833107e2bb5ce08589d31239be57937e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'License_Notice_T2_FI'))))))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'License_Notice_T2_FI')) > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('833107e2bb5ce08589d31239be57937e'))['color'] = 'Green';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'License_Notice_T2_FI')) == 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('833107e2bb5ce08589d31239be57937e'))['color'] = 'Yellow';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'License_Notice_T2_FI')) < 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('833107e2bb5ce08589d31239be57937e'))['color'] = 'Red';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/546a48668388fa22084637532e8cb507/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var error, item, Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'License_Notice_T2_FI'));}))).reduce(function(x, y) {return x + y;})))));

  } catch (error) {

  } finally {
    if (error) {
      Result = String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](0)));
    }

  }

  return Result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/64c413b6f39590467c54f0ff3da730a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '32Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/8f0df7a2d7febcca62dac1993c2f36e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Set Date - Loader')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/cd738dacb581eb0baccba7351652813e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Service_Warning_Duration_in_KM'));}))).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/dbb51eff794a530d55e3004f1395e53e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Service_Warning_Duration_in_KM'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/17227287ccc4b972ab0d0a3cf222cc28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '76Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Financial_Overview/components/0445650d1e682dd18db87446e248d425/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '76Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Fleet_Item, item, Start_Date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c55832ef99386143591bbb014b56e9ec', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('223497f79e8f94bac1476e487b09d448', true);
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4868296d30e939e74e0d3b7e0862b19d'))['opacity'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);
  ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  ___arguments.context.pageData['Company'] = ((await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(100)))[0]);
  ___arguments.context.pageData['Company_Logo'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Company_Logo'));
  ___arguments.context.pageData['Company_Name'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Company'));
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  if (!(await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  Start_Date = (new Date());
  Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
  Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
  Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
  Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
  Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
  ___arguments.context.pageData['Start_Date'] = Start_Date;
  ___arguments.context.pageData['End_Date'] = (new Date());
  Fleet_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Gain/Loss_Driving_Style`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_Driving_Style'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_TO`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GainLoss_On_Load'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Horse_Registration`]: (getObjectProperty(item, 'Fleet_ID')),[`objectId`]: (getObjectProperty(item, 'objectId')),[`Horse_ID`]: (getObjectProperty(item, 'Horse_Registration')),[`Driver_1`]: (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(100).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],[`Current_Mileage`]: (addItemToList(((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0]), 0)),[`Distance_Traveled`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Service_Interval`]: (getObjectProperty(item, 'Service_Interval')),[`Service_Warning_Duration_in_KM`]: (getObjectProperty(item, 'Service_Warning_Duration_in_KM')),[`Service_Notice`]: (getObjectProperty(item, 'Service_Status')),[`License_Notice_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'License_Expiry_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Horse_Registration'));})))[0] : null,[`License_PDP_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'PDP_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0] : null,[`License_Notice_Trailers_FI`]: ((new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null) == null && ((new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null) == null && ((new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null) == null ? true : false,[`License_Notice_T1_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null,[`License_Notice_T2_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null,[`License_Notice_T3_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null,[`Mileage_Target_Completion`]: Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0]) * 100 * 1000) / 1000,[`Ideal_KM/L`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0],[`Actual_KM/L`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Status`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0] * 0.99 > (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}) ? 'Consumption Error' : 'In Order',[`Litres_Filled`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Fuel_Cost`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Price_Per_Litre`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Fuel_Cost_Per_Km`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Gain/loss_Driving_Style`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round((((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0]) * ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;})) - (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Total_Tonnage`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (Number((getObjectProperty(item, 'tonnage'))));}))), 0)).reduce(function(x, y) {return x + y;}),[`Target_Tonnage_Completion`]: Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0]) * 1000) / 10,[`Permissible_Tonnage`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Permissible_Tonnage'));})))[0],[`Average_Tonnage`]: Math.round((await BackendlessUI.Functions.Custom['fn_233da43c13d3c6c2d0ff3d9fb1718932']((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Service <> \'Yes\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)))) * 1000) / 1000,[`Gain/Loss_Loading`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_MI`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Loss_On_Mileage_In_Money'));}))), 0)).reduce(function(x, y) {return x + y;}) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', Fleet_Item);
  await do_something();
  await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4868296d30e939e74e0d3b7e0862b19d')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4868296d30e939e74e0d3b7e0862b19d')), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6')), false);

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Fleet_Overview/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/a326c6adc603ee1603ce948afd16bbdf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var Start_Date;


  Start_Date = (new Date(___arguments.value));
  ___arguments.context.pageData['Start_Date'] = Start_Date;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Start_Date'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/8093a66253eb9b76d76778f92314ad6c/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'End_Date'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    var End_Date;


  End_Date = (new Date(___arguments.value));
  ___arguments.context.pageData['End_Date'] = End_Date;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Fleet_Overview/components/8105eda7dc01e95745414fb45f95d654/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8105eda7dc01e95745414fb45f95d654', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cfd1a8d15b5d8338effd0cd62e03efb8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/465efe2f6a01480de31a4f8a790e0a4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'License_Notice_Trailers_FI')) == false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8105eda7dc01e95745414fb45f95d654', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cfd1a8d15b5d8338effd0cd62e03efb8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/0e0200c11cbcde7cbdf70a0e7988a0d4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  onStyleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Service_Notice')) == 'Service Due') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0e0200c11cbcde7cbdf70a0e7988a0d4'))['color'] = 'yellow';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/aadffa177e03469667c81325f5b42c65/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  onStyleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status')) == 'Consumption Error') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aadffa177e03469667c81325f5b42c65'))['color'] = 'Red';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Fuel_Data_Title'] = (['  (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_Registration')),')',' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_ID'))].join(''));
  ___arguments.context.pageData['Fuel_Data_Whereclause'] = (['reg.objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'objectId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''));
  console.log(getObjectProperty(___arguments.context.pageData, 'objectId'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/5657405aa51342ecda98075493b5ff6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24da12d82de4886484433c4a1258961', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc4b155f812c7fbc742c88f3ca554e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('784f15df46d10e167e3ed3b589164f75', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/064284e8d81934617325340eabedd916/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24da12d82de4886484433c4a1258961', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc4b155f812c7fbc742c88f3ca554e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('784f15df46d10e167e3ed3b589164f75', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/7f9680277fe89cfde26b11be22d7b3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24da12d82de4886484433c4a1258961', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc4b155f812c7fbc742c88f3ca554e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('784f15df46d10e167e3ed3b589164f75', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/9bf3c6a806384ffef5c401cba2012dae/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var Where_Clause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
    var Fuel_Data_Title;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Fuel_Data_Title = String('Fuel Data for') + String(getObjectProperty(___arguments.context.pageData, 'Fuel_Data_Title'));

  return Fuel_Data_Title

  },
  /* handler:onTitleAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Images_View'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Image_1'] = (getObjectProperty(___arguments.selectedRecord, 'image'));
  ___arguments.context.pageData['DataImageText'] = (['Fuel Slip','Submitted on ',(getObjectProperty(___arguments.selectedRecord, 'created'))].join(''));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Fleet_Overview/components/f0f9a9f35c243f15ec01cdac7cf4f714/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')) <= -1000) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0f9a9f35c243f15ec01cdac7cf4f714'))['color'] = 'red';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')) < 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0f9a9f35c243f15ec01cdac7cf4f714'))['color'] = 'orange';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')) <= 500) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0f9a9f35c243f15ec01cdac7cf4f714'))['color'] = 'Yellow';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')) >= 500) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0f9a9f35c243f15ec01cdac7cf4f714'))['color'] = 'Green';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Load_Data_Title'] = (['  (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_Registration')),')',' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_ID'))].join(''));
  ___arguments.context.pageData['Load_Data_Whereclause'] = (['Horse.objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'objectId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'','1','\''].join(''));
  console.log(getObjectProperty(___arguments.context.pageData, 'objectId'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/b612d3b3061d799155f81a9286caaa69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc4b155f812c7fbc742c88f3ca554e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('784f15df46d10e167e3ed3b589164f75', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', false);
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24da12d82de4886484433c4a1258961', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/cd59d51714ea0c8c11d3a6513c131c19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24da12d82de4886484433c4a1258961', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc4b155f812c7fbc742c88f3ca554e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('784f15df46d10e167e3ed3b589164f75', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  ___arguments.context.pageData['Fuel_Data_Title'] = ' Fleet';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/a008425b7ccdc4b9bcc2ce02f09e4606/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Load_Data_Title'] = ' Fleet';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24da12d82de4886484433c4a1258961', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc4b155f812c7fbc742c88f3ca554e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('784f15df46d10e167e3ed3b589164f75', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/a7c42e7ab5d2d5166d8428d7a85a238d/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var Where_Clause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'','1','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
    var Load_Data_Title;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Load_Data_Title = String('Load Data for') + String(getObjectProperty(___arguments.context.pageData, 'Load_Data_Title'));

  return Load_Data_Title

  },
  /* handler:onTitleAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Images_View'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Image_1'] = (getObjectProperty(___arguments.selectedRecord, 'image'));
  ___arguments.context.pageData['Image_2'] = (getObjectProperty(___arguments.selectedRecord, 'image1'));
  ___arguments.context.pageData['Image_3'] = (getObjectProperty(___arguments.selectedRecord, 'image2'));
  ___arguments.context.pageData['Image_4'] = (getObjectProperty(___arguments.selectedRecord, 'image3'));
  ___arguments.context.pageData['DataImageText'] = (['Delivery Note ','Submitted on ',(getObjectProperty(___arguments.selectedRecord, 'created'))].join(''));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Fleet_Overview/components/784f15df46d10e167e3ed3b589164f75/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status <> \'','1','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/048977f589fc5a9c4bd1ba9c0215027d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24da12d82de4886484433c4a1258961', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('784f15df46d10e167e3ed3b589164f75', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc4b155f812c7fbc742c88f3ca554e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/e33968170893649d4367ac61f15e5408/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Images_View'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Image_1'] = (getObjectProperty(___arguments.selectedRecord, 'Profile_Photo'));
  ___arguments.context.pageData['Image_2'] = (getObjectProperty(___arguments.selectedRecord, 'ID_Attachment'));
  ___arguments.context.pageData['Image_3'] = (getObjectProperty(___arguments.selectedRecord, 'License_Attachment'));
  ___arguments.context.pageData['DataImageText'] = (String(getObjectProperty(___arguments.selectedRecord, 'Name')) + String('\'s Images'));

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Employer.ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/f7423269562d8c0f35d64aed19fb836f/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/65d3504d17c60c9dfecd3e95b1ffcbeb/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/ced40fcb6eaca79e0d3f45b91eae6dec/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/dae9c96ab8a4f5a20f5691e5f5af5af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24da12d82de4886484433c4a1258961', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc4b155f812c7fbc742c88f3ca554e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('784f15df46d10e167e3ed3b589164f75', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/c11adb9f109d6ffa0e951148f41ad97a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24da12d82de4886484433c4a1258961', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc4b155f812c7fbc742c88f3ca554e7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('784f15df46d10e167e3ed3b589164f75', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  ___arguments.context.pageData['Sundry_Data_Whereclause'] = (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/0a44b4c1e9cc4e8486e1847d8d0cadf9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a44b4c1e9cc4e8486e1847d8d0cadf9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64abcaf5ca5e80f2a7f4740b69d9c91c', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6ac9db8ea16e94f2f8edec3e1a5ecae', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/64abcaf5ca5e80f2a7f4740b69d9c91c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6ac9db8ea16e94f2f8edec3e1a5ecae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64abcaf5ca5e80f2a7f4740b69d9c91c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a44b4c1e9cc4e8486e1847d8d0cadf9', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/84e399febbb69c6906ae14f2c7c899ab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), 'Driver_Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/56a25647cafe65f486633cb8f338c2bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '3Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/83d3c61a37097477378eec49bf9d1e25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '4Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/07c2624860b79354fab219fa499b6d86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '5Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/34f478020a4af087eb9943b716f9c834/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '6Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/6471c6fa4c29c02f8b820496dfb980a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '7Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/090849a9211b46a9558969e764f374a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '8Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/6f2295db02fe4d353ffed4f8eab182d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '9Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/acf1d60d39370e881c2c2f3b9d848899/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '10Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/60f8c62d363af106cf134b052cfd3ccf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '11Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/d9395a792f543e413ce89701e4cd9812/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '12Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/f2932fb984a63989fe3fe2428f36664f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '13Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/c71e513692df5bc82a142eda2ca42795/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '15Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/38baaf59f6ab264c9ea3080349d674e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '16Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/be2ae87e6ee90ea59c8c6dc4ab57a9fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '17Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/4a522b097016d63ab1b90bec89512ac5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '18Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/b42d6b87bb41d83c316dbce64e6bdf8d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '19Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/d18be616a10fad5c6bc9a15927bfba34/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '20Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/8096fb55ff9c027bc50ec5ae514327e5/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.dataModel['Driver_Check'] = true;
  ___arguments.context.dataModel['2Check'] = true;
  ___arguments.context.dataModel['3Check'] = true;
  ___arguments.context.dataModel['4Check'] = true;
  ___arguments.context.dataModel['5Check'] = true;
  ___arguments.context.dataModel['7Check'] = true;
  ___arguments.context.dataModel['8Check'] = true;
  ___arguments.context.dataModel['9Check'] = true;
  ___arguments.context.dataModel['9Check'] = true;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Fleet_Overview/components/61348c3229e7b3dd8bd8d9aca2e7a152/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Driver_Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['2Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['3Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['4Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['5Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['7Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['8Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['9Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['15Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['21Check'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/5d06b9c2de2c2d3611890ad594edbeca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Driver_Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['2Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['3Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['4Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['5Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['6Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['7Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['8Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['9Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['10Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['11Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['12Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['13Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['14Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['15Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['16Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['17Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['18Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['19Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['20Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['21Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['22Check'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/cf2d5a1bc5dfeba8a9db31784a714f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Images_View'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/41f553479872cab9abf931ef3b0b2e47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Image_1'] = null;
  ___arguments.context.pageData['Image_2'] = null;
  ___arguments.context.pageData['Image_3'] = null;
  ___arguments.context.pageData['Image_3'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/daa89079a11340a16fc711568858863d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Image_Text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Image_1')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_2')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_3')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_4')) == null) {
    Image_Text = 'No Images Available';
  } else {
    Image_Text = (getObjectProperty(___arguments.context.pageData, 'DataImageText'));
  }

  return Image_Text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/e23b96acd1879198dc2f19e4e90eb0e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/b7649fc62cc8a1432e22311afd238672/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_2')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/2fae753c674e30dff7e7456114e29c61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_3')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/cd7e08f865dbe001d7579334b4752399/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_4')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/0b73ad5cfaaa72ce77521be7926ba1ed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_MI')))))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_MI')) <= -1000) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0b73ad5cfaaa72ce77521be7926ba1ed'))['color'] = 'red';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_MI')) < 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0b73ad5cfaaa72ce77521be7926ba1ed'))['color'] = 'orange';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_MI')) <= 500) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0b73ad5cfaaa72ce77521be7926ba1ed'))['color'] = 'Yellow';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_MI')) >= 500) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0b73ad5cfaaa72ce77521be7926ba1ed'))['color'] = 'Green';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Load_Data_Title'] = (['  (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_Registration')),')',' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_ID'))].join(''));
  ___arguments.context.pageData['Load_Data_Whereclause'] = (['Horse.objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'objectId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'','1','\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/2293200484b94fe91df355938d366f0a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Fleet_Item, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', true);
  Fleet_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`Gain/Loss_Loading_TO`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'GainLoss_On_Load'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Horse_Registration`]: (getObjectProperty(item, 'Fleet_ID')),[`objectId`]: (getObjectProperty(item, 'objectId')),[`Horse_ID`]: (getObjectProperty(item, 'Horse_Registration')),[`Driver_1`]: (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],[`Current_Mileage`]: (addItemToList(((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0]), 0)),[`Distance_Traveled`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Service_Interval`]: (getObjectProperty(item, 'Service_Interval')),[`Service_Warning_Duration_in_KM`]: (getObjectProperty(item, 'Service_Warning_Duration_in_KM')),[`Service_Notice`]: (getObjectProperty(item, 'Service_Status')),[`License_Notice_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'License_Expiry_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Horse_Registration'));})))[0] : null,[`License_PDP_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'PDP_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0] : null,[`License_Notice_Trailers_FI`]: ((new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null) == null && ((new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null) == null && ((new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null) == null ? true : false,[`License_Notice_T1_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null,[`License_Notice_T2_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null,[`License_Notice_T3_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null,[`Mileage_Target_Completion`]: Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0]) * 100 * 1000) / 1000,[`Ideal_KM/L`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0],[`Actual_KM/L`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Status`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0] * 0.99 > (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}) ? 'Consumption Error' : 'In Order',[`Litres_Filled`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Fuel_Cost`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Price_Per_Litre`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Fuel_Cost_Per_Km`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Gain/loss_Driving_Style`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round((((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0]) * ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;})) - (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Total_Tonnage`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (Number((getObjectProperty(item, 'tonnage'))));}))), 0)).reduce(function(x, y) {return x + y;}),[`Target_Tonnage_Completion`]: Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0]) * 1000) / 10,[`Permissible_Tonnage`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Permissible_Tonnage'));})))[0],[`Average_Tonnage`]: Math.round((await BackendlessUI.Functions.Custom['fn_233da43c13d3c6c2d0ff3d9fb1718932']((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Service <> \'Yes\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)))) * 1000) / 1000,[`Gain/Loss_Loading`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_MI`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Loss_On_Mileage_In_Money'));}))), 0)).reduce(function(x, y) {return x + y;}) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', Fleet_Item);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/4fd56b24502950d50b95a5ee0f44fb9b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '21Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/542f583e8706f42adb1d93b510182c2e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/c733efe7025aa34436a7d6c1f67bc6ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24da12d82de4886484433c4a1258961', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc4b155f812c7fbc742c88f3ca554e7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('784f15df46d10e167e3ed3b589164f75', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a7c42e7ab5d2d5166d8428d7a85a238d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbc13132067a7a446b6d9547b31a9ab3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/0dc4b155f812c7fbc742c88f3ca554e7/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/aa7b65a2354cf799f875104f531dbf49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Driving_Style')))))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Driving_Style')) <= -1000) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa7b65a2354cf799f875104f531dbf49'))['color'] = 'red';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Driving_Style')) < 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa7b65a2354cf799f875104f531dbf49'))['color'] = 'orange';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Driving_Style')) <= 500) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa7b65a2354cf799f875104f531dbf49'))['color'] = 'Yellow';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Driving_Style')) >= 500) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa7b65a2354cf799f875104f531dbf49'))['color'] = 'Green';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Fuel_Data_Title'] = (['  (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_Registration')),')',' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Horse_ID'))].join(''));
  ___arguments.context.pageData['Fuel_Data_Whereclause'] = (['reg.objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'objectId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/616cf44366ffd343ff89833f8e6aaf2c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '22Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/3025cc740c2e6016986db7acc957c12b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Current_Mileage')))) + String(' Km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/aaef52abada4847a42bf68ef573f6c2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')))) + String(' Km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/483935bcdd8a4b7ee73d9737828eadf6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion')))) == true) {
    Result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Mileage_Target_Completion'));
  } else {
    Result = 0;
  }

  return (String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](Result)) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/ec11a4cf1741c56fb1dbeb4378d2d577/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Ideal_KM/L')))) + String(' Km/L'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/4d49a09a5761ea0b09fbd0c721873fd1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Actual_KM/L')))) + String(' Km/L'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/28d3d17533c271b33778415f030448aa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Litres_Filled')))) + String(' L'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/27bc8b1642aef057a32c0b55204abd98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Fuel_Cost')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/f861780d9d1af912b4020aef7e7bdce9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/a9ff27240a081e57eeac944d8c37a83f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Fuel_Cost_Per_Km')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/f07c258c685e882135823fac66eb50ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Total_Tonnage')))) + String(' t '))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/8098c4eb61e4d46fceda522dd1ce5a72/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Target_Tonnage_Completion')))) + String(' % '))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/b72284f6b022c296181f820fc75e8068/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Permissible_Tonnage')))) + String(' t '))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/25cd314e2df875269493018a8c466ab8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Average_Tonnage')))) + String(' t '))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/e4a9ec58c517248bb6433615c3d87526/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Driving_Style')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_MI')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading'))))))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Driving_Style')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_MI')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')) <= -1000) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e4a9ec58c517248bb6433615c3d87526'))['color'] = 'red';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Driving_Style')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_MI')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')) < 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e4a9ec58c517248bb6433615c3d87526'))['color'] = 'orange';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Driving_Style')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_MI')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')) <= 500) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e4a9ec58c517248bb6433615c3d87526'))['color'] = 'Yellow';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Driving_Style')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading_MI')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/Loss_Loading')) >= 500) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e4a9ec58c517248bb6433615c3d87526'))['color'] = 'Green';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/fbcaae9a139c89e97ec94823e79d5ea1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	var print_div = document.getElementById("Data_Panel");
  	var print_area = window.open('Test');
  	print_area.document.write(print_div.innerHTML);
  	print_area.document.close();
  	print_area.focus();
  	print_area.print();
  	print_area.close();
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/2f542a9d4096a04b044575b9354be797/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == false) {
    ___arguments.context.pageData['WS_Hamburger_View'] = true;
  } else {
    ___arguments.context.pageData['WS_Hamburger_View'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/7b235bc4c41f346181aeac4b1ef1cb16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/81261c456bfff72600117f12981ff09a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/4e7b4b6b2004081711c2eaf4b4fc4fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Fleet_Item, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', null);
  Fleet_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Gain/Loss_Driving_Style`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_Driving_Style'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_TO`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GainLoss_On_Load'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Horse_Registration`]: (getObjectProperty(item, 'Fleet_ID')),[`objectId`]: (getObjectProperty(item, 'objectId')),[`Horse_ID`]: (getObjectProperty(item, 'Horse_Registration')),[`Driver_1`]: (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(100).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],[`Current_Mileage`]: (addItemToList(((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0]), 0)),[`Distance_Traveled`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Service_Interval`]: (getObjectProperty(item, 'Service_Interval')),[`Service_Warning_Duration_in_KM`]: (getObjectProperty(item, 'Service_Warning_Duration_in_KM')),[`Service_Notice`]: (getObjectProperty(item, 'Service_Status')),[`License_Notice_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'License_Expiry_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Horse_Registration'));})))[0] : null,[`License_PDP_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'PDP_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0] : null,[`License_Notice_Trailers_FI`]: ((new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null) == null && ((new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null) == null && ((new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null) == null ? true : false,[`License_Notice_T1_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null,[`License_Notice_T2_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null,[`License_Notice_T3_FI`]: (new Date()) >= (new Date((new Date(((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'License_Expirey_Date'));})))[0]))).getTime() - (2678400 * 1000))) ? (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Trailer_Registration'));})))[0] : null,[`Mileage_Target_Completion`]: Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0]) * 100 * 1000) / 1000,[`Ideal_KM/L`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0],[`Actual_KM/L`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Status`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0] * 0.99 > (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}) ? 'Consumption Error' : 'In Order',[`Litres_Filled`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Fuel_Cost`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Price_Per_Litre`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Fuel_Cost_Per_Km`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Gain/loss_Driving_Style`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round((((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));})))[0]) * ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;})) - (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;})) * 1000) / 1000))),[`Total_Tonnage`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (Number((getObjectProperty(item, 'tonnage'))));}))), 0)).reduce(function(x, y) {return x + y;}),[`Target_Tonnage_Completion`]: Math.round(((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0]) * 1000) / 10,[`Permissible_Tonnage`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Permissible_Tonnage'));})))[0],[`Average_Tonnage`]: Math.round((await BackendlessUI.Functions.Custom['fn_233da43c13d3c6c2d0ff3d9fb1718932']((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Service <> \'Yes\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)))) * 1000) / 1000,[`Gain/Loss_Loading`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_MI`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Loss_On_Mileage_In_Money'));}))), 0)).reduce(function(x, y) {return x + y;}) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', Fleet_Item);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Fleet_Overview/components/fbc13132067a7a446b6d9547b31a9ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Fleet_Overview/components/d24da12d82de4886484433c4a1258961/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f7423269562d8c0f35d64aed19fb836f')), 'display')) == true) {
    await BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'](null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f7423269562d8c0f35d64aed19fb836f')));
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dc4b155f812c7fbc742c88f3ca554e7')), 'display')) == true) {
    await BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'](null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dc4b155f812c7fbc742c88f3ca554e7')));
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('65d3504d17c60c9dfecd3e95b1ffcbeb')), 'display')) == true) {
    await BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'](null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('65d3504d17c60c9dfecd3e95b1ffcbeb')));
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e33968170893649d4367ac61f15e5408')), 'display')) == true) {
    await BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'](null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e33968170893649d4367ac61f15e5408')));
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9bf3c6a806384ffef5c401cba2012dae')), 'display')) == true) {
    await BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'](null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9bf3c6a806384ffef5c401cba2012dae')));
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7c42e7ab5d2d5166d8428d7a85a238d')), 'display')) == true) {
    await BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'](null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7c42e7ab5d2d5166d8428d7a85a238d')));
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('784f15df46d10e167e3ed3b589164f75')), 'display')) == true) {
    await BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'](null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('784f15df46d10e167e3ed3b589164f75')));
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ced40fcb6eaca79e0d3f45b91eae6dec')), 'display')) == true) {
    await BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'](null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ced40fcb6eaca79e0d3f45b91eae6dec')));
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fbc13132067a7a446b6d9547b31a9ab3')), 'display')) == true) {
    await BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'](null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fbc13132067a7a446b6d9547b31a9ab3')));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f7423269562d8c0f35d64aed19fb836f'))['display'] = undefined;
  console.log('abc');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/61afc62fd67d4c6e6c482533ab87e193/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Board_Truck', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Board_Truck'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/02c145b9ce792c5ff8b850e9bf7bfd4d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('addLoad', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_addLoad'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/97d9b1b980cde38105c6358ff1767355/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('swapTyre', null);

  },  
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_swapTyre'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/6851de2659d546c91cad0cf50f8df812/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Swap_Trailer', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Swap_Trailer'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove('Driver_Load_Updater');
  getRTSubscriptions().remove('Driver_Load_Creator');
  getRTSubscriptions().remove('Driver_Load_Delete ');

  },
  /* handler:onLeave */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Loads, item, error, Fleet_Item, Salary, Value, Start_Date, User_Level, currentUser, Tonnage_Total, Projected_Comission, Tyre, Driver_Filter, Other, Current_Target_Item, Current_Vehicle, Current_User, Employee_Item, object, Fuel_List, Current_Mileage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

/**
 * Describe this function...
 */
async function do_something() {
  Start_Date = (new Date());
  Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
  Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
  Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
  Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
  Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
  ___arguments.context.pageData['Start_Date'] = Start_Date;
  ___arguments.context.pageData['End_Date'] = (new Date());
  if ((getObjectProperty(___arguments.context.appData, 'DashLoad')) == 'Yes') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9174ebeb15066aca976c381e18029c32', false);
  } else {
    ___arguments.context.appData['Vehicles_Of_Concern'] = ((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  item['Fuel_Cons'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}));
    ; return ((getObjectProperty(item, 'Ideal_Fuel_Consumption')) * 0.95 > (getObjectProperty(item, 'Fuel_Cons')) ? 0 : 1);}))).reduce(function(x, y) {return x + y;}));
    ___arguments.context.appData['Tonnage_Completion_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;}) / (((getObjectProperty(item, 'Monthly_Tonnage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate()))) * 100 == Infinity ? 0 : ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;}) / (((getObjectProperty(item, 'Monthly_Tonnage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate()))) * 100);}))))));
    ___arguments.context.appData['Payload_Gauge'] = (mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (await BackendlessUI.Functions.Custom['fn_73996a4c829e78cd078929cb97ed2201']((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Tonnage_Ratio'));})))));}))) * 100);
    ___arguments.context.appData['Mileage_Completion_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  Value = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (((getObjectProperty(item, 'Monthly_Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate()))) * 100 == Infinity ? 0 : ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (((getObjectProperty(item, 'Monthly_Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate()))) * 100;
    ; return ((typeof Value === 'number' && !isNaN(Value)) ? Value : 0);}))))));
    ___arguments.context.appData['Total_Gain/Loss_Loading'] = ((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}));
    ___arguments.context.appData['Total_Gain/Loss_Driving_style'] = ((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_Driving_Style'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}));
    ___arguments.context.appData['Diesel_Vs_Turnover_Gauge'] = (((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})) * 100);
    ___arguments.context.appData['Consumption_Status_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));}))) / ((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})))))) * 100)));
    Salary = (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employer.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Name`]: (getObjectProperty(item, 'Name')),[`Call_Sign`]: (getObjectProperty(item, 'Call_Sign')),[`Employee_Details`]: item,[`Basic_Salary`]: (getObjectProperty(item, 'Basic_Salary')),[`Contractor_Km_Payment`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`GD_Payment`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Contractor_Tonnage_Pay`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Tonnage_Target_Pay`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Total`]: (getObjectProperty(item, 'Basic_Salary')) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) });})));
    ___arguments.context.appData['Profit/Loss_Gauge'] = (((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Monthly_Profit_Target'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all(Fleet_Item.map(async item => {; return (getObjectProperty(item, 'Gain/loss_Driving_Style'));}))).reduce(function(x, y) {return x + y;})) * 100);
    ___arguments.context.appData['DashLoad'] = 'Yes';
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9174ebeb15066aca976c381e18029c32', false);

    } catch (error) {
      console.log(error);

    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Director_Dash_Procedure() {
  Start_Date = (new Date());
  Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
  Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
  Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
  Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
  Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
  ___arguments.context.pageData['Start_Date'] = Start_Date;
  ___arguments.context.pageData['End_Date'] = (new Date());
  if ((getObjectProperty(___arguments.context.appData, 'DashLoad')) == 'Yes') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9174ebeb15066aca976c381e18029c32', false);
  } else {
    Current_User = currentUser;
    Current_User['objectId'] = (getObjectProperty(Current_User, 'ownerId'));
    ___arguments.context.appData['Company'] = ((await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(Current_User, 'ownerId')),'\''].join(''))).setPageSize(10)))[0]);
    ___arguments.context.pageData['Vehicles_By_Target'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Targets', (['ownerId = \'',(getObjectProperty(Current_User, 'objectId')),'\''].join(''))));
    ___arguments.context.appData['Vehicles_By_Target'] = (getObjectProperty(___arguments.context.pageData, 'Vehicles_By_Target'));
    ___arguments.context.pageData['Fuel_By_OwnerID'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Fuel', (['ownerId = \'',(getObjectProperty(Current_User, 'objectId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))));
    ___arguments.context.appData['Fuel_By_OwnerID'] = (getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID'));
    ___arguments.context.pageData['Other_By_OwnerID'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Other', (['ownerId = \'',(getObjectProperty(Current_User, 'objectId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))));
    ___arguments.context.appData['Other_By_OwnerID'] = (getObjectProperty(___arguments.context.pageData, 'Other_By_OwnerID'));
    ___arguments.context.pageData['Loads_By_OwnerID'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Loads', (['ownerId = \'',(getObjectProperty(Current_User, 'objectId')),'\' AND Planned_Delivery_Date_Time >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND Planned_Delivery_Date_Time <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))));
    ___arguments.context.appData['Loads_By_OwnerID'] = (getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID'));
    ___arguments.context.pageData['Trailers_By_OwnerID'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Trailers', (['ownerId = \'',(getObjectProperty(Current_User, 'objectId')),'\''].join(''))));
    ___arguments.context.appData['Trailers_By_OwnerID'] = (getObjectProperty(___arguments.context.pageData, 'Trailers_By_OwnerID'));
    ___arguments.context.pageData['Employee_By_OwnerID'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Employees', (['Employer.objectId = \'',(getObjectProperty(Current_User, 'objectId')),'\''].join('')))).map(async Employee_Item => {; return ({ [`Name`]: (getObjectProperty(Employee_Item, 'Name')),[`Call_Sign`]: (getObjectProperty(Employee_Item, 'Call_Sign')),[`Employee_Details`]: Employee_Item,[`Basic_Salary`]: (typeof (getObjectProperty(Employee_Item, 'Basic_Salary')) === 'number' && !isNaN((getObjectProperty(Employee_Item, 'Basic_Salary')))) ? (getObjectProperty(Employee_Item, 'Basic_Salary')) : 0,[`Contractor_Km_Payment`]: (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')), async (item) => {


     return ((getObjectProperty(Employee_Item, 'Call_Sign')) == (getObjectProperty(item, 'Driver')));
    })).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`GD_Payment`]: (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')), async (item) => {


     return ((getObjectProperty(Employee_Item, 'Call_Sign')) == (getObjectProperty(item, 'Driver')));
    })).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Contractor_Tonnage_Pay`]: (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')), async (item) => {


     return ((getObjectProperty(Employee_Item, 'Call_Sign')) == (getObjectProperty(item, 'Driver')));
    })).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Tonnage_Target_Pay`]: (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')), async (item) => {


     return ((getObjectProperty(Employee_Item, 'Call_Sign')) == (getObjectProperty(item, 'Driver')));
    })).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Total`]: (getObjectProperty(Employee_Item, 'Basic_Salary')) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')), async (item) => {


     return ((getObjectProperty(Employee_Item, 'Call_Sign')) == (getObjectProperty(item, 'Driver')));
    })).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')), async (item) => {


     return ((getObjectProperty(Employee_Item, 'Call_Sign')) == (getObjectProperty(item, 'Driver')));
    })).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')), async (item) => {


     return ((getObjectProperty(Employee_Item, 'Call_Sign')) == (getObjectProperty(item, 'Driver')));
    })).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')), async (item) => {


     return ((getObjectProperty(Employee_Item, 'Call_Sign')) == (getObjectProperty(item, 'Driver')));
    })).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) });})));
    ___arguments.context.appData['Employee_By_OwnerID'] = (getObjectProperty(___arguments.context.pageData, 'Employee_By_OwnerID'));
    ___arguments.context.pageData['Repairs_Maintenance_By_OwnerID'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Repairs_Maintenance', (['ownerId = \'',(getObjectProperty(Current_User, 'objectId')),'\''].join(''))));
    ___arguments.context.appData['Repairs_Maintenance_By_OwnerID'] = (getObjectProperty(___arguments.context.pageData, 'Repairs_Maintenance_By_OwnerID'));
    ___arguments.context.pageData['Tyres_By_OwnerID'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Tyres', (['ownerId = \'',(getObjectProperty(Current_User, 'objectId')),'\''].join(''))));
    ___arguments.context.appData['Tyres_By_OwnerID'] = (getObjectProperty(___arguments.context.pageData, 'Tyres_By_OwnerID'));
    ___arguments.context.pageData['Vehicles_By_OwnerID'] = (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Vehicles', (['ownerId = \'',(getObjectProperty(Current_User, 'objectId')),'\''].join('')))).map(async Current_Vehicle => {  console.log(Current_Vehicle);
      try {
        Current_Vehicle['Distance'] = ((addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Registration')));
        })).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      }
      try {
        Current_Vehicle['Targets'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Vehicles_By_Target')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Vehicle_Registration')));
        }))[0]);

      } catch (error) {
        console.log(error);

      }
      try {
        Current_Vehicle['Horse_FI'] = ((getObjectProperty(Current_Vehicle, 'Depreciation')) + (getObjectProperty(Current_Vehicle, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(Current_Vehicle, 'Fixed_Monthly_Sundry_Fee')) + (getObjectProperty(Current_Vehicle, 'Installment')) + (getObjectProperty(Current_Vehicle, 'Insurance_Premium')) + (getObjectProperty(Current_Vehicle, 'Tracking_Fee')) + (getObjectProperty(Current_Vehicle, 'Annual_License_Fee')) / 12);

      } catch (error) {
        console.log(error);

      }
      try {
        Current_Vehicle['Trailers_FI'] = (((getObjectProperty(Current_Vehicle, 'Trailer1_Reg')) != null ? (await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Trailers_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer1_Reg')) == (getObjectProperty(item, 'Trailer_Registration')));
        })).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(Current_Vehicle, 'Trailer2_Reg')) != null ? (await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Trailers_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer2_Reg')) == (getObjectProperty(item, 'Trailer_Registration')));
        })).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(Current_Vehicle, 'Trailer3_Reg')) != null ? (await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Trailers_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer3_Reg')) == (getObjectProperty(item, 'Trailer_Registration')));
        })).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0));

      } catch (error) {
        console.log(error);

      }
      try {
        Current_Vehicle['Diesel_FI'] = ((addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Registration')));
        })).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {

      }
      try {
        Current_Vehicle['Per_Km_TR_FI'] = ((getObjectProperty(Current_Vehicle, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(Current_Vehicle, 'Per_Km_Toll_Rate_R')) * (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Registration')));
        })).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);

      } catch (error) {
        console.log(error);

      } finally {
        if (error) {
          Current_Vehicle['Per_Km_TR_FI'] = 0;
        }

      }
      try {
        Current_Vehicle['Toll_Fees_FI'] = ((addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Other_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Registration')));
        })).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      } finally {
        if (error) {
          Current_Vehicle['Toll_Fees_FI'] = 0;
        }

      }
      try {
        Current_Vehicle['Salary/Wages_FI'] = ((getObjectProperty(Current_Vehicle, 'Current_Driver')) == null ? 0 : (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Employee_By_OwnerID')), async (Driver_Filter) => {


         return ((getObjectProperty(Current_Vehicle, 'Current_Driver')) == (getObjectProperty(Driver_Filter, 'Call_Sign')));
        }))[0]), 'Total')));

      } catch (error) {

      } finally {
        if (error) {
          Current_Vehicle['Salary/Wages_FI'] = 0;
        }

      }
      try {
        Current_Vehicle['Per_Km_M_Plan_FI'] = ((getObjectProperty(Current_Vehicle, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(Current_Vehicle, 'Maintenance_Plan_Rate_per_Km')) * (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Registration')));
        })).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);

      } catch (error) {
        console.log(error);

      } finally {
        if (error) {
          Current_Vehicle['Per_Km_M_Plan_FI'] = 0;
        }

      }
      try {
        Current_Vehicle['MRH_FI'] = ((addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Repairs_Maintenance_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Registration_Horse')));
        })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Repairs_Maintenance_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer1_Reg')) == (getObjectProperty(item, 'Registration_Trailer_1')));
        })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Repairs_Maintenance_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer2_Reg')) == (getObjectProperty(item, 'Registration_Trailer_2')));
        })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Repairs_Maintenance_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer3_Reg')) == (getObjectProperty(item, 'Registration_Trailer_3')));
        })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      } finally {
        if (error) {
          Current_Vehicle['MRH_FI'] = 0;
        }

      }
      try {
        Current_Vehicle['ATE_FI'] = ((addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyres_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Currently_On')));
        })).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(Current_Vehicle, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyres_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer1_Reg')) == (getObjectProperty(item, 'Currently_On')));
        })).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(Current_Vehicle, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyres_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer2_Reg')) == (getObjectProperty(item, 'Currently_On')));
        })).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(Current_Vehicle, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyres_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer3_Reg')) == (getObjectProperty(item, 'Currently_On')));
        })).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(Current_Vehicle, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      } finally {
        if (error) {
          Current_Vehicle['ATE_FI'] = 0;
        }

      }
      try {
        Current_Vehicle['PTE_FI'] = ((addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyres_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Currently_On')));
        })).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(Current_Vehicle, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyres_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer1_Reg')) == (getObjectProperty(item, 'Currently_On')));
        })).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(Current_Vehicle, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyres_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer2_Reg')) == (getObjectProperty(item, 'Currently_On')));
        })).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(Current_Vehicle, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyres_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Trailer3_Reg')) == (getObjectProperty(item, 'Currently_On')));
        })).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(Current_Vehicle, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      }
      try {
        Current_Vehicle['Projected_Commission_FI'] = ((addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Horse_Registration')));
        })).map(async Tonnage_Total => {; return (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((getObjectProperty(Tonnage_Total, 'Load_Value')) * (1 + (getObjectProperty((getObjectProperty(Current_Vehicle, 'Targets')), 'Commission_Rate')) / 100) - (getObjectProperty(Tonnage_Total, 'Load_Value')))));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      }
      try {
        Current_Vehicle['Turnover_FI'] = ((addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')), async (item) => {


         return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Horse_Registration')));
        })).map(async Tonnage_Total => {; return (getObjectProperty(Tonnage_Total, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      }
      console.log(getObjectProperty(Current_Vehicle, 'Targets'));
    ; return ({ [`objectId`]: (getObjectProperty(Current_Vehicle, 'objectId')),[`Horse_Registration`]: (getObjectProperty(Current_Vehicle, 'Horse_Registration')),[`Horse_ID`]: (getObjectProperty(Current_Vehicle, 'Fleet_ID')),[`License_Notice_FI`]: (getObjectProperty(Current_Vehicle, 'Trailer1_Reg')),[`License_PDP_FI`]: (getObjectProperty(Current_Vehicle, 'Trailer2_Reg')),[`Trailer_3_FI`]: (getObjectProperty(Current_Vehicle, 'Trailer3_Reg')),[`Driver_1`]: (getObjectProperty(Current_Vehicle, 'Horse_FI')),[`Service_Notice`]: (getObjectProperty(Current_Vehicle, 'Trailers_FI')),[`Current_Mileage`]: (getObjectProperty(Current_Vehicle, 'Diesel_FI')),[`Distance_Traveled`]: (getObjectProperty(Current_Vehicle, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(Current_Vehicle, 'Per_Km_TR_FI')) : 0,[`Mileage_Target_Completion`]: (getObjectProperty(Current_Vehicle, 'Toll_Fees_FI')),[`Ideal_KM/L`]: (getObjectProperty(Current_Vehicle, 'Salary/Wages_FI')),[`Actual_KM/L`]: (getObjectProperty(Current_Vehicle, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(Current_Vehicle, 'Per_Km_M_Plan_FI')) : 0,[`Status`]: (getObjectProperty(Current_Vehicle, 'MRH_FI')),[`Fuel_Cost`]: (getObjectProperty(Current_Vehicle, 'ATE_FI')),[`Price_Per_Litre`]: (getObjectProperty(Current_Vehicle, 'PTE_FI')),[`Fuel_Cost_Per_Km`]: (getObjectProperty(Current_Vehicle, 'Projected_Commission_FI')),[`Gain/loss_Driving_Style`]: (getObjectProperty((getObjectProperty(Current_Vehicle, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(Current_Vehicle, 'Salary/Wages_FI')) + (getObjectProperty(Current_Vehicle, 'Projected_Commission_FI')) + (getObjectProperty(Current_Vehicle, 'PTE_FI')) + (getObjectProperty(Current_Vehicle, 'ATE_FI')) + (getObjectProperty(Current_Vehicle, 'MRH_FI')) + (getObjectProperty(Current_Vehicle, 'Per_Km_M_Plan_FI')) + (getObjectProperty(Current_Vehicle, 'Toll_Fees_FI')) + (getObjectProperty(Current_Vehicle, 'Per_Km_TR_FI')) + (getObjectProperty(Current_Vehicle, 'Diesel_FI')) + (getObjectProperty(Current_Vehicle, 'Trailers_FI')) + (getObjectProperty(Current_Vehicle, 'Horse_FI')),[`Total_Tonnage`]: (getObjectProperty(Current_Vehicle, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(Current_Vehicle, 'Salary/Wages_FI')) + (getObjectProperty(Current_Vehicle, 'Projected_Commission_FI')) + (getObjectProperty(Current_Vehicle, 'PTE_FI')) + (getObjectProperty(Current_Vehicle, 'ATE_FI')) + (getObjectProperty(Current_Vehicle, 'MRH_FI')) + (getObjectProperty(Current_Vehicle, 'Per_Km_M_Plan_FI')) + (getObjectProperty(Current_Vehicle, 'Toll_Fees_FI')) + (getObjectProperty(Current_Vehicle, 'Per_Km_TR_FI')) + (getObjectProperty(Current_Vehicle, 'Diesel_FI')) + (getObjectProperty(Current_Vehicle, 'Trailers_FI')) + (getObjectProperty(Current_Vehicle, 'Horse_FI'))) / (getObjectProperty(Current_Vehicle, 'Distance'))))),[`Litres_Filled`]: (getObjectProperty(Current_Vehicle, 'Turnover_FI')),[`Target_Tonnage_Completion`]: (getObjectProperty((getObjectProperty(Current_Vehicle, 'Targets')), 'Monthly_Profit_Target')),[`Permissible_Tonnage`]: (getObjectProperty(Current_Vehicle, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(Current_Vehicle, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(Current_Vehicle, 'Salary/Wages_FI')) + (getObjectProperty(Current_Vehicle, 'Projected_Commission_FI')) + (getObjectProperty(Current_Vehicle, 'PTE_FI')) + (getObjectProperty(Current_Vehicle, 'ATE_FI')) + (getObjectProperty(Current_Vehicle, 'MRH_FI')) + (getObjectProperty(Current_Vehicle, 'Per_Km_M_Plan_FI')) + (getObjectProperty(Current_Vehicle, 'Toll_Fees_FI')) + (getObjectProperty(Current_Vehicle, 'Per_Km_TR_FI')) + (getObjectProperty(Current_Vehicle, 'Diesel_FI')) + (getObjectProperty(Current_Vehicle, 'Trailers_FI')) + (getObjectProperty(Current_Vehicle, 'Horse_FI'))),[`Average_Tonnage`]: (getObjectProperty(Current_Vehicle, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(Current_Vehicle, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(Current_Vehicle, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(Current_Vehicle, 'Salary/Wages_FI')) + (getObjectProperty(Current_Vehicle, 'Projected_Commission_FI')) + (getObjectProperty(Current_Vehicle, 'PTE_FI')) + (getObjectProperty(Current_Vehicle, 'ATE_FI')) + (getObjectProperty(Current_Vehicle, 'MRH_FI')) + (getObjectProperty(Current_Vehicle, 'Per_Km_M_Plan_FI')) + (getObjectProperty(Current_Vehicle, 'Toll_Fees_FI')) + (getObjectProperty(Current_Vehicle, 'Per_Km_TR_FI')) + (getObjectProperty(Current_Vehicle, 'Diesel_FI')) + (getObjectProperty(Current_Vehicle, 'Trailers_FI')) + (getObjectProperty(Current_Vehicle, 'Horse_FI')))) / (getObjectProperty(Current_Vehicle, 'Distance'))))),[`Gain/Loss_Loading`]: (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')), async (item) => {


     return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Horse_Registration')));
    })).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_MI`]: (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')), async (item) => {


     return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Horse_Registration')));
    })).map(async item => {; return (getObjectProperty(item, 'Loss_On_Mileage_In_Money'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/Loss_Loading_TO`]: (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')), async (item) => {


     return ((getObjectProperty(Current_Vehicle, 'Horse_Registration')) == (getObjectProperty(item, 'Horse_Registration')));
    })).map(async item => {; return (getObjectProperty(item, 'GainLoss_On_Load'));}))), 0)).reduce(function(x, y) {return x + y;}) });})));
    ___arguments.context.appData['Vehicles_By_OwnerID'] = (getObjectProperty(___arguments.context.pageData, 'Vehicles_By_OwnerID'));
    ___arguments.context.appData['Vehicles_Of_Concern'] = ((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles_By_Target')).map(async Current_Target_Item => {  Current_Target_Item['Fuel_Cons'] = ((addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')), async (item) => {


       return ((getObjectProperty(Current_Target_Item, 'Vehicle_Registration')) == (getObjectProperty(item, 'Registration')));
      })).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')), async (item) => {


       return ((getObjectProperty(Current_Target_Item, 'Vehicle_Registration')) == (getObjectProperty(item, 'Registration')));
      })).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}));
    ; return ((getObjectProperty(Current_Target_Item, 'Ideal_Fuel_Consumption')) * 0.95 > (getObjectProperty(Current_Target_Item, 'Fuel_Cons')) ? 1 : 0);}))).reduce(function(x, y) {return x + y;}));
    try {
      ___arguments.context.appData['Tonnage_Completion_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((addItemToList((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')).map(async Loads => {; return (getObjectProperty(Loads, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles_By_Target')).map(async Current_Target_Item => {; return (getObjectProperty(Current_Target_Item, 'Monthly_Tonnage_Target'));}))), 0)).reduce(function(x, y) {return x + y;})) * 100)));

    } catch (error) {

    }
    try {
      ___arguments.context.appData['Payload_Gauge'] = (mathMean(await Promise.all((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')).map(async Loads => {; return (getObjectProperty(Loads, 'Tonnage_Ratio'));}))) * 100);

    } catch (error) {

    }
    try {
      ___arguments.context.appData['Mileage_Completion_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((addItemToList((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')).map(async Loads => {; return (getObjectProperty(Loads, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles_By_Target')).map(async Current_Target_Item => {; return (getObjectProperty(Current_Target_Item, 'Monthly_Mileage_Target'));}))), 0)).reduce(function(x, y) {return x + y;})) * 100)));

    } catch (error) {

    }
    try {
      ___arguments.context.appData['Total_Gain/Loss_Loading'] = ((addItemToList((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}));

    } catch (error) {

    }
    try {
      ___arguments.context.appData['Total_Gain/Loss_Driving_style'] = ((addItemToList((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_Driving_Style'));}))), 0)).reduce(function(x, y) {return x + y;}));

    } catch (error) {

    }
    try {
      ___arguments.context.appData['Diesel_Vs_Turnover_Gauge'] = (((addItemToList((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')).map(async Loads => {; return (getObjectProperty(Loads, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Loads_By_OwnerID')).map(async Loads => {; return (getObjectProperty(Loads, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})) * 100);

    } catch (error) {

    }
    try {
      ___arguments.context.appData['Consumption_Status_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((mathMean(await asyncListFilter((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Fuel_By_OwnerID')).map(async Loads => {; return ((typeof ((getObjectProperty(Loads, 'Calculated_FC')) / (getObjectProperty(Loads, 'Ideal_Fuel_Consumption'))) === 'number' && !isNaN(((getObjectProperty(Loads, 'Calculated_FC')) / (getObjectProperty(Loads, 'Ideal_Fuel_Consumption'))))) ? ((((getObjectProperty(Loads, 'Calculated_FC')) / (getObjectProperty(Loads, 'Ideal_Fuel_Consumption'))) === null) ? null : (getObjectProperty(Loads, 'Calculated_FC')) / (getObjectProperty(Loads, 'Ideal_Fuel_Consumption'))) : null);}))), async (item) => {


       return (item > 0);
      })) * 100)));

    } catch (error) {

    }
    Fleet_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  console.log(item);
      try {
        item['Horse_FI'] = ((getObjectProperty(item, 'Depreciation')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Fixed_Monthly_Sundry_Fee')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Tracking_Fee')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);

      } catch (error) {
        console.log(error);

      }
      try {
        item['Trailers_FI'] = (((getObjectProperty(item, 'Trailer1_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer2_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer3_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0));

      } catch (error) {
        console.log(error);

      }
      try {
        Other = (addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;});
        item['Other_FI'] = ((typeof Other === 'undefined') ? 0 : Other);

      } catch (error) {
        console.log(error);

      }
      try {
        item['Diesel_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      }
      try {
        item['Per_Km_TR_FI'] = ((getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_Toll_Rate_R')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);

      } catch (error) {
        console.log(error);

      }
      try {
        item['Toll_Fees_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Type = \'Toll\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      }
      try {
        item['Salary/Wages_FI'] = (getObjectProperty(((await asyncListFilter(Salary, async (Driver_Filter) => {


         return ((getObjectProperty(item, 'Current_Driver')) == (getObjectProperty(Driver_Filter, 'Call_Sign')));
        }))[0]), 'Total'));

      } catch (error) {
        if (error) {
          item['Salary/Wages_FI'] = 0;
        }

      }
      try {
        item['Per_Km_M_Plan_FI'] = ((getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Maintenance_Plan_Rate_per_Km')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);

      } catch (error) {
        console.log(error);

      }
      try {
        item['MRH_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Horse = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      }
      try {
        item['ATE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Expected_CPK'));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      }
      try {
        item['Tyre_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\' AND System_Generated_Tyre = \'No\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return (getObjectProperty(Tyre, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      }
      try {
        item['PTE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      }
      try {
        try {
          Projected_Comission = (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((getObjectProperty(Tonnage_Total, 'Load_Value')) * (1 + (getObjectProperty((getObjectProperty(item, 'Targets')), 'Commission_Rate')) / 100) - (getObjectProperty(Tonnage_Total, 'Load_Value')))));}))), 0)).reduce(function(x, y) {return x + y;});

        } catch (error) {
          console.log(error);

        } finally {
          if (error) {
            item['Projected_Commission_FI'] = 0;
          }

        }
        if (typeof Projected_Comission === 'undefined') {
          item['Projected_Commission_FI'] = 0;
        } else {
          item['Projected_Commission_FI'] = Projected_Comission;
        }

      } catch (error) {
        console.log(error);

      }
      try {
        item['Turnover_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (getObjectProperty(Tonnage_Total, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;}));

      } catch (error) {
        console.log(error);

      }
      console.log(getObjectProperty(item, 'Turnover_FI'));
      console.log(getObjectProperty(item, 'Salary/Wages_FI'));
      console.log('1');
      console.log(getObjectProperty(item, 'Projected_Commission_FI'));
      console.log('1');
      console.log(getObjectProperty(item, 'Tyre_FI'));
      console.log(getObjectProperty(item, 'MRH_FI'));
      console.log(getObjectProperty(item, 'Per_Km_M_Plan_FI'));
      console.log(getObjectProperty(item, 'Toll_Fees_FI'));
      console.log(getObjectProperty(item, 'Per_Km_TR_FI'));
      console.log(getObjectProperty(item, 'Diesel_FI'));
      console.log(getObjectProperty(item, 'Trailers_FI'));
      console.log(getObjectProperty(item, 'Horse_FI'));
    ; return ({ [`License_Notice_T2_FI`]: (getObjectProperty(item, 'Turnover_FI')) - (0 + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'Tyre_FI')) + 0 + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))) });})));
    try {
      ___arguments.context.appData['Profit/Loss_Gauge'] = (((await Promise.all(Fleet_Item.map(async item => {; return (getObjectProperty(item, 'License_Notice_T2_FI'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles_By_Target')).map(async item => {; return (getObjectProperty(item, 'Monthly_Profit_Target'));}))).reduce(function(x, y) {return x + y;})) * 100);

    } catch (error) {

    }
    try {
      ___arguments.context.appData['DashLoad'] = 'Yes';

    } catch (error) {

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9174ebeb15066aca976c381e18029c32', false);

    } catch (error) {

    }
  }
}

/**
 * Describe this function...
 */
async function Login_Procedure() {
  ___arguments.context.appData['Director_User'] = (await Backendless.Data.of('Users').findById((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'ownerId')), ));
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Director_User')), 'userStatus')) == 'DISABLED') {
    ___arguments.context.appData['Blocked'] = true;
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  User_Level = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'User_level'));
}

/**
 * Describe this function...
 */
async function Director_Procedure() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9174ebeb15066aca976c381e18029c32', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5332f9dbc0afaf9c0e74967497c683c4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4efd556c305b99e9efb934ca5ddf42f5', true);
  await Director_Dash_Procedure();
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

/**
 * Describe this function...
 */
async function Driver_Procedure() {
  ___arguments.context.appData['Employee'] = ((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'objectId')),'\''].join(''))).setPageSize(10)))[0]);
  try {
    ___arguments.context.appData['Star Rating - Fuel'] = (await BackendlessUI.Functions.Custom['fn_518de41fac043aee8b8e5d4a87521873']('Fuel', (['Driver = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Call_Sign')),'\''].join('')), 'GD_Ratio'));

  } catch (error) {
    if (error) {
      console.log(error);
      ___arguments.context.appData['Star Rating - Fuel'] = 0;
    }

  }
  try {
    ___arguments.context.appData['Star Rating - Loading'] = (await BackendlessUI.Functions.Custom['fn_518de41fac043aee8b8e5d4a87521873']('Loads', (['Driver = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Call_Sign')),'\''].join('')), 'Tonnage_Ratio'));

  } catch (error) {
    if (error) {
      console.log(error);
      ___arguments.context.appData['Star Rating - Loading'] = 0;
    }

  }
  ___arguments.context.appData['Star Rating - Stage 1'] = (((getObjectProperty(___arguments.context.appData, 'Star Rating - Loading')) + (getObjectProperty(___arguments.context.appData, 'Star Rating - Fuel'))) / 2);
  ___arguments.context.appData['Star Rating - Stage 2'] = (await BackendlessUI.Functions.Custom['fn_338b2d52d76f0736d2c3d885025856c8']((getObjectProperty(___arguments.context.appData, 'Star Rating - Stage 1'))));
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Warehouse_Status')) == 'In') {
    ___arguments.context.pageData['Driver_Block_1'] = true;
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Warehouse_Status')) == 'Out') {
    ___arguments.context.pageData['Current_Truck_Horse_Registration'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard'));
    ___arguments.context.pageData['Current_Truck'] = ((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard')),'\''].join(''))).setPageSize(10)))[0]);
    Current_Mileage = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck')), 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0];
    (getObjectProperty(___arguments.context.pageData, 'Current_Truck'))['Current_Mileage'] = Current_Mileage;
    if (Current_Mileage - (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck')), 'Last_Service_Mileage')) <= (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck')), 'Service_Warning_Duration_in_KM'))) {
      (getObjectProperty(___arguments.context.pageData, 'Current_Truck'))['Service_Status'] = 'All in Order';
      try {
        await Backendless.Data.of('Trailers').bulkUpsert( (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(___arguments.context.pageData, 'Current_Truck_Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`Service_Status`]: (getObjectProperty(item, 'Service_Interval')) - (getObjectProperty(item, 'Current_Mileage')) % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration')) ? 'Service Due' : 'All in Order',[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck')), 'ownerId')) });}))) );

      } catch (error) {

      }
    } else {
      (getObjectProperty(___arguments.context.pageData, 'Current_Truck'))['Service_Status'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck')), 'Service_Interval')) - Current_Mileage % (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck')), 'Service_Interval')) < (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck')), 'Service_Warning_Duration_in_KM')) ? 'Service Due' : 'All in Order');
      try {
        await Backendless.Data.of('Trailers').bulkUpsert( (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(___arguments.context.pageData, 'Current_Truck_Horse_Registration')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`Service_Status`]: (getObjectProperty(item, 'Service_Interval')) - (getObjectProperty(item, 'Current_Mileage')) % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration')) ? 'Service Due' : 'All in Order',[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck')), 'ownerId')) });}))) );

      } catch (error) {

      }
    }
    await Backendless.Data.of('Vehicles').save( (getObjectProperty(___arguments.context.pageData, 'Current_Truck')) );
    ___arguments.context.pageData['Current_Truck_Targets'] = ((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard')),'\''].join(''))).setPageSize(10)))[0]);
    Fuel_List = (await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard')),'\''].join(''))).setSortBy('created DESC').setPageSize(3)));
    ___arguments.context.pageData['Last3_FC'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).slice(-1)[0] + (await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).slice(-2)[0] + (await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).slice(-3)[0]) / ((await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'litres'));}))).slice(-1)[0] + (await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'litres'));}))).slice(-2)[0] + (await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'litres'));}))).slice(-3)[0]))));
    ___arguments.context.pageData['Driver_Block_2'] = true;
    ___arguments.context.pageData['Driver_Block_3'] = true;
    ___arguments.context.pageData['Next_Load'] = ((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard')),'\' AND Completion_Status = \'0\''].join(''))).setSortBy('Planned_Delivery_Date_Time DESC').setPageSize(10))).slice(-1)[0]);
    try {
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'Planned_Delivery_Date_Time')) === null) {
        ___arguments.context.pageData['Next_Load'] = ((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard')),'\' AND Completion_Status = \'0\''].join(''))).setSortBy('Planned_Delivery_Date_Time DESC').setPageSize(10))).slice(-2)[0]);
      }

    } catch (error) {

    }
    try {

      ;(function(whereClause) {
        const callback = async object => {
            ___arguments.context.pageData['Next_Load'] = ((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard')),'\' AND Completion_Status = \'0\''].join(''))).setSortBy('Planned_Delivery_Date_Time DESC').setPageSize(10)))[0]);
        if ((typeof (getObjectProperty(___arguments.context.pageData, 'Next_Load')) === 'undefined') != true) {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', true);
        } else {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', false);
        }

        };

        const rtHandlers = Backendless.Data.of('Loads').rt();

        const options = [callback];

        if (whereClause) {
           options.unshift(whereClause);
        }

        rtHandlers.addCreateListener.apply(rtHandlers, options);

        getRTSubscriptions().add('Driver_Load_Creator', () => rtHandlers.removeCreateListener(callback));

      })((['Horse_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard')),'\''].join('')));

    } catch (error) {

    }
    try {

      ;(function(whereClause) {
        const callback = async object => {
            ___arguments.context.pageData['Next_Load'] = ((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard')),'\' AND Completion_Status = \'0\''].join(''))).setSortBy('Planned_Delivery_Date_Time DESC').setPageSize(10)))[0]);
        if ((typeof (getObjectProperty(___arguments.context.pageData, 'Next_Load')) === 'undefined') != true) {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', true);
        } else {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', false);
        }

        };

        const rtHandlers = Backendless.Data.of('Loads').rt();

        const options = [callback];

        if (whereClause) {
           options.unshift(whereClause);
        }

        rtHandlers.addUpdateListener.apply(rtHandlers, options);

        getRTSubscriptions().add('Driver_Load_Updater', () => rtHandlers.removeUpdateListener(callback));

      })((['Horse_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard')),'\''].join('')));

    } catch (error) {

    }
    try {

      ;(function(whereClause) {
        const callback = async object => {
            ___arguments.context.pageData['Next_Load'] = ((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard')),'\' AND Completion_Status = \'0\''].join(''))).setSortBy('Planned_Delivery_Date_Time DESC').setPageSize(10)))[0]);
        if ((typeof (getObjectProperty(___arguments.context.pageData, 'Next_Load')) === 'undefined') != true) {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', true);
        } else {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', false);
        }

        };

        const rtHandlers = Backendless.Data.of('Loads').rt();

        const options = [callback];

        if (whereClause) {
           options.unshift(whereClause);
        }

        rtHandlers.addDeleteListener.apply(rtHandlers, options);

        getRTSubscriptions().add('Driver_Load_Delete', () => rtHandlers.removeDeleteListener(callback));

      })((['Horse_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee')), 'Currently_Aboard')),'\' AND Completion_Status = \'0\''].join('')));

    } catch (error) {

    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('016a464b6458cb1718cdb8bb22143bcc', true);
    if ((typeof (getObjectProperty(___arguments.context.pageData, 'Next_Load')) === 'undefined') != true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', false);
    }
  }
  (getObjectProperty(___arguments.context.appData, 'Employee'))['Star_Rating_Fuel'] = (await BackendlessUI.Functions.Custom['fn_338b2d52d76f0736d2c3d885025856c8']((getObjectProperty(___arguments.context.appData, 'Star Rating - Fuel'))));
  (getObjectProperty(___arguments.context.appData, 'Employee'))['Star_Rating_Loading'] = (await BackendlessUI.Functions.Custom['fn_338b2d52d76f0736d2c3d885025856c8']((getObjectProperty(___arguments.context.appData, 'Star Rating - Loading'))));
  (getObjectProperty(___arguments.context.appData, 'Employee'))['Star_Rating'] = (getObjectProperty(___arguments.context.appData, 'Star Rating - Stage 2'));
  await Backendless.Data.of('Employees').save( (getObjectProperty(___arguments.context.appData, 'Employee')) );
}


  if ((getObjectProperty(___arguments.context.appData, 'Selected Cusomer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.appData, 'Selected Cusomer'))) && (typeof (getObjectProperty(___arguments.context.appData, 'Selected Cusomer')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'User_level')) == 'Global') {
      try {
        currentUser = (getObjectProperty(___arguments.context.appData, 'Selected Cusomer'));

      } catch (error) {
        console.log(error);

      }
    } else {
      currentUser = (await Backendless.UserService.getCurrentUser(true));
    }
    ___arguments.context.appData['Current_User'] = currentUser;
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'Account_Type')) == 'Agri') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home_Agri', undefined);
    }
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3dcfe403bb035444a5be40972b2f6063'))['opacity'] = 0;
    ___arguments.context.pageData['DDP'] = false;
    ___arguments.context.pageData['Driver_View'] = false;
    ___arguments.context.pageData['DDM'] = false;
    currentUser = (getObjectProperty(___arguments.context.appData, 'Current_User'));
    if (getObjectProperty(___arguments.context.appData, 'Current_User')) {
      await Login_Procedure();
      if (User_Level == 'Director' || (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'Manager')) == true) {
        if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1200) {
          ___arguments.context.pageData['DDM'] = true;
        } else {
          ___arguments.context.pageData['DDP'] = true;
        }
        await Director_Procedure();
      } else if (User_Level == 'Driver') {
        ___arguments.context.pageData['Driver_View'] = true;
        await Driver_Procedure();
      }
      await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3dcfe403bb035444a5be40972b2f6063')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3dcfe403bb035444a5be40972b2f6063')), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9174ebeb15066aca976c381e18029c32')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9174ebeb15066aca976c381e18029c32')), false);
    } else {
      await Backendless.UserService.logout();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'User_level')) == 'Global') {
      try {
        currentUser = (getObjectProperty(___arguments.context.appData, 'Selected Cusomer'));

      } catch (error) {
        console.log(error);

      }
    } else {
      currentUser = (await Backendless.UserService.getCurrentUser(true));
    }
    ___arguments.context.appData['Current_User'] = currentUser;
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'Account_Type')) == 'Agri') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home_Agri', undefined);
    }
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3dcfe403bb035444a5be40972b2f6063'))['opacity'] = 0;
    ___arguments.context.pageData['DDP'] = false;
    ___arguments.context.pageData['Driver_View'] = false;
    ___arguments.context.pageData['DDM'] = false;
    currentUser = (getObjectProperty(___arguments.context.appData, 'Current_User'));
    if (getObjectProperty(___arguments.context.appData, 'Current_User')) {
      await Login_Procedure();
      if (User_Level == 'Director' || (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'Manager')) == true) {
        if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1200) {
          ___arguments.context.pageData['DDM'] = true;
        } else {
          ___arguments.context.pageData['DDP'] = true;
        }
        await Director_Procedure();
      } else if (User_Level == 'Driver') {
        ___arguments.context.pageData['Driver_View'] = true;
        await Driver_Procedure();
      }
      await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3dcfe403bb035444a5be40972b2f6063')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3dcfe403bb035444a5be40972b2f6063')), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9174ebeb15066aca976c381e18029c32')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9174ebeb15066aca976c381e18029c32')), false);
    } else {
      await Backendless.UserService.logout();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
    }
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var currentUser;


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['Current_User'] = currentUser;
  if (currentUser) {
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/Home/components/c486e801c43c79658f8bee466aede9b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var error, User;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    User = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'displayName'));

  } catch (error) {

  } finally {
    if (error) {
      User = '';
    }

  }

  return User

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home/components/09856cb1e0e3377d004ebe96850941f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('addFuel', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_addFuel'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/65f9a4b4560319f72919795921cfbbee/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Current_Truck_Horse_Registration'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Home/components/1453cffbe53986b828d2c2e4b8fd79f2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck_Targets')), 'Ideal_Fuel_Consumption')))) + String(' Km/L'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home/components/a7870d1b53a34249b50f7ff8b6ebd7f4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Tonnage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck_Targets')), 'Tonnage_Override')) == null) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck_Targets')), 'Permissible_Tonnage')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck')), 'Payload'))) {
      Tonnage = String(JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck_Targets')), 'Permissible_Tonnage')))) + String(' Tons');
    } else {
      await Backendless.Messaging.sendEmail((['Payload Error on (',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck')), 'Horse_Registration')),')'].join('')), new Backendless.Bodyparts({ textmessage: (String(getObjectProperty(___arguments.context.pageData, 'Current_Truck_Targets')) + String(getObjectProperty(___arguments.context.pageData, 'Current_Truck'))) }), ensureArray(['support@fleetinform.com']), undefined);
      Tonnage = 'Error';
    }
  } else {
    Tonnage = String(JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck_Targets')), 'Tonnage_Override')))) + String(' Tons');
  }

  return Tonnage

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home/components/c797679c6aecc33b668aed8e0dfb1e51/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Leave_Truck', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Leave_Truck'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/358d520c67e21221c2857b42493ee017/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var item, Fuel_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Last3_FC')) <= (getObjectProperty(___arguments.context.pageData, 'Current_Truck_Km/L')) * 0.99) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('760a9af27706f2b247b70833b02bb8b9'))['backgroundColor'] = 'rgba(252, 0, 0, 0.40)';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Last3_FC')) >= (getObjectProperty(___arguments.context.pageData, 'Current_Truck_Km/L')) * 0.99 && (getObjectProperty(___arguments.context.pageData, 'Last3_FC')) >= (getObjectProperty(___arguments.context.pageData, 'Current_Truck_Km/L')) * 1.01) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('760a9af27706f2b247b70833b02bb8b9'))['backgroundColor'] = 'rgba(252, 252, 05, 0.40)';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Last3_FC')) >= (getObjectProperty(___arguments.context.pageData, 'Current_Truck_Km/L')) * 1.01) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('760a9af27706f2b247b70833b02bb8b9'))['backgroundColor'] = 'rgba(0, 252, 0, 0.40)';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Last3_FC')) == (getObjectProperty(___arguments.context.pageData, 'Current_Truck_Km/L'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('760a9af27706f2b247b70833b02bb8b9'))['backgroundColor'] = 'rgba(230, 195, 2, 0.6)';
  }

  return (String(getObjectProperty(___arguments.context.pageData, 'Last3_FC')) + String(' Km/L'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home/components/ac96599b2c6296b901f3f523b1a2543f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Load_Planner', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Load_Planner'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/1b94e40994c5b5fa8663279b809fa549/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Add_Fuel_Office', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Add_Fuel_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/531abda663a90464cfc9f23ba6ea6a4d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Add_Loads_Office', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Add_Loads_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/4af3b26630dcfd1f6d195f5d924fedf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Board_Truck_Office', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Board_Truck_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/f3c6553c0da3c38cd5590f9449f8ff11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Leave_Truck_Office', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Leave_Truck_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/6e7536289703adc2966632649f19abfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Swap_Trailer_Office', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Swap_Trailer_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/5332f9dbc0afaf9c0e74967497c683c4/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var Counter, Next_Load, Active_Truck, item, Current_Truck, Current_Driver, Last_3_Lt, Last_3_MD, Last_Mileage_Of_This_Truck, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  while ((await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']()) == true && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'User_level')) == 'Driver') {
    Current_Driver = (await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employee.displayName = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['Warehouse'] = (getObjectProperty(Current_Driver, 'Warehouse'));
    if ((getObjectProperty(___arguments.context.pageData, 'Warehouse')) == null || (getObjectProperty(___arguments.context.pageData, 'Warehouse')) == 'In') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61afc62fd67d4c6e6c482533ab87e193', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61afc62fd67d4c6e6c482533ab87e193', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01d4cb6c47e6b82be389dd6929265acf', false);
    } else {
      Active_Truck = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver_1.ownerId = \'',LiveUser,'\''].join(''))).setPageSize(100)))[0];
      ___arguments.context.pageData['Got_Mileage'] = (getObjectProperty(Active_Truck, 'objectId'));
      Last_Mileage_Of_This_Truck = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('mileage').setPageSize(100))).map(async item => {; return ({ 'Last Mileage': (getObjectProperty(item, 'mileage')) });})));
      ___arguments.context.pageData['Final_Last_Mileage'] = (Last_Mileage_Of_This_Truck.slice(-1)[0]);
      ___arguments.context.pageData['Reflected_Mileage'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_Mileage')), 'Last Mileage'))));
      Last_3_MD = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Mileage Differential': (getObjectProperty(item, 'Mileage_Differential')) });})));
      ___arguments.context.pageData['Final_Last_MD_1'] = (Last_3_MD.slice(-1)[0]);
      ___arguments.context.pageData['Reflected_MD_1'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_1')), 'Mileage Differential'));
      ___arguments.context.pageData['Final_Last_MD_2'] = (Last_3_MD.slice(-2)[0]);
      ___arguments.context.pageData['Reflected_MD_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_2')), 'Mileage Differential'))));
      ___arguments.context.pageData['Final_Last_MD_3'] = (Last_3_MD.slice(-3)[0]);
      ___arguments.context.pageData['Reflected_MD_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_3')), 'Mileage Differential'))));
      ___arguments.context.pageData['Got_LT'] = undefined;
      Last_3_Lt = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Last Litres ': (getObjectProperty(item, 'litres')) });})));
      ___arguments.context.pageData['Final_Last_LT_1'] = (Last_3_Lt.slice(-1)[0]);
      ___arguments.context.pageData['Reflected_LT_1'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_1')), 'Last Litres '))));
      ___arguments.context.pageData['Final_Last_LT_2'] = (Last_3_Lt.slice(-2)[0]);
      ___arguments.context.pageData['Reflected_LT_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_2')), 'Last Litres '))));
      ___arguments.context.pageData['Final_Last_LT_3'] = (Last_3_Lt.slice(-3)[0]);
      ___arguments.context.pageData['Reflected_LT_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_3')), 'Last Litres '))));
      ___arguments.context.pageData['Last3_FC'] = (Math.round((((getObjectProperty(___arguments.context.pageData, 'Reflected_MD_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_1'))) / ((getObjectProperty(___arguments.context.pageData, 'Reflected_LT_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_1')))) * 1000) / 1000);
      ___arguments.context.pageData['Current_Driver_objectId'] = (getObjectProperty(Current_Driver, 'objectId'));
      Current_Truck = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver_1.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Current_Driver_objectId')),'\''].join(''))).setPageSize(10)))[0];
      ___arguments.context.pageData['Horse_objectId'] = (getObjectProperty(Current_Truck, 'objectId'));
      if ((getObjectProperty(Active_Truck, 'Load_Planner_objectId')) == null) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', false);
      }
    }
    ___arguments.context.pageData['Current_Truck_PT'] = ((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(Current_Truck, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(Current_Truck, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Permissible_Tonnage'));})))[0] : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(Current_Truck, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0]);
    Next_Load = (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(Current_Truck, 'objectId')),'\' And ','Completion_Status = \'0\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(10))).map(async item => {; return ({ 'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Service': (getObjectProperty(item, 'Service')),'Status': (getObjectProperty(item, 'Status')),'load_point': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')) });})))[0];
    if ((getObjectProperty(Active_Truck, 'Load_Planner_objectId')) == null) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', false);
    } else {
      if ((getObjectProperty(Next_Load, 'Service')) == 'Yes' && (getObjectProperty(Next_Load, 'Status')) == null) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', true);
        ___arguments.context.pageData['Next_Load'] = (String('Service at ') + String(getObjectProperty(Next_Load, 'load_point')));
      } else if ((getObjectProperty(Next_Load, 'Status')) == null) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', true);
        ___arguments.context.pageData['Next_Load'] = (String('Load at ') + String(getObjectProperty(Next_Load, 'load_point')));
      }
      if ((getObjectProperty(Next_Load, 'Service')) == 'Yes' && (getObjectProperty(Next_Load, 'Status')) == 'Loaded') {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', true);
        ___arguments.context.pageData['Next_Load'] = (String('Complete Service') + String(''));
      } else if ((getObjectProperty(Next_Load, 'Status')) == 'Loaded') {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf92e1a8d8fc3fefef4caa4505c480e7', true);
        ___arguments.context.pageData['Next_Load'] = (String('Deliver to ') + String(getObjectProperty(Next_Load, 'delivery_point')));
      }
    }
    Counter = Counter + 1;
    console.log(Counter);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Home/components/9c3f425bfdb4a426e4ffb13e2f2bae69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Broker_Overview', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Broker_Overview'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/f31a0c9ad87c8fe449393c1eb97a8498/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 700) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Maintainance_Hub_Mobile', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Maintenance_Hub_Web', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Maintenance_Hub_Web'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/30018e4c2616574f22590fc9683f119f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Next_Load;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'Status')) == 'Loaded') {
    Next_Load = String('Delivery At ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'delivery_point'));
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'Service')) == null) {
      Next_Load = String('Load At ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'load_point'));
    } else {
      Next_Load = String('Service At ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'load_point'));
    }
  }

  return Next_Load

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home/components/63250328436c2c47a997258eef09f698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Broker_Overview', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Broker_Overview'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/f7b413abe5384391814fa3370e3c7fe2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Financial_Overview', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Financial_Overview'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/2d222d7a33f3b0ee4955ab01c55fac5b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Salary_Overview', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Salary_Overview'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/7b01f381aef59e02961f8c010cdd36b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Fleet_Overview', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Fleet_Overview'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/e3a95ec6ba5ef96a6d9bf0d8aa8496f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Board_Truck_Office', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Board_Truck_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/011d28c9cc1b2521ba4138b798e8953b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser;


  await Backendless.UserService.logout();
  ___arguments.context.appData['currentUser'] = currentUser;
  ___arguments.context.appData['DashLoad'] = undefined;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/173bce31279490bb234d2f1cf54619b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var error, User;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    User = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'displayName'));

  } catch (error) {

  } finally {
    if (error) {
      User = '';
    }

  }

  return User

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home/components/14f336b29fd14843f2d29575ad71f678/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Fleet_Item, Tonnage_Total, Tyre, error, Driver_Filter, Salary, Loads, Value, Start_Date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'Live_Updater')) == true) {
    ___arguments.context.pageData['Live_Updater'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('110bf11d03dcc4a181e506372a122ec3'))['color'] = 'Grey';
  } else {
    ___arguments.context.pageData['Live_Updater'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('110bf11d03dcc4a181e506372a122ec3'))['color'] = 'Red';
    while ((getObjectProperty(___arguments.context.pageData, 'Live_Updater')) == true) {
      await new Promise(r => setTimeout(r, 300000 || 0));
      if ((getObjectProperty(___arguments.context.pageData, 'Live_Updater')) == true) {
        console.log('Updating');
        Start_Date = (new Date());
        Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
        Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
        Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
        Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
        Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
        ___arguments.context.pageData['Start_Date'] = Start_Date;
        ___arguments.context.pageData['End_Date'] = (new Date());
        ___arguments.context.appData['Vehicles_Of_Concern'] = ((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  item['Fuel_Cons'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}));
        ; return ((getObjectProperty(item, 'Ideal_Fuel_Consumption')) * 0.95 < (getObjectProperty(item, 'Fuel_Cons')) ? 0 : 1);}))).reduce(function(x, y) {return x + y;}));
        ___arguments.context.appData['Tonnage_Completion_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (((((getObjectProperty(item, 'Monthly_Tonnage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate())) / (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})) * 100 == Infinity ? 0 : ((((getObjectProperty(item, 'Monthly_Tonnage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate())) / (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})) * 100);}))))));
        ___arguments.context.appData['Payload_Gauge'] = (mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (await BackendlessUI.Functions.Custom['fn_73996a4c829e78cd078929cb97ed2201']((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Tonnage_Ratio'));})))));}))) * 100);
        ___arguments.context.appData['Mileage_Completion_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  Value = ((((getObjectProperty(item, 'Monthly_Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate())) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;})) * 100 == Infinity ? 0 : ((((getObjectProperty(item, 'Monthly_Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate())) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;})) * 100;
        ; return ((typeof Value === 'number' && !isNaN(Value)) ? Value : 0);}))))));
        ___arguments.context.appData['Total_Gain/Loss_Loading'] = ((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}));
        ___arguments.context.appData['Total_Gain/Loss_Driving_style'] = ((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_Driving_Style'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}));
        ___arguments.context.appData['Diesel_Vs_Turnover_Gauge'] = (((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})) * 100);
        ___arguments.context.appData['Consumption_Status_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));}))) / ((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})))))) * 100)));
        Salary = (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employer.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Name': (getObjectProperty(item, 'Name')),'Call_Sign': (getObjectProperty(item, 'Call_Sign')),'Employee_Details': item,'Basic_Salary': (getObjectProperty(item, 'Basic_Salary')),'Contractor_Km_Payment': (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),'GD_Payment': (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),'Contractor_Tonnage_Pay': (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),'Tonnage_Target_Pay': (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),'Total': (getObjectProperty(item, 'Basic_Salary')) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) });})));
        Fleet_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  item['Distance'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['Targets'] = ((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(10)))[0]);
          item['Horse_FI'] = ((getObjectProperty(item, 'Depreciation')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Fixed_Monthly_Sundry_Fee')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Tracking_Fee')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);
          item['Trailers_FI'] = (((getObjectProperty(item, 'Trailer1_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setPageSize(10))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer2_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setPageSize(10))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer3_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setPageSize(10))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0));
          item['Diesel_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['Per_Km_TR_FI'] = ((getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_Toll_Rate_R')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);
          item['Toll_Fees_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Type = \'Toll\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
          try {
            item['Salary/Wages_FI'] = (getObjectProperty(((await asyncListFilter(Salary, async (Driver_Filter) => {


             return ((getObjectProperty(item, 'Current_Driver')) == (getObjectProperty(Driver_Filter, 'Call_Sign')));
            }))[0]), 'Total'));

          } catch (error) {
            if (error) {
              item['Salary/Wages_FI'] = 0;
            }

          }
          item['Per_Km_M_Plan_FI'] = ((getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Maintenance_Plan_Rate_per_Km')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);
          item['MRH_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Horse = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['ATE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['PTE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['Projected_Commission_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((getObjectProperty(Tonnage_Total, 'Load_Value')) * (1 + (getObjectProperty((getObjectProperty(item, 'Targets')), 'Commission_Rate')) / 100) - (getObjectProperty(Tonnage_Total, 'Load_Value')))));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['Turnover_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (getObjectProperty(Tonnage_Total, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;}));
        ; return ({ 'objectId': (getObjectProperty(item, 'objectId')),'Horse_Registration': (getObjectProperty(item, 'Fleet_ID')),'Horse_ID': (getObjectProperty(item, 'Horse_Registration')),'License_Notice_FI': (getObjectProperty(item, 'Trailer1_Reg')),'License_PDP_FI': (getObjectProperty(item, 'Trailer2_Reg')),'Trailer_3_FI': (getObjectProperty(item, 'Trailer3_Reg')),'Driver_1': (getObjectProperty(item, 'Horse_FI')),'Service_Notice': (getObjectProperty(item, 'Trailers_FI')),'Current_Mileage': (getObjectProperty(item, 'Diesel_FI')),'Distance_Traveled': (getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_TR_FI')) : 0,'Mileage_Target_Completion': (getObjectProperty(item, 'Toll_Fees_FI')),'Ideal_KM/L': (getObjectProperty(item, 'Salary/Wages_FI')),'Actual_KM/L': (getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_M_Plan_FI')) : 0,'Status': (getObjectProperty(item, 'MRH_FI')),'Fuel_Cost': (getObjectProperty(item, 'ATE_FI')),'Price_Per_Litre': (getObjectProperty(item, 'PTE_FI')),'Fuel_Cost_Per_Km': (getObjectProperty(item, 'Projected_Commission_FI')),'Gain/loss_Driving_Style': (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')),'Total_Tonnage': (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))) / (getObjectProperty(item, 'Distance'))))),'Litres_Filled': (getObjectProperty(item, 'Turnover_FI')),'Target_Tonnage_Completion': (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')),'Permissible_Tonnage': (getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))),'Average_Tonnage': (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')))) / (getObjectProperty(item, 'Distance'))))),'Gain/Loss_Loading': (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}),'Gain/Loss_Loading_MI': (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Loss_On_Mileage_In_Money'));}))), 0)).reduce(function(x, y) {return x + y;}),'Gain/Loss_Loading_TO': (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'GainLoss_On_Load'));}))), 0)).reduce(function(x, y) {return x + y;}),'License_Notice_T1_FI': undefined,'License_Notice_T2_FI': undefined,'License_Notice_T3_FI': undefined,'License_Notice_Trailers_FI': undefined,'Service_Warning_Duration_in_KM': undefined,'Service_Interval': undefined });})));
        ___arguments.context.appData['Profit/Loss_Gauge'] = (((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Monthly_Profit_Target'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all(Fleet_Item.map(async item => {; return (getObjectProperty(item, 'Gain/loss_Driving_Style'));}))).reduce(function(x, y) {return x + y;})) * 100);
        console.log('Update Complete');
      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/0a494c2bdc28dcb5e0ef52484a6bf63a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Full_Screen_Toggle')) == true) {
    await (async function() {
    	if (document.exitFullscreen) {
    	    document.exitFullscreen();
    	} else if (document.mozCancelFullScreen) {
    	    document.mozCancelFullScreen();
    	} else if (document.webkitCancelFullScreen) {
    	    document.webkitCancelFullScreen();
    	}
    })();
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85c7da063a6f9c66ab624f18d0cb5383'))['icon'] = 'fullscreen';
    ___arguments.context.pageData['Full_Screen_Toggle'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85c7da063a6f9c66ab624f18d0cb5383'))['color'] = 'Grey';
  } else {
    await (async function() {
    	function requestFullScreen(element) {
    	    // Supports most browsers and their versions.
    	    var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
    	
    	    if (requestMethod) { // Native full screen.
    	        requestMethod.call(element);
    	    } else if (typeof window.ActiveXObject !== "undefined") { // Older IE.
    	        var wscript = new ActiveXObject("WScript.Shell");
    	        if (wscript !== null) {
    	            wscript.SendKeys("{F11}");
    	        }
    	    }
    	}
    	
    	var elem = document.body; // Make the body go full screen.
    	requestFullScreen(elem);
    })();
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('85c7da063a6f9c66ab624f18d0cb5383'))['icon'] = 'fullscreen exit';
    ___arguments.context.pageData['Full_Screen_Toggle'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85c7da063a6f9c66ab624f18d0cb5383'))['color'] = 'Red';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/b69448c82fd6bc89b2f50688e22b195d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Maintainance_Hub_Mobile', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Maintenance_Hub_Web'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/bc1b16fdb3ab4893cbae1ca26086cd6e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Workshop_Block')) == true) {
    ___arguments.context.pageData['Workshop_Block'] = false;
  } else {
    ___arguments.context.pageData['Fleet_Overview_Block'] = false;
    ___arguments.context.pageData['Workshop_Block'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/5a11cc5819e1c10e1591e9b1e06db8f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Fleet_Overview_Block'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/ae8f7b669cf9e0f371d9b0715242f0cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Workshop_Block'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/31f1bed4b21736647349e158150c839d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Target_Select'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/0e38cdc2bd93f7edffe5a0bd9aee561b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Targets', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Targets'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/e30970ddae6ab67775e29d5f224faf37/bundle.js', [], () => ({
  /* content */
  /* handler:defaultValue */
  ['defaultValue'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'Star Rating - Stage 2')) * 1)

  },
  /* handler:defaultValue */
  /* content */
}))

define('./pages/Home/components/c5ddee9bc259b4ed38d2efff5a781c32/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Leave_Truck_Office', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Leave_Truck_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/4efd556c305b99e9efb934ca5ddf42f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DDP'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/f0fdd07e1e2f5b7b6a28ff74377c857f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DDM'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/e6b415024a47ae5ca6c9315ee0631549/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var error, User;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    User = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'displayName'));

  } catch (error) {

  } finally {
    if (error) {
      User = '';
    }

  }

  return User

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home/components/da4b110a9d6d9dfa9ff81c6d9927e346/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('CPK_Overview', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_CPK_Overview'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/4a17b607d14367c74bc988f17e44a562/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, NONESP_List, item, j, ESP_List, Passer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Push_Notifications() {
  await Backendless.Messaging.pushWithTemplate('Emergency', ({ [`Header`]: String('EMERGENCY - ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Currently_Aboard')),[`Message`]: [String('Driver: ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Name')),'   ',String('Contact: ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Name')),'   ',['Location: (Lat) ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lat')),' (Lng)',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lng'))].join(''),'','',''].join('') }));
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ESP_Locator() {
  try {
    ESP_List = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('AAA_EMERGENCY_SP_AAA', null));

  } catch (error) {
    console.log(error);

  }
  for (var j_index in ESP_List) {
    j = ESP_List[j_index];
    try {
      j['Distance'] = (await (async function(p1, p2) {
      	var rad = function(x) {
      	  return x * Math.PI / 180;
      	};

      	var R = 6378137; // Earth’s mean radius in meter
      	var dLat = rad(p2.lat - p1.lat);
      	var dLong = rad(p2.lng - p1.lng);
      	var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
      	var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      	var d = R * c;
      	return d;
      })(({ [`lat`]: (getObjectProperty((getObjectProperty(j, 'Location')), 'lat')),[`lng`]: (getObjectProperty((getObjectProperty(j, 'Location')), 'lng')) }), ({ [`lat`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lat')),[`lng`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lng')) })));

    } catch (error) {
      console.log(error);

    }
  }
  try {
    ___arguments.context.pageData['CESP'] = ((await asyncListSort(ESP_List, 1, async (item) => {


     return (getObjectProperty(item, 'Distance'));
    }))[0]);

  } catch (error) {
    console.log(error);

  }
  try {
    NONESP_List = (await Backendless.Request.get(`${Backendless.appPath}/services/MapAPIServices/DetailsPlace`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'Latitude': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lat')),'Longitude': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lng')),'Type': JSON.stringify('Ambulance'),'Radius': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CESP')), 'Distance')) }).send());

  } catch (error) {
    console.log(error);

  }
  try {
    for (var j_index2 in NONESP_List) {
      j = NONESP_List[j_index2];
      j['Distance'] = (await (async function(p1, p2) {
      	var rad = function(x) {
      	  return x * Math.PI / 180;
      	};

      	var R = 6378137; // Earth’s mean radius in meter
      	var dLat = rad(p2.lat - p1.lat);
      	var dLong = rad(p2.lng - p1.lng);
      	var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
      	var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      	var d = R * c;
      	return d;
      })(({ [`lat`]: (getObjectProperty((getObjectProperty(j, 'location')), 'lat')),[`lng`]: (getObjectProperty((getObjectProperty(j, 'location')), 'lng')) }), ({ [`lat`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lat')),[`lng`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lng')) })));
    }

  } catch (error) {
    console.log(error);

  }
  try {
    ___arguments.context.pageData['NONCESP'] = ((await asyncListSort(NONESP_List, 1, async (item) => {


     return (getObjectProperty(item, 'Distance'));
    }))[0]);

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'NONCESP'))['Phone'] = (await BackendlessUI.Functions.Custom['fn_9da8ac82c3ec900f5251d58b721f4ed3']((getObjectProperty((getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/MapAPIServices/GetPhoneNumberByPlaceID`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'PlaceId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'NONCESP')), 'place_id'))) }).send()), 'result')), 'formatted_phone_number')), '+27'));

  } catch (error) {
    console.log(error);

  }
  try {
    console.log(NONESP_List);

  } catch (error) {
    console.log(error);

  }
  try {
    console.log(getObjectProperty(___arguments.context.pageData, 'NONCESP'));

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function Emergeny_Data() {
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['L_REF'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_LOAD')), 'load_reference'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['L_CN'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_LOAD')), 'Customer_Name'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['L_LT'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_LOAD')), 'tonnage'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['L_LPLAN'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_LOAD')), 'Load_Planner'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['L_LP'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_LOAD')), 'load_point'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['L_DP'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_LOAD')), 'delivery_point'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['L_P'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_LOAD')), 'Product'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T1_Reg'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer1_Registration')), 'Trailer_Registration'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T1_ID'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer1_Registration')), 'Fleet_ID'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T1_VIN'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer1_Registration')), 'Vin'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T1_Make'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer1_Registration')), 'Make'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T1_Model'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer1_Registration')), 'Model'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T1_Year'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer1_Registration')), 'Year'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T1_Date'] = ((new Date((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer1_Registration')), 'License_Expirey_Date')))).toDateString());

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T1_Image'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer1_Registration')), 'Trailer_Image'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T2_Reg'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer2_Registration')), 'Trailer_Registration'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T2_ID'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer2_Registration')), 'Fleet_ID'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T2_VIN'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer2_Registration')), 'Vin'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T2_Make'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer2_Registration')), 'Make'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T2_Model'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer2_Registration')), 'Model'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T2_Year'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer2_Registration')), 'Year'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T2_Date'] = ((new Date((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer2_Registration')), 'License_Expirey_Date')))).toDateString());

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T2_Image'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer2_Registration')), 'Trailer_Image'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T3_Reg'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer3_Registration')), 'Trailer_Registration'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T3_ID'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer3_Registration')), 'Fleet_ID'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T3_VIN'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer3_Registration')), 'Vin'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T3_Make'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer3_Registration')), 'Make'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T3_Model'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer3_Registration')), 'Model'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T3_Year'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer3_Registration')), 'Year'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T3_Date'] = ((new Date((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer3_Registration')), 'License_Expirey_Date')))).toDateString());

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['T3_Image'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer3_Registration')), 'Trailer_Image'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['H_Reg'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Horse_Registration'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['H_VIN'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'VIN'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['H_ID'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Fleet_ID'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['H_ENG'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Engine_Number'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['H_Make'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Make'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['H_Model'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Model'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['H_Year'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Year'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['H_Pay'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Payload'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['G_Type'] = (getObjectProperty(___arguments.context.pageData, 'G_Type'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['H_Image'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Vehicle_Image'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['H_Date'] = ((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'License_Expiry_Date')))).toDateString());

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['G_Time'] = ([((new Date()).toLocaleTimeString()),'   ',((new Date()).toLocaleDateString()),' '].join(''));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['G_URL'] = (getObjectProperty(___arguments.context.pageData, 'EMERGENCY_GOOGLE_MAPS_URL'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['G_Address'] = (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_GOOGLE_GEOCODE')), 'results'))[0]), 'formatted_address'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['G_CoOrdinates'] = (['Location: (Lat) ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lat')),' (Lng)',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lng'))].join(''));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_Call_Sign'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Call_Sign'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_Cellphone_Number'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Cellphone_Number'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_Company_ID'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Company_ID'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_Currently_Aboard'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Currently_Aboard'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_ICE_NAME'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'ICE_NAME'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_ICE_Cellphone_Number'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'ICE_Cellphone_Number'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_ID_Attachment'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'ID_Attachment'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_ID_Number'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'ID_Number'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_License_Attachment'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'License_Attachment'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_License_Number'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'License_Number'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_Name'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Name'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_Medical_Aid_Name'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Medical_Aid_Name'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_Medical_Aid_Number'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Medical_Aid_Number'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['E_Profile_Photo'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Profile_Photo'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['D_Cellphone'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Cellphone'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['D_displayName'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'displayName'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['D_email'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'email'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_City'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'City'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_Company'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Company'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_Contact_Name'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Contact_Name'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_Email'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Contact_Email'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_Land_Line'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Land_Line'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_Company_Logo'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Company_Logo'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_Mobile'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Mobile'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_Emergency_Contact_Name'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Emergency_Contact_Name'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_Emergency_Contact_Number'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Emergency_Contact_Number'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_Postal_Address'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Postal_Address'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_Postal_Code'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Postal_Code'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['C_Registered_Name'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Registered_Name'));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['Emergeny_Location'] = (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lng'))).setY((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lat'))));

  } catch (error) {
    console.log(error);

  }
  try {
    (getObjectProperty(___arguments.context.appData, 'Emergeny_Data'))['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'ownerId'));

  } catch (error) {
    console.log(error);

  }
  console.log(getObjectProperty(___arguments.context.appData, 'Emergeny_Data'));
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Phone_List_Populator() {
  try {
    if (3 > getValueLength((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Emergeny_Data')), 'C_Mobile')))) {
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_PHONE_LIST')), (await BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Emergeny_Data')), 'C_Mobile')))));
    }

  } catch (error) {

  }
  try {
    if (3 > getValueLength((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Emergeny_Data')), 'D_Cellphone')))) {
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_PHONE_LIST')), (await BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Emergeny_Data')), 'D_Cellphone')))));
    }

  } catch (error) {

  }
  try {
    if (3 > getValueLength((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Emergeny_Data')), 'C_Emergency_Contact_Number')))) {
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_PHONE_LIST')), (await BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Emergeny_Data')), 'C_Emergency_Contact_Number')))));
    }

  } catch (error) {

  }
  try {
    if (3 > getValueLength((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CESP')), 'Emergency_Line')))) {
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_PHONE_LIST')), (await BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CESP')), 'Emergency_Line')))));
    }

  } catch (error) {

  }
  try {
    if (3 > getValueLength((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CESP')), 'Emergency_Cell_Line')))) {
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_PHONE_LIST')), (await BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CESP')), 'Emergency_Cell_Line')))));
    }

  } catch (error) {

  }
  try {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_PHONE_LIST')), '+27764810153');

  } catch (error) {

  }
}

/**
 * Describe this function...
 */
async function Email_List_Populator() {
  try {
    if (3 > getValueLength((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_LOAD_PLANNER')), 'email')))) {
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_EMAIL_LIST')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_LOAD_PLANNER')), 'email')));
    }

  } catch (error) {

  }
  try {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_EMAIL_LIST')), 'admin@fleetinform.com');

  } catch (error) {

  }
  try {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_EMAIL_LIST')), 'raymondewoodley@gmail.com');

  } catch (error) {

  }
  try {
    if (3 > getValueLength((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Emergency_Contact_Email')))) {
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_EMAIL_LIST')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'Details')), 'Emergency_Contact_Email')));
    }

  } catch (error) {

  }
  try {
    if (3 > getValueLength((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'email')))) {
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_EMAIL_LIST')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Employer')), 'email')));
    }

  } catch (error) {

  }
  try {
    if (3 > getValueLength((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CESP')), 'Email')))) {
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_EMAIL_LIST')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'CESP')), 'Email')));
    }

  } catch (error) {

  }
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

/**
 * Describe this function...
 */
async function PDF_Generation() {
  console.log(getObjectProperty(___arguments.context.appData, 'Emergeny_Data'));
  console.log('1223141');
  try {
    Passer = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'561339'}/data-output/${(['EMERGENY ','(',(generateUUID().long()),')'].join(''))}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': (getObjectProperty(___arguments.context.appData, 'Emergeny_Data')) }));

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function SMS_Protocol() {
  console.log(getObjectProperty(___arguments.context.pageData, 'EMERGENCY_PHONE_LIST'));
  console.log(getObjectProperty(Passer, 'fileUrl'));
  console.log(getObjectProperty(___arguments.context.pageData, 'EMERGENCY_GOOGLE_MAPS_URL'));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'EMERGENCY_PHONE_LIST'));
  for (var j_index3 in j_list) {
    j = j_list[j_index3];
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/Twilio/sendMessage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'phoneNumber': j,'message': (['To Whom it may concern,\n\n','An SOS has been activated. Please click the link below for the system generated SOS Report.\n\n',' \n\n',(getObjectProperty(Passer, 'fileUrl')),' \n\n Click the following link to open Google Maps\n\n',(getObjectProperty(___arguments.context.pageData, 'EMERGENCY_GOOGLE_MAPS_URL')),' \n\n','This SMS has been sent to all relevant parties as per our SOS Protocol. \n\n','Kind Regards,\n','The Fleet In Form Team'].join('')) });

    } catch (error) {
      console.log(error);

    }
  }
}

/**
 * Describe this function...
 */
async function Emails_Protocol() {
  await Backendless.Messaging.sendEmailFromTemplate('Emergency', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'EMERGENCY_EMAIL_LIST')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`H_REG`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Emergeny_Data')), 'H_Reg')),[`Maps`]: (getObjectProperty(___arguments.context.pageData, 'EMERGENCY_GOOGLE_MAPS_URL')),[`Report`]: (getObjectProperty(Passer, 'fileUrl')) }), undefined);
}

/**
 * Describe this function...
 */
async function Whattsapp() {
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'EMERGENCY_PHONE_LIST'));
  for (var j_index4 in j_list2) {
    j = j_list2[j_index4];
    console.log((await Backendless.Request.post(`${Backendless.appPath}/services/Twilio_WhatsApp/Send_WhatsApp`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'To': j,'Body': (['To Whom it may concern,',' \n\n','An SOS has been activated. Please click the link below for the system generated SOS Report.\n',(getObjectProperty(Passer, 'fileUrl')),' \n\n','Click the following link to open Google Maps\n',(getObjectProperty(___arguments.context.pageData, 'EMERGENCY_GOOGLE_MAPS_URL')),' \n\n','This email has been sent to all relevant parties as per our SOS Protocol.',' \n\n','Kind Regards,\n\n','The Fleet In Form Team'].join('')) })));
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'EMERGENY_COUNTER')) == 1) {
    ___arguments.context.pageData['Step 2'] = (((new Date()).valueOf()) * 1);
    if ((getObjectProperty(___arguments.context.pageData, 'Step 2')) - (getObjectProperty(___arguments.context.pageData, 'Step 1')) <= 15000) {
      console.log(getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_LOAD'));
      ___arguments.context.pageData['EMERGENY_COUNTER'] = 0;
      ___arguments.context.pageData['EMERGENCY_VIEWER'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4a17b607d14367c74bc988f17e44a562', false);
      await ESP_Locator();
      await Emergeny_Data();
      console.log(getObjectProperty(___arguments.context.appData, 'Emergeny_Data'));
      console.log('1');
      console.log(getObjectProperty(___arguments.context.appData, 'Emergeny_Data'));
      await new Promise(r => setTimeout(r, 8000 || 0));
      console.log(getObjectProperty(___arguments.context.appData, 'Emergeny_Data'));
      ___arguments.context.pageData['EMERGENCY_VIEWER'] = false;
      console.log(getObjectProperty(___arguments.context.appData, 'Emergeny_Data'));
      await PDF_Generation();
      console.log(getObjectProperty(___arguments.context.appData, 'Emergeny_Data'));
      console.log('2');
      await Email_List_Populator();
      console.log('3');
      await Phone_List_Populator();
      console.log('4');
      await SMS_Protocol();
      console.log('5');
      await Emails_Protocol();
      console.log('6');
      await Whattsapp();
      console.log('7');
    } else {
      ___arguments.context.pageData['EMERGENY_COUNTER'] = null;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'EMERGENY_COUNTER')) == 2) {
    ___arguments.context.pageData['Step 2'] = (((new Date()).valueOf()) * 1);
    if ((getObjectProperty(___arguments.context.pageData, 'Step 2')) - (getObjectProperty(___arguments.context.pageData, 'Step 1')) <= 10000) {
      ___arguments.context.pageData['EMERGENY_COUNTER'] = 1;
      ___arguments.context.pageData['EMERGENCY_EMAIL_LIST'] = [];
      ___arguments.context.pageData['EMERGENCY_PHONE_LIST'] = [];
      ___arguments.context.pageData['EMERGENCY_CURRENT_USER'] = (await Backendless.UserService.getCurrentUser(false));
      ___arguments.context.pageData['EMERGENCY_CURRENT_EMPLOYEE'] = ((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_USER')), 'objectId')),'\''].join(''))).setRelated(['Employer', 'Employer.Details', null]).setPageSize(10)))[0]);
      ___arguments.context.pageData['EMERGENCY_CURRENT_VEHICLE'] = ((await Backendless.Data.of('Vehicles ').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Currently_Aboard')),'\''].join(''))).setRelated(['Trailer1_Registration', 'Trailer2_Registration', 'Trailer3_Registration']).setPageSize(10)))[0]);
      try {
        ___arguments.context.pageData['EMERGENCY_CURRENT_LOAD'] = ((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_EMPLOYEE')), 'Currently_Aboard')),'\' AND Completion_Status = \'0\''].join(''))).setPageSize(10)))[0]);

      } catch (error) {

      } finally {
        if (error) {
          ___arguments.context.pageData['EMERGENCY_CURRENT_LOAD'] = ({ [`load_reference`]: 'None',[`Customer_Name`]: 'None',[`tonnage`]: 'None',[`Load_Planner`]: 'None',[`load_point`]: 'None',[`delivery_point`]: 'None',[`Product`]: 'None' });
        }

      }
      try {
        if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_LOAD')), 'tonnage')) == null) {
          ___arguments.context.pageData['EMERGENCY_CURRENT_LOAD'] = ({ [`load_reference`]: '-',[`Customer_Name`]: '-',[`tonnage`]: '-',[`Load_Planner`]: '-',[`load_point`]: '-',[`delivery_point`]: '-',[`Product`]: '-' });
        }

      } catch (error) {
        console.log(error);

      }
      try {
        ___arguments.context.pageData['EMERGENCY_CURRENT_LOAD_PLANNER'] = (await Backendless.Data.of('Users').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), '	 Load_Planner_objectId')), ));

      } catch (error) {

      }
      ___arguments.context.pageData['EMERGENCY_GOOGLE_GEOCODE'] = (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/GeoCode`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'currentPosition': JSON.stringify(([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lat')),',',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lng'))].join(''))) }).send());
      ___arguments.context.pageData['EMERGENCY_GOOGLE_MAPS_URL'] = (String('https://maps.google.com/?q=') + String([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lat')),',',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_LOCATION')), 'lng'))].join('')));
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer1_Reg')) == null) {
        (getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE'))['Trailer1_Registration'] = ({ [`Trailer_Registration`]: '-',[`Fleet_ID`]: '-',[`Vin`]: '-',[`Make`]: '-',[`Model`]: '-',[`Year`]: '-',[`License_Expirey_Date`]: '-',[`Trailer_Image`]: 'https://develop.backendless.com/CB411F83-2292-179C-FF6B-D25974153100/console/files/view/Profile%20Photos/NoImage.jpg' });
      }
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer2_Reg')) == null) {
        (getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE'))['Trailer2_Registration'] = ({ [`Trailer_Registration`]: '-',[`Fleet_ID`]: '-',[`Vin`]: '-',[`Make`]: '-',[`Model`]: '-',[`Year`]: '-',[`License_Expirey_Date`]: '-',[`Trailer_Image`]: 'https://develop.backendless.com/CB411F83-2292-179C-FF6B-D25974153100/console/files/view/Profile%20Photos/NoImage.jpg' });
      }
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE')), 'Trailer3_Reg')) == null) {
        (getObjectProperty(___arguments.context.pageData, 'EMERGENCY_CURRENT_VEHICLE'))['Trailer3_Registration'] = ({ [`Trailer_Registration`]: '-',[`Fleet_ID`]: '-',[`Vin`]: '-',[`Make`]: '-',[`Model`]: '-',[`Year`]: '-',[`License_Expirey_Date`]: '-',[`Trailer_Image`]: 'https://develop.backendless.com/CB411F83-2292-179C-FF6B-D25974153100/console/files/view/Profile%20Photos/NoImage.jpg' });
      }
      ___arguments.context.appData['Emergeny_Data'] = ({ [`Initiated`]: 1 });
    } else {
      ___arguments.context.pageData['EMERGENY_COUNTER'] = null;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'EMERGENY_COUNTER')) == null) {
    ___arguments.context.pageData['EMERGENCY_LOCATION'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
    ___arguments.context.pageData['EMERGENY_COUNTER'] = 2;
    ___arguments.context.pageData['EMERGENCY_CURRENT_LOAD'] = ({ [`load_reference`]: 'None',[`Customer_Name`]: 'None',[`tonnage`]: 'None',[`Load_Planner`]: 'None',[`load_point`]: 'None',[`delivery_point`]: 'None',[`Product`]: 'None' });
    ___arguments.context.pageData['Step 1'] = (((new Date()).valueOf()) * 1);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/2fd4f8744057b2c3b9c416dd76c5fcc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == false) {
    ___arguments.context.pageData['WS_Hamburger_View'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2fd4f8744057b2c3b9c416dd76c5fcc9'))['icon'] = 'menu open';
  } else {
    ___arguments.context.pageData['WS_Hamburger_View'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2fd4f8744057b2c3b9c416dd76c5fcc9'))['icon'] = 'menu';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/d585ad5571d9ca1958d39f88357df388/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == false) {
    Viewer = false;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Driver_Block_1')) == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/8774b813ba8d9998e19d4fb5c15e150c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == false) {
    Viewer = false;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Driver_Block_2')) == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/8b480d6e1a55cddfa5c69531c1feb3b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == false) {
    Viewer = false;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Driver_Block_3')) == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/9107cad46874960e039c05f297b68daf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/7eba144a65254059337d54939ce89ea7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/c5c71623d212c702a8085394f218007c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/cf92e1a8d8fc3fefef4caa4505c480e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/f7ba66056edce3a7530cec1563558b61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View1')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View1')) == false) {
    ___arguments.context.pageData['WS_Hamburger_View1'] = true;
  } else {
    ___arguments.context.pageData['WS_Hamburger_View1'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/d11124e5dc6a60c1073cd63a409afb11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/3efd3531d912b50fe8bece2d659a1815/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Workshop_M_Block')) == true) {
    ___arguments.context.pageData['Workshop_M_Block'] = false;
  } else {
    ___arguments.context.pageData['Workshop_M_Block'] = true;
    ___arguments.context.pageData['Fleet_Overview_M_Block'] = false;
    ___arguments.context.pageData['Target_M_Block'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/ce2f48e5c0aab9516b984ca16a77c6b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Workshop_M_Block'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/548bedfbf93eb68bd56fe5db0be4649f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Fleet_Item, Tonnage_Total, Tyre, error, Driver_Filter, Salary, Loads, Value, Start_Date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'Live_Updater')) == true) {
    ___arguments.context.pageData['Live_Updater'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4ccf824b11cdfa8c989cf3c27fe7f0fb'))['color'] = 'Grey';
  } else {
    ___arguments.context.pageData['Live_Updater'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4ccf824b11cdfa8c989cf3c27fe7f0fb'))['color'] = 'Red';
    while ((getObjectProperty(___arguments.context.pageData, 'Live_Updater')) == true) {
      await new Promise(r => setTimeout(r, 300000 || 0));
      if ((getObjectProperty(___arguments.context.pageData, 'Live_Updater')) == true) {
        console.log('Updating');
        Start_Date = (new Date());
        Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
        Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
        Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
        Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
        Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
        ___arguments.context.pageData['Start_Date'] = Start_Date;
        ___arguments.context.pageData['End_Date'] = (new Date());
        ___arguments.context.appData['Vehicles_Of_Concern'] = ((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  item['Fuel_Cons'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}));
        ; return ((getObjectProperty(item, 'Ideal_Fuel_Consumption')) * 0.95 < (getObjectProperty(item, 'Fuel_Cons')) ? 0 : 1);}))).reduce(function(x, y) {return x + y;}));
        ___arguments.context.appData['Tonnage_Completion_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (((((getObjectProperty(item, 'Monthly_Tonnage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate())) / (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})) * 100 == Infinity ? 0 : ((((getObjectProperty(item, 'Monthly_Tonnage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate())) / (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})) * 100);}))))));
        ___arguments.context.appData['Payload_Gauge'] = (mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (await BackendlessUI.Functions.Custom['fn_73996a4c829e78cd078929cb97ed2201']((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Tonnage_Ratio'));})))));}))) * 100);
        ___arguments.context.appData['Mileage_Completion_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  Value = ((((getObjectProperty(item, 'Monthly_Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate())) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;})) * 100 == Infinity ? 0 : ((((getObjectProperty(item, 'Monthly_Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate())) / (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;})) * 100;
        ; return ((typeof Value === 'number' && !isNaN(Value)) ? Value : 0);}))))));
        ___arguments.context.appData['Total_Gain/Loss_Loading'] = ((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}));
        ___arguments.context.appData['Total_Gain/Loss_Driving_style'] = ((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setSortBy('created desc').setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_Driving_Style'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}));
        ___arguments.context.appData['Diesel_Vs_Turnover_Gauge'] = (((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\' AND Completion_Status = \'1\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})) * 100);
        ___arguments.context.appData['Consumption_Status_Gauge'] = (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((mathMean(await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Ideal_Fuel_Consumption'));}))) / ((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Vehicle_Registration')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''))).setPageSize(100))).map(async Loads => {; return (getObjectProperty(Loads, 'litres'));}))), 0)).reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})))))) * 100)));
        Salary = (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employer.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Name': (getObjectProperty(item, 'Name')),'Call_Sign': (getObjectProperty(item, 'Call_Sign')),'Employee_Details': item,'Basic_Salary': (getObjectProperty(item, 'Basic_Salary')),'Contractor_Km_Payment': (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),'GD_Payment': (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),'Contractor_Tonnage_Pay': (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),'Tonnage_Target_Pay': (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),'Total': (getObjectProperty(item, 'Basic_Salary')) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND updated > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND updated < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) });})));
        Fleet_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {  item['Distance'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['Targets'] = ((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Vehicle_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(10)))[0]);
          item['Horse_FI'] = ((getObjectProperty(item, 'Depreciation')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Fixed_Monthly_Sundry_Fee')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Tracking_Fee')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);
          item['Trailers_FI'] = (((getObjectProperty(item, 'Trailer1_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setPageSize(10))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer2_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setPageSize(10))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0) + ((getObjectProperty(item, 'Trailer3_Reg')) != null ? (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setPageSize(10))).map(async item => {; return ((getObjectProperty(item, 'Tracking')) + (getObjectProperty(item, 'Monthly_Depreciation')) + (getObjectProperty(item, 'Insurance_Premium')) + (getObjectProperty(item, 'Installment')) + (getObjectProperty(item, 'Fixed_Maintenance_Plan_Cost')) + (getObjectProperty(item, 'Annual_License_Fee')) / 12);})))[0] : 0));
          item['Diesel_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['Per_Km_TR_FI'] = ((getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_Toll_Rate_R')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);
          item['Toll_Fees_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Type = \'Toll\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
          try {
            item['Salary/Wages_FI'] = (getObjectProperty(((await asyncListFilter(Salary, async (Driver_Filter) => {


             return ((getObjectProperty(item, 'Current_Driver')) == (getObjectProperty(Driver_Filter, 'Call_Sign')));
            }))[0]), 'Total'));

          } catch (error) {
            if (error) {
              item['Salary/Wages_FI'] = 0;
            }

          }
          item['Per_Km_M_Plan_FI'] = ((getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Maintenance_Plan_Rate_per_Km')) * (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}) : 0);
          item['MRH_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Horse = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Repairs_Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration_Trailer_1 = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Cost'));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['ATE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Current_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['PTE_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer1_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer2_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Trailer3_Reg')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async Tyre => {; return ((getObjectProperty(Tyre, 'Expected_CPK')) * (getObjectProperty(item, 'Distance')));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['Projected_Commission_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939'](((getObjectProperty(Tonnage_Total, 'Load_Value')) * (1 + (getObjectProperty((getObjectProperty(item, 'Targets')), 'Commission_Rate')) / 100) - (getObjectProperty(Tonnage_Total, 'Load_Value')))));}))), 0)).reduce(function(x, y) {return x + y;}));
          item['Turnover_FI'] = ((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async Tonnage_Total => {; return (getObjectProperty(Tonnage_Total, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;}));
        ; return ({ 'objectId': (getObjectProperty(item, 'objectId')),'Horse_Registration': (getObjectProperty(item, 'Fleet_ID')),'Horse_ID': (getObjectProperty(item, 'Horse_Registration')),'License_Notice_FI': (getObjectProperty(item, 'Trailer1_Reg')),'License_PDP_FI': (getObjectProperty(item, 'Trailer2_Reg')),'Trailer_3_FI': (getObjectProperty(item, 'Trailer3_Reg')),'Driver_1': (getObjectProperty(item, 'Horse_FI')),'Service_Notice': (getObjectProperty(item, 'Trailers_FI')),'Current_Mileage': (getObjectProperty(item, 'Diesel_FI')),'Distance_Traveled': (getObjectProperty(item, 'Per_Km_Toll_Rate')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_TR_FI')) : 0,'Mileage_Target_Completion': (getObjectProperty(item, 'Toll_Fees_FI')),'Ideal_KM/L': (getObjectProperty(item, 'Salary/Wages_FI')),'Actual_KM/L': (getObjectProperty(item, 'Per_Km_Maintenance_Plan')) == 'Yes' ? (getObjectProperty(item, 'Per_Km_M_Plan_FI')) : 0,'Status': (getObjectProperty(item, 'MRH_FI')),'Fuel_Cost': (getObjectProperty(item, 'ATE_FI')),'Price_Per_Litre': (getObjectProperty(item, 'PTE_FI')),'Fuel_Cost_Per_Km': (getObjectProperty(item, 'Projected_Commission_FI')),'Gain/loss_Driving_Style': (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')),'Total_Tonnage': (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))) / (getObjectProperty(item, 'Distance'))))),'Litres_Filled': (getObjectProperty(item, 'Turnover_FI')),'Target_Tonnage_Completion': (getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')),'Permissible_Tonnage': (getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI'))),'Average_Tonnage': (getObjectProperty(item, 'Distance')) == 0 ? 0 : (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(item, 'Turnover_FI')) - ((getObjectProperty((getObjectProperty(item, 'Targets')), 'Monthly_Profit_Target')) + (getObjectProperty(item, 'Salary/Wages_FI')) + (getObjectProperty(item, 'Projected_Commission_FI')) + (getObjectProperty(item, 'PTE_FI')) + (getObjectProperty(item, 'ATE_FI')) + (getObjectProperty(item, 'MRH_FI')) + (getObjectProperty(item, 'Per_Km_M_Plan_FI')) + (getObjectProperty(item, 'Toll_Fees_FI')) + (getObjectProperty(item, 'Per_Km_TR_FI')) + (getObjectProperty(item, 'Diesel_FI')) + (getObjectProperty(item, 'Trailers_FI')) + (getObjectProperty(item, 'Horse_FI')))) / (getObjectProperty(item, 'Distance'))))),'Gain/Loss_Loading': (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Gain_Loss_On_loading'));}))), 0)).reduce(function(x, y) {return x + y;}),'Gain/Loss_Loading_MI': (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Loss_On_Mileage_In_Money'));}))), 0)).reduce(function(x, y) {return x + y;}),'Gain/Loss_Loading_TO': (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'GainLoss_On_Load'));}))), 0)).reduce(function(x, y) {return x + y;}),'License_Notice_T1_FI': undefined,'License_Notice_T2_FI': undefined,'License_Notice_T3_FI': undefined,'License_Notice_Trailers_FI': undefined,'Service_Warning_Duration_in_KM': undefined,'Service_Interval': undefined });})));
        ___arguments.context.appData['Profit/Loss_Gauge'] = (((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Monthly_Profit_Target'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all(Fleet_Item.map(async item => {; return (getObjectProperty(item, 'Gain/loss_Driving_Style'));}))).reduce(function(x, y) {return x + y;})) * 100);
        console.log('Update Complete');
      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/fdaeeabc62745b4218e7575e6cc29beb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View2')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View2')) == false) {
    ___arguments.context.pageData['WS_Hamburger_View2'] = true;
  } else {
    ___arguments.context.pageData['WS_Hamburger_View2'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/a8ca10214fd3bd4bd37265c343454d1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/2ea810921886c9e7056af8d3ec56fd5b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Target_M_Block'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/d16ec29ca8e3bf618b3d16b680cafcf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Fleet_Overview_M_Block'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/c86b69f2c78714ac685bbeadb39f3553/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Targets', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/60b130fc366c637ee33301c173532dbb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Fleet_Overview', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Fleet_Overview'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/cc7740ab4b8fbd3b539c2193d2b59e0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Financial_Overview', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Financial_Overview'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/658edb6c363fd67dd416d8c6bcdf3977/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('CPK_Overview', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_CPK_Overview'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/760ee7aebbdfd98cf31e85351b663fcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Broker_Overview', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Broker_Overview'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/1aff4284145f08ae1f55bd48660d34c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Salary_Overview', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Salary_Overview'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/d7435c6b2662c194d021d96fa9bfc7e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Maintainance_Hub_Mobile', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Maintenance_Hub_Web'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/c3e940f2d11ac61b62242f782983ff46/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Board_Truck_Office', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Board_Truck_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/e7f6584c90c27f0b004407cb14f2db51/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Leave_Truck_Office', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Leave_Truck_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/ae11cbe80546e2788b39fdcbb9b2ceb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser;


  await Backendless.UserService.logout();
  ___arguments.context.appData['currentUser'] = currentUser;
  ___arguments.context.appData['DashLoad'] = undefined;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/c2c42a6a6f61750b852c15fbd8c819fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Driver_Block_1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/e3acc5a85c4da1714373f00a9a74da13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AA_Home_Page_Icon_View'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/00eed42c6fbb3dca0f5e29155a36882d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AA_Rated_Driver'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/2892fe4319178db48ce858865eb5a099/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Load_Planner', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Load_Planner'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/2fd24762ab0e3cca2e6a8cfb8c06b617/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Load_Planner', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Load_Planner'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/1f4a5cbda1625626259210374bc3a7bb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Swap_Trailer_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Swap_Trailer_Office', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/13b68993e0947bd43c41449bde212492/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Swap_Trailer_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Swap_Trailer_Office', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/f42b84defdde8ce690b5c77ff89bd99e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUser;


  await Backendless.UserService.logout();
  ___arguments.context.appData['currentUser'] = currentUser;
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/38f7fc5d3a6afd66e4e83da3fd29a2bb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'EMERGENY_COUNTER')) == 1) {
    Value = 'Final Press';
  } else if ((getObjectProperty(___arguments.context.pageData, 'EMERGENY_COUNTER')) == 2) {
    Value = 'Press 2X';
  } else if ((getObjectProperty(___arguments.context.pageData, 'EMERGENY_COUNTER')) == null) {
    Value = 'Press 3X';
  }

  return Value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home/components/73d798c2c87239eae787717d1cda85a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_VIEWER')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['EMERGENCY_VIEWER'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/cb1cbdac7da6a9bb94ef1cbca6166a56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['G_Type'] = 'ACCIDENT';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/b086829924f57e27966dbf7c03fcfe2f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['G_Type'] = 'HI-JACKING';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/25ff6fb6e2982c06d6c8ee0f0694fbe6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['G_Type'] = 'RIOTING';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home/components/9d2c98e6b36e8e08dc039eacbcb764eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Load, Location, Next_Load;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'Status')) == 'Loaded') {
    Next_Load = String('Delivery At ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'delivery_point'));
    Load = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'delivery_point'));
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'Service')) == null) {
      Next_Load = String('Load At ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'load_point'));
      Load = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'load_point'));
    } else {
      Next_Load = String('Service At ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'load_point'));
      Load = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Next_Load')), 'load_point'));
    }
  }
  console.log(Load);
  Location = (await Backendless.Data.of('Locations').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name = \'',Load,'\''].join(''))).setPageSize(10)))[0];
  ___arguments.context.pageData['EMERGENCY_GOOGLE_MAPS_URL'] = (String('https://maps.google.com/?q=') + String([(getObjectProperty((getObjectProperty(Location, 'Point')), 'lng')),',',(getObjectProperty((getObjectProperty(Location, 'Point')), 'lat'))].join('')));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'EMERGENCY_GOOGLE_MAPS_URL')), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_Truck')), 'Truck_Planning')) == 'Unplanned') {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/6357850494fda9946dc28b91fa7b8acb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Farming_Log'] = true;
  ___arguments.context.pageData['Fuel_Log'] = false;
  ___arguments.context.pageData['Bowser_Fill'] = false;
  ___arguments.context.pageData['Off_Farm_Fill'] = false;
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('27798fcc551708a11664a57df5c1b148', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Registration')) });}))));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Agri_Farm_Log')) == 'Yes') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/409d6215ae2d7af881770dfd80586f4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Farming_Log'] = false;
  ___arguments.context.pageData['Fuel_Log'] = true;
  ___arguments.context.pageData['Bowser_Fill'] = false;
  ___arguments.context.pageData['Off_Farm_Fill'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/4e98c525428e65f29aac6cc98a1b2dbd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Farming_Log')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/928735f5c04993fdd92b6ba83d46797c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Farming_Log'] = false;
  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Farm Log Contractor Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Driver'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Field'] = undefined;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('81590f8bda445fb6adcd5f84c5ec28c6', '0');
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('067de303ac1732acd194b2c1c74a1f5e', undefined);
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('27798fcc551708a11664a57df5c1b148', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/1b5787c603efdd6de5a7399f24f98b67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Farming_Log'] = false;
  ___arguments.context.pageData['Fuel_Log'] = false;
  ___arguments.context.pageData['Bowser_Fill'] = true;
  ___arguments.context.pageData['Off_Farm_Fill'] = false;
  ___arguments.context.pageData['Bowser_List'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Bowsers')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Name')) });})));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('501e88832cff8c7c791267c62931cb52', (getObjectProperty(___arguments.context.pageData, 'Bowser_List')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/4d63ed324d51bc39dcdfa25b39ea42de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Bowser_Fill')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/853e62e947ea12faebdf8318939b8f3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Bowser'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Litres'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Meter'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Supplier'] = undefined;
  ___arguments.context.pageData['Bowser_Fill'] = false;
  ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Incomplete Fields'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/5c3e5813b7b29e944653d456dc8663df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Boswer_Price, Bowser, Bowser_Drain, Bowser_Fill, Bowser_Supply, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c3e5813b7b29e944653d456dc8663df', false);
  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Bowser')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Litres')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Meter')) === 'undefined')) {
    ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Incomplete Fields'] = true;
  } else {
    Bowser = (await Backendless.Data.of('AGRI_Bowsers').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Bowser')), ));
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ce5aef1d38e283e2d55550cc7f662554')) == 'Delivery' || ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ce5aef1d38e283e2d55550cc7f662554')) == 'Garage') {
    } else {
      try {
        Bowser_Supply = (await Backendless.Data.of('AGRI_Bowsers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ce5aef1d38e283e2d55550cc7f662554')), ));

      } catch (error) {
        console.log(error);

      } finally {
        if (error) {
          Bowser_Supply = null;
        }

      }
      try {
        Boswer_Price = (getObjectProperty(((await Backendless.Data.of('AGRI_Bowser_Fills').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' AND Bowser = \'',(getObjectProperty(Bowser_Supply, 'Name')),'\''].join(''))).setSortBy('created desc').setPageSize(10)))[0]), 'R_Per_Litre'));

      } catch (error) {
        console.log(error);

      }
      try {
        Bowser_Fill = ({ [`Bowser`]: (getObjectProperty(Bowser, 'Name')),[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Litres')) * Boswer_Price,[`Company`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),[`Delivery`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Document')),[`Litres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Litres')),[`Meter`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Meter')),[`Supplier`]: (getObjectProperty(Bowser_Supply, 'Name')),[`Captured_By`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'displayName')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')) });

      } catch (error) {
        console.log(error);

      }
      try {
        Bowser_Drain = ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Litres')) * -1 * Boswer_Price,[`Bowser`]: (getObjectProperty(Bowser, 'Name')),[`Company`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),[`Litres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Litres')) * -1,[`Meter`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Supplying Bowser Meter')),[`Supplier`]: undefined,[`Captured_By`]: undefined,[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')) });

      } catch (error) {
        console.log(error);

      } finally {
        if (error) {
          Bowser_Drain = null;
        }

      }
      try {
        Bowser_Supply['Litres'] = ((getObjectProperty(Bowser_Supply, 'Litres')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Litres')));
        Bowser_Supply['Meter'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Supplying Bowser Meter'));
        await Backendless.Data.of('AGRI_Bowsers').save( Bowser_Supply );

      } catch (error) {
        console.log(error);

      }
      try {
        await Backendless.Data.of('AGRI_Bowser_Fills').save( Bowser_Drain );

      } catch (error) {
        console.log(error);

      }
    }
    console.log(getObjectProperty(Bowser, 'Name'));
    Bowser_Fill = ({ [`Bowser`]: (getObjectProperty(Bowser, 'Name')),[`Company`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),[`Delivery`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Document')),[`Litres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Litres')),[`Meter`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Meter')),[`Supplier`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Supplier')),[`Captured_By`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'displayName')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')) });
    Bowser['Litres'] = ((getObjectProperty(Bowser, 'Litres')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Litres')));
    Bowser['Meter'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Meter'));
    await Backendless.Data.of('AGRI_Bowser_Fills').save( Bowser_Fill );
    await Backendless.Data.of('AGRI_Bowsers').save( Bowser );
    ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Bowser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Litres'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Meter'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Supplier'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Document'] = false;
    ___arguments.context.pageData['Bowser_Fill'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, item, User_Level;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Login_Procedure() {
  ___arguments.context.pageData['Director_User'] = (await Backendless.Data.of('Users').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')), ));
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Director_User')), 'userStatus')) == 'DISABLED') {
    ___arguments.context.pageData['Blocked'] = true;
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  User_Level = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'User_level'));
}


  if ((getObjectProperty(___arguments.context.appData, 'Selected Cusomer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.appData, 'Selected Cusomer'))) && (typeof (getObjectProperty(___arguments.context.appData, 'Selected Cusomer')) === 'object')) {
    ___arguments.context.pageData['Start Date'] = (await BackendlessUI.Functions.Custom['fn_424c6f8b8fa9ba1fc714c1e2f3a1d685']());
    ___arguments.context.pageData['End Date'] = (new Date((new Date()).getTime() + (86400 * 1000)));
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Bowsers - View'] = false;
    currentUser = (await Backendless.UserService.getCurrentUser(true));
    ___arguments.context.pageData['User'] = currentUser;
    ___arguments.context.pageData['Applications - Drop down '] = (await asyncListSort([({ [`value`]: 'Vehicle - Farm',[`label`]: 'Vehicle - Farm' }), ({ [`value`]: 'General - Farm Work',[`label`]: 'General - Farm Work' }), ({ [`value`]: 'Fuel Transaction',[`label`]: 'Fuel Transaction' }), ({ [`value`]: 'Planting - Pasture',[`label`]: 'Planting - Pasture' }), ({ [`value`]: 'Planting - Crops',[`label`]: 'Planting - Crops' }), ({ [`value`]: 'Ripping - Pasture',[`label`]: 'Ripping - Pasture' }), ({ [`value`]: 'Ripping - Crops',[`label`]: 'Ripping - Crops' }), ({ [`value`]: 'Discing - Pasture',[`label`]: 'Discing - Pasture' }), ({ [`value`]: 'Discing - Crops',[`label`]: 'Discing - Crops' }), ({ [`value`]: 'Airating',[`label`]: 'Airating' }), ({ [`value`]: 'Fertiliser - Crop',[`label`]: 'Fertiliser - Crop' }), ({ [`value`]: 'Fertiliser - Pasture',[`label`]: 'Fertiliser - Pasture' }), ({ [`value`]: 'Liming - Crop',[`label`]: 'Liming - Crop' }), ({ [`value`]: 'Liming - Pasture',[`label`]: 'Liming - Pasture' }), ({ [`value`]: 'Silage - Harvesting',[`label`]: 'Silage - Harvesting' }), ({ [`value`]: 'Silage - Feeding',[`label`]: 'Silage - Feeding' }), ({ [`value`]: 'Spraying - Crops',[`label`]: 'Spraying - Crops' }), ({ [`value`]: 'Spraying Pasture',[`label`]: 'Spraying Pasture' }), ({ [`value`]: 'Trailer Work',[`label`]: 'Trailer Work' }), ({ [`value`]: 'Fire Breaks',[`label`]: 'Fire Breaks' }), ({ [`value`]: 'Road Works',[`label`]: 'Road Works' }), ({ [`value`]: 'Baling',[`label`]: 'Baling' }), ({ [`value`]: 'Livestock Feeding ',[`label`]: 'Livestock Feeding ' }), ({ [`value`]: 'Bomford/Rotavator',[`label`]: 'Bomford/Rotavator' }), ({ [`value`]: 'Land Rolling',[`label`]: 'Land Rolling' })], 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    }));
    ___arguments.context.pageData['Bowsers'] = (await Backendless.Data.of('AGRI_Bowsers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(currentUser, 'ownerId')),'\''].join(''))).setPageSize(100)));
    ___arguments.context.pageData['Bowser_List'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Bowsers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
    ___arguments.context.pageData['Vehicles'] = (await Backendless.Data.of('AGRI_Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(currentUser, 'ownerId')),'\''].join(''))).setPageSize(100)));
    ___arguments.context.pageData['Company'] = ((await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(currentUser, 'ownerId')),'\''].join(''))).setRelated(['AGRI_Contractors', 'AGRI_Clients']).setRelationsPageSize(100).setPageSize(100)))[0]);
    if (getObjectProperty(___arguments.context.pageData, 'User')) {
      await Login_Procedure();
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'User_level')) == 'Director') {
        ___arguments.context.pageData['Director_View'] = true;
        ___arguments.context.pageData['Hamburger'] = true;
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu open';
      } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'User_level')) == 'Bowser') {
        ___arguments.context.pageData['Bowser_View'] = true;
      }
    } else {
      await Backendless.UserService.logout();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
    }
  } else {
    if ((await Backendless.UserService.isValidLogin()) == false) {
      await Backendless.UserService.logout();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
    } else {
      ___arguments.context.pageData['Start Date'] = (await BackendlessUI.Functions.Custom['fn_424c6f8b8fa9ba1fc714c1e2f3a1d685']());
      ___arguments.context.pageData['End Date'] = (new Date((new Date()).getTime() + (86400 * 1000)));
      ___arguments.context.pageData['Fuel - View'] = false;
      ___arguments.context.pageData['Bowser Fuel - View'] = false;
      ___arguments.context.pageData['Vehicles - View'] = false;
      ___arguments.context.pageData['Bowsers - View'] = false;
      currentUser = (await Backendless.UserService.getCurrentUser(true));
      ___arguments.context.pageData['User'] = currentUser;
      ___arguments.context.pageData['Applications - Drop down '] = (await asyncListSort([({ [`value`]: 'Vehicle - Farm',[`label`]: 'Vehicle - Farm' }), ({ [`value`]: 'General - Farm Work',[`label`]: 'General - Farm Work' }), ({ [`value`]: 'Fuel Transaction',[`label`]: 'Fuel Transaction' }), ({ [`value`]: 'Planting - Pasture',[`label`]: 'Planting - Pasture' }), ({ [`value`]: 'Planting - Crops',[`label`]: 'Planting - Crops' }), ({ [`value`]: 'Ripping - Pasture',[`label`]: 'Ripping - Pasture' }), ({ [`value`]: 'Ripping - Crops',[`label`]: 'Ripping - Crops' }), ({ [`value`]: 'Discing - Pasture',[`label`]: 'Discing - Pasture' }), ({ [`value`]: 'Discing - Crops',[`label`]: 'Discing - Crops' }), ({ [`value`]: 'Airating',[`label`]: 'Airating' }), ({ [`value`]: 'Fertiliser - Crop',[`label`]: 'Fertiliser - Crop' }), ({ [`value`]: 'Fertiliser - Pasture',[`label`]: 'Fertiliser - Pasture' }), ({ [`value`]: 'Liming - Crop',[`label`]: 'Liming - Crop' }), ({ [`value`]: 'Liming - Pasture',[`label`]: 'Liming - Pasture' }), ({ [`value`]: 'Silage - Harvesting',[`label`]: 'Silage - Harvesting' }), ({ [`value`]: 'Silage - Feeding',[`label`]: 'Silage - Feeding' }), ({ [`value`]: 'Spraying - Crops',[`label`]: 'Spraying - Crops' }), ({ [`value`]: 'Spraying Pasture',[`label`]: 'Spraying Pasture' }), ({ [`value`]: 'Trailer Work',[`label`]: 'Trailer Work' }), ({ [`value`]: 'Fire Breaks',[`label`]: 'Fire Breaks' }), ({ [`value`]: 'Road Works',[`label`]: 'Road Works' }), ({ [`value`]: 'Baling',[`label`]: 'Baling' }), ({ [`value`]: 'Livestock Feeding ',[`label`]: 'Livestock Feeding ' }), ({ [`value`]: 'Bomford/Rotavator',[`label`]: 'Bomford/Rotavator' }), ({ [`value`]: 'Land Rolling',[`label`]: 'Land Rolling' })], 1, async (item) => {


       return (getObjectProperty(item, 'label'));
      }));
      ___arguments.context.pageData['Bowsers'] = (await Backendless.Data.of('AGRI_Bowsers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(currentUser, 'ownerId')),'\''].join(''))).setPageSize(100)));
      ___arguments.context.pageData['Bowser_List'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Bowsers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
      ___arguments.context.pageData['Vehicles'] = (await Backendless.Data.of('AGRI_Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(currentUser, 'ownerId')),'\''].join(''))).setPageSize(100)));
      ___arguments.context.pageData['Company'] = ((await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(currentUser, 'ownerId')),'\''].join(''))).setRelated(['AGRI_Contractors', 'AGRI_Clients']).setRelationsPageSize(100).setPageSize(100)))[0]);
      if (getObjectProperty(___arguments.context.pageData, 'User')) {
        await Login_Procedure();
        if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'User_level')) == 'Director') {
          ___arguments.context.pageData['Director_View'] = true;
          ___arguments.context.pageData['Hamburger'] = true;
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu open';
        } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'User_level')) == 'Bowser') {
          ___arguments.context.pageData['Bowser_View'] = true;
        }
      } else {
        await Backendless.UserService.logout();
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
      }
    }
  }

  },
  /* handler:onEnter */
  /* handler:onResize */
  async ['onResize'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Director_View() {
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2ebacddce83d80af215214a5744acc4'))['height'] = (___arguments.screenHeight - 20);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2ebacddce83d80af215214a5744acc4'))['width'] = (___arguments.screenWidth - 20);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6ce6480812891b7b1464c22ad9bbb721'))['height'] = (___arguments.screenHeight - 110);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6ce6480812891b7b1464c22ad9bbb721'))['width'] = (___arguments.screenWidth - 40);
  if ((getObjectProperty(___arguments.context.pageData, 'Bowsers - View')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bd45b2d199a6da97a32c32ae38de0cee'))['height'] = (___arguments.screenHeight - 130);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bd45b2d199a6da97a32c32ae38de0cee'))['width'] = (___arguments.screenWidth - 30);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Bowser Fuel - View')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3b18a6fbfb7bcf8ceacbf01d3c165034'))['height'] = (___arguments.screenHeight - 210);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3b18a6fbfb7bcf8ceacbf01d3c165034'))['width'] = (___arguments.screenWidth - 60);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Fuel - View')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb'))['height'] = (___arguments.screenHeight - 210);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb'))['width'] = (___arguments.screenWidth - 60);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Vehicles - View')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e48552e818a1ad85a3339b776f2795c'))['height'] = (___arguments.screenHeight - 130);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e48552e818a1ad85a3339b776f2795c'))['width'] = (___arguments.screenWidth - 30);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Farm - View')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce314058f79b19c76c3bcff9c66b1684'))['height'] = (___arguments.screenHeight - 210);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce314058f79b19c76c3bcff9c66b1684'))['width'] = (___arguments.screenWidth - 60);
  }
}


  await Director_View();

  },
  /* handler:onResize */
  /* content */
}))

define('./pages/Home_Agri/components/070929dfe4eec17757bb1ecf4bfbde93/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/eaaebcd2586894c8dd2f5de60f9ab278/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Incomplete Fields')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/07254abfbbeea79a58847a7d760f2213/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Fuel - View')) == true) {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
  } else {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = true;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    await new Promise(r => setTimeout(r, 2000 || 0));
    ___arguments.context.pageData['Fuel Totals'] = ({ [`Cost`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;})))),[`Litres`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Litres'));}))).reduce(function(x, y) {return x + y;})))),[`Meter_Diff`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Meter_Diff'));}))).reduce(function(x, y) {return x + y;})))),[`Mileage_Diff`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Mileage_Diff'));}))).reduce(function(x, y) {return x + y;})))),[`Rebate`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Rebate'));}))).reduce(function(x, y) {return x + y;})))) });
    console.log(getObjectProperty(___arguments.context.pageData, 'Fuel Totals'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/d474e6045d5dfdca4143cf5a2c2a14b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Vehicles - View')) == true) {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
  } else {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = true;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('7e48552e818a1ad85a3339b776f2795c');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/6f42eab4508bccf21a7f4eb122e7670f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Bowsers - View')) == true) {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
  } else {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = true;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('bd45b2d199a6da97a32c32ae38de0cee');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/71ebe8ace5969ba2e169ed29ac5ca838/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Bowser Fuel - View')) == true) {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
  } else {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = true;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('3b18a6fbfb7bcf8ceacbf01d3c165034');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/1b058d81775a27cad8ad4358fbb17edb/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return ([((getObjectProperty(___arguments.context.pageData, 'Bowser Option Select')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'Bowser Option Select')) === 'undefined') ? null : ((getObjectProperty(___arguments.context.pageData, 'Bowser Option Select')) == 'All' ? null : ['Bowser = \'',(getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Bowser_List')), async (item) => {


 return ((getObjectProperty(item, 'value')) == (getObjectProperty(___arguments.context.pageData, 'Bowser Option Select')));
}))[0]), 'label')),'\' AND '].join('')),'created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End Date')).valueOf()),'\' AND ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' OR Contractor = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End Date')).valueOf()),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/7e48552e818a1ad85a3339b776f2795c/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onObjectUpdate */
  async ['onObjectUpdate'](___arguments) {
    function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Updater() {
  ___arguments.newObject['Current_Mileage'] = (getObjectProperty(___arguments.oldObject, 'Current_Mileage'));
  ___arguments.newObject['Registration'] = (getObjectProperty(___arguments.oldObject, 'Registration'));
  ___arguments.newObject['Last_Service'] = (getObjectProperty(___arguments.oldObject, 'Last_Service'));
  ___arguments.newObject['License_Expirey'] = (getObjectProperty(___arguments.oldObject, 'License_Expirey'));
  ___arguments.newObject['Service_Interval'] = (getObjectProperty(___arguments.oldObject, 'Service_Interval'));
  ___arguments.newObject['Service_Notice_Period'] = (getObjectProperty(___arguments.oldObject, 'Service_Notice_Period'));
}


  ___arguments.context.pageData['OTP'] = (mathRandomInt(1000, 9999));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('48d6c8e2a9e7d5e7cbaa5e7ff7577158');
  console.log((await Backendless.Request.post(`${Backendless.appPath}/services/Twilio/sendMessage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'phoneNumber': '+27827775894','message': (String('Your Fleet In Form OTP is ') + String(getObjectProperty(___arguments.context.pageData, 'OTP'))) })));
  while (!((getObjectProperty(___arguments.context.pageData, 'OTP - Confirm')) == true || (getObjectProperty(___arguments.context.pageData, 'OTP - Close')) == true)) {
    await new Promise(r => setTimeout(r, 1000 || 0));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'OTP - Close')) == true) {
    await Updater();
    console.log(___arguments.oldObject);
  }
  ___arguments.context.pageData['OTP - Confirm'] = null;
  ___arguments.context.pageData['OTP - Close'] = null;

  },
  /* handler:onObjectUpdate */
  /* content */
}))

define('./pages/Home_Agri/components/bd45b2d199a6da97a32c32ae38de0cee/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onObjectUpdate */
  async ['onObjectUpdate'](___arguments) {
    function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Updater() {
  ___arguments.newObject['Capacity'] = (getObjectProperty(___arguments.oldObject, 'Capacity'));
  ___arguments.newObject['Litres'] = (getObjectProperty(___arguments.oldObject, 'Litres'));
  ___arguments.newObject['Meter'] = (getObjectProperty(___arguments.oldObject, 'Meter'));
  ___arguments.newObject['Name'] = (getObjectProperty(___arguments.oldObject, 'Name'));
  ___arguments.newObject['Name'] = (getObjectProperty(___arguments.oldObject, 'Name'));
}


  ___arguments.context.pageData['OTP'] = (mathRandomInt(1000, 9999));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('48d6c8e2a9e7d5e7cbaa5e7ff7577158');
  console.log((await Backendless.Request.post(`${Backendless.appPath}/services/Twilio/sendMessage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'phoneNumber': '+27827775894','message': (String('Your Fleet In Form OTP is ') + String(getObjectProperty(___arguments.context.pageData, 'OTP'))) })));
  while (!((getObjectProperty(___arguments.context.pageData, 'OTP - Confirm')) == true || (getObjectProperty(___arguments.context.pageData, 'OTP - Close')) == true)) {
    await new Promise(r => setTimeout(r, 1000 || 0));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'OTP - Close')) == true) {
    await Updater();
    console.log(___arguments.oldObject);
  }
  ___arguments.context.pageData['OTP - Confirm'] = null;
  ___arguments.context.pageData['OTP - Close'] = null;

  },
  /* handler:onObjectUpdate */
  /* content */
}))

define('./pages/Home_Agri/components/3b18a6fbfb7bcf8ceacbf01d3c165034/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End Date')).valueOf()),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/cbdeae51c058dd97014dcc4f07c9d694/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Start Date - Value'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Home_Agri/components/4eb2deb3804b529e586577b738abc2ee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['End Date - Value'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Home_Agri/components/102bb11599ccd0c65eda80cccaa9b917/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Fuel - View')) == true || (getObjectProperty(___arguments.context.pageData, 'OffFuel - View')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/57cc2fde57c1c206cb781e37fd375a31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/81590f8bda445fb6adcd5f84c5ec28c6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Product_List;

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Product_List = listsRepeat('New Product', (Number(___arguments.value)));
  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Product List'] = (await Promise.all(Product_List.map(async item => {; return ({ 'Product': undefined,'Rate': undefined });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('223a0d19fbc472363b7b7532ba8a47be', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Product List')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Home_Agri/components/cd6b22efc6a2bf8b4a4b13fbfaee1aca/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Farm Log Contractor Check')) == true) {
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('067de303ac1732acd194b2c1c74a1f5e', (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'AGRI_Contractors')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Company')) });}))));
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('27798fcc551708a11664a57df5c1b148', [({ 'value': 'No Contractor Selected','label': 'No Contractor Selected' })]);
  } else {
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('27798fcc551708a11664a57df5c1b148', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Registration')) });}))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Home_Agri/components/067de303ac1732acd194b2c1c74a1f5e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Contractor Data'] = (await Backendless.Data.of('Customers').findById(___arguments.value, ));
  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Contractor_Vehicles'] = (await Backendless.Data.of('AGRI_Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Contractor Data')), 'ownerId')),'\''].join(''))).setPageSize(100)));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('27798fcc551708a11664a57df5c1b148', (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Contractor_Vehicles')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Registration')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Home_Agri/components/987ad038cab2442f529b57a21b6dbfb4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Applications'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/2bc59766a90a9a8fa78d9e5cef7f4824/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, Contractor, Client;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2bc59766a90a9a8fa78d9e5cef7f4824', false);
  try {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Hectares')) === 'undefined') == true || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Field')) === 'undefined') == true || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('987ad038cab2442f529b57a21b6dbfb4')) === 'undefined') == true || (typeof (getObjectProperty(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('27798fcc551708a11664a57df5c1b148')), async (item) => {


     return ((getObjectProperty(item, 'value')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('27798fcc551708a11664a57df5c1b148')));
    }))[0]), 'label')) === 'undefined') == true || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Driver')) === 'undefined') == true) {
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Incomplete Fields'] = true;
    } else {
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Incomplete Fields'] = false;
      try {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Farm Log Client Check')) == true) {
          Contractor = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer'));
        } else {
          Contractor = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Contractor Data')), 'Company'));
        }

      } catch (error) {

      } finally {
        if (error) {
          Contractor = '';
        }

      }
      try {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Farm Log Contractor Check')) == true) {
          Client = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer'));
        } else {
          Client = (getObjectProperty(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('ed0cbb3ff55ee4069be8cb1342585fa2')), async (item) => {


           return ((getObjectProperty(item, 'value')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ed0cbb3ff55ee4069be8cb1342585fa2')));
          }))[0]), 'label'));
        }

      } catch (error) {

      } finally {
        if (error) {
          Client = '';
        }

      }
      await Backendless.Data.of('AGRI_Farming_Log').save( ({ 'Application': ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('987ad038cab2442f529b57a21b6dbfb4')),'Company': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'Client': Client,'Contractor': Contractor,'Driver': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Driver')),'Hectares': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Hectares')),'Field': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Field')),'Products': (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('223a0d19fbc472363b7b7532ba8a47be')).map(async item => {; return ([' (Product: ',(getObjectProperty(item, 'Product')),' , Rate: ',(getObjectProperty(item, 'Rate')),') '].join(''));}))).join('\n'),'Registration': (getObjectProperty(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('27798fcc551708a11664a57df5c1b148')), async (item) => {


       return ((getObjectProperty(item, 'value')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('27798fcc551708a11664a57df5c1b148')));
      }))[0]), 'label')),'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')) }) );
      ___arguments.context.pageData['Farming_Log'] = false;
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Farm Log Contractor Check'] = false;
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Driver'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Field'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Hectares'] = undefined;
      (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('067de303ac1732acd194b2c1c74a1f5e', undefined);
      (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('987ad038cab2442f529b57a21b6dbfb4', undefined);
      (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('81590f8bda445fb6adcd5f84c5ec28c6', undefined);
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2bc59766a90a9a8fa78d9e5cef7f4824', true);
    } else {
      ___arguments.context.pageData['Farming_Log'] = false;
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Farm Log Contractor Check'] = false;
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Driver'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Field'] = undefined;
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('81590f8bda445fb6adcd5f84c5ec28c6', '0');
      (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('067de303ac1732acd194b2c1c74a1f5e', undefined);
      (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('27798fcc551708a11664a57df5c1b148', undefined);
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/242bc10de31d43a986e9a431f92c55bb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var item;


  ___arguments.context.getComponentDataStoreByUid('73dd3cd1a687a461e89e0641c5984b1d')['Product'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Home_Agri/components/5e39f43e0682ac549d0e149bfeba091f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('73dd3cd1a687a461e89e0641c5984b1d')['Rate'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Home_Agri/components/0c9c8e5e28339d88b9bc8cf53c7c3782/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Incomplete Fields')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/498f797a7626a361c697d6692d5d0e61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Farm - View')) == true) {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
  } else {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
    ___arguments.context.pageData['Farm - View'] = true;
    ___arguments.context.pageData['OffFuel - View'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('ce314058f79b19c76c3bcff9c66b1684');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/ce314058f79b19c76c3bcff9c66b1684/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.pageData, 'Farm Log - Clause')) === null) || (typeof (getObjectProperty(___arguments.context.pageData, 'Farm Log - Clause')) === 'undefined')) {
    Clause = ['created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End Date')).valueOf()),'\' AND ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' OR Client = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End Date')).valueOf()),'\' OR Contractor = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End Date')).valueOf()),'\''].join('');
  } else {
    Clause = (getObjectProperty(___arguments.context.pageData, 'Farm Log - Clause'));
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/c4df9b18f091106e5c751afc69e18a46/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Farm Log Client Check')) == true) {
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ed0cbb3ff55ee4069be8cb1342585fa2', (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'AGRI_Clients')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Company')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    })));
  } else {
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Home_Agri/components/ed0cbb3ff55ee4069be8cb1342585fa2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Client Data'] = (await Backendless.Data.of('Customers').findById(___arguments.value, ));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Client Data'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Home_Agri/components/ac2f485e858ae1026385e87c803ddd19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Hamburger')) == true) {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['Application - View'] = false;
  } else {
    ___arguments.context.pageData['Hamburger'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu open';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['Application - View'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/6781e566ec57f94d7e55f679940f5f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Hamburger')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/d2ebacddce83d80af215214a5744acc4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Style;


  Style = ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2ebacddce83d80af215214a5744acc4'));
  Style['width'] = (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) - 20);
  Style['height'] = (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientHeight')) - 20);

  return Style

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/6ce6480812891b7b1464c22ad9bbb721/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
      return ({ 'width': ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) - 40,'height': ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientHeight')) - 90 })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/9904ca12c4950dacacbd68a69d8238eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;


  ___arguments.context.pageData['Farming_Log'] = false;
  ___arguments.context.pageData['Fuel_Log'] = false;
  ___arguments.context.pageData['Bowser_Fill'] = false;
  ___arguments.context.pageData['Off_Farm_Fill'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Agri_Log_Book')) == 'Yes') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/e1eba903bd818ee21bb7b0f84fea22e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Off_Farm_Fill')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/f7b662979bed8bc4f1a7c068aea7cabc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Farm - View')) == true) {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
  } else {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = true;
    ___arguments.context.pageData['Driver - View'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('ce314058f79b19c76c3bcff9c66b1684');
    await new Promise(r => setTimeout(r, 1000 || 0));
    ___arguments.context.pageData['Fuel Totals'] = ({ [`Cost`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cdec60a9786149d4588562f36b1edbaf')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;})))),[`Litres`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cdec60a9786149d4588562f36b1edbaf')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Litres'));}))).reduce(function(x, y) {return x + y;})))),[`Meter_Diff`]: 0,[`Mileage_Diff`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cdec60a9786149d4588562f36b1edbaf')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Mileage_Diff'));}))).reduce(function(x, y) {return x + y;})))) });
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/cdec60a9786149d4588562f36b1edbaf/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End Date')).valueOf()),'\' OR Client = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End Date')).valueOf()),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/b13d2e45b0eee9415a65989be0db938e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_bdd3f9226ef42fe6ac4eb15c13fc5c19']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), (getObjectProperty(___arguments.context.pageData, 'Fuel Totals')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/99fd5f16190c1616dd9b7785b0212e2e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NewJob - View')) == true) {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
  } else {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['NewJob - View'] = true;
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('7e48552e818a1ad85a3339b776f2795c');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/ed4b19037dc12d188ebad2f35c0820f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Job - View')) == true) {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
  } else {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Job - View'] = true;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('1b058d81775a27cad8ad4358fbb17edb');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/4d49422847e846f112a4a6f1cecef001/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End Date')).valueOf()),'\' AND ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' OR Client = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End Date')).valueOf()),'\' OR Contractor = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End Date')).valueOf()),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.selectedRecord, 'File')), true, undefined);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Home_Agri/components/eb25cf3b828263612925ad9fd2c6e442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_c2d5df2fba6f39d269674764c0156051'](null, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ce314058f79b19c76c3bcff9c66b1684')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/ce5aef1d38e283e2d55550cc7f662554/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('501e88832cff8c7c791267c62931cb52')) === 'string') {
    List = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Bowser_List')), async (item) => {


     return ((getObjectProperty(item, 'value')) != ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('501e88832cff8c7c791267c62931cb52')));
    }));
    addItemToList(List, ({ [`label`]: 'Garage',[`value`]: 'Garage' }));
    addItemToList(List, ({ [`label`]: 'Delivery',[`value`]: 'Delivery' }));
  } else {
    List = [];
  }

  return (await asyncListSort(List, 1, async (item) => {


 return (getObjectProperty(item, 'label'));
}))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Garage' || ___arguments.value == 'Delivery') {
    ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Supply System'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de')['Supply System'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Home_Agri/components/82978121454b418115174ccf52afbdaa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Supply System')) == false) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/494d3179de79d6c2379be67539c33e24/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Supply System')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/6fc23ac4d4388aef93f81f5c5438198c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4d63ed324d51bc39dcdfa25b39ea42de'), 'Supply System')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/2c117db3767a400724adcd6a91fc3ba6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'Fuel Totals')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'Fuel Totals')) === null)) {
    Content = '';
  } else {
    Content = String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fuel Totals')), 'Cost'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/b77cc6f9175ac93e42e2e98f4e9af906/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'Fuel Totals')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'Fuel Totals')) === null)) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fuel Totals')), 'Litres')) + String(' L');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/4ecb0543c0c78a5df0cb708cecb60659/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'Fuel Totals')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'Fuel Totals')) === null)) {
    Content = '';
  } else {
    Content = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fuel Totals')), 'Meter_Diff'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/95a882b80b34c65dc1ac5e4e2699e4e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'Fuel Totals')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'Fuel Totals')) === null)) {
    Content = '';
  } else {
    Content = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fuel Totals')), 'Mileage_Diff'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/24b344dcc865f4f7abe5368d9d3a9354/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Fuel - View')) == true) {
    ___arguments.context.pageData['Fuel Totals'] = ({ [`Cost`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;})))),[`Litres`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Litres'));}))).reduce(function(x, y) {return x + y;})))),[`Meter_Diff`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Meter_Diff'));}))).reduce(function(x, y) {return x + y;})))),[`Mileage_Diff`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Mileage_Diff'));}))).reduce(function(x, y) {return x + y;})))),[`Rebate`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Rebate'));}))).reduce(function(x, y) {return x + y;})))) });
  } else if ((getObjectProperty(___arguments.context.pageData, 'OffFuel - View')) == true) {
    ___arguments.context.pageData['Fuel Totals'] = ({ [`Cost`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cdec60a9786149d4588562f36b1edbaf')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;})))),[`Litres`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cdec60a9786149d4588562f36b1edbaf')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Litres'));}))).reduce(function(x, y) {return x + y;})))),[`Meter_Diff`]: 0,[`Mileage_Diff`]: (await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cdec60a9786149d4588562f36b1edbaf')), 'el')), 'dataManager')), 'filteredData')).map(async item => {; return (getObjectProperty(item, 'Mileage_Diff'));}))).reduce(function(x, y) {return x + y;})))) });
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/edbea00ce3e3ff7dd4db18a220a17065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Fuel - View')) == true) {
    await BackendlessUI.Functions.Custom['fn_bdd3f9226ef42fe6ac4eb15c13fc5c19']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b058d81775a27cad8ad4358fbb17edb')), (getObjectProperty(___arguments.context.pageData, 'Fuel Totals')), null, null);
  } else if ((getObjectProperty(___arguments.context.pageData, 'OffFuel - View')) == true) {
    await BackendlessUI.Functions.Custom['fn_bdd3f9226ef42fe6ac4eb15c13fc5c19']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cdec60a9786149d4588562f36b1edbaf')), (getObjectProperty(___arguments.context.pageData, 'Fuel Totals')), null, null);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/63c8981681bf93ca862d9c55f759ddec/bundle.js', [], () => ({
  /* content */
  /* handler:onDateSelect */
  async ['onDateSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Farm Log - Clause'] = (['created >= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getFromDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND created <= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getToDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' OR Client = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getFromDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND created <= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getToDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' OR Contractor = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getFromDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND created <= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getToDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\''].join(''));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('ce314058f79b19c76c3bcff9c66b1684');

  },
  /* handler:onDateSelect */
  /* handler:onStartDateChange */
  async ['onStartDateChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Farm Log - Clause'] = (['created >= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getFromDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND created <= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getToDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' OR Client = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getFromDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND created <= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getToDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' OR Contractor = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getFromDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND created <= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getToDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\''].join(''));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('ce314058f79b19c76c3bcff9c66b1684');

  },
  /* handler:onStartDateChange */
  /* handler:onEndDateChange */
  async ['onEndDateChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Farm Log - Clause'] = (['created >= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getFromDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND created <= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getToDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' OR Client = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getFromDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND created <= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getToDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' OR Contractor = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'\' AND created >= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getFromDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\' AND created <= \'',((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getToDate() })('63c8981681bf93ca862d9c55f759ddec')).valueOf()),'\''].join(''));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('ce314058f79b19c76c3bcff9c66b1684');

  },
  /* handler:onEndDateChange */
  /* content */
}))

define('./pages/Home_Agri/components/a142dd09d7fd025c6e2aba91d3a472e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'Fuel Totals')) === 'undefined') || ((getObjectProperty(___arguments.context.pageData, 'Fuel Totals')) === null)) {
    Content = '';
  } else {
    Content = String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fuel Totals')), 'Rebate'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/17f343d651fab6931a9bfe91fe6fb4f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Application - View')) == true) {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['Application - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
  } else {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['Application - View'] = true;
    ___arguments.context.pageData['Driver - View'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/8edd3d479c48522a66e5cd2817c9eb36/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.appData);
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/938802e7a3620468953f8cd2d5e9210d/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var Repeater_Data, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    Repeater_Data = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Applications'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Repeater_Data = [];
    }

  }

  return (await asyncListSort(Repeater_Data, 1, async (item) => {


 return (getObjectProperty(item, 'label'));
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/c65749620c2e29db599b5f69c91678e4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.appData);
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/04c86cf82948231fc398dd0429f8c5e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://files.fleetinform.co.za/Agri%20Bowser.pdf', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/aab1f8bb93e8a8984c4a84cf4ae89128/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('b6b8c5b8d3c8f9e1db88c05827684394', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/27d8f628cd48553c1ecd8a58f9f852a8/bundle.js', [], () => ({
  /* content */
  /* handler:pdfUrlLogic */
  ['pdfUrlLogic'](___arguments) {
    var Print;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty(___arguments.context.appData, 'Print')) === null) || (typeof (getObjectProperty(___arguments.context.appData, 'Print')) === 'undefined')) {
    Print = null;
  } else {
    Print = (getObjectProperty(___arguments.context.appData, 'Print'));
  }

  return Print

  },
  /* handler:pdfUrlLogic */
  /* content */
}))

define('./pages/Home_Agri/components/7bab01e1933f242d473e62d74e147eda/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.appData);
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/eae839e88608ac783d48a488c5e8cb35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57282758b8e89cb85b472f88515cac18', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/33d89f889c284a086db83e28c1d88d38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Applications')), ({ [`label`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('57282758b8e89cb85b472f88515cac18'), 'Input')),[`value`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('57282758b8e89cb85b472f88515cac18'), 'Input')) }));
  console.log((await Backendless.Data.of('Customers').save((getObjectProperty(___arguments.context.pageData, 'Company')), true)));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57282758b8e89cb85b472f88515cac18', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/14272d388c387c49d9afca0dc835ad78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Applications')), ___arguments.context.getComponentDataStoreByUid('4f9ad295bb48573759b86e71feec4771'), '');
  console.log((await Backendless.Data.of('Customers').save((getObjectProperty(___arguments.context.pageData, 'Company')), true)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/a7257798353803a8c4b82528088699e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e8ce2b3e981e98058824977252d898', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/0e18f85fcffe6a4c01e6371ccc776d16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Drivers')) === null) || (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Drivers')) === 'undefined')) {
    (getObjectProperty(___arguments.context.pageData, 'Company'))['Agri_Drivers'] = [];
  }
  addItemToList((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Drivers')), ({ [`label`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77e8ce2b3e981e98058824977252d898'), 'Input')),[`value`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('77e8ce2b3e981e98058824977252d898'), 'Input')) }));
  console.log((await Backendless.Data.of('Customers').save((getObjectProperty(___arguments.context.pageData, 'Company')), true)));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e8ce2b3e981e98058824977252d898', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/7c88ca2c8e9a30d1ac279ec8ccc8ea38/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var error, item, Repeater_Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    Repeater_Data = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Drivers'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Repeater_Data = [];
    }

  }

  return (await asyncListSort(Repeater_Data, 1, async (item) => {


 return (getObjectProperty(item, 'label'));
}))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/1fea0b286d783a2faac68348c49b8938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Drivers')), ___arguments.context.getComponentDataStoreByUid('e90d675667c86868c3d8b0a8443fbaf8'), '');
  console.log((await Backendless.Data.of('Customers').save((getObjectProperty(___arguments.context.pageData, 'Company')), true)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/1139ed687d182d42701f046871e9937a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Driver - View')) == true) {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['Application - View'] = false;
    ___arguments.context.pageData['Driver - View'] = false;
  } else {
    ___arguments.context.pageData['Hamburger'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ac2f485e858ae1026385e87c803ddd19'))['icon'] = 'menu';
    ___arguments.context.pageData['Bowsers - View'] = false;
    ___arguments.context.pageData['Bowser Fuel - View'] = false;
    ___arguments.context.pageData['NewJob - View'] = false;
    ___arguments.context.pageData['Fuel - View'] = false;
    ___arguments.context.pageData['Vehicles - View'] = false;
    ___arguments.context.pageData['Job - View'] = false;
    ___arguments.context.pageData['Farm - View'] = false;
    ___arguments.context.pageData['OffFuel - View'] = false;
    ___arguments.context.pageData['Application - View'] = false;
    ___arguments.context.pageData['Driver - View'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Home_Agri/components/6494ee77a42ef25f47bf71187d76b128/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}



  return (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Drivers')), 1, async (item) => {


 return (getObjectProperty(item, 'label'));
}))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Home_Agri/components/02c8e7b80a9e5b189c78b5593a63da82/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'Bowser_List')).concat([({ [`value`]: 'All',[`label`]: 'All' })]))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Bowser Option Select'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Leave_Truck/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Driver_Mileage_Dump, item, Current_Driver, Last_Mileage_Of_This_Truck, Current_Truck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('609885542943085abe1a49544fbddf5c'))['opacity'] = 0;
  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21b3b5359de78dac002b1cba70e8f383', true);
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  ___arguments.context.pageData['location'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  ___arguments.context.pageData['UserDriver'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName'));
  Current_Driver = (await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employee.displayName = \'',(getObjectProperty(___arguments.context.pageData, 'UserDriver')),'\''].join(''))).setPageSize(10)))[0];
  ___arguments.context.pageData['Driver_objectId'] = (getObjectProperty(Current_Driver, 'objectId'));
  Current_Truck = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver_1.Name = \'',(getObjectProperty(Current_Driver, 'Name')),'\''].join(''))).setPageSize(10)))[0];
  ___arguments.context.pageData['Horse_Registration'] = (getObjectProperty(Current_Truck, 'Horse_Registration'));
  ___arguments.context.pageData['Horse_objectId'] = (getObjectProperty(Current_Truck, 'objectId'));
  Last_Mileage_Of_This_Truck = (await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Horse_objectId')),'\''].join(''))).setSortBy('mileage').setPageSize(100))).slice(-1)[0];
  ___arguments.context.pageData['Final_Last_Mileage'] = (getObjectProperty(Last_Mileage_Of_This_Truck, 'mileage'));
  ___arguments.context.pageData['Reflected_Mileage'] = (getObjectProperty(___arguments.context.pageData, 'Final_Last_Mileage'));
  Driver_Mileage_Dump = (await Promise.all((await Backendless.Data.of('Driver_Mileage_Dumps').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver.Name = \'',(getObjectProperty(Current_Driver, 'Name')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return ({ 'Final_Mileage_On_Rig': (getObjectProperty(item, 'Final_Mileage_On_Rig')),'First_Mileage_On_Rig': (getObjectProperty(item, 'First_Mileage_On_Rig')),'Fuel_Consumption': (getObjectProperty(item, 'Fuel_Consumption')),'Last_Mileage_On_Rig': (getObjectProperty(item, 'Last_Mileage_On_Rig')),'Litres_Used': (getObjectProperty(item, 'Litres_Used')),'Mileage_Differential': (getObjectProperty(item, 'Mileage_Differential')),'objectId': (getObjectProperty(item, 'objectId')) });})));
  ___arguments.context.pageData['Driver_MD'] = (getObjectProperty((Driver_Mileage_Dump[0]), 'objectId'));
  ___arguments.context.pageData['Driver_Mileage_Dump'] = (await Backendless.Data.of('Driver_Mileage_Dumps').findById((getObjectProperty(___arguments.context.pageData, 'Driver_MD')), ));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21b3b5359de78dac002b1cba70e8f383', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('094257daf1a51969e1e3b92e0e050784', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', true);
  await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('08dabef6046e86c385454adccf14cf2a')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('08dabef6046e86c385454adccf14cf2a')), false);

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Leave_Truck/components/23eef22b5c313da3b0c90962a99b42c5/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), 'image')))

  },
  /* handler:onDisplayAssignment *//* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('Posts'))

  },
  /* handler:onDirectoryAssignment */
/* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split('.').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment *//* content */
}));

define('./pages/Leave_Truck/components/609885542943085abe1a49544fbddf5c/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Current_Truck, Current_Driver, Driver_Mileage_Dump;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.dataModel, 'Update_Log'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('094257daf1a51969e1e3b92e0e050784', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aff3702fb9b56813f2f6a8fcec3e3966', true);
    ___arguments.context.dataModel['Update_Log'] = true;
    Driver_Mileage_Dump = (await Backendless.Data.of('Driver_Mileage_Dumps').findById((getObjectProperty(___arguments.context.pageData, 'Driver_MD')), ));
    Driver_Mileage_Dump['Final_Mileage_On_Rig'] = (getObjectProperty(___arguments.context.dataModel, 'mileage'));
    Driver_Mileage_Dump['Total_Mileage_On_Rig'] = ((getObjectProperty(___arguments.context.dataModel, 'mileage')) + (getObjectProperty(Driver_Mileage_Dump, 'Last_Mileage_On_Rig')));
    await Backendless.Data.of('Driver_Mileage_Dumps').save( Driver_Mileage_Dump );
    Current_Truck = (await Backendless.Data.of('Vehicles ').findById((getObjectProperty(___arguments.context.pageData, 'Horse_objectId')), ));
    Current_Driver = (await Backendless.Data.of('Employees').findById((getObjectProperty(___arguments.context.pageData, 'Driver_objectId')), ));
    Current_Driver['Currently_Aboard'] = null;
    await Backendless.Data.of('Employees').save( Current_Driver );
    await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Driver_1', [Current_Driver]);
    Current_Truck['Current_Driver'] = null;
    await Backendless.Data.of('Vehicles').save( Current_Truck );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Post', undefined);
  }

  },
  /* handler:onSubmit *//* handler:onBeforeUnmount */
  async onBeforeUnmount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Fuel').setRelation((getObjectProperty(___arguments.context.pageData, 'NewFuel')), 'reg', [(getObjectProperty(___arguments.context.pageData, 'Registration'))]);

  },
  /* handler:onBeforeUnmount */
  /* content */
}));

define('./pages/Leave_Truck/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Leave_Truck/components/cb53911dc178fd277a2316cbfb1eca43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var CurrentCustomer, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData));
  if (currentUser) {
    CurrentCustomer = (getObjectProperty(currentUser, 'Customer'));
    ___arguments.context.pageData['CustomerSelect'] = CurrentCustomer;
  }

  return CurrentCustomer

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Leave_Truck/components/c77e57e7785a639b6d3b1b738466e375/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Leave_Truck/components/89aa8f06c6495d53dd6dd069a2389c3d/bundle.js', [], () => ({
  /* content */

  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage')) == 'Incompatible Mileage')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/Leave_Truck/components/4a0712b6dd5de72eb53179fd3bcef1e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Final_Last_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Leave_Truck/components/3899c55306cdf23a07c4ece729fe2194/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Leave_Truck/components/1c26b77fa5bfe57c7a573909c7f97ace/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'));
  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Leave_Truck/components/ec5a10bf6f78e3eecbe5f5afe174e4fd/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Horse_Registration'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Leave_Truck_Office/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('d37d6811c67c7e45f7310feda9187ec8', (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employee.ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\'','And Warehouse_Status = \'Out\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Call_Sign')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Leave_Truck_Office/components/23eef22b5c313da3b0c90962a99b42c5/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), 'image')))

  },
  /* handler:onDisplayAssignment *//* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('Posts'))

  },
  /* handler:onDirectoryAssignment */
/* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split('.').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment *//* content */
}));

define('./pages/Leave_Truck_Office/components/609885542943085abe1a49544fbddf5c/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Current_Truck, Current_Driver, Driver_Mileage_Dump;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.dataModel, 'Update_Log'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('094257daf1a51969e1e3b92e0e050784', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aff3702fb9b56813f2f6a8fcec3e3966', true);
    ___arguments.context.dataModel['Update_Log'] = true;
    Driver_Mileage_Dump = (await Backendless.Data.of('Driver_Mileage_Dumps').findById((getObjectProperty(___arguments.context.pageData, 'Driver_MD')), ));
    Driver_Mileage_Dump['Final_Mileage_On_Rig'] = (getObjectProperty(___arguments.context.dataModel, 'mileage'));
    Driver_Mileage_Dump['Total_Mileage_On_Rig'] = ((getObjectProperty(___arguments.context.dataModel, 'mileage')) + (getObjectProperty(Driver_Mileage_Dump, 'Last_Mileage_On_Rig')));
    await Backendless.Data.of('Driver_Mileage_Dumps').save( Driver_Mileage_Dump );
    Current_Truck = (await Backendless.Data.of('Vehicles ').findById((getObjectProperty(___arguments.context.pageData, 'Horse_objectId')), ));
    Current_Driver = (await Backendless.Data.of('Employees').findById((getObjectProperty(___arguments.context.pageData, 'Driver_objectId')), ));
    Current_Driver['Currently_Aboard'] = null;
    await Backendless.Data.of('Employees').save( Current_Driver );
    await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Driver_1', [Current_Driver]);
    Current_Truck['Current_Driver'] = null;
    await Backendless.Data.of('Vehicles').save( Current_Truck );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Post', undefined);
  }

  },
  /* handler:onSubmit *//* handler:onBeforeUnmount */
  async onBeforeUnmount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Fuel').setRelation((getObjectProperty(___arguments.context.pageData, 'NewFuel')), 'reg', [(getObjectProperty(___arguments.context.pageData, 'Registration'))]);

  },
  /* handler:onBeforeUnmount */
  /* content */
}));

define('./pages/Leave_Truck_Office/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Leave_Truck_Office/components/cb53911dc178fd277a2316cbfb1eca43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var CurrentCustomer, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData));
  if (currentUser) {
    CurrentCustomer = (getObjectProperty(currentUser, 'Customer'));
    ___arguments.context.pageData['CustomerSelect'] = CurrentCustomer;
  }

  return CurrentCustomer

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Leave_Truck_Office/components/c77e57e7785a639b6d3b1b738466e375/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Leave_Truck_Office/components/89aa8f06c6495d53dd6dd069a2389c3d/bundle.js', [], () => ({
  /* content */

  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage')) == 'Incompatible Mileage')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/Leave_Truck_Office/components/4a0712b6dd5de72eb53179fd3bcef1e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Final_Last_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Leave_Truck_Office/components/1c26b77fa5bfe57c7a573909c7f97ace/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'));
  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Leave_Truck_Office/components/ec5a10bf6f78e3eecbe5f5afe174e4fd/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Horse_Registration'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Leave_Truck_Office/components/d37d6811c67c7e45f7310feda9187ec8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Driver_Mileage_Dump, item, Current_Driver, Last_Mileage_Of_This_Truck, Current_Truck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21b3b5359de78dac002b1cba70e8f383', true);
  Current_Driver = (await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments.value,'\''].join(''))).setPageSize(10)))[0];
  console.log(Current_Driver);
  ___arguments.context.pageData['Driver_objectId'] = (getObjectProperty(Current_Driver, 'objectId'));
  Current_Truck = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(Current_Driver, 'Currently_Aboard')),'\''].join(''))).setPageSize(10)))[0];
  console.log(Current_Truck);
  ___arguments.context.pageData['Horse_Registration'] = (getObjectProperty(Current_Truck, 'Horse_Registration'));
  ___arguments.context.pageData['Horse_objectId'] = (getObjectProperty(Current_Truck, 'objectId'));
  Last_Mileage_Of_This_Truck = (await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(Current_Truck, 'objectId')),'\''].join(''))).setSortBy('mileage').setPageSize(100))).slice(-1)[0];
  console.log(Last_Mileage_Of_This_Truck);
  ___arguments.context.pageData['Final_Last_Mileage'] = (getObjectProperty(Last_Mileage_Of_This_Truck, 'mileage'));
  ___arguments.context.pageData['Reflected_Mileage'] = (getObjectProperty(___arguments.context.pageData, 'Final_Last_Mileage'));
  Driver_Mileage_Dump = (await Promise.all((await Backendless.Data.of('Driver_Mileage_Dumps').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver.Name = \'',(getObjectProperty(Current_Driver, 'Name')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return ({ [`Final_Mileage_On_Rig`]: (getObjectProperty(item, 'Final_Mileage_On_Rig')),[`First_Mileage_On_Rig`]: (getObjectProperty(item, 'First_Mileage_On_Rig')),[`Fuel_Consumption`]: (getObjectProperty(item, 'Fuel_Consumption')),[`Last_Mileage_On_Rig`]: (getObjectProperty(item, 'Last_Mileage_On_Rig')),[`Litres_Used`]: (getObjectProperty(item, 'Litres_Used')),[`Mileage_Differential`]: (getObjectProperty(item, 'Mileage_Differential')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  console.log(Driver_Mileage_Dump);
  ___arguments.context.pageData['Driver_MD'] = (getObjectProperty((Driver_Mileage_Dump[0]), 'objectId'));
  console.log(getObjectProperty(___arguments.context.pageData, 'Driver_MD'));
  ___arguments.context.pageData['Driver_Mileage_Dump'] = (await Backendless.Data.of('Driver_Mileage_Dumps').findById((getObjectProperty(___arguments.context.pageData, 'Driver_MD')), ));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21b3b5359de78dac002b1cba70e8f383', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('094257daf1a51969e1e3b92e0e050784', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/dac77a1a4f719e4c49120454a44f393c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Per_Ton'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Km'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = null;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/5188840eb28a56c19829cfa5085520ac/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Mileage_Input'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Mileage_Locker'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    var Place_Holder;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Route_Distance')) === 'undefined') {
    Place_Holder = 'km';
  } else {
    Place_Holder = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Route_Distance'));
  }

  return Place_Holder

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/a5155b854c9e5afccdcd9b4374227a34/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Product_Input'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/61e90b598149fccdeb7cf5760948d64a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Hider'] = true;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e90b598149fccdeb7cf5760948d64a', false);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/7bae0001628e6848b62a49557f170be8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, Loads_Repeater, New_Customer, New_Customer_Customer, New_Horse, New_Load, Rate_Per_Km, Rate_Per_Tonne, Vehicle_Item;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Loads_Populator() {
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Total_Mileage`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))),[`Total_Revenue`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))),[`Total_Tonnage`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))),[`Horse_Registration`]: (getObjectProperty(item, 'Horse_Registration')),[`owner_objectId`]: (getObjectProperty(item, 'ownerId')),[`objectId`]: (getObjectProperty(item, 'objectId')),[`Service_Due`]: (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? 'Service Due' : 'All in Order',[`Status`]: (getObjectProperty(item, 'Status')),[`Trailer1_Registration.Type`]: (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],[`Payload`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],[`Target_Mileage`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],[`Target_Tonnage`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],[`Ideal_Rate_Per_Tonne`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],[`Ideal_Rate_Per_Km`]: (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],[`Actual_Rate_Per_Km`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),[`Planned_Rate_Per_Km`]: (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),[`Driver_Name`]: (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],[`Driver_Cell`]: (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],[`Owner_Name`]: (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],[`Owner_Cell`]: (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],[`Load_Items`]: (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ [`Service`]: (getObjectProperty(item, 'Service')),[`Split_delivery`]: (getObjectProperty(item, 'Split_delivery')),[`Split_Load_Reference`]: (getObjectProperty(item, 'Split_Load_Reference')),[`Horse_Registration`]: (getObjectProperty(item, 'Horse_Registration')),[`Customer_Name`]: (getObjectProperty(item, 'Customer_Name')),[`Edit_Hide2`]: true,[`Edit_Hide_False`]: true,[`Edit_Hide3`]: false,[`Edit`]: false,[`Edit_Hide_True`]: false,[`tonnage`]: (getObjectProperty(item, 'tonnage')),[`tonnage2`]: (getObjectProperty(item, 'tonnage')),[`Status`]: (getObjectProperty(item, 'Status')),[`Status2`]: (getObjectProperty(item, 'Status')),[`Split_Load`]: (getObjectProperty(item, 'Split_Load')),[`Split_Load2`]: (getObjectProperty(item, 'Split_Load')),[`objectId`]: (getObjectProperty(item, 'objectId')),[`Planned_Load`]: (getObjectProperty(item, 'Planned_Load')),[`Planned_Load2`]: (getObjectProperty(item, 'Planned_Load')),[`Planned_Delivery_Date_Time`]: (getObjectProperty(item, 'Planned_Delivery_Date_Time')),[`Planned_Delivery_Date_Time2`]: (getObjectProperty(item, 'Planned_Delivery_Date_Time')),[`Planned_Delivery`]: (getObjectProperty(item, 'Planned_Delivery')),[`Planned_Delivery2`]: (getObjectProperty(item, 'Planned_Delivery')),[`Customer`]: (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Customer')),[`value`]: (getObjectProperty(item, 'objectId')) });})))[0],[`Customer2`]: (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Customer')),[`value`]: (getObjectProperty(item, 'objectId')) });})))[0],[`load_reference`]: (getObjectProperty(item, 'load_reference')),[`load_reference2`]: (getObjectProperty(item, 'load_reference')),[`Product`]: (getObjectProperty(item, 'Product')),[`Product2`]: (getObjectProperty(item, 'Product')),[`Planned_Tonnage`]: (getObjectProperty(item, 'Planned_Tonnage')),[`Planned_Tonnage2`]: (getObjectProperty(item, 'Planned_Tonnage')),[`load_point`]: (getObjectProperty(item, 'load_point')),[`load_point2`]: (getObjectProperty(item, 'load_point')),[`delivery_point`]: (getObjectProperty(item, 'delivery_point')),[`delivery_point2`]: (getObjectProperty(item, 'delivery_point')),[`mileage`]: (getObjectProperty(item, 'mileage')),[`mileage2`]: (getObjectProperty(item, 'mileage')),[`Rate_Per_Tonne`]: (getObjectProperty(item, 'Rate_Per_Tonne')),[`Rate_Per_Tonne2`]: (getObjectProperty(item, 'Rate_Per_Tonne')),[`Rate_Per_Km`]: (getObjectProperty(item, 'Rate_Per_Km')),[`Rate_Per_Km2`]: (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);
}

/**
 * Describe this function...
 */
async function Clear_Inputs() {
  for (var count = 0; count < 3; count++) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LAST_DP_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LOAD_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['DEL_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['CALCULATE_ROUTE_VIEWER'] = false;
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['STD LOAD VIEWER'] = false;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Del_Point_Input'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Mileage_Input'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Ratio'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Rate'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Summed_Split_Del'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Leaflet_Map_Viewer'] = false;

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e90b598149fccdeb7cf5760948d64a', true);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7bae0001628e6848b62a49557f170be8', true);

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Hider'] = null;

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('976f92e310c25237dfd7fa8d90c39755', '');

    } catch (error) {

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('976f92e310c25237dfd7fa8d90c39755', '');

    } catch (error) {

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c5d29fc7581cfc111964aa46653d7813', '');

    } catch (error) {

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('98f6611ffd4debb5e97d456d25ad4e0b', null);

    } catch (error) {

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('2e0113a9a964bbeb9dd481a47e34c0bf', '');

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('824c54dca465ea9b2108f90cf1f633aa', '');

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('86762cc135077ea60b46a1860983fbdc', null);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('2ee23293d6683fbe09d8f6cd1fe99204', '');

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a82eb4254d53749d09fe02e2a4a3131d', '');

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('97ae9afce97485738f893037934ff202', '');

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', null);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22f75797a1257312a4f28ed523462d73', null);

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Route_Distance'] = null;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Mileage_Input'] = null;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Load'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Ref_Input'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Del_Date_Locker'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Point_Text'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Product_Input'] = undefined;

    } catch (error) {
      console.log(error);

    }
  }
  for (var count2 = 0; count2 < 3; count2++) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LAST_DP_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LOAD_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['DEL_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['CALCULATE_ROUTE_VIEWER'] = false;
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['STD LOAD VIEWER'] = false;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Load'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Ref_Input'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Del_Date_Locker'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Point_Text'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Product_Input'] = undefined;

    } catch (error) {
      console.log(error);

    }
  }
  for (var count3 = 0; count3 < 3; count3++) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LAST_DP_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LOAD_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['DEL_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['CALCULATE_ROUTE_VIEWER'] = false;
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['STD LOAD VIEWER'] = false;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Load'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Ref_Input'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Del_Date_Locker'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Point_Text'] = undefined;

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Product_Input'] = undefined;

    } catch (error) {
      console.log(error);

    }
  }
}

/**
 * Describe this function...
 */
async function Rate_Per_Km2() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) == null) {
    Rate_Per_Km = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Km'));
  } else {
    Rate_Per_Km = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km'));
  }
  return Rate_Per_Km
}

/**
 * Describe this function...
 */
async function Rate_Per_Tonne2() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null) {
    Rate_Per_Tonne = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Per_Ton'));
  } else {
    Rate_Per_Tonne = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton'));
  }
  return Rate_Per_Tonne
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', true);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;
  New_Load = (await Backendless.Data.of('Loads').save( ({ [`Split_Load_Reference`]: (generateUUID().long()),[`Transporter`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Hauler')),[`Load_Planner`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName')),[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'owner_objectId')),[`Ideal_RKm`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')),[`Driver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Driver_Name')),[`Payload`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload')),[`Horse_Registration`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),[`Customer_Name`]: (getObjectProperty((await Backendless.Data.of('Tier_2_Customer').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('976f92e310c25237dfd7fa8d90c39755')), )), 'Customer')),[`Edit_Hide2`]: true,[`Edit_Hide_False`]: true,[`Edit_Hide3`]: false,[`Edit`]: false,[`Edit_Hide_True`]: false,[`Completion_Status`]: '0',[`Split_Load`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Load_Checked')),[`Split_Load2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Load_Checked')),[`Planned_Delivery_Date_Time`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),[`Planned_Delivery_Date_Time2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),[`tonnage`]: null,[`tonnage2`]: null,[`Status`]: null,[`Status2`]: null,[`Planned_Load`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),[`Planned_Load2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),[`Planned_Delivery`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Delivery')),[`Planned_Delivery2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Delivery')),[`load_reference`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),[`load_reference2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),[`Product`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),[`Product2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),[`Planned_Tonnage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Tonnage_Input')),[`Planned_Tonnage2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Tonnage_Input')),[`load_point`]: (getObjectProperty((await Backendless.Data.of('Locations').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('98f6611ffd4debb5e97d456d25ad4e0b')), )), 'Name')),[`load_point2`]: (getObjectProperty((await Backendless.Data.of('Locations').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('98f6611ffd4debb5e97d456d25ad4e0b')), )), 'Name')),[`delivery_point`]: (getObjectProperty((await Backendless.Data.of('Locations').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('97ae9afce97485738f893037934ff202')), )), 'Name')),[`delivery_point2`]: (getObjectProperty((await Backendless.Data.of('Locations').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('97ae9afce97485738f893037934ff202')), )), 'Name')),[`mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')),[`mileage2`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')),[`Rate_Per_Tonne`]: await Rate_Per_Tonne2(),[`Rate_Per_Tonne2`]: await Rate_Per_Tonne2(),[`Rate_Per_Km`]: await Rate_Per_Km2(),[`Rate_Per_Km2`]: await Rate_Per_Km2() }) ));
  New_Customer = (await Backendless.Data.of('Tier_2_Customer').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('976f92e310c25237dfd7fa8d90c39755')), ));
  New_Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'objectId')), ));
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Customer', [New_Customer]);
  New_Customer_Customer = (getObjectProperty(New_Customer, 'Customer'));
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [New_Horse]);
  await Loads_Populator();
  await new Promise(r => setTimeout(r, 3000 || 0));
  await Clear_Inputs();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Button_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/fe9339d55bffe2182175d6fcedf6551f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error, item, Overlapping_Loads, TotalT;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TotalT = (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Total')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Total')))) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Total')) : 0;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Tonnage_Input'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;
  if (___arguments.value + TotalT > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f8cc858421f9b9e031dc26cab845fa'))['backgroundColor'] = 'rgba(255, 0, 0, 0.43)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f8cc858421f9b9e031dc26cab845fa'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  }

  },
  /* handler:onChange */
  /* handler:onPlaceholderAssignment */
  onPlaceholderAssignment(___arguments) {
    var Display_Tonnage, Tonnage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Summed_Split_Del'));
    Tonnage = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Summed_Split_Del'));
    if (Tonnage > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f8cc858421f9b9e031dc26cab845fa'))['backgroundColor'] = 'rgba(255, 0, 0, 0.43)';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f8cc858421f9b9e031dc26cab845fa'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
    }
    Display_Tonnage = 't';
  } else {
    Display_Tonnage = 't';
  }

  return Display_Tonnage

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/47ed825e9d162645c0ffc9a4b42285a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Route, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Add_Load_Load_Ref_Input')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Product_Input')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) != null) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7f47209559dcccb8b0d1f91955d37a95', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7f47209559dcccb8b0d1f91955d37a95', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Load_Check_State')) == 'Yes') {
    if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) === 'undefined') {
      try {
        ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Mileage_Input'] = ((getObjectProperty((getObjectProperty(((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'legs'))[0]), 'distance')), 'value')) / 1000);

      } catch (error) {

      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) == null) {
      try {
        ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'));

      } catch (error) {

      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) == null) {
      try {
        ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));

      } catch (error) {

      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null) {
      try {
        ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'))) * 1000) / 1000);

      } catch (error) {

      }
    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'))) * 1000) / 1000);

    } catch (error) {

    }
    try {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = (Math.round((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input'))) * 1000) / 1000);

    } catch (error) {

    }
  } else {
    if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) === 'undefined') {
      try {
        ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Mileage_Input'] = ((getObjectProperty((getObjectProperty(((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'legs'))[0]), 'distance')), 'value')) / 1000);

      } catch (error) {

      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) == null) {
      try {
        ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'));

      } catch (error) {

      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null) {
      try {
        ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));

      } catch (error) {

      }
      try {
        ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));

      } catch (error) {

      }
      try {
        ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'))) * 1000) / 1000);

      } catch (error) {

      }
      try {
        ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'))) * 1000) / 1000);

      } catch (error) {

      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null) {
      try {
        ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'))) * 1000) / 1000);

      } catch (error) {

      }
      try {
        ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'))) * 1000) / 1000);

      } catch (error) {

      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) == null) {
      try {
        ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input'))) * 1000) / 1000);

      } catch (error) {

      }
      try {
        ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Km'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input'))) * 1000) / 1000);

      } catch (error) {

      }
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Km')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'Red';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Km')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'green';
  }
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['STD LOAD VIEWER'] = true;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['STD LOAD VALUE'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Per_Ton')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) == null ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'))));
}


  await do_something();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Del_Date_Locker')) == false) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/bb5e61736219d3cef0f157fe612a0469/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Per_Ton'] = null;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Rate_Km_Work'] = null;
  ___arguments.context.dataModel['Split_Load_List'] = [];

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Add_Load_Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Hider')) == true) {
    Add_Load_Hider = true;
  } else {
    Add_Load_Hider = false;
  }

  return Add_Load_Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Load_Planner/components/469b966455bdd35a3006484bda3f23d5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Status'))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Status')) == 'Active') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('469b966455bdd35a3006484bda3f23d5'))['color'] = 'Green';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('469b966455bdd35a3006484bda3f23d5'))['color'] = 'Red';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/7a5231e82088f89d398bb5f8e97dfd09/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Trailer1_Registration.Type'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/3a61a5179d7e8694a6da6b541d079404/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/08c94e7aad78278c6d823ebf0dd8bd71/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/9557a8a22746d6370ccaec4b2bac2191/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Driver_Name'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/a7348e5a4edfe202337cdab9a242ef19/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Driver_Cell'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/d0338f4381ec7ca78be460a88597e517/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Owner_Name'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/50ccd705e23e1ca37fcd60418c5ce28e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Owner_Cell'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/7a31ba9c6c02a3874564c73b9d036347/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Load_Items'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/f7444bace24b713919d96307c681c483/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Date'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Delivery_Date_Time')) == null ? String(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Load2')))).slice(0, 15) : String(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Delivery_Date_Time')))).slice(0, 15));

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Date'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/ce9c6c8871f6e1e8ebfb3488c8c7abe9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Customer_Selector'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Customer_Select_Edit'] = ___arguments.value;
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2'))['value'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/43f855dbbb51ad2191f1c5cd617c9861/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/378f90ec32729d3b247b8d764d36f8fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == null) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['mileage2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['mileage2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/206c143f4db64213a40f0fdfe4296b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onMinDateAssignment */
  onMinDateAssignment(___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/963a5ef384b99b2e118f782debfaa5b9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Load_Ref_Input'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/976f92e310c25237dfd7fa8d90c39755/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var Customer_Selector;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Customer_Selector')) === 'undefined') == true) {
    Customer_Selector = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Customer_Selector'));
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Customer_Selector'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Customer_Selector'));
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Customer_Selector')).length > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Customer_Selector')).length) {
      Customer_Selector = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Customer_Selector'));
    } else {
      Customer_Selector = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Customer_Selector'));
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Customer_Selector'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Customer_Selector'));
    }
  }

  return (getObjectProperty(___arguments.context.pageData, 'Customer_Selector'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/104b6042b412922c8545961ade73b86c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Km'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Per_Ton'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = null;
  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'rgba(255, 0, 0, 0.43)';
  }
  if (___arguments.value >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'rgba(0, 150, 3, 0.43)';
  }
  if (___arguments.value == null) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'rgba(255, 255, 255, 0.0)';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/11e63e484cdf3ed9d30ef8d21a0c6d1e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Overlapping_Loads, Load_Items;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Total'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Remaining_Tonnage'] = undefined;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22f75797a1257312a4f28ed523462d73', []);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')) > (new Date((new Date()).getTime() - (300 * 1000)))) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = 'Unlocked';
  }
  Load_Items = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Load_Items'));
  Overlapping_Loads = (await asyncListFilter(Load_Items, async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')) >= (getObjectProperty(item, 'Planned_Load')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')) <= (getObjectProperty(item, 'Planned_Delivery')));
  }));
  if (Overlapping_Loads.length > 1) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = true;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = false;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22f75797a1257312a4f28ed523462d73', Overlapping_Loads);
  }
  if (Overlapping_Loads.length == 1) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = true;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = false;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22f75797a1257312a4f28ed523462d73', Overlapping_Loads);
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Ref'] = (getObjectProperty((Overlapping_Loads[0]), 'load_reference'));
  }
  if (Overlapping_Loads.length == 0) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = false;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = false;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = false;
  }
  try {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Total'] = ((await Promise.all(Overlapping_Loads.map(async item => {; return (getObjectProperty(item, 'Planned_Tonnage'));}))).reduce(function(x, y) {return x + y;}));
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Remaining_Tonnage'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Total')));

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  onMinDateAssignment(___arguments) {
      return (new Date((new Date((new Date())).getTime())))

  },
  /* handler:onMinDateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/fe33d4dd6ba56bbc585ea5aaade8a28a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Vehicle_Item, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Loads_Populator() {
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? 'Service Due' : 'All in Order','Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (getObjectProperty(item, 'Payload')),'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),'Planned_Rate_Per_Km': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);
}


  if (___arguments.value == 'Delete') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', true);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load')) == true) {
      await Backendless.Data.of('Loads').bulkDelete( (['Split_Load_Reference = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load_Reference')),'\''].join('')) );
    } else {
      await Backendless.Data.of('Loads').remove( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'objectId')) );
    }
    console.log('Start Sequence');
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Delete_Reset'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_True'] = false;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_False'] = true;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide3'] = false;
    await Loads_Populator();
    console.log('End Sequense');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/b4219f68336213a341e88a6a6a62a7b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Customer, Update_Load, Old_Customer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', true);
  console.log('1');
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  Update_Load = (await Backendless.Data.of('Loads').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'objectId')), ));
  console.log('2');
  Update_Load['Rerouted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check'));
  Update_Load['Split_Load'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load2'));
  Update_Load['Planned_Load'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Load2'));
  Update_Load['Planned_Delivery'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Delivery2'));
  Update_Load['load_reference'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'load_reference2'));
  Update_Load['Product'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Product2'));
  Update_Load['Planned_Tonnage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2'));
  Update_Load['load_point'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'load_point2'));
  Update_Load['delivery_point'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'delivery_point2'));
  Update_Load['mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2'));
  Update_Load['Rate_Per_Tonne'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2'));
  Update_Load['Rate_Per_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2'));
  try {
    New_Customer = [(await Backendless.Data.of('Tier_2_Customer').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ce9c6c8871f6e1e8ebfb3488c8c7abe9')), ))];

  } catch (error) {

  }
  try {
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ce9c6c8871f6e1e8ebfb3488c8c7abe9')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'value'))) {
      console.log('State 2');
      Old_Customer = [(await Backendless.Data.of('Tier_2_Customer').findById((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'value')), ))];
      await Backendless.Data.of('Loads').setRelation(Update_Load, 'Customer', New_Customer);
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2'))['label'] = (getObjectProperty((New_Customer[0]), 'Customer'));
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['label'] = (getObjectProperty((New_Customer[0]), 'Customer'));
      console.log('State 3.1');
    } else {
      console.log('State 3');
      Old_Customer = [(await Backendless.Data.of('Tier_2_Customer').findById((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'value')), ))];
      await Backendless.Data.of('Loads').setRelation(Update_Load, 'Customer', New_Customer);
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2'))['label'] = (getObjectProperty((New_Customer[0]), 'Customer'));
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['label'] = (getObjectProperty((New_Customer[0]), 'Customer'));
      console.log('State 3.1');
    }

  } catch (error) {

  }
  console.log('State 1');
  console.log('State 4');
  Update_Load['Customer_Name'] = (getObjectProperty((New_Customer[0]), 'Customer'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide2'] = true;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide3'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_False'] = true;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_True'] = false;
  await Backendless.Data.of('Loads').save( Update_Load );
  console.log('State 5');
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == 'Loaded') {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = false;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = true;
    } else {
      Disabler = false;
    }
  } else {
    Disabler = false;
  }

  return Disabler

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/a20c1cdd5cb2c6ee3d01e5660f5b8ae5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == null) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/63ad9f3746536bb61cb7134645d6d09e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['Add_Load_Hider'] = false;

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'Truck_Item_Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/7a4ee66c1ab7014a1737fa1210c724d1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var Overlapping_Loads, item, Load_Items;


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Delivery'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Del_Date_Locker'] = false;

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  onMinDateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date'))).getTime())))

  },
  /* handler:onMinDateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Date_Locker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Date_Locker')) == null) {
    Date_Locker = true;
  } else {
    Date_Locker = false;
  }

  return Date_Locker

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/07c5c236032eee4eb474df37512b9d9f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')) !== null && !Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2'))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')) === 'object')) {
    Customer = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'label'));
  } else {
    Customer = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2'));
  }

  return Customer

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/0576e6e91b465ba1fb52b16f9fece693/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onMinDateAssignment */
  onMinDateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Load2'))).getTime())))

  },
  /* handler:onMinDateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/21ceb6af10e809125c5d8e5789786d5a/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    var Load_Items, item, object;

  },
  /* handler:onMounted */
  /* handler:onStyleAssignment */
  onStyleAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Loaded') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('21ceb6af10e809125c5d8e5789786d5a'))['backgroundColor'] = 'rgba(255, 60, 0, 0.25)';
    ___arguments.context.dataModel['Loaded_Tonnage'] = true;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Delivered') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21ceb6af10e809125c5d8e5789786d5a', false);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('21ceb6af10e809125c5d8e5789786d5a'))['backgroundColor'] = 'rgba(119, 119, 119, 0.25)';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/90daec64a60ea96f9c3a46b32d029299/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Disabler = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/5d277a486e57499e635441e5bc55e977/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/0ce95513837197c76807166bbe9459d2/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/6becd84feb725b91d826f2ab729ae3b2/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('442a911b71cb646130171fd7ea6f7aa1'))['backgroundColor'] = 'rgba(255, 0, 0, 0.40)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2')) <= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('442a911b71cb646130171fd7ea6f7aa1'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == null) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  async onValueAssignment(___arguments) {
    var Planned_Tonnage, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('7a31ba9c6c02a3874564c73b9d036347')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load_Reference')) == (getObjectProperty(item, 'Split_Load_Reference')));
    }));
    Planned_Tonnage = (await Promise.all((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('7a31ba9c6c02a3874564c73b9d036347')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load_Reference')) == (getObjectProperty(item, 'Split_Load_Reference')));
    })).map(async item => {; return (getObjectProperty(item, 'Planned_Tonnage2'));}))).reduce(function(x, y) {return x + y;}) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2'));
  } else {
    Planned_Tonnage = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2'));
  }

  return Planned_Tonnage

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/e24753f5be04b561701c67b2f21443e1/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == null) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/cc364e23a98ad58d59aab8f3ed4439c3/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == null) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/e882dee9e7f71c17e3263b958de2ee2c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = true;
    } else {
      Disabler = false;
    }
  } else {
    Disabler = false;
  }

  return Disabler

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == 'Loaded') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) == null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'tonnage'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) == null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'tonnage'))) * 1000) / 1000);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) != null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = (Math.round((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'tonnage')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2'))) * 1000) / 1000);
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) == null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) == null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2'))) * 1000) / 1000);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) != null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = (Math.round((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2'))) * 1000) / 1000);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(0, 128, 0, 0.40)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 0, 0, 0.40)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/3a99be020b0ca03ae3abb24d74358165/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('976f92e310c25237dfd7fa8d90c39755', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/34ea13f2d2b322e7869899567cb6915f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('976f92e310c25237dfd7fa8d90c39755', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/3b87e41e107b73bd07217bbfa49e032d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Customer_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/077bdb9d14cdc9176f9ccb7c4d9eae26/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['New_Customer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/6d321472aac6b50d0bf28d389af1f4f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, New_Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  New_Customer = (await Backendless.Data.of('Tier_2_Customer').save( ({ 'Customer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'New_Customer')),'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Customer_Selector'] = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });})));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('976f92e310c25237dfd7fa8d90c39755', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/bef2b148d0f5d945b7e785cedf8e1104/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Add_Customer_Hider2'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/cc78ee7ab7f175db8e375a0af70e30f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['New_Customer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/8a02e1d2b8fb29d678c11ce46298da8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Add_Customer_Hider2'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa4df345d69ffeb7a8f7aa1a45268187', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/92e7fd9a12b744fec03ca2464344d97e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, New_Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  New_Customer = (await Backendless.Data.of('Tier_2_Customer').save( ({ 'Customer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'New_Customer')),'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  await new Promise(r => setTimeout(r, 2000 || 0));
  ___arguments.context.pageData['Customer_Selector'] = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });})));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Add_Customer_Hider2'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/4c250386b1ee75c2a863ab589d1f19b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('48356f8f9959eaf9c45c1587e07f3b9f'), 'Planned_Load')))).toString()).slice(3, 21))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/175a85befe5cadb63eeb2ef462ec62b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('94852f4aaf0ac272e8483081c04537fa'), 'Planned_Delivery')))).toString()).slice(3, 21))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/35d47ac26f7a420e2cd4678cfce884d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Warning_Hider_1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/dc6b284859894b79508b31b83b033d8d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Warning_Hider_2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/c3967fd1d8756cab2e9f2508502984c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/d39ac0f6b29393cb64b1f38d9d835a77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Total')) * 1000) / 1000)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/22f75797a1257312a4f28ed523462d73/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/b75a5e06be0af2d810ce1442eb222d81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/713a708f72fa7c02cc4c0221f5bd2ec8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Add_Load_Load_Ref_Input')) != null && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('98f6611ffd4debb5e97d456d25ad4e0b')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Product_Input')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Date_Locker')) == 'Unlocked') {
      Hider = true;
    }
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Split_Delivery_Repeater_adder, item;

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Del_Number'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = ___arguments.value;
  Split_Delivery_Repeater_adder = listsRepeat('New_Split_Del', ___arguments.value);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Repeater'] = (await Promise.all(Split_Delivery_Repeater_adder.map(async item => {; return ({ 'Planned_Tonnage_Input': undefined,'Horse_Registration': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'Customer_Name': undefined,'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': undefined,'tonnage2': undefined,'Status': undefined,'Status2': undefined,'Split_Load': undefined,'Split_Load2': undefined,'objectId': undefined,'Planned_Load': undefined,'Planned_Load2': undefined,'Planned_Delivery_Date_Time': undefined,'Planned_Delivery_Date_Time2': undefined,'Planned_Delivery': undefined,'Planned_Delivery2': undefined,'Customer': undefined,'Customer2': undefined,'load_reference': undefined,'load_reference2': undefined,'Product': undefined,'Product2': undefined,'Planned_Tonnage': undefined,'Planned_Tonnage2': undefined,'load_point': undefined,'load_point2': undefined,'delivery_point': undefined,'delivery_point2': undefined,'mileage': undefined,'mileage2': undefined,'Rate_Per_Tonne': undefined,'Rate_Per_Tonne2': undefined,'Rate_Per_Km': undefined,'Rate_Per_Km2': undefined });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Repeater')));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split Del Measure'] = 0;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number'));

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/91abd94c4cf682f3f2f976c21287a5e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['LDP'] = (getObjectProperty(((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'\''].join(''))).setSortBy('Planned_Delivery2 DESC').setPageSize(10)))[0]), 'delivery_point'));

  } catch (error) {

  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = null;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == false) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Del_Calc'] = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Del_Calc'] = true;
  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c5d29fc7581cfc111964aa46653d7813', (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return ((getObjectProperty(item, 'label')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'LDP')));
    }))[0]), 'value')));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/3b51a2fdba0802319f3c4e6fb6d58342/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/9d37270f0ec9bd16b7bcb371ef96d04a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/c32667bec55a8ca3c877a8e4cd56c06b/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    
  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/d86e3ce834488b272b3292f8306a5868/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  onMinDateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date'))).getTime())))

  },
  /* handler:onMinDateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Date_Locker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == true) {
    Date_Locker = true;
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Date_Locker')) == null) {
      Date_Locker = true;
    } else {
      Date_Locker = false;
    }
  }

  return Date_Locker

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Counter_3'] = 1;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Planned_Delivery'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Del_Date_Locker'] = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/f5139f61c741aae2e394cbf24c082601/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['New_Customer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/ffad665e6c02eb123d43983727cd60d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, New_Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  New_Customer = (await Backendless.Data.of('Tier_2_Customer').save( ({ 'Customer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'New_Customer')),'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Customer_Selector'] = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });})));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Customer_Selector'));
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Add_Customer_Hider'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21e9b85527523a69c4828f52037add1d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/d6fb77229d4422c7f5bcc385ccc1f9d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Add_Customer_Hider'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21e9b85527523a69c4828f52037add1d', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == true) {
    Hider = false;
  } else {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/a2e77ffb0587dae7c61440b5b1d8c227/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Counter_2'] = 1;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Qouted_Split_Del_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = undefined;
  }
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = false;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Planned_Delivery_Tonnage'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Summed_Split_Del'] = ((await Promise.all((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')), async (item) => {


   return ((getObjectProperty(item, 'Planned_Delivery_Tonnage')) != null);
  })).map(async item => {; return (getObjectProperty(item, 'Planned_Delivery_Tonnage'));}))).reduce(function(x, y) {return x + y;}));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Date_Locker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == true) {
    Date_Locker = true;
  } else {
    Date_Locker = false;
  }

  return Date_Locker

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/5f14188b0a8201138a2d59674a94df29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Add_Customer_Hider'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21e9b85527523a69c4828f52037add1d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/c8eeb4eb82d4c151573c2edc8a244774/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Customer_Selector'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Counter_4'] = 1;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Qouted_Split_Del_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = undefined;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/dc9321e27708c74e057c327f15f7e933/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


 return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('98f6611ffd4debb5e97d456d25ad4e0b')) == (getObjectProperty(item, 'objectId')));
}))[0]), 'Name'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/d24596e234bb1ea3e0dd5c7136563783/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = null;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = null;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Qouted_Split_Del_Load'] = 1;
  if (((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) === null)) && ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) === null))) {
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = (((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Mileage_Total')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Summed_Split_Del'))) / 2) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')));
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Mileage_Total')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Summed_Split_Del'))) / 2) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
  } else if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) === null)) {
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')));
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton'));
  } else if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) === null)) {
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km'));
  }
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
}


  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Qouted_Split_Del_Load'] = 1;
  await do_something();
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == true) {
      Hider = false;
    } else {
      Viewer = true;
    }
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/b3d63eac1c9394e23719751f7c929d56/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Qouted_Split_Del_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = undefined;
  }
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = false;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Add_Mileage_Input'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Mileage_Locker'] = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Counter'] = 1;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Mileage'] = ___arguments.value;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Leaflet_Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/2e2520e62252cda94727807b50242bbb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var Value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calulated_Split_Del')) == true) {
    Value = Math.round(((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calculated_Split_Del_Rate')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calculated_Ratio'))) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Mileage_Max')))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input'))) * 100) / 100;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km_Del'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/2b1ab5d44c99092931965721fdd92139/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var Value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calulated_Split_Del')) == true) {
    Value = Math.round((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) * ((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calculated_Split_Del_Rate')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calculated_Ratio'))) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Mileage_Max')))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input'))) * 100) / 100;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Quote_Value'] = (Value * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/04166d64515e0b63302f06b56c4c17c4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    Hider = false;
  } else {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Input_Rate_Km'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/28032a3d34aecb161aedaded240e5bb2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    Hider = false;
  } else {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Input_Rate_Per_Ton'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/233c65027ebdc81ba635dddb76d93103/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Planned_Tonnage_Input'));}))).reduce(function(x, y) {return x + y;}));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Reference'] = (generateUUID().long());
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Mileage_Max'] = (Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Add_Mileage_Input'));})))));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Mileage_Total'] = ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Add_Mileage_Input'));}))).reduce(function(x, y) {return x + y;}));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Ratio'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Mileage_Max')));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Rate'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Mileage_Max')));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = true;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Hider, Item, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  try {
    if ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async Item => {; return (getObjectProperty(Item, 'Split_Del_Counter_2'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) && (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async Item => {; return (getObjectProperty(Item, 'Split_Del_Counter_3'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) && (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async Item => {; return (getObjectProperty(Item, 'Split_Del_Counter_4'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) && (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async Item => {; return (getObjectProperty(Item, 'Split_Del_Counter_5'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Leaflet_Viewer')) == true) {
      Hider = true;
    } else {
      Hider = false;
    }

  } catch (error) {

  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/368b7ac2bb4ebb4ab90ec2c3fca916c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/9287a56e1d34f5713d433272e89aa576/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Horse, New_Load, Load_Items, item, Vehicle_Item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Loads_Populator() {
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Total_Mileage': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))),'Total_Revenue': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))),'Total_Tonnage': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? 'Service Due' : 'All in Order','Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],'Target_Mileage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],'Target_Tonnage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],'Ideal_Rate_Per_Tonne': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),'Planned_Rate_Per_Km': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Load_Items);
}


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Saver'] = 'Save';
  New_Load = (await Backendless.Data.of('Loads').save( ({ 'Split_delivery': 'Load','Split_Load_Reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'Customer_Name': undefined,'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'Completion_Status': '0','Split_Load': true,'Split_Load2': true,'Planned_Delivery_Date_Time': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Delivery_Date_Time2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'tonnage': null,'tonnage2': null,'Status': null,'Status2': null,'Planned_Load': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Load2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Delivery': undefined,'Planned_Delivery2': undefined,'load_reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),'load_reference2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),'Product': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),'Product2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),'Planned_Tonnage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Summed_Split_Del')),'Planned_Tonnage2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Summed_Split_Del')),'load_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Point_Text')),'load_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Point_Text')),'delivery_point': undefined,'delivery_point2': undefined,'mileage': undefined,'mileage2': undefined,'Rate_Per_Tonne': undefined,'Rate_Per_Tonne2': undefined,'Rate_Per_Km': undefined,'Rate_Per_Km2': undefined }) ));
  New_Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'objectId')), ));
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [New_Horse]);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Load'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Ref_Input'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Point_Text'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Product_Input'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Del_Point_Input'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Mileage_Input'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Ratio'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Rate'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Summed_Split_Del'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = undefined;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e90b598149fccdeb7cf5760948d64a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7bae0001628e6848b62a49557f170be8', true);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Hider'] = null;
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('976f92e310c25237dfd7fa8d90c39755', null);

  } catch (error) {

  }
  await new Promise(r => setTimeout(r, 3000 || 0));
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Customer_Selector': undefined,'Total_Mileage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Revenue': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Tonnage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? 'Service Due' : 'All in Order','Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],'Target_Mileage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],'Target_Tonnage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],'Ideal_Rate_Per_Tonne': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Planned_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var Hider, Item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  try {
    if ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async Item => {; return (getObjectProperty(Item, 'Finalised_Load'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) != 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) != null)) {
      console.log('abc');
      Hider = true;
    } else {
      Hider = false;
    }

  } catch (error) {

  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/505a9d1194adf5612266d1e202318f86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    Hider = false;
  } else {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    var error, Quote;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Quote = Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Quote')) * 100) / 100;

  } catch (error) {

  }

  return Quote

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/1af1ea4cca0231f97d27d87b1f94336d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calulated_Split_Del')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  async onValueAssignment(___arguments) {
    var Calculated_Split_Rate_Per_Km, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Calculated_Split_Rate_Per_Km = String('R ') + String((typeof (Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Calculated_Quote_Value'));}))).reduce(function(x, y) {return x + y;}) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));}))))) * 100) / 100) === 'number' && !isNaN((Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Calculated_Quote_Value'));}))).reduce(function(x, y) {return x + y;}) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));}))))) * 100) / 100))) ? Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Calculated_Quote_Value'));}))).reduce(function(x, y) {return x + y;}) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));}))))) * 100) / 100 : '-');

  } catch (error) {

  }

  return Calculated_Split_Rate_Per_Km

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/758ef8da13c6fc3e8255cfca2976ffd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calulated_Split_Del')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Quoted_Split_Rate_Per_Km, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Quoted_Split_Rate_Per_Km = String('R ') + String((typeof (Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input'))) * 100) / 100) === 'number' && !isNaN((Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input'))) * 100) / 100))) ? Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input'))) * 100) / 100 : '-');

  } catch (error) {

  }

  return Quoted_Split_Rate_Per_Km

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/7b784624154aef21f015b9ba65ca8202/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calulated_Split_Del')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  async onValueAssignment(___arguments) {
    var Total_Quote_Ammount, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Total_Quote_Ammount = String('R ') + String((typeof (Math.round((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) * 100) / 100) === 'number' && !isNaN((Math.round((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) * 100) / 100))) ? Math.round((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) * 100) / 100 : '-');

  } catch (error) {

  }

  return Total_Quote_Ammount

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/f598deac451f2e0fc9822ceb592282e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/0f4c99376bb4fa0c8e8901ea4fe92939/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Due')) == 'Service Due') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
      Hider = false;
    } else {
      Hider = true;
    }
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Due')) == 'Service Due') {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Service_Hider'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/113df1c1a6235da33efdb11e0c75c63c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Service_Hider'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/18d3b57355045fd8f5bb4b38766e469e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/019c246c3864596b157cfb3aa068aa64/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/cb9b9bbd1a8a2b5ff5334b231c720d38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/dcadf2bbc0c69c4355e470c3e725da92/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/6f91033f1fcdd289ebe7da795352f4f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/e5718d535b36409db7ad26a8cf4bf946/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/ae2c8e8f17cc9aaedd3254e688c15147/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Horse, New_Load, Trailer_3, Trailer_2, Trailer_1, New_Service, Vehicle_Item, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Loads_Populator() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', true);
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Total_Mileage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Revenue': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Tonnage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? 'Service Due' : 'All in Order','Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],'Target_Mileage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],'Target_Tonnage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],'Ideal_Rate_Per_Tonne': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Planned_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', false);
}


  New_Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'objectId')), ));
  New_Load = (await Backendless.Data.of('Loads').save( ({ 'Service': 'Yes','Description': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Description')),'Horse_Registration': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'Customer_Name': 'Service','Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'Completion_Status': '0','Planned_Delivery_Date_Time': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Planned_Load')),'Planned_Delivery_Date_Time2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Planned_Load')),'tonnage': null,'tonnage2': null,'Status': null,'Status2': null,'Planned_Load': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Planned_Load')),'Planned_Load2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Planned_Load')),'load_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'load_point')),'load_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'load_point')),'delivery_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'load_point')),'delivery_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'load_point')) }) ));
  New_Service = (await Backendless.Data.of('Repairs_Maintenance').save( ({ 'Date_Scheduled': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Planned_Load')),'Scheduled_Notes': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Description')),'Registration_Horse': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'Repair_Or_Service': 'Service','Service_Point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'load_point')),'Completion_Status': 'Scheduled','ownerId': (getObjectProperty(New_Horse, 'ownerId')) }) ));
  ___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f')['Planned_Load'] = null;
  ___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f')['load_point'] = null;
  ___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f')['Description'] = null;
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [New_Horse]);
  await Loads_Populator();
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Service_Hider'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/866e39bf419b805d9cb2093d56946cf3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = 'Service';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = 'Split Delivery Load';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = 'Split Delivery';
  }

  return Hider

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/442a911b71cb646130171fd7ea6f7aa1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      if (false) {
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Load_Planner/components/d50f3ce45dbd343c3521f696d4813988/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/ca7c47fd06cb518976fb36d33547532a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    var Check_State;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load_Reference')) != null) {
    Check_State = true;
  } else {
    Check_State = false;
  }

  return Check_State

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/0a2c68890b3a5584a278cd3c4b08fe09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/f3bb7eb99c11f494282d2d1ce3cd84eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  for (var count = 0; count < 3; count++) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LAST_DP_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LOAD_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['DEL_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['CALCULATE_ROUTE_VIEWER'] = false;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['STD LOAD VIEWER'] = false;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Del_Date_Locker'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Ref_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Point_Text'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Product_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Del_Point_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Mileage_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Ratio'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Rate'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Summed_Split_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = undefined;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e90b598149fccdeb7cf5760948d64a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7bae0001628e6848b62a49557f170be8', true);
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Hider'] = null;
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('976f92e310c25237dfd7fa8d90c39755', null);

    } catch (error) {

    }
  }
  for (var count2 = 0; count2 < 3; count2++) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LAST_DP_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LOAD_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['DEL_VIEW_NUMBER'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['CALCULATE_ROUTE_VIEWER'] = false;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['STD LOAD VIEWER'] = false;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Ref_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Del_Date_Locker'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Point_Text'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Product_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Del_Point_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Mileage_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Ratio'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Rate'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Summed_Split_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Leaflet_Map_Viewer'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e90b598149fccdeb7cf5760948d64a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7bae0001628e6848b62a49557f170be8', true);
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Hider'] = null;
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('976f92e310c25237dfd7fa8d90c39755', '');

    } catch (error) {

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('976f92e310c25237dfd7fa8d90c39755', '');

    } catch (error) {

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c5d29fc7581cfc111964aa46653d7813', '');

    } catch (error) {

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('98f6611ffd4debb5e97d456d25ad4e0b', null);

    } catch (error) {

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('2e0113a9a964bbeb9dd481a47e34c0bf', '');

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('824c54dca465ea9b2108f90cf1f633aa', '');

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('86762cc135077ea60b46a1860983fbdc', null);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('2ee23293d6683fbe09d8f6cd1fe99204', '');

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a82eb4254d53749d09fe02e2a4a3131d', '');

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('97ae9afce97485738f893037934ff202', '');

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', null);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22f75797a1257312a4f28ed523462d73', null);

    } catch (error) {
      console.log(error);

    }
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Route_Distance'] = null;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Mileage_Input'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/feeca394d05b2a74b0b835e65252550d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = null;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22f75797a1257312a4f28ed523462d73', []);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = null;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Load'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Load'] = null;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('976f92e310c25237dfd7fa8d90c39755', null);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Ref_Input'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Product_Input'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Point_Text'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Del_Point_Input'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Mileage_Input'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/7552207d6a527b6f1339803de6fbad9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('7a31ba9c6c02a3874564c73b9d036347'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit'] = true;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_False'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_True'] = true;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide2'] = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == 'Loaded') {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = true;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Undeletable'] = true;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Undeletable'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Loaded_Tonnage'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = false;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit'] = false;
    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = true;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Loaded_Tonnage'] = false;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = false;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Loaded_Tonnage'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Undeletable'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = false;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit'] = false;
    }
  }
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Selected_Customer'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'value'));
  console.log(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'value'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Customer_Selector'] = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'owner_objectId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });})));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/57a77a01129d53dd69f33b359f04e91c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) != true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = false;
  } else {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = false;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Revealer'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Status2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Split_Load2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Planned_Load2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Load'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Planned_Delivery2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Delivery'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Customer2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['load_reference2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'load_reference'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Product2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Product'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Planned_Tonnage2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['load_point2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'load_point'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['delivery_point2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'delivery_point'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['mileage2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('442a911b71cb646130171fd7ea6f7aa1'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('ce9c6c8871f6e1e8ebfb3488c8c7abe9', null);
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Add_Customer_Hider2'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_True'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide2'] = true;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide3'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_False'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/18a295d63ae675a8e65b6c8cb4091207/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Undeletable')) == true) {
    Hide = false;
  } else {
    Hide = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit_Hide_True'));
  }

  return Hide

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide3'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/d6ddd318aa06f275086ab0dcd0f583af/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = false;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = false;
  }
  try {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['LDP'] = (getObjectProperty(((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'\''].join(''))).setSortBy('Planned_Delivery2 DESC').setPageSize(10)))[0]), 'delivery_point'));
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c5d29fc7581cfc111964aa46653d7813', (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return ((getObjectProperty(item, 'label')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'LDP')));
    }))[0]), 'value')));
    if (!(typeof ((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return ((getObjectProperty(item, 'label')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'LDP')));
    }))[0]), 'value')) != null) === 'undefined')) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LAST_DP_VIEW_NUMBER'] = 1;
    }

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/d5f8cc858421f9b9e031dc26cab845fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/c756becd2eee48f9de4391ecbbf70f53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Horse, New_Load, New_Customer, New_Customer_Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Load_Added'] = true;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finalised_Load'] = 1;
  New_Load = (await Backendless.Data.of('Loads').save( ({ 'ownerId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'owner_objectId')),'Load_Planner': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName')),'Split_delivery': 'Yes','Split_Load_Reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'Customer_Name': (getObjectProperty((await Backendless.Data.of('Tier_2_Customer').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c8eeb4eb82d4c151573c2edc8a244774')), )), 'Customer')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'Completion_Status': '0','Split_Load': true,'Split_Load2': true,'Planned_Delivery_Date_Time': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Delivery')),'Planned_Delivery_Date_Time2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Delivery')),'tonnage': null,'tonnage2': null,'Status': null,'Status2': null,'Planned_Load': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Load2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Delivery': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Delivery')),'load_reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),'load_reference2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),'Product': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),'Product2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),'Planned_Tonnage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')),'Planned_Tonnage2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')),'load_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Point_Text')),'load_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Point_Text')),'delivery_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Load_Del_Point_Input')),'delivery_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Load_Del_Point_Input')),'mileage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')),'mileage2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')),'Rate_Per_Tonne': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')),'Rate_Per_Tonne2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')),'Rate_Per_Km': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Km')),'Rate_Per_Km2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Km')) }) ));
  New_Customer = (await Backendless.Data.of('Tier_2_Customer').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c8eeb4eb82d4c151573c2edc8a244774')), ));
  New_Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'objectId')), ));
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Customer', [New_Customer]);
  New_Customer_Customer = (getObjectProperty(New_Customer, 'Customer'));
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [New_Horse]);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Finaliser')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == false || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == null) {
        Hider = true;
      } else {
        Hider = false;
      }
    } else {
      Hider = false;
    }
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/a1527e0bfd18ff8930e3412790f4babb/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'tonnage'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1527e0bfd18ff8930e3412790f4babb'))['backgroundColor'] = 'rgba(0, 0, 0, 0.4)';
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1527e0bfd18ff8930e3412790f4babb'))['backgroundColor'] = 'rgba(0, 0, 0, 0.4)';
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Load_Planner/components/fd3f801f50a915b9c3e886eaa1c37ed4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  } else {
    Hider = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute'));
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/5ecf23feef9d25091d767f88b123b195/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var Label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Label = 'Delivery Tonnage';
  } else {
    Label = 'Loaded Tonnage';
  }

  return Label

  },
  /* handler:onLabelAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Editable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
    Editable = false;
  } else {
    Editable = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Loaded_Tonnage'));
  }

  return Editable

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Reader;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Reader = false;
  } else {
    Reader = true;
  }

  return Reader

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
    var Reader;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Revealer'] = true;
    Reader = (await Backendless.Data.of('Loads').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'objectId')), ));
    Reader['tonnage'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  } else {
    Hider = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Loaded_Tonnage'));
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/7cdacc9ac37da37684331df8b33b34c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Reader;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Reader = (await Backendless.Data.of('Loads').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'objectId')), ));
    Reader['tonnage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'tonnage'));
    await Backendless.Data.of('Loads').save( Reader );
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Vehicle_Item, item, Start_Date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (await Backendless.UserService.isValidLogin()) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4dee53e9f92d12aa04ad645fc5989c5'))['opacity'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb2960c5019976d78d3a19fb09469426', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86be408f9222570656323ee6fb3ccb77', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d0e5c3bc1d87929626a38c2bcc26094', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e6c5c027ce55df803eaa9241caa7618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('994620ee1519465b94e55fbae6bf9b23', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70f22ea7660718a7648f6008cd21f70d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11818d94f7a748ffebda45ba3b1f9c34', false);
    ___arguments.context.pageData['Customer_Selector'] = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });})));
    Start_Date = (new Date());
    Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
    Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
    Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
    Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
    Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
    ___arguments.context.pageData['Start_Date'] = (Start_Date.valueOf());
    ___arguments.context.pageData['End_Date'] = ((new Date()).valueOf());
    Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Hauler': (getObjectProperty(item, 'Company')),'Customer_Selector': undefined,'Total_Mileage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Revenue': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Tonnage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) || (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\' AND Service_Status = \'Service Due\''].join(''))).setPageSize(10))).length > 0 ? 'Service Due' : 'All in Order','Service_Due_2': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? true : false,'Service_Due_3': (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\' AND Service_Status = \'Service Due\''].join(''))).setPageSize(10))).length > 0 ? true : false,'Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],'Target_Mileage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],'Target_Tonnage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],'Ideal_Rate_Per_Tonne': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Planned_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
    ___arguments.context.pageData['Location_Lists_Pre_Map'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Locations', (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))));
    ___arguments.context.pageData['Location_Lists'] = (await asyncListSort((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')).map(async item => {; return ({ 'label': textToTitleCase(getObjectProperty(item, 'Name')),'value': (getObjectProperty(item, 'objectId')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb2960c5019976d78d3a19fb09469426', false);
    ___arguments.context.pageData['Live_Check'] = true;
    await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4dee53e9f92d12aa04ad645fc5989c5')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4dee53e9f92d12aa04ad645fc5989c5')), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('86be408f9222570656323ee6fb3ccb77')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86be408f9222570656323ee6fb3ccb77')), false);
    await BackendlessUI.Functions.Custom['fn_f1bf64c5c5a6dd6f25dd14c4bf39499e'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('11818d94f7a748ffebda45ba3b1f9c34')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11818d94f7a748ffebda45ba3b1f9c34')), true);
    console.log(getObjectProperty(___arguments.context.pageData, 'Location_Lists'));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }

  },
  /* handler:onEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  ___arguments.context.pageData['Load_Viewer'] = false;
  try {
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')));
    console.log(['Horse Update Listener',(getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')),' Has Been Removed'].join(''));
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')));
    console.log(['Load Update Listener ',(getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')),' Has Been Removed'].join(''));
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')));
    console.log(['Target Update Listener ',(getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')),' Has Been Removed'].join(''));

  } catch (error) {

  }

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/Load_Planner/components/b98f729c5df3491e57c9e3bf28014eba/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var Load_Items, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!___arguments.newValue) {
    console.log('Work');
    Load_Items = (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });})));
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Load_Items'] = [Load_Items];
    ___arguments.context.appData['Next_Load'] = (Load_Items[0]);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7a31ba9c6c02a3874564c73b9d036347', Load_Items);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/Load_Planner/components/954b46d6c9ea7af36bbb257f4bdc46da/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Load_Planner = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName')),'\' AND Completion_Status = \'','1','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5271750889635ac881f35c54c006a06e', true);
  ___arguments.context.pageData['image'] = (getObjectProperty(___arguments.selectedRecord, 'image'));
  ___arguments.context.pageData['image 1'] = (getObjectProperty(___arguments.selectedRecord, 'image1'));
  ___arguments.context.pageData['image 2'] = (getObjectProperty(___arguments.selectedRecord, 'image2'));
  ___arguments.context.pageData['image 3'] = (getObjectProperty(___arguments.selectedRecord, 'image3'));
  ___arguments.context.pageData['image 4'] = (getObjectProperty(___arguments.selectedRecord, 'imageload'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Load_Planner/components/2cead99be0bdaedece9df7c2a9d6b8ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cead99be0bdaedece9df7c2a9d6b8ea', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('954b46d6c9ea7af36bbb257f4bdc46da', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5271750889635ac881f35c54c006a06e', false);
  ___arguments.context.pageData['Locations_Viewer'] = false;
  ___arguments.context.pageData['image'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/0105a5f96d82d7580cc23b7e63dbd869/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'image')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/58d8c49915fcda386fbd529e359519ad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Actual_Rate_Per_Km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/bb0bd26a55efdcb4fc38e867f42f769f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Rate_Per_Km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/eb266272512cb686c6a738665ef1b213/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Tonnage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/8dfdaf880c4a582b4945b96af5b39b0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/3eb8d96939c46d93d142b6dbd5bc2316/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/8e165477f81a1be119c57337c3ca9416/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((typeof (Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Mileage')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Mileage'))) * 100 * 100) / 100) === 'number' && !isNaN((Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Mileage')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Mileage'))) * 100 * 100) / 100))) ? (Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Mileage')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Mileage'))) * 100) / 100) * 100 : 0) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/38d934f322b8a293ffd39fb5585a9341/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Tonnage')) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Tonnage')) * ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())))) * 100 * 100) / 100) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/e42d3c7935052b2dfb2254d24c73ab34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Tonnage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/0a95f05ddc4d00c1110c25eda0dc8f3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Tonnage')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Tonnage'))) * 100 * 100) / 100) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/a6cbe5fe46aa896388bf57db63bd790b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Mileage')) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Mileage')) * ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())))) * 100 * 100) / 100) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/f1c2d8162dce51ba2975663fb724e9e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Revenue')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/a301b21f90757aee98fb179485841f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a301b21f90757aee98fb179485841f35', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('008a950e023fabaf6b83b499f3ba2889', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('904f8ab859bf20bed07f68cebbcd9726', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/904f8ab859bf20bed07f68cebbcd9726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a301b21f90757aee98fb179485841f35', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('008a950e023fabaf6b83b499f3ba2889', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('904f8ab859bf20bed07f68cebbcd9726', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/9556b4cf518a30cc8ee492d1ae48b1da/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Remaining_Tonnage')) * 1000) / 1000)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/1df21a48486206960194db4b2625fc49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Tonne'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/6b1da7be10dfc8778ca6a22fe54f4511/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Vehicle_Item, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', true);
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Customer_Selector': undefined,'Total_Mileage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Revenue': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Tonnage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Status')),'Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],'Target_Mileage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],'Target_Tonnage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],'Ideal_Rate_Per_Tonne': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Planned_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/60b44d7c62dddcbb2c622fec2257546c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Load, Horse, object, item, Load_Planner, New_Object, error, Payload, Trailer, Trailer_1, Trailer_1_ObjectId, Load_Planner_ObjectId, Vehicle_Item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    Load_Planner = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName'));
    Load_Planner_ObjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    console.log(Load_Planner);
    console.log(Load_Planner_ObjectId);
    ___arguments.context.pageData['Horse_Update_Listener'] = (generateUUID().long());
    ___arguments.context.pageData['Target_Update_Listener'] = (generateUUID().long());
    ___arguments.context.pageData['Load_Update_Listener'] = (generateUUID().long());

    ;(function(whereClause) {
      const callback = async object => {
          console.log(String('Horse Update Listener Engaged ') + String(getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')));
      console.log(object);
      Horse = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c0436a52dbbfa168d9ec43af5e491832')), async (item) => {


       return ((getObjectProperty(object, 'Horse_Registration')) == (getObjectProperty(item, 'Horse_Registration')));
      }))[0];
      console.log(getObjectProperty(object, 'Horse_Registration'));
      console.log(Horse);
      Horse['Service_Due'] = (getObjectProperty(object, 'Service_Status'));
      Horse['Status'] = (getObjectProperty(object, 'Status'));
      Horse['Service_Status'] = (getObjectProperty(object, 'Service_Status'));
      if ((getObjectProperty(object, 'Trailer_1_Confirm')) == 'None') {
        Trailer = 'No Trailers Hitched';
        Horse['Trailer1_Registration.Type'] = Trailer;
      } else {
        Trailer_1 = (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(object, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)))[0];
        Trailer = (getObjectProperty(Trailer_1, 'Type'));
        Trailer_1_ObjectId = (getObjectProperty(Trailer_1, 'objectId'));
        Horse['Trailer1_Registration.Type'] = Trailer;
      }
      try {
        Payload = (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(object, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(object, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(object, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0];
        if (Payload == (getObjectProperty(Horse, 'Payload'))) {
        } else {
          await new Promise(r => setTimeout(r, 1000 || 0));
          (function (message) { alert(message) })((['Payload/Trailer Type of',' (',(getObjectProperty(object, 'Horse_Registration')),') has changed New Payload (',Payload,')'].join('')));
          Horse['Payload'] = Payload;
          console.log(Payload);
        }

      } catch (error) {
        console.log(error);

      }
      Horse['Load_Items'] = (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(object, 'Horse_Registration')),'\' AND Completion_Status = \'0\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });})));
      Horse['Driver_Name'] = ((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(object, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0]);
      Horse['Driver_Cell'] = ((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(object, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0]);

      };

      const rtHandlers = Backendless.Data.of('Vehicles').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addUpdateListener.apply(rtHandlers, options);

      getRTSubscriptions().add((getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')), () => rtHandlers.removeUpdateListener(callback));

    })((['Load_Planner_Name = \'',Load_Planner,'\''].join('')));

    ;(function(whereClause) {
      const callback = async object => {
          console.log(String('Target_Update_Listener') + String(getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')));
      console.log(object);
      Horse = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c0436a52dbbfa168d9ec43af5e491832')), async (item) => {


       return ((getObjectProperty(object, 'Vehicle_Registration')) == (getObjectProperty(item, 'Horse_Registration')));
      }))[0];
      console.log(Horse);
      if ((getObjectProperty(object, 'Ideal_Rate_Per_Tonne')) == (getObjectProperty(Horse, 'Ideal_Rate_Per_Tonne'))) {
      } else {
        Horse['Ideal_Rate_Per_Tonne'] = (getObjectProperty(object, 'Ideal_Rate_Per_Tonne'));
        (function (message) { alert(message) })((['The Ideal Rate Per Tonne For (',(getObjectProperty(object, 'Vehicle_Registration')),') Has Changed, The Rate is(R ',(getObjectProperty(object, 'Ideal_Rate_Per_Tonne')),')'].join('')));
      }
      if ((getObjectProperty(object, 'Monthly_Mileage_Target')) == (getObjectProperty(Horse, 'Target_Mileage'))) {
      } else {
        Horse['Target_Mileage'] = (getObjectProperty(object, 'Monthly_Mileage_Target'));
        (function (message) { alert(message) })((['The Monthly Mileage Target  For (',(getObjectProperty(object, 'Vehicle_Registration')),') Has Changed, The New Target is (',(getObjectProperty(object, 'Monthly_Mileage_Target')),'Km)'].join('')));
      }
      if ((getObjectProperty(object, 'Ideal_Rate_Per_Km')) == (getObjectProperty(Horse, 'Ideal_Rate_Per_Km'))) {
      } else {
        Horse['Ideal_Rate_Per_Km'] = (getObjectProperty(object, 'Ideal_Rate_Per_Km'));
        (function (message) { alert(message) })((['The Ideal Rate Per Km  For (',(getObjectProperty(object, 'Vehicle_Registration')),')  Has Changed, The Rate is (R ',(getObjectProperty(object, 'Ideal_Rate_Per_Km')),')'].join('')));
      }
      if ((getObjectProperty(object, 'Monthly_Tonnage_Target')) == (getObjectProperty(Horse, 'Target_Tonnage'))) {
      } else {
        Horse['Target_Tonnage'] = (getObjectProperty(object, 'Monthly_Tonnage_Target'));
        (function (message) { alert(message) })((['The Monthly Tonnage Target (',(getObjectProperty(object, 'Vehicle_Registration')),')  Has Changed, The New Target is ( ',(getObjectProperty(object, 'Monthly_Mileage_Target')),'t)'].join('')));
      }

      };

      const rtHandlers = Backendless.Data.of('Targets').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addUpdateListener.apply(rtHandlers, options);

      getRTSubscriptions().add((getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')), () => rtHandlers.removeUpdateListener(callback));

    })((['Load_Planner = \'',Load_Planner,'\''].join('')));

    ;(function(whereClause) {
      const callback = async object => {
          console.log(String('Loads Update Listner Engaged') + String(getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')));
      await new Promise(r => setTimeout(r, 10000 || 0));
      New_Object = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner = \'',Load_Planner,'\' AND load_reference = \'',(getObjectProperty(object, 'Load_Reference')),'\''].join(''))).setSortBy('updated').setPageSize(10)))[0];
      console.log(New_Object);
      Horse = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c0436a52dbbfa168d9ec43af5e491832')), async (item) => {


       return ((getObjectProperty(New_Object, 'Horse_Registration')) == (getObjectProperty(item, 'Horse_Registration')));
      }))[0];
      console.log(Horse);
      Load = (await asyncListFilter((getObjectProperty(Horse, 'Load_Items')), async (item) => {


       return ((getObjectProperty(New_Object, 'objectId')) == (getObjectProperty(item, 'objectId')));
      }))[0];
      console.log(Load);
      if ((getObjectProperty(New_Object, 'Completion_Status')) == '0' && (getObjectProperty(New_Object, 'Status')) == 'Loaded') {
        Load['Completion_Status'] = '0';
        Load['Status'] = 'Loaded';
        Load['tonnage'] = (getObjectProperty(New_Object, 'tonnage'));
      }
      if ((getObjectProperty(New_Object, 'Completion_Status')) == '1' && (getObjectProperty(New_Object, 'Status')) == 'Delivered') {
        console.log(getObjectProperty(Horse, 'Load_Items'));
        console.log(Load);
        removeItemInList((getObjectProperty(Horse, 'Load_Items')), Load, '');
      }

      };

      const rtHandlers = Backendless.Data.of('Load_Neg').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addCreateListener.apply(rtHandlers, options);

      getRTSubscriptions().add((getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')), () => rtHandlers.removeCreateListener(callback));

    })((['Load_Planner = \'',Load_Planner,'\''].join('')));
      }
  if (___arguments.value == false) {
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')));
    console.log(['Horse Update Listener',(getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')),' Has Been Removed'].join(''));
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')));
    console.log(['Load Update Listener ',(getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')),' Has Been Removed'].join(''));
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')));
    console.log(['Target Update Listener ',(getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')),' Has Been Removed'].join(''));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/7191640c91ca0b3913d78e26dd0a3409/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cead99be0bdaedece9df7c2a9d6b8ea', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('954b46d6c9ea7af36bbb257f4bdc46da', true);
  ___arguments.context.pageData['Locations_Viewer'] = false;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('954b46d6c9ea7af36bbb257f4bdc46da');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('954b46d6c9ea7af36bbb257f4bdc46da')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/f27fff3b399c90020ac6133c1fdf6c72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11818d94f7a748ffebda45ba3b1f9c34', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/11818d94f7a748ffebda45ba3b1f9c34/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70f22ea7660718a7648f6008cd21f70d', false);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Load_Planner/components/df93d5b76bce7ddbe206e067ed6f5f7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70f22ea7660718a7648f6008cd21f70d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/c68f5e25428df674277a321196c6989e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Due'))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Due')) == 'Service Due') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c68f5e25428df674277a321196c6989e'))['color'] = 'Yellow';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c68f5e25428df674277a321196c6989e'))['color'] = 'Green';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/6bc84bc4e2641207a144d14a91f85fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/7567e0f802bfac7fd6ce118eedd4876d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/b72d60d62ca20db16008e01f451a16e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint_Clicker')) == 1) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint_Clicker'] = 2;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint_Clicker')) == 2) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint_Clicker'] = 3;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint_Clicker')) == 3) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint_Clicker'] = 4;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint_Clicker')) == 4) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint_Clicker'] = 5;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint_Clicker')) == 5) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint_Clicker'] = 0;
  } else {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint_Clicker'] = 1;
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/31f4347cdc6c9c5c2c1e9dee906dc7de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint_Clicker')) == 5) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/7a8327552cee7922758429e1b70cb609/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint_Clicker')) >= 4) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/db0cefeb1717543431c3405420f144db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint_Clicker')) >= 3) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/275d9b63446f5242c7cd0d0489a610a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint_Clicker')) >= 2) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/beda7cd8697a8cc45e8e7c85347d9077/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint_Clicker')) >= 1) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/84b660fe945f36af0722532555944245/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/b3eac665d8d8811ead3f0ab6b7de6b32/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Add_Location')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/92bbab09d0f6fce9b395c1e64eda0a4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Add_Location'] = false;
  ___arguments.context.pageData['Location_Lists_Pre_Map'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Locations', (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join('')), null, null));
  ___arguments.context.pageData['Location_Lists'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Name')),'value': (getObjectProperty(item, 'objectId')) });})));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/2d14cae35239b3852f06b16d3ebe8ff9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ebd6661c75432d6df69e4e7244a7d53'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6ebd6661c75432d6df69e4e7244a7d53'));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6ebd6661c75432d6df69e4e7244a7d53'));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c5d29fc7581cfc111964aa46653d7813'));
  console.log((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c5d29fc7581cfc111964aa46653d7813'));
  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c5d29fc7581cfc111964aa46653d7813'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/2d420f6a06850a9d94159ee5e9b70735/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/f87a06dcebe9619cbeb2c44702ea7a44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/d676a923c4283edc92e3845b97a2620e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'CALCULATE_ROUTE_VIEWER')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var DP, Route, LP, error, WP5, WP4, WP3, WP2, WP1, item, Variable, j, LDP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Map_Function() {
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Leaflet_Map_Holder_Viewer'] = false;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Polygon'] = null;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'DeadLeg')) == true) {
    ___arguments.context.pageData['Location_Lists_Pre_Map'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Locations', (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))));
    ___arguments.context.pageData['Location_Lists'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Name')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint List'] = [];
    LDP = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


     return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c5d29fc7581cfc111964aa46653d7813')) == (getObjectProperty(item, 'objectId')));
    }))[0]), 'Point'));
    LP = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


     return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('98f6611ffd4debb5e97d456d25ad4e0b')) == (getObjectProperty(item, 'objectId')));
    }))[0]), 'Point'));
    DP = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


     return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('97ae9afce97485738f893037934ff202')) == (getObjectProperty(item, 'objectId')));
    }))[0]), 'Point'));
    try {
      WP1 = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


       return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('2e0113a9a964bbeb9dd481a47e34c0bf')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Point'));

    } catch (error) {
      console.log(error);

    }
    try {
      WP2 = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


       return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('824c54dca465ea9b2108f90cf1f633aa')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Point'));

    } catch (error) {
      console.log(error);

    }
    try {
      WP3 = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


       return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('86762cc135077ea60b46a1860983fbdc')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Point'));

    } catch (error) {
      console.log(error);

    }
    try {
      WP4 = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


       return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('2ee23293d6683fbe09d8f6cd1fe99204')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Point'));

    } catch (error) {
      console.log(error);

    }
    try {
      WP5 = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


       return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('a82eb4254d53749d09fe02e2a4a3131d')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Point'));

    } catch (error) {
      console.log(error);

    }
    try {

    } catch (error) {
      console.log(error);

    }
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Total Mileage'] = 0;
    try {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(LP, 'x')),' ',(getObjectProperty(LP, 'y'))].join('')));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(WP1, 'x')),' ',(getObjectProperty(WP1, 'y'))].join('')));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(WP2, 'x')),' ',(getObjectProperty(WP2, 'y'))].join('')));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(WP3, 'x')),' ',(getObjectProperty(WP3, 'y'))].join('')));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(WP4, 'x')),' ',(getObjectProperty(WP4, 'y'))].join('')));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(WP5, 'x')),' ',(getObjectProperty(WP5, 'y'))].join('')));

    } catch (error) {
      console.log(error);

    }
    console.log(LDP);
    console.log(DP);
    console.log(LP);
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List'));
    console.log((await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/Directions`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'origin': JSON.stringify('-29.3239701 29.9038569'),'destination': JSON.stringify('-29.3038455 29.9457389') }).send()));
    console.log((await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/Directions`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'origin': JSON.stringify(([(getObjectProperty(LDP, 'x')),' ',(getObjectProperty(LDP, 'y'))].join(''))),'destination': JSON.stringify(([(getObjectProperty(DP, 'x')),' ',(getObjectProperty(DP, 'y'))].join(''))),'waypoints': JSON.stringify(([[(getObjectProperty(DP, 'x')),' ',(getObjectProperty(DP, 'y'))].join(''), null, null].join(' | '))) }).send()));
    Route = (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/Directions`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'origin': JSON.stringify(([(getObjectProperty(LDP, 'x')),' ',(getObjectProperty(LDP, 'y'))].join(''))),'destination': JSON.stringify(([(getObjectProperty(DP, 'x')),' ',(getObjectProperty(DP, 'y'))].join(''))),'waypoints': JSON.stringify(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')).join(' | '))) }).send());
    console.log(Route);
    await new Promise(r => setTimeout(r, 500 || 0));
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Route_Distance'] = (String((await Promise.all((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'legs')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'distance')), 'value'));}))).reduce(function(x, y) {return x + y;}) / 1000) + String('km'));
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Mileage_Input'] = ((await Promise.all((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'legs')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'distance')), 'value'));}))).reduce(function(x, y) {return x + y;}) / 1000);
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Polygon'] = (await BackendlessUI.Functions.Custom['fn_8fe2c41e87941e6bf7e3c4388133e6b9']((getObjectProperty((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'overview_polyline')), 'points'))));
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['DP Lat'] = (getObjectProperty(DP, 'lng'));
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['DP Lng'] = (getObjectProperty(DP, 'lat'));
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Leaflet_Map_Holder_Viewer'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3bdceef721ecb63e9ff22b236f396079'))['opacity'] = 1;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Map Centre'] = ([String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'DP Lat')) + String('0000000'),', ',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'DP Lng')) + String('0000000')].join(''));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
      try {
        try {
          addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(LP, 'x')),' ',(getObjectProperty(LP, 'y'))].join('')));

        } catch (error) {
          console.log(error);

        }
        var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f'));
        for (var j_index in j_list) {
          j = j_list[j_index];
          Variable = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


           return ((getObjectProperty(j, 'Split Del Del Location')) == (getObjectProperty(item, 'objectId')));
          }))[0]), 'Point'));
          j['Add_Mileage_Input'] = (((getObjectProperty((getObjectProperty(((getObjectProperty(((getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/MapAPIServices/directions`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'origin': ([String(getObjectProperty(LDP, 'lng')) + String('0000000'),', ',String(getObjectProperty(LDP, 'lat')) + String('0000000')].join('')),'waypoints': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')),'destination': ([String(getObjectProperty(Variable, 'lng')) + String('0000000'),', ',String(getObjectProperty(Variable, 'lat')) + String('0000000')].join('')) })), 'routes'))[0]), 'legs'))[0]), 'distance')), 'value')) / 1000) * 1);
          ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Total Mileage'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total Mileage')) + (getObjectProperty(j, 'Add_Mileage_Input'))) * 1);
          addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(Variable, 'x')),' ',(getObjectProperty(Variable, 'y'))].join('')));
        }
        DP = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


         return ((getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).slice(-1)[0]), 'Split Del Del Location')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Point'));
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')).pop();

      } catch (error) {

      }
    }
  } else {
    ___arguments.context.pageData['Location_Lists_Pre_Map'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Locations', (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))));
    ___arguments.context.pageData['Location_Lists'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Name')),[`value`]: (getObjectProperty(item, 'objectId')) });})));
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint List'] = [];
    LDP = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


     return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c5d29fc7581cfc111964aa46653d7813')) == (getObjectProperty(item, 'objectId')));
    }))[0]), 'Point'));
    LP = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


     return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('98f6611ffd4debb5e97d456d25ad4e0b')) == (getObjectProperty(item, 'objectId')));
    }))[0]), 'Point'));
    try {
      WP1 = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


       return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('2e0113a9a964bbeb9dd481a47e34c0bf')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Point'));

    } catch (error) {
      console.log(error);

    }
    try {
      WP2 = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


       return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('824c54dca465ea9b2108f90cf1f633aa')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Point'));

    } catch (error) {
      console.log(error);

    }
    try {
      WP3 = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


       return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('86762cc135077ea60b46a1860983fbdc')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Point'));

    } catch (error) {
      console.log(error);

    }
    try {
      WP4 = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


       return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('2ee23293d6683fbe09d8f6cd1fe99204')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Point'));

    } catch (error) {
      console.log(error);

    }
    try {
      WP5 = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


       return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('a82eb4254d53749d09fe02e2a4a3131d')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Point'));

    } catch (error) {
      console.log(error);

    }
    try {
      DP = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


       return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('97ae9afce97485738f893037934ff202')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Point'));

    } catch (error) {
      console.log(error);

    }
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Total Mileage'] = 0;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
      try {
        var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f'));
        for (var j_index2 in j_list2) {
          j = j_list2[j_index2];
          Variable = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


           return ((getObjectProperty(j, 'Split Del Del Location')) == (getObjectProperty(item, 'objectId')));
          }))[0]), 'Point'));
          j['Add_Mileage_Input'] = (((getObjectProperty((getObjectProperty(((getObjectProperty(((getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/MapAPIServices/directions`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'origin': ([String(getObjectProperty(LP, 'lng')) + String('0000000'),' ',String(getObjectProperty(LP, 'lat')) + String('0000000')].join('')),'waypoints': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')),'destination': ([String(getObjectProperty(Variable, 'lng')) + String('0000000'),' ',String(getObjectProperty(Variable, 'lat')) + String('0000000')].join('')) })), 'routes'))[0]), 'legs'))[0]), 'distance')), 'value')) / 1000) * 1);
          ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Total Mileage'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total Mileage')) + (getObjectProperty(j, 'Add_Mileage_Input'))) * 1);
          addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(Variable, 'x')),' ',(getObjectProperty(Variable, 'y'))].join('')));
        }
        DP = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists_Pre_Map')), async (item) => {


         return ((getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).slice(-1)[0]), 'Split Del Del Location')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Point'));
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')).pop();

      } catch (error) {

      }
    }
    try {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(WP1, 'x')),' ',(getObjectProperty(WP1, 'y'))].join('')));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(WP2, 'y')),' ',(getObjectProperty(WP2, 'x'))].join('')));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(WP3, 'y')),' ',(getObjectProperty(WP3, 'x'))].join('')));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(WP4, 'y')),' ',(getObjectProperty(WP4, 'x'))].join('')));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')), ([(getObjectProperty(WP5, 'y')),' ',(getObjectProperty(WP5, 'x'))].join('')));

    } catch (error) {
      console.log(error);

    }
    Route = (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/Directions`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'origin': JSON.stringify(([(getObjectProperty(LP, 'x')),' ',(getObjectProperty(LP, 'y'))].join(''))),'destination': JSON.stringify(([(getObjectProperty(DP, 'x')),' ',(getObjectProperty(DP, 'y'))].join(''))),'waypoints': JSON.stringify(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint List')).join(' | '))) }).send());
    await new Promise(r => setTimeout(r, 500 || 0));
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Route_Distance'] = (getObjectProperty((getObjectProperty(((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'legs'))[0]), 'distance')), 'text'));
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Mileage_Input'] = ((getObjectProperty((getObjectProperty(((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'legs'))[0]), 'distance')), 'value')) / 1000);
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Polygon'] = (await BackendlessUI.Functions.Custom['fn_8944e9a7ffd2170577737788990e9b43'](Route));
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['DP Lat'] = (getObjectProperty(DP, 'lng'));
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['DP Lng'] = (getObjectProperty(DP, 'lat'));
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Leaflet_Map_Holder_Viewer'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3bdceef721ecb63e9ff22b236f396079'))['opacity'] = 1;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Map Centre'] = ([String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'DP Lat')) + String('0000000'),', ',String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'DP Lng')) + String('0000000')].join(''));
  }
}


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Per_Ton'] = null;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Km'] = null;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c5d29fc7581cfc111964aa46653d7813')) == '' && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('98f6611ffd4debb5e97d456d25ad4e0b')) == '') {
    } else {
      if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('98f6611ffd4debb5e97d456d25ad4e0b')) != '' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Date_Locker')) == 'Unlocked') {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Number')) > 0) {
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Number')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split Del Measure'))) {
            await Map_Function();
          }
        }
      }
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c5d29fc7581cfc111964aa46653d7813')) != '' && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('98f6611ffd4debb5e97d456d25ad4e0b')) != '' && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('97ae9afce97485738f893037934ff202')) != '') {
      await Map_Function();
    }
  }
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Leaflet_Viewer'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/c5d29fc7581cfc111964aa46653d7813/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Last DP Input')) === 'undefined') {
    Options = (getObjectProperty(___arguments.context.pageData, 'Location_Lists'));
  } else {
    Options = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return (((getObjectProperty(item, 'label')).toLowerCase()).indexOf(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Last DP Input')).toLowerCase())) !== -1);
    }));
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'LAST_DP_VIEW_NUMBER')) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'LOAD_VIEW_NUMBER')) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'DEL_VIEW_NUMBER')) == 1) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['CALCULATE_ROUTE_VIEWER'] = true;
  }
}


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LAST_DP_VIEW_NUMBER'] = 1;
  await do_something();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/6ebd6661c75432d6df69e4e7244a7d53/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c5d29fc7581cfc111964aa46653d7813', null);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Last DP Input'] = ___arguments.value;
  list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('c5d29fc7581cfc111964aa46653d7813'));
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Last DP Input Label'] = (getObjectProperty((list[0]), 'label'));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c5d29fc7581cfc111964aa46653d7813', (getObjectProperty((list[0]), 'value')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/3906d265a7b4804da31ff407759140cb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('98f6611ffd4debb5e97d456d25ad4e0b', null);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Load Input'] = ___arguments.value;
  list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('98f6611ffd4debb5e97d456d25ad4e0b'));
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Load Label'] = (getObjectProperty((list[0]), 'label'));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('98f6611ffd4debb5e97d456d25ad4e0b', (getObjectProperty((list[0]), 'value')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/1864e5d636b8ac0fba532824d198c088/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('2e0113a9a964bbeb9dd481a47e34c0bf', null);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint 1 Input'] = ___arguments.value;
  list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('2e0113a9a964bbeb9dd481a47e34c0bf'));
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint 1 label'] = (getObjectProperty((list[0]), 'label'));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('2e0113a9a964bbeb9dd481a47e34c0bf', (getObjectProperty((list[0]), 'value')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/83ad6a4d749b2d9efcf43437767f7f45/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('824c54dca465ea9b2108f90cf1f633aa', null);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint 2 Input'] = ___arguments.value;
  list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('824c54dca465ea9b2108f90cf1f633aa'));
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint 2 label'] = (getObjectProperty((list[0]), 'label'));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('824c54dca465ea9b2108f90cf1f633aa', (getObjectProperty((list[0]), 'value')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/5dac66879ca8c61b5e716a17f706f345/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('86762cc135077ea60b46a1860983fbdc', null);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint 3 Input'] = ___arguments.value;
  list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('86762cc135077ea60b46a1860983fbdc'));
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint 3 label'] = (getObjectProperty((list[0]), 'label'));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('86762cc135077ea60b46a1860983fbdc', (getObjectProperty((list[0]), 'value')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/f4d157f3c36bd3bf4b8c86051bdbb365/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('2ee23293d6683fbe09d8f6cd1fe99204', null);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint 4 Input'] = ___arguments.value;
  list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('2ee23293d6683fbe09d8f6cd1fe99204'));
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint 4 label'] = (getObjectProperty((list[0]), 'label'));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('2ee23293d6683fbe09d8f6cd1fe99204', (getObjectProperty((list[0]), 'value')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/9b0baa375effb30f95bb822cc6c30923/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a82eb4254d53749d09fe02e2a4a3131d', null);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint 5 Input'] = ___arguments.value;
  list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('a82eb4254d53749d09fe02e2a4a3131d'));
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Waypoint 5 label'] = (getObjectProperty((list[0]), 'label'));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a82eb4254d53749d09fe02e2a4a3131d', (getObjectProperty((list[0]), 'value')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/a1b95d83f9cb44fa4fb3a0b6b1630a87/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('97ae9afce97485738f893037934ff202', null);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Delivery Point Input'] = ___arguments.value;
  list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('97ae9afce97485738f893037934ff202'));
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Delivery Point label'] = (getObjectProperty((list[0]), 'label'));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('97ae9afce97485738f893037934ff202', (getObjectProperty((list[0]), 'value')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/98f6611ffd4debb5e97d456d25ad4e0b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Load Input')) === 'undefined') {
    Options = (getObjectProperty(___arguments.context.pageData, 'Location_Lists'));
  } else {
    Options = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return (((getObjectProperty(item, 'label')).toLowerCase()).indexOf(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Load Input')).toLowerCase())) !== -1);
    }));
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'LAST_DP_VIEW_NUMBER')) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'LOAD_VIEW_NUMBER')) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'DEL_VIEW_NUMBER')) == 1) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['CALCULATE_ROUTE_VIEWER'] = true;
  }
}


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['LOAD_VIEW_NUMBER'] = 1;
  await do_something();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/2e0113a9a964bbeb9dd481a47e34c0bf/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint 1 Input')) === 'undefined') {
    Options = (getObjectProperty(___arguments.context.pageData, 'Location_Lists'));
  } else {
    Options = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return (((getObjectProperty(item, 'label')).toLowerCase()).indexOf(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint 1 Input')).toLowerCase())) !== -1);
    }));
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/824c54dca465ea9b2108f90cf1f633aa/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint 2 Input')) === 'undefined') {
    Options = (getObjectProperty(___arguments.context.pageData, 'Location_Lists'));
  } else {
    Options = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return (((getObjectProperty(item, 'label')).toLowerCase()).indexOf(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint 2 Input')).toLowerCase())) !== -1);
    }));
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/86762cc135077ea60b46a1860983fbdc/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint 3 Input')) === 'undefined') {
    Options = (getObjectProperty(___arguments.context.pageData, 'Location_Lists'));
  } else {
    Options = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return (((getObjectProperty(item, 'label')).toLowerCase()).indexOf(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint 3 Input')).toLowerCase())) !== -1);
    }));
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/2ee23293d6683fbe09d8f6cd1fe99204/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint 4 Input')) === 'undefined') {
    Options = (getObjectProperty(___arguments.context.pageData, 'Location_Lists'));
  } else {
    Options = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return (((getObjectProperty(item, 'label')).toLowerCase()).indexOf(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint 4 Input')).toLowerCase())) !== -1);
    }));
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/a82eb4254d53749d09fe02e2a4a3131d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint 1 Input')) === 'undefined') {
    Options = (getObjectProperty(___arguments.context.pageData, 'Location_Lists'));
  } else {
    Options = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return (((getObjectProperty(item, 'label')).toLowerCase()).indexOf(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Waypoint 5 Input')).toLowerCase())) !== -1);
    }));
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/97ae9afce97485738f893037934ff202/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Delivery Point Input')) === 'undefined') {
    Options = (getObjectProperty(___arguments.context.pageData, 'Location_Lists'));
  } else {
    Options = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return (((getObjectProperty(item, 'label')).toLowerCase()).indexOf(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Delivery Point Input')).toLowerCase())) !== -1);
    }));
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'LAST_DP_VIEW_NUMBER')) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'LOAD_VIEW_NUMBER')) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'DEL_VIEW_NUMBER')) == 1) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['CALCULATE_ROUTE_VIEWER'] = true;
  }
}


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['DEL_VIEW_NUMBER'] = 1;
  await do_something();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/169e34d31baed31ea1657cd61687ace3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/fb79b41aafa40a22e6c9b402dac42642/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/2a57056448fb930829fe93bf6315b08f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/31bfded3ba8352711b5ca01153d2c038/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/674d23d7af2d375b88686f981cd79572/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/d32d7b8912f163920ba84002dc9c3fcc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c1414fdb18113ada232fba4a048b39b4', null);
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Delivery Point Input'] = ___arguments.value;
  list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('c1414fdb18113ada232fba4a048b39b4'));
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Delivery Point label'] = (getObjectProperty((list[0]), 'label'));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c1414fdb18113ada232fba4a048b39b4', (getObjectProperty((list[0]), 'value')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/c1414fdb18113ada232fba4a048b39b4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Delivery Point Input')) === 'undefined') {
    Options = (getObjectProperty(___arguments.context.pageData, 'Location_Lists'));
  } else {
    Options = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Location_Lists')), async (item) => {


     return (((getObjectProperty(item, 'label')).toLowerCase()).indexOf(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Delivery Point Input')).toLowerCase())) !== -1);
    }));
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'LAST_DP_VIEW_NUMBER')) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'LOAD_VIEW_NUMBER')) == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'DEL_VIEW_NUMBER')) == 1) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['CALCULATE_ROUTE_VIEWER'] = true;
  }
}


  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Counter_5'] = 1;
  if ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Counter_5'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Number'))) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['DEL_VIEW_NUMBER'] = 1;
    await do_something();
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Split Del Measure')) == 1) {
  } else {
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split Del Measure'] = 1;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split Del Measure'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split Del Measure')) + 1);
  }
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split Del Del Location'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Qouted_Split_Del_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = undefined;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner/components/e66248e260d54b6c440c88f12138cb04/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = null;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = null;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Input_Rate_Per_Ton'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/d7a90dc1fd0453c9104a9d3c4c9f012b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = null;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Input_Rate_Km'] = null;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = null;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/f39a8c55db83b969c4d40a0c61ca61e3/bundle.js', [], () => ({
  /* content */
  /* handler:centerHandler */
  ['centerHandler'](___arguments) {
    var Centre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Map Centre')) === 'undefined') {
    Centre = '-30.830891, 30.387148';
  } else {
    Centre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Map Centre'));
  }

  return Centre

  },
  /* handler:centerHandler */
  /* handler:polygonsHandler */
  ['polygonsHandler'](___arguments) {
    var Polygon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Polygon')) == null) {
    Polygon = 0;
  } else {
    Polygon = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Polygon'));
  }

  return Polygon

  },
  /* handler:polygonsHandler */
  /* content */
}))

define('./pages/Load_Planner/components/3bdceef721ecb63e9ff22b236f396079/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Leaflet_Map_Holder_Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/e4511f8b52d3cfe7ff3dba559517740c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Locations_Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/8e7f40a4b5bef801d2ff62acf8f677a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cead99be0bdaedece9df7c2a9d6b8ea', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('954b46d6c9ea7af36bbb257f4bdc46da', false);
  ___arguments.context.pageData['Locations_Viewer'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/beb5f4bca531ff83608edd949fbf4669/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d5061997c19738978bc7b17ae3656e04'), 'Truck_Item_Viewer')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('d5061997c19738978bc7b17ae3656e04')['Truck_Item_Viewer'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/c07b37ac8aba7a23c1c4c0ad022a9d4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d5061997c19738978bc7b17ae3656e04'), 'Truck_Item_Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('d5061997c19738978bc7b17ae3656e04')['Truck_Item_Viewer'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/de226312e48fb385d185f663681e4541/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d5061997c19738978bc7b17ae3656e04'), 'Horse_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner/components/e87f61d85566b4298b057c5f7c45b0cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'image')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/cfcd9c4cb965d5ff11a631d4b77bba5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'image 2')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/cc6deaeb458235db6ff43c5e0c072ce1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'image 3')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner/components/55f1e74e9761ca0c064a08bb86021955/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'image')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/dac77a1a4f719e4c49120454a44f393c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Per_Ton'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Km'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = null;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/5188840eb28a56c19829cfa5085520ac/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Mileage_Input'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Mileage_Locker'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/a5155b854c9e5afccdcd9b4374227a34/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Product_Input'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/61e90b598149fccdeb7cf5760948d64a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Hider'] = true;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e90b598149fccdeb7cf5760948d64a', false);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/7bae0001628e6848b62a49557f170be8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Horse, New_Load, New_Customer, New_Customer_Customer, Vehicle_Item, item, Rate_Per_Km, Rate_Per_Tonne, Loads_Repeater;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Loads_Populator() {
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Total_Mileage': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))),'Total_Revenue': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))),'Total_Tonnage': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? 'Service Due' : 'All in Order','Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],'Target_Mileage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],'Target_Tonnage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],'Ideal_Rate_Per_Tonne': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),'Planned_Rate_Per_Km': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);
}

/**
 * Describe this function...
 */
async function Clear_Inputs() {
  for (var count = 0; count < 3; count++) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Ref_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Point_Text'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Product_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Del_Point_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Mileage_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Ratio'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Rate'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Summed_Split_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = undefined;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e90b598149fccdeb7cf5760948d64a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7bae0001628e6848b62a49557f170be8', true);
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Hider'] = null;
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('976f92e310c25237dfd7fa8d90c39755', null);

    } catch (error) {

    }
  }
}

/**
 * Describe this function...
 */
async function Rate_Per_Km2() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) == null) {
    Rate_Per_Km = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Km'));
  } else {
    Rate_Per_Km = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km'));
  }
  return Rate_Per_Km
}

/**
 * Describe this function...
 */
async function Rate_Per_Tonne2() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null) {
    Rate_Per_Tonne = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Per_Ton'));
  } else {
    Rate_Per_Tonne = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton'));
  }
  return Rate_Per_Tonne
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', true);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;
  New_Load = (await Backendless.Data.of('Loads').save( ({ 'Split_Load_Reference': (generateUUID().long()),'Transporter': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Hauler')),'Load_Planner': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName')),'ownerId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'owner_objectId')),'Ideal_RKm': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')),'Driver': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Driver_Name')),'Payload': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload')),'Horse_Registration': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'Customer_Name': (getObjectProperty((await Backendless.Data.of('Tier_2_Customer').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('976f92e310c25237dfd7fa8d90c39755')), )), 'Customer')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'Completion_Status': '0','Split_Load': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Load_Checked')),'Split_Load2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Load_Checked')),'Planned_Delivery_Date_Time': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Delivery_Date_Time2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'tonnage': null,'tonnage2': null,'Status': null,'Status2': null,'Planned_Load': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Load2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Delivery': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Delivery')),'load_reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),'load_reference2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),'Product': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),'Product2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),'Planned_Tonnage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Tonnage_Input')),'Planned_Tonnage2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Tonnage_Input')),'load_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Point_Text')),'load_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Point_Text')),'delivery_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Del_Point_Input')),'delivery_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Del_Point_Input')),'mileage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')),'mileage2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')),'Rate_Per_Tonne': await Rate_Per_Tonne2(),'Rate_Per_Tonne2': await Rate_Per_Tonne2(),'Rate_Per_Km': await Rate_Per_Km2(),'Rate_Per_Km2': await Rate_Per_Km2() }) ));
  New_Customer = (await Backendless.Data.of('Tier_2_Customer').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('976f92e310c25237dfd7fa8d90c39755')), ));
  New_Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'objectId')), ));
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Customer', [New_Customer]);
  New_Customer_Customer = (getObjectProperty(New_Customer, 'Customer'));
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [New_Horse]);
  await Loads_Populator();
  await new Promise(r => setTimeout(r, 3000 || 0));
  await Clear_Inputs();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Button_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/fe9339d55bffe2182175d6fcedf6551f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error, item, Overlapping_Loads, TotalT;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TotalT = (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Total')) === 'number' && !isNaN((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Total')))) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Total')) : 0;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Tonnage_Input'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;
  if (___arguments.value + TotalT > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f8cc858421f9b9e031dc26cab845fa'))['backgroundColor'] = 'rgba(255, 0, 0, 0.43)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f8cc858421f9b9e031dc26cab845fa'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  }

  },
  /* handler:onChange */
  /* handler:onPlaceholderAssignment */
  onPlaceholderAssignment(___arguments) {
    var Display_Tonnage, Tonnage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Summed_Split_Del'));
    Tonnage = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Summed_Split_Del'));
    if (Tonnage > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f8cc858421f9b9e031dc26cab845fa'))['backgroundColor'] = 'rgba(255, 0, 0, 0.43)';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f8cc858421f9b9e031dc26cab845fa'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
    }
    Display_Tonnage = 't';
  } else {
    Display_Tonnage = 't';
  }

  return Display_Tonnage

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/47ed825e9d162645c0ffc9a4b42285a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Add_Load_Load_Ref_Input')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Product_Input')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Add_Load_Load_Point_Text')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Add_Load_Del_Point_Input')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Add_Mileage_Input')) != null) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7f47209559dcccb8b0d1f91955d37a95', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7f47209559dcccb8b0d1f91955d37a95', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Load_Check_State')) == 'Yes') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) == null) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) != null) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) == null) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) * 1000) / 1000);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) != null) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'))) * 1000) / 1000);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) != null) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = (Math.round((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input'))) * 1000) / 1000);
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Km')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'green';
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Km')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'Red';
      }
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) == null) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) != null) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) == null) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) * 1000) / 1000);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) != null) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'))) * 1000) / 1000);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) != null) {
      console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton'));
      console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input'));
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = (Math.round((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Input_Rate_Per_Ton'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Mileage_Input'))) * 1000) / 1000);
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Km')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'green';
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Km')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'Red';
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Input')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f8cc858421f9b9e031dc26cab845fa'))['backgroundColor'] = 'Red';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Km')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'Red';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Calculated_Rate_Km')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'rgba(255, 255, 255, 0.0)';
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Del_Date_Locker')) == false && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Mileage_Locker')) == false) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/bb5e61736219d3cef0f157fe612a0469/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Per_Ton'] = null;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Rate_Km_Work'] = null;
  ___arguments.context.dataModel['Split_Load_List'] = [];

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Add_Load_Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Hider')) == true) {
    Add_Load_Hider = true;
  } else {
    Add_Load_Hider = false;
  }

  return Add_Load_Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/469b966455bdd35a3006484bda3f23d5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Status'))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Status')) == 'Active') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('469b966455bdd35a3006484bda3f23d5'))['color'] = 'Green';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('469b966455bdd35a3006484bda3f23d5'))['color'] = 'Red';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/0a33dd811b61d377a27efac1e0cb7b47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/7a5231e82088f89d398bb5f8e97dfd09/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Trailer1_Registration.Type'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/3a61a5179d7e8694a6da6b541d079404/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/08c94e7aad78278c6d823ebf0dd8bd71/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/9557a8a22746d6370ccaec4b2bac2191/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Driver_Name'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/a7348e5a4edfe202337cdab9a242ef19/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Driver_Cell'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/d0338f4381ec7ca78be460a88597e517/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Owner_Name'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/50ccd705e23e1ca37fcd60418c5ce28e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Owner_Cell'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/7a31ba9c6c02a3874564c73b9d036347/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Load_Items'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/f7444bace24b713919d96307c681c483/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Date'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Delivery_Date_Time')) == null ? String(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Load2')))).slice(0, 15) : String(new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Delivery_Date_Time')))).slice(0, 15));

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Date'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/ce9c6c8871f6e1e8ebfb3488c8c7abe9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Customer_Selector'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Customer_Select_Edit'] = ___arguments.value;
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2'))['value'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/43f855dbbb51ad2191f1c5cd617c9861/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/378f90ec32729d3b247b8d764d36f8fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == null) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['mileage2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['mileage2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/206c143f4db64213a40f0fdfe4296b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onMinDateAssignment */
  onMinDateAssignment(___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/a9417e859d8f1b5dbc42e424b0ef6598/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Del_Point_Input'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/7b7dfbae837b7aa8982e970e1a6c0e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Load_Point_Text'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/963a5ef384b99b2e118f782debfaa5b9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Load_Ref_Input'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/976f92e310c25237dfd7fa8d90c39755/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var Customer_Selector;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Customer_Selector')) === 'undefined') == true) {
    Customer_Selector = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Customer_Selector'));
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Customer_Selector'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Customer_Selector'));
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Customer_Selector')).length > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Customer_Selector')).length) {
      Customer_Selector = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Customer_Selector'));
    } else {
      Customer_Selector = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Customer_Selector'));
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Customer_Selector'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Customer_Selector'));
    }
  }

  return (getObjectProperty(___arguments.context.pageData, 'Customer_Selector'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/104b6042b412922c8545961ade73b86c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Button_Hider'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Km'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Input_Rate_Per_Ton'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = null;
  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'rgba(255, 0, 0, 0.43)';
  }
  if (___arguments.value >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'rgba(0, 150, 3, 0.43)';
  }
  if (___arguments.value == null) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'rgba(255, 255, 255, 0.0)';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/11e63e484cdf3ed9d30ef8d21a0c6d1e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Overlapping_Loads, Load_Items;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Total'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Remaining_Tonnage'] = undefined;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22f75797a1257312a4f28ed523462d73', []);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')) > (new Date((new Date()).getTime() - (300 * 1000)))) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = 'Unlocked';
  }
  Load_Items = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Load_Items'));
  Overlapping_Loads = (await asyncListFilter(Load_Items, async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')) >= (getObjectProperty(item, 'Planned_Load')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')) <= (getObjectProperty(item, 'Planned_Delivery')));
  }));
  if (Overlapping_Loads.length > 1) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = true;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = false;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22f75797a1257312a4f28ed523462d73', Overlapping_Loads);
  }
  if (Overlapping_Loads.length == 1) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = true;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = false;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22f75797a1257312a4f28ed523462d73', Overlapping_Loads);
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Ref'] = (getObjectProperty((Overlapping_Loads[0]), 'load_reference'));
  }
  if (Overlapping_Loads.length == 0) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = false;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = false;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = false;
  }
  try {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Total'] = ((await Promise.all(Overlapping_Loads.map(async item => {; return (getObjectProperty(item, 'Planned_Tonnage'));}))).reduce(function(x, y) {return x + y;}));
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Remaining_Tonnage'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Total')));

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  onMinDateAssignment(___arguments) {
      return (new Date((new Date((new Date())).getTime())))

  },
  /* handler:onMinDateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/fe33d4dd6ba56bbc585ea5aaade8a28a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Vehicle_Item, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Loads_Populator() {
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? 'Service Due' : 'All in Order','Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (getObjectProperty(item, 'Payload')),'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),'Planned_Rate_Per_Km': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);
}


  if (___arguments.value == 'Delete') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', true);
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load')) == true) {
      await Backendless.Data.of('Loads').bulkDelete( (['Split_Load_Reference = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load_Reference')),'\''].join('')) );
    } else {
      await Backendless.Data.of('Loads').remove( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'objectId')) );
    }
    console.log('Start Sequence');
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Delete_Reset'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_True'] = false;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_False'] = true;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide3'] = false;
    await Loads_Populator();
    console.log('End Sequense');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/b4219f68336213a341e88a6a6a62a7b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Customer, Update_Load, Old_Customer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', true);
  console.log('1');
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  Update_Load = (await Backendless.Data.of('Loads').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'objectId')), ));
  console.log('2');
  Update_Load['Rerouted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check'));
  Update_Load['Split_Load'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load2'));
  Update_Load['Planned_Load'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Load2'));
  Update_Load['Planned_Delivery'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Delivery2'));
  Update_Load['load_reference'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'load_reference2'));
  Update_Load['Product'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Product2'));
  Update_Load['Planned_Tonnage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2'));
  Update_Load['load_point'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'load_point2'));
  Update_Load['delivery_point'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'delivery_point2'));
  Update_Load['mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2'));
  Update_Load['Rate_Per_Tonne'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2'));
  Update_Load['Rate_Per_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2'));
  try {
    New_Customer = [(await Backendless.Data.of('Tier_2_Customer').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ce9c6c8871f6e1e8ebfb3488c8c7abe9')), ))];

  } catch (error) {

  }
  try {
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ce9c6c8871f6e1e8ebfb3488c8c7abe9')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'value'))) {
      console.log('State 2');
      Old_Customer = [(await Backendless.Data.of('Tier_2_Customer').findById((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'value')), ))];
      await Backendless.Data.of('Loads').setRelation(Update_Load, 'Customer', New_Customer);
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2'))['label'] = (getObjectProperty((New_Customer[0]), 'Customer'));
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['label'] = (getObjectProperty((New_Customer[0]), 'Customer'));
      console.log('State 3.1');
    } else {
      console.log('State 3');
      Old_Customer = [(await Backendless.Data.of('Tier_2_Customer').findById((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'value')), ))];
      await Backendless.Data.of('Loads').setRelation(Update_Load, 'Customer', New_Customer);
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2'))['label'] = (getObjectProperty((New_Customer[0]), 'Customer'));
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['label'] = (getObjectProperty((New_Customer[0]), 'Customer'));
      console.log('State 3.1');
    }

  } catch (error) {

  }
  console.log('State 1');
  console.log('State 4');
  Update_Load['Customer_Name'] = (getObjectProperty((New_Customer[0]), 'Customer'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide2'] = true;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide3'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_False'] = true;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_True'] = false;
  await Backendless.Data.of('Loads').save( Update_Load );
  console.log('State 5');
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == 'Loaded') {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = false;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = true;
    } else {
      Disabler = false;
    }
  } else {
    Disabler = false;
  }

  return Disabler

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/a20c1cdd5cb2c6ee3d01e5660f5b8ae5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == null) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/63ad9f3746536bb61cb7134645d6d09e/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['Add_Load_Hider'] = false;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/7a4ee66c1ab7014a1737fa1210c724d1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var Overlapping_Loads, item, Load_Items;


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Delivery'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Del_Date_Locker'] = false;

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  onMinDateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date'))).getTime())))

  },
  /* handler:onMinDateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Date_Locker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Date_Locker')) == null) {
    Date_Locker = true;
  } else {
    Date_Locker = false;
  }

  return Date_Locker

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/07c5c236032eee4eb474df37512b9d9f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')) !== null && !Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2'))) && (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')) === 'object')) {
    Customer = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'label'));
  } else {
    Customer = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2'));
  }

  return Customer

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/0576e6e91b465ba1fb52b16f9fece693/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onMinDateAssignment */
  onMinDateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Load2'))).getTime())))

  },
  /* handler:onMinDateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/21ceb6af10e809125c5d8e5789786d5a/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    var Load_Items, item, object;

  },
  /* handler:onMounted */
  /* handler:onStyleAssignment */
  onStyleAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Loaded') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('21ceb6af10e809125c5d8e5789786d5a'))['backgroundColor'] = 'rgba(255, 60, 0, 0.25)';
    ___arguments.context.dataModel['Loaded_Tonnage'] = true;
  } else if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Delivered') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21ceb6af10e809125c5d8e5789786d5a', false);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('21ceb6af10e809125c5d8e5789786d5a'))['backgroundColor'] = 'rgba(119, 119, 119, 0.25)';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/90daec64a60ea96f9c3a46b32d029299/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Disabler = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/5d277a486e57499e635441e5bc55e977/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/0ce95513837197c76807166bbe9459d2/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/6becd84feb725b91d826f2ab729ae3b2/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('442a911b71cb646130171fd7ea6f7aa1'))['backgroundColor'] = 'rgba(255, 0, 0, 0.40)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2')) <= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('442a911b71cb646130171fd7ea6f7aa1'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == null) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  async onValueAssignment(___arguments) {
    var Planned_Tonnage, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('7a31ba9c6c02a3874564c73b9d036347')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load_Reference')) == (getObjectProperty(item, 'Split_Load_Reference')));
    }));
    Planned_Tonnage = (await Promise.all((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('7a31ba9c6c02a3874564c73b9d036347')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load_Reference')) == (getObjectProperty(item, 'Split_Load_Reference')));
    })).map(async item => {; return (getObjectProperty(item, 'Planned_Tonnage2'));}))).reduce(function(x, y) {return x + y;}) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2'));
  } else {
    Planned_Tonnage = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2'));
  }

  return Planned_Tonnage

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/e24753f5be04b561701c67b2f21443e1/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == null) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/cc364e23a98ad58d59aab8f3ed4439c3/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  } else {
    Disabler = true;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == null) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = null;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/e882dee9e7f71c17e3263b958de2ee2c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
      Disabler = true;
    } else {
      Disabler = false;
    }
  } else {
    Disabler = false;
  }

  return Disabler

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == 'Loaded') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) == null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'tonnage'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) == null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'tonnage'))) * 1000) / 1000);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) != null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = (Math.round((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'tonnage')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2'))) * 1000) / 1000);
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) == null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) == null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2'))) * 1000) / 1000);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2')) != null) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = (Math.round((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne2'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage2'))) * 1000) / 1000);
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(0, 128, 0, 0.40)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 0, 0, 0.40)';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km2')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Calculated')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/3a99be020b0ca03ae3abb24d74358165/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('976f92e310c25237dfd7fa8d90c39755', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/34ea13f2d2b322e7869899567cb6915f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('976f92e310c25237dfd7fa8d90c39755', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/3b87e41e107b73bd07217bbfa49e032d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Customer_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/077bdb9d14cdc9176f9ccb7c4d9eae26/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['New_Customer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/6d321472aac6b50d0bf28d389af1f4f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, New_Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  New_Customer = (await Backendless.Data.of('Tier_2_Customer').save( ({ 'Customer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'New_Customer')),'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Customer_Selector'] = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });})));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('976f92e310c25237dfd7fa8d90c39755', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/bef2b148d0f5d945b7e785cedf8e1104/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Add_Customer_Hider2'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/cc78ee7ab7f175db8e375a0af70e30f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['New_Customer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/8a02e1d2b8fb29d678c11ce46298da8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Add_Customer_Hider2'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa4df345d69ffeb7a8f7aa1a45268187', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/92e7fd9a12b744fec03ca2464344d97e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, New_Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  New_Customer = (await Backendless.Data.of('Tier_2_Customer').save( ({ 'Customer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'New_Customer')),'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  await new Promise(r => setTimeout(r, 2000 || 0));
  ___arguments.context.pageData['Customer_Selector'] = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });})));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Add_Customer_Hider2'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/4c250386b1ee75c2a863ab589d1f19b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('48356f8f9959eaf9c45c1587e07f3b9f'), 'Planned_Load')))).toString()).slice(3, 21))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/175a85befe5cadb63eeb2ef462ec62b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('94852f4aaf0ac272e8483081c04537fa'), 'Planned_Delivery')))).toString()).slice(3, 21))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/35d47ac26f7a420e2cd4678cfce884d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Warning_Hider_1'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/dc6b284859894b79508b31b83b033d8d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Warning_Hider_2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/c3967fd1d8756cab2e9f2508502984c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/d39ac0f6b29393cb64b1f38d9d835a77/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Planned_Tonnage_Total')) * 1000) / 1000)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/22f75797a1257312a4f28ed523462d73/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/b75a5e06be0af2d810ce1442eb222d81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Hider'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/713a708f72fa7c02cc4c0221f5bd2ec8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Add_Load_Load_Ref_Input')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Add_Load_Load_Point_Text')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Product_Input')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Date_Locker')) == 'Unlocked') {
      Hider = true;
    }
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
    var Split_Delivery_Repeater_adder, item;

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Del_Number'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = ___arguments.value;
  Split_Delivery_Repeater_adder = listsRepeat('New_Split_Del', ___arguments.value);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Repeater'] = (await Promise.all(Split_Delivery_Repeater_adder.map(async item => {; return ({ 'Planned_Tonnage_Input': undefined,'Horse_Registration': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'Customer_Name': undefined,'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': undefined,'tonnage2': undefined,'Status': undefined,'Status2': undefined,'Split_Load': undefined,'Split_Load2': undefined,'objectId': undefined,'Planned_Load': undefined,'Planned_Load2': undefined,'Planned_Delivery_Date_Time': undefined,'Planned_Delivery_Date_Time2': undefined,'Planned_Delivery': undefined,'Planned_Delivery2': undefined,'Customer': undefined,'Customer2': undefined,'load_reference': undefined,'load_reference2': undefined,'Product': undefined,'Product2': undefined,'Planned_Tonnage': undefined,'Planned_Tonnage2': undefined,'load_point': undefined,'load_point2': undefined,'delivery_point': undefined,'delivery_point2': undefined,'mileage': undefined,'mileage2': undefined,'Rate_Per_Tonne': undefined,'Rate_Per_Tonne2': undefined,'Rate_Per_Km': undefined,'Rate_Per_Km2': undefined });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Repeater')));

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number'));

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/91abd94c4cf682f3f2f976c21287a5e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Load_Checked')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == false && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Load_Checked')) == true) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = undefined;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == false) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Del_Calc'] = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Del_Calc'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/3b51a2fdba0802319f3c4e6fb6d58342/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/9d37270f0ec9bd16b7bcb371ef96d04a/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/c32667bec55a8ca3c877a8e4cd56c06b/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    
  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/d86e3ce834488b272b3292f8306a5868/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  onMinDateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Date((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date'))).getTime())))

  },
  /* handler:onMinDateAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Date_Locker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == true) {
    Date_Locker = true;
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Date_Locker')) == null) {
      Date_Locker = true;
    } else {
      Date_Locker = false;
    }
  }

  return Date_Locker

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Planned_Delivery'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Del_Date_Locker'] = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Counter_3'] = 1;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/f5139f61c741aae2e394cbf24c082601/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['New_Customer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/ffad665e6c02eb123d43983727cd60d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, New_Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  New_Customer = (await Backendless.Data.of('Tier_2_Customer').save( ({ 'Customer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'New_Customer')),'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Customer_Selector'] = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });})));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Customer_Selector'));
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Add_Customer_Hider'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21e9b85527523a69c4828f52037add1d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/d6fb77229d4422c7f5bcc385ccc1f9d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Add_Customer_Hider'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21e9b85527523a69c4828f52037add1d', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == true) {
    Hider = false;
  } else {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/a2e77ffb0587dae7c61440b5b1d8c227/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Qouted_Split_Del_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = undefined;
  }
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = false;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Planned_Delivery_Tonnage'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Summed_Split_Del'] = ((await Promise.all((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')), async (item) => {


   return ((getObjectProperty(item, 'Planned_Delivery_Tonnage')) != null);
  })).map(async item => {; return (getObjectProperty(item, 'Planned_Delivery_Tonnage'));}))).reduce(function(x, y) {return x + y;}));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Counter_2'] = 1;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Date_Locker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == true) {
    Date_Locker = true;
  } else {
    Date_Locker = false;
  }

  return Date_Locker

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/5f14188b0a8201138a2d59674a94df29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Add_Customer_Hider'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21e9b85527523a69c4828f52037add1d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/c8eeb4eb82d4c151573c2edc8a244774/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Customer_Selector'))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Qouted_Split_Del_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = undefined;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Counter_4'] = 1;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/dc9321e27708c74e057c327f15f7e933/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Point_Text'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/d24596e234bb1ea3e0dd5c7136563783/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Qouted_Split_Del_Load'] = 1;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Split_Load_Check_State')) == 'Yes') {
    console.log('3');
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) == null) {
      console.log('4');
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'));
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) != null) {
      console.log('5');
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) == null) {
      console.log('6');
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'));
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
      console.log('7');
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) != null) {
      console.log('8');
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) != null) {
      console.log('9');
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = (Math.round((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Km')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'green';
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Km')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'Red';
      }
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) == null) {
      console.log('10');
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'));
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) != null) {
      console.log('11');
      console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input'));
      console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
      console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input'));
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) == null) {
      console.log('12');
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Planned_Tonnage_Input'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'));
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
      console.log('13');
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Payload'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) != null) {
      console.log('14');
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton')) != null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Km')) == null && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) != null) {
      console.log('15');
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = (Math.round((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Input_Rate_Per_Ton'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input'))) * 1000) / 1000);
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Quote'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')));
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Km')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'green';
      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Km')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'Red';
      }
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Payload'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5f8cc858421f9b9e031dc26cab845fa'))['backgroundColor'] = 'Red';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Km')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'Red';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Km')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('368b7ac2bb4ebb4ab90ec2c3fca916c8'))['backgroundColor'] = 'rgba(255, 255, 255, 0.0)';
    }
  }
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Viewer, Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == true) {
      console.log('Spar');
      Hider = false;
    } else {
      Viewer = true;
    }
  } else {
    Viewer = false;
    console.log('Shoprite');
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/b3d63eac1c9394e23719751f7c929d56/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Qouted_Split_Del_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = undefined;
  }
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = false;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Add_Mileage_Input'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Mileage_Locker'] = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Counter'] = 1;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Mileage'] = ___arguments.value;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/2e2520e62252cda94727807b50242bbb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  async onValueAssignment(___arguments) {
    var Value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calulated_Split_Del')) == true) {
    Value = Math.round(((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calculated_Split_Del_Rate')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calculated_Ratio'))) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));})))))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input'))) * 100) / 100;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km_Del'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/2b1ab5d44c99092931965721fdd92139/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  async onValueAssignment(___arguments) {
    var Value, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calulated_Split_Del')) == true) {
    Value = Math.round((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')) * ((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calculated_Split_Del_Rate')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calculated_Ratio'))) * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));})))))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input'))) * 100) / 100;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Quote_Value'] = (Value * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/04166d64515e0b63302f06b56c4c17c4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    Hider = false;
  } else {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Input_Rate_Km'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/28032a3d34aecb161aedaded240e5bb2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    Hider = false;
  } else {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Input_Rate_Per_Ton'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/233c65027ebdc81ba635dddb76d93103/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Planned_Tonnage_Input'));}))).reduce(function(x, y) {return x + y;}));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Reference'] = (generateUUID().long());
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = true;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = true;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Ratio'] = ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));}))).reduce(function(x, y) {return x + y;}) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));})))));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Rate'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Km')) * Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));})))));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = true;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = true;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['New_Loads_List'] = undefined;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var Hider, Item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  try {
    if ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async Item => {; return (getObjectProperty(Item, 'Split_Del_Counter'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) && (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async Item => {; return (getObjectProperty(Item, 'Split_Del_Counter_2'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) && (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async Item => {; return (getObjectProperty(Item, 'Split_Del_Counter_3'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) && (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async Item => {; return (getObjectProperty(Item, 'Split_Del_Counter_4'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) && (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async Item => {; return (getObjectProperty(Item, 'Split_Del_Counter_5'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number'))) {
      Hider = true;
    } else {
      Hider = false;
    }

  } catch (error) {

  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/368b7ac2bb4ebb4ab90ec2c3fca916c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/9287a56e1d34f5713d433272e89aa576/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Horse, New_Load, Load_Items, item, Vehicle_Item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Loads_Populator() {
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Total_Mileage': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))),'Total_Revenue': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))),'Total_Tonnage': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? 'Service Due' : 'All in Order','Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],'Target_Mileage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],'Target_Tonnage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],'Ideal_Rate_Per_Tonne': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),'Planned_Rate_Per_Km': (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))),'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Load_Items);
}


  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Saver'] = 'Save';
  New_Load = (await Backendless.Data.of('Loads').save( ({ 'Split_delivery': 'Load','Split_Load_Reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'Customer_Name': undefined,'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'Completion_Status': '0','Split_Load': true,'Split_Load2': true,'Planned_Delivery_Date_Time': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Delivery_Date_Time2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'tonnage': null,'tonnage2': null,'Status': null,'Status2': null,'Planned_Load': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Load2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Delivery': undefined,'Planned_Delivery2': undefined,'load_reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),'load_reference2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),'Product': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),'Product2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),'Planned_Tonnage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Summed_Split_Del')),'Planned_Tonnage2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Summed_Split_Del')),'load_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Point_Text')),'load_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Point_Text')),'delivery_point': undefined,'delivery_point2': undefined,'mileage': undefined,'mileage2': undefined,'Rate_Per_Tonne': undefined,'Rate_Per_Tonne2': undefined,'Rate_Per_Km': undefined,'Rate_Per_Km2': undefined }) ));
  New_Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'objectId')), ));
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [New_Horse]);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Load'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Ref_Input'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Point_Text'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Product_Input'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Del_Point_Input'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Mileage_Input'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Ratio'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Rate'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Summed_Split_Del'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = undefined;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e90b598149fccdeb7cf5760948d64a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7bae0001628e6848b62a49557f170be8', true);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Hider'] = null;
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('976f92e310c25237dfd7fa8d90c39755', null);

  } catch (error) {

  }
  await new Promise(r => setTimeout(r, 3000 || 0));
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Customer_Selector': undefined,'Total_Mileage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Revenue': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Tonnage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? 'Service Due' : 'All in Order','Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],'Target_Mileage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],'Target_Tonnage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],'Ideal_Rate_Per_Tonne': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Planned_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var Hider, Item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  try {
    if ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async Item => {; return (getObjectProperty(Item, 'Finalised_Load'));}))).reduce(function(x, y) {return x + y;}) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) != 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Number')) != null)) {
      console.log('abc');
      Hider = true;
    } else {
      Hider = false;
    }

  } catch (error) {

  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/505a9d1194adf5612266d1e202318f86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    Hider = false;
  } else {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    var error, Quote;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Quote = Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Quote')) * 100) / 100;

  } catch (error) {

  }

  return Quote

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/1af1ea4cca0231f97d27d87b1f94336d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calulated_Split_Del')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  async onValueAssignment(___arguments) {
    var Calculated_Split_Rate_Per_Km, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Calculated_Split_Rate_Per_Km = String('R ') + String((typeof (Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Calculated_Quote_Value'));}))).reduce(function(x, y) {return x + y;}) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));}))))) * 100) / 100) === 'number' && !isNaN((Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Calculated_Quote_Value'));}))).reduce(function(x, y) {return x + y;}) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));}))))) * 100) / 100))) ? Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Calculated_Quote_Value'));}))).reduce(function(x, y) {return x + y;}) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));}))))) * 100) / 100 : '-');

  } catch (error) {

  }

  return Calculated_Split_Rate_Per_Km

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/758ef8da13c6fc3e8255cfca2976ffd5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calulated_Split_Del')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  async onValueAssignment(___arguments) {
    var Quoted_Split_Rate_Per_Km, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Quoted_Split_Rate_Per_Km = String('R ') + String((typeof (Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));}))))) * 100) / 100) === 'number' && !isNaN((Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));}))))) * 100) / 100))) ? Math.round(((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) / Math.max.apply(null, (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Split_Del_Mileage'));}))))) * 100) / 100 : '-');

  } catch (error) {

  }

  return Quoted_Split_Rate_Per_Km

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/7b784624154aef21f015b9ba65ca8202/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Calulated_Split_Del')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  async onValueAssignment(___arguments) {
    var Total_Quote_Ammount, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Total_Quote_Ammount = String('R ') + String((typeof (Math.round((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) * 100) / 100) === 'number' && !isNaN((Math.round((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) * 100) / 100))) ? Math.round((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b72a8461e8542c358a5301a19f541c0f')).map(async item => {; return (getObjectProperty(item, 'Quote'));}))).reduce(function(x, y) {return x + y;}) * 100) / 100 : '-');

  } catch (error) {

  }

  return Total_Quote_Ammount

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/58b443fa9aa7efbfc944bf46643c63f6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finaliser'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Qouted_Split_Del_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Per_Ton_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Calculated_Rate_Km'] = undefined;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Del_Calc')) == true) {
    ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Split_Del_Counter_5'] = 1;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/f598deac451f2e0fc9822ceb592282e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/0f4c99376bb4fa0c8e8901ea4fe92939/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Due')) == 'Service Due') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
      Hider = false;
    } else {
      Hider = true;
    }
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Due')) == 'Service Due') {
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Service_Hider'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/113df1c1a6235da33efdb11e0c75c63c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Service_Hider'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/18d3b57355045fd8f5bb4b38766e469e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/019c246c3864596b157cfb3aa068aa64/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/cb9b9bbd1a8a2b5ff5334b231c720d38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/dcadf2bbc0c69c4355e470c3e725da92/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/6f91033f1fcdd289ebe7da795352f4f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/e5718d535b36409db7ad26a8cf4bf946/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/ae2c8e8f17cc9aaedd3254e688c15147/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Hider')) == true) {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Horse, New_Load, Trailer_3, Trailer_2, Trailer_1, New_Service, Vehicle_Item, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Loads_Populator() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', true);
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Total_Mileage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Revenue': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Tonnage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? 'Service Due' : 'All in Order','Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],'Target_Mileage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],'Target_Tonnage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],'Ideal_Rate_Per_Tonne': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Planned_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', false);
}


  New_Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'objectId')), ));
  New_Load = (await Backendless.Data.of('Loads').save( ({ 'Service': 'Yes','Description': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Description')),'Horse_Registration': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'Customer_Name': 'Service','Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'Completion_Status': '0','Planned_Delivery_Date_Time': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Planned_Load')),'Planned_Delivery_Date_Time2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Planned_Load')),'tonnage': null,'tonnage2': null,'Status': null,'Status2': null,'Planned_Load': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Planned_Load')),'Planned_Load2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Planned_Load')),'load_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'load_point')),'load_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'load_point')),'delivery_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'load_point')),'delivery_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'load_point')) }) ));
  New_Service = (await Backendless.Data.of('Repairs_Maintenance').save( ({ 'Date_Scheduled': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Planned_Load')),'Scheduled_Notes': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'Description')),'Registration_Horse': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'Repair_Or_Service': 'Service','Service_Point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f'), 'load_point')),'Completion_Status': 'Scheduled','ownerId': (getObjectProperty(New_Horse, 'ownerId')) }) ));
  ___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f')['Planned_Load'] = null;
  ___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f')['load_point'] = null;
  ___arguments.context.getComponentDataStoreByUid('de7b6d648e8900cc91bcf20b1484898f')['Description'] = null;
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [New_Horse]);
  await Loads_Populator();
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Service_Hider'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/866e39bf419b805d9cb2093d56946cf3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = 'Service';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = 'Split Delivery Load';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = 'Split Delivery';
  }

  return Hider

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/442a911b71cb646130171fd7ea6f7aa1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      if (false) {
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/d50f3ce45dbd343c3521f696d4813988/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/ca7c47fd06cb518976fb36d33547532a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    var Check_State;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load_Reference')) != null) {
    Check_State = true;
  } else {
    Check_State = false;
  }

  return Check_State

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/0a2c68890b3a5584a278cd3c4b08fe09/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = true;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/f3bb7eb99c11f494282d2d1ce3cd84eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var error;


  for (var count = 0; count < 3; count++) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Load'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Ref_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Point_Text'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Product_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Del_Point_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Mileage_Input'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Ratio'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Rate'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calculated_Split_Del_Hider'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Summed_Split_Del'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Finaliser'] = undefined;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Customer_Hider'] = undefined;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61e90b598149fccdeb7cf5760948d64a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7bae0001628e6848b62a49557f170be8', true);
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Add_Load_Hider'] = null;
    try {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('976f92e310c25237dfd7fa8d90c39755', null);

    } catch (error) {

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/feeca394d05b2a74b0b835e65252550d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b72a8461e8542c358a5301a19f541c0f', []);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Calulated_Split_Del'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Hider_2'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Del_Number'] = null;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Date_Locker'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22f75797a1257312a4f28ed523462d73', []);
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Hider'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_1'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Split_Load_Warning_Hider_2'] = false;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Date'] = null;
  ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Planned_Load'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Load'] = null;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('976f92e310c25237dfd7fa8d90c39755', null);
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Ref_Input'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Product_Input'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Planned_Tonnage_Input'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Load_Point_Text'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Load_Del_Point_Input'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Add_Mileage_Input'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Per_Ton'] = null;
  ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Calculated_Rate_Km'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/7552207d6a527b6f1339803de6fbad9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('7a31ba9c6c02a3874564c73b9d036347'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit'] = true;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_False'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_True'] = true;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide2'] = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status')) == 'Loaded') {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = true;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Undeletable'] = true;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Undeletable'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Loaded_Tonnage'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = false;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit'] = false;
    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = true;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Loaded_Tonnage'] = false;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = false;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Loaded_Tonnage'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Undeletable'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = true;
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = false;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit'] = false;
    }
  }
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Selected_Customer'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'value'));
  console.log(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer2')), 'value'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Customer_Selector'] = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'owner_objectId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });})));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/57a77a01129d53dd69f33b359f04e91c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute_Check')) != true) {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = false;
  } else {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = false;
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Revealer'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Status2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Status'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Split_Load2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_Load'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Planned_Load2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Load'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Planned_Delivery2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Delivery'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Customer2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Customer'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['load_reference2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'load_reference'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Product2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Product'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Planned_Tonnage2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['load_point2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'load_point'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['delivery_point2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'delivery_point'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['mileage2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'mileage'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Tonne2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Tonne'));
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Rate_Per_Km2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Rate_Per_Km'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('442a911b71cb646130171fd7ea6f7aa1'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d50f3ce45dbd343c3521f696d4813988'))['backgroundColor'] = 'rgba(255, 255, 255, 0)';
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('ce9c6c8871f6e1e8ebfb3488c8c7abe9', null);
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Add_Customer_Hider2'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_True'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide2'] = true;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide3'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Reroute_Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Calculated'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit'] = false;
  ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide_False'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/18a295d63ae675a8e65b6c8cb4091207/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hide;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Undeletable')) == true) {
    Hide = false;
  } else {
    Hide = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit_Hide_True'));
  }

  return Hide

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Edit_Hide3'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/41ce59286d3b25525577d9ae5c05a7b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Standard_Load')) == true) {
    Hider = false;
  } else {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Load_Checked')) == true && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == null || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == false)) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Load_Checked')) == false && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Std_Shower'] = undefined;
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/d6ddd318aa06f275086ab0dcd0f583af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Load_Checked')) == true) {
    Hider = false;
  } else {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    ___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469')['Split_Load_Checked'] = undefined;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/d5f8cc858421f9b9e031dc26cab845fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Std_Shower')) == true) {
    Hider = true;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Split_Del_Hider_2')) == true) {
    Hider = true;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/c756becd2eee48f9de4391ecbbf70f53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Horse, New_Load, New_Customer, New_Customer_Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Load_Added'] = true;
  ___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df')['Finalised_Load'] = 1;
  New_Load = (await Backendless.Data.of('Loads').save( ({ 'ownerId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'owner_objectId')),'Load_Planner': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName')),'Split_delivery': 'Yes','Split_Load_Reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Horse_Registration')),'Customer_Name': (getObjectProperty((await Backendless.Data.of('Tier_2_Customer').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c8eeb4eb82d4c151573c2edc8a244774')), )), 'Customer')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'Completion_Status': '0','Split_Load': true,'Split_Load2': true,'Planned_Delivery_Date_Time': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Delivery')),'Planned_Delivery_Date_Time2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Delivery')),'tonnage': null,'tonnage2': null,'Status': null,'Status2': null,'Planned_Load': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Load2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Date')),'Planned_Delivery': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Delivery')),'load_reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),'load_reference2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Ref_Input')),'Product': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),'Product2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Product_Input')),'Planned_Tonnage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')),'Planned_Tonnage2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Planned_Tonnage_Input')),'load_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Point_Text')),'load_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Add_Load_Load_Point_Text')),'delivery_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Load_Del_Point_Input')),'delivery_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Load_Del_Point_Input')),'mileage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')),'mileage2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Add_Mileage_Input')),'Rate_Per_Tonne': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')),'Rate_Per_Tonne2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Per_Ton')),'Rate_Per_Km': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Km')),'Rate_Per_Km2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Calculated_Rate_Km')) }) ));
  New_Customer = (await Backendless.Data.of('Tier_2_Customer').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c8eeb4eb82d4c151573c2edc8a244774')), ));
  New_Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'objectId')), ));
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Customer', [New_Customer]);
  New_Customer_Customer = (getObjectProperty(New_Customer, 'Customer'));
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [New_Horse]);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Finaliser')) == true) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Finaliser')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == false || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4c1660de185b98cab875fa756e29b1df'), 'Load_Added')) == null) {
        Hider = true;
      } else {
        Hider = false;
      }
    } else {
      Hider = false;
    }
  } else {
    Hider = false;
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/a1527e0bfd18ff8930e3412790f4babb/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Planned_Tonnage2')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'tonnage'))) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1527e0bfd18ff8930e3412790f4babb'))['backgroundColor'] = 'rgba(0, 0, 0, 0.4)';
    }
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a1527e0bfd18ff8930e3412790f4babb'))['backgroundColor'] = 'rgba(0, 0, 0, 0.4)';
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/fd3f801f50a915b9c3e886eaa1c37ed4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Hider = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Load') {
    Hider = false;
  } else {
    Hider = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Reroute'));
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/5ecf23feef9d25091d767f88b123b195/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var Label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Label = 'Delivery Tonnage';
  } else {
    Label = 'Loaded Tonnage';
  }

  return Label

  },
  /* handler:onLabelAssignment */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Editable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Edit')) == true) {
    Editable = false;
  } else {
    Editable = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Loaded_Tonnage'));
  }

  return Editable

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Reader;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Reader = false;
  } else {
    Reader = true;
  }

  return Reader

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
    var Reader;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    ___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a')['Revealer'] = true;
    Reader = (await Backendless.Data.of('Loads').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'objectId')), ));
    Reader['tonnage'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var Hider;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Service')) == 'Yes') {
    Hider = false;
  } else {
    Hider = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Loaded_Tonnage'));
  }

  return Hider

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/7cdacc9ac37da37684331df8b33b34c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Reader;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'Split_delivery')) == 'Yes') {
    Reader = (await Backendless.Data.of('Loads').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'objectId')), ));
    Reader['tonnage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('21ceb6af10e809125c5d8e5789786d5a'), 'tonnage'));
    await Backendless.Data.of('Loads').save( Reader );
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Vehicle_Item, item, Start_Date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (await Backendless.UserService.isValidLogin()) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4dee53e9f92d12aa04ad645fc5989c5'))['opacity'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb2960c5019976d78d3a19fb09469426', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('86be408f9222570656323ee6fb3ccb77', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d0e5c3bc1d87929626a38c2bcc26094', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e6c5c027ce55df803eaa9241caa7618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('994620ee1519465b94e55fbae6bf9b23', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70f22ea7660718a7648f6008cd21f70d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11818d94f7a748ffebda45ba3b1f9c34', false);
    ___arguments.context.pageData['Customer_Selector'] = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });})));
    Start_Date = (new Date());
    Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
    Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
    Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
    Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
    Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
    ___arguments.context.pageData['Start_Date'] = (Start_Date.valueOf());
    ___arguments.context.pageData['End_Date'] = ((new Date()).valueOf());
    Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Hauler': (getObjectProperty(item, 'Company')),'Customer_Selector': undefined,'Total_Mileage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Revenue': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Tonnage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) || (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\' AND Service_Status = \'Service Due\''].join(''))).setPageSize(10))).length > 0 ? 'Service Due' : 'All in Order','Service_Due_2': (getObjectProperty(item, 'Service_Interval')) - (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'mileage'));})))[0] % (getObjectProperty(item, 'Service_Interval')) < (getObjectProperty(item, 'Service_Warning_Duration_in_KM')) ? true : false,'Service_Due_3': (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(item, 'Horse_Registration')),'\' AND Service_Status = \'Service Due\''].join(''))).setPageSize(10))).length > 0 ? true : false,'Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],'Target_Mileage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],'Target_Tonnage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],'Ideal_Rate_Per_Tonne': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Planned_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cb2960c5019976d78d3a19fb09469426', false);
    ___arguments.context.pageData['Live_Check'] = true;
    await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4dee53e9f92d12aa04ad645fc5989c5')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4dee53e9f92d12aa04ad645fc5989c5')), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('86be408f9222570656323ee6fb3ccb77')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86be408f9222570656323ee6fb3ccb77')), false);
    await BackendlessUI.Functions.Custom['fn_f1bf64c5c5a6dd6f25dd14c4bf39499e'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('11818d94f7a748ffebda45ba3b1f9c34')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11818d94f7a748ffebda45ba3b1f9c34')), true);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }

  },
  /* handler:onEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  ___arguments.context.pageData['Load_Viewer'] = false;
  try {
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')));
    console.log(['Horse Update Listener',(getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')),' Has Been Removed'].join(''));
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')));
    console.log(['Load Update Listener ',(getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')),' Has Been Removed'].join(''));
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')));
    console.log(['Target Update Listener ',(getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')),' Has Been Removed'].join(''));

  } catch (error) {

  }

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/b98f729c5df3491e57c9e3bf28014eba/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var Load_Items, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!___arguments.newValue) {
    console.log('Work');
    Load_Items = (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });})));
    ___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e')['Load_Items'] = [Load_Items];
    ___arguments.context.appData['Next_Load'] = (Load_Items[0]);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7a31ba9c6c02a3874564c73b9d036347', Load_Items);
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/954b46d6c9ea7af36bbb257f4bdc46da/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Load_Planner = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName')),'\' AND Completion_Status = \'','1','\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5271750889635ac881f35c54c006a06e', true);
  ___arguments.context.pageData['image'] = (getObjectProperty(___arguments.selectedRecord, 'image'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/2cead99be0bdaedece9df7c2a9d6b8ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cead99be0bdaedece9df7c2a9d6b8ea', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('954b46d6c9ea7af36bbb257f4bdc46da', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5271750889635ac881f35c54c006a06e', false);
  ___arguments.context.pageData['image'] = undefined;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/0105a5f96d82d7580cc23b7e63dbd869/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'image')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/58d8c49915fcda386fbd529e359519ad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Actual_Rate_Per_Km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/bb0bd26a55efdcb4fc38e867f42f769f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Planned_Rate_Per_Km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/eb266272512cb686c6a738665ef1b213/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Tonnage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/8dfdaf880c4a582b4945b96af5b39b0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/3eb8d96939c46d93d142b6dbd5bc2316/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/8e165477f81a1be119c57337c3ca9416/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((typeof (Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Mileage')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Mileage'))) * 100 * 100) / 100) === 'number' && !isNaN((Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Mileage')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Mileage'))) * 100 * 100) / 100))) ? (Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Mileage')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Mileage'))) * 100) / 100) * 100 : 0) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/38d934f322b8a293ffd39fb5585a9341/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Tonnage')) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Tonnage')) * ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())))) * 100 * 100) / 100) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/e42d3c7935052b2dfb2254d24c73ab34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Tonnage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/0a95f05ddc4d00c1110c25eda0dc8f3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Tonnage')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Tonnage'))) * 100 * 100) / 100) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/a6cbe5fe46aa896388bf57db63bd790b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Mileage')) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Target_Mileage')) * ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())))) * 100 * 100) / 100) + String('%'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/f1c2d8162dce51ba2975663fb724e9e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Total_Revenue')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/a301b21f90757aee98fb179485841f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a301b21f90757aee98fb179485841f35', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('008a950e023fabaf6b83b499f3ba2889', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('904f8ab859bf20bed07f68cebbcd9726', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/904f8ab859bf20bed07f68cebbcd9726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a301b21f90757aee98fb179485841f35', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('008a950e023fabaf6b83b499f3ba2889', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('904f8ab859bf20bed07f68cebbcd9726', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/9556b4cf518a30cc8ee492d1ae48b1da/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (Math.round((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb5e61736219d3cef0f157fe612a0469'), 'Remaining_Tonnage')) * 1000) / 1000)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/1df21a48486206960194db4b2625fc49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Ideal_Rate_Per_Tonne'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/6b1da7be10dfc8778ca6a22fe54f4511/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Vehicle_Item, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', true);
  Vehicle_Item = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Customer_Selector': undefined,'Total_Mileage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Revenue': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Load_Value'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Total_Tonnage': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'tonnage'));}))), 0)).reduce(function(x, y) {return x + y;})))) * 1000) / 1000,'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'owner_objectId': (getObjectProperty(item, 'ownerId')),'objectId': (getObjectProperty(item, 'objectId')),'Service_Due': (getObjectProperty(item, 'Service_Status')),'Status': (getObjectProperty(item, 'Status')),'Trailer1_Registration.Type': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Type'));})))[0],'Payload': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(item, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0],'Target_Mileage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Mileage_Target'));})))[0],'Target_Tonnage': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Monthly_Tonnage_Target'));})))[0],'Ideal_Rate_Per_Tonne': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Tonne'));})))[0],'Ideal_Rate_Per_Km': (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(item, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Ideal_Rate_Per_Km'));})))[0],'Actual_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND Status = \'Delivered\'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Actual_Mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Planned_Rate_Per_Km': Math.round((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e']((Math.round(((await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return ((getObjectProperty(item, 'Rate_Per_Tonne')) * (getObjectProperty(item, 'Planned_Tonnage')));}))), 0)).reduce(function(x, y) {return x + y;})))) / (await BackendlessUI.Functions.Custom['fn_3e8b0b6172bbd0d7c17c4684ebc3473e'](((addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(item, 'Horse_Registration')),'\'',' AND Planned_Delivery_Date_Time > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'',''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'mileage'));}))), 0)).reduce(function(x, y) {return x + y;}))))) * 100) / 100))) * 1000) / 1000,'Driver_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0],'Driver_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0],'Owner_Name': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'displayName'));})))[0],'Owner_Cell': (await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Owner').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone'));})))[0],'Load_Items': (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty(item, 'objectId')),'\' And Completion_Status = \'0','\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });}))) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c0436a52dbbfa168d9ec43af5e491832', Vehicle_Item);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('151589db572c08c4c227aacd1724f2d1', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/60b44d7c62dddcbb2c622fec2257546c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Load, Horse, object, item, Load_Planner, New_Object, error, Payload, Trailer, Trailer_1, Trailer_1_ObjectId, Load_Planner_ObjectId, Vehicle_Item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value == true) {
    Load_Planner = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName'));
    Load_Planner_ObjectId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    console.log(Load_Planner);
    console.log(Load_Planner_ObjectId);
    ___arguments.context.pageData['Horse_Update_Listener'] = (generateUUID().long());
    ___arguments.context.pageData['Target_Update_Listener'] = (generateUUID().long());
    ___arguments.context.pageData['Load_Update_Listener'] = (generateUUID().long());

    ;(function(whereClause) {
      const callback = async object => {
          console.log(String('Horse Update Listener Engaged ') + String(getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')));
      console.log(object);
      Horse = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c0436a52dbbfa168d9ec43af5e491832')), async (item) => {


       return ((getObjectProperty(object, 'Horse_Registration')) == (getObjectProperty(item, 'Horse_Registration')));
      }))[0];
      console.log(getObjectProperty(object, 'Horse_Registration'));
      console.log(Horse);
      Horse['Service_Due'] = (getObjectProperty(object, 'Service_Status'));
      Horse['Status'] = (getObjectProperty(object, 'Status'));
      Horse['Service_Status'] = (getObjectProperty(object, 'Service_Status'));
      if ((getObjectProperty(object, 'Trailer_1_Confirm')) == 'None') {
        Trailer = 'No Trailers Hitched';
        Horse['Trailer1_Registration.Type'] = Trailer;
      } else {
        Trailer_1 = (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(object, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)))[0];
        Trailer = (getObjectProperty(Trailer_1, 'Type'));
        Trailer_1_ObjectId = (getObjectProperty(Trailer_1, 'objectId'));
        Horse['Trailer1_Registration.Type'] = Trailer;
      }
      try {
        Payload = (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(object, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0] == null ? (getObjectProperty(object, 'Payload')) : (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(object, 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Override'));})))[0];
        if (Payload == (getObjectProperty(Horse, 'Payload'))) {
        } else {
          await new Promise(r => setTimeout(r, 1000 || 0));
          (function (message) { alert(message) })((['Payload/Trailer Type of',' (',(getObjectProperty(object, 'Horse_Registration')),') has changed New Payload (',Payload,')'].join('')));
          Horse['Payload'] = Payload;
          console.log(Payload);
        }

      } catch (error) {
        console.log(error);

      }
      Horse['Load_Items'] = (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(object, 'Horse_Registration')),'\' AND Completion_Status = \'0\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(100))).map(async item => {; return ({ 'Service': (getObjectProperty(item, 'Service')),'Split_delivery': (getObjectProperty(item, 'Split_delivery')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Customer_Name': (getObjectProperty(item, 'Customer_Name')),'Edit_Hide2': true,'Edit_Hide_False': true,'Edit_Hide3': false,'Edit': false,'Edit_Hide_True': false,'tonnage': (getObjectProperty(item, 'tonnage')),'tonnage2': (getObjectProperty(item, 'tonnage')),'Status': (getObjectProperty(item, 'Status')),'Status2': (getObjectProperty(item, 'Status')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load2': (getObjectProperty(item, 'Split_Load')),'objectId': (getObjectProperty(item, 'objectId')),'Planned_Load': (getObjectProperty(item, 'Planned_Load')),'Planned_Load2': (getObjectProperty(item, 'Planned_Load')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery_Date_Time2': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Delivery': (getObjectProperty(item, 'Planned_Delivery')),'Planned_Delivery2': (getObjectProperty(item, 'Planned_Delivery')),'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'Customer2': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(100).setOffset(0))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})))[0],'load_reference': (getObjectProperty(item, 'load_reference')),'load_reference2': (getObjectProperty(item, 'load_reference')),'Product': (getObjectProperty(item, 'Product')),'Product2': (getObjectProperty(item, 'Product')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Planned_Tonnage2': (getObjectProperty(item, 'Planned_Tonnage')),'load_point': (getObjectProperty(item, 'load_point')),'load_point2': (getObjectProperty(item, 'load_point')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'delivery_point2': (getObjectProperty(item, 'delivery_point')),'mileage': (getObjectProperty(item, 'mileage')),'mileage2': (getObjectProperty(item, 'mileage')),'Rate_Per_Tonne': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Tonne2': (getObjectProperty(item, 'Rate_Per_Tonne')),'Rate_Per_Km': (getObjectProperty(item, 'Rate_Per_Km')),'Rate_Per_Km2': (getObjectProperty(item, 'Rate_Per_Km')) });})));
      Horse['Driver_Name'] = ((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(object, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Call_Sign'));})))[0]);
      Horse['Driver_Cell'] = ((await Promise.all((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(object, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Driver_1').setPageSize(10).setOffset(0))).map(async item => {; return (getObjectProperty(item, 'Cellphone_Number'));})))[0]);

      };

      const rtHandlers = Backendless.Data.of('Vehicles').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addUpdateListener.apply(rtHandlers, options);

      getRTSubscriptions().add((getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')), () => rtHandlers.removeUpdateListener(callback));

    })((['Load_Planner_Name = \'',Load_Planner,'\''].join('')));

    ;(function(whereClause) {
      const callback = async object => {
          console.log(String('Target_Update_Listener') + String(getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')));
      console.log(object);
      Horse = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c0436a52dbbfa168d9ec43af5e491832')), async (item) => {


       return ((getObjectProperty(object, 'Vehicle_Registration')) == (getObjectProperty(item, 'Horse_Registration')));
      }))[0];
      console.log(Horse);
      if ((getObjectProperty(object, 'Ideal_Rate_Per_Tonne')) == (getObjectProperty(Horse, 'Ideal_Rate_Per_Tonne'))) {
      } else {
        Horse['Ideal_Rate_Per_Tonne'] = (getObjectProperty(object, 'Ideal_Rate_Per_Tonne'));
        (function (message) { alert(message) })((['The Ideal Rate Per Tonne For (',(getObjectProperty(object, 'Vehicle_Registration')),') Has Changed, The Rate is(R ',(getObjectProperty(object, 'Ideal_Rate_Per_Tonne')),')'].join('')));
      }
      if ((getObjectProperty(object, 'Monthly_Mileage_Target')) == (getObjectProperty(Horse, 'Target_Mileage'))) {
      } else {
        Horse['Target_Mileage'] = (getObjectProperty(object, 'Monthly_Mileage_Target'));
        (function (message) { alert(message) })((['The Monthly Mileage Target  For (',(getObjectProperty(object, 'Vehicle_Registration')),') Has Changed, The New Target is (',(getObjectProperty(object, 'Monthly_Mileage_Target')),'Km)'].join('')));
      }
      if ((getObjectProperty(object, 'Ideal_Rate_Per_Km')) == (getObjectProperty(Horse, 'Ideal_Rate_Per_Km'))) {
      } else {
        Horse['Ideal_Rate_Per_Km'] = (getObjectProperty(object, 'Ideal_Rate_Per_Km'));
        (function (message) { alert(message) })((['The Ideal Rate Per Km  For (',(getObjectProperty(object, 'Vehicle_Registration')),')  Has Changed, The Rate is (R ',(getObjectProperty(object, 'Ideal_Rate_Per_Km')),')'].join('')));
      }
      if ((getObjectProperty(object, 'Monthly_Tonnage_Target')) == (getObjectProperty(Horse, 'Target_Tonnage'))) {
      } else {
        Horse['Target_Tonnage'] = (getObjectProperty(object, 'Monthly_Tonnage_Target'));
        (function (message) { alert(message) })((['The Monthly Tonnage Target (',(getObjectProperty(object, 'Vehicle_Registration')),')  Has Changed, The New Target is ( ',(getObjectProperty(object, 'Monthly_Mileage_Target')),'t)'].join('')));
      }

      };

      const rtHandlers = Backendless.Data.of('Targets').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addUpdateListener.apply(rtHandlers, options);

      getRTSubscriptions().add((getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')), () => rtHandlers.removeUpdateListener(callback));

    })((['Load_Planner = \'',Load_Planner,'\''].join('')));

    ;(function(whereClause) {
      const callback = async object => {
          console.log(String('Loads Update Listner Engaged') + String(getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')));
      await new Promise(r => setTimeout(r, 10000 || 0));
      New_Object = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Load_Planner = \'',Load_Planner,'\' AND load_reference = \'',(getObjectProperty(object, 'Load_Reference')),'\''].join(''))).setSortBy('updated').setPageSize(10)))[0];
      console.log(New_Object);
      Horse = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c0436a52dbbfa168d9ec43af5e491832')), async (item) => {


       return ((getObjectProperty(New_Object, 'Horse_Registration')) == (getObjectProperty(item, 'Horse_Registration')));
      }))[0];
      console.log(Horse);
      Load = (await asyncListFilter((getObjectProperty(Horse, 'Load_Items')), async (item) => {


       return ((getObjectProperty(New_Object, 'objectId')) == (getObjectProperty(item, 'objectId')));
      }))[0];
      console.log(Load);
      if ((getObjectProperty(New_Object, 'Completion_Status')) == '0' && (getObjectProperty(New_Object, 'Status')) == 'Loaded') {
        Load['Completion_Status'] = '0';
        Load['Status'] = 'Loaded';
        Load['tonnage'] = (getObjectProperty(New_Object, 'tonnage'));
      }
      if ((getObjectProperty(New_Object, 'Completion_Status')) == '1' && (getObjectProperty(New_Object, 'Status')) == 'Delivered') {
        console.log(getObjectProperty(Horse, 'Load_Items'));
        console.log(Load);
        removeItemInList((getObjectProperty(Horse, 'Load_Items')), Load, '');
      }

      };

      const rtHandlers = Backendless.Data.of('Load_Neg').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addCreateListener.apply(rtHandlers, options);

      getRTSubscriptions().add((getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')), () => rtHandlers.removeCreateListener(callback));

    })((['Load_Planner = \'',Load_Planner,'\''].join('')));
      }
  if (___arguments.value == false) {
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')));
    console.log(['Horse Update Listener',(getObjectProperty(___arguments.context.pageData, 'Horse_Update_Listener')),' Has Been Removed'].join(''));
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')));
    console.log(['Load Update Listener ',(getObjectProperty(___arguments.context.pageData, 'Load_Update_Listener')),' Has Been Removed'].join(''));
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')));
    console.log(['Target Update Listener ',(getObjectProperty(___arguments.context.pageData, 'Target_Update_Listener')),' Has Been Removed'].join(''));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/7191640c91ca0b3913d78e26dd0a3409/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cead99be0bdaedece9df7c2a9d6b8ea', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('954b46d6c9ea7af36bbb257f4bdc46da', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('954b46d6c9ea7af36bbb257f4bdc46da');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('954b46d6c9ea7af36bbb257f4bdc46da')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/f27fff3b399c90020ac6133c1fdf6c72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11818d94f7a748ffebda45ba3b1f9c34', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/11818d94f7a748ffebda45ba3b1f9c34/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70f22ea7660718a7648f6008cd21f70d', false);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/df93d5b76bce7ddbe206e067ed6f5f7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('70f22ea7660718a7648f6008cd21f70d', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/c68f5e25428df674277a321196c6989e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Due'))

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('63ad9f3746536bb61cb7134645d6d09e'), 'Service_Due')) == 'Service Due') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c68f5e25428df674277a321196c6989e'))['color'] = 'Yellow';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c68f5e25428df674277a321196c6989e'))['color'] = 'Green';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/6bc84bc4e2641207a144d14a91f85fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Load_Planner_Backup/components/7567e0f802bfac7fd6ce118eedd4876d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Counter, RGBA;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tyre_Clear() {
  Counter = 0;
  for (var count = 0; count < 90; count++) {
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = null;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function Page_Enter_Procedure() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('591ff9311ac43105a1380544107cc892', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9b74ddf7c468f8fcf875f6e8c798c575', false);
  ___arguments.context.pageData['RGBA'] = 1;
  for (var count2 = 0; count2 < 100; count2++) {
    RGBA = (getObjectProperty(___arguments.context.pageData, 'RGBA')) - 0.01;
    ___arguments.context.pageData['RGBA'] = RGBA;
    await new Promise(r => setTimeout(r, 0.1 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6'))['backgroundColor'] = (['rgba(0, 0, 0, ',RGBA,')'].join(''));
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', false);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);
  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  ___arguments.context.pageData['User_OwnerId'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_User')), 'ownerId'));
  ___arguments.context.pageData['Tyre_Swap_Edit_True2'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False2'] = true;
  ___arguments.context.pageData['Tyre_Swap_Edit_True'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False'] = true;
  ___arguments.context.pageData['Images_View'] = false;
  try {
    ___arguments.context.pageData['Tyre_Life_Average'] = (await BackendlessUI.Functions.Custom['fn_518de41fac043aee8b8e5d4a87521873']('Tyres', (['ownerId =\'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\''].join('')), 'Life'));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Service_Due_Average_Test'] = ((((await Backendless.Data.of('Vehicles').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\' AND Service_Status = \'Service Due\''].join(''))))) + (await Backendless.Data.of('Trailers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\' AND Service_Status = \'Service Due\''].join('')))))) / ((await Backendless.Data.of('Vehicles').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\''].join(''))))) + (await Backendless.Data.of('Trailers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\''].join(''))))))) * 100);

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Over_Mileage_Tyres'] = (((await Backendless.Data.of('Tyres').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\' AND Over_MIleage = \'Over Mileage\''].join(''))))) / (await Backendless.Data.of('Tyres').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\''].join('')))))) * 100);

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Service_Due_Average'] = ((getObjectProperty(___arguments.context.pageData, 'Service_Due_Average_Test')) == Infinity ? 0 : (getObjectProperty(___arguments.context.pageData, 'Service_Due_Average_Test')));

  } catch (error) {

  }
  await Page_Enter_Procedure();

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Maintainance_Hub_Mobile/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/5657405aa51342ecda98075493b5ff6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  if ((getObjectProperty(___arguments.context.pageData, 'Truck_Data_Icon_Select')) == true) {
    await Closer();
  } else {
    await Closer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/064284e8d81934617325340eabedd916/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_Data_Icon_Select')) == true) {
    await Closer();
  } else {
    await Closer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/b612d3b3061d799155f81a9286caaa69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      try {
    ___arguments.context.pageData['Repair_Viewer'] = false;

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Tyre_Icon_Select'] = false;

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83a6fc9424db2a765b195747c78aec53', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03854a0902b645e81b28d5723f082e23', false);
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);

  } catch (error) {

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('591ff9311ac43105a1380544107cc892', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4bc355cbfa331854e5c326026ec55b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('20312f99482797f4157228f54b9fa217', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89cbdd9906f1205369b27df94c0a9bac', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/f7423269562d8c0f35d64aed19fb836f/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/65d3504d17c60c9dfecd3e95b1ffcbeb/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/cf2d5a1bc5dfeba8a9db31784a714f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Images_View'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/41f553479872cab9abf931ef3b0b2e47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Image_1'] = null;
  ___arguments.context.pageData['Image_2'] = null;
  ___arguments.context.pageData['Image_3'] = null;
  ___arguments.context.pageData['Image_3'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/daa89079a11340a16fc711568858863d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Image_Text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Image_1')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_2')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_3')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_4')) == null) {
    Image_Text = 'No Images Available';
  } else {
    Image_Text = (getObjectProperty(___arguments.context.pageData, 'DataImageText'));
  }

  return Image_Text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/e23b96acd1879198dc2f19e4e90eb0e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/b7649fc62cc8a1432e22311afd238672/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/2fae753c674e30dff7e7456114e29c61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/cd7e08f865dbe001d7579334b4752399/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/7f9680277fe89cfde26b11be22d7b3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
}


  if ((getObjectProperty(___arguments.context.pageData, 'Tyre_Icon_Select')) == true) {
    await Closer();
  } else {
    await Closer();
    ___arguments.context.pageData['Tyre_Icon_Select'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/435c6d4bd57574dc78747a9da3b3f3d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', true);
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('c2d4f0b561fd0c723374abd58b625e11', (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Horse_Registration').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Horse_Registration')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('92bcb6b56e3bbd24d9cc6534582e8e94', (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Horse_Registration').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Horse_Registration')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('6c91227e85eaa27982d3833dddc5866f', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Trailer_Registration').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Trailer_Registration')) });}))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/0befd528f07c49d12f526e672d597252/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/58c221cd83f7d11c5ccc229544498106/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9628b47d6ca2488164b2935febd7b93b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/da9736f35fb4ac560cf3525ec7b83f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', true);
  ___arguments.context.pageData['Add_Tyre_Data'] = ((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Tyre_Number').setPageSize(100))).map(async item => {; return ({ 'Tyre_Number': (getObjectProperty(item, 'Tyre_Number')),'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')) });}))).slice(-1)[0]);
  await Backendless.Data.of('Tyres').save( ({ 'State': 'In Order','Cost': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cost')),'Current_Cap_State': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cap_State')),'Current_Mileage': 0,'Expected_Mileage': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_EM')),'Fleet_Brand': String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Fleet_Brand')).slice(0, 5)) + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1),'Make': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Make')),'Model': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Model')),'Serial_Number': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_SN')),'System_Generated_Tyre': 'No','Type': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Type')),'Tyre_Number': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1,'Tyre_Position': null,'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );
  ___arguments.context.pageData['Add_Tyre_Cost'] = null;
  ___arguments.context.pageData['Add_Tyre_Cap_State'] = null;
  ___arguments.context.pageData['Add_Tyre_EM'] = null;
  ___arguments.context.pageData['Add_Tyre_Make'] = null;
  ___arguments.context.pageData['Add_Tyre_Model'] = null;
  ___arguments.context.pageData['Add_Tyre_SN'] = null;
  ___arguments.context.pageData['Add_Tyre_Type'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/44c3b966ea3806de97b4f9779b9e8b08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', true);
  ___arguments.context.pageData['Add_Tyre_Data'] = ((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Tyre_Number').setPageSize(100))).map(async item => {; return ({ 'Tyre_Number': (getObjectProperty(item, 'Tyre_Number')),'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')) });}))).slice(-1)[0]);
  await Backendless.Data.of('Tyres').save( ({ 'State': 'In Order','Cost': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cost')),'Current_Cap_State': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cap_State')),'Current_Mileage': 0,'Expected_Mileage': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_EM')),'Fleet_Brand': String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Fleet_Brand')).slice(0, 5)) + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1),'Make': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Make')),'Model': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Model')),'Serial_Number': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_SN')),'System_Generated_Tyre': 'No','Type': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Type')),'Tyre_Number': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1,'Tyre_Position': null,'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );
  ___arguments.context.pageData['Add_Tyre_Cost'] = null;
  ___arguments.context.pageData['Add_Tyre_Cap_State'] = null;
  ___arguments.context.pageData['Add_Tyre_EM'] = null;
  ___arguments.context.pageData['Add_Tyre_Make'] = null;
  ___arguments.context.pageData['Add_Tyre_Model'] = null;
  ___arguments.context.pageData['Add_Tyre_SN'] = null;
  ___arguments.context.pageData['Add_Tyre_Type'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/3d5325c98073def13916f9efa43608a1/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/d4c45696ad32d68d06987d2729e37336/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Over_Mileage = \'Over Mileage\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/ea9bfd5f9411e9cc82665fd97d1f96b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/994c081a40c710b88e3fd6ac7be585cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
}


  if ((getObjectProperty(___arguments.context.pageData, 'Serv./Repair_Icon_Select')) == true) {
    await Closer();
  } else {
    await Closer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', true);
    ___arguments.context.pageData['Serv./Repair_Icon_Select'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/da962d555aa7b166e5e30dfc9743a357/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Completion_Status = \'Scheduled\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Horse_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Scheduler_Viewer'] = true;
    ___arguments.context.pageData['Service_Due_Table_Horse'] = ((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')),'\''].join(''))).setPageSize(10)))[0]);
    console.log(getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c2b2435813b9d528a56eecc596cf94c', true);
    ___arguments.context.pageData['Service_Due_Table_Horse_Service'] = false;
    ___arguments.context.pageData['Service_Due_Table_Horse_Repair'] = false;
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Trailer_1_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Scheduler_Viewer'] = true;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')),'\''].join(''))).setPageSize(10)))[0]);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11974116ba9d4519cc99ebcd2e41f19b', true);
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = false;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = false;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Service'] = false;
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_2')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Trailer_1_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Scheduler_Viewer'] = true;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')),'\''].join(''))).setPageSize(10)))[0]);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11974116ba9d4519cc99ebcd2e41f19b', true);
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = false;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Service'] = false;
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_3')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Trailer_1_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Scheduler_Viewer'] = true;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')),'\''].join(''))).setPageSize(10)))[0]);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11974116ba9d4519cc99ebcd2e41f19b', true);
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = false;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Service'] = false;
  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/45854249bf27338e7dd6f9c1864b00c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('da962d555aa7b166e5e30dfc9743a357');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/af042cd4926a40945e932d3882ebd0e2/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Completion_Status = \'Commenced\' AND Repair_Or_Service = \'Service\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Horse_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Service_Due_Table_Horse'] = ((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')),'\''].join(''))).setPageSize(10)))[0]);
    ___arguments.context.pageData['Service_Due_Table_Horse_Service'] = false;
    ___arguments.context.pageData['Service_Due_Table_Horse_Repair'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c2b2435813b9d528a56eecc596cf94c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4bc355cbfa331854e5c326026ec55b41', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Trailer_1_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')),'\''].join(''))).setPageSize(10)))[0]);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('591ff9311ac43105a1380544107cc892', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_2')) != null) {
    ___arguments.context.pageData['Service_Due_Table_Trailer_2'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_2')),'\''].join(''))).setPageSize(10)))[0]);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_3')) != null) {
    ___arguments.context.pageData['Service_Due_Table_Trailer_3'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_3')),'\''].join(''))).setPageSize(10)))[0]);
  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/93d449a62b413c361725b037c3ebee1a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('da962d555aa7b166e5e30dfc9743a357');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/0e87ada8b72292789f2c28436ae953ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Trailer_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/92e3557497187098b44b1b3866fcb42d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Fleet_ID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/bd1b415348b2eff9bb4927ad72fa2c47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Vin'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/383797c8346cad035a37d04740558af8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/7ab97d8eb89f3d5fc3b76dd343cff88a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/bd0e77bb4514981e3d07037328caac8c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Year'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/599462284cad868a76a3f7d577425b6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Current_Mileage')) + String(' Km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/57f84fe5e1e412ab136cced5265da838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Currently_On'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/8aa3f6bc308d1ceee647157b796daf4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bd2585390a34489a10429a73e9c0c3b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23f42799911aef7b6bbf21d5ec5c1ab5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13f1e05c3083ea44280e5993fe8b1af3', true);
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Service_Notes'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')), 'Service_Notes'));
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Repairs_Conducted'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')), 'Repairs_Conducted'));
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Cost'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')), 'Cost'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/11c74048623a36657c12bf4d48fa4105/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Service_Notes'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/038ee04bfd56da31b61f7bb3aacaa966/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Repairs_Conducted'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/b5ddb7979ead59a230b15d462b654b3f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bd2585390a34489a10429a73e9c0c3b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23f42799911aef7b6bbf21d5ec5c1ab5', true);
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Service_Notes'] = null;
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Repairs_Conducted'] = null;
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Cost'] = null;
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Service_Notes'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/a754e9c3eb7cca03f252692fc3554443/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Service_Notes'] = null;
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Repairs_Conducted'] = null;
  (getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1'))['Last_Service_Mileage'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Current_Mileage'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Service_Notes'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Trailer1_Mileage_At_Service'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Current_Mileage'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Completion_Status'] = 'Completed';
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Date_Completed'] = (new Date());
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')) );
  await Backendless.Data.of('Trailers').save( (getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('591ff9311ac43105a1380544107cc892', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/674d3ea938779ca58d6ea5dfd535211d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/b90106c865ae6994fb31f396fc4714b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Horse_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/b69ebc3ba46f3409df97097f3e5b37f3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Fleet_ID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/e50e8734200220a4a0fcd9ff4afd9a8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'VIN'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/faa2bc34633a3bcc8e02b1de263a3f16/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Engine_Number'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/5d9343f2001a31560af93861f037374e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/6a1681032ae4e623b68e1ddba1155b21/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/342d43c6cf294a8fb6ac44f9cecb5f21/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Year'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/483612de4b4564e514d5d762c5535f37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2122580a515425d53ebfb14859ba6462', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc9b24cc9605994702d87fd318d4e4f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c28cfb9bc59f1f77e9d57bbf077dddc6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('048bd4e88f021d151a25372fc6c30878', true);
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Horse_Mileage_At_Service'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')), 'Horse_Mileage_At_Service'));
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Service_Notes'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')), 'Service_Notes'));
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Repairs_Conducted'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')), 'Repairs_Conducted'));
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Cost'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')), 'Cost'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/a1af57df5b5517070f67e7b9b8c71c63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc9b24cc9605994702d87fd318d4e4f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c28cfb9bc59f1f77e9d57bbf077dddc6', true);
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Service_Notes'] = null;
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Repairs_Conducted'] = null;
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Cost'] = null;
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Service_Notes'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/d0fb6cde83cf086e25bda448ec43812c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Horse;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Service_Notes'] = null;
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Repairs_Conducted'] = null;
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Cost'] = null;
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Service_Notes'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Horse_Mileage_At_Service'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Horse_Mileage_At_Service'));
  New_Horse = (getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse'));
  New_Horse['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Horse_Mileage_At_Service'));
  await Backendless.Data.of('Vehicles').save( New_Horse );
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Completion_Status'] = 'Completed';
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Date_Completed'] = (new Date());
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4bc355cbfa331854e5c326026ec55b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/00ceee7b0d44c141a4314b13268a54ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Horse_Mileage_At_Service'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Horse_Mileage_At_Service'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/5609beda910b2e39149b4e2a107e9757/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Service_Notes'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/05e1069d6e7911861939f5b1e3b56cfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Repairs_Conducted'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/0034c7ec135a997376daaa86cc7470ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/3aeaf46602e932b3e9cd2b62c0c7c32e/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Service_Status = \'Service Due\' AND Schedule_Status = \'None\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Selected_Service_Due_Horse_Record'] = ___arguments.selectedRecord;
  ___arguments.context.pageData['Scheduler_Viewer'] = false;
  ___arguments.context.pageData['Service_Due_Table_Horse'] = ((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Horse_Registration')),'\''].join(''))).setPageSize(10)))[0]);
  console.log(getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c2b2435813b9d528a56eecc596cf94c', true);
  ___arguments.context.pageData['Service_Due_Table_Horse_Service'] = false;
  ___arguments.context.pageData['Service_Due_Table_Horse_Repair'] = false;

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/767c4491b2e4fede819406680681633a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('3aeaf46602e932b3e9cd2b62c0c7c32e');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/4ac3085c979d046ec87550d7d0cd1625/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Service_Status = \'Service Due\' AND Schedule_Status = \'None\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Selected_Service_Due_Trailer_Record'] = ___arguments.selectedRecord;
  ___arguments.context.pageData['Scheduler_Viewer_3'] = false;
  ___arguments.context.pageData['Service_Due_Table_Trailer_1'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Trailer_Registration')),'\''].join(''))).setPageSize(10)))[0]);
  ___arguments.context.pageData['Record_Selected_Service_Due_Trailer1_Viewer'] = true;
  ___arguments.context.pageData['Service_Due_Table_Trailer_Service'] = false;
  ___arguments.context.pageData['Service_Due_Table_Trailer_Repair'] = false;

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/21f85ab90133657d86797b16ae2ee28c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4ac3085c979d046ec87550d7d0cd1625');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/99b230c291e2fc3cf3238854f3fb4c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  ___arguments.context.pageData['Repair_Viewer'] = true;
  ___arguments.context.pageData['Vehicles_List'] = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10)));
  ___arguments.context.pageData['Trailers_List'] = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10)));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('1f9d3a61ba76de03823525ca085b8fa8', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles_List')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Horse_Registration')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('11ff39ac4faf59864f68b234b343f4da', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Trailers_List')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Trailer_Registration')) });}))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/ce43cd6e159c65e242a713efbf48b962/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['Filtered_Vehicle_List'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Vehicles_List')), async (item) => {


   return ((getObjectProperty(item, 'Horse_Registration')).toLowerCase().indexOf(___arguments.value.toLowerCase()) + 1 != 0);
  }));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('1f9d3a61ba76de03823525ca085b8fa8', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Filtered_Vehicle_List')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Horse_Registration')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/ff9606d281955ba92f72e907dc61539e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Repair_Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/1b34220af6f74453fe7ab1312f37e577/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['Filtered_Trailer_List'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Trailers_List')), async (item) => {


   return ((getObjectProperty(item, 'Trailer_Registration')).toLowerCase().indexOf(___arguments.value.toLowerCase()) + 1 != 0);
  }));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('11ff39ac4faf59864f68b234b343f4da', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Filtered_Trailer_List')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Trailer_Registration')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/1f9d3a61ba76de03823525ca085b8fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['Selected_Horse_Repair'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Vehicles_List')), async (item) => {


   return (___arguments.value == (getObjectProperty(item, 'objectId')));
  }))[0]);
  ___arguments.context.pageData['New_Horse_Repair'] = (await Backendless.Data.of('Repairs_Maintenance').save( ({ 'Completion_Status': 'Scheduled','Cost': undefined,'Date_Scheduled': (new Date()),'Registration_Horse': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Horse_Registration')),'Repair_Or_Service': 'Repair','Repairs_Conducted': undefined,'Scheduled_Notes': undefined,'Service_Notes': undefined,'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83a6fc9424db2a765b195747c78aec53', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/7c132aa476fe6151842fae666856b54d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Horse_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/86b5532f76c841e8aea38a646b34b05d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Fleet_ID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/edaf5515753b824fca414554d42a2d1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'VIN'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/852f3d1fd0d59de1874c5abe68eb8071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Engine_Number'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/c61bb1c42246adab5696197811363f25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/412c9b04a1e7822a69870b64868ce387/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/d76fc659fc3ece6398cd01f16cf8a0be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Year'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/11ff39ac4faf59864f68b234b343f4da/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['Selected_Trailer_Repair'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Trailers_List')), async (item) => {


   return (___arguments.value == (getObjectProperty(item, 'objectId')));
  }))[0]);
  ___arguments.context.pageData['New_Trailer_Repair'] = (await Backendless.Data.of('Repairs_Maintenance').save( ({ 'Completion_Status': 'Scheduled','Cost': undefined,'Date_Scheduled': (new Date()),'Registration_Trailer_1': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Trailer_Registration')),'Trailer1_Mileage_At_Service': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Current_Mileage')),'Repair_Or_Service': 'Repair','Repairs_Conducted': undefined,'Scheduled_Notes': undefined,'Service_Notes': undefined,'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03854a0902b645e81b28d5723f082e23', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/1c82d4aedea456057fac3a573f0a2eb7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Trailer_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/0b13e7b13fab6035166f470503fd5565/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Fleet_ID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/3755266db27b5a59ad0a9684ce7cdc5a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Vin'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/6a5390c4fb794efc9caf0c5b8cbfc2e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/517d86e6e655cf2cca64bc1a5ef8ae71/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/8db698bc3174d6471a2e5d813da26524/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Year'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/ee439839825c99dfc51b600e07f2e574/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Current_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/43cc89463b776783e1151e7a092183fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Currently_On'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/f3447aa8dd3945395fd8dacac102de3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5ad50fe39dd4e7e1dc3e8b41782548f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bff524bdb2e6e5c56ce84d7cdfcb138', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85216395c60d03c42bb12ad60182d41f', true);
  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Horse_Mileage_At_Service'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')), 'Horse_Mileage_At_Service'));
  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Repairs_Conducted'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')), 'Repairs_Conducted'));
  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Cost'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')), 'Cost'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/1a1123b71fafdc7b49f744780a46b46a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Horse_Mileage_At_Service'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Horse_Mileage_At_Service'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/d5b5818f4a58ab9c0122f814034cd04e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Repairs_Conducted'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/9e04184a1ed8d44f523bd168a1d673ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/0ad5cc4c1bb621859c94ca617d97a569/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Horse_Mileage_At_Service'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Horse_Mileage_At_Service'));
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Cost'));
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Date_Completed'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Completion_Status'] = 'Completed';
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83a6fc9424db2a765b195747c78aec53', false);
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('1f9d3a61ba76de03823525ca085b8fa8', null);
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('11ff39ac4faf59864f68b234b343f4da', null);

  } catch (error) {

  }
  ___arguments.context.pageData['Repair_Viewer'] = false;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('5d381f1f5424c68c28d30d84123c11db');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/8701feb93cc74d62173f8ea40261a9cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Horse_Mileage_At_Service'] = null;
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Horse_Mileage_At_Service'] = null;
  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Repairs_Conducted'] = null;
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Repairs_Conducted'] = null;
  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Cost'] = null;
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Cost'] = null;
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/a457470f2bf1727b0037f9adcc18e10b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee12d1a43338b4250499924dc3b45cfc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b2ba9e43c16fa76bd1f4c33d7b0e22ab', true);
  ___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23')['Repairs_Conducted'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Repairs_Conducted'));
  ___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23')['Cost'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Cost'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/9d8df50abb4eb439bfe4e441c0aa0f54/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23')['Repairs_Conducted'] = null;
  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Repairs_Conducted'] = null;
  ___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23')['Cost'] = null;
  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Cost'] = null;
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/ed7ce6317e2b829f5caccb289d13e0ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23'), 'Cost'));
  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Date_Completed'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Completion_Status'] = 'Completed';
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03854a0902b645e81b28d5723f082e23', false);
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('1f9d3a61ba76de03823525ca085b8fa8', null);
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('11ff39ac4faf59864f68b234b343f4da', null);

  } catch (error) {

  }
  ___arguments.context.pageData['Repair_Viewer'] = false;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('5d381f1f5424c68c28d30d84123c11db');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/1cb8d01e1a21ce1b121eaa059b7a6817/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23'), 'Repairs_Conducted'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/1b9461a9a6f27fc9a4c48a947b6f3473/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/5d381f1f5424c68c28d30d84123c11db/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Completion_Status = \'Scheduled\' AND Repair_Or_Service = \'Repair\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')) == null) {
    ___arguments.context.pageData['Selected_Trailer_Repair'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')),'\''].join(''))).setPageSize(10)))[0]);
    ___arguments.context.pageData['New_Trailer_Repair'] = ___arguments.selectedRecord;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03854a0902b645e81b28d5723f082e23', true);
  } else {
    ___arguments.context.pageData['Selected_Horse_Repair'] = ((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')),'\''].join(''))).setPageSize(10)))[0]);
    ___arguments.context.pageData['New_Horse_Repair'] = ___arguments.selectedRecord;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83a6fc9424db2a765b195747c78aec53', true);
  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/ad9ae6daac6761ac78212851d9ca2846/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('5d381f1f5424c68c28d30d84123c11db');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/d32c3429d1e23c2608775fb9d21208e6/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Result = (getObjectProperty(___arguments.context.pageData, 'Service_Due_Average'));

  return [Result]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/77fa07ad48e4ea8f7631256fa44e3038/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.pageData, 'Tyre_Life_Average'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/a1cbef3f61c43cd584bd28d423b1a241/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Average Tyre Life (',(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.pageData, 'Tyre_Life_Average')))),'%)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/95e56ad5e0fafb8c63c176aa7f6b9b0e/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Completion_Status = \'Completed\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/83d77ab74796dda4d6c66dfd568a3973/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('95e56ad5e0fafb8c63c176aa7f6b9b0e');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/fe4e4e4e2d0d9d8a9727a64bde8170fc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Percentage of assets due for Service (',(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.pageData, 'Service_Due_Average')))),'%)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/25e1e91ca988933c9adf88f3a3921072/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.pageData, 'Over_Mileage_Tyres'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/e686bd4ffad4b6957cf1718c68ab2e68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Percentage of Tyres over Mileage (',(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.pageData, 'Over_Mileage_Tyres')))),'%)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/1993e13cb692b67cc4c1228c16ce84ba/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('20312f99482797f4157228f54b9fa217', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89cbdd9906f1205369b27df94c0a9bac', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/731dbd24d54ee20f884e0fe15e3792f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == false) {
    ___arguments.context.pageData['WS_Hamburger_View'] = true;
  } else {
    ___arguments.context.pageData['WS_Hamburger_View'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintainance_Hub_Mobile/components/8096fb55ff9c027bc50ec5ae514327e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Start_Date, Counter, RGBA, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tyre_Clear() {
  Counter = 0;
  for (var count = 0; count < 90; count++) {
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = null;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function Page_Enter_Procedure() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);

  } catch (error) {
    console.log(error);

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('591ff9311ac43105a1380544107cc892', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc0e7dd276e8f74df413f7b475dad8a7', false);
  ___arguments.context.pageData['RGBA'] = 1;
  for (var count2 = 0; count2 < 100; count2++) {
    RGBA = (getObjectProperty(___arguments.context.pageData, 'RGBA')) - 0.01;
    ___arguments.context.pageData['RGBA'] = RGBA;
    await new Promise(r => setTimeout(r, 0.5 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6'))['backgroundColor'] = (['rgba(0, 0, 0, ',RGBA,')'].join(''));
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', false);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);
  ___arguments.context.pageData['User_OwnerId'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  ___arguments.context.pageData['Tyre_Swap_Edit_True2'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False2'] = true;
  ___arguments.context.pageData['Tyre_Swap_Edit_True'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False'] = true;
  ___arguments.context.pageData['Images_View'] = false;
  try {
    ___arguments.context.pageData['Tyre_Life_Average'] = (await BackendlessUI.Functions.Custom['fn_518de41fac043aee8b8e5d4a87521873']('Tyres', (['ownerId =\'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\''].join('')), 'Life'));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Service_Due_Average_Test'] = ((((await Backendless.Data.of('Vehicles').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\' AND Service_Status = \'Service Due\''].join(''))))) + (await Backendless.Data.of('Trailers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\' AND Service_Status = \'Service Due\''].join('')))))) / ((await Backendless.Data.of('Vehicles').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\''].join(''))))) + (await Backendless.Data.of('Trailers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\''].join(''))))))) * 100);

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Over_Mileage_Tyres'] = (((await Backendless.Data.of('Tyres').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\' AND Over_MIleage = \'Over Mileage\''].join(''))))) / (await Backendless.Data.of('Tyres').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\''].join('')))))) * 100);

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Service_Due_Average'] = ((getObjectProperty(___arguments.context.pageData, 'Service_Due_Average_Test')) == Infinity ? 0 : (getObjectProperty(___arguments.context.pageData, 'Service_Due_Average_Test')));

  } catch (error) {

  }
  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  ___arguments.context.pageData['Company'] = ((await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10)))[0]);
  ___arguments.context.pageData['Company_Logo'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Company_Logo'));
  ___arguments.context.pageData['Company_Name'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Company'));
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  if (!(await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  Start_Date = (new Date());
  Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
  Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
  Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
  Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
  Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
  ___arguments.context.pageData['Start_Date'] = Start_Date;
  ___arguments.context.pageData['End_Date'] = (new Date());
  console.log('abc');
  await Page_Enter_Procedure();

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Maintenance_Hub_Web/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/b612d3b3061d799155f81a9286caaa69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      try {
    ___arguments.context.pageData['Repair_Viewer'] = false;

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Tyre_Icon_Select'] = false;

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83a6fc9424db2a765b195747c78aec53', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03854a0902b645e81b28d5723f082e23', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('591ff9311ac43105a1380544107cc892', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4bc355cbfa331854e5c326026ec55b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('20312f99482797f4157228f54b9fa217', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89cbdd9906f1205369b27df94c0a9bac', true);
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/65d3504d17c60c9dfecd3e95b1ffcbeb/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/cf2d5a1bc5dfeba8a9db31784a714f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Images_View'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/41f553479872cab9abf931ef3b0b2e47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Image_1'] = null;
  ___arguments.context.pageData['Image_2'] = null;
  ___arguments.context.pageData['Image_3'] = null;
  ___arguments.context.pageData['Image_3'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/daa89079a11340a16fc711568858863d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Image_Text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Image_1')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_2')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_3')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_4')) == null) {
    Image_Text = 'No Images Available';
  } else {
    Image_Text = (getObjectProperty(___arguments.context.pageData, 'DataImageText'));
  }

  return Image_Text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/e23b96acd1879198dc2f19e4e90eb0e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/b7649fc62cc8a1432e22311afd238672/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/2fae753c674e30dff7e7456114e29c61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/cd7e08f865dbe001d7579334b4752399/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/da9736f35fb4ac560cf3525ec7b83f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', true);
  ___arguments.context.pageData['Add_Tyre_Data'] = ((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Tyre_Number').setPageSize(100))).map(async item => {; return ({ 'Tyre_Number': (getObjectProperty(item, 'Tyre_Number')),'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')) });}))).slice(-1)[0]);
  await Backendless.Data.of('Tyres').save( ({ 'State': 'In Order','Cost': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cost')),'Current_Cap_State': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cap_State')),'Current_Mileage': 0,'Expected_Mileage': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_EM')),'Fleet_Brand': String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Fleet_Brand')).slice(0, 5)) + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1),'Make': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Make')),'Model': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Model')),'Serial_Number': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_SN')),'System_Generated_Tyre': 'No','Type': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Type')),'Tyre_Number': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1,'Tyre_Position': null,'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );
  ___arguments.context.pageData['Add_Tyre_Cost'] = null;
  ___arguments.context.pageData['Add_Tyre_Cap_State'] = null;
  ___arguments.context.pageData['Add_Tyre_EM'] = null;
  ___arguments.context.pageData['Add_Tyre_Make'] = null;
  ___arguments.context.pageData['Add_Tyre_Model'] = null;
  ___arguments.context.pageData['Add_Tyre_SN'] = null;
  ___arguments.context.pageData['Add_Tyre_Type'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/44c3b966ea3806de97b4f9779b9e8b08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', true);
  ___arguments.context.pageData['Add_Tyre_Data'] = ((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Tyre_Number').setPageSize(100))).map(async item => {; return ({ 'Tyre_Number': (getObjectProperty(item, 'Tyre_Number')),'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')) });}))).slice(-1)[0]);
  await Backendless.Data.of('Tyres').save( ({ 'State': 'In Order','Cost': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cost')),'Current_Cap_State': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cap_State')),'Current_Mileage': 0,'Expected_Mileage': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_EM')),'Fleet_Brand': String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Fleet_Brand')).slice(0, 5)) + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1),'Make': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Make')),'Model': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Model')),'Serial_Number': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_SN')),'System_Generated_Tyre': 'No','Type': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Type')),'Tyre_Number': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1,'Tyre_Position': null,'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );
  ___arguments.context.pageData['Add_Tyre_Cost'] = null;
  ___arguments.context.pageData['Add_Tyre_Cap_State'] = null;
  ___arguments.context.pageData['Add_Tyre_EM'] = null;
  ___arguments.context.pageData['Add_Tyre_Make'] = null;
  ___arguments.context.pageData['Add_Tyre_Model'] = null;
  ___arguments.context.pageData['Add_Tyre_SN'] = null;
  ___arguments.context.pageData['Add_Tyre_Type'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/3d5325c98073def13916f9efa43608a1/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/d4c45696ad32d68d06987d2729e37336/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Over_Mileage = \'Over Mileage\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/da962d555aa7b166e5e30dfc9743a357/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Completion_Status = \'Scheduled\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Horse_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Scheduler_Viewer'] = true;
    ___arguments.context.pageData['Service_Due_Table_Horse'] = ((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')),'\''].join(''))).setPageSize(10)))[0]);
    console.log(getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c2b2435813b9d528a56eecc596cf94c', true);
    ___arguments.context.pageData['Service_Due_Table_Horse_Service'] = false;
    ___arguments.context.pageData['Service_Due_Table_Horse_Repair'] = false;
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Trailer_1_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Scheduler_Viewer'] = true;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')),'\''].join(''))).setPageSize(10)))[0]);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11974116ba9d4519cc99ebcd2e41f19b', true);
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = false;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = false;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Service'] = false;
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_2')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Trailer_1_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Scheduler_Viewer'] = true;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')),'\''].join(''))).setPageSize(10)))[0]);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11974116ba9d4519cc99ebcd2e41f19b', true);
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = false;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Service'] = false;
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_3')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Trailer_1_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Scheduler_Viewer'] = true;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')),'\''].join(''))).setPageSize(10)))[0]);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11974116ba9d4519cc99ebcd2e41f19b', true);
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = false;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1_Service'] = false;
  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/af042cd4926a40945e932d3882ebd0e2/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Completion_Status = \'Commenced\' AND Repair_Or_Service = \'Service\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Horse_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Service_Due_Table_Horse'] = ((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')),'\''].join(''))).setPageSize(10)))[0]);
    ___arguments.context.pageData['Service_Due_Table_Horse_Service'] = false;
    ___arguments.context.pageData['Service_Due_Table_Horse_Repair'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c2b2435813b9d528a56eecc596cf94c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4bc355cbfa331854e5c326026ec55b41', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')) != null) {
    ___arguments.context.pageData['Selected_Service_Due_Trailer_1_Record'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Service_Due_Table_Trailer_1'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')),'\''].join(''))).setPageSize(10)))[0]);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('591ff9311ac43105a1380544107cc892', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_2')) != null) {
    ___arguments.context.pageData['Service_Due_Table_Trailer_2'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_2')),'\''].join(''))).setPageSize(10)))[0]);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_3')) != null) {
    ___arguments.context.pageData['Service_Due_Table_Trailer_3'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_3')),'\''].join(''))).setPageSize(10)))[0]);
  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/0e87ada8b72292789f2c28436ae953ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Trailer_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/92e3557497187098b44b1b3866fcb42d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Fleet_ID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/bd1b415348b2eff9bb4927ad72fa2c47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Vin'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/383797c8346cad035a37d04740558af8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/7ab97d8eb89f3d5fc3b76dd343cff88a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/bd0e77bb4514981e3d07037328caac8c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Year'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/599462284cad868a76a3f7d577425b6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Current_Mileage')) + String(' Km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/57f84fe5e1e412ab136cced5265da838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Currently_On'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/8aa3f6bc308d1ceee647157b796daf4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bd2585390a34489a10429a73e9c0c3b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23f42799911aef7b6bbf21d5ec5c1ab5', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('13f1e05c3083ea44280e5993fe8b1af3', true);
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Service_Notes'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')), 'Service_Notes'));
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Repairs_Conducted'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')), 'Repairs_Conducted'));
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Cost'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')), 'Cost'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/11c74048623a36657c12bf4d48fa4105/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Service_Notes'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/038ee04bfd56da31b61f7bb3aacaa966/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Repairs_Conducted'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/b5ddb7979ead59a230b15d462b654b3f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bd2585390a34489a10429a73e9c0c3b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23f42799911aef7b6bbf21d5ec5c1ab5', true);
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Service_Notes'] = null;
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Repairs_Conducted'] = null;
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Cost'] = null;
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Service_Notes'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/a754e9c3eb7cca03f252692fc3554443/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Service_Notes'] = null;
  ___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892')['Repairs_Conducted'] = null;
  (getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1'))['Last_Service_Mileage'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Current_Mileage'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Service_Notes'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Trailer1_Mileage_At_Service'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Current_Mileage'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Completion_Status'] = 'Completed';
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Date_Completed'] = (new Date());
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')) );
  await Backendless.Data.of('Trailers').save( (getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('591ff9311ac43105a1380544107cc892', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/674d3ea938779ca58d6ea5dfd535211d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('591ff9311ac43105a1380544107cc892'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Trailer_1_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/b90106c865ae6994fb31f396fc4714b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Horse_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/b69ebc3ba46f3409df97097f3e5b37f3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Fleet_ID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/e50e8734200220a4a0fcd9ff4afd9a8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'VIN'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/faa2bc34633a3bcc8e02b1de263a3f16/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Engine_Number'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/5d9343f2001a31560af93861f037374e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/6a1681032ae4e623b68e1ddba1155b21/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/342d43c6cf294a8fb6ac44f9cecb5f21/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Year'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/483612de4b4564e514d5d762c5535f37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2122580a515425d53ebfb14859ba6462', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc9b24cc9605994702d87fd318d4e4f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c28cfb9bc59f1f77e9d57bbf077dddc6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('048bd4e88f021d151a25372fc6c30878', true);
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Horse_Mileage_At_Service'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')), 'Horse_Mileage_At_Service'));
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Service_Notes'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')), 'Service_Notes'));
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Repairs_Conducted'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')), 'Repairs_Conducted'));
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Cost'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')), 'Cost'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/a1af57df5b5517070f67e7b9b8c71c63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc9b24cc9605994702d87fd318d4e4f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c28cfb9bc59f1f77e9d57bbf077dddc6', true);
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Service_Notes'] = null;
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Repairs_Conducted'] = null;
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Cost'] = null;
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Service_Notes'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/d0fb6cde83cf086e25bda448ec43812c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Horse;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Service_Notes'] = null;
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Repairs_Conducted'] = null;
  ___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41')['Cost'] = null;
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Service_Notes'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Horse_Mileage_At_Service'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Horse_Mileage_At_Service'));
  New_Horse = (getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse'));
  New_Horse['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Horse_Mileage_At_Service'));
  await Backendless.Data.of('Vehicles').save( New_Horse );
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Completion_Status'] = 'Completed';
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Date_Completed'] = (new Date());
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4bc355cbfa331854e5c326026ec55b41', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/00ceee7b0d44c141a4314b13268a54ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Horse_Mileage_At_Service'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Horse_Mileage_At_Service'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/5609beda910b2e39149b4e2a107e9757/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Service_Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Service_Notes'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/05e1069d6e7911861939f5b1e3b56cfa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Repairs_Conducted'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/0034c7ec135a997376daaa86cc7470ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4bc355cbfa331854e5c326026ec55b41'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/3aeaf46602e932b3e9cd2b62c0c7c32e/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Service_Status = \'Service Due\' AND Schedule_Status = \'None\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Selected_Service_Due_Horse_Record'] = ___arguments.selectedRecord;
  ___arguments.context.pageData['Scheduler_Viewer'] = false;
  ___arguments.context.pageData['Service_Due_Table_Horse'] = ((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Horse_Registration')),'\''].join(''))).setPageSize(10)))[0]);
  console.log(getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c2b2435813b9d528a56eecc596cf94c', true);
  ___arguments.context.pageData['Service_Due_Table_Horse_Service'] = false;
  ___arguments.context.pageData['Service_Due_Table_Horse_Repair'] = false;

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/4ac3085c979d046ec87550d7d0cd1625/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Service_Status = \'Service Due\' AND Schedule_Status = \'None\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Selected_Service_Due_Trailer_Record'] = ___arguments.selectedRecord;
  ___arguments.context.pageData['Scheduler_Viewer_3'] = false;
  ___arguments.context.pageData['Service_Due_Table_Trailer_1'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Trailer_Registration')),'\''].join(''))).setPageSize(10)))[0]);
  ___arguments.context.pageData['Record_Selected_Service_Due_Trailer1_Viewer'] = true;
  ___arguments.context.pageData['Service_Due_Table_Trailer_Service'] = false;
  ___arguments.context.pageData['Service_Due_Table_Trailer_Repair'] = false;

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/ce43cd6e159c65e242a713efbf48b962/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['Filtered_Vehicle_List'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Vehicles_List')), async (item) => {


   return ((getObjectProperty(item, 'Horse_Registration')).toLowerCase().indexOf(___arguments.value.toLowerCase()) + 1 != 0);
  }));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('1f9d3a61ba76de03823525ca085b8fa8', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Filtered_Vehicle_List')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Horse_Registration')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/ff9606d281955ba92f72e907dc61539e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Repair_Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/1b34220af6f74453fe7ab1312f37e577/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['Filtered_Trailer_List'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Trailers_List')), async (item) => {


   return ((getObjectProperty(item, 'Trailer_Registration')).toLowerCase().indexOf(___arguments.value.toLowerCase()) + 1 != 0);
  }));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('11ff39ac4faf59864f68b234b343f4da', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Filtered_Trailer_List')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Trailer_Registration')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/1f9d3a61ba76de03823525ca085b8fa8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['Selected_Horse_Repair'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Vehicles_List')), async (item) => {


   return (___arguments.value == (getObjectProperty(item, 'objectId')));
  }))[0]);
  ___arguments.context.pageData['New_Horse_Repair'] = (await Backendless.Data.of('Repairs_Maintenance').save( ({ 'Completion_Status': 'Scheduled','Cost': undefined,'Date_Scheduled': (new Date()),'Registration_Horse': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Horse_Registration')),'Repair_Or_Service': 'Repair','Repairs_Conducted': undefined,'Scheduled_Notes': undefined,'Service_Notes': undefined,'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83a6fc9424db2a765b195747c78aec53', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/7c132aa476fe6151842fae666856b54d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Horse_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/86b5532f76c841e8aea38a646b34b05d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Fleet_ID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/edaf5515753b824fca414554d42a2d1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'VIN'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/852f3d1fd0d59de1874c5abe68eb8071/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Engine_Number'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/c61bb1c42246adab5696197811363f25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/412c9b04a1e7822a69870b64868ce387/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/d76fc659fc3ece6398cd01f16cf8a0be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Horse_Repair')), 'Year'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/11ff39ac4faf59864f68b234b343f4da/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['Selected_Trailer_Repair'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Trailers_List')), async (item) => {


   return (___arguments.value == (getObjectProperty(item, 'objectId')));
  }))[0]);
  ___arguments.context.pageData['New_Trailer_Repair'] = (await Backendless.Data.of('Repairs_Maintenance').save( ({ 'Completion_Status': 'Scheduled','Cost': undefined,'Date_Scheduled': (new Date()),'Registration_Trailer_1': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Trailer_Registration')),'Trailer1_Mileage_At_Service': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Current_Mileage')),'Repair_Or_Service': 'Repair','Repairs_Conducted': undefined,'Scheduled_Notes': undefined,'Service_Notes': undefined,'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03854a0902b645e81b28d5723f082e23', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/1c82d4aedea456057fac3a573f0a2eb7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Trailer_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/0b13e7b13fab6035166f470503fd5565/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Fleet_ID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/3755266db27b5a59ad0a9684ce7cdc5a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Vin'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/6a5390c4fb794efc9caf0c5b8cbfc2e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/517d86e6e655cf2cca64bc1a5ef8ae71/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/8db698bc3174d6471a2e5d813da26524/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Year'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/ee439839825c99dfc51b600e07f2e574/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Current_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/43cc89463b776783e1151e7a092183fb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Currently_On'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/f3447aa8dd3945395fd8dacac102de3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5ad50fe39dd4e7e1dc3e8b41782548f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0bff524bdb2e6e5c56ce84d7cdfcb138', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85216395c60d03c42bb12ad60182d41f', true);
  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Horse_Mileage_At_Service'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')), 'Horse_Mileage_At_Service'));
  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Repairs_Conducted'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')), 'Repairs_Conducted'));
  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Cost'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')), 'Cost'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/1a1123b71fafdc7b49f744780a46b46a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Horse_Mileage_At_Service'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Horse_Mileage_At_Service'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/d5b5818f4a58ab9c0122f814034cd04e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Repairs_Conducted'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/9e04184a1ed8d44f523bd168a1d673ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/0ad5cc4c1bb621859c94ca617d97a569/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Horse_Mileage_At_Service'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Horse_Mileage_At_Service'));
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53'), 'Cost'));
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Date_Completed'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Completion_Status'] = 'Completed';
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83a6fc9424db2a765b195747c78aec53', false);
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('1f9d3a61ba76de03823525ca085b8fa8', null);
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('11ff39ac4faf59864f68b234b343f4da', null);

  } catch (error) {

  }
  ___arguments.context.pageData['Repair_Viewer'] = false;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('5d381f1f5424c68c28d30d84123c11db');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/8701feb93cc74d62173f8ea40261a9cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Horse_Mileage_At_Service'] = null;
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Horse_Mileage_At_Service'] = null;
  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Repairs_Conducted'] = null;
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Repairs_Conducted'] = null;
  ___arguments.context.getComponentDataStoreByUid('83a6fc9424db2a765b195747c78aec53')['Cost'] = null;
  (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair'))['Cost'] = null;
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Horse_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/a457470f2bf1727b0037f9adcc18e10b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee12d1a43338b4250499924dc3b45cfc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b2ba9e43c16fa76bd1f4c33d7b0e22ab', true);
  ___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23')['Repairs_Conducted'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Repairs_Conducted'));
  ___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23')['Cost'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Trailer_Repair')), 'Cost'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/9d8df50abb4eb439bfe4e441c0aa0f54/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23')['Repairs_Conducted'] = null;
  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Repairs_Conducted'] = null;
  ___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23')['Cost'] = null;
  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Cost'] = null;
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/ed7ce6317e2b829f5caccb289d13e0ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23'), 'Repairs_Conducted'));
  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23'), 'Cost'));
  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Date_Completed'] = (new Date());
  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Completion_Status'] = 'Completed';
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03854a0902b645e81b28d5723f082e23', false);
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('1f9d3a61ba76de03823525ca085b8fa8', null);
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('11ff39ac4faf59864f68b234b343f4da', null);

  } catch (error) {

  }
  ___arguments.context.pageData['Repair_Viewer'] = false;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('5d381f1f5424c68c28d30d84123c11db');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/1cb8d01e1a21ce1b121eaa059b7a6817/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Repairs_Conducted'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23'), 'Repairs_Conducted'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/1b9461a9a6f27fc9a4c48a947b6f3473/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair'))['Cost'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('03854a0902b645e81b28d5723f082e23'), 'Cost'));
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Trailer_Repair')) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/5d381f1f5424c68c28d30d84123c11db/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Completion_Status = \'Scheduled\' AND Repair_Or_Service = \'Repair\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')) == null) {
    ___arguments.context.pageData['Selected_Trailer_Repair'] = ((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Trailer_1')),'\''].join(''))).setPageSize(10)))[0]);
    ___arguments.context.pageData['New_Trailer_Repair'] = ___arguments.selectedRecord;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03854a0902b645e81b28d5723f082e23', true);
  } else {
    ___arguments.context.pageData['Selected_Horse_Repair'] = ((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse_Registration = \'',(getObjectProperty(___arguments.selectedRecord, 'Registration_Horse')),'\''].join(''))).setPageSize(10)))[0]);
    ___arguments.context.pageData['New_Horse_Repair'] = ___arguments.selectedRecord;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83a6fc9424db2a765b195747c78aec53', true);
  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/d32c3429d1e23c2608775fb9d21208e6/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Result = (getObjectProperty(___arguments.context.pageData, 'Service_Due_Average'));

  return [Result]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/77fa07ad48e4ea8f7631256fa44e3038/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.pageData, 'Tyre_Life_Average'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/a1cbef3f61c43cd584bd28d423b1a241/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Average Tyre Life (',(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.pageData, 'Tyre_Life_Average')))),'%)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/95e56ad5e0fafb8c63c176aa7f6b9b0e/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Completion_Status = \'Completed\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/fe4e4e4e2d0d9d8a9727a64bde8170fc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Percentage of assets due for Service (',(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.pageData, 'Service_Due_Average')))),'%)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/25e1e91ca988933c9adf88f3a3921072/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.pageData, 'Over_Mileage_Tyres'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/e686bd4ffad4b6957cf1718c68ab2e68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Percentage of Tyres over Mileage (',(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.pageData, 'Over_Mileage_Tyres')))),'%)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/a741958ea3964e1924aa91532567bfac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Hamburger_View')) == false || (typeof (getObjectProperty(___arguments.context.pageData, 'Hamburger_View')) === 'undefined')) {
    ___arguments.context.pageData['Hamburger_View'] = true;
  } else {
    ___arguments.context.pageData['Hamburger_View'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/8096fb55ff9c027bc50ec5ae514327e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Maintenance_Hub_Web/components/55af00ebffb1f98cd34e7ab8b29c2448/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Hamburger_View'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Notify/components/b98e4a0445339c6f6f41921a76f99f97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'town'));
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('ca92086d7b6a8ae9a91d3aab402c469e', [({ 'autoOpenInfo': true,'infoWindow': ['<b>','Raymond','</b>: ','is Here'].join(''),'lat': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lat')),'lng': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lng')),'showLabel': true })]);
  await Backendless.Messaging.pushWithTemplate('Load_Data', ({ 'type': [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('5fbb77e63946f9fdc0c5b70bae9afddd')),' - ',(getObjectProperty(___arguments.context.pageData, 'Road')),' ',(getObjectProperty(___arguments.context.pageData, 'Direction'))].join(''),'Message': [(getObjectProperty(___arguments.context.pageData, 'Distance')),'Km from ',(getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'town')), 'terms'))[0]), 'value')),': ',(getObjectProperty(___arguments.context.pageData, 'Message'))].join('') }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Notify/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['currentLocation'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  ___arguments.context.pageData['Markers'] = [];
  ___arguments.context.pageData['Markers_Google'] = [];
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('ca92086d7b6a8ae9a91d3aab402c469e', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lat')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('ca92086d7b6a8ae9a91d3aab402c469e', 12);
  await ( async function (componentUid, latitude, longitude) {  ___arguments.context.getComponentByUid(componentUid).setMapCenter(latitude, longitude) })('173e392552718827f0c44c63bb740345', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lat')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lng')));
  (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken } })('f161b3417d02b191cba855ed34d5619e', undefined, undefined, ({ 'lat': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lat')),'lng': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lng')) }), undefined, undefined, 50000, undefined, undefined);
  await ( async function (componentUid, latitude, longitude) {  ___arguments.context.getComponentByUid(componentUid).setMapCenter(latitude, longitude) })('758c518cc1d5a7578694906bbe06525b', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lat')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lng')));
  (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken } })('df1e54627b31978da37ae1af33588d3b', undefined, undefined, ({ 'lat': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lat')),'lng': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lng')) }), undefined, undefined, 50000, undefined, undefined);
  await ( async function (componentUid, latitude, longitude) {  ___arguments.context.getComponentByUid(componentUid).setMapCenter(latitude, longitude) })('fe4790e688cf243b2ea9589668f8e4df', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lat')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lng')));
  (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken } })('38357517f99de0c9c829195e6592448e', undefined, undefined, ({ 'lat': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lat')),'lng': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentLocation')), 'lng')) }), undefined, undefined, 50000, undefined, undefined);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Notify/components/fe4790e688cf243b2ea9589668f8e4df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var Marker_Google, Marker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Marker = ({ 'description': 'Point','point': ({ 'lat': ___arguments['coordinates'][0] * 1,'lng': ___arguments['coordinates'].slice(-1)[0] * 1 }) });
  Marker_Google = ({ 'lat': ___arguments['coordinates'][0],'lng': ___arguments['coordinates'].slice(-1)[0] });
  addItemToList((getObjectProperty(___arguments.context.pageData, 'Markers')), Marker);
  ___arguments.context.pageData['Markers_Google_Delivery'] = Marker_Google;
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('ca92086d7b6a8ae9a91d3aab402c469e', [(getObjectProperty(___arguments.context.pageData, 'Markers_Google_Start')), (getObjectProperty(___arguments.context.pageData, 'Markers_Google_Load')), (getObjectProperty(___arguments.context.pageData, 'Markers_Google_Delivery'))]);
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('ca92086d7b6a8ae9a91d3aab402c469e', (___arguments['coordinates'][0] * 1), (___arguments['coordinates'].slice(-1)[0] * 1));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('ca92086d7b6a8ae9a91d3aab402c469e', 18);

  },
  /* handler:onClick */
  /* handler:onPan */
  ['onPan'](___arguments) {
    
  },
  /* handler:onPan */
  /* content */
}))

define('./pages/Notify/components/df1e54627b31978da37ae1af33588d3b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Marker, Load_Point;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Load_Point = (await Backendless.Request.get(`${Backendless.appPath}/services/MapAPIServices/getPlaceDetails`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'place_id': JSON.stringify((getObjectProperty(___arguments.value, 'place_id'))) }).send());
  ___arguments.context.pageData['Load_Point'] = (getObjectProperty(___arguments.value, 'place_id'));
  Marker = ({ 'description': 'Point','point': ({ 'lat': (getObjectProperty(Load_Point, 'lat')) * 1,'lng': (getObjectProperty(Load_Point, 'lng')) * 1 }) });
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('ca92086d7b6a8ae9a91d3aab402c469e', (getObjectProperty(Load_Point, 'lat')), (getObjectProperty(Load_Point, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('ca92086d7b6a8ae9a91d3aab402c469e', 20);
  addItemToList((getObjectProperty(___arguments.context.pageData, 'Markers')), Marker);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Notify/components/f161b3417d02b191cba855ed34d5619e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Marker, Start_Point;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Start_Point = (await Backendless.Request.get(`${Backendless.appPath}/services/MapAPIServices/getPlaceDetails`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'place_id': JSON.stringify((getObjectProperty(___arguments.value, 'place_id'))) }).send());
  ___arguments.context.pageData['Start_Point'] = (getObjectProperty(___arguments.value, 'place_id'));
  Marker = ({ 'description': 'Point','point': ({ 'lat': (getObjectProperty(Start_Point, 'lat')) * 1,'lng': (getObjectProperty(Start_Point, 'lng')) * 1 }) });
  await ( async function (componentUid, latitude, longitude) {  ___arguments.context.getComponentByUid(componentUid).setMapCenter(latitude, longitude) })('173e392552718827f0c44c63bb740345', (getObjectProperty(Start_Point, 'lat')), (getObjectProperty(Start_Point, 'lng')));
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('ca92086d7b6a8ae9a91d3aab402c469e', (getObjectProperty(Start_Point, 'lat')), (getObjectProperty(Start_Point, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('ca92086d7b6a8ae9a91d3aab402c469e', 19);
  await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setMapZoom(value) })('173e392552718827f0c44c63bb740345', 19);
  addItemToList((getObjectProperty(___arguments.context.pageData, 'Markers')), Marker);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Notify/components/38357517f99de0c9c829195e6592448e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var trip, item, Marker, Delivery_Point;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Delivery_Point = (await Backendless.Request.get(`${Backendless.appPath}/services/MapAPIServices/getPlaceDetails`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'place_id': JSON.stringify((getObjectProperty(___arguments.value, 'place_id'))) }).send());
  ___arguments.context.pageData['Delivery_Point'] = (getObjectProperty(___arguments.value, 'place_id'));
  console.log(Delivery_Point);
  Marker = ({ 'description': 'Point','point': ({ 'lat': (getObjectProperty(Delivery_Point, 'lat')) * 1,'lng': (getObjectProperty(Delivery_Point, 'lng')) * 1 }) });
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('ca92086d7b6a8ae9a91d3aab402c469e', (getObjectProperty(Delivery_Point, 'lat')), (getObjectProperty(Delivery_Point, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('ca92086d7b6a8ae9a91d3aab402c469e', 20);
  console.log(Marker);
  addItemToList((getObjectProperty(___arguments.context.pageData, 'Markers')), Marker);
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('ca92086d7b6a8ae9a91d3aab402c469e', (await BackendlessUI.Functions.Custom['fn_8ae41fdafafb2c62472ee008f644d7b7'](((getObjectProperty(trip, 'pickupLocation')) ? ({ 'lat': (getObjectProperty((getObjectProperty(trip, 'pickupLocation')), 'lat')),'lng': (getObjectProperty((getObjectProperty(trip, 'pickupLocation')), 'lng')) }) : null), ((getObjectProperty(trip, 'waypoints')) ? (await Promise.all((await asyncListFilter((getObjectProperty(trip, 'waypoints')), async (item) => {


   return ((getObjectProperty(item, 'lat')) && (getObjectProperty(item, 'lng')));
  })).map(async item => {; return ({ 'lat': (getObjectProperty(item, 'lat')),'lng': (getObjectProperty(item, 'lng')) });}))) : null), ((getObjectProperty(trip, 'dropoffLocation')) ? ({ 'lat': (getObjectProperty((getObjectProperty(trip, 'dropoffLocation')), 'lat')),'lng': (getObjectProperty((getObjectProperty(trip, 'dropoffLocation')), 'lng')) }) : null))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Notify/components/b214711ba9421d619a46ac2c190fdcfe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Route, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, traffic) { ___arguments.context.getComponentByUid(componentUid).traffic = traffic })('ca92086d7b6a8ae9a91d3aab402c469e', true);
  Route = (await Backendless.Request.post(`${Backendless.appPath}/services/MapAPIServices/directions`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'origin': ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Markers_Google_Start')), 'lat')),', ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Markers_Google_Start')), 'lng'))].join('')),'waypoints': [[(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Markers_Google_Load')), 'lat')),', ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Markers_Google_Load')), 'lng'))].join('')],'destination': ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Markers_Google_Delivery')), 'lat')),', ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Markers_Google_Delivery')), 'lng'))].join('')) }));
  ___arguments.context.pageData['Route'] = Route;
  ___arguments.context.pageData['Polygon'] = (await BackendlessUI.Functions.Custom['fn_8944e9a7ffd2170577737788990e9b43'](Route));
  console.log(getObjectProperty((getObjectProperty((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Polygon'))[0]), 'polygon')), 'boundary')), 'points'));
  await ( async function (componentUid, latitude, longitude) {  ___arguments.context.getComponentByUid(componentUid).setMapCenter(latitude, longitude) })('3eb509033739996f865194168dbc9b14', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Markers_Google_Delivery')), 'lat')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Markers_Google_Delivery')), 'lng')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Notify/components/ca92086d7b6a8ae9a91d3aab402c469e/bundle.js', [], () => ({
  /* content */
  /* handler:onZoomChange */
  async ['onZoomChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Start_View')) == true) {
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setMapZoom(value) })('173e392552718827f0c44c63bb740345', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('ca92086d7b6a8ae9a91d3aab402c469e')));
  } else if ((getObjectProperty(___arguments.context.pageData, 'Load_View')) == true) {
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setMapZoom(value) })('758c518cc1d5a7578694906bbe06525b', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('ca92086d7b6a8ae9a91d3aab402c469e')));
  } else if ((getObjectProperty(___arguments.context.pageData, 'Del_View')) == true) {
    await ( async function (componentUid, value) {  ___arguments.context.getComponentByUid(componentUid).setMapZoom(value) })('fe4790e688cf243b2ea9589668f8e4df', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('ca92086d7b6a8ae9a91d3aab402c469e')));
  }

  },
  /* handler:onZoomChange */
  /* handler:onPanChange */
  async ['onPanChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Start_View')) == true) {
    await ( async function (componentUid, latitude, longitude) {  ___arguments.context.getComponentByUid(componentUid).setMapCenter(latitude, longitude) })('173e392552718827f0c44c63bb740345', (getObjectProperty(___arguments.value, 'lat')), (getObjectProperty(___arguments.value, 'lng')));
  } else if ((getObjectProperty(___arguments.context.pageData, 'Load_View')) == true) {
    await ( async function (componentUid, latitude, longitude) {  ___arguments.context.getComponentByUid(componentUid).setMapCenter(latitude, longitude) })('758c518cc1d5a7578694906bbe06525b', (getObjectProperty(___arguments.value, 'lat')), (getObjectProperty(___arguments.value, 'lng')));
  } else if ((getObjectProperty(___arguments.context.pageData, 'Del_View')) == true) {
    await ( async function (componentUid, latitude, longitude) {  ___arguments.context.getComponentByUid(componentUid).setMapCenter(latitude, longitude) })('fe4790e688cf243b2ea9589668f8e4df', (getObjectProperty(___arguments.value, 'lat')), (getObjectProperty(___arguments.value, 'lng')));
  }

  },
  /* handler:onPanChange */
  /* content */
}))

define('./pages/Notify/components/173e392552718827f0c44c63bb740345/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var Marker_Google, Marker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Marker = ({ 'description': 'Point','point': ({ 'lat': ___arguments['coordinates'][0] * 1,'lng': ___arguments['coordinates'].slice(-1)[0] * 1 }) });
  Marker_Google = ({ 'lat': ___arguments['coordinates'][0],'lng': ___arguments['coordinates'].slice(-1)[0] });
  addItemToList((getObjectProperty(___arguments.context.pageData, 'Markers')), Marker);
  ___arguments.context.pageData['Markers_Google_Start'] = Marker_Google;
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('ca92086d7b6a8ae9a91d3aab402c469e', [(getObjectProperty(___arguments.context.pageData, 'Markers_Google_Start'))]);
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('ca92086d7b6a8ae9a91d3aab402c469e', (___arguments['coordinates'][0] * 1), (___arguments['coordinates'].slice(-1)[0] * 1));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('ca92086d7b6a8ae9a91d3aab402c469e', 18);

  },
  /* handler:onClick */
  /* handler:onPan */
  ['onPan'](___arguments) {
    
  },
  /* handler:onPan */
  /* content */
}))

define('./pages/Notify/components/758c518cc1d5a7578694906bbe06525b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var Marker_Google, Marker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Marker = ({ 'description': 'Point','point': ({ 'lat': ___arguments['coordinates'][0] * 1,'lng': ___arguments['coordinates'].slice(-1)[0] * 1 }) });
  Marker_Google = ({ 'lat': ___arguments['coordinates'][0],'lng': ___arguments['coordinates'].slice(-1)[0] });
  addItemToList((getObjectProperty(___arguments.context.pageData, 'Markers')), Marker);
  ___arguments.context.pageData['Markers_Google_Load'] = Marker_Google;
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('ca92086d7b6a8ae9a91d3aab402c469e', [(getObjectProperty(___arguments.context.pageData, 'Markers_Google_Start')), (getObjectProperty(___arguments.context.pageData, 'Markers_Google_Load'))]);
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('ca92086d7b6a8ae9a91d3aab402c469e', (___arguments['coordinates'][0] * 1), (___arguments['coordinates'].slice(-1)[0] * 1));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('ca92086d7b6a8ae9a91d3aab402c469e', 18);

  },
  /* handler:onClick */
  /* handler:onPan */
  ['onPan'](___arguments) {
    
  },
  /* handler:onPan */
  /* content */
}))

define('./pages/Notify/components/7b887cc660838b457b3196f18ec43da1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var error, Text2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Text2 = (getObjectProperty((getObjectProperty(((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Route')), 'routes'))[0]), 'legs'))[0]), 'distance')), 'text'));

  } catch (error) {

  } finally {
    if (error) {
      Text2 = ' ';
    }

  }

  return Text2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Notify/components/0811539a8c63acf4e3ef7b2ae0c92081/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Text2, error, j, Counter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    ___arguments.context.pageData['Steps_List'] = [];
    Counter = 0;
    var j_list = (getObjectProperty(((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Route')), 'routes'))[0]), 'legs'))[0]), 'steps'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      Counter = Counter + 1;
      addItemToList((getObjectProperty(___arguments.context.pageData, 'Steps_List')), (String('<li>') + String(getObjectProperty(j, 'html_instructions'))));
    }
    Text2 = ['<ol>',(getObjectProperty(___arguments.context.pageData, 'Steps_List')),'<ol>'].join('');

  } catch (error) {

  } finally {
    if (error) {
      Text2 = ' ';
    }

  }

  return Text2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Privacy_Policy/components/dc9de278d6aa3e240f77e6ccd5dd5885/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return '<p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:11.25pt;margin-left:0cm;line-height:48.0pt;font-size:15px;font-family:"Calibri","sans-serif";text-align:center;vertical-align:baseline;\'><strong><span style=\'font-size:54px;font-family:"Times New Roman","serif";color:black;\'>Privacy Policy</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Straight Forward Hauliers (Pty) Ltd&nbsp;</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>We can be reached via e-mail at support@fleetinform.com; admin@fleetinform.com or via phone (Monday to Friday) at (+27) 69&nbsp;845 1020.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>General</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>You can visit most areas of our website without providing personal information. But we do require valid and accurate information when you register to download the dash app. This information is required to not only provide access to our products and services, but also to prevent internet abuses using Fleet In Form resources. Straight Forward Hauliers (Pty) Ltd respects your need for online privacy and will protect any information that you may share with us.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Information We Collect</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>When you sign up for an account that requires registration or express interest in our services, we ask you for personal information such as your full name and email address. In addition, we collect information regarding the Internet Protocol address, browser type, browser language, referring URL, files accessed, errors generated, time zone , when required by the Dash app also your geo-location and operating system. If you are a user of the Dash app services, we will store and maintain your data, reports, account information and usage statistics, which are stored in your account in order to provide the services for which you are registered.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>How Information Is Used</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Your personal information such as full name, email address, phone number and company name are used to verify that you are who you say you are and you work for the company you say you work for. This information will also be used to keep you informed on new products/versions/updates/service packs, upcoming events and changes in this privacy policy. Any alternate email address, if given, will be used solely for the purpose of resetting password. We do not process or use the contents of your account information, test data or reports for any purpose other than to provide access to the services.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Your financial information will not be stored by us. We use Internet Protocol address, browser type, browser language, referring URL, files accessed, errors generated, time zone and operating system of visitors collected in our log files to analyze the trends, administer the websites, track visitor&rsquo;s movements and to improve our applications.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Unless requested to the contrary by the customer, we publish the names of our customers in the Customer List on our websites, press releases, advertisements, brochures and other promotional materials. From time to time we may ask customers to consent to providing case study information, which would be used for marketing purposes.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>We use cookies for easier access to our websites. Once you close your browser, the temporary cookies simply terminate, except for the permanent cookies created when you select the &lsquo;keep me signed-in&rsquo; option.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>We do not sell or rent your personal information with third parties for marketing purposes. Your personal information is never shared outside of Fleet In Form without your permission, except in cases where:</span></p> <ul style="list-style-type: square;margin-left:-4px;">     <li><span style=\'font-family:"Times New Roman","serif";\'>we have your consent to share such information;</span></li>     <li><span style=\'font-family:"Times New Roman","serif";\'>sharing is necessary to provide services which you have requested;</span></li>     <li><span style=\'font-family:"Times New Roman","serif";\'>we are required by law to do so in connection with litigation to prevent a crime, including personal safety, public safety or our site;</span></li>     <li><span style=\'font-family:"Times New Roman","serif";\'>there is a sale or merger with another entity or should Straight Forward Hauliers (Pty) Ltd file for&nbsp;bankruptcy&nbsp;or have its assets sold to another entity;</span></li>     <li><span style=\'font-family:"Times New Roman","serif";\'>there is a need to share non-personal information.</span></li> </ul> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Legal Basis for Processing Personal Data under the General Data Protection Regulation (GDPR)</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>If you are from the European Economic Area (EEA), Straight Forward Hauliers (Pty) Ltd legal basis for collecting and using the personal information described in this Privacy Policy depends on the Personal Data we collect and the specific context in which we collect it.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Straight Forward Hauliers (Pty) Ltd may process your Personal Data because:</span></p> <ul style="list-style-type: square;margin-left:-4px;">     <li><span style=\'font-family:"Times New Roman","serif";\'>We need to perform a contract with you</span></li>     <li><span style=\'font-family:"Times New Roman","serif";\'>You have given us permission to do so</span></li>     <li><span style=\'font-family:"Times New Roman","serif";\'>The processing is in our legitimate interests and it is not overridden by your rights</span></li>     <li><span style=\'font-family:"Times New Roman","serif";\'>To comply with the law</span></li> </ul> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Retention of Data</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Straight Forward Hauliers (Pty) Ltd trading as Fleet In Form will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes and enforce our legal agreements and policies.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Fleet In Form will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer periods.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Transfer of Data</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Your information, including Personal Data, may be transferred to &ndash; and maintained on &ndash; computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>If you are located outside the United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to the United States and process it there.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Straight Forward Hauliers (Pty) Ltd trading as Fleet In Form will take all the steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Disclosure of Data</span></strong></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:24.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:24px;font-family:"Times New Roman","serif";color:black;\'>Disclosure for Law Enforcement</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Under certain circumstances, Fleet In Form may be required to disclose your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:24.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:24px;font-family:"Times New Roman","serif";color:black;\'>Legal Requirements</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Fleet In Form may disclose your Personal Data in the good faith belief that such action is necessary to:</span></p> <ul style="list-style-type: square;margin-left:-4px;">     <li><span style=\'font-family:"Times New Roman","serif";\'>To comply with a legal obligation</span></li>     <li><span style=\'font-family:"Times New Roman","serif";\'>To protect and defend the rights or property of Straight Forward Hauliers (Pty) Ltd trading as Fleet In Form oration</span></li>     <li><span style=\'font-family:"Times New Roman","serif";\'>To prevent or investigate possible wrongdoing in connection with the Service</span></li>     <li><span style=\'font-family:"Times New Roman","serif";\'>To protect the personal safety of users of the Service or the public</span></li>     <li><span style=\'font-family:"Times New Roman","serif";\'>To protect against legal liability</span></li> </ul> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Security of Data</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Your Data Protection Rights under the General Data Protection Regulation (GDPR)</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>If you are a resident of the European Economic Area (EEA), you have certain data protection rights. Fleet In Form aims to take reasonable steps to allow you to correct, amend, delete or limit the use of your Personal Data.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>If you wish to be informed about what Personal Data we hold about you and if you want it to be removed from our systems, please contact us.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>In certain circumstances, you have the following data protection rights:</span></p> <ul style="list-style-type: square;margin-left:-4px;">     <li><strong><span style=\'font-family:"Times New Roman","serif";\'>The right to access, update or delete the information we have on you.</span></strong><span style=\'font-family:"Times New Roman","serif";\'>&nbsp;Whenever made possible, you can access, update or request deletion of your Personal Data directly within your account settings section. If you are unable to perform these actions yourself, please contact us to assist you.</span></li>     <li><strong><span style=\'font-family:"Times New Roman","serif";\'>The right of rectification.</span></strong><span style=\'font-family:"Times New Roman","serif";font-size:13.5pt;color:black;\'>&nbsp;You have the right to have your information rectified if that information is inaccurate or incomplete.</span></li>     <li><strong><span style=\'font-family:"Times New Roman","serif";\'>The right to object.</span></strong><span style=\'font-family:"Times New Roman","serif";\'>&nbsp;You have the right to object to our processing of your Personal Data.</span></li>     <li><strong><span style=\'font-family:"Times New Roman","serif";\'>The right of restriction.</span></strong><span style=\'font-family:"Times New Roman","serif";font-size:13.5pt;color:black;\'>&nbsp;You have the right to request that we restrict the processing of your personal information.</span></li>     <li><strong><span style=\'font-family:"Times New Roman","serif";\'>The right to data portability.</span></strong><span style=\'font-family:"Times New Roman","serif";font-size:13.5pt;color:black;\'>&nbsp;You have the right to be provided with a copy of the information we have on you in a structured, machine-readable and commonly used format.</span></li>     <li><strong><span style=\'font-family:"Times New Roman","serif";\'>The right to withdraw consent.</span></strong><span style=\'font-family:"Times New Roman","serif";font-size:13.5pt;color:black;\'>&nbsp;You also have the right to withdraw your consent at any time where Straight Forward Hauliers (Pty) Ltd trading as Fleet In Form oration relied on your consent to process your personal information.</span></li> </ul> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>&nbsp;</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Please note that we may ask you to verify your identity before responding to such requests.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>You have the right to complain to a Data Protection Authority about our collection and use of your Personal Data. For more information, please contact your local data protection authority in the European Economic Area (EEA).</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>&nbsp;</span></strong></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Service Providers</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>We may employ third party companies and individuals to facilitate our Service (&ldquo;Service Providers&rdquo;), provide the Service on our behalf, perform Service-related services or assist us in analyzing how our Service is used.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:24.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:24px;font-family:"Times New Roman","serif";color:black;\'>Analytics</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>We may use third-party Service Providers to monitor and analyze the use of our Service.</span></p> <div style=\'margin-top:0cm;margin-right:0cm;margin-bottom:10.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri","sans-serif";\'>     <ul style="margin-bottom:0cm;list-style-type: square;margin-left:-4px;">         <li style=\'margin-top:0cm;margin-right:0cm;margin-bottom:10.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri","sans-serif";\'><strong><span style=\'font-family:"Times New Roman","serif";\'>Google Analytics&nbsp;</span></strong><span style=\'font-family:"Times New Roman","serif";font-size:11.5pt;color:black;\'>Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualize and personalize the ads of its own advertising network. You can opt-out of having made your activity on the Service available to Google Analytics by installing the Google Analytics opt-out browser add-on. The add-on prevents the Google Analytics JavaScript (ga.js, analytics.js and dc.js) from sharing information with Google Analytics about visits activity. For more information on the privacy practices of Google, please visit the Google Privacy &amp; Terms web page: <a href="https://policies.google.com/privacy?hl=en"><span style="color:windowtext;">https://policies.google.com/privacy?hl=en</span></a></span></li>     </ul> </div> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:24.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:24px;font-family:"Times New Roman","serif";color:black;\'>Behavioral Remarketing</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Fleet In Form uses remarketing services to advertise on third party websites to you after you visited our Service. We and our third-party vendors use cookies to inform, optimize and serve ads based on your past visits to our Service.</span></p> <div style=\'margin-top:0cm;margin-right:0cm;margin-bottom:10.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri","sans-serif";\'>     <ul style="margin-bottom:0cm;list-style-type: square;margin-left:-4px;">         <li style=\'margin-top:0cm;margin-right:0cm;margin-bottom:10.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri","sans-serif";\'><strong><span style=\'font-family:"Times New Roman","serif";\'>Google AdWords&nbsp;</span></strong><span style=\'font-family:"Times New Roman","serif";\'>Google AdWords remarketing service is provided by Google Inc. You can opt-out of Google Analytics for Display Advertising and customize the Google Display Network ads by visiting the Google Ads Settings page: <a href="https://www.google.com/settings/ads"><span style="color:windowtext;">http://www.google.com/settings/ads</span></a>Google also recommends installing the Google Analytics Opt-out Browser Add-on &ndash; <a href="https://tools.google.com/dlpage/gaoptout"><span style="color:windowtext;">https://tools.google.com/dlpage/gaoptout</span></a> &ndash; for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics. For more information on the privacy practices of Google, please visit the Google Privacy &amp; Terms web page: <a href="https://policies.google.com/privacy?hl=en"><span style="color:windowtext;">https://policies.google.com/privacy?hl=en</span></a></span></li>     </ul> </div> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Your Choice in Information Use</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>You will be required to register for our services by providing personal information. You can decline to submit personal information to any of our services, in which case we will not be able to provide those services to you. While using our services, you are not allowed to opt out from receiving information on versions/updates/service packs. We will obtain your prior consent for use of your personal information in a manner different than the purpose for which it was collected or the purposes described in this privacy policy. In such cases we will offer you an effective way to opt out of the use of your personal information for those other purposes.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Location</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Fleet In Forms Dash app collects location data to enable Fuel Location Submission, Load Location Directions and Submission, &amp; Final the Driver distress SOS System even when the app is closed or not in use.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Links From Our Website</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Some pages of our websites contain external links. You are advised to verify the privacy practices of such other websites. We are not responsible for the manner of use or misuse of information made available by you at such other websites. We encourage you not to provide personal information, without assuring yourselves of the privacy policy of other websites.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>How Secure Is Your Information</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>We adopt appropriate data collection, storage and processing practices and security measures, as well as physical security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored in your account. Access to your name and email address is restricted to our employees, contractors, business partners, and affiliates who need to know such information in connection with our products and services and are bound by strict confidentiality obligations.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Enforcement of Privacy Policy</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>We make every effort including periodic reviews to ensure that personal information provided by you is used in conformity with this privacy policy. If you have any concerns regarding our adherence to this policy or the manner in which personal information is used on our websites, kindly contact Fleet In Form Support Services at support@fleetinform.com. We will contact you to address your concerns and we will also co-operate with regulatory authorities in this regard.</span></p> <p style=\'margin-top:22.5pt;margin-right:0cm;margin-bottom:7.5pt;margin-left:0cm;line-height:36.0pt;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:46px;font-family:"Times New Roman","serif";color:black;\'>Notification of Changes</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>Any changes to our privacy policy will be posted on our websites in order to keep you informed of any changes in the nature of the information collected and manner of collection, use and sharing of information. If at any point we decide to use personally identifiable information in a manner different from that stated at the time it was collected, we will notify you by email and provide you with the ability to opt out of these new uses. If you are concerned about how your information is used, you should check back at <a href="https://www.fleetinform.com/?page=Privacy_Policy">https://www.fleetinform.com/?page=Privacy_Policy</a> periodically.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>END OF PRIVACY POLICY</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:15.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:black;\'>last updated on&nbsp;January 10, 2023</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:10.0pt;margin-left:0cm;line-height:12.95pt;font-size:15px;font-family:"Calibri","sans-serif";\'><span style=\'font-size:15px;font-family:"Times New Roman","serif";color:black;\'>&nbsp;</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:10.0pt;margin-left:0cm;line-height:115%;font-size:15px;font-family:"Calibri","sans-serif";\'><span style=\'font-family:"Times New Roman","serif";\'>&nbsp;</span></p>'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Privacy_Policy/components/948fbefe9f9f2751226cfb9cc5affe49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.fleetinform.co.za/', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SYSTEM_GLOBAL_NOTIFICATIONS/components/b98e4a0445339c6f6f41921a76f99f97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Request.post(`${Backendless.appPath}/services/Twilio_WhatsApp/Send_WhatsApp`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'To': '+27827775894','Body': (['Fleet Notification:','\n\n','Type: ',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('5fbb77e63946f9fdc0c5b70bae9afddd')),'\n','Road: ',(getObjectProperty(___arguments.context.pageData, 'Road')),'\n','Near: ',(getObjectProperty(___arguments.context.pageData, 'Near')),'\n','Direction: ',(getObjectProperty(___arguments.context.pageData, 'Direction')),'\n\n','Please click the link below for exact location.','\n\n',(getObjectProperty(___arguments.context.pageData, 'EMERGENCY_GOOGLE_MAPS_URL')),'\n\n','',(getObjectProperty(___arguments.context.pageData, 'Message')),'\n\n','Kind Regards,','\n','The Fleet In Form Team'].join('')) });
  await Backendless.Request.post(`${Backendless.appPath}/services/Twilio_WhatsApp/Send_WhatsApp`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'To': '+27764810153','Body': (['Fleet Notification:','\n\n','Type: ',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('5fbb77e63946f9fdc0c5b70bae9afddd')),'\n','Road: ',(getObjectProperty(___arguments.context.pageData, 'Road')),'\n','Near: ',(getObjectProperty(___arguments.context.pageData, 'Near')),'\n','Direction: ',(getObjectProperty(___arguments.context.pageData, 'Direction')),'\n\n','Please click the link below for exact location.','\n\n',(getObjectProperty(___arguments.context.pageData, 'EMERGENCY_GOOGLE_MAPS_URL')),'\n\n','Approach with caution.','\n\n','Kind Regards,','\n','The Fleet In Form Team'].join('')) });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SYSTEM_GLOBAL_NOTIFICATIONS/components/290a146fd80e7aa72412a995a7968a01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('56f562ca43612e6d94a7e3633c8a58fe')));
  Location = (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/GeoCode`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'currentPosition': JSON.stringify(([(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('56f562ca43612e6d94a7e3633c8a58fe')), 'lat')),',',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('56f562ca43612e6d94a7e3633c8a58fe')), 'lng'))].join(''))) }).send());
  ___arguments.context.pageData['Location'] = (getObjectProperty(((getObjectProperty(Location, 'results'))[0]), 'formatted_address'));
  ___arguments.context.pageData['EMERGENCY_GOOGLE_MAPS_URL'] = (String('https://maps.google.com/?q=') + String([(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('56f562ca43612e6d94a7e3633c8a58fe')), 'lat')),',',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('56f562ca43612e6d94a7e3633c8a58fe')), 'lng'))].join('')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SYSTEM_GLOBAL_NOTIFICATIONS/components/f51c93b4d87584252d4b629e2866b504/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Location'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/SYSTEM_GLOBAL_NOTIFICATIONS/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('56f562ca43612e6d94a7e3633c8a58fe', -26.18599340662474, 28.04149345200147);
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('56f562ca43612e6d94a7e3633c8a58fe', 5);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Salary_Overview/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Salary, item, Start_Date, RGBA;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['RGBA'] = 1;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c55832ef99386143591bbb014b56e9ec', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('223497f79e8f94bac1476e487b09d448', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa1c7da621c326218e7b9444142b5b7d', false);
  for (var count = 0; count < 100; count++) {
    RGBA = (getObjectProperty(___arguments.context.pageData, 'RGBA')) - 0.01;
    ___arguments.context.pageData['RGBA'] = RGBA;
    await new Promise(r => setTimeout(r, 1 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6'))['backgroundColor'] = (['rgba(0, 0, 0, ',RGBA,')'].join(''));
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', false);
}


  console.log(___arguments.context.appData);
  console.log(___arguments.context.pageData);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);
  ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Slider'] = 0;
  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  ___arguments.context.pageData['Company'] = ((await Backendless.Data.of('Customers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10)))[0]);
  ___arguments.context.pageData['Company_Logo'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Company_Logo'));
  ___arguments.context.pageData['Company_Name'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Company'));
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  if (!(await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  Start_Date = (new Date());
  Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
  Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
  Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
  Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
  Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
  ___arguments.context.pageData['Start_Date'] = Start_Date;
  ___arguments.context.pageData['End_Date'] = (new Date());
  Salary = (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employer.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`objectId`]: item,[`Horse_Registration`]: (getObjectProperty(item, 'Company_ID')),[`Horse_ID`]: (getObjectProperty(item, 'Name')),[`License_Notice_FI`]: (getObjectProperty(item, 'Call_Sign')),[`License_PDP_FI`]: undefined,[`Trailer_3_FI`]: undefined,[`Driver_1`]: (getObjectProperty(item, 'ID_Number')),[`Service_Notice`]: (getObjectProperty(item, 'Cellphone_Number')),[`Current_Mileage`]: (getObjectProperty(item, 'Currently_Aboard')),[`Distance_Traveled`]: (getObjectProperty(item, 'Bargaining_Council_And_Union_Levies')),[`Mileage_Target_Completion`]: (getObjectProperty(item, 'Employee_Position')),[`Ideal_KM/L`]: (getObjectProperty(item, 'Medical_Aid')),[`Actual_KM/L`]: (getObjectProperty(item, 'Provident_And_Pension_Fund')),[`Status`]: (getObjectProperty(item, 'Tax_Refrence_Number')),[`Fuel_Cost`]: (getObjectProperty(item, 'Basic_Salary')),[`SO_Value`]: (addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Type = \'Sleep Out\''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Price_Per_Litre`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Fuel_Cost_Per_Km`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/loss_Driving_Style`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Total_Tonnage`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Litres_Filled`]: (getObjectProperty(item, 'Basic_Salary')) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (getObjectProperty(item, 'Medical_Aid')) + (getObjectProperty(item, 'Provident_And_Pension_Fund')) + (getObjectProperty(item, 'Bargaining_Council_And_Union_Levies')) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', Salary);
  await do_something();

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Salary_Overview/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/a326c6adc603ee1603ce948afd16bbdf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var Start_Date;


  Start_Date = (new Date(___arguments.value));
  ___arguments.context.pageData['Start_Date'] = Start_Date;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Start_Date'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/8093a66253eb9b76d76778f92314ad6c/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'End_Date'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    var End_Date;


  End_Date = (new Date(___arguments.value));
  ___arguments.context.pageData['End_Date'] = End_Date;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Salary_Overview/components/0e0200c11cbcde7cbdf70a0e7988a0d4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  onStyleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Service_Notice')) == 'Service Due') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0e0200c11cbcde7cbdf70a0e7988a0d4'))['color'] = 'yellow';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/aadffa177e03469667c81325f5b42c65/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  onStyleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Status')) == 'Consumption Error') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aadffa177e03469667c81325f5b42c65'))['color'] = 'Red';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/7f9680277fe89cfde26b11be22d7b3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('206c1d94f6911f11aabd1d5632391aba', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/9bf3c6a806384ffef5c401cba2012dae/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Driver_Fuel')) == 'Viewed') {
    Clause = ['Driver = \'',(getObjectProperty(___arguments.context.pageData, 'Selected_Driver')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'ownerId')),'\''].join('');
  } else {
    Clause = ['created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'ownerId')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue && (getObjectProperty(___arguments.context.pageData, 'Selected_Driver')) != null) {
    ___arguments.context.pageData['Driver_Fuel'] = 'Viewed';
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/Salary_Overview/components/b612d3b3061d799155f81a9286caaa69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('206c1d94f6911f11aabd1d5632391aba', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/cd59d51714ea0c8c11d3a6513c131c19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['WS_Hamburger_View'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('206c1d94f6911f11aabd1d5632391aba', false);
  ___arguments.context.pageData['Fuel_Data_Whereclause'] = (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND created >= \'',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),'\' AND created <= \'',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),'\''].join(''));
  ___arguments.context.pageData['Fuel_Data_Title'] = ' Fleet';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/e33968170893649d4367ac61f15e5408/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Images_View'] = true;
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Image_1'] = (getObjectProperty(___arguments.selectedRecord, 'Profile_Photo'));
  ___arguments.context.pageData['Image_2'] = (getObjectProperty(___arguments.selectedRecord, 'ID_Attachment'));
  ___arguments.context.pageData['Image_3'] = (getObjectProperty(___arguments.selectedRecord, 'License_Attachment'));
  ___arguments.context.pageData['DataImageText'] = (String(getObjectProperty(___arguments.selectedRecord, 'Name')) + String('\'s Images'));

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Employer.ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/ced40fcb6eaca79e0d3f45b91eae6dec/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Clause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Driver_Loads')) == 'Viewed') {
    Clause = ['Driver = \'',(getObjectProperty(___arguments.context.pageData, 'Selected_Driver')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' ',' AND ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'ownerId')),'\''].join('');
  } else {
    Clause = ['created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' ',' AND ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'ownerId')),'\''].join('');
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.newValue && (getObjectProperty(___arguments.context.pageData, 'Selected_Driver')) != null) {
    ___arguments.context.pageData['Driver_Loads'] = 'Viewed';
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/Salary_Overview/components/c11adb9f109d6ffa0e951148f41ad97a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('206c1d94f6911f11aabd1d5632391aba', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/0a44b4c1e9cc4e8486e1847d8d0cadf9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a44b4c1e9cc4e8486e1847d8d0cadf9', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64abcaf5ca5e80f2a7f4740b69d9c91c', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6ac9db8ea16e94f2f8edec3e1a5ecae', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/64abcaf5ca5e80f2a7f4740b69d9c91c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6ac9db8ea16e94f2f8edec3e1a5ecae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64abcaf5ca5e80f2a7f4740b69d9c91c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a44b4c1e9cc4e8486e1847d8d0cadf9', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/84e399febbb69c6906ae14f2c7c899ab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), 'Driver_Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/56a25647cafe65f486633cb8f338c2bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '3Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/83d3c61a37097477378eec49bf9d1e25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '4Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/07c2624860b79354fab219fa499b6d86/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '5Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/34f478020a4af087eb9943b716f9c834/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '6Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/6471c6fa4c29c02f8b820496dfb980a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '7Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/090849a9211b46a9558969e764f374a8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '8Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/6f2295db02fe4d353ffed4f8eab182d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '9Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/acf1d60d39370e881c2c2f3b9d848899/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '16Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/60f8c62d363af106cf134b052cfd3ccf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '11Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/d9395a792f543e413ce89701e4cd9812/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '12Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/f2932fb984a63989fe3fe2428f36664f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '13Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/b53852c6a7463b394fd5a0e7c0b36fc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '14Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/c71e513692df5bc82a142eda2ca42795/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '15Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/8096fb55ff9c027bc50ec5ae514327e5/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.dataModel['Driver_Check'] = false;
  ___arguments.context.dataModel['2Check'] = true;
  ___arguments.context.dataModel['3Check'] = false;
  ___arguments.context.dataModel['4Check'] = true;
  ___arguments.context.dataModel['5Check'] = false;
  ___arguments.context.dataModel['7Check'] = false;
  ___arguments.context.dataModel['8Check'] = false;
  ___arguments.context.dataModel['9Check'] = false;
  ___arguments.context.dataModel['10Check'] = true;
  ___arguments.context.dataModel['11Check'] = true;
  ___arguments.context.dataModel['12Check'] = true;
  ___arguments.context.dataModel['13Check'] = true;
  ___arguments.context.dataModel['14Check'] = true;
  ___arguments.context.dataModel['15Check'] = true;
  ___arguments.context.dataModel['16Check'] = true;

  },
  /* handler:onMounted */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/61348c3229e7b3dd8bd8d9aca2e7a152/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Driver_Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['2Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['3Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['4Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['5Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['7Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['8Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['9Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['10Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['11Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['12Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['13Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['14Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['15Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['16Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['22Check'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/5d06b9c2de2c2d3611890ad594edbeca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['Driver_Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['2Check'] = true;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['3Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['4Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['5Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['7Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['8Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['9Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['10Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['11Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['12Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['13Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['14Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['15Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['16Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['17Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['18Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['19Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['20Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['21Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5')['22Check'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/cf2d5a1bc5dfeba8a9db31784a714f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Images_View'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/41f553479872cab9abf931ef3b0b2e47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Images_View'] = false;
  ___arguments.context.pageData['Image_1'] = null;
  ___arguments.context.pageData['Image_2'] = null;
  ___arguments.context.pageData['Image_3'] = null;
  ___arguments.context.pageData['Image_3'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/daa89079a11340a16fc711568858863d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Image_Text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Image_1')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_2')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_3')) == null && (getObjectProperty(___arguments.context.pageData, 'Image_4')) == null) {
    Image_Text = 'No Images Available';
  } else {
    Image_Text = (getObjectProperty(___arguments.context.pageData, 'DataImageText'));
  }

  return Image_Text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/e23b96acd1879198dc2f19e4e90eb0e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/b7649fc62cc8a1432e22311afd238672/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/2fae753c674e30dff7e7456114e29c61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/cd7e08f865dbe001d7579334b4752399/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.pageData, 'Image_1')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/2293200484b94fe91df355938d366f0a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Salary, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', true);
  Salary = (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employer.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`objectId`]: item,[`Horse_Registration`]: (getObjectProperty(item, 'Company_ID')),[`Horse_ID`]: (getObjectProperty(item, 'Name')),[`License_Notice_FI`]: (getObjectProperty(item, 'Call_Sign')),[`License_PDP_FI`]: undefined,[`Trailer_3_FI`]: undefined,[`Driver_1`]: (getObjectProperty(item, 'ID_Number')),[`Service_Notice`]: (getObjectProperty(item, 'Cellphone_Number')),[`Current_Mileage`]: (getObjectProperty(item, 'Currently_Aboard')),[`Distance_Traveled`]: (getObjectProperty(item, 'Bargaining_Council_And_Union_Levies')),[`Mileage_Target_Completion`]: (getObjectProperty(item, 'Employee_Position')),[`Ideal_KM/L`]: (getObjectProperty(item, 'Medical_Aid')),[`Actual_KM/L`]: (getObjectProperty(item, 'Provident_And_Pension_Fund')),[`Status`]: (getObjectProperty(item, 'Tax_Refrence_Number')),[`Fuel_Cost`]: (getObjectProperty(item, 'Basic_Salary')),[`SO_Value`]: (addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Type = \'Sleep Out\''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Price_Per_Litre`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Fuel_Cost_Per_Km`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/loss_Driving_Style`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Total_Tonnage`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Litres_Filled`]: (getObjectProperty(item, 'Basic_Salary')) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (getObjectProperty(item, 'Medical_Aid')) + (getObjectProperty(item, 'Provident_And_Pension_Fund')) + (getObjectProperty(item, 'Bargaining_Council_And_Union_Levies')) });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', Salary);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/ec11a4cf1741c56fb1dbeb4378d2d577/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Ideal_KM/L')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/f861780d9d1af912b4020aef7e7bdce9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Price_Per_Litre')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/a9ff27240a081e57eeac944d8c37a83f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Fuel_Cost_Per_Km')))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Selected_Driver'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'License_Notice_FI'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/0dab29db9916ae196e1aa35627669346/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Gain/loss_Driving_Style')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/f07c258c685e882135823fac66eb50ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Total_Tonnage'))))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Selected_Driver'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'License_Notice_FI'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/28d3d17533c271b33778415f030448aa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Litres_Filled'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/4d49a09a5761ea0b09fbd0c721873fd1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Actual_KM/L')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/27bc8b1642aef057a32c0b55204abd98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Fuel_Cost'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/aaef52abada4847a42bf68ef573f6c2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'Distance_Traveled')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/a822f37e11852bbe0cddd7986fac5b63/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Distance_Traveled'));}))).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/f48d3287b374e83c11bdb34a13137fd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Ideal_KM/L'));}))).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/e05594b3e28a283d95a761edf5bd6a76/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Actual_KM/L'));}))).reduce(function(x, y) {return x + y;})))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/e23210ebc16ab388de612189ff682c55/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((addItemToList((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return ((typeof (getObjectProperty(item, 'Fuel_Cost')) === 'number' && !isNaN((getObjectProperty(item, 'Fuel_Cost')))) ? (getObjectProperty(item, 'Fuel_Cost')) : 0);}))), 0)).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/57151331490a437bed83137d1868e273/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((addItemToList((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Price_Per_Litre'));}))), 0)).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/56bbd7bc3544478f41037b147479895d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((addItemToList((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Fuel_Cost_Per_Km'));}))), 0)).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/990a776c365a831f09983fef1703bcb2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((addItemToList((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Gain/loss_Driving_Style'));}))), 0)).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/bed938ec722ae3ad3efce387e5942145/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((addItemToList((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Total_Tonnage'));}))), 0)).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/900cc4cb9eea7c747714b76ad10c9fec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((addItemToList((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return (getObjectProperty(item, 'Litres_Filled'));}))), 0)).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/206c1d94f6911f11aabd1d5632391aba/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Employer.ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/b14ed827f1c5effcf7647a8de39ab026/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e33968170893649d4367ac61f15e5408', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bf3c6a806384ffef5c401cba2012dae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ced40fcb6eaca79e0d3f45b91eae6dec', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('206c1d94f6911f11aabd1d5632391aba', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/bd113ab1869fc6e9113794617a1877f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4edbeffd3e146d81ad8a4887ba78d58a', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/636dde24aaa35af15a0bc82ab2de6c76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Salary, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log(getObjectProperty(___arguments.context.pageData, 'Start_Date'));
  console.log(getObjectProperty(___arguments.context.pageData, 'End_Date'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', null);
  Salary = (await Promise.all((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Employer.objectId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`objectId`]: item,[`Horse_Registration`]: (getObjectProperty(item, 'Company_ID')),[`Horse_ID`]: (getObjectProperty(item, 'Name')),[`License_Notice_FI`]: (getObjectProperty(item, 'Call_Sign')),[`License_PDP_FI`]: undefined,[`Trailer_3_FI`]: undefined,[`Driver_1`]: (getObjectProperty(item, 'ID_Number')),[`Service_Notice`]: (getObjectProperty(item, 'Cellphone_Number')),[`Current_Mileage`]: (getObjectProperty(item, 'Currently_Aboard')),[`Distance_Traveled`]: (getObjectProperty(item, 'Bargaining_Council_And_Union_Levies')),[`Mileage_Target_Completion`]: (getObjectProperty(item, 'Employee_Position')),[`Ideal_KM/L`]: (getObjectProperty(item, 'Medical_Aid')),[`Actual_KM/L`]: (getObjectProperty(item, 'Provident_And_Pension_Fund')),[`Status`]: (getObjectProperty(item, 'Tax_Refrence_Number')),[`Fuel_Cost`]: (getObjectProperty(item, 'Basic_Salary')),[`SO_Value`]: (addItemToList((await Promise.all((await Backendless.Data.of('Other').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Type = \'Sleep Out\''].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'cost'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Price_Per_Litre`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Fuel_Cost_Per_Km`]: (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Gain/loss_Driving_Style`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Total_Tonnage`]: (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}),[`Litres_Filled`]: (getObjectProperty(item, 'Basic_Salary')) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Km_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf())].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'GD_Payment'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created> ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Contractor_Tonnage_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (addItemToList((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver = \'',(getObjectProperty(item, 'Call_Sign')),'\'',' AND created > ',((getObjectProperty(___arguments.context.pageData, 'Start_Date')).valueOf()),' AND created < ',((getObjectProperty(___arguments.context.pageData, 'End_Date')).valueOf()),' AND Completion_Status = \'1\' '].join(''))).setPageSize(100))).map(async item => {; return (getObjectProperty(item, 'Tonnage_Target_Pay'));}))), 0)).reduce(function(x, y) {return x + y;}) + (getObjectProperty(item, 'Medical_Aid')) + (getObjectProperty(item, 'Provident_And_Pension_Fund')) + (getObjectProperty(item, 'Bargaining_Council_And_Union_Levies')) });})));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6dae1be43702a69469ec25ac82074e8e', Salary);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/aeb713837487ee2f64f15a4e476a0f3a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == false) {
    ___arguments.context.pageData['WS_Hamburger_View'] = true;
  } else {
    ___arguments.context.pageData['WS_Hamburger_View'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/2af4968a3c7b354f09df0a995a425226/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/9406fe2f73d564b8e528ac72d7d3263b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/41a897c7c215b7a66772ecd2bc5177ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/c55832ef99386143591bbb014b56e9ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/791462defbcfc3a3c13eec6eb8ccb1f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	var print_div = document.getElementById("Data_Panel");
  	var print_area = window.open('Test');
  	print_area.document.write(print_div.innerHTML);
  	print_area.document.close();
  	print_area.focus();
  	print_area.print();
  	print_area.close();
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/81261c456bfff72600117f12981ff09a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Salary_Overview/components/be46668c83db77a50ced82b865b465b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84312f32b8c74eb7182f94d63214e05f'), 'SO_Value'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/93568aecde2a60e333eeae4c7ea6bb38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad'](((addItemToList((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6dae1be43702a69469ec25ac82074e8e')).map(async item => {; return ((typeof (getObjectProperty(item, 'SO_Value')) === 'number' && !isNaN((getObjectProperty(item, 'SO_Value')))) ? (getObjectProperty(item, 'SO_Value')) : 0);}))), 0)).reduce(function(x, y) {return x + y;}))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Salary_Overview/components/8727cad809225084b7129d5399b6300b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096fb55ff9c027bc50ec5ae514327e5'), '22Check'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Swap_Trailer/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Active_Truck, Ideal_FC, item, Last_3_Lt, Last_3_MD, Last_Mileage_Of_This_Truck, LiveUser, Trailer_1, Trailer_1_Detail, Trailer_2, Trailer_2_Detail, Trailer_3, Trailer_3_Detail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  ___arguments.context.pageData['location'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  ___arguments.context.pageData['UserDriver'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName'));
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
  Active_Truck = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver_1.ownerId = \'',LiveUser,'\''].join(''))).setPageSize(100)))[0];
  ___arguments.context.pageData['Active_Truck_Final'] = Active_Truck;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', true);
  ___arguments.context.pageData['Got_Mileage'] = (getObjectProperty(Active_Truck, 'objectId'));
  Last_Mileage_Of_This_Truck = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('mileage').setPageSize(100))).map(async item => {; return ({ 'Last Mileage': (getObjectProperty(item, 'mileage')) });})));
  ___arguments.context.pageData['Final_Last_Mileage'] = (Last_Mileage_Of_This_Truck.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_Mileage'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_Mileage')), 'Last Mileage'))));
  Ideal_FC = (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Ideal_Fuel_Consumption': (getObjectProperty(item, 'Ideal_Fuel_Consumption')) });})));
  ___arguments.context.pageData['Truck_Ideal_Fuel_Consumption'] = (getObjectProperty((Ideal_FC.slice(-1)[0]), 'Ideal_Fuel_Consumption'));
  ___arguments.context.pageData['New_Reg'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  ___arguments.context.pageData['Final_New_Reg'] = (getObjectProperty(___arguments.context.pageData, 'New_Reg'));
  Last_3_MD = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Mileage Differential': (getObjectProperty(item, 'Mileage_Differential')) });})));
  ___arguments.context.pageData['Final_Last_MD_1'] = (Last_3_MD.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_MD_1'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_1')), 'Mileage Differential'));
  ___arguments.context.pageData['Final_Last_MD_2'] = (Last_3_MD.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_MD_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_2')), 'Mileage Differential'))));
  ___arguments.context.pageData['Final_Last_MD_3'] = (Last_3_MD.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_MD_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_3')), 'Mileage Differential'))));
  Last_3_Lt = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Last Litres ': (getObjectProperty(item, 'litres')) });})));
  ___arguments.context.pageData['Final_Last_LT_1'] = (Last_3_Lt.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_LT_1'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_1')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_2'] = (Last_3_Lt.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_LT_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_2')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_3'] = (Last_3_Lt.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_LT_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_3')), 'Last Litres '))));
  ___arguments.context.pageData['Last3_FC'] = (Math.round((((getObjectProperty(___arguments.context.pageData, 'Reflected_MD_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_1'))) / ((getObjectProperty(___arguments.context.pageData, 'Reflected_LT_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_1')))) * 1000) / 1000);
  await new Promise(r => setTimeout(r, 500 || 0));
  try {
    if ((getObjectProperty(Active_Truck, 'Trailer_1_Confirm')) == 'Hitched') {
      Trailer_1_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));
      Trailer_1 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',Trailer_1_Detail,'\''].join(''))).setPageSize(10)))[0];
      ___arguments.context.pageData['T1_CLDW'] = (9000 * (getObjectProperty(Trailer_1, 'Axle_Number_Double_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) > 24000) {
        ___arguments.context.pageData['T1_CLDW'] = 24000;
      }
      ___arguments.context.pageData['T1_CLSW'] = (8000 * (getObjectProperty(Trailer_1, 'Axle_Number_Single_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) > 24000) {
        ___arguments.context.pageData['T1_CLSW'] = 24000;
      }
      ___arguments.context.pageData['T1_Tare'] = (getObjectProperty(Trailer_1, 'Tare'));
      ___arguments.context.pageData['T1_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T1_Tare')));
      ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;
    } else {
      Trailer_1_Detail = 'None';
      ___arguments.context.pageData['T1_CLDW'] = 0;
      ___arguments.context.pageData['T1_CLSW'] = 0;
      ___arguments.context.pageData['T1_Tare'] = 0;
      ___arguments.context.pageData['T1_Payload'] = 0;
      ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;
    }

  } catch (error) {

  }
  try {
    if ((getObjectProperty(Active_Truck, 'Trailer_2_Confirm')) == 'Hitched') {
      Trailer_2_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));
      Trailer_2 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',Trailer_2_Detail,'\''].join(''))).setPageSize(10)))[0];
      ___arguments.context.pageData['T2_CLDW'] = (9000 * (getObjectProperty(Trailer_2, 'Axle_Number_Double_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) > 24000) {
        ___arguments.context.pageData['T2_CLDW'] = 24000;
      }
      ___arguments.context.pageData['T2_CLSW'] = (8000 * (getObjectProperty(Trailer_2, 'Axle_Number_Single_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) > 24000) {
        ___arguments.context.pageData['T2_CLSW'] = 24000;
      }
      ___arguments.context.pageData['T2_Tare'] = (getObjectProperty(Trailer_2, 'Tare'));
      ___arguments.context.pageData['T2_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T2_Tare')));
      ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;
    } else {
      Trailer_2_Detail = 'None';
      ___arguments.context.pageData['T2_CLDW'] = 0;
      ___arguments.context.pageData['T2_CLSW'] = 0;
      ___arguments.context.pageData['T2_Tare'] = 0;
      ___arguments.context.pageData['T2_Payload'] = 0;
      ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;
    }

  } catch (error) {

  }
  try {
    if ((getObjectProperty(Active_Truck, 'Trailer_3_Confirm')) == 'Hitched') {
      Trailer_3_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));
      Trailer_3 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',Trailer_3_Detail,'\''].join(''))).setPageSize(10)))[0];
      ___arguments.context.pageData['T3_CLDW'] = (9000 * (getObjectProperty(Trailer_3, 'Axle_Number_Double_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) > 24000) {
        ___arguments.context.pageData['T3_CLDW'] = 24000;
      }
      ___arguments.context.pageData['T3_CLSW'] = (8000 * (getObjectProperty(Trailer_3, 'Axle_Number_Single_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) > 24000) {
        ___arguments.context.pageData['T3_CLSW'] = 24000;
      }
      ___arguments.context.pageData['T3_Tare'] = (getObjectProperty(Trailer_3, 'Tare'));
      ___arguments.context.pageData['T3_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
      ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;
    } else {
      Trailer_3_Detail = 'None';
      ___arguments.context.pageData['T3_CLDW'] = 0;
      ___arguments.context.pageData['T3_CLSW'] = 0;
      ___arguments.context.pageData['T3_Tare'] = 0;
      ___arguments.context.pageData['T3_Payload'] = 0;
      ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;
    }

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2b221935822bd10deb4b8fabd9c49b16', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc0d83e656ebf94df776d01a2abd78a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', false);

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Swap_Trailer/components/23eef22b5c313da3b0c90962a99b42c5/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), 'image')))

  },
  /* handler:onDisplayAssignment *//* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('Posts'))

  },
  /* handler:onDirectoryAssignment */
/* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split('.').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment *//* content */
}));

define('./pages/Swap_Trailer/components/609885542943085abe1a49544fbddf5c/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Horse_Targets, Active_Horse, Selected_Horse, Selected_Driver;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.dataModel, 'SubmitFuel'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c45895c769eee0d6105de09bfeae78f3', true);
    ___arguments.context.dataModel['SubmitFuel'] = true;
    ___arguments.context.pageData['New_Fuel_Dump'] = (await Backendless.Data.of('Driver_Mileage_Dumps').save( ({ 'First_Mileage_On_Rig': (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')),'Mileage_Differential': (getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')),'Fuel_Consumption': (getObjectProperty(___arguments.context.pageData, 'Last3_FC')),'Last_Mileage_On_Rig': (getObjectProperty(___arguments.context.dataModel, 'mileage')),'Horse_Ideal_FC': (getObjectProperty(___arguments.context.pageData, 'Truck_Ideal_Fuel_Consumption')),'Dash_Slip': (getObjectProperty(___arguments.context.dataModel, 'image')),'location': (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lng'))).setY((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lat')))) }) ));
    Selected_Horse = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['Horse_Steer_Tare'] = (7700 * (getObjectProperty(Selected_Horse, 'Steer_Axle_Number')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare')) > 23100) {
      ___arguments.context.pageData['Horse_Steer_Tare'] = 23100;
    }
    ___arguments.context.pageData['Horse_Drive1_Tare'] = (8000 * (getObjectProperty(Selected_Horse, 'Drive_Axle_Number_Single_Wheels')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) > 24000) {
      ___arguments.context.pageData['Horse_Drive1_Tare'] = 24000;
    }
    ___arguments.context.pageData['Horse_Drive2_Tare'] = (9000 * (getObjectProperty(Selected_Horse, 'Drive_Axle_Number_Double_Wheels')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) > 24000) {
      ___arguments.context.pageData['Horse_Drive2_Tare'] = 24000;
    }
    ___arguments.context.pageData['H_Tare'] = (getObjectProperty(Selected_Horse, 'Tare_Weight'));
    ___arguments.context.pageData['H_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare'))) - (getObjectProperty(___arguments.context.pageData, 'H_Tare')));
    ___arguments.context.pageData['Current_Payload'] = ((getObjectProperty(___arguments.context.pageData, 'H_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T1_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T2_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T3_Payload')));
    if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare')) > 56000) {
      ___arguments.context.pageData['Tare_Combine'] = ((getObjectProperty(___arguments.context.pageData, 'H_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
      ___arguments.context.pageData['Current_Payload'] = (56000 - (getObjectProperty(___arguments.context.pageData, 'Tare_Combine')));
    }
    ___arguments.context.pageData['Current_Payload_Final'] = ((getObjectProperty(___arguments.context.pageData, 'Current_Payload')) / 1000);
    await Backendless.Data.of('Driver_Mileage_Dumps').setRelation((getObjectProperty(___arguments.context.pageData, 'New_Fuel_Dump')), 'Horse_Registration', [(getObjectProperty(Selected_Horse, 'objectId'))]);
    ___arguments.context.pageData['Username'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName'));
    Selected_Driver = (await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Call_Sign = \'',(getObjectProperty(___arguments.context.pageData, 'Username')),'\''].join(''))).setPageSize(10)))[0];
    await Backendless.Data.of('Driver_Mileage_Dumps').setRelation((getObjectProperty(___arguments.context.pageData, 'New_Fuel_Dump')), 'Driver', [(getObjectProperty(Selected_Driver, 'objectId'))]);
    Active_Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
    Active_Horse['Warehouse'] = 'Out';
    await Backendless.Data.of('Vehicles').save( Active_Horse );
    await Backendless.Data.of('Vehicles').setRelation(Active_Horse, 'Driver_1', [(getObjectProperty(Selected_Driver, 'objectId'))]);
    Horse_Targets = (await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.Horse_Registration = \'',(getObjectProperty(Selected_Horse, 'Horse_Registration')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['Tonnage_Override'] = (getObjectProperty(Horse_Targets, 'Tonnage_Override'));
    if ((getObjectProperty(___arguments.context.pageData, 'Tonnage_Override')) == null) {
      Active_Horse['Payload'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      await Backendless.Data.of('Vehicles').save( Active_Horse );
      Horse_Targets['Permissible_Tonnage'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      await Backendless.Data.of('Targets').save( Horse_Targets );
    } else {
      await Backendless.Data.of('Vehicles').save( Active_Horse );
      Horse_Targets['Permissible_Tonnage'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      Horse_Targets['Tonnage_Override'] = undefined;
      await Backendless.Data.of('Targets').save( Horse_Targets );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
    await Backendless.Data.of('Trailers').bulkUpdate( (['Currently_On = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Active_Truck_Final')), 'Horse_Registration')),'\''].join('')), ({ 'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Active_Truck_Final')), 'ownerId')) }) );
  }

  },
  /* handler:onSubmit *//* handler:onBeforeUnmount */
  async onBeforeUnmount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Fuel').setRelation((getObjectProperty(___arguments.context.pageData, 'NewFuel')), 'reg', [(getObjectProperty(___arguments.context.pageData, 'Registration'))]);

  },
  /* handler:onBeforeUnmount */
  /* content */
}));

define('./pages/Swap_Trailer/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer/components/cb53911dc178fd277a2316cbfb1eca43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var CurrentCustomer, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData));
  if (currentUser) {
    CurrentCustomer = (getObjectProperty(currentUser, 'Customer'));
    ___arguments.context.pageData['CustomerSelect'] = CurrentCustomer;
  }

  return CurrentCustomer

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Swap_Trailer/components/c77e57e7785a639b6d3b1b738466e375/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Swap_Trailer/components/1c26b77fa5bfe57c7a573909c7f97ace/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
    await new Promise(r => setTimeout(r, 600 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', true);
  }

  },
  /* handler:onChange */
  /* handler:onBlur */
  onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', true);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/Swap_Trailer/components/77e673caff9505f12e09fb9545cba7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('407f7d03fdee41b57c6be559cdfecb5a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', false);
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) == 'None' && (getObjectProperty(___arguments.context.pageData, 'Trailer_2')) == 'None' && (getObjectProperty(___arguments.context.pageData, 'Trailer_3')) == 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55c34211478125c39dda96b2ac32d9d7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_2')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_3')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer/components/160aa861c90b95da1c393679d5aca13e/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var Trailer_1_Detail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_1'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Swap_Trailer/components/dde9807dfa1d1185dbd8d5b98e77dbb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', true);
  }
  if (___arguments.value == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', false);
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', true);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_2')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_3')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', true);
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Swap_Trailer/components/183ce27a8636e037382490975dbfd1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_2'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Swap_Trailer/components/11b12f25adcc0e1cf3130774e586e192/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var Trailer_3_Details;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_3'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Swap_Trailer/components/0283b96d7d565ee14b92ac32030844fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var New_Trailer_1, item, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dccb7a3a45361a7b2e6fbc328ba74cc', true);
  New_Trailer_1 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_1['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Swap_Trailer/components/ada52d13b9a3be49565e4c18a5362d07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Trailer_1_Old, Current_Truck, Trailer_1_Relation, Trailer_1_Unhitch, Number_Of_Loads, NUmber_Holder_1, Loads, Updated_Loads, Number_Holder;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Load_Relation_Deleter() {
  for (var count = 0; count < Number_Of_Loads; count++) {
    NUmber_Holder_1 = NUmber_Holder_1 - 1;
    Number_Holder = NUmber_Holder_1;
    Updated_Loads = Loads[((Number_Holder + 1) - 1)];
    await Backendless.Data.of('Loads').deleteRelation(Updated_Loads, 'Horse', [Current_Truck]);
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fccffecc1eead3abededaea02b85d6d', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('0283b96d7d565ee14b92ac32030844fe', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer1_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_1_Relation = (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_1_ID'] = (getObjectProperty((Trailer_1_Relation[0]), 'objectId'));
  Trailer_1_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_1_ID')), ));
  try {
    Number_Of_Loads = (await Backendless.Data.of('Loads').bulkUpdate( (['Trailer_1.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Trailer_1_ID')),'\' AND Completion_Status = \'0\''].join('')), ({ 'Horse_Registration': null }) ));
    Loads = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_1.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Trailer_1_ID')),'\' AND Completion_Status = \'0\''].join(''))).setPageSize(100)));
    NUmber_Holder_1 = Number_Of_Loads;
    await Load_Relation_Deleter();

  } catch (error) {

  }
  Trailer_1_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_1_Unhitch );
  Trailer_1_Old = Trailer_1_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer1_Registration', Trailer_1_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T1_CLDW'] = 0;
  ___arguments.context.pageData['T1_CLSW'] = 0;
  ___arguments.context.pageData['T1_Tare'] = 0;
  ___arguments.context.pageData['T1_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fccffecc1eead3abededaea02b85d6d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer/components/8f4b8e227d3820bd939239829ee53539/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Trailer_2_Old, Current_Truck, Trailer_2_Relation, Trailer_2_Unhitch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('615f84e546ea8ba8496b0a9103b6b965', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('fbbef77ab7a3d1795aa3424ad2143abf', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer2_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_2_Relation = (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_2_ID'] = (getObjectProperty((Trailer_2_Relation[0]), 'objectId'));
  Trailer_2_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_2_ID')), ));
  Trailer_2_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_2_Unhitch );
  Trailer_2_Old = Trailer_2_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer2_Registration', Trailer_2_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T2_CLDW'] = 0;
  ___arguments.context.pageData['T2_CLSW'] = 0;
  ___arguments.context.pageData['T2_Tare'] = 0;
  ___arguments.context.pageData['T2_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('615f84e546ea8ba8496b0a9103b6b965', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer/components/fef4b50eb5a671c325a4c283c0264acf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Current_Truck, Trailer_3_Old, Trailer_3_Unhitch, Trailer_2_Old, Trailer_3_Relation, Trailer_2_Unhitch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b23d9d29ab34d18499caebe36fa3b478', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('ada6857aafb61354249cf2a84e757fba', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer3_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_3_Relation = (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_3_ID'] = (getObjectProperty((Trailer_3_Relation[0]), 'objectId'));
  Trailer_3_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_3_ID')), ));
  Trailer_3_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_3_Unhitch );
  Trailer_3_Old = Trailer_3_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer3_Registration', Trailer_3_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T3_CLDW'] = 0;
  ___arguments.context.pageData['T3_CLSW'] = 0;
  ___arguments.context.pageData['T3_Tare'] = 0;
  ___arguments.context.pageData['T3_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b23d9d29ab34d18499caebe36fa3b478', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer/components/fbbef77ab7a3d1795aa3424ad2143abf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var New_Trailer_2, item, LiveUser, New_Trailer_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('854783575616ac3945377bc9a3351554', true);
  New_Trailer_2 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_2['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  await Backendless.Data.of('Trailers').save( New_Trailer_2 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Swap_Trailer/components/ada6857aafb61354249cf2a84e757fba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var New_Trailer_3, item, LiveUser, New_Trailer_2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24098d0a08e6fa674dd707faf2571277', true);
  New_Trailer_3 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_3['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  await Backendless.Data.of('Trailers').save( New_Trailer_3 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Swap_Trailer/components/5dccb7a3a45361a7b2e6fbc328ba74cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Active_Truck, Trailer_1_Detail, New_Trailer_1, error, Number_Of_Loads, NUmber_Holder_1, Loads, Active_Loads, Updated_Loads, Number_Holder;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Load_Relation_Creater() {
  for (var count = 0; count < Number_Of_Loads; count++) {
    NUmber_Holder_1 = NUmber_Holder_1 - 1;
    Number_Holder = NUmber_Holder_1;
    Updated_Loads = Loads[((Number_Holder + 1) - 1)];
    console.log(Updated_Loads);
    console.log((await Backendless.Data.of('Loads').setRelation(Updated_Loads, 'Horse', [Active_Truck])));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dccb7a3a45361a7b2e6fbc328ba74cc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fccffecc1eead3abededaea02b85d6d', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_1 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('0283b96d7d565ee14b92ac32030844fe')), ));
  New_Trailer_1['Currently_On'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  Active_Truck['Trailer1_Reg'] = (getObjectProperty(New_Trailer_1, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  Active_Loads = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_1.objectId = \'',(getObjectProperty(New_Trailer_1, 'objectId')),'\'  AND Status = \'Loaded\''].join(''))).setPageSize(10)));
  try {
    Number_Of_Loads = (await Backendless.Data.of('Loads').bulkUpdate( (['Trailer_1.objectId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('0283b96d7d565ee14b92ac32030844fe')),'\' AND Completion_Status = \'0\''].join('')), ({ 'Horse_Registration': (getObjectProperty(Active_Truck, 'Horse_Registration')) }) ));
    Loads = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_1.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Trailer_1_ID')),'\' AND Completion_Status = \'0\''].join(''))).setPageSize(100)));
    NUmber_Holder_1 = Number_Of_Loads;
    await Load_Relation_Creater();

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['T1_CLDW'] = (9000 * (getObjectProperty(New_Trailer_1, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) > 24000) {
    ___arguments.context.pageData['T1_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T1_CLSW'] = (8000 * (getObjectProperty(New_Trailer_1, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) > 24000) {
    ___arguments.context.pageData['T1_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T1_Tare'] = (getObjectProperty(New_Trailer_1, 'Tare'));
  ___arguments.context.pageData['T1_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T1_Tare')));
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer1_Registration', [New_Trailer_1]);
  try {
    Trailer_1_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_1_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;

  }
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  Active_Truck['Trailer_1_Con'] = 'Hitched';
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fccffecc1eead3abededaea02b85d6d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer/components/854783575616ac3945377bc9a3351554/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Active_Truck, Trailer_2_Detail, New_Trailer_2, New_Trailer_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('854783575616ac3945377bc9a3351554', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('615f84e546ea8ba8496b0a9103b6b965', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_2 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fbbef77ab7a3d1795aa3424ad2143abf')), ));
  New_Trailer_2['Currently_On'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  Active_Truck['Trailer2_Reg'] = (getObjectProperty(New_Trailer_2, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  ___arguments.context.pageData['T2_CLDW'] = (9000 * (getObjectProperty(New_Trailer_2, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) > 24000) {
    ___arguments.context.pageData['T2_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T2_CLSW'] = (8000 * (getObjectProperty(New_Trailer_2, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) > 24000) {
    ___arguments.context.pageData['T2_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T2_Tare'] = (getObjectProperty(New_Trailer_2, 'Tare'));
  ___arguments.context.pageData['T2_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T2_Tare')));
  await Backendless.Data.of('Trailers').save( New_Trailer_2 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer2_Registration', [New_Trailer_2]);
  try {
    Trailer_2_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_2_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;

  }
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('615f84e546ea8ba8496b0a9103b6b965', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer/components/24098d0a08e6fa674dd707faf2571277/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Active_Truck, Trailer_3_Detail, New_Trailer_3, New_Trailer_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24098d0a08e6fa674dd707faf2571277', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b23d9d29ab34d18499caebe36fa3b478', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_3 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ada6857aafb61354249cf2a84e757fba')), ));
  New_Trailer_3['Currently_On'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  Active_Truck['Trailer3_Reg'] = (getObjectProperty(New_Trailer_3, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  ___arguments.context.pageData['T3_CLDW'] = (9000 * (getObjectProperty(New_Trailer_3, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) > 24000) {
    ___arguments.context.pageData['T3_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T3_CLSW'] = (8000 * (getObjectProperty(New_Trailer_3, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) > 24000) {
    ___arguments.context.pageData['T3_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T3_Tare'] = (getObjectProperty(New_Trailer_3, 'Tare'));
  ___arguments.context.pageData['T3_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
  await Backendless.Data.of('Trailers').save( New_Trailer_3 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer3_Registration', [New_Trailer_3]);
  try {
    Trailer_3_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_3_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;

  }
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b23d9d29ab34d18499caebe36fa3b478', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer/components/2b221935822bd10deb4b8fabd9c49b16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc0d83e656ebf94df776d01a2abd78a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2b221935822bd10deb4b8fabd9c49b16', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('576155c6897967125f086d6bf7d5885a', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer/components/cc0d83e656ebf94df776d01a2abd78a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Active_Truck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Trailers').bulkUpdate( (['Currently_On = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Active_Truck_Final')), 'Horse_Registration')),'\''].join('')), ({ 'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Active_Truck_Final')), 'ownerId')) }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['location'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('8ad84168027e8e0c521a965116921174', (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Horse_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Swap_Trailer_Office/components/23eef22b5c313da3b0c90962a99b42c5/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), 'image')))

  },
  /* handler:onDisplayAssignment *//* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('Posts'))

  },
  /* handler:onDirectoryAssignment */
/* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split('.').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment *//* content */
}));

define('./pages/Swap_Trailer_Office/components/609885542943085abe1a49544fbddf5c/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Horse_Targets, Active_Horse, Selected_Horse, Selected_Driver, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.dataModel, 'SubmitFuel'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c45895c769eee0d6105de09bfeae78f3', true);
    ___arguments.context.dataModel['SubmitFuel'] = true;
    ___arguments.context.pageData['New_Fuel_Dump'] = (await Backendless.Data.of('Driver_Mileage_Dumps').save( ({ 'First_Mileage_On_Rig': (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')),'Mileage_Differential': (getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')),'Fuel_Consumption': (getObjectProperty(___arguments.context.pageData, 'Last3_FC')),'Last_Mileage_On_Rig': (getObjectProperty(___arguments.context.dataModel, 'mileage')),'Horse_Ideal_FC': (getObjectProperty(___arguments.context.pageData, 'Truck_Ideal_Fuel_Consumption')),'Dash_Slip': (getObjectProperty(___arguments.context.dataModel, 'image')),'location': (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lng'))).setY((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lat')))) }) ));
    Selected_Horse = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['Horse_Steer_Tare'] = (7700 * (getObjectProperty(Selected_Horse, 'Steer_Axle_Number')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare')) > 23100) {
      ___arguments.context.pageData['Horse_Steer_Tare'] = 23100;
    }
    ___arguments.context.pageData['Horse_Drive1_Tare'] = (8000 * (getObjectProperty(Selected_Horse, 'Drive_Axle_Number_Single_Wheels')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) > 24000) {
      ___arguments.context.pageData['Horse_Drive1_Tare'] = 24000;
    }
    ___arguments.context.pageData['Horse_Drive2_Tare'] = (9000 * (getObjectProperty(Selected_Horse, 'Drive_Axle_Number_Double_Wheels')));
    if ((getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) > 24000) {
      ___arguments.context.pageData['Horse_Drive2_Tare'] = 24000;
    }
    ___arguments.context.pageData['H_Tare'] = (getObjectProperty(Selected_Horse, 'Tare_Weight'));
    ___arguments.context.pageData['H_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare'))) - (getObjectProperty(___arguments.context.pageData, 'H_Tare')));
    ___arguments.context.pageData['Current_Payload'] = ((getObjectProperty(___arguments.context.pageData, 'H_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T1_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T2_Payload')) + (getObjectProperty(___arguments.context.pageData, 'T3_Payload')));
    if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Drive1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'Horse_Steer_Tare')) > 56000) {
      ___arguments.context.pageData['Tare_Combine'] = ((getObjectProperty(___arguments.context.pageData, 'H_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T1_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T2_Tare')) + (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
      ___arguments.context.pageData['Current_Payload'] = (56000 - (getObjectProperty(___arguments.context.pageData, 'Tare_Combine')));
    }
    ___arguments.context.pageData['Current_Payload_Final'] = ((getObjectProperty(___arguments.context.pageData, 'Current_Payload')) / 1000);
    try {
      await Backendless.Data.of('Driver_Mileage_Dumps').setRelation((getObjectProperty(___arguments.context.pageData, 'New_Fuel_Dump')), 'Horse_Registration', [(getObjectProperty(Selected_Horse, 'objectId'))]);

    } catch (error) {

    }
    try {
      ___arguments.context.pageData['Username'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName'));
      Selected_Driver = (await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['Call_Sign = \'',(getObjectProperty(___arguments.context.pageData, 'Username')),'\''].join(''))).setPageSize(10)))[0];
      await Backendless.Data.of('Driver_Mileage_Dumps').setRelation((getObjectProperty(___arguments.context.pageData, 'New_Fuel_Dump')), 'Driver', [(getObjectProperty(Selected_Driver, 'objectId'))]);

    } catch (error) {

    }
    Active_Horse = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
    Active_Horse['Warehouse'] = 'Out';
    await Backendless.Data.of('Vehicles').save( Active_Horse );
    try {
      await Backendless.Data.of('Vehicles').setRelation(Active_Horse, 'Driver_1', [(getObjectProperty(Selected_Driver, 'objectId'))]);

    } catch (error) {

    }
    Horse_Targets = (await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.Horse_Registration = \'',(getObjectProperty(Selected_Horse, 'Horse_Registration')),'\''].join(''))).setPageSize(10)))[0];
    ___arguments.context.pageData['Tonnage_Override'] = (getObjectProperty(Horse_Targets, 'Tonnage_Override'));
    if ((getObjectProperty(___arguments.context.pageData, 'Tonnage_Override')) == null) {
      Active_Horse['Payload'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      await Backendless.Data.of('Vehicles').save( Active_Horse );
      Horse_Targets['Permissible_Tonnage'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      await Backendless.Data.of('Targets').save( Horse_Targets );
    } else {
      await Backendless.Data.of('Vehicles').save( Active_Horse );
      Horse_Targets['Permissible_Tonnage'] = (getObjectProperty(___arguments.context.pageData, 'Current_Payload_Final'));
      Horse_Targets['Tonnage_Override'] = undefined;
      await Backendless.Data.of('Targets').save( Horse_Targets );
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
  }

  },
  /* handler:onSubmit *//* handler:onBeforeUnmount */
  async onBeforeUnmount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Fuel').setRelation((getObjectProperty(___arguments.context.pageData, 'NewFuel')), 'reg', [(getObjectProperty(___arguments.context.pageData, 'Registration'))]);

  },
  /* handler:onBeforeUnmount */
  /* content */
}));

define('./pages/Swap_Trailer_Office/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/cb53911dc178fd277a2316cbfb1eca43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var CurrentCustomer, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData));
  if (currentUser) {
    CurrentCustomer = (getObjectProperty(currentUser, 'Customer'));
    ___arguments.context.pageData['CustomerSelect'] = CurrentCustomer;
  }

  return CurrentCustomer

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/c77e57e7785a639b6d3b1b738466e375/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/1c26b77fa5bfe57c7a573909c7f97ace/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
    await new Promise(r => setTimeout(r, 600 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', true);
  }

  },
  /* handler:onChange */
  /* handler:onBlur */
  onBlur(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', true);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/77e673caff9505f12e09fb9545cba7d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('407f7d03fdee41b57c6be559cdfecb5a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', false);
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) == 'None' && (getObjectProperty(___arguments.context.pageData, 'Trailer_2')) == 'None' && (getObjectProperty(___arguments.context.pageData, 'Trailer_3')) == 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('55c34211478125c39dda96b2ac32d9d7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_2')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_3')) != 'None') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8273cf727ad04c842cc45f35422d0f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde9807dfa1d1185dbd8d5b98e77dbb9', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77e673caff9505f12e09fb9545cba7d1', false);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/160aa861c90b95da1c393679d5aca13e/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var Trailer_1_Detail;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_1'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/dde9807dfa1d1185dbd8d5b98e77dbb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'true') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', true);
  }
  if (___arguments.value == 'false') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', false);
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_1')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2737863786afd3bf201bc42ff005ee8a', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', true);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_2')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3cc994a567acee9d48060a4df474bdca', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Trailer_3')) == 'None') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8726e4ef24c1450af4b8c46f8dcfad5d', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', true);
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/183ce27a8636e037382490975dbfd1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_2'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/11b12f25adcc0e1cf3130774e586e192/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var Trailer_3_Details;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Trailer_3'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/0283b96d7d565ee14b92ac32030844fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var New_Trailer_1, item, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dccb7a3a45361a7b2e6fbc328ba74cc', true);
  New_Trailer_1 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_1['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/ada52d13b9a3be49565e4c18a5362d07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Trailer_1_Old, Current_Truck, Trailer_1_Relation, Trailer_1_Unhitch, Number_Of_Loads, NUmber_Holder_1, Loads, Updated_Loads, Number_Holder;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Load_Relation_Deleter() {
  for (var count = 0; count < Number_Of_Loads; count++) {
    NUmber_Holder_1 = NUmber_Holder_1 - 1;
    Number_Holder = NUmber_Holder_1;
    Updated_Loads = Loads[((Number_Holder + 1) - 1)];
    await Backendless.Data.of('Loads').deleteRelation(Updated_Loads, 'Horse', [Current_Truck]);
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada52d13b9a3be49565e4c18a5362d07', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fccffecc1eead3abededaea02b85d6d', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('0283b96d7d565ee14b92ac32030844fe', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer1_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_1_Relation = (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_1_ID'] = (getObjectProperty((Trailer_1_Relation[0]), 'objectId'));
  Trailer_1_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_1_ID')), ));
  try {
    Number_Of_Loads = (await Backendless.Data.of('Loads').bulkUpdate( (['Trailer_1.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Trailer_1_ID')),'\' AND Completion_Status = \'0\''].join('')), ({ 'Horse_Registration': null }) ));
    Loads = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_1.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Trailer_1_ID')),'\' AND Completion_Status = \'0\''].join(''))).setPageSize(100)));
    NUmber_Holder_1 = Number_Of_Loads;
    await Load_Relation_Deleter();

  } catch (error) {

  }
  Trailer_1_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_1_Unhitch );
  Trailer_1_Old = Trailer_1_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer1_Registration', Trailer_1_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T1_CLDW'] = 0;
  ___arguments.context.pageData['T1_CLSW'] = 0;
  ___arguments.context.pageData['T1_Tare'] = 0;
  ___arguments.context.pageData['T1_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fccffecc1eead3abededaea02b85d6d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/8f4b8e227d3820bd939239829ee53539/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Trailer_2_Old, Current_Truck, Trailer_2_Relation, Trailer_2_Unhitch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8f4b8e227d3820bd939239829ee53539', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('615f84e546ea8ba8496b0a9103b6b965', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('fbbef77ab7a3d1795aa3424ad2143abf', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer2_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_2_Relation = (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_2_ID'] = (getObjectProperty((Trailer_2_Relation[0]), 'objectId'));
  Trailer_2_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_2_ID')), ));
  Trailer_2_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_2_Unhitch );
  Trailer_2_Old = Trailer_2_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer2_Registration', Trailer_2_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T2_CLDW'] = 0;
  ___arguments.context.pageData['T2_CLSW'] = 0;
  ___arguments.context.pageData['T2_Tare'] = 0;
  ___arguments.context.pageData['T2_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('615f84e546ea8ba8496b0a9103b6b965', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/fef4b50eb5a671c325a4c283c0264acf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Current_Truck, Trailer_3_Old, Trailer_3_Unhitch, Trailer_2_Old, Trailer_3_Relation, Trailer_2_Unhitch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fef4b50eb5a671c325a4c283c0264acf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b23d9d29ab34d18499caebe36fa3b478', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('ada6857aafb61354249cf2a84e757fba', null);
  Current_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  Current_Truck['Trailer3_Reg'] = null;
  await Backendless.Data.of('Vehicles').save( Current_Truck );
  Trailer_3_Relation = (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)));
  ___arguments.context.pageData['Trailer_3_ID'] = (getObjectProperty((Trailer_3_Relation[0]), 'objectId'));
  Trailer_3_Unhitch = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.pageData, 'Trailer_3_ID')), ));
  Trailer_3_Unhitch['Currently_On'] = null;
  await Backendless.Data.of('Trailers').save( Trailer_3_Unhitch );
  Trailer_3_Old = Trailer_3_Relation;
  await Backendless.Data.of('Vehicles').deleteRelation(Current_Truck, 'Trailer3_Registration', Trailer_3_Old);
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  ___arguments.context.pageData['T3_CLDW'] = 0;
  ___arguments.context.pageData['T3_CLSW'] = 0;
  ___arguments.context.pageData['T3_Tare'] = 0;
  ___arguments.context.pageData['T3_Payload'] = 0;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b23d9d29ab34d18499caebe36fa3b478', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/fbbef77ab7a3d1795aa3424ad2143abf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var New_Trailer_2, item, LiveUser, New_Trailer_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('854783575616ac3945377bc9a3351554', true);
  New_Trailer_2 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_2['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  await Backendless.Data.of('Trailers').save( New_Trailer_2 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/ada6857aafb61354249cf2a84e757fba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var New_Trailer_3, item, LiveUser, New_Trailer_2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24098d0a08e6fa674dd707faf2571277', true);
  New_Trailer_3 = (await Backendless.Data.of('Trailers').findById(___arguments.value, ));
  New_Trailer_3['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Final_New_Reg'));
  await Backendless.Data.of('Trailers').save( New_Trailer_3 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/5dccb7a3a45361a7b2e6fbc328ba74cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Active_Truck, Trailer_1_Detail, New_Trailer_1, error, Number_Of_Loads, NUmber_Holder_1, Loads, Active_Loads, Updated_Loads, Number_Holder;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Load_Relation_Creater() {
  for (var count = 0; count < Number_Of_Loads; count++) {
    NUmber_Holder_1 = NUmber_Holder_1 - 1;
    Number_Holder = NUmber_Holder_1;
    Updated_Loads = Loads[((Number_Holder + 1) - 1)];
    console.log(Updated_Loads);
    console.log((await Backendless.Data.of('Loads').setRelation(Updated_Loads, 'Horse', [Active_Truck])));
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0283b96d7d565ee14b92ac32030844fe', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dccb7a3a45361a7b2e6fbc328ba74cc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fccffecc1eead3abededaea02b85d6d', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_1 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('0283b96d7d565ee14b92ac32030844fe')), ));
  New_Trailer_1['Currently_On'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  Active_Truck['Trailer1_Reg'] = (getObjectProperty(New_Trailer_1, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  Active_Loads = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_1.objectId = \'',(getObjectProperty(New_Trailer_1, 'objectId')),'\'  AND Status = \'Loaded\''].join(''))).setPageSize(10)));
  try {
    Number_Of_Loads = (await Backendless.Data.of('Loads').bulkUpdate( (['Trailer_1.objectId = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('0283b96d7d565ee14b92ac32030844fe')),'\' AND Completion_Status = \'0\''].join('')), ({ 'Horse_Registration': (getObjectProperty(Active_Truck, 'Horse_Registration')) }) ));
    Loads = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_1.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Trailer_1_ID')),'\' AND Completion_Status = \'0\''].join(''))).setPageSize(100)));
    NUmber_Holder_1 = Number_Of_Loads;
    await Load_Relation_Creater();

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['T1_CLDW'] = (9000 * (getObjectProperty(New_Trailer_1, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) > 24000) {
    ___arguments.context.pageData['T1_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T1_CLSW'] = (8000 * (getObjectProperty(New_Trailer_1, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) > 24000) {
    ___arguments.context.pageData['T1_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T1_Tare'] = (getObjectProperty(New_Trailer_1, 'Tare'));
  ___arguments.context.pageData['T1_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T1_Tare')));
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer1_Registration', [New_Trailer_1]);
  try {
    Trailer_1_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_1_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;

  }
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  Active_Truck['Trailer_1_Con'] = 'Hitched';
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fccffecc1eead3abededaea02b85d6d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/854783575616ac3945377bc9a3351554/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Active_Truck, Trailer_2_Detail, New_Trailer_2, New_Trailer_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fbbef77ab7a3d1795aa3424ad2143abf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('854783575616ac3945377bc9a3351554', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('615f84e546ea8ba8496b0a9103b6b965', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_2 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fbbef77ab7a3d1795aa3424ad2143abf')), ));
  New_Trailer_2['Currently_On'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  Active_Truck['Trailer2_Reg'] = (getObjectProperty(New_Trailer_2, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  ___arguments.context.pageData['T2_CLDW'] = (9000 * (getObjectProperty(New_Trailer_2, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) > 24000) {
    ___arguments.context.pageData['T2_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T2_CLSW'] = (8000 * (getObjectProperty(New_Trailer_2, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) > 24000) {
    ___arguments.context.pageData['T2_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T2_Tare'] = (getObjectProperty(New_Trailer_2, 'Tare'));
  ___arguments.context.pageData['T2_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T2_Tare')));
  await Backendless.Data.of('Trailers').save( New_Trailer_2 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer2_Registration', [New_Trailer_2]);
  try {
    Trailer_2_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_2_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;

  }
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('615f84e546ea8ba8496b0a9103b6b965', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/24098d0a08e6fa674dd707faf2571277/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, LiveUser, Active_Truck, Trailer_3_Detail, New_Trailer_3, New_Trailer_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ada6857aafb61354249cf2a84e757fba', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24098d0a08e6fa674dd707faf2571277', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b23d9d29ab34d18499caebe36fa3b478', true);
  Active_Truck = (await Backendless.Data.of('Vehicles').findById((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), ));
  New_Trailer_3 = (await Backendless.Data.of('Trailers').findById(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ada6857aafb61354249cf2a84e757fba')), ));
  New_Trailer_3['Currently_On'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  Active_Truck['Trailer3_Reg'] = (getObjectProperty(New_Trailer_3, 'Trailer_Registration'));
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  await Backendless.Data.of('Trailers').save( New_Trailer_1 );
  ___arguments.context.pageData['T3_CLDW'] = (9000 * (getObjectProperty(New_Trailer_3, 'Axle_Number_Double_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) > 24000) {
    ___arguments.context.pageData['T3_CLDW'] = 24000;
  }
  ___arguments.context.pageData['T3_CLSW'] = (8000 * (getObjectProperty(New_Trailer_3, 'Axle_Number_Single_Wheel')));
  if ((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) > 24000) {
    ___arguments.context.pageData['T3_CLSW'] = 24000;
  }
  ___arguments.context.pageData['T3_Tare'] = (getObjectProperty(New_Trailer_3, 'Tare'));
  ___arguments.context.pageData['T3_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
  await Backendless.Data.of('Trailers').save( New_Trailer_3 );
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
  await Backendless.Data.of('Vehicles').setRelation(Active_Truck, 'Trailer3_Registration', [New_Trailer_3]);
  try {
    Trailer_3_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));

  } catch (error) {
    ___arguments.context.pageData['Null_Trailer'] = 'None';
    Trailer_3_Detail = (getObjectProperty(___arguments.context.pageData, 'Null_Trailer'));

  } finally {
    ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;

  }
  await Backendless.Data.of('Vehicles').save( Active_Truck );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('0283b96d7d565ee14b92ac32030844fe', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fbbef77ab7a3d1795aa3424ad2143abf', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada6857aafb61354249cf2a84e757fba', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['owner.objectId = \'',LiveUser,'\'','And Warehouse_Status = \'In\'',' And Trailer_Status = \'Active\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Trailer_Registration')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b23d9d29ab34d18499caebe36fa3b478', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/2b221935822bd10deb4b8fabd9c49b16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc0d83e656ebf94df776d01a2abd78a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2b221935822bd10deb4b8fabd9c49b16', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('576155c6897967125f086d6bf7d5885a', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/cc0d83e656ebf94df776d01a2abd78a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Swap_Trailer_Office/components/8ad84168027e8e0c521a965116921174/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Trailer_3_Detail, Trailer_3, Active_Truck, Trailer_2_Detail, Trailer_2, Trailer_1_Detail, Trailer_1, Last_3_Lt, item, Last_3_MD, Ideal_FC, Last_Mileage_Of_This_Truck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Active_Truck = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments.value,'\''].join(''))).setPageSize(100)))[0];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', true);
  ___arguments.context.pageData['Got_Mileage'] = (getObjectProperty(Active_Truck, 'objectId'));
  Last_Mileage_Of_This_Truck = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('mileage').setPageSize(100))).map(async item => {; return ({ 'Last Mileage': (getObjectProperty(item, 'mileage')) });})));
  ___arguments.context.pageData['Final_Last_Mileage'] = (Last_Mileage_Of_This_Truck.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_Mileage'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_Mileage')), 'Last Mileage'))));
  Ideal_FC = (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Ideal_Fuel_Consumption': (getObjectProperty(item, 'Ideal_Fuel_Consumption')) });})));
  ___arguments.context.pageData['Truck_Ideal_Fuel_Consumption'] = (getObjectProperty((Ideal_FC.slice(-1)[0]), 'Ideal_Fuel_Consumption'));
  ___arguments.context.pageData['New_Reg'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  ___arguments.context.pageData['Final_New_Reg'] = (getObjectProperty(___arguments.context.pageData, 'New_Reg'));
  await new Promise(r => setTimeout(r, 500 || 0));
  Last_3_MD = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Mileage Differential': (getObjectProperty(item, 'Mileage_Differential')) });})));
  ___arguments.context.pageData['Final_Last_MD_1'] = (Last_3_MD.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_MD_1'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_1')), 'Mileage Differential'));
  ___arguments.context.pageData['Final_Last_MD_2'] = (Last_3_MD.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_MD_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_2')), 'Mileage Differential'))));
  ___arguments.context.pageData['Final_Last_MD_3'] = (Last_3_MD.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_MD_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_3')), 'Mileage Differential'))));
  ___arguments.context.pageData['Got_LT'] = undefined;
  Last_3_Lt = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ 'Last Litres ': (getObjectProperty(item, 'litres')) });})));
  ___arguments.context.pageData['Final_Last_LT_1'] = (Last_3_Lt.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_LT_1'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_1')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_2'] = (Last_3_Lt.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_LT_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_2')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_3'] = (Last_3_Lt.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_LT_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_3')), 'Last Litres '))));
  ___arguments.context.pageData['Last3_FC'] = (Math.round((((getObjectProperty(___arguments.context.pageData, 'Reflected_MD_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_1'))) / ((getObjectProperty(___arguments.context.pageData, 'Reflected_LT_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_1')))) * 1000) / 1000);
  try {
    if ((getObjectProperty(Active_Truck, 'Trailer_1_Confirm')) == 'Hitched') {
      Trailer_1_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));
      Trailer_1 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',Trailer_1_Detail,'\''].join(''))).setPageSize(10)))[0];
      ___arguments.context.pageData['T1_CLDW'] = (9000 * (getObjectProperty(Trailer_1, 'Axle_Number_Double_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T1_CLDW')) > 24000) {
        ___arguments.context.pageData['T1_CLDW'] = 24000;
      }
      ___arguments.context.pageData['T1_CLSW'] = (8000 * (getObjectProperty(Trailer_1, 'Axle_Number_Single_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) > 24000) {
        ___arguments.context.pageData['T1_CLSW'] = 24000;
      }
      ___arguments.context.pageData['T1_Tare'] = (getObjectProperty(Trailer_1, 'Tare'));
      ___arguments.context.pageData['T1_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T1_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T1_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T1_Tare')));
      ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;
    } else {
      Trailer_1_Detail = 'None';
      ___arguments.context.pageData['T1_CLDW'] = 0;
      ___arguments.context.pageData['T1_CLSW'] = 0;
      ___arguments.context.pageData['T1_Tare'] = 0;
      ___arguments.context.pageData['T1_Payload'] = 0;
      ___arguments.context.pageData['Trailer_1'] = Trailer_1_Detail;
    }

  } catch (error) {

  }
  try {
    if ((getObjectProperty(Active_Truck, 'Trailer_2_Confirm')) == 'Hitched') {
      Trailer_2_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));
      Trailer_2 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',Trailer_2_Detail,'\''].join(''))).setPageSize(10)))[0];
      ___arguments.context.pageData['T2_CLDW'] = (9000 * (getObjectProperty(Trailer_2, 'Axle_Number_Double_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T2_CLDW')) > 24000) {
        ___arguments.context.pageData['T2_CLDW'] = 24000;
      }
      ___arguments.context.pageData['T2_CLSW'] = (8000 * (getObjectProperty(Trailer_2, 'Axle_Number_Single_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) > 24000) {
        ___arguments.context.pageData['T2_CLSW'] = 24000;
      }
      ___arguments.context.pageData['T2_Tare'] = (getObjectProperty(Trailer_2, 'Tare'));
      ___arguments.context.pageData['T2_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T2_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T2_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T2_Tare')));
      ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;
    } else {
      Trailer_2_Detail = 'None';
      ___arguments.context.pageData['T2_CLDW'] = 0;
      ___arguments.context.pageData['T2_CLSW'] = 0;
      ___arguments.context.pageData['T2_Tare'] = 0;
      ___arguments.context.pageData['T2_Payload'] = 0;
      ___arguments.context.pageData['Trailer_2'] = Trailer_2_Detail;
    }

  } catch (error) {

  }
  try {
    if ((getObjectProperty(Active_Truck, 'Trailer_3_Confirm')) == 'Hitched') {
      Trailer_3_Detail = (getObjectProperty(((await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(___arguments.context.pageData, 'Got_Mileage')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0)))[0]), 'Trailer_Registration'));
      Trailer_3 = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Trailer_Registration = \'',Trailer_3_Detail,'\''].join(''))).setPageSize(10)))[0];
      ___arguments.context.pageData['T3_CLDW'] = (9000 * (getObjectProperty(Trailer_3, 'Axle_Number_Double_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T3_CLDW')) > 24000) {
        ___arguments.context.pageData['T3_CLDW'] = 24000;
      }
      ___arguments.context.pageData['T3_CLSW'] = (8000 * (getObjectProperty(Trailer_3, 'Axle_Number_Single_Wheel')));
      if ((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) > 24000) {
        ___arguments.context.pageData['T3_CLSW'] = 24000;
      }
      ___arguments.context.pageData['T3_Tare'] = (getObjectProperty(Trailer_3, 'Tare'));
      ___arguments.context.pageData['T3_Payload'] = (((getObjectProperty(___arguments.context.pageData, 'T3_CLSW')) + (getObjectProperty(___arguments.context.pageData, 'T3_CLDW'))) - (getObjectProperty(___arguments.context.pageData, 'T3_Tare')));
      ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;
    } else {
      Trailer_3_Detail = 'None';
      ___arguments.context.pageData['T3_CLDW'] = 0;
      ___arguments.context.pageData['T3_CLSW'] = 0;
      ___arguments.context.pageData['T3_Tare'] = 0;
      ___arguments.context.pageData['T3_Payload'] = 0;
      ___arguments.context.pageData['Trailer_3'] = Trailer_3_Detail;
    }

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b82a83ecacab7add9c8b2c47a347c8ce', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2b221935822bd10deb4b8fabd9c49b16', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc0d83e656ebf94df776d01a2abd78a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('160aa861c90b95da1c393679d5aca13e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('183ce27a8636e037382490975dbfd1f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11b12f25adcc0e1cf3130774e586e192', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8ad84168027e8e0c521a965116921174', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Targets/components/cd0d4fee14b25b96f6b45238154e7c6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Targets/components/146fbc03c0393d3eb21d57c694d7922a/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Targets/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26']((await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']()));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Targets/components/c0c2421d0cad41bd7ce4586997758025/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var columnsMapping, properties, Where, tableName, filePath, j, Component, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  Component = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('146fbc03c0393d3eb21d57c694d7922a'));
  columnsMapping = ({ 'Passer': null });
  Where = (getObjectProperty(Component, 'whereClause'));
  properties = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns')).map(async item => {; return (getObjectProperty(item, 'field'));})));
  tableName = (getObjectProperty(Component, 'tableName'));
  filePath = String(getObjectProperty(Component, 'title')) + String('.csv');
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    columnsMapping[(getObjectProperty(j, 'field'))] = (getObjectProperty(j, 'title'));
  }
  delete columnsMapping['Passer'];
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': filePath,'tableName': tableName,'tableOptions': ({ 'where': Where,'properties': properties,'columnsMapping': columnsMapping,'excludeProps': ['objectId'] }),'csvOptions': ({ 'header': true }) })), true, undefined);
}

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Test/components/970c0e5fee586d97895bac83d828a4fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Route;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  console.log(getObjectProperty(___arguments.context.pageData, 'Email'));
  console.log((await Backendless.Messaging.sendEmail('Test', new Backendless.Bodyparts({ textmessage: 'hello' }), ensureArray([(getObjectProperty(___arguments.context.pageData, 'Email'))]), undefined)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var RGBA, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('095a325d1065630153bc97bc5b6aa223', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);
  try {
    ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());

  } catch (error) {

  }
  ___arguments.context.pageData['Customers'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Customers', (['Third_Party_Tyre_Manager = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_User')), 'Third_Party_Tyre_Manager')),'\''].join('')), null));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('8fb5beb15dd40c8b11d10fc9471548b2', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Customers')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'ownerId')),'label': (getObjectProperty(item, 'Company')) });}))));
  ___arguments.context.pageData['Tyre_Swap_Edit_True2'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False2'] = true;
  ___arguments.context.pageData['Tyre_Swap_Edit_True'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False'] = true;
  ___arguments.context.pageData['Images_View'] = false;
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('233ea02d528ea296096fab865d466a43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8096fb55ff9c027bc50ec5ae514327e5', false);

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['RGBA'] = 1;
  for (var count = 0; count < 100; count++) {
    RGBA = (getObjectProperty(___arguments.context.pageData, 'RGBA')) - 0.01;
    ___arguments.context.pageData['RGBA'] = RGBA;
    await new Promise(r => setTimeout(r, 0.1 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6'))['backgroundColor'] = (['rgba(0, 0, 0, ',RGBA,')'].join(''));
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c34a0533a03ad3d9598079e1bfad2aa', true);

  },
  /* handler:onEnter *//* content */
}));

define('./pages/Third_Party_Tyre_Operator/components/b612d3b3061d799155f81a9286caaa69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      try {
    ___arguments.context.pageData['Repair_Viewer'] = false;

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Tyre_Icon_Select'] = false;

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('233ea02d528ea296096fab865d466a43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd34eb4c1caac4aac398e36cabee4e17', false);
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);

  } catch (error) {

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('20312f99482797f4157228f54b9fa217', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89cbdd9906f1205369b27df94c0a9bac', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/da9736f35fb4ac560cf3525ec7b83f7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', true);
  console.log(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId'));
  ___arguments.context.pageData['Add_Tyre_Data'] = ((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId')),'\''].join(''))).setSortBy('Tyre_Number').setPageSize(100))).map(async item => {; return ({ 'Tyre_Number': (getObjectProperty(item, 'Tyre_Number')),'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')) });}))).slice(-1)[0]);
  await Backendless.Data.of('Tyres').save( ({ 'State': 'In Order','Cost': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cost')),'Current_Cap_State': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cap_State')),'Current_Mileage': 0,'Expected_Mileage': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_EM')),'Fleet_Brand': String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Fleet_Brand')).slice(0, 5)) + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1),'Make': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Make')),'Model': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Model')),'Serial_Number': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_SN')),'System_Generated_Tyre': 'No','Type': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Type')),'Tyre_Number': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1,'Tyre_Position': null,'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId')) }) );
  ___arguments.context.pageData['Add_Tyre_Cost'] = null;
  ___arguments.context.pageData['Add_Tyre_Cap_State'] = null;
  ___arguments.context.pageData['Add_Tyre_EM'] = null;
  ___arguments.context.pageData['Add_Tyre_Make'] = null;
  ___arguments.context.pageData['Add_Tyre_Model'] = null;
  ___arguments.context.pageData['Add_Tyre_SN'] = null;
  ___arguments.context.pageData['Add_Tyre_Type'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/44c3b966ea3806de97b4f9779b9e8b08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', true);
  ___arguments.context.pageData['Add_Tyre_Data'] = ((await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId')),'\''].join(''))).setSortBy('Tyre_Number').setPageSize(100))).map(async item => {; return ({ 'Tyre_Number': (getObjectProperty(item, 'Tyre_Number')),'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')) });}))).slice(-1)[0]);
  await Backendless.Data.of('Tyres').save( ({ 'State': 'In Order','Cost': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cost')),'Current_Cap_State': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Cap_State')),'Current_Mileage': 0,'Expected_Mileage': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_EM')),'Fleet_Brand': String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Fleet_Brand')).slice(0, 5)) + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1),'Make': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Make')),'Model': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Model')),'Serial_Number': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_SN')),'System_Generated_Tyre': 'No','Type': (getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Type')),'Tyre_Number': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Add_Tyre_Data')), 'Tyre_Number')) + 1,'Tyre_Position': null,'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );
  ___arguments.context.pageData['Add_Tyre_Cost'] = null;
  ___arguments.context.pageData['Add_Tyre_Cap_State'] = null;
  ___arguments.context.pageData['Add_Tyre_EM'] = null;
  ___arguments.context.pageData['Add_Tyre_Make'] = null;
  ___arguments.context.pageData['Add_Tyre_Model'] = null;
  ___arguments.context.pageData['Add_Tyre_SN'] = null;
  ___arguments.context.pageData['Add_Tyre_Type'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/3d5325c98073def13916f9efa43608a1/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var error, Where_Clause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId')) === 'undefined') {
    } else {
      Where_Clause = ['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId')),'\''].join('');
    }

  } catch (error) {

  } finally {
    if (error) {
      Where_Clause = 0;
    }

  }

  return Where_Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/d4c45696ad32d68d06987d2729e37336/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    var Where_Clause, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId')) === 'undefined') {
      Where_Clause = 0;
    } else {
      if (typeof (getObjectProperty(___arguments.context.pageData, 'RM_SET')) === 'undefined') {
        Where_Clause = ['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId')),'\' AND Over_Mileage = \'Over Mileage\''].join('');
      } else {
        Where_Clause = ['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId')),'\' AND Remaining_Mileage < \'',(getObjectProperty(___arguments.context.pageData, 'RM_SET')),'\''].join('');
      }
    }

  } catch (error) {

  } finally {
    if (error) {
      Where_Clause = 0;
    }

  }

  return Where_Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/77fa07ad48e4ea8f7631256fa44e3038/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.pageData, 'Tyre_Life_Average'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/a1cbef3f61c43cd584bd28d423b1a241/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Average Tyre Life (',(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.pageData, 'Tyre_Life_Average')))),'%)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/25e1e91ca988933c9adf88f3a3921072/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.pageData, 'Over_Mileage_Tyres'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/e686bd4ffad4b6957cf1718c68ab2e68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Percentage of Tyres over Mileage (',(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.pageData, 'Over_Mileage_Tyres')))),'%)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/731dbd24d54ee20f884e0fe15e3792f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == null || (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View')) == false) {
    ___arguments.context.pageData['WS_Hamburger_View'] = true;
  } else {
    ___arguments.context.pageData['WS_Hamburger_View'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/8096fb55ff9c027bc50ec5ae514327e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/8fb5beb15dd40c8b11d10fc9471548b2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Customer, item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Customer = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Customers')), async (item) => {


   return ((getObjectProperty(item, 'ownerId')) == ___arguments.value);
  }))[0];
  ___arguments.context.pageData['Selected_Customer'] = Customer;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/8fe71c897befad117d570e4cbac40938/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Entered_Key'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/93d908b342661d7cff933a8be40e91a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Password_Check')) == true || (typeof (getObjectProperty(___arguments.context.pageData, 'Password_Check')) === 'undefined')) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/d63119ee6e2d0d939d193787d9c2110b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}


  if ((getObjectProperty(___arguments.context.pageData, 'Entered_Key')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'TPTM_Password'))) {
    ___arguments.context.pageData['Password_Check'] = true;
    ___arguments.context.pageData['User_OwnerId'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId'));
    try {
      ___arguments.context.pageData['Tyres'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Tyres', (['ownerId =\'',(getObjectProperty(___arguments.context.pageData, 'User_OwnerId')),'\''].join(''))));

    } catch (error) {

    }
    try {
      ___arguments.context.pageData['Over_Mileage_Tyres'] = (((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyres')), async (item) => {


       return ((getObjectProperty(item, 'Remaining_Mileage')) < 0);
      })).length / (getObjectProperty(___arguments.context.pageData, 'Tyres')).length) * 100);

    } catch (error) {

    }
    try {
      ___arguments.context.pageData['Tyre_Life_Average'] = (mathMean(await Promise.all((getObjectProperty(___arguments.context.pageData, 'Tyres')).map(async item => {; return (getObjectProperty(item, 'Life'));}))));

    } catch (error) {

    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44b535d202ccf645a6afa259d002a0bd', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('095a325d1065630153bc97bc5b6aa223', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8096fb55ff9c027bc50ec5ae514327e5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('233ea02d528ea296096fab865d466a43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd34eb4c1caac4aac398e36cabee4e17', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('20312f99482797f4157228f54b9fa217', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89cbdd9906f1205369b27df94c0a9bac', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c34a0533a03ad3d9598079e1bfad2aa', false);
  } else {
    ___arguments.context.pageData['Password_Check'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/1bd3f98df4a504c26a4ab1ad928c09ed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['RM_SET'] = (getObjectProperty(___arguments.context.pageData, 'RM_Value'));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('d4c45696ad32d68d06987d2729e37336');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/9f018a4f35feb88fadef2c898a2edb17/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['RM_Value'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/f6b576f4f3c679e6cb1d8aba816a7fe7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'WS_Hamburger_View'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Third_Party_Tyre_Operator/components/efeff8de53241b2f11bc439f1002b1d2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Tyre_Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/addFuel/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Active_Truck, Ideal_FC, item, Last_3_Lt, Last_3_MD, Last_Mileage_Of_This_Truck, LiveUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  await BackendlessUI.Functions.Custom['fn_f3398cab771c7281f65827bb29f68e26'](___arguments.context.appData);
  ___arguments.context.pageData['Fuel_Lock'] = false;
  ___arguments.context.pageData['location'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  ___arguments.context.pageData['UserDriver'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName'));
  LiveUser = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
  Active_Truck = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver_1.ownerId = \'',LiveUser,'\''].join(''))).setPageSize(100)))[0];
  ___arguments.context.pageData['Last Fuel Transaction Mileage'] = (getObjectProperty(Active_Truck, 'Current_Mileage'));
  ___arguments.context.pageData['Active_Truck_Reg'] = (getObjectProperty(Active_Truck, 'Horse_Registration'));
  ___arguments.context.pageData['Got_Mileage'] = (getObjectProperty(Active_Truck, 'objectId'));
  Last_Mileage_Of_This_Truck = (await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('mileage desc').setPageSize(100)))[0];
  ___arguments.context.pageData['Fuel_Count'] = (getObjectProperty(Last_Mileage_Of_This_Truck, 'Fuel_Count'));
  if ((getObjectProperty(___arguments.context.pageData, 'Fuel_Count')) == 3) {
    ___arguments.context.pageData['Fuel_Count'] = 1;
  } else if ((getObjectProperty(___arguments.context.pageData, 'Fuel_Count')) == 2) {
    ___arguments.context.pageData['Fuel_Lock'] = true;
    ___arguments.context.pageData['Fuel_Count'] = 3;
  } else if ((getObjectProperty(___arguments.context.pageData, 'Fuel_Count')) == 1) {
    ___arguments.context.pageData['Fuel_Count'] = 2;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Fuel_Count')) < 3) {
    Last_Mileage_Of_This_Truck['Fuel_Count'] = 3;
    await Backendless.Data.of('Fuel').save( Last_Mileage_Of_This_Truck );
  }
  ___arguments.context.pageData['Final_Last_Mileage'] = (getObjectProperty(Last_Mileage_Of_This_Truck, 'mileage'));
  ___arguments.context.pageData['Reflected_Mileage'] = (Number((getObjectProperty(Last_Mileage_Of_This_Truck, 'mileage'))));
  Last_3_MD = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ [`Mileage Differential`]: (getObjectProperty(item, 'Mileage_Differential')) });})));
  ___arguments.context.pageData['Final_Last_MD_1'] = (Last_3_MD.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_MD_1'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_1')), 'Mileage Differential'));
  ___arguments.context.pageData['Final_Last_MD_2'] = (Last_3_MD.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_MD_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_2')), 'Mileage Differential'))));
  ___arguments.context.pageData['Final_Last_MD_3'] = (Last_3_MD.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_MD_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_MD_3')), 'Mileage Differential'))));
  ___arguments.context.pageData['Got_LT'] = undefined;
  Last_3_Lt = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('created').setPageSize(100))).map(async item => {; return ({ [`Last Litres `]: (getObjectProperty(item, 'litres')) });})));
  ___arguments.context.pageData['Final_Last_LT_1'] = (Last_3_Lt.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_LT_1'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_1')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_2'] = (Last_3_Lt.slice(-2)[0]);
  ___arguments.context.pageData['Reflected_LT_2'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_2')), 'Last Litres '))));
  ___arguments.context.pageData['Final_Last_LT_3'] = (Last_3_Lt.slice(-3)[0]);
  ___arguments.context.pageData['Reflected_LT_3'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_LT_3')), 'Last Litres '))));
  ___arguments.context.pageData['Last3_FC'] = (Math.round((((getObjectProperty(___arguments.context.pageData, 'Reflected_MD_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_MD_1'))) / ((getObjectProperty(___arguments.context.pageData, 'Reflected_LT_3')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_2')) + (getObjectProperty(___arguments.context.pageData, 'Reflected_LT_1')))) * 1000) / 1000);
  Ideal_FC = (await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Ideal_Fuel_Consumption`]: (getObjectProperty(item, 'Ideal_Fuel_Consumption')) });})));
  ___arguments.context.pageData['Truck_Ideal_Fuel_Consumption'] = (getObjectProperty((Ideal_FC.slice(-1)[0]), 'Ideal_Fuel_Consumption'));
  ___arguments.context.pageData['New_Reg'] = Active_Truck;
  ___arguments.context.pageData['Final_New_Reg'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Reg')), 'Horse_Registration'));
  await new Promise(r => setTimeout(r, 500 || 0));
  ___arguments.context.pageData['Data_View'] = true;
  await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f4b0a8f99dc1b4602c42b6470cec7c7')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f4b0a8f99dc1b4602c42b6470cec7c7')), false);

  },
  /* handler:onEnter *//* content */
}));

define('./pages/addFuel/components/23eef22b5c313da3b0c90962a99b42c5/bundle.js', [], () => ({
  /* content */

  
/* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), 'image')) == false) {
    ___arguments.context.pageData['Fuel_Lock'] = false;
  }

  return (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), 'image')))

  },
  /* handler:onDisplayAssignment *//* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('Posts'))

  },
  /* handler:onDirectoryAssignment */
/* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split('.').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment *//* content */
}));

define('./pages/addFuel/components/bb5ada8e9d94fa6a225cc5aa02236794/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb5ada8e9d94fa6a225cc5aa02236794')));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f55f0e45addc1dfb8f9adf3d8215fbbf')) == 'Other')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/addFuel/components/609885542943085abe1a49544fbddf5c/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, Owner, item, Trailer3_Reg, Trailer2_Reg, Trailer1_Reg, Driver, Trailers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', false);
  Driver = (await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(10)))[0];
  Trailers = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(___arguments.context.pageData, 'Active_Truck_Reg')),'\''].join(''))).setPageSize(100)));
  try {
    Trailer1_Reg = (getObjectProperty((Trailers[0]), 'Trailer_Registration'));

  } catch (error) {

  }
  try {
    Trailer2_Reg = (getObjectProperty((Trailers[0]), 'Trailer_Registration'));

  } catch (error) {

  }
  try {
    Trailer3_Reg = (getObjectProperty((Trailers[1]), 'Trailer_Registration'));

  } catch (error) {

  }
  if ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
    if (!(getObjectProperty(___arguments.context.dataModel, 'SubmitFuel'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65231cd243ff11bef9c77719b028e65f', true);
      ___arguments.context.dataModel['SubmitFuel'] = true;
      Owner = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
      ___arguments.context.pageData['NewFuel'] = (await Backendless.Data.of('Fuel').save( ({ [`Contractor_Km_Rate`]: (getObjectProperty(Driver, 'Contractor_Km_Rate')),[`Good_Driving_Rate`]: (getObjectProperty(Driver, 'Good_Driving_Rate')),[`Fuel_Count`]: (getObjectProperty(___arguments.context.pageData, 'Fuel_Count')),[`Ideal_Fuel_Consumption`]: (getObjectProperty(___arguments.context.pageData, 'Truck_Ideal_Fuel_Consumption')),[`Gain_Loss`]: (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((((getObjectProperty(___arguments.context.dataModel, 'cost')) / (getObjectProperty(___arguments.context.dataModel, 'litres'))) * (((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))) / (getObjectProperty(___arguments.context.pageData, 'Truck_Ideal_Fuel_Consumption'))) - (getObjectProperty(___arguments.context.dataModel, 'cost'))))),[`Driver`]: (getObjectProperty(___arguments.context.pageData, 'UserDriver')),[`Fuel_Consumption`]: ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))) / (getObjectProperty(___arguments.context.dataModel, 'litres')),[`Mileage_Differential`]: (getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')),[`image`]: (getObjectProperty(___arguments.context.dataModel, 'image')),[`description`]: (getObjectProperty(___arguments.context.dataModel, 'description')),[`garage`]: (getObjectProperty(___arguments.context.dataModel, 'garage')),[`mileage`]: (getObjectProperty(___arguments.context.dataModel, 'mileage')),[`litres`]: (getObjectProperty(___arguments.context.dataModel, 'litres')),[`cost`]: (getObjectProperty(___arguments.context.dataModel, 'cost')),[`location`]: (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lng'))).setY((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lat')))),[`Registration`]: (getObjectProperty(___arguments.context.pageData, 'Active_Truck_Reg')),[`reg_objectId`]: (getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),[`ownerId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
      (getObjectProperty(___arguments.context.pageData, 'New_Reg'))['Current_Mileage'] = (((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Reg')), 'Current_Mileage')));
      await Backendless.Data.of('Vehicles').save( (getObjectProperty(___arguments.context.pageData, 'New_Reg')) );
      ___arguments.context.pageData['Selected_Reg'] = (getObjectProperty(___arguments.context.pageData, 'Got_Mileage'));
      await Backendless.Data.of('Fuel').setRelation((getObjectProperty(___arguments.context.pageData, 'NewFuel')), 'reg', [(getObjectProperty(___arguments.context.pageData, 'Selected_Reg'))]);
      try {
        await Backendless.Data.of('Tyres').bulkUpsert( (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(___arguments.context.pageData, 'Active_Truck_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Current_Mileage`]: (getObjectProperty(item, 'Current_Mileage')) + ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))),[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: Owner });}))) );

      } catch (error) {

      }
      try {
        await Backendless.Data.of('Tyres').bulkUpsert( (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',Trailer1_Reg,'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Current_Mileage`]: (getObjectProperty(item, 'Current_Mileage')) + ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))),[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: Owner });}))) );

      } catch (error) {

      }
      try {
        await Backendless.Data.of('Tyres').bulkUpsert( (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',Trailer2_Reg,'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Current_Mileage`]: (getObjectProperty(item, 'Current_Mileage')) + ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))),[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: Owner });}))) );

      } catch (error) {

      }
      try {
        await Backendless.Data.of('Tyres').bulkUpsert( (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',Trailer3_Reg,'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Current_Mileage`]: (getObjectProperty(item, 'Current_Mileage')) + ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))),[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: Owner });}))) );

      } catch (error) {

      }
      try {
        await Backendless.Data.of('Trailers').bulkUpsert( (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(___arguments.context.pageData, 'Active_Truck_Reg')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ [`Current_Mileage`]: (getObjectProperty(item, 'Current_Mileage')) + ((getObjectProperty(___arguments.context.dataModel, 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))),[`objectId`]: (getObjectProperty(item, 'objectId')),[`ownerId`]: Owner });}))) );

      } catch (error) {
        console.log(error);

      }
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
    }
  } else {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible_Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('576155c6897967125f086d6bf7d5885a', true);
  }

  },
  /* handler:onSubmit *//* handler:onBeforeUnmount */
  async onBeforeUnmount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('Fuel').setRelation((getObjectProperty(___arguments.context.pageData, 'NewFuel')), 'reg', [(getObjectProperty(___arguments.context.pageData, 'Registration'))]);

  },
  /* handler:onBeforeUnmount */
  /* content */
}));

define('./pages/addFuel/components/0d2cb3a2e684e07c62f226acdd61ad72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addFuel/components/cb53911dc178fd277a2316cbfb1eca43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var CurrentCustomer, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await BackendlessUI.Functions.Custom['fn_40231e2dd0378fd17972815199986b28'](___arguments.context.appData));
  if (currentUser) {
    CurrentCustomer = (getObjectProperty(currentUser, 'Customer'));
    ___arguments.context.pageData['CustomerSelect'] = CurrentCustomer;
  }

  return CurrentCustomer

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/addFuel/components/c77e57e7785a639b6d3b1b738466e375/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/addFuel/components/1c26b77fa5bfe57c7a573909c7f97ace/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var Active_Truck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) == (getObjectProperty(___arguments.context.pageData, 'Last Fuel Transaction Mileage'))) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
  } else {
    if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0)) {
      ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', true);
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')) >= 0) {
      ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c77e57e7785a639b6d3b1b738466e375', false);
    }
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b51538c6481c1ab759c677a7fe82f142')));
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c26b77fa5bfe57c7a573909c7f97ace')));

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b51538c6481c1ab759c677a7fe82f142')));
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b51538c6481c1ab759c677a7fe82f142')));

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/addFuel/components/98946b7835a5ef6d2b63071bc2528187/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Last3_FC'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/addFuel/components/89aa8f06c6495d53dd6dd069a2389c3d/bundle.js', [], () => ({
  /* content */

  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Lock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Fuel_Lock')) == true) {
    Lock = true;
  } else {
    Lock = (getObjectProperty(___arguments.context.pageData, 'Incompatible_Mileage')) == 'Incompatible Mileage';
  }

  return Lock

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}));

define('./pages/addFuel/components/4a0712b6dd5de72eb53179fd3bcef1e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/addFuel/components/5aee54c7652c6eec08788f7ffabb0a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Truck_Ideal_Fuel_Consumption'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/addFuel/components/62bfbb1142a79853e9f1c5cf543cdd48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63d89ac4b5aa4d910a77e6670f43fc6f', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21ac9fb4c41519b2bc0ebd87ff1dbbb2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62bfbb1142a79853e9f1c5cf543cdd48', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('407f7d03fdee41b57c6be559cdfecb5a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc26e6835c72d6d29aff4f7d086251f9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f26784897427ee179733302c972db1df', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b51538c6481c1ab759c677a7fe82f142', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76fc74658706e3dcc8454c3a13d783dc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89aa8f06c6495d53dd6dd069a2389c3d', true);
  ___arguments.context.pageData['Data_View2'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addFuel/components/21ac9fb4c41519b2bc0ebd87ff1dbbb2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c')['Shop Viewer'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63d89ac4b5aa4d910a77e6670f43fc6f', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63d89ac4b5aa4d910a77e6670f43fc6f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62bfbb1142a79853e9f1c5cf543cdd48', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21ac9fb4c41519b2bc0ebd87ff1dbbb2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('094257daf1a51969e1e3b92e0e050784', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('407f7d03fdee41b57c6be559cdfecb5a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f55f0e45addc1dfb8f9adf3d8215fbbf', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1c26b77fa5bfe57c7a573909c7f97ace', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc26e6835c72d6d29aff4f7d086251f9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a1c149946837aec55d5308b6ed77cde', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('76fc74658706e3dcc8454c3a13d783dc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bb5ada8e9d94fa6a225cc5aa02236794', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1837b916e0a41519aa7c5c9be221653', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addFuel/components/76fc74658706e3dcc8454c3a13d783dc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb5ada8e9d94fa6a225cc5aa02236794')));

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    var Disabler;


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f55f0e45addc1dfb8f9adf3d8215fbbf')) == 'Sleep Out') {
    Disabler = true;
  } else {
    Disabler = false;
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/addFuel/components/cc71947e3fe67644b9336d518805c43d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Fuel_Lock'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/addFuel/components/9116a35d0082db9bb6e80ee70298b41f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('609885542943085abe1a49544fbddf5c')), 'image'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('23eef22b5c313da3b0c90962a99b42c5');
  ___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c')['image'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addFuel/components/f1837b916e0a41519aa7c5c9be221653/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Horse, New_Other;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1837b916e0a41519aa7c5c9be221653', false);
  New_Other = (await Backendless.Data.of('Other').save( ({ 'Type': ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f55f0e45addc1dfb8f9adf3d8215fbbf')),'Driver': (getObjectProperty(___arguments.context.pageData, 'UserDriver')),'Driver_ObjectID': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'image': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'image')),'description': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'description')),'Outlet': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'garage')),'mileage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'mileage')),'cost': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'cost')),'location': (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lng'))).setY((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lat')))),'Registration': (getObjectProperty(___arguments.context.pageData, 'Active_Truck_Reg')),'reg_objectId': (getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  Horse = [(getObjectProperty(___arguments.context.pageData, 'Got_Mileage'))];
  await Backendless.Data.of('Other').setRelation(New_Other, 'reg', Horse);
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Post', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addFuel/components/f55f0e45addc1dfb8f9adf3d8215fbbf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c')['Type'] = ___arguments.value;
  if (___arguments.value == 'Sleep Out') {
    ___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c')['cost'] = (getObjectProperty(((await Backendless.Data.of('Users').loadRelations((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Employee_Details').setPageSize(10).setOffset(0)))[0]), 'Sleep_Out_Rate'));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/addFuel/components/f26784897427ee179733302c972db1df/bundle.js', [], () => ({
  /* content */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f26784897427ee179733302c972db1df')));

  },
  /* handler:onFocus */
  /* handler:onBlur *//* handler:onBlur */
  /* content */
}))

define('./pages/addFuel/components/094257daf1a51969e1e3b92e0e050784/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Data_View2')) == true && (getObjectProperty(___arguments.context.pageData, 'Data_View')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('63d89ac4b5aa4d910a77e6670f43fc6f', false);
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/addFuel/components/bbe7a9be84ebde8b4ab6b44d140795ea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Loader_Viewer')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/addFuel/components/6a1c149946837aec55d5308b6ed77cde/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c26b77fa5bfe57c7a573909c7f97ace')));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f55f0e45addc1dfb8f9adf3d8215fbbf')) == 'Sleep Out') {
    Viewer = false;
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('609885542943085abe1a49544fbddf5c'), 'Shop Viewer')) == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/addLoad/components/0fec6c027fd1aa122d3e05e33ff8922e/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var New_Loads;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.dataModel, 'submit'))) {
    ___arguments.context.dataModel['submit'] = true;
    await Backendless.Data.of('Load_Neg').save( ({ 'Load_Planner': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );
    New_Loads = (await Backendless.Data.of('Loads').save( ({ 'load_reference': (getObjectProperty(___arguments.context.dataModel, 'reference')),'load_point': (getObjectProperty(___arguments.context.dataModel, 'load')),'delivery_point': (getObjectProperty(___arguments.context.dataModel, 'offload')),'tonnage': (getObjectProperty(___arguments.context.dataModel, 'tonnage')),'Tonnage_Differential': (getObjectProperty(___arguments.context.pageData, 'Targets')) - (getObjectProperty(___arguments.context.dataModel, 'tonnage')),'Completion_Status': true,'Customer_objectId': ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('740b7f86a872d36bf62b05467dcbcca7')),'Horse_objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'objectId')),'image': (getObjectProperty(___arguments.context.dataModel, 'image')),'location': (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lng'))).setY((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'location')), 'lat')))) }) ));
    await Backendless.Data.of('Loads').addRelation(New_Loads, 'Horse', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'objectId'))]);
    await Backendless.Data.of('Loads').addRelation(New_Loads, 'Customer', [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('740b7f86a872d36bf62b05467dcbcca7'))]);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
  }

  },
  /* handler:onSubmit */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    var Customers, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Customers = (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Customer')),'value': (getObjectProperty(item, 'objectId')) });})));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('740b7f86a872d36bf62b05467dcbcca7', Customers);
  ___arguments.context.dataModel['Image_Loaded'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/addLoad/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var Last_Mileage_Of_This_Truck, item, Active_Truck, error, Item2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Hider() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4eb380a85e211d3438981d8713a69d04', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68df3a0bb0e3a81c53b7dd2e88a484fb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('063bf7dd3583be8e4c0a8b1e87cbdbc2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db741351834684aa89461f71e5c83506', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2bf29f1509d6544b2b4e95c0a889829', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2e2d8bff51f234c3a5bf1890b765681', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ab40cdfc6ddef434140a113b0a60fe', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14713a0d50e8adbfeb2fc07ab90a4e0c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('87af0188fb652b37bb8611da9363244d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('740b7f86a872d36bf62b05467dcbcca7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8a43e23557fd0ccf67115213a9ede06d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a2ec28eb08710031eb6643f2813a109', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7203f813b98d99f33dc22364528ea439', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e856531dcf78b46fc3ee427b33c451f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a7169894bba68180b91a32c98a7453a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4eb380a85e211d3438981d8713a69d04', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('805e32463ef291f11eed20717acc8967', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dbae3f03f9ccd1d3b1abf0ce04e30395', false);

  } catch (error) {
    console.log(error);

  }
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf5f7a9a2e3a299c3594cd4e0d876831'))['opacity'] = 0;
  ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  await Hider();
  ___arguments.context.pageData['location'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  ___arguments.context.pageData['Horse'] = ((await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Driver_1.ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`Horse_Registration`]: (getObjectProperty(item, 'Horse_Registration')),[`Load_Planner`]: (await Promise.all((await Backendless.Data.of('vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Load_Planner').setPageSize(10).setOffset(0))).map(async Item2 => {; return (getObjectProperty(Item2, 'displayName'));})))[0],[`Trailer_1`]: (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(10).setOffset(0))),[`Trailer_2`]: (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(10).setOffset(0))),[`Trailer_3`]: (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(10).setOffset(0))),[`Payload`]: (getObjectProperty(item, 'Payload')) });})))[0]);
  ___arguments.context.pageData['Tonnage_Target'] = ((await Promise.all((await Backendless.Data.of('Targets').find(Backendless.DataQueryBuilder.create().setWhereClause((['Registration.objectId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'objectId')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ [`Permissible_Tonnage`]: (getObjectProperty(item, 'Permissible_Tonnage')),[`Tonnage_Override`]: (getObjectProperty(item, 'Tonnage_Override')),[`Load_Tolerance`]: (getObjectProperty(item, 'Load_Tolerance')) });})))[0]);
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Load_Planner')) == null) {
    ___arguments.context.pageData['Load_Planner'] = null;
    ___arguments.context.pageData['Loads'] = (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'objectId')),'\' And ','Completion_Status = \'0\''].join(''))).setSortBy('Customer').setPageSize(10))).map(async item => {; return ({ [`Load_Planner`]: (getObjectProperty(item, 'Load_Planner')),[`Rate_Per_Km`]: (getObjectProperty(item, 'Rate_Per_Km')),[`mileage`]: (getObjectProperty(item, 'mileage')),[`Customer_Name`]: (getObjectProperty(item, 'Customer_Name')),[`Completion_Status`]: (getObjectProperty(item, 'Completion_Status')),[`Split_delivery`]: (getObjectProperty(item, 'Split_delivery')),[`Service`]: (getObjectProperty(item, 'Service')),[`Rerouted`]: (getObjectProperty(item, 'Rerouted')),[`Horse_Registration`]: (getObjectProperty(item, 'Horse_Registration')),[`Description`]: (getObjectProperty(item, 'Description')),[`Planned_Load`]: (getObjectProperty(item, 'Planned_Load')),[`Planned_Delivery`]: (getObjectProperty(item, 'Planned_Delivery')),[`Customer`]: (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async Item2 => {; return (getObjectProperty(Item2, 'Customer'));})))[0],[`objectId`]: (getObjectProperty(item, 'objectId')),[`delivery_point`]: (getObjectProperty(item, 'delivery_point')),[`Delivery_Point_Mileage`]: (getObjectProperty(item, 'Delivery_Point_Mileage')),[`load_point`]: (getObjectProperty(item, 'load_point')),[`Load_Point_Mileage`]: (getObjectProperty(item, 'Load_Point_Mileage')),[`load_reference`]: (getObjectProperty(item, 'load_reference')),[`Mileage_Differential`]: (getObjectProperty(item, 'Mileage_Differential')),[`Planned_Delivery_Date_Time`]: (getObjectProperty(item, 'Planned_Delivery_Date_Time')),[`Planned_Tonnage`]: (getObjectProperty(item, 'Planned_Tonnage')),[`Product`]: (getObjectProperty(item, 'Product')),[`Split_Load`]: (getObjectProperty(item, 'Split_Load')),[`Split_Load_Load_Number`]: (getObjectProperty(item, 'Split_Load_Load_Number')),[`Split_Load_Reference`]: (getObjectProperty(item, 'Split_Load_Reference')),[`Status`]: (getObjectProperty(item, 'Status')),[`tonnage`]: (getObjectProperty(item, 'tonnage')),[`Tonnage_Differential`]: (getObjectProperty(item, 'Tonnage_Differential')),[`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async Item2 => {; return (getObjectProperty(Item2, 'Customer'));})))[0],' - ',(getObjectProperty(item, 'load_reference'))].join('') });})));
    ___arguments.context.pageData['Delivered_Loads'] = ((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'objectId')),'\' And ','Completion_Status = \'1\''].join(''))).setSortBy('Customer').setPageSize(10))).map(async item => {; return ({ [`Load_Planner`]: (getObjectProperty(item, 'Load_Planner')),[`Rate_Per_Km`]: (getObjectProperty(item, 'Rate_Per_Km')),[`mileage`]: (getObjectProperty(item, 'mileage')),[`Customer_Name`]: (getObjectProperty(item, 'Customer_Name')),[`Completion_Status`]: (getObjectProperty(item, 'Completion_Status')),[`Split_delivery`]: (getObjectProperty(item, 'Split_delivery')),[`Service`]: (getObjectProperty(item, 'Service')),[`Rerouted`]: (getObjectProperty(item, 'Rerouted')),[`Horse_Registration`]: (getObjectProperty(item, 'Horse_Registration')),[`Description`]: (getObjectProperty(item, 'Description')),[`Planned_Load`]: (getObjectProperty(item, 'Planned_Load')),[`Planned_Delivery`]: (getObjectProperty(item, 'Planned_Delivery')),[`Customer`]: (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async Item2 => {; return (getObjectProperty(Item2, 'Customer'));})))[0],[`objectId`]: (getObjectProperty(item, 'objectId')),[`delivery_point`]: (getObjectProperty(item, 'delivery_point')),[`Delivery_Point_Mileage`]: (getObjectProperty(item, 'Delivery_Point_Mileage')),[`load_point`]: (getObjectProperty(item, 'load_point')),[`Load_Point_Mileage`]: (getObjectProperty(item, 'Load_Point_Mileage')),[`load_reference`]: (getObjectProperty(item, 'load_reference')),[`Mileage_Differential`]: (getObjectProperty(item, 'Mileage_Differential')),[`Planned_Delivery_Date_Time`]: (getObjectProperty(item, 'Planned_Delivery_Date_Time')),[`Planned_Tonnage`]: (getObjectProperty(item, 'Planned_Tonnage')),[`Product`]: (getObjectProperty(item, 'Product')),[`Split_Load`]: (getObjectProperty(item, 'Split_Load')),[`Split_Load_Load_Number`]: (getObjectProperty(item, 'Split_Load_Load_Number')),[`Split_Load_Reference`]: (getObjectProperty(item, 'Split_Load_Reference')),[`Status`]: (getObjectProperty(item, 'Status')),[`tonnage`]: (getObjectProperty(item, 'tonnage')),[`Tonnage_Differential`]: (getObjectProperty(item, 'Tonnage_Differential')),[`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async Item2 => {; return (getObjectProperty(Item2, 'Customer'));})))[0],' - ',(getObjectProperty(item, 'load_reference'))].join('') });}))).slice(-1)[0]);
    ___arguments.context.pageData['Last_MD'] = ((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'objectId')),'\''].join(''))).setSortBy('Delivery_Point_Mileage desc').setPageSize(10)))[0]);
    console.log(getObjectProperty(___arguments.context.pageData, 'Last_MD'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2bbd2ce5499c17d6c5e9677ccda9766', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cbaa8773c19a429686e24b8387a6dc65', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2e2d8bff51f234c3a5bf1890b765681', true);
    if ((getObjectProperty(___arguments.context.pageData, 'Loads')).length > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2bbd2ce5499c17d6c5e9677ccda9766', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cbaa8773c19a429686e24b8387a6dc65', false);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Loads')).length == 5) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2e2d8bff51f234c3a5bf1890b765681', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('59e7455583f5ddb40e9eb1fbef2e5b63', true);
    }
  } else {
    try {
      ___arguments.context.pageData['Old_Load'] = ((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'objectId')),'\' And ','Completion_Status = \'1\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(10))).map(async item => {; return ({ [`Rate_Per_Km`]: (getObjectProperty(item, 'Rate_Per_Km')),[`mileage`]: (getObjectProperty(item, 'mileage')),[`Customer_Name`]: (getObjectProperty(item, 'Customer_Name')),[`Completion_Status`]: (getObjectProperty(item, 'Completion_Status')),[`Split_delivery`]: (getObjectProperty(item, 'Split_delivery')),[`Service`]: (getObjectProperty(item, 'Service')),[`Rerouted`]: (getObjectProperty(item, 'Rerouted')),[`Horse_Registration`]: (getObjectProperty(item, 'Horse_Registration')),[`Description`]: (getObjectProperty(item, 'Description')),[`Planned_Load`]: (getObjectProperty(item, 'Planned_Load')),[`Planned_Delivery`]: (getObjectProperty(item, 'Planned_Delivery')),[`Customer`]: (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async Item2 => {; return (getObjectProperty(Item2, 'Customer'));})))[0],[`objectId`]: (getObjectProperty(item, 'objectId')),[`delivery_point`]: (getObjectProperty(item, 'delivery_point')),[`Delivery_Point_Mileage`]: (getObjectProperty(item, 'Delivery_Point_Mileage')),[`load_point`]: (getObjectProperty(item, 'load_point')),[`Load_Point_Mileage`]: (getObjectProperty(item, 'Load_Point_Mileage')),[`load_reference`]: (getObjectProperty(item, 'load_reference')),[`Mileage_Differential`]: (getObjectProperty(item, 'Mileage_Differential')),[`Planned_Delivery_Date_Time`]: (getObjectProperty(item, 'Planned_Delivery_Date_Time')),[`Planned_Tonnage`]: (getObjectProperty(item, 'Planned_Tonnage')),[`Product`]: (getObjectProperty(item, 'Product')),[`Split_Load`]: (getObjectProperty(item, 'Split_Load')),[`Split_Load_Load_Number`]: (getObjectProperty(item, 'Split_Load_Load_Number')),[`Split_Load_Reference`]: (getObjectProperty(item, 'Split_Load_Reference')),[`Status`]: (getObjectProperty(item, 'Status')),[`tonnage`]: (getObjectProperty(item, 'tonnage')),[`Tonnage_Differential`]: (getObjectProperty(item, 'Tonnage_Differential')),[`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async Item2 => {; return (getObjectProperty(Item2, 'Customer'));})))[0],' - ',(getObjectProperty(item, 'load_reference'))].join('') });}))).slice(-1)[0]);
      ___arguments.context.pageData['Loads'] = (await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['Horse.objectId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'objectId')),'\' And ','Completion_Status = \'0\''].join(''))).setSortBy('Planned_Delivery_Date_Time').setPageSize(10))).map(async item => {; return ({ [`load_reference`]: (getObjectProperty(item, 'load_reference')),[`Load_Planner`]: (getObjectProperty(item, 'Load_Planner')),[`Rate_Per_Km`]: (getObjectProperty(item, 'Rate_Per_Km')),[`mileage`]: (getObjectProperty(item, 'mileage')),[`Customer_Name`]: (getObjectProperty(item, 'Customer_Name')),[`Completion_Status`]: (getObjectProperty(item, 'Completion_Status')),[`Split_delivery`]: (getObjectProperty(item, 'Split_delivery')),[`Service`]: (getObjectProperty(item, 'Service')),[`Rerouted`]: (getObjectProperty(item, 'Rerouted')),[`Horse_Registration`]: (getObjectProperty(item, 'Horse_Registration')),[`Description`]: (getObjectProperty(item, 'Description')),[`Planned_Load`]: (getObjectProperty(item, 'Planned_Load')),[`Planned_Delivery`]: (getObjectProperty(item, 'Planned_Delivery')),[`Customer`]: (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async Item2 => {; return (getObjectProperty(Item2, 'Customer'));})))[0],[`objectId`]: (getObjectProperty(item, 'objectId')),[`delivery_point`]: (getObjectProperty(item, 'delivery_point')),[`Delivery_Point_Mileage`]: (getObjectProperty(item, 'Delivery_Point_Mileage')),[`load_point`]: (getObjectProperty(item, 'load_point')),[`Load_Point_Mileage`]: (getObjectProperty(item, 'Load_Point_Mileage')),[`Mileage_Differential`]: (getObjectProperty(item, 'Mileage_Differential')),[`Planned_Delivery_Date_Time`]: (getObjectProperty(item, 'Planned_Delivery_Date_Time')),[`Planned_Tonnage`]: (getObjectProperty(item, 'Planned_Tonnage')),[`Product`]: (getObjectProperty(item, 'Product')),[`Split_Load`]: (getObjectProperty(item, 'Split_Load')),[`Split_Load_Load_Number`]: (getObjectProperty(item, 'Split_Load_Load_Number')),[`Split_Load_Reference`]: (getObjectProperty(item, 'Split_Load_Reference')),[`Status`]: (getObjectProperty(item, 'Status')),[`tonnage`]: (getObjectProperty(item, 'tonnage')),[`Tonnage_Differential`]: (getObjectProperty(item, 'Tonnage_Differential')),[`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async Item2 => {; return (getObjectProperty(Item2, 'Customer'));})))[0],' - ',(getObjectProperty(item, 'load_reference'))].join('') });})));
      ___arguments.context.pageData['Load_Planner'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a2bbd2ce5499c17d6c5e9677ccda9766', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cbaa8773c19a429686e24b8387a6dc65', false);

    } catch (error) {

    } finally {
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cbaa8773c19a429686e24b8387a6dc65', true);
      }

    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbaa8773c19a429686e24b8387a6dc65'))['content'] = 'No Load Detected <br>Please Contact Planner';
  }
  ___arguments.context.pageData['Got_Mileage'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'objectId'));
  Active_Truck = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setPageSize(10))).slice(-1)[0];
  Last_Mileage_Of_This_Truck = (await Promise.all((await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['reg.objectId = \'',(getObjectProperty(___arguments.context.pageData, 'Got_Mileage')),'\''].join(''))).setSortBy('mileage').setPageSize(100))).map(async item => {; return ({ [`Last Mileage`]: (getObjectProperty(item, 'mileage')) });})));
  ___arguments.context.pageData['Final_Last_Mileage'] = (Last_Mileage_Of_This_Truck.slice(-1)[0]);
  ___arguments.context.pageData['Reflected_Mileage'] = (Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Final_Last_Mileage')), 'Last Mileage'))));
  await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cf5f7a9a2e3a299c3594cd4e0d876831')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf5f7a9a2e3a299c3594cd4e0d876831')), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b3e81376bd86fc2e97e4a99ba42803b6')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3e81376bd86fc2e97e4a99ba42803b6')), false);
  await BackendlessUI.Functions.Custom['fn_f1bf64c5c5a6dd6f25dd14c4bf39499e'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c9b3bcff333e518f8799bad6ab25df3a')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9b3bcff333e518f8799bad6ab25df3a')), true);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/addLoad/components/6d6de0728aefd5535b274ee9b82428b7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Home', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/addLoad/components/4eb380a85e211d3438981d8713a69d04/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('Loads'))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split(',').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3315e07ffaa108a893237007b6434e13', true);

  },
  /* handler:onBeforeUpload */
  /* content */
}))

define('./pages/addLoad/components/dbae3f03f9ccd1d3b1abf0ce04e30395/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Submit_Button_Disable;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Image_Loaded')) == true) {
    Submit_Button_Disable = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'submit'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Image_Loaded')) == false) {
    Submit_Button_Disable = true;
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Image_Loaded')) == null) {
    Submit_Button_Disable = false;
  }

  return Submit_Button_Disable

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addLoad/components/96fdb0c5d7f68243be95385b57c51d43/bundle.js', [], () => ({
  /* content */
  /* handler:onLoad */
  onLoad(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Image_Loaded'] = true;

  },
  /* handler:onLoad */
  /* handler:onError */
  onError(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Image_Loaded'] = false;

  },
  /* handler:onError */
  /* content */
}))

define('./pages/addLoad/components/06f413e22d16282dabd22383011a2287/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Selected_Load'] = true;
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('05ab40cdfc6ddef434140a113b0a60fe', (getObjectProperty(___arguments.context.pageData, 'Loads')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ab40cdfc6ddef434140a113b0a60fe', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2e2d8bff51f234c3a5bf1890b765681', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9095a8f9ea788fc3b476924f5083a29c'))['variant'] = 'filled';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a7169894bba68180b91a32c98a7453a'))['variant'] = 'filled';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cea745686bfb55980f5ba16186cd5db'))['variant'] = 'outlined';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addLoad/components/05ab40cdfc6ddef434140a113b0a60fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Item2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Selected_Load'] = ((await Promise.all((await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments.value,'\''].join(''))).setPageSize(10))).map(async item => {; return ({ 'Customer': (await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async Item2 => {; return (getObjectProperty(Item2, 'Customer'));})))[0],'Completion_Status': (getObjectProperty(item, 'Completion_Status')),'delivery_point': (getObjectProperty(item, 'delivery_point')),'Delivery_Point_Mileage': (getObjectProperty(item, 'Delivery_Point_Mileage')),'load_point': (getObjectProperty(item, 'load_point')),'Load_Point_Mileage': (getObjectProperty(item, 'Load_Point_Mileage')),'load_reference': (getObjectProperty(item, 'load_reference')),'Mileage_Differential': (getObjectProperty(item, 'Mileage_Differential')),'Planned_Delivery_Date_Time': (getObjectProperty(item, 'Planned_Delivery_Date_Time')),'Planned_Tonnage': (getObjectProperty(item, 'Planned_Tonnage')),'Product': (getObjectProperty(item, 'Product')),'Split_Load': (getObjectProperty(item, 'Split_Load')),'Split_Load_Load_Number': (getObjectProperty(item, 'Split_Load_Load_Number')),'Split_Load_Reference': (getObjectProperty(item, 'Split_Load_Reference')),'Status': (getObjectProperty(item, 'Status')),'tonnage': (getObjectProperty(item, 'tonnage')),'Tonnage_Differential': (getObjectProperty(item, 'Tonnage_Differential')),'objectId': (getObjectProperty(item, 'objectId')),'value': (getObjectProperty(item, 'objectId')),'label': [(await Promise.all((await Backendless.Data.of('Loads').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Customer').setPageSize(10).setOffset(0))).map(async Item2 => {; return (getObjectProperty(Item2, 'Customer'));})))[0],' - ',(getObjectProperty(item, 'load_reference'))].join('') });})))[0]);
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Completion_Status')) == 0) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Split_Load')) != null) {
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Reference'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Split_Load_Reference'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Load_Number'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Split_Load_Load_Number'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('063bf7dd3583be8e4c0a8b1e87cbdbc2', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db741351834684aa89461f71e5c83506', true);
    }
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Customer'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'load_reference'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'load_point'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load_mileage'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Load_Point_Mileage'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['tonnage'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'tonnage'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'delivery_point'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Delivery_Mileage'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Delivery_Point_Mileage'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Product'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', false);
  } else {
    ___arguments.context.pageData['Item_Disabler'] = true;
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Status')) == null) {
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Customer'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'load_reference'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'load_point'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load_mileage'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Load_Point_Mileage'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['tonnage'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'tonnage'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'delivery_point'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Delivery_Mileage'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Delivery_Point_Mileage'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Load')), 'Product'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2e2d8bff51f234c3a5bf1890b765681', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7203f813b98d99f33dc22364528ea439', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a7169894bba68180b91a32c98a7453a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e856531dcf78b46fc3ee427b33c451f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4eb380a85e211d3438981d8713a69d04', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2bf29f1509d6544b2b4e95c0a889829', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/addLoad/components/fc581819b372b629c2fdc62c197d463b/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Load_Planner')) == null) {
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      Disabler = true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Viewed_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if (Disabler == null) {
      Disabler = false;
    }
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/addLoad/components/d2e2d8bff51f234c3a5bf1890b765681/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['New_Load'] = true;
  ___arguments.context.pageData['New_Load_Handshake'] = true;
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('740b7f86a872d36bf62b05467dcbcca7', (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d2e2d8bff51f234c3a5bf1890b765681', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14713a0d50e8adbfeb2fc07ab90a4e0c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addLoad/components/28a1743c6a47b40427fcaded8e0ba6e1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['New_Customer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Load_Planner')) == null) {
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      Disabler = true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Viewed_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if (Disabler == null) {
      Disabler = false;
    }
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/addLoad/components/87af0188fb652b37bb8611da9363244d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item, New_Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  New_Customer = (await Backendless.Data.of('Tier_2_Customer').save( ({ 'Customer': (getObjectProperty(___arguments.context.pageData, 'New_Customer')),'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) ));
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('740b7f86a872d36bf62b05467dcbcca7', (await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14713a0d50e8adbfeb2fc07ab90a4e0c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('87af0188fb652b37bb8611da9363244d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('740b7f86a872d36bf62b05467dcbcca7', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addLoad/components/aeb80dfac5ded6a5f3649571e713a89e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Load, Driver, error, Customer, Last_Delivered_Mileage, Loads, Load_Trigger;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', false);
  await BackendlessUI.Functions.Custom['fn_0901f308fb0d72f9d34224d34ba4a664'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf5f7a9a2e3a299c3594cd4e0d876831')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cf5f7a9a2e3a299c3594cd4e0d876831')), true);
  Driver = (await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))).setPageSize(10)))[0];
  try {
    Loads = (getObjectProperty(___arguments.context.pageData, 'Loads'))[0];

  } catch (error) {

  }
  try {
    Load_Trigger = (await Backendless.Data.of('Load_Neg').save( ({ 'Load_Planner': (getObjectProperty(Loads, 'Load_Planner')),'Load_Reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'reference')) }) ));

  } catch (error) {

  }
  if ((getObjectProperty(___arguments.context.pageData, 'New_Load')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'New_Load_Handshake')) == true) {
      try {
        console.log('abc');
        Customer = (await Backendless.Data.of('Tier_2_Customer').findById((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), ));
        try {
          Last_Delivered_Mileage = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Delivered_Loads')), 'Delivery_Point_Mileage'));

        } catch (error) {
          console.log(error);

        }
        New_Load = (await Backendless.Data.of('Loads').save( ({ 'Location_Load': (new Backendless.Data.Point().setX((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lng'))).setY((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lat')))),'Last_Delivered_Mileage': Last_Delivered_Mileage,'Customer_Name': (getObjectProperty(Customer, 'Customer')),'Payload': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Payload')),'Product': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Product')),'delivery_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'offload')),'load_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load')),'load_reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'reference')),'tonnage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'tonnage')),'Load_Point_Mileage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load_mileage')),'imageload': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'imageload')),'Status': 'Loaded','Horse_Registration': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Horse_Registration')),'Completion_Status': '0','Planned_Delivery_Date_Time': (new Date()),'Driver': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName')),'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'Contractor_Tonnage_Rate': (getObjectProperty(Driver, 'Contractor_Tonnage_Rate')),'Tonnage_Target_Rate': (getObjectProperty(Driver, 'Tonnage_Target_Rate')) }) ));
        console.log('abc');
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_1', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_1')));
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_2', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_2')));
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_3', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_3')));
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Customer', [(getObjectProperty(___arguments.context.pageData, 'Selected_Customer'))]);
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [(getObjectProperty(___arguments.context.pageData, 'Horse'))]);
        console.log('abc');
        ___arguments.context.pageData['New_Load_Handshake'] = false;
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Post', undefined);

      } catch (error) {
        console.log(error);

      }
    } else {
      try {
        Customer = (await Backendless.Data.of('Tier_2_Customer').findById((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), ));
        New_Load = (await Backendless.Data.of('Loads').save( ({ 'Location_Load': (new Backendless.Data.Point().setX((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lng'))).setY((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lat')))),'Last_Delivered_Mileage': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Delivered_Loads')), 'Delivery_Point_Mileage')),'Customer_Name': (getObjectProperty(Customer, 'Customer')),'Payload': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Payload')),'Product': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Product')),'delivery_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'offload')),'load_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load')),'load_reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'reference')),'tonnage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'tonnage')),'Load_Point_Mileage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load_mileage')),'imageload': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'imageload')),'Status': 'Loaded','Horse_Registration': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Horse_Registration')),'Completion_Status': '0','Planned_Delivery_Date_Time': (new Date()),'Driver': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'displayName')),'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'Contractor_Tonnage_Rate': (getObjectProperty(Driver, 'Contractor_Tonnage_Rate')),'Tonnage_Target_Rate': (getObjectProperty(Driver, 'Tonnage_Target_Rate')) }) ));
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_1', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_1')));
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_2', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_2')));
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_3', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_3')));
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Customer', [(getObjectProperty(___arguments.context.pageData, 'Selected_Customer'))]);
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [(getObjectProperty(___arguments.context.pageData, 'Horse'))]);
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Post', undefined);

      } catch (error) {
        console.log(error);

      }
    }
  } else {
    New_Load = (getObjectProperty(___arguments.context.pageData, 'Loads'))[0];
    console.log('ghvgjvjhgv');
    if ((getObjectProperty(New_Load, 'Service')) == 'Yes') {
      console.log('abc');
      New_Load['Load_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load_mileage'));
      New_Load['Completion_Status'] = 0;
      New_Load['Status'] = 'Loaded';
      await Backendless.Data.of('Loads').save( New_Load );
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Post', undefined);
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'Viewed_Load')) == true) {
        if ((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')) == null) {
          ___arguments.context.pageData['Selected_Customer'] = ((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['Customer = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Customer_View')),'\''].join(''))).setPageSize(10)))[0]);
        }
        New_Load = (getObjectProperty(___arguments.context.pageData, 'Loads'))[0];
        if ((getObjectProperty(New_Load, 'Split_delivery')) == 'Load') {
          await Backendless.Data.of('Loads').bulkUpdate( (['Split_Load_Reference = \'',(getObjectProperty(New_Load, 'Split_Load_Reference')),'\''].join('')), ({ 'Status': 'Loaded' }) );
          console.log('1');
          New_Load['Planned_Delivery_Date_Time'] = null;
          New_Load['tonnage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'tonnage'));
          New_Load['Contractor_Tonnage_Rate'] = (getObjectProperty(Driver, 'Contractor_Tonnage_Rate'));
          New_Load['Tonnage_Target_Rate'] = (getObjectProperty(Driver, 'Tonnage_Target_Rate'));
          console.log('2');
          New_Load['Load_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load_mileage'));
          New_Load['Status'] = 'Loaded';
          console.log('3');
          New_Load['Completion_Status'] = '0';
          try {
            New_Load['imageload'] = (new Backendless.Data.Point().setX((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lng'))).setY((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lat'))));

          } catch (error) {
            console.log(error);

          }
          New_Load['Location_Load'] = (new Backendless.Data.Point().setX((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lng'))).setY((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lat'))));
          await Backendless.Data.of('Loads').save( New_Load );
          console.log('4');
          await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_1', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_1')));
          await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_2', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_2')));
          await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_3', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_3')));
          console.log('5');
          try {
            await Backendless.Data.of('Loads').setRelation(New_Load, 'Customer', [(getObjectProperty(___arguments.context.pageData, 'Selected_Customer'))]);

          } catch (error) {

          }
          await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [(getObjectProperty(___arguments.context.pageData, 'Horse'))]);
          console.log('6');
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Post', undefined);
        } else {
          New_Load['tonnage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'tonnage'));
          New_Load['Location_Load'] = (new Backendless.Data.Point().setX((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lng'))).setY((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lat'))));
          New_Load['Load_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load_mileage'));
          New_Load['Contractor_Tonnage_Rate'] = (getObjectProperty(Driver, 'Contractor_Tonnage_Rate'));
          New_Load['Tonnage_Target_Rate'] = (getObjectProperty(Driver, 'Tonnage_Target_Rate'));
          New_Load['Status'] = 'Loaded';
          New_Load['Horse_Registration'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Horse_Registration'));
          New_Load['Completion_Status'] = '0';
          New_Load['Planned_Delivery_Date_Time'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Next_Load')), 'Planned_Delivery'));
          console.log([(getObjectProperty(___arguments.context.pageData, 'Selected_Customer'))]);
          console.log(New_Load);
          await Backendless.Data.of('Loads').save( New_Load );
          await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_1', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_1')));
          await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_2', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_2')));
          await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_3', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_3')));
          await Backendless.Data.of('Loads').setRelation(New_Load, 'Customer', [(getObjectProperty(___arguments.context.pageData, 'Selected_Customer'))]);
          await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [(getObjectProperty(___arguments.context.pageData, 'Horse'))]);
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Post', undefined);
        }
      } else {
        if ((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')) == null) {
          ___arguments.context.pageData['Selected_Customer'] = ((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['Customer = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Customer_View')),'\''].join(''))).setPageSize(10)))[0]);
        }
        console.log([(getObjectProperty(___arguments.context.pageData, 'Selected_Customer'))]);
        New_Load = (await Backendless.Data.of('Loads').save( ({ 'Location_Load': (new Backendless.Data.Point().setX((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lng'))).setY((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lat')))),'load_reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'reference')),'Horse_Registration': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Horse_Registration')),'load_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load')),'tonnage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'tonnage')),'Status': 'Loaded','Product': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Product')),'Load_Point_Mileage': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load_mileage')),'delivery_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'offload')),'Completion_Status': '0','Contractor_Tonnage_Rate': (getObjectProperty(Driver, 'Contractor_Tonnage_Rate')),'Tonnage_Target_Rate': (getObjectProperty(Driver, 'Tonnage_Target_Rate')) }) ));
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_1', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_1')));
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_2', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_2')));
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Trailer_3', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Trailer_3')));
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Customer', [(getObjectProperty(___arguments.context.pageData, 'Selected_Customer'))]);
        await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [(getObjectProperty(___arguments.context.pageData, 'Horse'))]);
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Post', undefined);
      }
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Disabler = 'Submit Load';
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'Service At') {
    Disabler = 'Start Service';
  }

  return Disabler

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/addLoad/components/f52ff789f2e755c6f5b9cfdad9392748/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Mileage_Check'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load_mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')));
  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Mileage_Check')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Mileage_Check')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a2ec28eb08710031eb6643f2813a109', true);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Mileage_Check')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Mileage_Check')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a2ec28eb08710031eb6643f2813a109', false);
  }

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Load_Planner')) == null) {
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      Disabler = true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Viewed_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'Service At') {
        Disabler = false;
      } else {
        Disabler = true;
      }
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = false;
      } else {
        Disabler = true;
      }
    }
    if (Disabler == null) {
      Disabler = false;
    }
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/addLoad/components/34e4288c8c8c135741a9afeb1a1eca82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('740b7f86a872d36bf62b05467dcbcca7', (addItemToList((await Promise.all((await Backendless.Data.of('Tier_2_Customer').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Customer').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Customer')) });}))), ({ 'value': 'Add New Customer','label': 'Add New Customer' }))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14713a0d50e8adbfeb2fc07ab90a4e0c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('740b7f86a872d36bf62b05467dcbcca7', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addLoad/components/78060035fbb4078c1c349ecc2ebd7f85/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Load_Planner')) == null) {
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      Disabler = true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Viewed_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if (Disabler == null) {
      Disabler = false;
    }
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/addLoad/components/503c38068acb2d2b908a4ca5fdecfd9f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Load_Planner')) == null) {
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      Disabler = true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Viewed_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if (Disabler == null) {
      Disabler = false;
    }
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/addLoad/components/2cea745686bfb55980f5ba16186cd5db/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Load_Planner')) == null) {
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      Disabler = true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Viewed_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = false;
      } else {
        Disabler = true;
      }
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = false;
      } else {
        Disabler = true;
      }
    }
    if (Disabler == null) {
      Disabler = false;
    }
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Tonnage_Target')), 'Tonnage_Override')) == null) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'tonnage')) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Tonnage_Target')), 'Permissible_Tonnage')) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Tonnage_Target')), 'Load_Tolerance'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8a43e23557fd0ccf67115213a9ede06d', true);
      ___arguments.context.pageData['Tonnage_Locker'] = true;
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8a43e23557fd0ccf67115213a9ede06d', false);
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'tonnage')) > (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Tonnage_Target')), 'Tonnage_Override')) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Tonnage_Target')), 'Load_Tolerance'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8a43e23557fd0ccf67115213a9ede06d', true);
      ___arguments.context.pageData['Tonnage_Locker'] = true;
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8a43e23557fd0ccf67115213a9ede06d', false);
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/addLoad/components/c2bf29f1509d6544b2b4e95c0a889829/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Load, Next_Load, New_Load, Loads, Load_Trigger, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2bf29f1509d6544b2b4e95c0a889829', false);
  await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b3e81376bd86fc2e97e4a99ba42803b6')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b3e81376bd86fc2e97e4a99ba42803b6')), false, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cf5f7a9a2e3a299c3594cd4e0d876831')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf5f7a9a2e3a299c3594cd4e0d876831')), true);
  try {
    Loads = (getObjectProperty(___arguments.context.pageData, 'Loads'))[0];

  } catch (error) {

  }
  try {
    Load_Trigger = (await Backendless.Data.of('Load_Neg').save( ({ 'Load_Planner': (getObjectProperty(Loads, 'Load_Planner')),'Load_Reference': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'reference')) }) ));

  } catch (error) {

  }
  New_Load = (getObjectProperty(___arguments.context.pageData, 'Loads'))[0];
  if ((getObjectProperty(New_Load, 'Service')) == 'Yes') {
    New_Load['Load_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'load_mileage'));
    New_Load['Completion_Status'] = 1;
    New_Load['Status'] = 'Delivered';
    New_Load['Delivery_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage'));
    await Backendless.Data.of('Loads').save( New_Load );
    try {
      (getObjectProperty(___arguments.context.pageData, 'Horse'))['Last_Delivery_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage'));
      await Backendless.Data.of('Vehicles').save( (getObjectProperty(___arguments.context.pageData, 'Horse')) );

    } catch (error) {
      console.log(error);

    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Viewed_Load')) == true) {
      if ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Loads'))[0]), 'Planned_Delivery_Date_Time')) == null) {
        Next_Load = (getObjectProperty(___arguments.context.pageData, 'Loads'))[1];
        if ((getObjectProperty(Next_Load, 'Split_delivery')) == 'Yes') {
          await Backendless.Data.of('Loads').bulkUpdate( (['Split_Load_Reference = \'',(getObjectProperty(Next_Load, 'Split_Load_Reference')),'\' AND Split_delivery = \'Load\''].join('')), ({ 'Completion_Status': 1 }) );
        }
        Next_Load['Completion_Status'] = '1';
        Next_Load['Last_Delivered_Mileage'] = (getObjectProperty(___arguments.context.pageData, 'Last_Delivered_Mileage'));
        Next_Load['Location_Delivery'] = (new Backendless.Data.Point().setX((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lng'))).setY((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lat'))));
        try {
          Next_Load['image'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'image'));

        } catch (error) {

        }
        try {
          Next_Load['image1'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('98a41a27ebf88258090b14b73e46dda2'))[0]), 'image'));

        } catch (error) {

        }
        try {
          Next_Load['image2'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('98a41a27ebf88258090b14b73e46dda2'))[1]), 'image'));

        } catch (error) {

        }
        try {
          Next_Load['image3'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('98a41a27ebf88258090b14b73e46dda2')).slice(-1)[0]), 'image'));

        } catch (error) {

        }
        Next_Load['Status'] = 'Delivered';
        Next_Load['tonnage_Delivery'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Tonnage'));
        Next_Load['Delivery_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage'));
        Next_Load['Mileage_Differential'] = (Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage')) - (getObjectProperty(Next_Load, 'Load_Point_Mileage'))) * 1000) / 1000);
        Next_Load['Mileage_GainLoss'] = (Math.round(((getObjectProperty(Next_Load, 'mileage')) * (getObjectProperty(Next_Load, 'Rate_Per_Km')) - ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage')) - (getObjectProperty(Next_Load, 'Load_Point_Mileage'))) * (getObjectProperty(Next_Load, 'Rate_Per_Km'))) * 1000) / 1000);
        await Backendless.Data.of('Loads').save( Next_Load );
        try {
          (getObjectProperty(___arguments.context.pageData, 'Horse'))['Last_Delivery_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage'));
          await Backendless.Data.of('Vehicles').save( (getObjectProperty(___arguments.context.pageData, 'Horse')) );

        } catch (error) {
          console.log(error);

        }
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
      } else {
        Next_Load = (getObjectProperty(___arguments.context.pageData, 'Loads'))[0];
        if ((getObjectProperty(Next_Load, 'Split_delivery')) == 'Yes') {
          await Backendless.Data.of('Loads').bulkUpdate( (['Split_Load_Reference = \'',(getObjectProperty(Next_Load, 'Split_Load_Reference')),'\' And Split_delivery = \'Load\''].join('')), ({ 'Completion_Status': 1 }) );
        }
        Next_Load['Completion_Status'] = '1';
        try {
          Next_Load['image'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'image'));

        } catch (error) {

        }
        try {
          Next_Load['image1'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('98a41a27ebf88258090b14b73e46dda2'))[0]), 'image'));

        } catch (error) {

        }
        try {
          Next_Load['image2'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('98a41a27ebf88258090b14b73e46dda2'))[1]), 'image'));

        } catch (error) {

        }
        try {
          Next_Load['image3'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('98a41a27ebf88258090b14b73e46dda2')).slice(-1)[0]), 'image'));

        } catch (error) {

        }
        Next_Load['Status'] = 'Delivered';
        Next_Load['tonnage_Delivery'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Tonnage'));
        Next_Load['Delivery_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage'));
        Next_Load['Mileage_GainLoss'] = (Math.round(((getObjectProperty(Next_Load, 'mileage')) * (getObjectProperty(Next_Load, 'Rate_Per_Km')) - ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage')) - (getObjectProperty(Next_Load, 'Load_Point_Mileage'))) * (getObjectProperty(Next_Load, 'Rate_Per_Km'))) * 1000) / 1000);
        Next_Load['Mileage_Differential'] = (Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage')) - (getObjectProperty(Next_Load, 'Load_Point_Mileage'))) * 1000) / 1000);
        try {
          (getObjectProperty(___arguments.context.pageData, 'Horse'))['Last_Delivery_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage'));
          await Backendless.Data.of('Vehicles').save( (getObjectProperty(___arguments.context.pageData, 'Horse')) );

        } catch (error) {
          console.log(error);

        }
        await Backendless.Data.of('Loads').save( Next_Load );
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
      }
    } else {
      Selected_Load = (getObjectProperty(___arguments.context.pageData, 'Selected_Load'));
      Selected_Load['Completion_Status'] = '1';
      Selected_Load['Status'] = 'Delivered';
      Selected_Load['Location_Delivery'] = (new Backendless.Data.Point().setX((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lng'))).setY((getObjectProperty((await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })()), 'lat'))));
      try {
        Selected_Load['image'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'image'));

      } catch (error) {

      }
      try {
        Selected_Load['image1'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('98a41a27ebf88258090b14b73e46dda2'))[0]), 'image'));

      } catch (error) {

      }
      try {
        Selected_Load['image2'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('98a41a27ebf88258090b14b73e46dda2'))[1]), 'image'));

      } catch (error) {

      }
      try {
        Selected_Load['image3'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('98a41a27ebf88258090b14b73e46dda2')).slice(-1)[0]), 'image'));

      } catch (error) {

      }
      Selected_Load['Last_Delivered_Mileage'] = (getObjectProperty(___arguments.context.pageData, 'Last_Delivered_Mileage'));
      Selected_Load['tonnage_Delivery'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Tonnage'));
      Selected_Load['Delivery_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage'));
      Selected_Load['Mileage_Differential'] = (Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage')) - (getObjectProperty(Selected_Load, 'load_mileage'))) * 1000) / 1000);
      try {
        Selected_Load['Mileage_GainLoss'] = (Math.round(((getObjectProperty(Next_Load, 'mileage')) * (getObjectProperty(Next_Load, 'Rate_Per_Km')) - ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage')) - (getObjectProperty(Next_Load, 'Load_Point_Mileage'))) * (getObjectProperty(Next_Load, 'Rate_Per_Km'))) * 1000) / 1000);

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.pageData, 'Horse'))['Last_Delivery_Point_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage'));
        await Backendless.Data.of('Vehicles').save( (getObjectProperty(___arguments.context.pageData, 'Horse')) );

      } catch (error) {
        console.log(error);

      }
      Selected_Load['delivery_point'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'offload'));
      await Backendless.Data.of('Loads').save( Selected_Load );
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2bf29f1509d6544b2b4e95c0a889829', true);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'Complete Service') {
    Disabler = false;
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Image_Loaded')) == true && (getObjectProperty(___arguments.context.pageData, 'Del_Mileage_Enabler')) == true) {
      Disabler = false;
    } else {
      Disabler = true;
    }
  }

  return Disabler

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Disabler = 'Offload';
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'Complete Service') {
    Disabler = 'Complete Service';
  }

  return Disabler

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/addLoad/components/5a7169894bba68180b91a32c98a7453a/bundle.js', [], () => ({
  /* content */
  /* handler:onRequiredStateAssignment */
  onRequiredStateAssignment(___arguments) {
    var Required;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Item_Disabler')) == true) {
    Required = true;
  } else {
    Required = false;
  }

  return Required

  },
  /* handler:onRequiredStateAssignment */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Mileage_Check'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Delivery_Mileage')) - (getObjectProperty(___arguments.context.pageData, 'Reflected_Mileage')));
  if (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Mileage_Check')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Mileage_Check')) >= 0)) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Incompatible Mileage';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79c516f4c294ab7bb0f6694770d2802', true);
    ___arguments.context.pageData['Del_Mileage_Enabler'] = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Mileage_Check')) <= 1500 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Mileage_Check')) >= 0) {
    ___arguments.context.pageData['Incompatible_Mileage'] = 'Compatible Mileage';
    ___arguments.context.pageData['Del_Mileage_Enabler'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a79c516f4c294ab7bb0f6694770d2802', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/addLoad/components/65b528e1df47cdf58a36b74f1f26fffb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var Next_Load;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Load'] = true;
  Next_Load = (getObjectProperty(___arguments.context.pageData, 'Loads'))[0];
  ___arguments.context.pageData['Viewed_Next_Load'] = ((getObjectProperty(___arguments.context.pageData, 'Loads'))[0]);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f52ff789f2e755c6f5b9cfdad9392748'))['variant'] = 'outlined';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cea745686bfb55980f5ba16186cd5db'))['variant'] = 'outlined';
  if ((getObjectProperty(Next_Load, 'Status')) == null) {
    if ((getObjectProperty(Next_Load, 'Split_Load')) == 'Yes') {
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Reference'] = (getObjectProperty(Next_Load, 'Split_Load_Reference'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Load_Number'] = (getObjectProperty(Next_Load, 'Split_Load_Load_Number'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
      console.log(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time'))));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('063bf7dd3583be8e4c0a8b1e87cbdbc2', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db741351834684aa89461f71e5c83506', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('805e32463ef291f11eed20717acc8967', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f52ff789f2e755c6f5b9cfdad9392748'))['variant'] = 'outlined';
    }
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Load_Del'] = 'To Load';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68df3a0bb0e3a81c53b7dd2e88a484fb', true);
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('805e32463ef291f11eed20717acc8967', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
  } else {
    if ((getObjectProperty(Next_Load, 'Split_Load')) == 'Yes') {
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Reference'] = (getObjectProperty(Next_Load, 'Split_Load_Reference'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Load_Number'] = (getObjectProperty(Next_Load, 'Split_Load_Load_Number'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
      console.log(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time'))));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('063bf7dd3583be8e4c0a8b1e87cbdbc2', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db741351834684aa89461f71e5c83506', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('805e32463ef291f11eed20717acc8967', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f52ff789f2e755c6f5b9cfdad9392748'))['variant'] = 'outlined';
    }
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Load_Del'] = 'To Deliver';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68df3a0bb0e3a81c53b7dd2e88a484fb', true);
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['tonnage'] = (getObjectProperty(Next_Load, 'tonnage'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cea745686bfb55980f5ba16186cd5db'))['variant'] = 'filled';
    ___arguments.context.pageData['tonnage_Disabler'] = true;
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
    ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a7169894bba68180b91a32c98a7453a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2bf29f1509d6544b2b4e95c0a889829', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4eb380a85e211d3438981d8713a69d04', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a7169894bba68180b91a32c98a7453a'))['variant'] = 'outlined';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addLoad/components/740b7f86a872d36bf62b05467dcbcca7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Add New Customer') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('740b7f86a872d36bf62b05467dcbcca7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14713a0d50e8adbfeb2fc07ab90a4e0c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('87af0188fb652b37bb8611da9363244d', true);
  } else {
    ___arguments.context.pageData['Selected_Customer'] = ___arguments.value;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('805e32463ef291f11eed20717acc8967', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/addLoad/components/9095a8f9ea788fc3b476924f5083a29c/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    var Disabler;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Load_Planner')) == null) {
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      Disabler = false;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Viewed_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if ((getObjectProperty(___arguments.context.pageData, 'Selected_Load')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e'), 'Load_Del')) == 'To Load') {
        Disabler = true;
      } else {
        Disabler = true;
      }
    }
    if (Disabler == null) {
      Disabler = false;
    }
  }

  return Disabler

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/addLoad/components/a2bbd2ce5499c17d6c5e9677ccda9766/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var Last_Load, Next_Load, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Load_Planner')) == true) {
    if ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Loads'))[0]), 'Planned_Delivery_Date_Time')) == null) {
      ___arguments.context.pageData['Viewed_Load'] = true;
      Next_Load = (getObjectProperty(___arguments.context.pageData, 'Loads'))[1];
      ___arguments.context.pageData['Viewed_Next_Load'] = ((getObjectProperty(___arguments.context.pageData, 'Loads'))[1]);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f52ff789f2e755c6f5b9cfdad9392748'))['variant'] = 'outlined';
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cea745686bfb55980f5ba16186cd5db'))['variant'] = 'outlined';
      if ((getObjectProperty(Next_Load, 'Service')) == 'Yes') {
        if ((getObjectProperty(Next_Load, 'Completion_Status')) == 0) {
          if ((getObjectProperty(Next_Load, 'Status')) == 'Loaded') {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68df3a0bb0e3a81c53b7dd2e88a484fb', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dfe7baf4ee2ebeb2b9a4771e013da574', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51157a7c0e074af947b863661a73fdcc', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2bf29f1509d6544b2b4e95c0a889829', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a7169894bba68180b91a32c98a7453a', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7203f813b98d99f33dc22364528ea439', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e856531dcf78b46fc3ee427b33c451f', true);
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Description'] = (String('Notes: ') + String(getObjectProperty(Next_Load, 'Description')));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Load_Del'] = 'Complete Service';
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
          } else {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68df3a0bb0e3a81c53b7dd2e88a484fb', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51157a7c0e074af947b863661a73fdcc', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('805e32463ef291f11eed20717acc8967', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dfe7baf4ee2ebeb2b9a4771e013da574', true);
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Description'] = (String('Notes: ') + String(getObjectProperty(Next_Load, 'Description')));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Load_Del'] = 'Service At';
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
          }
        }
      } else {
        if ((getObjectProperty(Next_Load, 'Status')) == null) {
          if ((getObjectProperty(Next_Load, 'Split_Load')) == 'Yes') {
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Reference'] = (getObjectProperty(Next_Load, 'Split_Load_Reference'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Load_Number'] = (getObjectProperty(Next_Load, 'Split_Load_Load_Number'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('063bf7dd3583be8e4c0a8b1e87cbdbc2', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db741351834684aa89461f71e5c83506', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
            ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f52ff789f2e755c6f5b9cfdad9392748'))['variant'] = 'outlined';
          }
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Load_Del'] = 'To Load';
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68df3a0bb0e3a81c53b7dd2e88a484fb', true);
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('805e32463ef291f11eed20717acc8967', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
        } else {
          if ((getObjectProperty(Next_Load, 'Service')) == 'Yes') {
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
          } else {
            if ((getObjectProperty(Next_Load, 'Split_Load')) == 'Yes') {
              ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
              ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
              ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
              ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Reference'] = (getObjectProperty(Next_Load, 'Split_Load_Reference'));
              ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Load_Number'] = (getObjectProperty(Next_Load, 'Split_Load_Load_Number'));
              ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
              ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
              ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
              ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
              console.log(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time'))));
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('063bf7dd3583be8e4c0a8b1e87cbdbc2', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db741351834684aa89461f71e5c83506', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('805e32463ef291f11eed20717acc8967', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
              ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f52ff789f2e755c6f5b9cfdad9392748'))['variant'] = 'outlined';
            }
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Load_Del'] = 'To Deliver';
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68df3a0bb0e3a81c53b7dd2e88a484fb', true);
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['tonnage'] = (getObjectProperty(Next_Load, 'tonnage'));
            ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cea745686bfb55980f5ba16186cd5db'))['variant'] = 'filled';
            ___arguments.context.pageData['tonnage_Disabler'] = true;
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', false);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', false);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a7169894bba68180b91a32c98a7453a', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2bf29f1509d6544b2b4e95c0a889829', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4eb380a85e211d3438981d8713a69d04', true);
            ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a7169894bba68180b91a32c98a7453a'))['variant'] = 'outlined';
          }
        }
      }
    } else {
      ___arguments.context.pageData['Viewed_Load'] = true;
      Next_Load = (getObjectProperty(___arguments.context.pageData, 'Loads'))[0];
      Last_Load = (getObjectProperty(___arguments.context.pageData, 'Old_Load'));
      try {
        Next_Load['Last_Delivered_Mileage'] = (getObjectProperty(Last_Load, 'Delivery_Point_Mileage'));
        ___arguments.context.pageData['Last_Delivered_Mileage'] = (getObjectProperty(Last_Load, 'Delivery_Point_Mileage'));

      } catch (error) {
        console.log(error);

      } finally {
        if (error) {
          Next_Load['Last_Delivered_Mileage'] = 0;
          ___arguments.context.pageData['Last_Delivered_Mileage'] = 0;
        }

      }
      ___arguments.context.pageData['Viewed_Next_Load'] = ((getObjectProperty(___arguments.context.pageData, 'Loads'))[0]);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f52ff789f2e755c6f5b9cfdad9392748'))['variant'] = 'outlined';
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cea745686bfb55980f5ba16186cd5db'))['variant'] = 'outlined';
      if ((getObjectProperty(Next_Load, 'Service')) == 'Yes') {
        if ((getObjectProperty(Next_Load, 'Completion_Status')) == 0) {
          if ((getObjectProperty(Next_Load, 'Status')) == 'Loaded') {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68df3a0bb0e3a81c53b7dd2e88a484fb', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51157a7c0e074af947b863661a73fdcc', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2bf29f1509d6544b2b4e95c0a889829', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a7169894bba68180b91a32c98a7453a', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7203f813b98d99f33dc22364528ea439', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e856531dcf78b46fc3ee427b33c451f', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dfe7baf4ee2ebeb2b9a4771e013da574', true);
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Description'] = (String('Notes: ') + String(getObjectProperty(Next_Load, 'Description')));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Load_Del'] = 'Complete Service';
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
          } else {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68df3a0bb0e3a81c53b7dd2e88a484fb', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51157a7c0e074af947b863661a73fdcc', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dfe7baf4ee2ebeb2b9a4771e013da574', true);
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Description'] = (String('Notes: ') + String(getObjectProperty(Next_Load, 'Description')));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Load_Del'] = 'Service At';
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
          }
        }
      } else {
        if ((getObjectProperty(Next_Load, 'Status')) == null) {
          if ((getObjectProperty(Next_Load, 'Split_Load')) == 'Yes') {
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Reference'] = (getObjectProperty(Next_Load, 'Split_Load_Reference'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Load_Number'] = (getObjectProperty(Next_Load, 'Split_Load_Load_Number'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('063bf7dd3583be8e4c0a8b1e87cbdbc2', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db741351834684aa89461f71e5c83506', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
            ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f52ff789f2e755c6f5b9cfdad9392748'))['variant'] = 'outlined';
          }
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Load_Del'] = 'To Load';
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68df3a0bb0e3a81c53b7dd2e88a484fb', true);
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('805e32463ef291f11eed20717acc8967', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
        } else {
          if ((getObjectProperty(Next_Load, 'Split_Load')) == 'Yes') {
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Reference'] = (getObjectProperty(Next_Load, 'Split_Load_Reference'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Split_Load_Load_Number'] = (getObjectProperty(Next_Load, 'Split_Load_Load_Number'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
            ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('063bf7dd3583be8e4c0a8b1e87cbdbc2', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db741351834684aa89461f71e5c83506', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('805e32463ef291f11eed20717acc8967', true);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', true);
            ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f52ff789f2e755c6f5b9cfdad9392748'))['variant'] = 'outlined';
          }
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Load_Del'] = 'To Deliver';
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('68df3a0bb0e3a81c53b7dd2e88a484fb', true);
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['tonnage'] = (getObjectProperty(Next_Load, 'tonnage'));
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cea745686bfb55980f5ba16186cd5db'))['variant'] = 'filled';
          ___arguments.context.pageData['tonnage_Disabler'] = true;
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Customer_View'] = (getObjectProperty(Next_Load, 'Customer'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['date'] = (String(new Date((getObjectProperty(Next_Load, 'Planned_Delivery_Date_Time')))).slice(0, 24));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['reference'] = (getObjectProperty(Next_Load, 'load_reference'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['load'] = (getObjectProperty(Next_Load, 'load_point'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Product'] = (getObjectProperty(Next_Load, 'Product'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['offload'] = (getObjectProperty(Next_Load, 'delivery_point'));
          ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['planned_tonnage'] = (getObjectProperty(Next_Load, 'Planned_Tonnage'));
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65b528e1df47cdf58a36b74f1f26fffb', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('06f413e22d16282dabd22383011a2287', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e7378016cc546170b059e9c34cd5a25', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('28a1743c6a47b40427fcaded8e0ba6e1', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc581819b372b629c2fdc62c197d463b', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78060035fbb4078c1c349ecc2ebd7f85', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('503c38068acb2d2b908a4ca5fdecfd9f', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2cea745686bfb55980f5ba16186cd5db', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f52ff789f2e755c6f5b9cfdad9392748', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9095a8f9ea788fc3b476924f5083a29c', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd789d16fbda7efc3ae2f701df4c941b', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aeb80dfac5ded6a5f3649571e713a89e', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a7169894bba68180b91a32c98a7453a', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e856531dcf78b46fc3ee427b33c451f', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7203f813b98d99f33dc22364528ea439', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2bf29f1509d6544b2b4e95c0a889829', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4eb380a85e211d3438981d8713a69d04', true);
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a7169894bba68180b91a32c98a7453a'))['variant'] = 'outlined';
        }
      }
    }
  }

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/addLoad/components/3315e07ffaa108a893237007b6434e13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4eb380a85e211d3438981d8713a69d04');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addLoad/components/7e856531dcf78b46fc3ee427b33c451f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Multiple Image Select View')) == true) {
    ___arguments.context.pageData['Multiple Image Select View'] = false;
  } else {
    ___arguments.context.pageData['Multiple Image Select View'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addLoad/components/71a4238c44235e99bb4be905b541456d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Multiple Image Select View')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/addLoad/components/64753ce434cba7eab11760038f2b2fd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list, Number2, Object2, Repeater_List;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Number2 = 0;
  Repeater_List = [];
  var repeat_end = ___arguments.value;
  for (var count = 0; count < repeat_end; count++) {
    Number2 = Number2 + 1;
    Object2 = ({ 'Image Number': String('Image ') + String(Number2) });
    addItemToList(Repeater_List, Object2);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('98a41a27ebf88258090b14b73e46dda2', Repeater_List);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/addLoad/components/e2416f0e6f07e7f32c6f1aba443e2aaf/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('Loads'))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split(',').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/addLoad/components/c53ffa74e63a076ed8357571cb1e3e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('e2416f0e6f07e7f32c6f1aba443e2aaf');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/addLoad/components/7173568c6e4531ee947e160a928b7d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onLoad */
  ['onLoad'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Imageload_Loaded'] = true;

  },
  /* handler:onLoad */
  /* handler:onError */
  ['onError'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('0fec6c027fd1aa122d3e05e33ff8922e')['Image_Loaded'] = false;

  },
  /* handler:onError */
  /* content */
}))

define('./pages/addLoad/components/c44f603bb76892398b0c2197f58febb3/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('Loads'))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split(',').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  ['onBeforeUpload'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ebd7e4a35785a2191f47e2a7b5aef231', true);

  },
  /* handler:onBeforeUpload */
  /* content */
}))

define('./pages/addLoad/components/ebd7e4a35785a2191f47e2a7b5aef231/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('c44f603bb76892398b0c2197f58febb3');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser;


  ___arguments.context.pageData['EULA'] = false;
  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if (currentUser) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
  }
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d9c356e580c317f851756188ec14ee9f')));
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d9c356e580c317f851756188ec14ee9f')));

  },
  /* handler:onEnter *//* content */
}));

define('./pages/login/components/8aae761907cbcf4a7b876b6178a9d27e/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0deea665b809587ae836ee53f9d38bd2')));

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/login/components/52cacce32bd47b066d06f61f20bff7a6/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, Device_Registration, redirectToFollowersPostsPage, password, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  email = (getObjectProperty(___arguments.context.dataModel, 'email')).trim();
  password = (getObjectProperty(___arguments.context.dataModel, 'password')).trim();
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('6cb26a84965de01223cefd0cd256f861')), 'isLogging')) && email && password) {
    ___arguments.context.getComponentDataStoreByUid('6cb26a84965de01223cefd0cd256f861')['isLogging'] = true;
    ___arguments.context.getComponentDataStoreByUid('6cb26a84965de01223cefd0cd256f861')['signInError'] = null;
    try {
      ___arguments.context.appData['currentUser'] = (await Backendless.UserService.login( email, password, true  ));
      redirectToFollowersPostsPage = true;

    } catch (error) {
      ___arguments.context.getComponentDataStoreByUid('6cb26a84965de01223cefd0cd256f861')['signInError'] = (getObjectProperty(error, 'message'));

    }
    ___arguments.context.getComponentDataStoreByUid('6cb26a84965de01223cefd0cd256f861')['isLogging'] = false;
    if (redirectToFollowersPostsPage) {
      if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'User_level')) == 'Global') {
        if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'Account_Type')) == 'Com') {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Data_Com', undefined);
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Data_Agri', undefined);
        }
      }
      ___arguments.context.appData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
      if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'T_C_Privacy_Policy_Agreement')) == true) {
        ___arguments.context.appData['Director_User'] = (await Backendless.Data.of('Users').findById((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'ownerId')), ));
        try {
          ___arguments.context.appData['Employee_User'] = ((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'objectId')),'\''].join(''))).setPageSize(10)))[0]);

        } catch (error) {
          console.log(error);

        }
        if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Director_User')), 'userStatus')) == 'DISABLED') {
          ___arguments.context.appData['Blocked'] = true;
          await Backendless.UserService.logout();
        } else {
          if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'Account_Type')) == 'Com') {
            if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'Third_Party_Tyre_Manager')) != null) {
              (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Third_Party_Tyre_Operator', undefined);
            } else {
              try {
                Device_Registration = (await ( async function (channels) { return BackendlessUI.DeviceAPI.registerDevice(channels) })('default '));
                Device_Registration['Current_Truck'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'Currently_Aboard'));
                Device_Registration['User_Company'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Director_User')), 'Customer'));
                Device_Registration['User_Name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'Call_Sign'));
                Device_Registration['User_ownerId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'ownerId'));
                Device_Registration['ownerId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'ownerId'));
                console.log(Device_Registration);
                await Backendless.Data.of('Device Registration').save( Device_Registration );

              } catch (error) {
                console.log(error);

              }
              (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
            }
          } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'Account_Type')) == 'Agri') {
            try {
              Device_Registration = (await ( async function (channels) { return BackendlessUI.DeviceAPI.registerDevice(channels) })('default '));
              Device_Registration['User_Company'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Director_User')), 'Customer'));
              Device_Registration['User_Name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'Call_Sign'));
              Device_Registration['User_ownerId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'ownerId'));
              Device_Registration['ownerId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'ownerId'));
              console.log(Device_Registration);
              await Backendless.Data.of('Device Registration').save( Device_Registration );

            } catch (error) {
              console.log(error);

            }
            (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home_Agri', undefined);
          } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'Account_Type')) == 'Log') {
            try {
              Device_Registration = (await ( async function (channels) { return BackendlessUI.DeviceAPI.registerDevice(channels) })('default '));
              Device_Registration['User_Company'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Director_User')), 'Customer'));
              Device_Registration['User_Name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'Call_Sign'));
              Device_Registration['User_ownerId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'ownerId'));
              Device_Registration['ownerId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'ownerId'));
              console.log(Device_Registration);
              await Backendless.Data.of('Device Registration').save( Device_Registration );

            } catch (error) {
              console.log(error);

            }
            (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home_Log', undefined);
          }
        }
      } else {
        ___arguments.context.pageData['T_C_Privacy_Policy_Agreement_Viewer'] = true;
      }
    }
  }

  },
  /* handler:onSubmit *//* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Reset_Viewer')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}));

define('./pages/login/components/0deea665b809587ae836ee53f9d38bd2/bundle.js', [], () => ({
  /* content */

  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6cb26a84965de01223cefd0cd256f861'), 'isLogging')) ? 'Please wait...' : 'Log In')

  },
  /* handler:onLabelAssignment *//* content */
}));

define('./pages/login/components/5e7a4b69419c97c3c854fa3d4f1d6b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'Blocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/66f73b31bebfdf4e2e7cb7abc652daac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'Blocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/9d5c10fc89674ff227970e7997183455/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['Blocked'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/da38045ffbdf60c65df151bfa3447059/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['EULA'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/8fa645ee6d5464037b75731323cc2f09/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['EULA'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/0401ef2d2dc9328447c1549282d60329/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'EULA'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/b29d8fb3491db391278eab8ffdaaf84d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Desicion;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'EULA')) == true) {
    Desicion = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'EULA')) == false) {
    Desicion = true;
  }

  return Desicion

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/4579157de80ef6ec0494c19aa0378361/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Desicion;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'EULA')) == true) {
    Desicion = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'EULA')) == false) {
    Desicion = true;
  }

  return Desicion

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/921a35da8f9a587b82813079f215d08d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Desicion;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'EULA')) == true) {
    Desicion = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'EULA')) == false) {
    Desicion = true;
  }

  return Desicion

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/62be74f4b8ebfc2df44fa98a628714a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return '<p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:21px;font-family:"Apercu Pro","serif";color:white;\'>Your Choice in Information Use</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style=\'font-size:18px;font-family:"Apercu Pro","serif";color:white;\'>You will be required to register for our services by providing personal information. You can decline to submit personal information to any of our services, in which case we will not be able to provide those services to you. While using our services, you are not allowed to opt out from receiving information on versions/updates/service packs. We will obtain your prior consent for use of your personal information in a manner different than the purpose for which it was collected or the purposes described in this privacy policy. In such cases we will offer you an effective way to opt out of the use of your personal information for those other purposes.</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><span style="font-size:15px;color:white;">&nbsp;</span></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";vertical-align:baseline;\'><strong><span style=\'font-size:29px;font-family:"Times New Roman","serif";color:white;\'>Location</span></strong></p> <p style=\'margin-top:0cm;margin-right:0cm;margin-bottom:10.0pt;margin-left:0cm;line-height:normal;font-size:15px;font-family:"Calibri","sans-serif";\'><span style=\'font-size:18px;font-family:"Times New Roman","serif";color:white;\'>Fleet In Form&rsquo;s Dash app collects location data to enable Fuel Location Submission, Load Location Directions and Submission, Load Planning while using the app, and Finally the Driver distress SOS System even when the app is closed or not in use.</span></p>'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/login/components/2c35ff1f1013fec6baab21e7f3e79934/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.fleetinform.com/?page=Privacy_Policy', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/7fd17ccb1202a31f63f13203bd0ab006/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'T_C_Privacy_Policy_Agreement_Viewer'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/9c56a63337e97e412a32b1d965e411f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  ___arguments.context.pageData['T_C_Privacy_Policy_Agreement_Viewer'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/37d2e12ba6cfec7fc299697dff3e31c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Device_Registration, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['T_C_Privacy_Policy_Agreement_Viewer'] = false;
  (getObjectProperty(___arguments.context.appData, 'Current_User'))['T_C_Privacy_Policy_Agreement'] = true;
  (getObjectProperty(___arguments.context.appData, 'Current_User'))['T_C_Privacy_Policy_Agreement_Date_Time'] = ([((new Date()).toLocaleDateString()),' ',((new Date()).toLocaleTimeString())].join(''));
  await Backendless.Data.of('Users').save( (getObjectProperty(___arguments.context.appData, 'Current_User')) );
  ___arguments.context.appData['Director_User'] = (await Backendless.Data.of('Users').findById((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'ownerId')), ));
  try {
    ___arguments.context.appData['Employee_User'] = ((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'objectId')),'\''].join(''))).setPageSize(10)))[0]);

  } catch (error) {
    console.log(error);

  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Director_User')), 'userStatus')) == 'DISABLED') {
    ___arguments.context.appData['Blocked'] = true;
    await Backendless.UserService.logout();
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'Third_Party_Tyre_Manager')) != null) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Third_Party_Tyre_Operator', undefined);
    } else {
      try {
        Device_Registration = (await ( async function (channels) { return BackendlessUI.DeviceAPI.registerDevice(channels) })('default '));
        console.log(Device_Registration);
        Device_Registration['Current_Truck'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'Currently_Aboard'));
        Device_Registration['User_Company'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Director_User')), 'Customer'));
        Device_Registration['User_Name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'Call_Sign'));
        Device_Registration['User_ownerId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'ownerId'));
        Device_Registration['ownerId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'ownerId'));
        console.log(Device_Registration);
        await Backendless.Data.of('Device Registration').save( Device_Registration );

      } catch (error) {
        console.log(error);

      }
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/419d676b1e14edd2f7678ec1246a4f56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}


  try {
    ___arguments.context.pageData['User'] = ((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['email = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('52cacce32bd47b066d06f61f20bff7a6'), 'email')),'\''].join(''))).setPageSize(10)))[0]);
    if (getObjectProperty(___arguments.context.pageData, 'User')) {
      ___arguments.context.pageData['One Time Pin'] = (mathRandomInt(10000, 99999));
      ___arguments.context.pageData['Reset_Viewer'] = true;
    } else {
      ___arguments.context.pageData['Email Error'] = true;
      console.log(getObjectProperty(___arguments.context.pageData, 'Email Error'));
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/b4080fd6e84b78572c0f1ff93486a768/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['New_Password'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/login/components/7f97b9a4d3bd547425aaaddd2ed76bd1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Confirm_New_Password'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/login/components/514d9773c0ab1c081bef5638b3ac316c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Reset_Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/932dcfd891f570ad2465925254ae8562/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Request.post(`${Backendless.appPath}/services/Twilio/sendMessage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'phoneNumber': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Phone_Number')),'message': (['Dear ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'displayName')),'\n','\n','A Password reset has been requested on your Fleet In Form Dash Account','\n','\n','Your one time pin is ',(getObjectProperty(___arguments.context.pageData, 'One Time Pin')),'\n','\n','Kind Regards,','\n','The Fleet In Form Team'].join('')) });
  ___arguments.context.pageData['One Time Pin Viewer'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'New_Password')) == (getObjectProperty(___arguments.context.pageData, 'Confirm_New_Password')) && (getObjectProperty(___arguments.context.pageData, 'New_Password')) != null) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/bfdd3e93feb7bd28a82ee688ba6ceeda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'One Time Pin Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/4f4b142c29bd7d2a77e97388738d4a28/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Recieved One Time Pin'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.pageData, 'Recieved One Time Pin')) >= 10000 && (getObjectProperty(___arguments.context.pageData, 'Recieved One Time Pin')) <= 99999 && (getObjectProperty(___arguments.context.pageData, 'Recieved One Time Pin')) != (getObjectProperty(___arguments.context.pageData, 'One Time Pin'))) {
    ___arguments.context.pageData['OTP ERROR'] = true;
    ___arguments.context.pageData['Change Password Viewer'] = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'Recieved One Time Pin')) == (getObjectProperty(___arguments.context.pageData, 'One Time Pin'))) {
    ___arguments.context.pageData['Change Password Viewer'] = true;
    ___arguments.context.pageData['OTP ERROR'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/login/components/952e20567f3949d80574d304660e5de7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Change Password Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Device_Registration, redirectToFollowersPostsPage, password, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'User'))['password'] = (getObjectProperty(___arguments.context.pageData, 'Confirm_New_Password'));
  await Backendless.Data.of('Users').save( (getObjectProperty(___arguments.context.pageData, 'User')) );
  ___arguments.context.pageData['Button'] = true;
  email = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'email')).trim();
  password = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'password')).trim();
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('6cb26a84965de01223cefd0cd256f861')), 'isLogging')) && email && password) {
    ___arguments.context.getComponentDataStoreByUid('6cb26a84965de01223cefd0cd256f861')['isLogging'] = true;
    ___arguments.context.getComponentDataStoreByUid('6cb26a84965de01223cefd0cd256f861')['signInError'] = null;
    try {
      ___arguments.context.appData['currentUser'] = (await Backendless.UserService.login( email, password, true  ));
      redirectToFollowersPostsPage = true;

    } catch (error) {
      ___arguments.context.getComponentDataStoreByUid('6cb26a84965de01223cefd0cd256f861')['signInError'] = (getObjectProperty(error, 'message'));

    }
    ___arguments.context.getComponentDataStoreByUid('6cb26a84965de01223cefd0cd256f861')['isLogging'] = false;
    if (redirectToFollowersPostsPage) {
      ___arguments.context.appData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
      if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'T_C_Privacy_Policy_Agreement')) == true) {
        ___arguments.context.appData['Director_User'] = (await Backendless.Data.of('Users').findById((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'ownerId')), ));
        try {
          ___arguments.context.appData['Employee_User'] = ((await Backendless.Data.of('Employees').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'objectId')),'\''].join(''))).setPageSize(10)))[0]);

        } catch (error) {
          console.log(error);

        }
        if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Director_User')), 'userStatus')) == 'DISABLED') {
          ___arguments.context.appData['Blocked'] = true;
          await Backendless.UserService.logout();
        } else {
          if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'Third_Party_Tyre_Manager')) != null) {
            (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Third_Party_Tyre_Operator', undefined);
          } else {
            try {
              Device_Registration = (await ( async function (channels) { return BackendlessUI.DeviceAPI.registerDevice(channels) })('default '));
              Device_Registration['Current_Truck'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'Currently_Aboard'));
              Device_Registration['User_Company'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Director_User')), 'Customer'));
              Device_Registration['User_Name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'Call_Sign'));
              Device_Registration['User_ownerId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Employee_User')), 'ownerId'));
              Device_Registration['ownerId'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'ownerId'));
              console.log(Device_Registration);
              await Backendless.Data.of('Device Registration').save( Device_Registration );

            } catch (error) {
              console.log(error);

            }
            (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
          }
        }
      } else {
        ___arguments.context.pageData['T_C_Privacy_Policy_Agreement_Viewer'] = true;
      }
    }
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var Name;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Button')) == true) {
    Name = 'Logging In...';
  } else {
    Name = 'Reset Password';
  }

  return Name

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/login/components/30223676eebae7e364d49746b39ab60c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'OTP ERROR')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/d7a9b4cbdeec42352af9211d96b416ab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Email Error')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/login/components/2c82fa1382e22cffe612a6137facb3dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      Object.assign({}, {});

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/swapTyre/components/c34119f89ab762556812f81549fc6d27/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Home', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/swapTyre/components/54027de275ea98e75e4418a376d5ffbb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (!(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('86cf676c46748268e5f7148e1b5d5c92'))['image2']))

  },  
  /* handler:onDisplayAssignment */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa']('swapTyre'))

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    var fileExt, list;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (___arguments.file['name']).split(',').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },  
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/swapTyre/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var CurrentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86cf676c46748268e5f7148e1b5d5c92'))['opacity'] = 0;
  CurrentUser = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());
  if (CurrentUser) {
    ___arguments.context.pageData['location'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  }
  ___arguments.context.pageData['OwnerId'] = (getObjectProperty(CurrentUser, 'ownerId'));
  ___arguments.context.pageData['Mechanics'] = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(CurrentUser, 'ownerId')),'\' AND User_level = \'Mechanic\''].join(''))).setPageSize(10)));
  ___arguments.context.pageData['Horse'] = ((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['Current_Driver = \'',(getObjectProperty(CurrentUser, 'displayName')),'\''].join(''))).setPageSize(10)))[0]);
  await BackendlessUI.Functions.Custom['fn_2c2a6db614083db668e75636ea250fab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('86cf676c46748268e5f7148e1b5d5c92')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('86cf676c46748268e5f7148e1b5d5c92')), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f59d08d9b6be3cf848e12ed6476605c9')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f59d08d9b6be3cf848e12ed6476605c9')), false);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/swapTyre/components/86cf676c46748268e5f7148e1b5d5c92/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if (!(getObjectProperty(___arguments.context.dataModel, 'submit'))) {
    ___arguments.context.dataModel['submit'] = true;
    console.log(await Promise.all((getObjectProperty(___arguments.context.pageData, 'Mechanics')).map(async item => {; return (getObjectProperty(item, 'email'));})));
    await Backendless.Messaging.sendEmail('Test', new Backendless.Bodyparts({ textmessage: 'Test' }), ensureArray((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Mechanics')).map(async item => {; return (getObjectProperty(item, 'email'));})))), undefined);
    console.log((await Backendless.Messaging.sendEmailFromTemplate('New Tyre', Backendless.EmailEnvelope.create({ addresses: (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Mechanics')).map(async item => {; return (getObjectProperty(item, 'email'));}))), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ 'Driver': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Current_Driver')),'Horse': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Horse')), 'Horse_Registration')),'newtyremake': (getObjectProperty(___arguments.context.dataModel, 'newtyremake')),'newtyremodel': (getObjectProperty(___arguments.context.dataModel, 'newtyremodel')),'newtyreserial': (getObjectProperty(___arguments.context.dataModel, 'newtyreserial')),'newtyretype': ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('39a55d3fde1b5f39fa0ca60cd9bad131')),'oldtyrebrand': (getObjectProperty(___arguments.context.dataModel, 'oldtyrebrand')),'image2': (getObjectProperty(___arguments.context.dataModel, 'image2')),'mileage': (getObjectProperty(___arguments.context.dataModel, 'mileage')),'Dash': (getObjectProperty(___arguments.context.dataModel, 'Dash Image')),'Location': undefined }), undefined)));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Home', undefined);
  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/swapTyre/components/8eec86b555d8d6f2dbc4aebce0cb62ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('86cf676c46748268e5f7148e1b5d5c92'), 'submit')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('86cf676c46748268e5f7148e1b5d5c92'), 'image2')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/swapTyre/components/1db30ba9a739eaff4aaf130a19efd222/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (!(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('86cf676c46748268e5f7148e1b5d5c92'))['Dash Image']))

  },  
  /* handler:onDisplayAssignment */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_30e6b79b85ff0a1d11773b745fc245aa'](''))

  },  
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    var fileExt, list;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (___arguments.file['name']).split(',').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },  
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./components/reusable/r_d70bb35eb028401fcc2e6dd2d731e583/logic/1993e13cb692b67cc4c1228c16ce84ba/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('20312f99482797f4157228f54b9fa217', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89cbdd9906f1205369b27df94c0a9bac', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_d70bb35eb028401fcc2e6dd2d731e583/logic/0befd528f07c49d12f526e672d597252/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('233ea02d528ea296096fab865d466a43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd34eb4c1caac4aac398e36cabee4e17', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_d70bb35eb028401fcc2e6dd2d731e583/logic/ea9bfd5f9411e9cc82665fd97d1f96b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd34eb4c1caac4aac398e36cabee4e17', false);
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('233ea02d528ea296096fab865d466a43', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_d70bb35eb028401fcc2e6dd2d731e583/logic/435c6d4bd57574dc78747a9da3b3f3d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('233ea02d528ea296096fab865d466a43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd34eb4c1caac4aac398e36cabee4e17', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  ___arguments.context.pageData['WS_Hamburger_View'] = false;
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('c2d4f0b561fd0c723374abd58b625e11', (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Vehicles', (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId')),'\''].join('')), 'Horse_Registration')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Horse_Registration')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('92bcb6b56e3bbd24d9cc6534582e8e94', (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Vehicles', (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId')),'\''].join('')), 'Horse_Registration')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Horse_Registration')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('6c91227e85eaa27982d3833dddc5866f', (await Promise.all((await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Trailers', (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Customer')), 'ownerId')),'\''].join('')), 'Trailer_Registration')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Trailer_Registration')) });}))));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_d70bb35eb028401fcc2e6dd2d731e583/logic/58c221cd83f7d11c5ccc229544498106/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('233ea02d528ea296096fab865d466a43', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd34eb4c1caac4aac398e36cabee4e17', false);
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  ___arguments.context.pageData['WS_Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_d70bb35eb028401fcc2e6dd2d731e583/logic/75cd382e28fbe147f09ddebde8fa559b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var RGBA, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('095a325d1065630153bc97bc5b6aa223', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', true);

  } catch (error) {
    console.log(error);

  }
  try {
    ___arguments.context.pageData['Current_User'] = (await BackendlessUI.Functions.Custom['fn_5a16854754a90b444dc8e7a6d99bb9e3']());

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['Customers'] = (await BackendlessUI.Functions.Custom['fn_503b7283234c81cc315a940c67023c2b']('Customers', (['Third_Party_Tyre_Manager = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Current_User')), 'Third_Party_Tyre_Manager')),'\''].join(''))));

  } catch (error) {
    console.log(error);

  }
  console.log(getObjectProperty(___arguments.context.pageData, 'Customers'));
  try {
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('8fb5beb15dd40c8b11d10fc9471548b2', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company')) });}))));

  } catch (error) {
    console.log(error);

  }
  try {
    ___arguments.context.pageData['Tyre_Swap_Edit_True2'] = false;
    ___arguments.context.pageData['Tyre_Swap_Edit_False2'] = true;
    ___arguments.context.pageData['Tyre_Swap_Edit_True'] = false;
    ___arguments.context.pageData['Tyre_Swap_Edit_False'] = true;
    ___arguments.context.pageData['Images_View'] = false;

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('233ea02d528ea296096fab865d466a43', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8096fb55ff9c027bc50ec5ae514327e5', false);

  } catch (error) {
    console.log(error);

  }
  try {
    ___arguments.context.pageData['RGBA'] = 1;

  } catch (error) {
    console.log(error);

  }
  try {
    for (var count = 0; count < 100; count++) {
      RGBA = (getObjectProperty(___arguments.context.pageData, 'RGBA')) - 0.01;
      ___arguments.context.pageData['RGBA'] = RGBA;
      await new Promise(r => setTimeout(r, 0.1 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('704fcd63d126442e0ff7b219bd91a1f6'))['backgroundColor'] = (['rgba(0, 0, 0, ',RGBA,')'].join(''));
    }

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('704fcd63d126442e0ff7b219bd91a1f6', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c34a0533a03ad3d9598079e1bfad2aa', true);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('8fb5beb15dd40c8b11d10fc9471548b2', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company')) });}))));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_d70bb35eb028401fcc2e6dd2d731e583/logic/47f305d6f51daa187f1a5a6856de7ead/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/be4f4caa0f1e53bb9bba6882d58222cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Selected_Tyre_132'] = null;
  ___arguments.context.pageData['Tyre_Viewer'] = false;
  ___arguments.context.pageData['Tyre_Swap'] = false;
  ___arguments.context.pageData['Tyre_Swap_2'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/40bee0f7016d72c45a5abc575f4cbc9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Tyre_Viewer')) == true && (getObjectProperty(___arguments.context.pageData, 'Tyre_Swap')) == false) {
    Result = true;
  } else {
    Result = false;
  }

  return Result

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/52f298462c15159de29a6a28c793d9cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Tyre_Swap_Edit_True'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False'] = true;
  ___arguments.context.pageData['Tyre_Edit_1'] = null;
  ___arguments.context.pageData['Tyre_Edit_2'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/af8836b912bd075fb17a1054b911d595/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('81261c456bfff72600117f12981ff09a'))['marginTop'] = 175;
  ___arguments.context.pageData['Tyre_Swap_Edit_True'] = false;
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Edited')) <= 4) {
    (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Edited'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Edited')) + 1);
    ___arguments.context.pageData[(String('Selected_Tyre') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Tyre_Position')))] = (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'));
    await Backendless.Data.of('Tyres').save( (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')) );
  }
  ___arguments.context.pageData['Tyre_Swap_Edit_False'] = true;
  ___arguments.context.pageData['Tyre_Edit_1'] = null;
  ___arguments.context.pageData['Tyre_Edit_2'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/fcef828d5f1214149b768e5c974a10bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Tyre_Swap_Edit_True'] = true;
  console.log(getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'));
  ___arguments.context.pageData['Tyre_Swap_Edit_False'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/848baf04fbd3bc6a236f0161403da076/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Fleet_Brand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/9edd9101ba75a34b64b53d5342595abc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Currently_On'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/8ec2b4a804972e360c7b9128cb440a91/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Type'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/9a86c063efc9a04af3698a0f6ed29f3b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/115de4a2062f12af8593427b871ac4a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/220eceefdbed0f02577ba4519a09ad2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Serial_Number'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/928a53e164d1186356478cd323e87748/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Current_Cap_State'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/3d58d284f9a15de4db2e81571b388733/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Current_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/a1d91cc250f5344aa0dcd56a8b093e99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Remaining_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/6c1e0b5e3165de0d10bcce039d722038/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Make'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/65ea5b42d566ee9b1dd529951f917931/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Model'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/a22fa2e5acd22696174717ef0b090927/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Current_Cap_State'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/f1c9d3c26dae7c4e579c262d10440edf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Serial_Number'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/3f751e4d87cb00b8c38acfcc5adb15a1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Cost'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/5a1807f3eceabb8e5bcc918d0db5c848/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Tyre_Edit_2'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Current_Mileage'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Expected_Mileage')) - ___arguments.value);
  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Life'] = (100 - ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Current_Mileage')) / (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Expected_Mileage'))) * 100);
  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Remaining_Mileage'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Tyre_Edit_2'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/6467cdee6769d76d701fedba5e2a06fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Tyre_Swap_Edit_True')) == true) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Edited')) == 0) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Tyre_Edit_1'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Expected_Mileage'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Life'] = (100 - ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Current_Mileage')) / ___arguments.value) * 100);

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Tyre_Edit_1'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/50ecfe1e2fd5fe71adaead2c17afb548/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Life'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/b62e23c4cf94ccc593935b6e1e45ef1c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Tyre_Select_Input'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/2bb898cc316b560d9d05e486e3e4c225/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.pageData['New_Tyre'] = (await Backendless.Data.of('Tyres').findById(___arguments.value, ));
  ___arguments.context.pageData['Selected_Tyre_132'] = ___arguments.value;
  ___arguments.context.pageData['Tyre_Swap_2'] = true;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var List, Decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_Input')) == null) {
    List = (getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'));
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_Input')).startsWith(((getObjectProperty(___arguments.context.pageData, 'Company_Brand')).slice(0, 2)))) {
      List = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List')), async (item) => {
         if (((getObjectProperty(item, 'label')).toLowerCase()).startsWith((String((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_Input')).toLowerCase())))) {
          Decision = true;
        } else {
          Decision = false;
        }


       return Decision;
      }));
    } else {
      List = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List')), async (item) => {
         if (((getObjectProperty(item, 'Serial_Number')).toLowerCase()).startsWith((String((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_Input')).toLowerCase())))) {
          Decision = true;
        } else {
          Decision = false;
        }


       return Decision;
      }));
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/8e154b7d9f9b2d1a68e3d7b8c554212b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2, New_Tyre, Replaced_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Tyre_Position'));
  Replaced_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'objectId')), ));
  Replaced_Tyre['Tyre_Position'] = null;
  Replaced_Tyre['Currently_On'] = null;
  await Backendless.Data.of('Tyres').save( Replaced_Tyre );
  New_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre_132')), ));
  New_Tyre['Tyre_Position'] = (Number2 * 1);
  New_Tyre['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Horse'));
  await Backendless.Data.of('Tyres').save( New_Tyre );
  ___arguments.context.pageData[(String('Selected_Tyre') + String(Number2))] = New_Tyre;
  ___arguments.context.pageData[(String('Tyre_Select_Input_') + String(Number2))] = null;
  ___arguments.context.pageData['Selected_Tyre_132'] = null;
  ___arguments.context.pageData['Tyre_Viewer'] = false;
  ___arguments.context.pageData['Tyre_Swap'] = false;
  ___arguments.context.pageData['Tyre_Swap_2'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/d1f506eeba3f99c820b5c2732dc5c0ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2, New_Tyre, Replaced_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Tyre_Position'));
  Replaced_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'objectId')), ));
  Replaced_Tyre['Tyre_Position'] = null;
  if ((getObjectProperty(Replaced_Tyre, 'Current_Cap_State')) == 'New') {
    Replaced_Tyre['New_Total_Mileage'] = (getObjectProperty(Replaced_Tyre, 'Current_Mileage'));
    Replaced_Tyre['Current_Cap_State'] = 'Cap 1';
    Replaced_Tyre['Expected_Mileage'] = 60000;
    Replaced_Tyre['Current_Mileage'] = 0;
  } else if ((getObjectProperty(Replaced_Tyre, 'Current_Cap_State')) == 'Cap 1') {
    Replaced_Tyre['Cap1_Total_Mileage'] = (getObjectProperty(Replaced_Tyre, 'Current_Mileage'));
    Replaced_Tyre['Current_Cap_State'] = 'Cap 2';
    Replaced_Tyre['Expected_Mileage'] = 60000;
    Replaced_Tyre['Current_Mileage'] = 0;
  } else if ((getObjectProperty(Replaced_Tyre, 'Current_Cap_State')) == 'Cap 2') {
    Replaced_Tyre['Cap2_Total_Mileage'] = (getObjectProperty(Replaced_Tyre, 'Current_Mileage'));
    Replaced_Tyre['Current_Cap_State'] = 'Cap 3';
    Replaced_Tyre['Expected_Mileage'] = 60000;
    Replaced_Tyre['Current_Mileage'] = 0;
  } else if ((getObjectProperty(Replaced_Tyre, 'Current_Cap_State')) == 'Cap 3') {
    Replaced_Tyre['Cap3_Total_Mileage'] = (getObjectProperty(Replaced_Tyre, 'Current_Mileage'));
    Replaced_Tyre['Current_Cap_State'] = null;
    Replaced_Tyre['Expected_Mileage'] = 60000;
    Replaced_Tyre['Current_Mileage'] = 0;
  }
  Replaced_Tyre['Retread_List'] = 'Yes';
  Replaced_Tyre['Currently_On'] = null;
  await Backendless.Data.of('Tyres').save( Replaced_Tyre );
  New_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre_132')), ));
  New_Tyre['Tyre_Position'] = (Number2 * 1);
  New_Tyre['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Horse'));
  await Backendless.Data.of('Tyres').save( New_Tyre );
  ___arguments.context.pageData[(String('Selected_Tyre') + String(Number2))] = New_Tyre;
  ___arguments.context.pageData[(String('Tyre_Select_Input_') + String(Number2))] = null;
  ___arguments.context.pageData['Selected_Tyre_132'] = null;
  ___arguments.context.pageData['Tyre_Viewer'] = false;
  ___arguments.context.pageData['Tyre_Swap'] = false;
  ___arguments.context.pageData['Tyre_Swap_2'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/5daa18e8a5eb42da648370a9ca346a77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2, New_Tyre, Replaced_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Tyre_Position'));
  Replaced_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'objectId')), ));
  Replaced_Tyre['Tyre_Position'] = null;
  Replaced_Tyre['State'] = 'Scraped';
  Replaced_Tyre['Currently_On'] = 'Scraped';
  await Backendless.Data.of('Tyres').save( Replaced_Tyre );
  New_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre_132')), ));
  New_Tyre['Tyre_Position'] = (Number2 * 1);
  New_Tyre['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Horse'));
  await Backendless.Data.of('Tyres').save( New_Tyre );
  ___arguments.context.pageData[(String('Selected_Tyre') + String(Number2))] = New_Tyre;
  ___arguments.context.pageData[(String('Tyre_Select_Input_') + String(Number2))] = null;
  ___arguments.context.pageData['Selected_Tyre_132'] = null;
  ___arguments.context.pageData['Tyre_Viewer'] = false;
  ___arguments.context.pageData['Tyre_Swap'] = false;
  ___arguments.context.pageData['Tyre_Swap_2'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/330af95aabeb98d509868e9d5cc1f1c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Tyre_Swap_Edit_True2'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False2'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/c022593d5b2c65c1a7896cd7ad21f911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Tyre_Swap_Edit_True2'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False2'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/4d188ed3cf94645e9285007fbe7a38df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Tyre_Swap_Edit_True2'] = true;
  ___arguments.context.pageData['Tyre_Swap_Edit_False2'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/12eb81bdb9ac4dd8833f1c5f8e8c843c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Fleet_Brand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/515fce8f19c4732b90725423908a9e8b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Type'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/94b7774aced2dbe7ef7cc0b5d0c71bc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Type'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/e3b181becb16fd6dc56e64aeaff81116/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/46c83cbccf7971cd2d039f599fad717f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Serial_Number'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/62fbf197e8ea5f2d77857546e31952cb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Current_Cap_State'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/f0d12a01a1ff3287a8cab0c856280dec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Current_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/d8a4829b96016e59c7ff0594c04ea247/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Remaining_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ccce49fb5424d6df3c12b385e9ac0347/logic/1d93125ea9b2c0620986dde3079495ac/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Life'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/716957734e331906990b257e9f01c565/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Trailer_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/610448f72daaef01a4037bd3ea89f6bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Fleet_ID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/ae661764587dc24e5d52298dadbdc4f6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Vin'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/900d939baf7f966c7ded5c396cefda09/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/283fd0d162c4ba8a9ae673f7a63c9783/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/73c37362aff6f3f9744502659d48c8a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Year'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/6ffeb91dad833469e02d46d43319e2ff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Type'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/713b4aaf34c32aa82a6d25e9052db62e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Trailer_1_History_Block_Viewer'] = true;
  await new Promise(r => setTimeout(r, 500 || 0));
  ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = true;
  ___arguments.context.pageData['Service_Due_Table_Trailer_1_Service'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/e816bd5cf0b311490c9ff5fc7ee8165f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Trailer_1_History_Block_Viewer'] = true;
  await new Promise(r => setTimeout(r, 500 || 0));
  ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = false;
  ___arguments.context.pageData['Service_Due_Table_Trailer_1_Service'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/37ba1203e974225595c7f9a2348e343e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Service_Trailer'))['Completion_Status'] = 'Commenced';
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Service_Trailer')) );
  ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = false;
  ___arguments.context.pageData['Service_Due_Table_Trailer_1_Service'] = false;
  ___arguments.context.pageData['Trailer_History_Block_Viewer'] = false;
  ___arguments.context.pageData['Scheduler_Viewer_4.1'] = false;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('da962d555aa7b166e5e30dfc9743a357');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Scheduler_Viewer_4')) == false) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/634a67cd5b1a28d2b16ebf3d5c032547/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Scheduler_Viewer_4'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Scheduler_Viewer_3')) == true) {
    Viewer = false;
    ___arguments.context.pageData['Scheduler_Viewer_4'] = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/a591c286daa2ede474ce87a4d439429c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11974116ba9d4519cc99ebcd2e41f19b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Scheduler_Viewer_4.1')) == false) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/137c214bce1b8d3e5a0d5f86df939bdc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Scheduler_Viewer_4'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/b401498a24dcd10ec1d446bac15b3f49/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/0c3e6e54d84d259bb8a614838996fe9f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Service, New_Trailer, New_Horse, New_Load;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Workshop_Scheduled_Trailer'] = true;
  New_Trailer = (getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1'));
  New_Trailer['Last_Service_Scheduled'] = (getObjectProperty(New_Trailer, 'Next_Service'));
  await Backendless.Data.of('Trailers').save( New_Trailer );
  New_Service = (await Backendless.Data.of('Repairs_Maintenance').save( ({ 'Date_Scheduled': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('137c214bce1b8d3e5a0d5f86df939bdc'), 'Date')),'Scheduled_Notes': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('137c214bce1b8d3e5a0d5f86df939bdc'), 'Instructions')),'Registration_Trailer_1': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Trailer_Registration')),'Repair_Or_Service': 'Service','Service_Point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('137c214bce1b8d3e5a0d5f86df939bdc'), 'Location')),'Completion_Status': 'Scheduled','ownerId': (getObjectProperty(New_Trailer, 'ownerId')) }) ));
  ___arguments.context.pageData['New_Service_Trailer'] = New_Service;
  ___arguments.context.pageData['Scheduler_Viewer_3'] = true;
  ___arguments.context.pageData['Scheduler_Viewer_4'] = false;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('da962d555aa7b166e5e30dfc9743a357');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a591c286daa2ede474ce87a4d439429c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/594cb366da72040116d59ec50a2c299e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Service_Due_Table_Trailer_1_Repair'] = false;
  ___arguments.context.pageData['Service_Due_Table_Trailer_1_Service'] = false;
  ___arguments.context.pageData['Trailer_1_History_Block_Viewer'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11974116ba9d4519cc99ebcd2e41f19b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/121319e98462415a412a1635c7a3bf5e/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Registration_Trailer_1 = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Trailer_Registration')),'\' AND Completion_Status = \'Completed\' AND Repair_Or_Service = \'Service\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./components/reusable/r_3c55f06f463ab06ac63ddfdd806b31e9/logic/14243b219be3714baa0c0c1ad45c97f4/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Registration_Trailer_1 = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Trailer_1')), 'Trailer_Registration')),'\' AND Completion_Status = \'Completed\' AND Repair_Or_Service = \'Repair\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/d67232e28d2268048c13d0ad6f1e3d8c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Horse_Registration'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/9428c36a188f15639a58773678a51694/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Fleet_ID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/2d1f458a2d08788b430a4348baaa9026/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'VIN'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/2c17be5ab047ab8dd308f3ded7486883/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Engine_Number'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/7d7246b85d39340e1245ace98b088cac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/ac0bb846e06266047229aba524fa9404/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/6315da9c8cbd2129662e02fc18bcfbd6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Year'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/cb1c34483b8a888ca3fb74866c41de3c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Horse_History_Block_Viewer'] = true;
  await new Promise(r => setTimeout(r, 500 || 0));
  ___arguments.context.pageData['Service_Due_Table_Horse_Repair'] = true;
  ___arguments.context.pageData['Service_Due_Table_Horse_Service'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/6c72499a7d6d6e164ca8d2d5535d92a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Horse_History_Block_Viewer'] = true;
  await new Promise(r => setTimeout(r, 500 || 0));
  ___arguments.context.pageData['Service_Due_Table_Horse_Repair'] = false;
  ___arguments.context.pageData['Service_Due_Table_Horse_Service'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/99fe695e3a0e7a9e805b0d1707f6f261/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'New_Service_Horse'))['Completion_Status'] = 'Commenced';
  await Backendless.Data.of('Repairs_Maintenance').save( (getObjectProperty(___arguments.context.pageData, 'New_Service_Horse')) );
  (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record'))['Last_Service_Scheduled'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')), 'Next_Service'));
  await Backendless.Data.of('Vehicles').save( (getObjectProperty(___arguments.context.pageData, 'Selected_Service_Due_Horse_Record')) );
  ___arguments.context.pageData['Service_Due_Table_Horse_Repair'] = false;
  ___arguments.context.pageData['Service_Due_Table_Horse_Service'] = false;
  ___arguments.context.pageData['Trailer_History_Block_Viewer'] = false;
  ___arguments.context.pageData['Scheduler_Viewer_2.1'] = false;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('da962d555aa7b166e5e30dfc9743a357');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Scheduler_Viewer_2')) == false) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/f9923ce6dc04985bd35f2a96db780e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Scheduler_Viewer')) == true) {
    Viewer = false;
    ___arguments.context.pageData['Scheduler_Viewer_2'] = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Scheduler_Viewer_2'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/b23ebc0a07078769dc41e3776bf5f0f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('210ebfb674bfc78fa9fc21445fff24de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11974116ba9d4519cc99ebcd2e41f19b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Scheduler_Viewer_2.1')) == false) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/eaa8cbfaade8efed3d08c7cb83d1be38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Scheduler_Viewer_2'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/4f2dffdf2a19548942d8b951d14f186b/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/424870edef93a5663117b30c0911e7cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Horse, New_Load, New_Service;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Workshop_Scheduled_Horse'] = true;
  New_Horse = (getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse'));
  New_Horse['Last_Service_Scheduled'] = (getObjectProperty(New_Horse, 'Next_Service'));
  await Backendless.Data.of('Vehicles').save( New_Horse );
  New_Load = (await Backendless.Data.of('Loads').save( ({ 'Service': 'Yes','Description': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Instructions')),'Horse_Registration': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Horse_Registration')),'Customer_Name': 'Service','Completion_Status': '0','Planned_Delivery_Date_Time': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Date')),'Planned_Delivery_Date_Time2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Date')),'Planned_Load': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Date')),'Planned_Load2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Date')),'load_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Location')),'load_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Location')),'delivery_point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Location')),'delivery_point2': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Location')),'tonnage': null,'tonnage2': null,'Status': null,'Status2': null }) ));
  New_Service = (await Backendless.Data.of('Repairs_Maintenance').save( ({ 'Date_Scheduled': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Date')),'Scheduled_Notes': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Instructions')),'Registration_Horse': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Horse_Registration')),'Repair_Or_Service': 'Service','Service_Point': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eaa8cbfaade8efed3d08c7cb83d1be38'), 'Location')),'Completion_Status': 'Scheduled','ownerId': (getObjectProperty(New_Horse, 'ownerId')) }) ));
  console.log(New_Service);
  ___arguments.context.pageData['New_Service_Horse'] = New_Service;
  await Backendless.Data.of('Loads').setRelation(New_Load, 'Horse', [New_Horse]);
  ___arguments.context.pageData['Scheduler_Viewer'] = true;
  ___arguments.context.pageData['Scheduler_Viewer_2'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/b0ed8fedd6a15fcff1d47664fc0fe23e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Service_Due_Table_Horse_Repair'] = false;
  ___arguments.context.pageData['Service_Due_Table_Horse_Service'] = false;
  ___arguments.context.pageData['Horse_History_Block_Viewer'] = false;
  ___arguments.context.pageData['Scheduler_Viewer_2'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c2b2435813b9d528a56eecc596cf94c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/fe73603d8cee36ae0a6e594235ff91e4/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Registration_Horse = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Horse_Registration')),'\' AND Completion_Status = \'Completed\' AND Repair_Or_Service = \'Service\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./components/reusable/r_b1ac1d3222ad3d01c1c3dd72aed83a37/logic/350e6dbe5a0771b9f239246758648c57/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Registration_Horse = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Service_Due_Table_Horse')), 'Horse_Registration')),'\' AND Completion_Status = \'Completed\' AND Repair_Or_Service = \'Repair\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c2d4f0b561fd0c723374abd58b625e11/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Tyres, Rig, Counter, Tyre, Tyre_Position;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tyre_Clear() {
  Counter = 0;
  for (var count = 0; count < 132; count++) {
    Counter = Counter + 1;
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = undefined;
  }
}

/**
 * Describe this function...
 */
async function Axle_Clear() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30db9f4b55346d9f8c6148696703211f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d1bc84170661413cbec46223355899b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36e1a9c7451c1362f7e7fcb1090a2b6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e354ebd7a4bdff6b79d49f7a3d19cf6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0583c16836065a466adb818cd7feb7cd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a67f3ab76caa7d5c6fa6941b3e018c5f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc58b9e94a283c651507b1cccb9a92db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3c1e709cbdf289adfeaa2d8dc7b6141', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b446196ecbf44e7eb9b52cfc06d13ac', false);
  console.log('Success');
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Horse_Tyre_Populator() {
  Counter = 0;
  var repeat_end = (getObjectProperty(___arguments.context.pageData, 'Horse_Total_Tyres')) + 1;
  for (var count2 = 0; count2 < repeat_end; count2++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T1_Tyre_Populator() {
  Counter = 0;
  var repeat_end2 = (getObjectProperty(___arguments.context.pageData, 'T1_Total_Tyres')) + 1;
  for (var count3 = 0; count3 < repeat_end2; count3++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T1_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T1_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T2_Tyre_Populator() {
  Counter = 0;
  var repeat_end3 = (getObjectProperty(___arguments.context.pageData, 'T2_Total_Tyres')) + 1;
  for (var count4 = 0; count4 < repeat_end3; count4++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T2_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T2_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T3_Tyre_Populator() {
  Counter = 0;
  var repeat_end4 = (getObjectProperty(___arguments.context.pageData, 'T3_Total_Tyres')) + 1;
  for (var count5 = 0; count5 < repeat_end4; count5++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T3_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T3_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function Horse_Steer() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30db9f4b55346d9f8c6148696703211f', true);
  }
}

/**
 * Describe this function...
 */
async function Horse_SD() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d1bc84170661413cbec46223355899b', true);
  }
}

/**
 * Describe this function...
 */
async function Horse_DD() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36e1a9c7451c1362f7e7fcb1090a2b6b', true);
  }
}

/**
 * Describe this function...
 */
async function T1_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e354ebd7a4bdff6b79d49f7a3d19cf6', true);
  }
}

/**
 * Describe this function...
 */
async function T1_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0583c16836065a466adb818cd7feb7cd', true);
  }
}

/**
 * Describe this function...
 */
async function T2_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a67f3ab76caa7d5c6fa6941b3e018c5f', true);
  }
}

/**
 * Describe this function...
 */
async function T2_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc58b9e94a283c651507b1cccb9a92db', true);
  }
}

/**
 * Describe this function...
 */
async function T3_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3c1e709cbdf289adfeaa2d8dc7b6141', true);
  }
}

/**
 * Describe this function...
 */
async function T3_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b446196ecbf44e7eb9b52cfc06d13ac', true);
  }
}


  Rig = null;
  ___arguments.context.pageData['Horse'] = null;
  ___arguments.context.pageData['Horse_Steer'] = null;
  ___arguments.context.pageData['Horse_SD'] = null;
  ___arguments.context.pageData['Horse_DD'] = null;
  ___arguments.context.pageData['T1'] = null;
  ___arguments.context.pageData['T1_SW'] = null;
  ___arguments.context.pageData['T1_DW'] = null;
  ___arguments.context.pageData['T2'] = null;
  ___arguments.context.pageData['T2_SW'] = null;
  ___arguments.context.pageData['T2_DW'] = null;
  ___arguments.context.pageData['T3'] = null;
  ___arguments.context.pageData['T3_SW'] = null;
  ___arguments.context.pageData['T3_DW'] = null;
  ___arguments.context.pageData['Horse_Tyres'] = null;
  ___arguments.context.pageData['T1_Tyres'] = null;
  ___arguments.context.pageData['T2_Tyres'] = null;
  ___arguments.context.pageData['T3_Tyres'] = null;
  ___arguments.context.pageData['Horse_Total_Tyres'] = [];
  ___arguments.context.pageData['T1_Total_Tyres'] = [];
  ___arguments.context.pageData['T2_Total_Tyres'] = [];
  ___arguments.context.pageData['T3_Total_Tyres'] = [];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('92bcb6b56e3bbd24d9cc6534582e8e94', null);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6c91227e85eaa27982d3833dddc5866f', null);
  await Tyre_Clear();
  await Axle_Clear();
  ___arguments.context.pageData['Rig_Create'] = true;
  ___arguments.context.pageData['H_Create'] = false;
  ___arguments.context.pageData['T1_Create'] = false;
  ___arguments.context.pageData['T2_Create'] = false;
  ___arguments.context.pageData['T3_Create'] = false;
  ___arguments.context.pageData['Type_Selected'] = 'Rig';
  Rig = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments.value,'\''].join(''))).setPageSize(1))).map(async item => {; return ({ 'objectId': (getObjectProperty(item, 'objectId')),'Fleet_ID': (getObjectProperty(item, 'Fleet_ID')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Steer_Axle_Number': (getObjectProperty(item, 'Steer_Axle_Number')),'Drive_Axle_Number_Single_Wheels': (getObjectProperty(item, 'Drive_Axle_Number_Single_Wheels')),'Drive_Axle_Number_Double_Wheels': (getObjectProperty(item, 'Drive_Axle_Number_Double_Wheels')),'Trailer1_Registration': (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(1).setOffset(0)))[0],'Trailer2_Registration': (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(1).setOffset(0)))[0],'Trailer3_Registration': (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(1).setOffset(0)))[0] });})))[0];
  ___arguments.context.pageData['Horse'] = (getObjectProperty(Rig, 'Horse_Registration'));
  try {
    ___arguments.context.pageData['Horse_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(Rig, 'Horse_Registration')),'\''].join(''))).setSortBy('Tyre_Position').setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  ___arguments.context.pageData['Horse_Steer'] = ((getObjectProperty(Rig, 'Steer_Axle_Number')) * 1);
  ___arguments.context.pageData['Horse_SD'] = ((getObjectProperty(Rig, 'Drive_Axle_Number_Single_Wheels')) * 1);
  ___arguments.context.pageData['Horse_DD'] = ((getObjectProperty(Rig, 'Drive_Axle_Number_Double_Wheels')) * 1);
  try {
    ___arguments.context.pageData['T1'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer1_Registration')), 'Trailer_Registration'));
    ___arguments.context.pageData['T1_SW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer1_Registration')), 'Axle_Number_Single_Wheel'));
    ___arguments.context.pageData['T1_DW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer1_Registration')), 'Axle_Number_Double_Wheel'));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['T2'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer2_Registration')), 'Trailer_Registration'));
    ___arguments.context.pageData['T2_SW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer2_Registration')), 'Axle_Number_Single_Wheel'));
    ___arguments.context.pageData['T2_DW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer2_Registration')), 'Axle_Number_Double_Wheel'));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['T3'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer3_Registration')), 'Trailer_Registration'));
    ___arguments.context.pageData['T3_SW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer3_Registration')), 'Axle_Number_Single_Wheel'));
    ___arguments.context.pageData['T3_DW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer3_Registration')), 'Axle_Number_Double_Wheel'));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['T1_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty((getObjectProperty(Rig, 'Trailer1_Registration')), 'Trailer_Registration')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['T2_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty((getObjectProperty(Rig, 'Trailer2_Registration')), 'Trailer_Registration')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['T3_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty((getObjectProperty(Rig, 'Trailer3_Registration')), 'Trailer_Registration')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  ___arguments.context.pageData['Horse_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) * 2 + (getObjectProperty(___arguments.context.pageData, 'Horse_SD')) * 2 + (getObjectProperty(___arguments.context.pageData, 'Horse_DD')) * 4);
  ___arguments.context.pageData['T1_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T1_DW')) * 4);
  ___arguments.context.pageData['T2_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T2_DW')) * 4);
  ___arguments.context.pageData['T3_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T3_DW')) * 4);
  ___arguments.context.pageData['Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'Horse_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T1_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T2_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T3_Total_Tyres')));
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')).length == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', true);
  }
  await Horse_Steer();
  await Horse_SD();
  await Horse_DD();
  await T1_SW();
  await T1_DW();
  await T2_SW();
  await T2_DW();
  await T3_SW();
  await T3_DW();
  await Horse_Tyre_Populator();
  try {
    await T1_Tyre_Populator();

  } catch (error) {

  }
  try {
    await T2_Tyre_Populator();

  } catch (error) {

  }
  try {
    await T3_Tyre_Populator();

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/92bcb6b56e3bbd24d9cc6534582e8e94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Rig, Counter, Tyre, Tyre_Position;

/**
 * Describe this function...
 */
async function Axle_Clear() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30db9f4b55346d9f8c6148696703211f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d1bc84170661413cbec46223355899b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36e1a9c7451c1362f7e7fcb1090a2b6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e354ebd7a4bdff6b79d49f7a3d19cf6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0583c16836065a466adb818cd7feb7cd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a67f3ab76caa7d5c6fa6941b3e018c5f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc58b9e94a283c651507b1cccb9a92db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3c1e709cbdf289adfeaa2d8dc7b6141', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b446196ecbf44e7eb9b52cfc06d13ac', false);
  console.log('Success');
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tyre_Clear() {
  Counter = 0;
  for (var count = 0; count < 90; count++) {
    Counter = Counter + 1;
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = null;
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Horse_Tyre_Populator() {
  Counter = 0;
  var repeat_end = (getObjectProperty(___arguments.context.pageData, 'Horse_Total_Tyres')) + 1;
  for (var count2 = 0; count2 < repeat_end; count2++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function Horse_Steer() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30db9f4b55346d9f8c6148696703211f', true);
  }
}

/**
 * Describe this function...
 */
async function Horse_SD() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d1bc84170661413cbec46223355899b', true);
  }
}

/**
 * Describe this function...
 */
async function Horse_DD() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36e1a9c7451c1362f7e7fcb1090a2b6b', true);
  }
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c2d4f0b561fd0c723374abd58b625e11', null);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6c91227e85eaa27982d3833dddc5866f', null);
  Rig = null;
  ___arguments.context.pageData['Horse'] = null;
  ___arguments.context.pageData['Horse_Steer'] = null;
  ___arguments.context.pageData['Horse_SD'] = null;
  ___arguments.context.pageData['Horse_DD'] = null;
  ___arguments.context.pageData['T1'] = null;
  ___arguments.context.pageData['T1_SW'] = null;
  ___arguments.context.pageData['T1_DW'] = null;
  ___arguments.context.pageData['T2'] = null;
  ___arguments.context.pageData['T2_SW'] = null;
  ___arguments.context.pageData['T2_DW'] = null;
  ___arguments.context.pageData['T3'] = null;
  ___arguments.context.pageData['T3_SW'] = null;
  ___arguments.context.pageData['T3_DW'] = null;
  ___arguments.context.pageData['Horse_Tyres'] = null;
  ___arguments.context.pageData['T1_Tyres'] = null;
  ___arguments.context.pageData['T2_Tyres'] = null;
  ___arguments.context.pageData['T3_Tyres'] = null;
  ___arguments.context.pageData['Horse_Total_Tyres'] = [];
  ___arguments.context.pageData['T1_Total_Tyres'] = [];
  ___arguments.context.pageData['T2_Total_Tyres'] = [];
  ___arguments.context.pageData['T3_Total_Tyres'] = [];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  await Axle_Clear();
  await Tyre_Clear();
  ___arguments.context.pageData['Rig_Create'] = false;
  ___arguments.context.pageData['H_Create'] = true;
  ___arguments.context.pageData['T1_Create'] = false;
  ___arguments.context.pageData['T2_Create'] = false;
  ___arguments.context.pageData['T3_Create'] = false;
  ___arguments.context.pageData['Type_Selected'] = 'Horse';
  Rig = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments.value,'\''].join(''))).setPageSize(1))).map(async item => {; return ({ 'objectId': (getObjectProperty(item, 'objectId')),'Fleet_ID': (getObjectProperty(item, 'Fleet_ID')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Steer_Axle_Number': (getObjectProperty(item, 'Steer_Axle_Number')),'Drive_Axle_Number_Single_Wheels': (getObjectProperty(item, 'Drive_Axle_Number_Single_Wheels')),'Drive_Axle_Number_Double_Wheels': (getObjectProperty(item, 'Drive_Axle_Number_Double_Wheels')) });})))[0];
  ___arguments.context.pageData['Horse'] = (getObjectProperty(Rig, 'Horse_Registration'));
  try {
    ___arguments.context.pageData['Horse_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(Rig, 'Horse_Registration')),'\''].join(''))).setSortBy('Tyre_Position').setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  ___arguments.context.pageData['Horse_Steer'] = ((getObjectProperty(Rig, 'Steer_Axle_Number')) * 1);
  ___arguments.context.pageData['Horse_SD'] = ((getObjectProperty(Rig, 'Drive_Axle_Number_Single_Wheels')) * 1);
  ___arguments.context.pageData['Horse_DD'] = ((getObjectProperty(Rig, 'Drive_Axle_Number_Double_Wheels')) * 1);
  await Horse_Steer();
  await Horse_SD();
  await Horse_DD();
  try {
    ___arguments.context.pageData['T3_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty((getObjectProperty(Rig, 'Trailer3_Registration')), 'Trailer_Registration')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  ___arguments.context.pageData['Horse_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) * 2 + (getObjectProperty(___arguments.context.pageData, 'Horse_SD')) * 2 + (getObjectProperty(___arguments.context.pageData, 'Horse_DD')) * 4);
  ___arguments.context.pageData['T1_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T1_DW')) * 4);
  ___arguments.context.pageData['T2_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T2_DW')) * 4);
  ___arguments.context.pageData['T3_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T3_DW')) * 4);
  ___arguments.context.pageData['Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'Horse_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T1_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T2_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T3_Total_Tyres')));
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')).length == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', true);
  }
  await Horse_Tyre_Populator();

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6c91227e85eaa27982d3833dddc5866f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Trailer, error, Rig, Counter, Tyre, Tyre_Position;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tyre_Clear() {
  Counter = 0;
  for (var count = 0; count < 90; count++) {
    Counter = Counter + 1;
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = null;
  }
}

/**
 * Describe this function...
 */
async function Axle_Clear() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30db9f4b55346d9f8c6148696703211f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d1bc84170661413cbec46223355899b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36e1a9c7451c1362f7e7fcb1090a2b6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e354ebd7a4bdff6b79d49f7a3d19cf6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0583c16836065a466adb818cd7feb7cd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a67f3ab76caa7d5c6fa6941b3e018c5f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc58b9e94a283c651507b1cccb9a92db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3c1e709cbdf289adfeaa2d8dc7b6141', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b446196ecbf44e7eb9b52cfc06d13ac', false);
  console.log('Success');
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function T1_Tyre_Populator() {
  Counter = 0;
  var repeat_end = (getObjectProperty(___arguments.context.pageData, 'T1_Total_Tyres')) + 1;
  for (var count2 = 0; count2 < repeat_end; count2++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T1_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T1_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T2_Tyre_Populator() {
  Counter = 0;
  var repeat_end2 = (getObjectProperty(___arguments.context.pageData, 'T2_Total_Tyres')) + 1;
  for (var count3 = 0; count3 < repeat_end2; count3++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T2_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T2_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T3_Tyre_Populator() {
  Counter = 0;
  var repeat_end3 = (getObjectProperty(___arguments.context.pageData, 'T3_Total_Tyres')) + 1;
  for (var count4 = 0; count4 < repeat_end3; count4++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T3_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T3_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T1_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e354ebd7a4bdff6b79d49f7a3d19cf6', true);
  }
}

/**
 * Describe this function...
 */
async function T1_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0583c16836065a466adb818cd7feb7cd', true);
  }
}

/**
 * Describe this function...
 */
async function T2_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a67f3ab76caa7d5c6fa6941b3e018c5f', true);
  }
}

/**
 * Describe this function...
 */
async function T2_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc58b9e94a283c651507b1cccb9a92db', true);
  }
}

/**
 * Describe this function...
 */
async function T3_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3c1e709cbdf289adfeaa2d8dc7b6141', true);
  }
}

/**
 * Describe this function...
 */
async function T3_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b446196ecbf44e7eb9b52cfc06d13ac', true);
  }
}


  Rig = null;
  ___arguments.context.pageData['Horse'] = null;
  ___arguments.context.pageData['Horse_Steer'] = null;
  ___arguments.context.pageData['Horse_SD'] = null;
  ___arguments.context.pageData['Horse_DD'] = null;
  ___arguments.context.pageData['T1'] = null;
  ___arguments.context.pageData['T1_SW'] = null;
  ___arguments.context.pageData['T1_DW'] = null;
  ___arguments.context.pageData['T2'] = null;
  ___arguments.context.pageData['T2_SW'] = null;
  ___arguments.context.pageData['T2_DW'] = null;
  ___arguments.context.pageData['T3'] = null;
  ___arguments.context.pageData['T3_SW'] = null;
  ___arguments.context.pageData['T3_DW'] = null;
  ___arguments.context.pageData['Horse_Tyres'] = null;
  ___arguments.context.pageData['T1_Tyres'] = null;
  ___arguments.context.pageData['T2_Tyres'] = null;
  ___arguments.context.pageData['T3_Tyres'] = null;
  ___arguments.context.pageData['Horse_Total_Tyres'] = [];
  ___arguments.context.pageData['T1_Total_Tyres'] = [];
  ___arguments.context.pageData['T2_Total_Tyres'] = [];
  ___arguments.context.pageData['T3_Total_Tyres'] = [];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  await Axle_Clear();
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c2d4f0b561fd0c723374abd58b625e11', null);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('92bcb6b56e3bbd24d9cc6534582e8e94', null);
  await Tyre_Clear();
  ___arguments.context.pageData['Rig_Create'] = false;
  ___arguments.context.pageData['H_Create'] = false;
  ___arguments.context.pageData['T1_Create'] = false;
  ___arguments.context.pageData['T2_Create'] = false;
  ___arguments.context.pageData['T3_Create'] = false;
  ___arguments.context.pageData['Type_Selected'] = 'Trailer';
  Trailer = (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments.value,'\''].join(''))).setPageSize(1))).map(async item => {; return ({ 'objectId': (getObjectProperty(item, 'objectId')),'Fleet_ID': (getObjectProperty(item, 'Fleet_ID')),'Trailer_Registration': (getObjectProperty(item, 'Trailer_Registration')),'Axle_Number_Single_Wheel': (getObjectProperty(item, 'Axle_Number_Single_Wheel')),'Axle_Number_Double_Wheel': (getObjectProperty(item, 'Axle_Number_Double_Wheel')),'Trailer_Position': (getObjectProperty(item, 'Trailer_Position')) });})))[0];
  if ((getObjectProperty(Trailer, 'Trailer_Position')) == 'T1') {
    try {
      ___arguments.context.pageData['T1'] = (getObjectProperty(Trailer, 'Trailer_Registration'));
      ___arguments.context.pageData['T1_SW'] = (getObjectProperty(Trailer, 'Axle_Number_Single_Wheel'));
      ___arguments.context.pageData['T1_DW'] = (getObjectProperty(Trailer, 'Axle_Number_Double_Wheel'));

    } catch (error) {

    }
    try {
      ___arguments.context.pageData['T1_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(Trailer, 'Trailer_Registration')),'\''].join(''))).setSortBy('Tyre_Position').setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

    } catch (error) {

    }
    console.log('abc');
    ___arguments.context.pageData['T1_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T1_DW')) * 4);
    console.log('abc');
    await T1_Tyre_Populator();
    await T1_SW();
    await T1_DW();
    if ((getObjectProperty(___arguments.context.pageData, 'T1_Tyres')).length == 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', true);
      ___arguments.context.pageData['T1_Create'] = true;
    }
  }
  if ((getObjectProperty(Trailer, 'Trailer_Position')) == 'T2') {
    try {
      ___arguments.context.pageData['T2'] = (getObjectProperty(Trailer, 'Trailer_Registration'));
      ___arguments.context.pageData['T2_SW'] = (getObjectProperty(Trailer, 'Axle_Number_Single_Wheel'));
      ___arguments.context.pageData['T2_DW'] = (getObjectProperty(Trailer, 'Axle_Number_Double_Wheel'));

    } catch (error) {

    }
    try {
      ___arguments.context.pageData['T2_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(Trailer, 'Trailer_Registration')),'\''].join(''))).setSortBy('Tyre_Position').setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

    } catch (error) {

    }
    ___arguments.context.pageData['T2_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T2_DW')) * 4);
    await T2_SW();
    await T2_DW();
    await T2_Tyre_Populator();
    if ((getObjectProperty(___arguments.context.pageData, 'T2_Tyres')).length == 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', true);
      ___arguments.context.pageData['T2_Create'] = true;
    }
  }
  if ((getObjectProperty(Trailer, 'Trailer_Position')) == 'T3') {
    try {
      ___arguments.context.pageData['T3'] = (getObjectProperty(Trailer, 'Trailer_Registration'));
      ___arguments.context.pageData['T3_SW'] = (getObjectProperty(Trailer, 'Axle_Number_Single_Wheel'));
      ___arguments.context.pageData['T3_DW'] = (getObjectProperty(Trailer, 'Axle_Number_Double_Wheel'));

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.pageData['T3_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(Trailer, 'Trailer_Registration')),'\''].join(''))).setSortBy('Tyre_Position').setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

    } catch (error) {

    }
    ___arguments.context.pageData['T3_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T3_DW')) * 4);
    await T3_SW();
    await T3_DW();
    await T3_Tyre_Populator();
    if ((getObjectProperty(___arguments.context.pageData, 'T3_Tyres')).length == 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', true);
      ___arguments.context.pageData['T3_Create'] = true;
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/45ebd82eafeace129282d7ad08fc09ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Counter, Brand_Number, error, item, OwnerId, Tyre_Brand, New_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Steer_Populator() {
  var repeat_end = (getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) * 2;
  for (var count = 0; count < repeat_end; count++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'Horse')),[`Type`]: 'Steer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 100000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function Drive_SW_Populator() {
  Counter = 6;
  var repeat_end2 = (getObjectProperty(___arguments.context.pageData, 'Horse_SD')) * 2;
  for (var count2 = 0; count2 < repeat_end2; count2++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'Horse')),[`Type`]: 'Drive',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 90000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function Drive_DW_Populator() {
  Counter = 12;
  var repeat_end3 = (getObjectProperty(___arguments.context.pageData, 'Horse_DD')) * 4;
  for (var count3 = 0; count3 < repeat_end3; count3++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'Horse')),[`Type`]: 'Drive',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 90000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T1_SW_Populator() {
  Counter = 24;
  var repeat_end4 = (getObjectProperty(___arguments.context.pageData, 'T1_SW')) * 2;
  for (var count4 = 0; count4 < repeat_end4; count4++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T1')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 120000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T1_DW_Populator() {
  Counter = 36;
  var repeat_end5 = (getObjectProperty(___arguments.context.pageData, 'T1_DW')) * 4;
  for (var count5 = 0; count5 < repeat_end5; count5++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T1')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 120000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T2_SW_Populator() {
  Counter = 60;
  var repeat_end6 = (getObjectProperty(___arguments.context.pageData, 'T2_SW')) * 2;
  for (var count6 = 0; count6 < repeat_end6; count6++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T2')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 120000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T2_DW_Populator() {
  Counter = 72;
  var repeat_end7 = (getObjectProperty(___arguments.context.pageData, 'T2_DW')) * 4;
  for (var count7 = 0; count7 < repeat_end7; count7++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T2')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 120000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T3_SW_Populator() {
  Counter = 96;
  var repeat_end8 = (getObjectProperty(___arguments.context.pageData, 'T3_SW')) * 2;
  for (var count8 = 0; count8 < repeat_end8; count8++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T3')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 12000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T3_DW_Populator() {
  Counter = 108;
  var repeat_end9 = (getObjectProperty(___arguments.context.pageData, 'T3_DW')) * 4;
  for (var count9 = 0; count9 < repeat_end9; count9++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T3')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 120000,[`Current_Mileage`]: 0,[`Cost`]: 4500 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'Rig_Create')) == true) {
    OwnerId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
    Tyre_Brand = String((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'Customer')).slice(0, 4)) + String(' T ');
    try {
      Brand_Number = (await BackendlessUI.Functions.Custom['fn_fa967009987c607bdead79e8a14b3d7d']('Tyres', (['ownerId = \'',OwnerId,'\''].join('')), 'Tyre_Number', 'desc'))[0];
      console.log(Brand_Number);

    } catch (error) {
      console.log(error);

    } finally {
      if ((typeof Brand_Number === 'number' && !isNaN(Brand_Number)) == false) {
        Brand_Number = 0;
      }

    }
    Counter = 0;
    await Steer_Populator();
    await Drive_DW_Populator();
    await Drive_SW_Populator();
    await T1_SW_Populator();
    await T1_DW_Populator();
    await T2_SW_Populator();
    await T2_DW_Populator();
    await T3_SW_Populator();
    await T3_DW_Populator();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'H_Create')) == true) {
    OwnerId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
    Tyre_Brand = String((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'Customer')).slice(0, 4)) + String(' T ');
    try {
      Brand_Number = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',OwnerId,'\''].join(''))).setSortBy('Tyre_Number desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tyre_Number'));})))[0];
      console.log(Brand_Number);

    } catch (error) {
      console.log(error);

    } finally {
      if ((typeof Brand_Number === 'number' && !isNaN(Brand_Number)) == false) {
        Brand_Number = 0;
      }

    }
    Counter = 0;
    await Steer_Populator();
    await Drive_DW_Populator();
    await Drive_SW_Populator();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'T1_Create')) == true) {
    OwnerId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
    Tyre_Brand = String((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'Customer')).slice(0, 4)) + String(' T ');
    try {
      Brand_Number = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',OwnerId,'\''].join(''))).setSortBy('Tyre_Number desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tyre_Number'));})))[0];
      console.log(Brand_Number);

    } catch (error) {
      console.log(error);

    } finally {
      if ((typeof Brand_Number === 'number' && !isNaN(Brand_Number)) == false) {
        Brand_Number = 0;
      }

    }
    Counter = 0;
    await T1_SW_Populator();
    await T1_DW_Populator();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'T2_Create')) == true) {
    OwnerId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
    Tyre_Brand = String((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'Customer')).slice(0, 4)) + String(' T ');
    try {
      Brand_Number = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',OwnerId,'\''].join(''))).setSortBy('Tyre_Number desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tyre_Number'));})))[0];

    } catch (error) {

    } finally {
      if ((typeof Brand_Number === 'number' && !isNaN(Brand_Number)) == false) {
        Brand_Number = 0;
      }

    }
    Counter = 0;
    await T2_SW_Populator();
    await T2_DW_Populator();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'T3_Create')) == true) {
    OwnerId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
    Tyre_Brand = String((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'Customer')).slice(0, 4)) + String(' T ');
    try {
      Brand_Number = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',OwnerId,'\''].join(''))).setSortBy('Tyre_Number desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tyre_Number'));})))[0];
      console.log(Brand_Number);

    } catch (error) {
      console.log(error);

    } finally {
      if ((typeof Brand_Number === 'number' && !isNaN(Brand_Number)) == false) {
        Brand_Number = 0;
      }

    }
    Counter = 0;
    await T3_SW_Populator();
    await T3_DW_Populator();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0122187ce2fb2374bccefc73ebe2e7ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '1';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\' AND Retread_List <> \'Yes\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f169871dbd8dcf0552d4f88729a4ae95/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '1';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f169871dbd8dcf0552d4f88729a4ae95'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f169871dbd8dcf0552d4f88729a4ae95'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3c7ccfea94a279cb82084d5867ad3b59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre1')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9dd6c2dadd19158375df6ef19a9ade59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '2';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/aa39deda3b4c9b23ba1dc8642f7b4b21/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Style, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '2';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa39deda3b4c9b23ba1dc8642f7b4b21'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa39deda3b4c9b23ba1dc8642f7b4b21'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6927c6ae5e9b14ad70060ec92beadfcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre2')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0f250027400ab7ed4204a552b7628eeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '3';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9d4486c7d2b7c5b3b099226aae557ff6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '3';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9d4486c7d2b7c5b3b099226aae557ff6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9d4486c7d2b7c5b3b099226aae557ff6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0e8230f2852501c61b14f0597f675948/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre1')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/bc669dd9873c772fbbc4ead18bc351a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '4';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1a0e76066cebb4c47b6f466903966a63/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '4';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a0e76066cebb4c47b6f466903966a63'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a0e76066cebb4c47b6f466903966a63'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6bc33e3907b5c4d2858f78aef90a413b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre1')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f0a26dfaf35fa8516cde66d403643de2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '5';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/d8ce63d67cc5a6ced1271045f772eb03/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '5';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8ce63d67cc5a6ced1271045f772eb03'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8ce63d67cc5a6ced1271045f772eb03'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/32133403e6abfc7e85b291738a38ff43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre6')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/14848336bd5c34f64b5382b8c06cf824/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '6';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ce558705af0c5f08144bfe6df0834b24/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '6';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce558705af0c5f08144bfe6df0834b24'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce558705af0c5f08144bfe6df0834b24'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/987d801700999bf2857d6cbca27b027f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre6')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8f370082decf9288e6cc5537a95c51dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '7';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f4d63265d4e4737f1215116e3e02e451/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '7';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4d63265d4e4737f1215116e3e02e451'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4d63265d4e4737f1215116e3e02e451'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/de62ae9e76990055547e2807849a13f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(7);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/861c795ce9992c1ce52347e2914dd8ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '8';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a3e95bd5f6579a3a71996afae7dc35bc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '8';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3e95bd5f6579a3a71996afae7dc35bc'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3e95bd5f6579a3a71996afae7dc35bc'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1601139248b56eb4e1da5b5af45e7c94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(8);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b746b79749cb5dbc5feac7591c97c86c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '9';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/55655207195d01836e52f0f333e37f12/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '9';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55655207195d01836e52f0f333e37f12'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55655207195d01836e52f0f333e37f12'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0d07c5babb3ce9cca51bd83287772e56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(9);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a487d8b22ef474368fad1f6c71fce703/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '10';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f86d1df518b88e5c8b2b256accb8daea/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '9';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f86d1df518b88e5c8b2b256accb8daea'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f86d1df518b88e5c8b2b256accb8daea'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ab434d279d296347d37d8dee32aa6c6a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(10);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a61763f5445522146a0416ee489d4ddf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '11';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1bd7be3dce280b36117575d3d0dfc415/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '11';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bd7be3dce280b36117575d3d0dfc415'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bd7be3dce280b36117575d3d0dfc415'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b97f8d03076cd7a4907f3b2fd8ecfe81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(11);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6a2f3c083cf7e919a6bda679ccad0374/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '12';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a7058ec17bdf79ca96b7b7e5dc9ecf03/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '12';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7058ec17bdf79ca96b7b7e5dc9ecf03'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7058ec17bdf79ca96b7b7e5dc9ecf03'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/64e6f332a51e7bdb89e91a3b03cb9fd7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(12);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b5098b2a0e94209702d2d2b6e01e0a48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '13';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Retread_List <> \'Yes\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/56195035b7fb8e7f54c70b8a0a0ab0b9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '13';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('56195035b7fb8e7f54c70b8a0a0ab0b9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('56195035b7fb8e7f54c70b8a0a0ab0b9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9be56cac9df99704153fbc554e76811d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(13);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/7efd177a074ba5b83abe608d10b9fe19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '14';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2e36ac0acf96e1256ac5a83e6fe45cb7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '14';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36ac0acf96e1256ac5a83e6fe45cb7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36ac0acf96e1256ac5a83e6fe45cb7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f6f735c16a3c5647914bab0de0aba022/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(14);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/88d9098dc814777bf029324f3aade901/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '15';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/23b75e6f9c4c4e15f576230cd50f3e03/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '15';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('23b75e6f9c4c4e15f576230cd50f3e03'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('23b75e6f9c4c4e15f576230cd50f3e03'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2ee8b3720c096f3c7362b167b8e9b773/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(15);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c18b11efb5840de18c531fe4de139ea3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '16';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/33161804a793ac9edcf1be940a0f0516/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '16';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('33161804a793ac9edcf1be940a0f0516'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('33161804a793ac9edcf1be940a0f0516'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e99831942fec357bc038ae3937a98ce4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(16);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/39f83bff5006a5577035669b46cb0a85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '17';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/7c09d924d7f518d3d55ebf0cc1eb1af9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '17';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c09d924d7f518d3d55ebf0cc1eb1af9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c09d924d7f518d3d55ebf0cc1eb1af9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/bdeace4838fa2c61c3bb528f1886fb74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(17);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1646fd51458f540625b723c14bf8b5db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '18';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/aee2c2c772f63b870db361a8255723b6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '18';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aee2c2c772f63b870db361a8255723b6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aee2c2c772f63b870db361a8255723b6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6e0dda5241c9820b12c3f3a805f10dde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(18);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/cbfec65acc7fc08ad5160709bea8cdeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '19';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ae9cd158bb89281423b3aee457edcd46/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '19';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ae9cd158bb89281423b3aee457edcd46'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ae9cd158bb89281423b3aee457edcd46'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0a7167682a7f6105e2b1f58ac84d8db9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(19);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2d8626c6d88e54d46ba7b7bbb8d17cd2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '20';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/69fb8c086e844d712a1fdf8c0d1842a8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '20';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('69fb8c086e844d712a1fdf8c0d1842a8'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('69fb8c086e844d712a1fdf8c0d1842a8'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/de6d498f92753f4b48731c34468b4631/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(20);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/157fa81d94885ab7bc2d7a8366c497c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '21';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/dbc3e1945c08fefe661905ff3624dc77/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '21';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dbc3e1945c08fefe661905ff3624dc77'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dbc3e1945c08fefe661905ff3624dc77'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/82d2e942abddbf89a9cae4b4d93f7636/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(20);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f0c4a4dd0a143e6ec03512db5eef6e95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '22';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/22c36b7e5bee59030c76a7cf112f50c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '22';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22c36b7e5bee59030c76a7cf112f50c4'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22c36b7e5bee59030c76a7cf112f50c4'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/df9cdfbb0297dd6c1fa97e48e00d9e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(22);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/edd5557304987aeb39aaf9165e78946f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '23';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/daf50e381b2be516110651c483a327f1/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '23';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('daf50e381b2be516110651c483a327f1'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('daf50e381b2be516110651c483a327f1'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/5cb1ebf5cff9505d3b43d1addc626ed9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(23);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/245fac5a1d1146e213d6648b484ecbe7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '24';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e5877c9cddcc6a2913db1a2e7f2b8a29/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '24';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e5877c9cddcc6a2913db1a2e7f2b8a29'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e5877c9cddcc6a2913db1a2e7f2b8a29'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8f0c5d7301023eaae13adef7572d704d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(24);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/82d4ca21cd6439f76e6dcf276ddb8338/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '25';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/93bec6f9f95d58216b6977a749beb7f4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '25';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('93bec6f9f95d58216b6977a749beb7f4'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('93bec6f9f95d58216b6977a749beb7f4'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3b0de6be644883ccffdfb79a6dc138f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(25);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/fbc6d8525533918de1844da6a32e0b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '26';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1db5b1678bdc7a9463f19e6ba0976b85/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '26';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1db5b1678bdc7a9463f19e6ba0976b85'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1db5b1678bdc7a9463f19e6ba0976b85'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f436e09b7ec16a08a68acf9ce7e46475/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(26);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/047829ce8c3f5a473417c2e6c4d69aea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '27';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/5ef39633fbee8f767cf8743e6858d8ad/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '27';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ef39633fbee8f767cf8743e6858d8ad'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ef39633fbee8f767cf8743e6858d8ad'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/82e83427746fe71b1531ede8b25c792f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(27);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8db449046caad04535d2f62336913f58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '28';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/370a7b597643d87dafb4f092487fb0c7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '28';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('370a7b597643d87dafb4f092487fb0c7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('370a7b597643d87dafb4f092487fb0c7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b1bb81ee0ef19b033398e1eacd11dc92/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(28);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/747a528c76abc689c34bdf1f01eba37b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '29';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/57da9142508a37c612695461b7c48828/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '29';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57da9142508a37c612695461b7c48828'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57da9142508a37c612695461b7c48828'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c4e2ac0fc587e098ffb186341b591ea3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(29);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/d39acfb2260d3fc5944dc5dd98bf065f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '30';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0f7c43cad46172d2de8d14e837b458a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '30';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0f7c43cad46172d2de8d14e837b458a6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0f7c43cad46172d2de8d14e837b458a6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/aff2879311a275379d8750145168bde1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(30);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a83be573295fd6778cace78542aad61f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '31';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/101324aadb5cff32105f04ed97d70b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '31';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('101324aadb5cff32105f04ed97d70b5b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('101324aadb5cff32105f04ed97d70b5b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9a1e274c663c0cfe53698a2fb79d7b4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(31);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/83a5b9ec873c5dabffe51c02603c8a7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '32';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/fed5c74335318d35d464d92ebffa92ce/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '32';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fed5c74335318d35d464d92ebffa92ce'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fed5c74335318d35d464d92ebffa92ce'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/30a4351a7ede240f8a4e7042086b12f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(32);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3f770072bffbb6e50c9266827869e5ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '33';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ed1a18023975c735b253be95e4d5a71e/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '33';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ed1a18023975c735b253be95e4d5a71e'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ed1a18023975c735b253be95e4d5a71e'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/254d7326dbba8962d9e4f3e5875da0d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(33);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8192f8028c01924b6492201c38e3f138/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '34';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/dce549feebf8e943f914b7ebe63b539e/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '34';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce549feebf8e943f914b7ebe63b539e'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce549feebf8e943f914b7ebe63b539e'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/54334ee221ff9fb1d7b2f616aa0f12ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(34);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b6ea6854160f085ddb96766ac47760b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '35';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/67a6639bb48f28d7dd3ee5a22febaca2/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '35';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('67a6639bb48f28d7dd3ee5a22febaca2'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('67a6639bb48f28d7dd3ee5a22febaca2'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0f3fd74cb9961b74f6e492d73b3ba692/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(35);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a4dfbe29eb6cb1f7cbd6f11433786b49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '36';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/7c89c464f20f88fe3c7ed72723bf6f02/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '36';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c89c464f20f88fe3c7ed72723bf6f02'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c89c464f20f88fe3c7ed72723bf6f02'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2002625b5239547966ba70e39a1dc4f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(36);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/458cf746b08cd5424083b975dd0b67de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '37';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a2a5d01bd257c1ed79b894a1b3516c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '37';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a2a5d01bd257c1ed79b894a1b3516c7a'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a2a5d01bd257c1ed79b894a1b3516c7a'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6992c39bba6b8dcf27952575a60a9ab8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(37);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c6f8267591e9d13e940c0455b28db1b1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '38';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/238cf98dd228eff107937d320739f337/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '38';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('238cf98dd228eff107937d320739f337'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('238cf98dd228eff107937d320739f337'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6719a7d9d08f6e4242ce78ffbe627596/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(38);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1e37420ceafda3d4452cc577858c56b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '39';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6bc75b11f984206f1ecceabbf159853c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '39';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6bc75b11f984206f1ecceabbf159853c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6bc75b11f984206f1ecceabbf159853c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/80f7ed2e24e3cb96d977cc09264a0803/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(39);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1c14b9ec87feddd86fdb2131bffbbd26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '40';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2c82109c0bdecc96558e13a7a89773f3/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '40';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2c82109c0bdecc96558e13a7a89773f3'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2c82109c0bdecc96558e13a7a89773f3'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/72a223ac98237fba5401da4405d5feb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(40);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2581e1c4ff2f83ba1056c9728b76835d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '41';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9ef22a1ac24e8eb109bfe54a7668a836/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '41';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9ef22a1ac24e8eb109bfe54a7668a836'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9ef22a1ac24e8eb109bfe54a7668a836'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e76a518458e960edf1ec843de00d1d59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(41);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1f7d193f207f251bdb6c6f7d2eb40296/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '42';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c76655f52715aa8c0e39a119cdac5a4f/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '42';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c76655f52715aa8c0e39a119cdac5a4f'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c76655f52715aa8c0e39a119cdac5a4f'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3f4b872ac401931b3888fbfc40c19632/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(42);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e6ba1bdd1595f03882b1c1a88527949d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '43';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/921b801b5acdf89fe2bac251d6073669/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '43';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('921b801b5acdf89fe2bac251d6073669'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('921b801b5acdf89fe2bac251d6073669'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/57c41e97be8d88c90d54292ca3d1749d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(43);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/854b6db7d917ea9fd2543565f3fec6da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '44';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6f4beb312a1f9699397330a2d2ac2b72/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '44';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6f4beb312a1f9699397330a2d2ac2b72'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6f4beb312a1f9699397330a2d2ac2b72'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/228b57ef590204087d782a9f45f1a705/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(44);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/fa9de93564ee8d8670445a5a0f6d8bf2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '45';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c805a846e4d524fc0f4ef106249557d7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '45';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c805a846e4d524fc0f4ef106249557d7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c805a846e4d524fc0f4ef106249557d7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0fff2a7720541e24f4e59ad32f6ca3da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(45);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/49bccc52244f963f50068946a33a6946/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '46';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/d065c7decff6aa8212586c1e3b9a950d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '46';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d065c7decff6aa8212586c1e3b9a950d'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d065c7decff6aa8212586c1e3b9a950d'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/36f12a01acdffd72bca7dcdd49b4939a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(46);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/944697b62fd1555831ca315348e16528/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '47';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c7cab948b7e77bc5979750fc6ab81169/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '47';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7cab948b7e77bc5979750fc6ab81169'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7cab948b7e77bc5979750fc6ab81169'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6508f6049466ffdf1473c119854a4169/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(47);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/bd2faf7bef8aa366e0894adb8113671f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '48';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/789201d1a023de7a4b171294c52c1f5a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '48';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('789201d1a023de7a4b171294c52c1f5a'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('789201d1a023de7a4b171294c52c1f5a'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f85dbc55adaf4f0306458a7a5454dc91/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(48);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/4493c9ab965f70dc1e186bb9e77a6977/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '49';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/96ba6f78557fb3a5fcd5577c1c12de54/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '49';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96ba6f78557fb3a5fcd5577c1c12de54'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96ba6f78557fb3a5fcd5577c1c12de54'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/bd8a86b734cce81bfdb45d9acff2af6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(49);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/87c40196837a45c84d5138148e7b3389/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '50';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2eb8e668f0e92049c83f33ca6fe49115/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '50';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2eb8e668f0e92049c83f33ca6fe49115'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2eb8e668f0e92049c83f33ca6fe49115'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/df728955bf5c77949d8923c6493d7832/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(50);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/aa11a815b10f098c11aaa89f4911faa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '51';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3b57832fe5840be57eb4e0ea6ea3982c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '51';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3b57832fe5840be57eb4e0ea6ea3982c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3b57832fe5840be57eb4e0ea6ea3982c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1396e64a9559f016db8a50aca44220bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(51);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f3e8c8918478bc6c0d4d746ccb022135/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '52';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9a6b0f771a7aa79e194cdcef3a8d99dc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '52';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a6b0f771a7aa79e194cdcef3a8d99dc'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a6b0f771a7aa79e194cdcef3a8d99dc'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1a1c8181871c26043afacbde80fce8a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(52);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ea03e1ad44a8d029dc96c8354eeea3e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '53';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/16f19838c73c2403b6e2248248c9c8d4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '53';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('16f19838c73c2403b6e2248248c9c8d4'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('16f19838c73c2403b6e2248248c9c8d4'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c636c66651c3f47b4b6307d1b59aeee6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(53);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/25664c38cbee89eedf219a45a9e64f18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '54';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/5e94ddd99472c9c6b9ad6b68fb640ce7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '54';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5e94ddd99472c9c6b9ad6b68fb640ce7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5e94ddd99472c9c6b9ad6b68fb640ce7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/00b88de8b0e7850b31432a56dc49eb23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(54);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c23262c9c17fc4d9015a2b644a6ef293/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '55';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/68ef52752953f38511a4287e36a393df/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '55';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('68ef52752953f38511a4287e36a393df'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('68ef52752953f38511a4287e36a393df'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/5fb655c54469149a8623a65828dbc89b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(55);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/78ec8646454fe04b2d32e5aeb51c3207/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '56';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ee9d5c9eb8a7254d7304b211a158078c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '56';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee9d5c9eb8a7254d7304b211a158078c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee9d5c9eb8a7254d7304b211a158078c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/13e1d5e6734cfdbde77502a72e314a1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(56);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e14b53677352a044f84fd1095f3e7049/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '57';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/818297b98afbff6416b1bb3e3ef99969/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '57';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('818297b98afbff6416b1bb3e3ef99969'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('818297b98afbff6416b1bb3e3ef99969'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9d8157af7cbd379140baf43413a38833/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(57);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9676d11a46265a7c5e5721fbeb47cd5f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '58';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e4c274e9f838a98e743e5551954b3b99/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '58';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e4c274e9f838a98e743e5551954b3b99'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e4c274e9f838a98e743e5551954b3b99'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/22f11149db211e94b814f6b7636a5dd1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(58);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/4faad0db2d8f72a3b9e3eb7e2ba18c49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '59';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1b48bf4c8197130cdc8bfefc5934b97e/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '59';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1b48bf4c8197130cdc8bfefc5934b97e'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1b48bf4c8197130cdc8bfefc5934b97e'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/4c929d3bb112eb391efd8e43ad75781e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(59);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/184d0b82f4365074b1213e7d0c67307d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '60';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/83719e5478e5fc0ef3a804e23b3ba194/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '60';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83719e5478e5fc0ef3a804e23b3ba194'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83719e5478e5fc0ef3a804e23b3ba194'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8fa6ef942c1758e792d5a99d2826855a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(60);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ab9fd1bbcbb18e945d033f463b02767c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '61';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/520c33a5ffc9bd6aa358197f8b35a60b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '61';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('520c33a5ffc9bd6aa358197f8b35a60b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('520c33a5ffc9bd6aa358197f8b35a60b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/18c6d4fd9dfbce59f42c15d4942c2c3d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(61);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/59cd6da2906bc58a2db61edaeebd81f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '62';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0646717aa083c08aa645750ed59f1596/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '62';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0646717aa083c08aa645750ed59f1596'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0646717aa083c08aa645750ed59f1596'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0c3f94780ff68d458e8c96ea453648a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(62);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/4f24ac593a546fd5373cb2cdc259f06d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '63';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ab2fb2d769a4ef9daa133e34d34d0d2b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '63';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ab2fb2d769a4ef9daa133e34d34d0d2b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ab2fb2d769a4ef9daa133e34d34d0d2b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/682a2aa98a7cc4e3ebed3431bd2fa1f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(63);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/fe34ca7236bbcd65ae7aa9f7de564167/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '64';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/35720519667520da1a968dd7e4b9d8c9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '64';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35720519667520da1a968dd7e4b9d8c9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35720519667520da1a968dd7e4b9d8c9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/97a61689fd271169eeb646111bcc251f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(64);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2f4bdec114c4e5f1220dae98f4b42df7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '65';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/479f753ad466fd7aaff77d4f54045fcf/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '65';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('479f753ad466fd7aaff77d4f54045fcf'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('479f753ad466fd7aaff77d4f54045fcf'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c2646138c9ad7936e699a6df6c883abd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(65);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6f2598669c39d7ddcd93d7ff16256cde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '66';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b07172fa1337260ece5b0c738658bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '66';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07172fa1337260ece5b0c738658bcd8'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07172fa1337260ece5b0c738658bcd8'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/281d89fd04a869b89f4de70562942c7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(66);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/fb363e21b0cb6f7eb845d989ea5ce8be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '67';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ce037756d29659e6fe9c64ac278f7c38/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '67';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce037756d29659e6fe9c64ac278f7c38'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce037756d29659e6fe9c64ac278f7c38'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/68aa7a476f0cb45b406e02e93d0510ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(67);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/293faf861ce7e36187e4e8530f4dcb23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '68';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/d5af7e9b448c2f6d5428db2a4daad7e9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '68';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5af7e9b448c2f6d5428db2a4daad7e9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5af7e9b448c2f6d5428db2a4daad7e9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/aa3f91298d8f3979f79febd1b04409d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(68);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/4a2bde8b8092e135ad419bdd5637e127/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '69';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/88830ed8d62b90c3b9a83e81f6ab948e/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '69';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('88830ed8d62b90c3b9a83e81f6ab948e'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('88830ed8d62b90c3b9a83e81f6ab948e'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/62781d9babf34e92724783277d22a52f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(69);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/4bef6676b6cc48126e427481c3764c98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '70';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/736553e89eafcd18f599ae9ba5231112/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '70';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('736553e89eafcd18f599ae9ba5231112'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('736553e89eafcd18f599ae9ba5231112'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8edbf59eb8c42b91e3087fe81c4122f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(70);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8484e4faa9650f0cbb879162b1ffe362/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '71';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1c5b4141bef5007bc212c0ab0f12161c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '71';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c5b4141bef5007bc212c0ab0f12161c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c5b4141bef5007bc212c0ab0f12161c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6a5ca6cf7ed151a268a90e98d9a36772/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(70);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/87edbc05922a5145e0a76d1cc33f88d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '72';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/85f8472e82374b7cefcaeeeeb6976c52/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '72';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85f8472e82374b7cefcaeeeeb6976c52'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85f8472e82374b7cefcaeeeeb6976c52'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/d6f5a4e1c93e14f11b3a63313e6b8a76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(72);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c2fe2943173910168c2b04faf5ef23f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '73';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/363f877733d2bd2d1da4c71961aa4ac4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '73';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('363f877733d2bd2d1da4c71961aa4ac4'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('363f877733d2bd2d1da4c71961aa4ac4'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b4cd159324f73accb2742dd14f2a7128/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(73);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3bf5d8f14c85b867d79ba21cbf7f1785/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '74';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b802ca84d595b107703ab57436fdbab7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '74';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b802ca84d595b107703ab57436fdbab7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b802ca84d595b107703ab57436fdbab7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/4fbdcd2ed0326fef3a5625873469447d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(74);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9b7444758c0edd6f67f20523bffc55f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '75';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ddd76116c489180cb0b4ff7c6fb4e77f/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '75';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ddd76116c489180cb0b4ff7c6fb4e77f'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ddd76116c489180cb0b4ff7c6fb4e77f'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6521497a4628dacef475cd666a56582d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(75);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/930f401dd61dc71ed37530f702a5b683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '76';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b592cf24e3d4754c20bcc5064685b4cf/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '76';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b592cf24e3d4754c20bcc5064685b4cf'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b592cf24e3d4754c20bcc5064685b4cf'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0b0bea63cacf0e892762cc9908f4c2f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(76);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f24e22a86af77c42fbd657f34959c29a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '77';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/efd6bc2ae7cad2a7b2cc864c9429ab96/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '77';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('efd6bc2ae7cad2a7b2cc864c9429ab96'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('efd6bc2ae7cad2a7b2cc864c9429ab96'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/661234ba0cdd60857e95b86a0973e7e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(77);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/55dd8e296427dece02ed0367afb804a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '78';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6689939dda3b9e55c86ee943699d62b7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '78';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6689939dda3b9e55c86ee943699d62b7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6689939dda3b9e55c86ee943699d62b7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c618b28d4845ffa3721d40e56ffc3976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(78);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0d3bc94ce137a9621afa3c3b79f1c9fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '79';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/98c6f618d7c9731244990979da111a6a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '79';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('98c6f618d7c9731244990979da111a6a'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('98c6f618d7c9731244990979da111a6a'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0d7c9f065d1311c64e71cf4a80b532b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(79);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9e642f5d403eb45bd5e137d261a33c14/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '80';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/5b77e3276116a97466515c21c6d4dfbb/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '80';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5b77e3276116a97466515c21c6d4dfbb'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5b77e3276116a97466515c21c6d4dfbb'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/5ceabb7129dacb811c2f2d54ad637c44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(80);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b89f7d1648bce0e4c65e1cc1a0dce555/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '81';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/31de661941b80e9868242db474dc2fab/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '81';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('31de661941b80e9868242db474dc2fab'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('31de661941b80e9868242db474dc2fab'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c939f0f236ba4e99336e86cfe7532de4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(81);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b94a62e158a30a6a64933f5225829022/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '82';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/83451da6780364721c514f3e00bba1d6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '82';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83451da6780364721c514f3e00bba1d6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83451da6780364721c514f3e00bba1d6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/063ca043fc86eb3c5b48708c276e0566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(81);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/d92d9496586f792921095014b27bf264/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '83';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a591dbef207b0b3aceba585b0daa0cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '83';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a591dbef207b0b3aceba585b0daa0cd9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a591dbef207b0b3aceba585b0daa0cd9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/81316ed699c1425cd728c85beef228d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(83);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/87e52a732ff8861892ba2f0482337847/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '84';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/53dd21dae67bf089258c75fe700a827c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '84';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53dd21dae67bf089258c75fe700a827c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53dd21dae67bf089258c75fe700a827c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/02e9664a72692a620f4ac4c2b35354e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(84);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/478cd98fe7767aecc3998d259f121df2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '85';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/7b4e2deb9743379946573f080d73cdd5/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '85';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7b4e2deb9743379946573f080d73cdd5'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7b4e2deb9743379946573f080d73cdd5'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a71ccf033176d12d9c24b42a85bad016/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(85);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/720587f922ea18484a1be8862eafd237/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '86';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f64c7c7498da39de5a3e4c0fba6b2665/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '86';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f64c7c7498da39de5a3e4c0fba6b2665'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f64c7c7498da39de5a3e4c0fba6b2665'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e9e1b2bc4a439a22574fe31c18690463/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(86);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8ad10da74f5dbb21de013d82e0920fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '87';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8f2c5f2361e8b2db5465191eceaabf9b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '87';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2c5f2361e8b2db5465191eceaabf9b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2c5f2361e8b2db5465191eceaabf9b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/27c40a710f7a5778fd9caea948a14e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(86);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/45b84948e0c516879f1fe89f462324a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '88';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/311ccd5aabe464a3939e929e0e493c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '88';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('311ccd5aabe464a3939e929e0e493c7a'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('311ccd5aabe464a3939e929e0e493c7a'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/caa857384acd20d47be6f1f67a5e49f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(88);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/79ede9c195ee7dc2cbbbcc0187fac85f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '89';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/aa1d14e86809a8469d679d8b63c9777e/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '89';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa1d14e86809a8469d679d8b63c9777e'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa1d14e86809a8469d679d8b63c9777e'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/46a184945797ea038017f26dd2292ef7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(89);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e3e6d968aefaa7a8f722269359c62b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '90';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/54225e4b1f250593c5b17815c3250b2b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '90';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('54225e4b1f250593c5b17815c3250b2b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('54225e4b1f250593c5b17815c3250b2b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/99242ed87d4d8e920693bce2b34b274a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(89);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/23cf9311c0bb891685fcafa33a060b3c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '91';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ffcb750d949636023d7576a505e28942/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '91';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffcb750d949636023d7576a505e28942'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffcb750d949636023d7576a505e28942'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/09dfa7cdc3e9c10cf055a7713fdbfc2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(91);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/54a364e8cac5f88691a31d07a6c4b23c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '92';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/d127635d9d5e3ce5154a17c326b18832/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '92';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d127635d9d5e3ce5154a17c326b18832'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d127635d9d5e3ce5154a17c326b18832'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/bc81f24ffbd2f1860ea95911837eda66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(92);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2b3dad29fbeead8e8fa4666a1daae105/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '93';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/92f28ea5389453c3219e18158c117b6b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '93';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92f28ea5389453c3219e18158c117b6b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92f28ea5389453c3219e18158c117b6b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ed68ac316583cab58a7ec0f71dc64339/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(93);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3f66bf332f654857178e5c3f416dd3b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '94';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/50e5d98e8c4af7bf74d19b393009f488/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '94';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50e5d98e8c4af7bf74d19b393009f488'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50e5d98e8c4af7bf74d19b393009f488'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/61e266285bbb6d792acb7c78a0b620a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(93);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/fccda592b76d2e066b6c807d5f1a5e1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '95';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8677542390c5efbb98cff2e461c8cc72/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '95';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8677542390c5efbb98cff2e461c8cc72'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8677542390c5efbb98cff2e461c8cc72'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2269bfba9569f07788a837f3fc77d661/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(95);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3bc1724ebf08c4f463ac439accfc9b3a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '96';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2158025de73c5bffb9b9c63b061ead45/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '96';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2158025de73c5bffb9b9c63b061ead45'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2158025de73c5bffb9b9c63b061ead45'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/bffb8e56ab8e76776c26b73e6b342a35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(96);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/07d5993d24cfd6ae29fd6ccf9ab22635/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '97';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e00fbf0410e7ed8ab636b871303b7a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '97';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e00fbf0410e7ed8ab636b871303b7a4b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e00fbf0410e7ed8ab636b871303b7a4b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6221bfdc64afb7e93f1f0df561ec5698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(97);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/7463f55c3bd5e14bda2db2ac9824fa97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '98';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/84af86a644669b8c1b3724dae792bdda/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '98';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('84af86a644669b8c1b3724dae792bdda'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('84af86a644669b8c1b3724dae792bdda'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/614cdcd82ce306ef56652143796aa9c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(98);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0d4b0f289a11947e46482148ab0d9fdc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '99';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ce070a4342b861db119ee092d839dba9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '99';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce070a4342b861db119ee092d839dba9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce070a4342b861db119ee092d839dba9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/48ad1a45976fd4b2392cd6072587f4d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(99);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1d63082cf7a7c6e1074aaff7d1c17e94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '100';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ebbaa10416af816fb7d176551a5e22ef/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '100';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ebbaa10416af816fb7d176551a5e22ef'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ebbaa10416af816fb7d176551a5e22ef'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/70556edd9da5d197ccc7e35306987bf6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(100);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/066689f96394dcc8561792ee5c54ae7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '101';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0049ce3f16a1f8d101c483cab499411c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '101';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0049ce3f16a1f8d101c483cab499411c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0049ce3f16a1f8d101c483cab499411c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b8c20c086e993237c93eb4aa58cbbf71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(101);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/01a6f213a47d006800b135250bbad6ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '102';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0aa5238a2179ec6916d3514bfe66bac6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '102';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0aa5238a2179ec6916d3514bfe66bac6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0aa5238a2179ec6916d3514bfe66bac6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/bdb1c68b7b98106df0b2076e6a137387/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(102);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/03627e752fa49cf53ff799dff2f6675a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '103';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b8c3ff18bd730d9f7d86917caabc7ebd/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '103';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8c3ff18bd730d9f7d86917caabc7ebd'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8c3ff18bd730d9f7d86917caabc7ebd'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/34c58792dd74e92139d7d611dcb55b98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(102);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3aa2b95598781c7b940fe01988eb3d5c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '104';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/afd28a6359de06cacd85ffa86fb3a748/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '104';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('afd28a6359de06cacd85ffa86fb3a748'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('afd28a6359de06cacd85ffa86fb3a748'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6b4ba4fef8cf0e72c0e50b63791d3f0d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(104);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a33d790d051e5ef7eba81b1b58a1717c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '105';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/acdb7ae7620c02014416fe5ba82481c5/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '105';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('acdb7ae7620c02014416fe5ba82481c5'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('acdb7ae7620c02014416fe5ba82481c5'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b135f8ca3fff5df1486a575a430423eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(104);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/043e7057eba3b98fb612aaedf4bd7d14/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '106';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/bffb88532e8219d1591dbbf96fd69fa2/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '106';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bffb88532e8219d1591dbbf96fd69fa2'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bffb88532e8219d1591dbbf96fd69fa2'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f35bfd1c96c4b91e0b788a17c5d6d0ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(106);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/0607d2b957250a9c49a5fc41f7bbadf1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '107';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/340c9d7aabebba3d843be4e26f516187/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '107';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('340c9d7aabebba3d843be4e26f516187'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('340c9d7aabebba3d843be4e26f516187'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f472f4a8fd4c1664bd156391ef7ed1c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(107);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/13e8570345215a164ff66664b948b313/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '108';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/fa431a4fdd617c4f419c20fe9a6bacfa/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '108';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fa431a4fdd617c4f419c20fe9a6bacfa'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fa431a4fdd617c4f419c20fe9a6bacfa'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/7086db3f1e7e7eb2d83cf30901618d1a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(108);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/67e1c806354e17f77f1e99c24813f8fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '109';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/c4f56f17ed957e8796232a01af3ff80d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '109';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4f56f17ed957e8796232a01af3ff80d'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4f56f17ed957e8796232a01af3ff80d'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/35d292753eaafc45f5f501aa60d3866b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(109);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/87fd976d706d2a2a56e88731fe6e2f98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '110';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/62962d75be11bb56e409d109793b8521/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '110';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('62962d75be11bb56e409d109793b8521'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('62962d75be11bb56e409d109793b8521'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/5b2bb21ed22aa19b13acaff278391a07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(110);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/bc2a1ae4b5767b2e07bbb7e3ed36b66b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '111';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/20a1511db9a1fd2c65e40c46eece4265/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '111';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20a1511db9a1fd2c65e40c46eece4265'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20a1511db9a1fd2c65e40c46eece4265'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a672af57cae617166e0b44ea5831eeb1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(111);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3afdf265f096219e59db2794a74edb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '112';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/02877b65895656b1f02cfc8a85e297e3/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '112';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('02877b65895656b1f02cfc8a85e297e3'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('02877b65895656b1f02cfc8a85e297e3'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/86535732d8af775a8c6f8f959c6edf68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(112);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/be8f8f08d7fec88faa0c8ede1df7012c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '113';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/948269140539c0ca8bb87e3598bf5853/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '113';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('948269140539c0ca8bb87e3598bf5853'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('948269140539c0ca8bb87e3598bf5853'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/5fb2ad32a42627537dc328bdbe97a67d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(113);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8169e516c282e1ac84e215a8aae33664/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '114';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/948814d63627a3e111ecf635a87e6792/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '114';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('948814d63627a3e111ecf635a87e6792'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('948814d63627a3e111ecf635a87e6792'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f3fb89459f231d551e7c7ff18956a7d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(113);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/8d56ea8232b2dcea51c7aa31b42dfdc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '115';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/1cef5e84706a117c087aa3477ae133b7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '115';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cef5e84706a117c087aa3477ae133b7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cef5e84706a117c087aa3477ae133b7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9554e8fa65fac02e76e614920c0ce6cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(115);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/a7f13d22c8e725eebfb36ec3dfcaf36f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '116';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ea3401eb940ed435718c8d66e62c03be/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '116';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ea3401eb940ed435718c8d66e62c03be'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ea3401eb940ed435718c8d66e62c03be'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/bebd26ff86ddf39484efbe6505183ea4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(116);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/db7a41aa7369e69e0f7f7feed6761ce4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '117';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/56181694695c889cc94f6e4891a882e7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '117';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('56181694695c889cc94f6e4891a882e7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('56181694695c889cc94f6e4891a882e7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/90610558ea9f1b418807aa24e5d42858/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(117);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3531acb100f6305908fe5148b51843f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '118';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/9dc1888c40a4c7a2d0ce8cb1e60f4e5a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '118';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc1888c40a4c7a2d0ce8cb1e60f4e5a'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc1888c40a4c7a2d0ce8cb1e60f4e5a'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/156d100a36cbbf2f912c238a66d9dd27/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(118);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/5d45791fad99ac71360d085201e97fae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '119';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b08f28b607fcb658da3d018db02a2812/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '119';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b08f28b607fcb658da3d018db02a2812'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b08f28b607fcb658da3d018db02a2812'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6724704c5fc495570a7ad44bace26b02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(119);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/20119e471bd4e7fea1758a0121834a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '120';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/6e3485cdc3228f5cd9820fcdadc63dcd/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '120';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d00c7b975e442d262f468c0d764ab50c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d00c7b975e442d262f468c0d764ab50c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/241c5d473f5605df809a28df4f6c0842/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(120);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/cfaaaef520181d65dd34f6fa99bf717d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '121';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/12593b630b9f0d77961fe78d5d8ffa98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '121';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12593b630b9f0d77961fe78d5d8ffa98'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12593b630b9f0d77961fe78d5d8ffa98'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/51b7f05565dc74fe5e5c748967ca52bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(121);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2fd4a48c3c02ceeb4927b98db9f4be8f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '122';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/5a24f6e71aac11924294f0493d3264bb/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '122';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5a24f6e71aac11924294f0493d3264bb'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5a24f6e71aac11924294f0493d3264bb'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e12bb26e362d42b83892f7c77571d285/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(122);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/72a46485c3fa29645ac38403240a1595/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '123';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/42895a724fefc384af2e38b54b81b98f/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '123';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('42895a724fefc384af2e38b54b81b98f'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('42895a724fefc384af2e38b54b81b98f'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/5a97857e7113a427aa352725b47710f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(123);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/3d599871bd25da99ce6206d289888aeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '124';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2a23b1be0bf14597e6ae5136950b3ad9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '124';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2a23b1be0bf14597e6ae5136950b3ad9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2a23b1be0bf14597e6ae5136950b3ad9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/dfebdc58c804e2d1b9de9ff66cefad8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(124);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/7266f79e80e7f5a4e2a7acb4c4adb938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '125';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f2ad7428b137c8e6a25b7c07eb12b611/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '125';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f2ad7428b137c8e6a25b7c07eb12b611'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f2ad7428b137c8e6a25b7c07eb12b611'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e248e51f190a0d22f651ab5602f23e43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(125);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b90783e82c51e4cbb7ed6317c683398a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '126';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/30c7c5b8a78a280d3ff987b53db67a27/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '126';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('30c7c5b8a78a280d3ff987b53db67a27'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('30c7c5b8a78a280d3ff987b53db67a27'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/979c80bd705414f7cda1f88db9b41104/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(126);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/43d7f7142f9dd1f83ca9c1d2ad6fe6cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '127';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e9f610a8d00452e98838117d3ef43764/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '127';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e9f610a8d00452e98838117d3ef43764'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e9f610a8d00452e98838117d3ef43764'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b06c277671058c1aeb72c99f682c7286/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(127);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/65e6cae82e79296380a19f9f4709ad95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '128';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/02591d43e8c5ad5e39fa8c5f9f06556d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '128';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('02591d43e8c5ad5e39fa8c5f9f06556d'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('02591d43e8c5ad5e39fa8c5f9f06556d'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/2f9788b651ea144c5a390f8ba4b49e41/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(128);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/dbbae7f144b9c32e045204e580d29452/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '129';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/dd9d0fa96c62f28619273be72858cee2/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '129';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dd9d0fa96c62f28619273be72858cee2'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dd9d0fa96c62f28619273be72858cee2'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/d28322a940159bdc615bdcf3fc3f056c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(129);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/090431ade661920f54c9cfd605894efb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '130';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/b2b19327069e7967ae066e446712d1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '130';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b2b19327069e7967ae066e446712d1a6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b2b19327069e7967ae066e446712d1a6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ede1822309469eeb60fc2b3c75776908/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(130);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/f27f7c2d8c6da75bb12a1348c6613d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '131';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/ee9e6646a8fc1b654fc4bf242ee85016/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '131';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee9e6646a8fc1b654fc4bf242ee85016'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee9e6646a8fc1b654fc4bf242ee85016'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/df93babb83c4ef0e70eab9f6fb86462c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(131);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e48832abfb6be427655524493fbabeb5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '132';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/e8b2d736047d4c25fad6d511a9ba5f28/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '132';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8b2d736047d4c25fad6d511a9ba5f28'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8b2d736047d4c25fad6d511a9ba5f28'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_9111b0f3dade34bdbf6b9785891c407a/logic/df8df1428a2f4b3c65f8e51f4f693176/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(132);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/1993e13cb692b67cc4c1228c16ce84ba/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('20312f99482797f4157228f54b9fa217', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89cbdd9906f1205369b27df94c0a9bac', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/5657405aa51342ecda98075493b5ff6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1993e13cb692b67cc4c1228c16ce84ba', false);

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
}


  if ((getObjectProperty(___arguments.context.pageData, 'Truck_Data_Icon_Select')) == true) {
    await Closer();
  } else {
    await Closer();
    try {

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

    } catch (error) {
      console.log(error);

    }
  }
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/064284e8d81934617325340eabedd916/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1993e13cb692b67cc4c1228c16ce84ba', false);

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
}


  if ((getObjectProperty(___arguments.context.pageData, 'Trailer_Data_Icon_Select')) == true) {
    await Closer();
  } else {
    await Closer();
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', true);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);

    } catch (error) {
      console.log(error);

    }
  }
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/7f9680277fe89cfde26b11be22d7b3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1993e13cb692b67cc4c1228c16ce84ba', false);

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
}


  if ((getObjectProperty(___arguments.context.pageData, 'Tyre_Icon_Select')) == true) {
    await Closer();
  } else {
    await Closer();
    ___arguments.context.pageData['Tyre_Icon_Select'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/0befd528f07c49d12f526e672d597252/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function Closer() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1993e13cb692b67cc4c1228c16ce84ba', false);

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/ea9bfd5f9411e9cc82665fd97d1f96b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function Closer() {
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1993e13cb692b67cc4c1228c16ce84ba', false);

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/435c6d4bd57574dc78747a9da3b3f3d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
}


  await Closer();
  ___arguments.context.pageData['Hamburger_View'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('c2d4f0b561fd0c723374abd58b625e11', (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Horse_Registration').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Horse_Registration')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('92bcb6b56e3bbd24d9cc6534582e8e94', (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Horse_Registration').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Horse_Registration')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('6c91227e85eaa27982d3833dddc5866f', (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setSortBy('Trailer_Registration').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Trailer_Registration')) });}))));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/58c221cd83f7d11c5ccc229544498106/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1993e13cb692b67cc4c1228c16ce84ba', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9628b47d6ca2488164b2935febd7b93b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dea698f2c49b16484b5917850269be8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/994c081a40c710b88e3fd6ac7be585cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
  ___arguments.context.pageData['Serv./Repair_Icon_Select'] = false;
}


  if ((getObjectProperty(___arguments.context.pageData, 'Serv./Repair_Icon_Select')) == true) {
    await Closer();
  } else {
    await Closer();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92c358efed6dc908e167b3bf70aad59d', true);
    ___arguments.context.pageData['Serv./Repair_Icon_Select'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/767c4491b2e4fede819406680681633a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('3aeaf46602e932b3e9cd2b62c0c7c32e');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/21f85ab90133657d86797b16ae2ee28c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('4ac3085c979d046ec87550d7d0cd1625');
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/45854249bf27338e7dd6f9c1864b00c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('da962d555aa7b166e5e30dfc9743a357');
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/83d77ab74796dda4d6c66dfd568a3973/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('95e56ad5e0fafb8c63c176aa7f6b9b0e');
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/93d449a62b413c361725b037c3ebee1a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('af042cd4926a40945e932d3882ebd0e2');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('da962d555aa7b166e5e30dfc9743a357');
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/99b230c291e2fc3cf3238854f3fb4c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  ___arguments.context.pageData['Repair_Viewer'] = true;
  ___arguments.context.pageData['Vehicles_List'] = (await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10)));
  ___arguments.context.pageData['Trailers_List'] = (await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\''].join(''))).setPageSize(10)));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('1f9d3a61ba76de03823525ca085b8fa8', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles_List')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Horse_Registration')) });}))));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('11ff39ac4faf59864f68b234b343f4da', (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Trailers_List')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Trailer_Registration')) });}))));
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_894cec71184dafc9c8a3c94d12dac4ed/logic/ad9ae6daac6761ac78212851d9ca2846/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    /**
 * Describe this function...
 */
async function Closer() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('99cf333d0b258ef51a4b1c42942ab833', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ff9606d281955ba92f72e907dc61539e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f7423269562d8c0f35d64aed19fb836f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95e56ad5e0fafb8c63c176aa7f6b9b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('65d3504d17c60c9dfecd3e95b1ffcbeb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3d5325c98073def13916f9efa43608a1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4c45696ad32d68d06987d2729e37336', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3aeaf46602e932b3e9cd2b62c0c7c32e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4ac3085c979d046ec87550d7d0cd1625', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da962d555aa7b166e5e30dfc9743a357', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af042cd4926a40945e932d3882ebd0e2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5df8c228b573c4cdcaa98e1fdaec8269', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5dd7eaf4ae3da2b304e925ef1fd54c0e', false);
  ___arguments.context.pageData['Repair_Viewer'] = false;
  ___arguments.context.pageData['Truck_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Trailer_Data_Icon_Select'] = false;
  ___arguments.context.pageData['Tyre_Icon_Select'] = false;
}


  await Closer();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b612d3b3061d799155f81a9286caaa69', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d381f1f5424c68c28d30d84123c11db', true);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('5d381f1f5424c68c28d30d84123c11db');
  ___arguments.context.pageData['Hamburger_View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c2d4f0b561fd0c723374abd58b625e11/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Tyres, Rig, Counter, Tyre, Tyre_Position;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tyre_Clear() {
  Counter = 0;
  for (var count = 0; count < 132; count++) {
    Counter = Counter + 1;
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = undefined;
  }
}

/**
 * Describe this function...
 */
async function Axle_Clear() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30db9f4b55346d9f8c6148696703211f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d1bc84170661413cbec46223355899b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36e1a9c7451c1362f7e7fcb1090a2b6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e354ebd7a4bdff6b79d49f7a3d19cf6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0583c16836065a466adb818cd7feb7cd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a67f3ab76caa7d5c6fa6941b3e018c5f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc58b9e94a283c651507b1cccb9a92db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3c1e709cbdf289adfeaa2d8dc7b6141', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b446196ecbf44e7eb9b52cfc06d13ac', false);
  console.log('Success');
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Horse_Tyre_Populator() {
  Counter = 0;
  var repeat_end = (getObjectProperty(___arguments.context.pageData, 'Horse_Total_Tyres')) + 1;
  for (var count2 = 0; count2 < repeat_end; count2++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T1_Tyre_Populator() {
  Counter = 0;
  var repeat_end2 = (getObjectProperty(___arguments.context.pageData, 'T1_Total_Tyres')) + 1;
  for (var count3 = 0; count3 < repeat_end2; count3++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T1_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T1_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T2_Tyre_Populator() {
  Counter = 0;
  var repeat_end3 = (getObjectProperty(___arguments.context.pageData, 'T2_Total_Tyres')) + 1;
  for (var count4 = 0; count4 < repeat_end3; count4++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T2_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T2_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T3_Tyre_Populator() {
  Counter = 0;
  var repeat_end4 = (getObjectProperty(___arguments.context.pageData, 'T3_Total_Tyres')) + 1;
  for (var count5 = 0; count5 < repeat_end4; count5++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T3_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T3_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function Horse_Steer() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30db9f4b55346d9f8c6148696703211f', true);
  }
}

/**
 * Describe this function...
 */
async function Horse_SD() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d1bc84170661413cbec46223355899b', true);
  }
}

/**
 * Describe this function...
 */
async function Horse_DD() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36e1a9c7451c1362f7e7fcb1090a2b6b', true);
  }
}

/**
 * Describe this function...
 */
async function T1_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e354ebd7a4bdff6b79d49f7a3d19cf6', true);
  }
}

/**
 * Describe this function...
 */
async function T1_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0583c16836065a466adb818cd7feb7cd', true);
  }
}

/**
 * Describe this function...
 */
async function T2_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a67f3ab76caa7d5c6fa6941b3e018c5f', true);
  }
}

/**
 * Describe this function...
 */
async function T2_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc58b9e94a283c651507b1cccb9a92db', true);
  }
}

/**
 * Describe this function...
 */
async function T3_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3c1e709cbdf289adfeaa2d8dc7b6141', true);
  }
}

/**
 * Describe this function...
 */
async function T3_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b446196ecbf44e7eb9b52cfc06d13ac', true);
  }
}


  Rig = null;
  ___arguments.context.pageData['Horse'] = null;
  ___arguments.context.pageData['Horse_Steer'] = null;
  ___arguments.context.pageData['Horse_SD'] = null;
  ___arguments.context.pageData['Horse_DD'] = null;
  ___arguments.context.pageData['T1'] = null;
  ___arguments.context.pageData['T1_SW'] = null;
  ___arguments.context.pageData['T1_DW'] = null;
  ___arguments.context.pageData['T2'] = null;
  ___arguments.context.pageData['T2_SW'] = null;
  ___arguments.context.pageData['T2_DW'] = null;
  ___arguments.context.pageData['T3'] = null;
  ___arguments.context.pageData['T3_SW'] = null;
  ___arguments.context.pageData['T3_DW'] = null;
  ___arguments.context.pageData['Horse_Tyres'] = null;
  ___arguments.context.pageData['T1_Tyres'] = null;
  ___arguments.context.pageData['T2_Tyres'] = null;
  ___arguments.context.pageData['T3_Tyres'] = null;
  ___arguments.context.pageData['Horse_Total_Tyres'] = [];
  ___arguments.context.pageData['T1_Total_Tyres'] = [];
  ___arguments.context.pageData['T2_Total_Tyres'] = [];
  ___arguments.context.pageData['T3_Total_Tyres'] = [];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', true);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('92bcb6b56e3bbd24d9cc6534582e8e94', null);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6c91227e85eaa27982d3833dddc5866f', null);
  await Tyre_Clear();
  await Axle_Clear();
  ___arguments.context.pageData['Rig_Create'] = true;
  ___arguments.context.pageData['H_Create'] = false;
  ___arguments.context.pageData['T1_Create'] = false;
  ___arguments.context.pageData['T2_Create'] = false;
  ___arguments.context.pageData['T3_Create'] = false;
  ___arguments.context.pageData['Type_Selected'] = 'Rig';
  Rig = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments.value,'\''].join(''))).setPageSize(1))).map(async item => {; return ({ 'objectId': (getObjectProperty(item, 'objectId')),'Fleet_ID': (getObjectProperty(item, 'Fleet_ID')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Steer_Axle_Number': (getObjectProperty(item, 'Steer_Axle_Number')),'Drive_Axle_Number_Single_Wheels': (getObjectProperty(item, 'Drive_Axle_Number_Single_Wheels')),'Drive_Axle_Number_Double_Wheels': (getObjectProperty(item, 'Drive_Axle_Number_Double_Wheels')),'Trailer1_Registration': (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer1_Registration').setPageSize(1).setOffset(0)))[0],'Trailer2_Registration': (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer2_Registration').setPageSize(1).setOffset(0)))[0],'Trailer3_Registration': (await Backendless.Data.of('Vehicles').loadRelations((getObjectProperty(item, 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('Trailer3_Registration').setPageSize(1).setOffset(0)))[0] });})))[0];
  ___arguments.context.pageData['Horse'] = (getObjectProperty(Rig, 'Horse_Registration'));
  try {
    ___arguments.context.pageData['Horse_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(Rig, 'Horse_Registration')),'\''].join(''))).setSortBy('Tyre_Position').setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  ___arguments.context.pageData['Horse_Steer'] = ((getObjectProperty(Rig, 'Steer_Axle_Number')) * 1);
  ___arguments.context.pageData['Horse_SD'] = ((getObjectProperty(Rig, 'Drive_Axle_Number_Single_Wheels')) * 1);
  ___arguments.context.pageData['Horse_DD'] = ((getObjectProperty(Rig, 'Drive_Axle_Number_Double_Wheels')) * 1);
  try {
    ___arguments.context.pageData['T1'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer1_Registration')), 'Trailer_Registration'));
    ___arguments.context.pageData['T1_SW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer1_Registration')), 'Axle_Number_Single_Wheel'));
    ___arguments.context.pageData['T1_DW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer1_Registration')), 'Axle_Number_Double_Wheel'));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['T2'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer2_Registration')), 'Trailer_Registration'));
    ___arguments.context.pageData['T2_SW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer2_Registration')), 'Axle_Number_Single_Wheel'));
    ___arguments.context.pageData['T2_DW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer2_Registration')), 'Axle_Number_Double_Wheel'));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['T3'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer3_Registration')), 'Trailer_Registration'));
    ___arguments.context.pageData['T3_SW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer3_Registration')), 'Axle_Number_Single_Wheel'));
    ___arguments.context.pageData['T3_DW'] = (getObjectProperty((getObjectProperty(Rig, 'Trailer3_Registration')), 'Axle_Number_Double_Wheel'));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['T1_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty((getObjectProperty(Rig, 'Trailer1_Registration')), 'Trailer_Registration')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['T2_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty((getObjectProperty(Rig, 'Trailer2_Registration')), 'Trailer_Registration')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  try {
    ___arguments.context.pageData['T3_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty((getObjectProperty(Rig, 'Trailer3_Registration')), 'Trailer_Registration')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  ___arguments.context.pageData['Horse_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) * 2 + (getObjectProperty(___arguments.context.pageData, 'Horse_SD')) * 2 + (getObjectProperty(___arguments.context.pageData, 'Horse_DD')) * 4);
  ___arguments.context.pageData['T1_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T1_DW')) * 4);
  ___arguments.context.pageData['T2_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T2_DW')) * 4);
  ___arguments.context.pageData['T3_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T3_DW')) * 4);
  ___arguments.context.pageData['Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'Horse_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T1_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T2_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T3_Total_Tyres')));
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')).length == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', true);
  }
  await Horse_Steer();
  await Horse_SD();
  await Horse_DD();
  await T1_SW();
  await T1_DW();
  await T2_SW();
  await T2_DW();
  await T3_SW();
  await T3_DW();
  await Horse_Tyre_Populator();
  try {
    await T1_Tyre_Populator();

  } catch (error) {

  }
  try {
    await T2_Tyre_Populator();

  } catch (error) {

  }
  try {
    await T3_Tyre_Populator();

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bbebd816d176280d661079960307c1', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/92bcb6b56e3bbd24d9cc6534582e8e94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Rig, Counter, Tyre, Tyre_Position;

/**
 * Describe this function...
 */
async function Axle_Clear() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30db9f4b55346d9f8c6148696703211f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d1bc84170661413cbec46223355899b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36e1a9c7451c1362f7e7fcb1090a2b6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e354ebd7a4bdff6b79d49f7a3d19cf6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0583c16836065a466adb818cd7feb7cd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a67f3ab76caa7d5c6fa6941b3e018c5f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc58b9e94a283c651507b1cccb9a92db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3c1e709cbdf289adfeaa2d8dc7b6141', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b446196ecbf44e7eb9b52cfc06d13ac', false);
  console.log('Success');
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tyre_Clear() {
  Counter = 0;
  for (var count = 0; count < 90; count++) {
    Counter = Counter + 1;
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = null;
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Horse_Tyre_Populator() {
  Counter = 0;
  var repeat_end = (getObjectProperty(___arguments.context.pageData, 'Horse_Total_Tyres')) + 1;
  for (var count2 = 0; count2 < repeat_end; count2++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function Horse_Steer() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30db9f4b55346d9f8c6148696703211f', true);
  }
}

/**
 * Describe this function...
 */
async function Horse_SD() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_SD')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d1bc84170661413cbec46223355899b', true);
  }
}

/**
 * Describe this function...
 */
async function Horse_DD() {
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'Horse_DD')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36e1a9c7451c1362f7e7fcb1090a2b6b', true);
  }
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c2d4f0b561fd0c723374abd58b625e11', null);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6c91227e85eaa27982d3833dddc5866f', null);
  Rig = null;
  ___arguments.context.pageData['Horse'] = null;
  ___arguments.context.pageData['Horse_Steer'] = null;
  ___arguments.context.pageData['Horse_SD'] = null;
  ___arguments.context.pageData['Horse_DD'] = null;
  ___arguments.context.pageData['T1'] = null;
  ___arguments.context.pageData['T1_SW'] = null;
  ___arguments.context.pageData['T1_DW'] = null;
  ___arguments.context.pageData['T2'] = null;
  ___arguments.context.pageData['T2_SW'] = null;
  ___arguments.context.pageData['T2_DW'] = null;
  ___arguments.context.pageData['T3'] = null;
  ___arguments.context.pageData['T3_SW'] = null;
  ___arguments.context.pageData['T3_DW'] = null;
  ___arguments.context.pageData['Horse_Tyres'] = null;
  ___arguments.context.pageData['T1_Tyres'] = null;
  ___arguments.context.pageData['T2_Tyres'] = null;
  ___arguments.context.pageData['T3_Tyres'] = null;
  ___arguments.context.pageData['Horse_Total_Tyres'] = [];
  ___arguments.context.pageData['T1_Total_Tyres'] = [];
  ___arguments.context.pageData['T2_Total_Tyres'] = [];
  ___arguments.context.pageData['T3_Total_Tyres'] = [];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  await Axle_Clear();
  await Tyre_Clear();
  ___arguments.context.pageData['Rig_Create'] = false;
  ___arguments.context.pageData['H_Create'] = true;
  ___arguments.context.pageData['T1_Create'] = false;
  ___arguments.context.pageData['T2_Create'] = false;
  ___arguments.context.pageData['T3_Create'] = false;
  ___arguments.context.pageData['Type_Selected'] = 'Horse';
  Rig = (await Promise.all((await Backendless.Data.of('Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments.value,'\''].join(''))).setPageSize(1))).map(async item => {; return ({ 'objectId': (getObjectProperty(item, 'objectId')),'Fleet_ID': (getObjectProperty(item, 'Fleet_ID')),'Horse_Registration': (getObjectProperty(item, 'Horse_Registration')),'Steer_Axle_Number': (getObjectProperty(item, 'Steer_Axle_Number')),'Drive_Axle_Number_Single_Wheels': (getObjectProperty(item, 'Drive_Axle_Number_Single_Wheels')),'Drive_Axle_Number_Double_Wheels': (getObjectProperty(item, 'Drive_Axle_Number_Double_Wheels')) });})))[0];
  ___arguments.context.pageData['Horse'] = (getObjectProperty(Rig, 'Horse_Registration'));
  try {
    ___arguments.context.pageData['Horse_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(Rig, 'Horse_Registration')),'\''].join(''))).setSortBy('Tyre_Position').setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  ___arguments.context.pageData['Horse_Steer'] = ((getObjectProperty(Rig, 'Steer_Axle_Number')) * 1);
  ___arguments.context.pageData['Horse_SD'] = ((getObjectProperty(Rig, 'Drive_Axle_Number_Single_Wheels')) * 1);
  ___arguments.context.pageData['Horse_DD'] = ((getObjectProperty(Rig, 'Drive_Axle_Number_Double_Wheels')) * 1);
  await Horse_Steer();
  await Horse_SD();
  await Horse_DD();
  try {
    ___arguments.context.pageData['T3_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty((getObjectProperty(Rig, 'Trailer3_Registration')), 'Trailer_Registration')),'\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

  } catch (error) {

  }
  ___arguments.context.pageData['Horse_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) * 2 + (getObjectProperty(___arguments.context.pageData, 'Horse_SD')) * 2 + (getObjectProperty(___arguments.context.pageData, 'Horse_DD')) * 4);
  ___arguments.context.pageData['T1_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T1_DW')) * 4);
  ___arguments.context.pageData['T2_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T2_DW')) * 4);
  ___arguments.context.pageData['T3_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T3_DW')) * 4);
  ___arguments.context.pageData['Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'Horse_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T1_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T2_Total_Tyres')) + (getObjectProperty(___arguments.context.pageData, 'T3_Total_Tyres')));
  if ((getObjectProperty(___arguments.context.pageData, 'Horse_Tyres')).length == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', true);
  }
  await Horse_Tyre_Populator();

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6c91227e85eaa27982d3833dddc5866f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Trailer, error, Rig, Counter, Tyre, Tyre_Position;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tyre_Clear() {
  Counter = 0;
  for (var count = 0; count < 90; count++) {
    Counter = Counter + 1;
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = null;
  }
}

/**
 * Describe this function...
 */
async function Axle_Clear() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7c37025f47a2bb6a88e40113743340f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('10578244639fa10c3b5a6643e3ecd3d4', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30db9f4b55346d9f8c6148696703211f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273ebf7fca2a20c32ac9c9798172f34d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cabec679cf29238845e86401ce075c4d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d1bc84170661413cbec46223355899b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8481b783c325f8b19a94ff1ec92908e5', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9caf8422e1c026c384fed083675f2b3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('36e1a9c7451c1362f7e7fcb1090a2b6b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e354ebd7a4bdff6b79d49f7a3d19cf6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0583c16836065a466adb818cd7feb7cd', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a67f3ab76caa7d5c6fa6941b3e018c5f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc58b9e94a283c651507b1cccb9a92db', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3c1e709cbdf289adfeaa2d8dc7b6141', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b446196ecbf44e7eb9b52cfc06d13ac', false);
  console.log('Success');
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function T1_Tyre_Populator() {
  Counter = 0;
  var repeat_end = (getObjectProperty(___arguments.context.pageData, 'T1_Total_Tyres')) + 1;
  for (var count2 = 0; count2 < repeat_end; count2++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T1_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T1_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T2_Tyre_Populator() {
  Counter = 0;
  var repeat_end2 = (getObjectProperty(___arguments.context.pageData, 'T2_Total_Tyres')) + 1;
  for (var count3 = 0; count3 < repeat_end2; count3++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T2_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T2_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T3_Tyre_Populator() {
  Counter = 0;
  var repeat_end3 = (getObjectProperty(___arguments.context.pageData, 'T3_Total_Tyres')) + 1;
  for (var count4 = 0; count4 < repeat_end3; count4++) {
    Tyre_Position = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'T3_Tyres')).map(async item => {; return (getObjectProperty(item, 'Tyre_Position'));})))[(Counter - 1)];
    Tyre = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'T3_Tyres')), async (item) => {


     return ((getObjectProperty(item, 'Tyre_Position')) == Tyre_Position);
    }))[0];
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Tyre_Position))] = Tyre;
    Counter = Counter + 1;
  }
}

/**
 * Describe this function...
 */
async function T1_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('426d8097718e414c584bf6bfc0cd611e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62b4f304361e39756411cdd36741761c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c64d8260e54d185058a6f3e5f0b3613', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35088f07c54aba628e01c995e71a306d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1f7c5921a29820cb6291d7f6d85e5e19', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e354ebd7a4bdff6b79d49f7a3d19cf6', true);
  }
}

/**
 * Describe this function...
 */
async function T1_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T1_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24bc3b1e6cdf4cdf35f5e0f5ed58803a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('835eedb1e1b69b387e16d1fb56d2b03f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('89ae4adc383aad3cee842721ccd7bfc2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5915066b13ea682da646994ef71794d1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f34ce988ef975356ece754a8699c31c7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0583c16836065a466adb818cd7feb7cd', true);
  }
}

/**
 * Describe this function...
 */
async function T2_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b03c8a577e9c0a8e1bf7a4359ea8ac8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa93383a3adcf14ebfeeeb915de4e618', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec732193abbab447d7799c71e1fecb54', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('19ed5d16a1aab0f7f68519f7e8890182', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4e7816d968a213ec2d24bde338cbe556', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a67f3ab76caa7d5c6fa6941b3e018c5f', true);
  }
}

/**
 * Describe this function...
 */
async function T2_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T2_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d7074e9405215f5aa99321c31b1711', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b559b88d7740eeb60de467dacc7b6b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd53802697b8572d80cbe94f33fd4f55', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('980ec10dab59ac94e52ce4d5a172e62b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a1c45cbe6c135161e23e5fd7194b5b45', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc58b9e94a283c651507b1cccb9a92db', true);
  }
}

/**
 * Describe this function...
 */
async function T3_SW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('05ffd63dee2227c9279820ea46c51f2f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d88cd46a52c6a19c7b9d557cae36d734', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22c2493b6e0ccd0cb573525a5c6d540e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07b511230e5b9c38be5e2c48fc6a5bae', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0938337a4c9a29b2c177692f75108c8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f3c1e709cbdf289adfeaa2d8dc7b6141', true);
  }
}

/**
 * Describe this function...
 */
async function T3_DW() {
  if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 4) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 5) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'T3_DW')) == 6) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5af27cb3cbcf5a3c644135e93c948489', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('163426a33a54eb0e1fb6cba2b698e43d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('09fc4345b539968da7d4932677cce3f2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9bea2e4160969916ff7502eb4639fe5d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('076b95a26f9a4504c71a46f11c63c1ad', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b446196ecbf44e7eb9b52cfc06d13ac', true);
  }
}


  Rig = null;
  ___arguments.context.pageData['Horse'] = null;
  ___arguments.context.pageData['Horse_Steer'] = null;
  ___arguments.context.pageData['Horse_SD'] = null;
  ___arguments.context.pageData['Horse_DD'] = null;
  ___arguments.context.pageData['T1'] = null;
  ___arguments.context.pageData['T1_SW'] = null;
  ___arguments.context.pageData['T1_DW'] = null;
  ___arguments.context.pageData['T2'] = null;
  ___arguments.context.pageData['T2_SW'] = null;
  ___arguments.context.pageData['T2_DW'] = null;
  ___arguments.context.pageData['T3'] = null;
  ___arguments.context.pageData['T3_SW'] = null;
  ___arguments.context.pageData['T3_DW'] = null;
  ___arguments.context.pageData['Horse_Tyres'] = null;
  ___arguments.context.pageData['T1_Tyres'] = null;
  ___arguments.context.pageData['T2_Tyres'] = null;
  ___arguments.context.pageData['T3_Tyres'] = null;
  ___arguments.context.pageData['Horse_Total_Tyres'] = [];
  ___arguments.context.pageData['T1_Total_Tyres'] = [];
  ___arguments.context.pageData['T2_Total_Tyres'] = [];
  ___arguments.context.pageData['T3_Total_Tyres'] = [];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  await Axle_Clear();
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c2d4f0b561fd0c723374abd58b625e11', null);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('92bcb6b56e3bbd24d9cc6534582e8e94', null);
  await Tyre_Clear();
  ___arguments.context.pageData['Rig_Create'] = false;
  ___arguments.context.pageData['H_Create'] = false;
  ___arguments.context.pageData['T1_Create'] = false;
  ___arguments.context.pageData['T2_Create'] = false;
  ___arguments.context.pageData['T3_Create'] = false;
  ___arguments.context.pageData['Type_Selected'] = 'Trailer';
  Trailer = (await Promise.all((await Backendless.Data.of('Trailers').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments.value,'\''].join(''))).setPageSize(1))).map(async item => {; return ({ 'objectId': (getObjectProperty(item, 'objectId')),'Fleet_ID': (getObjectProperty(item, 'Fleet_ID')),'Trailer_Registration': (getObjectProperty(item, 'Trailer_Registration')),'Axle_Number_Single_Wheel': (getObjectProperty(item, 'Axle_Number_Single_Wheel')),'Axle_Number_Double_Wheel': (getObjectProperty(item, 'Axle_Number_Double_Wheel')),'Trailer_Position': (getObjectProperty(item, 'Trailer_Position')) });})))[0];
  if ((getObjectProperty(Trailer, 'Trailer_Position')) == 'T1') {
    try {
      ___arguments.context.pageData['T1'] = (getObjectProperty(Trailer, 'Trailer_Registration'));
      ___arguments.context.pageData['T1_SW'] = (getObjectProperty(Trailer, 'Axle_Number_Single_Wheel'));
      ___arguments.context.pageData['T1_DW'] = (getObjectProperty(Trailer, 'Axle_Number_Double_Wheel'));

    } catch (error) {

    }
    try {
      ___arguments.context.pageData['T1_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(Trailer, 'Trailer_Registration')),'\''].join(''))).setSortBy('Tyre_Position').setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

    } catch (error) {

    }
    console.log('abc');
    ___arguments.context.pageData['T1_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T1_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T1_DW')) * 4);
    console.log('abc');
    await T1_Tyre_Populator();
    await T1_SW();
    await T1_DW();
    if ((getObjectProperty(___arguments.context.pageData, 'T1_Tyres')).length == 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', true);
      ___arguments.context.pageData['T1_Create'] = true;
    }
  }
  if ((getObjectProperty(Trailer, 'Trailer_Position')) == 'T2') {
    try {
      ___arguments.context.pageData['T2'] = (getObjectProperty(Trailer, 'Trailer_Registration'));
      ___arguments.context.pageData['T2_SW'] = (getObjectProperty(Trailer, 'Axle_Number_Single_Wheel'));
      ___arguments.context.pageData['T2_DW'] = (getObjectProperty(Trailer, 'Axle_Number_Double_Wheel'));

    } catch (error) {

    }
    try {
      ___arguments.context.pageData['T2_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(Trailer, 'Trailer_Registration')),'\''].join(''))).setSortBy('Tyre_Position').setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

    } catch (error) {

    }
    ___arguments.context.pageData['T2_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T2_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T2_DW')) * 4);
    await T2_SW();
    await T2_DW();
    await T2_Tyre_Populator();
    if ((getObjectProperty(___arguments.context.pageData, 'T2_Tyres')).length == 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', true);
      ___arguments.context.pageData['T2_Create'] = true;
    }
  }
  if ((getObjectProperty(Trailer, 'Trailer_Position')) == 'T3') {
    try {
      ___arguments.context.pageData['T3'] = (getObjectProperty(Trailer, 'Trailer_Registration'));
      ___arguments.context.pageData['T3_SW'] = (getObjectProperty(Trailer, 'Axle_Number_Single_Wheel'));
      ___arguments.context.pageData['T3_DW'] = (getObjectProperty(Trailer, 'Axle_Number_Double_Wheel'));

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.pageData['T3_Tyres'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['Currently_On = \'',(getObjectProperty(Trailer, 'Trailer_Registration')),'\''].join(''))).setSortBy('Tyre_Position').setPageSize(100))).map(async item => {; return ({ 'Fleet_Brand': (getObjectProperty(item, 'Fleet_Brand')),'objectId': (getObjectProperty(item, 'objectId')),'Life': (getObjectProperty(item, 'Life')),'Tyre_Position': (getObjectProperty(item, 'Tyre_Position')) });})));

    } catch (error) {

    }
    ___arguments.context.pageData['T3_Total_Tyres'] = ((getObjectProperty(___arguments.context.pageData, 'T3_SW')) * 2 + (getObjectProperty(___arguments.context.pageData, 'T3_DW')) * 4);
    await T3_SW();
    await T3_DW();
    await T3_Tyre_Populator();
    if ((getObjectProperty(___arguments.context.pageData, 'T3_Tyres')).length == 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', true);
      ___arguments.context.pageData['T3_Create'] = true;
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/45ebd82eafeace129282d7ad08fc09ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Counter, Brand_Number, error, item, OwnerId, Tyre_Brand, New_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Steer_Populator() {
  var repeat_end = (getObjectProperty(___arguments.context.pageData, 'Horse_Steer')) * 2;
  for (var count = 0; count < repeat_end; count++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'Horse')),[`Type`]: 'Steer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 10000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function Drive_SW_Populator() {
  Counter = 6;
  var repeat_end2 = (getObjectProperty(___arguments.context.pageData, 'Horse_SD')) * 2;
  for (var count2 = 0; count2 < repeat_end2; count2++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'Horse')),[`Type`]: 'Drive',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 90000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function Drive_DW_Populator() {
  Counter = 12;
  var repeat_end3 = (getObjectProperty(___arguments.context.pageData, 'Horse_DD')) * 4;
  for (var count3 = 0; count3 < repeat_end3; count3++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'Horse')),[`Type`]: 'Drive',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 90000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T1_SW_Populator() {
  Counter = 24;
  var repeat_end4 = (getObjectProperty(___arguments.context.pageData, 'T1_SW')) * 2;
  for (var count4 = 0; count4 < repeat_end4; count4++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T1')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 120000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T1_DW_Populator() {
  Counter = 36;
  var repeat_end5 = (getObjectProperty(___arguments.context.pageData, 'T1_DW')) * 4;
  for (var count5 = 0; count5 < repeat_end5; count5++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T1')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 120000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T2_SW_Populator() {
  Counter = 60;
  var repeat_end6 = (getObjectProperty(___arguments.context.pageData, 'T2_SW')) * 2;
  for (var count6 = 0; count6 < repeat_end6; count6++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T2')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 120000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T2_DW_Populator() {
  Counter = 72;
  var repeat_end7 = (getObjectProperty(___arguments.context.pageData, 'T2_DW')) * 4;
  for (var count7 = 0; count7 < repeat_end7; count7++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T2')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 120000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T3_SW_Populator() {
  Counter = 96;
  var repeat_end8 = (getObjectProperty(___arguments.context.pageData, 'T3_SW')) * 2;
  for (var count8 = 0; count8 < repeat_end8; count8++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T3')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 120000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}

/**
 * Describe this function...
 */
async function T3_DW_Populator() {
  Counter = 108;
  var repeat_end9 = (getObjectProperty(___arguments.context.pageData, 'T3_DW')) * 4;
  for (var count9 = 0; count9 < repeat_end9; count9++) {
    Counter = Counter + 1;
    console.log(Counter);
    Brand_Number = Brand_Number + 1;
    New_Tyre = (await Backendless.Data.of('Tyres').save( ({ [`Current_Cap_State`]: 'New',[`Current_Mileage`]: 0,[`Currently_On`]: (getObjectProperty(___arguments.context.pageData, 'T3')),[`Type`]: 'Trailer',[`Tyre_Position`]: Counter,[`ownerId`]: OwnerId,[`Fleet_Brand`]: String(Tyre_Brand) + String(Brand_Number),[`Tyre_Number`]: Brand_Number,[`System_Generated_Tyre`]: 'Yes',[`Expected_Mileage`]: 120000,[`Current_Mileage`]: 0,[`Cost`]: 7900 }) ));
    ___arguments.context.pageData[(String('Selected_Tyre') + String(Counter))] = New_Tyre;
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'Rig_Create')) == true) {
    OwnerId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
    Tyre_Brand = String((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'Customer')).slice(0, 4)) + String(' T ');
    try {
      Brand_Number = (await BackendlessUI.Functions.Custom['fn_fa967009987c607bdead79e8a14b3d7d']('Tyres', (['ownerId = \'',OwnerId,'\''].join('')), 'Tyre_Number', 'desc'))[0];
      console.log(Brand_Number);

    } catch (error) {
      console.log(error);

    } finally {
      if ((typeof Brand_Number === 'number' && !isNaN(Brand_Number)) == false) {
        Brand_Number = 0;
      }

    }
    Counter = 0;
    await Steer_Populator();
    await Drive_DW_Populator();
    await Drive_SW_Populator();
    await T1_SW_Populator();
    await T1_DW_Populator();
    await T2_SW_Populator();
    await T2_DW_Populator();
    await T3_SW_Populator();
    await T3_DW_Populator();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'H_Create')) == true) {
    OwnerId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
    Tyre_Brand = String((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'Customer')).slice(0, 4)) + String(' T ');
    try {
      Brand_Number = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',OwnerId,'\''].join(''))).setSortBy('Tyre_Number desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tyre_Number'));})))[0];
      console.log(Brand_Number);

    } catch (error) {
      console.log(error);

    } finally {
      if ((typeof Brand_Number === 'number' && !isNaN(Brand_Number)) == false) {
        Brand_Number = 0;
      }

    }
    Counter = 0;
    await Steer_Populator();
    await Drive_DW_Populator();
    await Drive_SW_Populator();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'T1_Create')) == true) {
    OwnerId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
    Tyre_Brand = String((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'Customer')).slice(0, 4)) + String(' T ');
    try {
      Brand_Number = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',OwnerId,'\''].join(''))).setSortBy('Tyre_Number desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tyre_Number'));})))[0];
      console.log(Brand_Number);

    } catch (error) {
      console.log(error);

    } finally {
      if ((typeof Brand_Number === 'number' && !isNaN(Brand_Number)) == false) {
        Brand_Number = 0;
      }

    }
    Counter = 0;
    await T1_SW_Populator();
    await T1_DW_Populator();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'T2_Create')) == true) {
    OwnerId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
    Tyre_Brand = String((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'Customer')).slice(0, 4)) + String(' T ');
    try {
      Brand_Number = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',OwnerId,'\''].join(''))).setSortBy('Tyre_Number desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tyre_Number'));})))[0];

    } catch (error) {

    } finally {
      if ((typeof Brand_Number === 'number' && !isNaN(Brand_Number)) == false) {
        Brand_Number = 0;
      }

    }
    Counter = 0;
    await T2_SW_Populator();
    await T2_DW_Populator();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'T3_Create')) == true) {
    OwnerId = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
    Tyre_Brand = String((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'Customer')).slice(0, 4)) + String(' T ');
    try {
      Brand_Number = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',OwnerId,'\''].join(''))).setSortBy('Tyre_Number desc').setPageSize(10))).map(async item => {; return (getObjectProperty(item, 'Tyre_Number'));})))[0];
      console.log(Brand_Number);

    } catch (error) {
      console.log(error);

    } finally {
      if ((typeof Brand_Number === 'number' && !isNaN(Brand_Number)) == false) {
        Brand_Number = 0;
      }

    }
    Counter = 0;
    await T3_SW_Populator();
    await T3_DW_Populator();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9212318594c7dd9a91d4690db82338d8', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0122187ce2fb2374bccefc73ebe2e7ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '1';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\' AND Retread_List <> \'Yes\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f169871dbd8dcf0552d4f88729a4ae95/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '1';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f169871dbd8dcf0552d4f88729a4ae95'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f169871dbd8dcf0552d4f88729a4ae95'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3c7ccfea94a279cb82084d5867ad3b59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre1')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9dd6c2dadd19158375df6ef19a9ade59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '2';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/aa39deda3b4c9b23ba1dc8642f7b4b21/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Style, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '2';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa39deda3b4c9b23ba1dc8642f7b4b21'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa39deda3b4c9b23ba1dc8642f7b4b21'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6927c6ae5e9b14ad70060ec92beadfcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre2')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0f250027400ab7ed4204a552b7628eeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '3';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9d4486c7d2b7c5b3b099226aae557ff6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '3';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9d4486c7d2b7c5b3b099226aae557ff6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9d4486c7d2b7c5b3b099226aae557ff6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0e8230f2852501c61b14f0597f675948/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre1')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/bc669dd9873c772fbbc4ead18bc351a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '4';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1a0e76066cebb4c47b6f466903966a63/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '4';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a0e76066cebb4c47b6f466903966a63'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a0e76066cebb4c47b6f466903966a63'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6bc33e3907b5c4d2858f78aef90a413b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre1')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f0a26dfaf35fa8516cde66d403643de2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '5';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/d8ce63d67cc5a6ced1271045f772eb03/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '5';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8ce63d67cc5a6ced1271045f772eb03'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8ce63d67cc5a6ced1271045f772eb03'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/32133403e6abfc7e85b291738a38ff43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre6')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/14848336bd5c34f64b5382b8c06cf824/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '6';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Type = \'Steer\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ce558705af0c5f08144bfe6df0834b24/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '6';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce558705af0c5f08144bfe6df0834b24'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce558705af0c5f08144bfe6df0834b24'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/987d801700999bf2857d6cbca27b027f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre6')), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8f370082decf9288e6cc5537a95c51dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '7';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f4d63265d4e4737f1215116e3e02e451/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '7';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4d63265d4e4737f1215116e3e02e451'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f4d63265d4e4737f1215116e3e02e451'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/de62ae9e76990055547e2807849a13f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(7);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/861c795ce9992c1ce52347e2914dd8ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '8';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a3e95bd5f6579a3a71996afae7dc35bc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '8';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3e95bd5f6579a3a71996afae7dc35bc'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a3e95bd5f6579a3a71996afae7dc35bc'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1601139248b56eb4e1da5b5af45e7c94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(8);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b746b79749cb5dbc5feac7591c97c86c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '9';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/55655207195d01836e52f0f333e37f12/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '9';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55655207195d01836e52f0f333e37f12'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('55655207195d01836e52f0f333e37f12'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0d07c5babb3ce9cca51bd83287772e56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(9);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a487d8b22ef474368fad1f6c71fce703/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '10';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f86d1df518b88e5c8b2b256accb8daea/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '9';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f86d1df518b88e5c8b2b256accb8daea'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f86d1df518b88e5c8b2b256accb8daea'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ab434d279d296347d37d8dee32aa6c6a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(10);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a61763f5445522146a0416ee489d4ddf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '11';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1bd7be3dce280b36117575d3d0dfc415/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '11';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bd7be3dce280b36117575d3d0dfc415'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bd7be3dce280b36117575d3d0dfc415'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b97f8d03076cd7a4907f3b2fd8ecfe81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(11);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6a2f3c083cf7e919a6bda679ccad0374/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '12';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a7058ec17bdf79ca96b7b7e5dc9ecf03/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '12';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7058ec17bdf79ca96b7b7e5dc9ecf03'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7058ec17bdf79ca96b7b7e5dc9ecf03'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/64e6f332a51e7bdb89e91a3b03cb9fd7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(12);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b5098b2a0e94209702d2d2b6e01e0a48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '13';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\' AND Retread_List <> \'Yes\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/56195035b7fb8e7f54c70b8a0a0ab0b9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '13';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('56195035b7fb8e7f54c70b8a0a0ab0b9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('56195035b7fb8e7f54c70b8a0a0ab0b9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9be56cac9df99704153fbc554e76811d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(13);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/7efd177a074ba5b83abe608d10b9fe19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '14';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2e36ac0acf96e1256ac5a83e6fe45cb7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '14';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36ac0acf96e1256ac5a83e6fe45cb7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2e36ac0acf96e1256ac5a83e6fe45cb7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f6f735c16a3c5647914bab0de0aba022/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(14);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/88d9098dc814777bf029324f3aade901/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '15';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/23b75e6f9c4c4e15f576230cd50f3e03/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '15';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('23b75e6f9c4c4e15f576230cd50f3e03'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('23b75e6f9c4c4e15f576230cd50f3e03'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2ee8b3720c096f3c7362b167b8e9b773/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(15);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c18b11efb5840de18c531fe4de139ea3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '16';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/33161804a793ac9edcf1be940a0f0516/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '16';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('33161804a793ac9edcf1be940a0f0516'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('33161804a793ac9edcf1be940a0f0516'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e99831942fec357bc038ae3937a98ce4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(16);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/39f83bff5006a5577035669b46cb0a85/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '17';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/7c09d924d7f518d3d55ebf0cc1eb1af9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '17';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c09d924d7f518d3d55ebf0cc1eb1af9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c09d924d7f518d3d55ebf0cc1eb1af9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/bdeace4838fa2c61c3bb528f1886fb74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(17);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1646fd51458f540625b723c14bf8b5db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '18';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/aee2c2c772f63b870db361a8255723b6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '18';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aee2c2c772f63b870db361a8255723b6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aee2c2c772f63b870db361a8255723b6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6e0dda5241c9820b12c3f3a805f10dde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(18);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/cbfec65acc7fc08ad5160709bea8cdeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '19';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ae9cd158bb89281423b3aee457edcd46/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '19';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ae9cd158bb89281423b3aee457edcd46'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ae9cd158bb89281423b3aee457edcd46'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0a7167682a7f6105e2b1f58ac84d8db9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(19);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2d8626c6d88e54d46ba7b7bbb8d17cd2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '20';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/69fb8c086e844d712a1fdf8c0d1842a8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '20';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('69fb8c086e844d712a1fdf8c0d1842a8'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('69fb8c086e844d712a1fdf8c0d1842a8'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/de6d498f92753f4b48731c34468b4631/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(20);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/157fa81d94885ab7bc2d7a8366c497c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '21';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/dbc3e1945c08fefe661905ff3624dc77/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '21';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dbc3e1945c08fefe661905ff3624dc77'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dbc3e1945c08fefe661905ff3624dc77'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/82d2e942abddbf89a9cae4b4d93f7636/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(20);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f0c4a4dd0a143e6ec03512db5eef6e95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '22';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/22c36b7e5bee59030c76a7cf112f50c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '22';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22c36b7e5bee59030c76a7cf112f50c4'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('22c36b7e5bee59030c76a7cf112f50c4'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/df9cdfbb0297dd6c1fa97e48e00d9e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(22);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/edd5557304987aeb39aaf9165e78946f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '23';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/daf50e381b2be516110651c483a327f1/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '23';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('daf50e381b2be516110651c483a327f1'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('daf50e381b2be516110651c483a327f1'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/5cb1ebf5cff9505d3b43d1addc626ed9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(23);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/245fac5a1d1146e213d6648b484ecbe7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '24';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e5877c9cddcc6a2913db1a2e7f2b8a29/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '24';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e5877c9cddcc6a2913db1a2e7f2b8a29'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e5877c9cddcc6a2913db1a2e7f2b8a29'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8f0c5d7301023eaae13adef7572d704d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(24);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/82d4ca21cd6439f76e6dcf276ddb8338/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '25';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/93bec6f9f95d58216b6977a749beb7f4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '25';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('93bec6f9f95d58216b6977a749beb7f4'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('93bec6f9f95d58216b6977a749beb7f4'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3b0de6be644883ccffdfb79a6dc138f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(25);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/fbc6d8525533918de1844da6a32e0b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '26';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1db5b1678bdc7a9463f19e6ba0976b85/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '26';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1db5b1678bdc7a9463f19e6ba0976b85'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1db5b1678bdc7a9463f19e6ba0976b85'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f436e09b7ec16a08a68acf9ce7e46475/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(26);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/047829ce8c3f5a473417c2e6c4d69aea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '27';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/5ef39633fbee8f767cf8743e6858d8ad/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '27';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ef39633fbee8f767cf8743e6858d8ad'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ef39633fbee8f767cf8743e6858d8ad'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/82e83427746fe71b1531ede8b25c792f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(27);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8db449046caad04535d2f62336913f58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '28';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/370a7b597643d87dafb4f092487fb0c7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '28';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('370a7b597643d87dafb4f092487fb0c7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('370a7b597643d87dafb4f092487fb0c7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b1bb81ee0ef19b033398e1eacd11dc92/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(28);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/747a528c76abc689c34bdf1f01eba37b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '29';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/57da9142508a37c612695461b7c48828/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '29';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57da9142508a37c612695461b7c48828'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('57da9142508a37c612695461b7c48828'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c4e2ac0fc587e098ffb186341b591ea3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(29);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/d39acfb2260d3fc5944dc5dd98bf065f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '30';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0f7c43cad46172d2de8d14e837b458a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '30';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0f7c43cad46172d2de8d14e837b458a6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0f7c43cad46172d2de8d14e837b458a6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/aff2879311a275379d8750145168bde1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(30);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a83be573295fd6778cace78542aad61f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '31';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/101324aadb5cff32105f04ed97d70b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '31';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('101324aadb5cff32105f04ed97d70b5b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('101324aadb5cff32105f04ed97d70b5b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9a1e274c663c0cfe53698a2fb79d7b4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(31);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/83a5b9ec873c5dabffe51c02603c8a7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '32';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/fed5c74335318d35d464d92ebffa92ce/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '32';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fed5c74335318d35d464d92ebffa92ce'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fed5c74335318d35d464d92ebffa92ce'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/30a4351a7ede240f8a4e7042086b12f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(32);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3f770072bffbb6e50c9266827869e5ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '33';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ed1a18023975c735b253be95e4d5a71e/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '33';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ed1a18023975c735b253be95e4d5a71e'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ed1a18023975c735b253be95e4d5a71e'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/254d7326dbba8962d9e4f3e5875da0d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(33);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8192f8028c01924b6492201c38e3f138/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '34';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/dce549feebf8e943f914b7ebe63b539e/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '34';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce549feebf8e943f914b7ebe63b539e'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dce549feebf8e943f914b7ebe63b539e'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/54334ee221ff9fb1d7b2f616aa0f12ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(34);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b6ea6854160f085ddb96766ac47760b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '35';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/67a6639bb48f28d7dd3ee5a22febaca2/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '35';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('67a6639bb48f28d7dd3ee5a22febaca2'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('67a6639bb48f28d7dd3ee5a22febaca2'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0f3fd74cb9961b74f6e492d73b3ba692/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(35);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a4dfbe29eb6cb1f7cbd6f11433786b49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '36';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/7c89c464f20f88fe3c7ed72723bf6f02/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '36';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c89c464f20f88fe3c7ed72723bf6f02'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7c89c464f20f88fe3c7ed72723bf6f02'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2002625b5239547966ba70e39a1dc4f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(36);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/458cf746b08cd5424083b975dd0b67de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '37';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a2a5d01bd257c1ed79b894a1b3516c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '37';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a2a5d01bd257c1ed79b894a1b3516c7a'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a2a5d01bd257c1ed79b894a1b3516c7a'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6992c39bba6b8dcf27952575a60a9ab8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(37);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c6f8267591e9d13e940c0455b28db1b1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '38';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/238cf98dd228eff107937d320739f337/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '38';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('238cf98dd228eff107937d320739f337'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('238cf98dd228eff107937d320739f337'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6719a7d9d08f6e4242ce78ffbe627596/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(38);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1e37420ceafda3d4452cc577858c56b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '39';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6bc75b11f984206f1ecceabbf159853c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '39';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6bc75b11f984206f1ecceabbf159853c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6bc75b11f984206f1ecceabbf159853c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/80f7ed2e24e3cb96d977cc09264a0803/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(39);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1c14b9ec87feddd86fdb2131bffbbd26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '40';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2c82109c0bdecc96558e13a7a89773f3/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '40';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2c82109c0bdecc96558e13a7a89773f3'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2c82109c0bdecc96558e13a7a89773f3'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/72a223ac98237fba5401da4405d5feb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(40);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2581e1c4ff2f83ba1056c9728b76835d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '41';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9ef22a1ac24e8eb109bfe54a7668a836/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '41';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9ef22a1ac24e8eb109bfe54a7668a836'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9ef22a1ac24e8eb109bfe54a7668a836'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e76a518458e960edf1ec843de00d1d59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(41);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1f7d193f207f251bdb6c6f7d2eb40296/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '42';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c76655f52715aa8c0e39a119cdac5a4f/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '42';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c76655f52715aa8c0e39a119cdac5a4f'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c76655f52715aa8c0e39a119cdac5a4f'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3f4b872ac401931b3888fbfc40c19632/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(42);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e6ba1bdd1595f03882b1c1a88527949d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '43';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/921b801b5acdf89fe2bac251d6073669/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '43';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('921b801b5acdf89fe2bac251d6073669'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('921b801b5acdf89fe2bac251d6073669'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/57c41e97be8d88c90d54292ca3d1749d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(43);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/854b6db7d917ea9fd2543565f3fec6da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '44';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6f4beb312a1f9699397330a2d2ac2b72/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '44';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6f4beb312a1f9699397330a2d2ac2b72'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6f4beb312a1f9699397330a2d2ac2b72'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/228b57ef590204087d782a9f45f1a705/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(44);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/fa9de93564ee8d8670445a5a0f6d8bf2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '45';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c805a846e4d524fc0f4ef106249557d7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '45';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c805a846e4d524fc0f4ef106249557d7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c805a846e4d524fc0f4ef106249557d7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0fff2a7720541e24f4e59ad32f6ca3da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(45);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/49bccc52244f963f50068946a33a6946/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '46';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/d065c7decff6aa8212586c1e3b9a950d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '46';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d065c7decff6aa8212586c1e3b9a950d'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d065c7decff6aa8212586c1e3b9a950d'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/36f12a01acdffd72bca7dcdd49b4939a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(46);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/944697b62fd1555831ca315348e16528/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '47';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c7cab948b7e77bc5979750fc6ab81169/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '47';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7cab948b7e77bc5979750fc6ab81169'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c7cab948b7e77bc5979750fc6ab81169'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6508f6049466ffdf1473c119854a4169/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(47);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/bd2faf7bef8aa366e0894adb8113671f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '48';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/789201d1a023de7a4b171294c52c1f5a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '48';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('789201d1a023de7a4b171294c52c1f5a'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('789201d1a023de7a4b171294c52c1f5a'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f85dbc55adaf4f0306458a7a5454dc91/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(48);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/4493c9ab965f70dc1e186bb9e77a6977/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '49';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/96ba6f78557fb3a5fcd5577c1c12de54/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '49';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96ba6f78557fb3a5fcd5577c1c12de54'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('96ba6f78557fb3a5fcd5577c1c12de54'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/bd8a86b734cce81bfdb45d9acff2af6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(49);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/87c40196837a45c84d5138148e7b3389/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '50';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2eb8e668f0e92049c83f33ca6fe49115/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '50';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2eb8e668f0e92049c83f33ca6fe49115'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2eb8e668f0e92049c83f33ca6fe49115'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/df728955bf5c77949d8923c6493d7832/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(50);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/aa11a815b10f098c11aaa89f4911faa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '51';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3b57832fe5840be57eb4e0ea6ea3982c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '51';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3b57832fe5840be57eb4e0ea6ea3982c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3b57832fe5840be57eb4e0ea6ea3982c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1396e64a9559f016db8a50aca44220bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(51);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f3e8c8918478bc6c0d4d746ccb022135/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '52';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9a6b0f771a7aa79e194cdcef3a8d99dc/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '52';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a6b0f771a7aa79e194cdcef3a8d99dc'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a6b0f771a7aa79e194cdcef3a8d99dc'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1a1c8181871c26043afacbde80fce8a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(52);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ea03e1ad44a8d029dc96c8354eeea3e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '53';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/16f19838c73c2403b6e2248248c9c8d4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '53';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('16f19838c73c2403b6e2248248c9c8d4'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('16f19838c73c2403b6e2248248c9c8d4'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c636c66651c3f47b4b6307d1b59aeee6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(53);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/25664c38cbee89eedf219a45a9e64f18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '54';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/5e94ddd99472c9c6b9ad6b68fb640ce7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '54';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5e94ddd99472c9c6b9ad6b68fb640ce7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5e94ddd99472c9c6b9ad6b68fb640ce7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/00b88de8b0e7850b31432a56dc49eb23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(54);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c23262c9c17fc4d9015a2b644a6ef293/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '55';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/68ef52752953f38511a4287e36a393df/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '55';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('68ef52752953f38511a4287e36a393df'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('68ef52752953f38511a4287e36a393df'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/5fb655c54469149a8623a65828dbc89b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(55);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/78ec8646454fe04b2d32e5aeb51c3207/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '56';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ee9d5c9eb8a7254d7304b211a158078c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '56';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee9d5c9eb8a7254d7304b211a158078c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee9d5c9eb8a7254d7304b211a158078c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/13e1d5e6734cfdbde77502a72e314a1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(56);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e14b53677352a044f84fd1095f3e7049/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '57';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/818297b98afbff6416b1bb3e3ef99969/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '57';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('818297b98afbff6416b1bb3e3ef99969'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('818297b98afbff6416b1bb3e3ef99969'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9d8157af7cbd379140baf43413a38833/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(57);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9676d11a46265a7c5e5721fbeb47cd5f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '58';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e4c274e9f838a98e743e5551954b3b99/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '58';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e4c274e9f838a98e743e5551954b3b99'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e4c274e9f838a98e743e5551954b3b99'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/22f11149db211e94b814f6b7636a5dd1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(58);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/4faad0db2d8f72a3b9e3eb7e2ba18c49/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '59';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1b48bf4c8197130cdc8bfefc5934b97e/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '59';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1b48bf4c8197130cdc8bfefc5934b97e'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1b48bf4c8197130cdc8bfefc5934b97e'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/4c929d3bb112eb391efd8e43ad75781e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(59);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/184d0b82f4365074b1213e7d0c67307d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '60';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/83719e5478e5fc0ef3a804e23b3ba194/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '60';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83719e5478e5fc0ef3a804e23b3ba194'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83719e5478e5fc0ef3a804e23b3ba194'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8fa6ef942c1758e792d5a99d2826855a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(60);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ab9fd1bbcbb18e945d033f463b02767c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '61';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/520c33a5ffc9bd6aa358197f8b35a60b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '61';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('520c33a5ffc9bd6aa358197f8b35a60b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('520c33a5ffc9bd6aa358197f8b35a60b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/18c6d4fd9dfbce59f42c15d4942c2c3d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(61);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/59cd6da2906bc58a2db61edaeebd81f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '62';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0646717aa083c08aa645750ed59f1596/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '62';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0646717aa083c08aa645750ed59f1596'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0646717aa083c08aa645750ed59f1596'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0c3f94780ff68d458e8c96ea453648a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(62);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/4f24ac593a546fd5373cb2cdc259f06d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '63';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ab2fb2d769a4ef9daa133e34d34d0d2b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '63';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ab2fb2d769a4ef9daa133e34d34d0d2b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ab2fb2d769a4ef9daa133e34d34d0d2b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/682a2aa98a7cc4e3ebed3431bd2fa1f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(63);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/fe34ca7236bbcd65ae7aa9f7de564167/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '64';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/35720519667520da1a968dd7e4b9d8c9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '64';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35720519667520da1a968dd7e4b9d8c9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35720519667520da1a968dd7e4b9d8c9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/97a61689fd271169eeb646111bcc251f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(64);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2f4bdec114c4e5f1220dae98f4b42df7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '65';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/479f753ad466fd7aaff77d4f54045fcf/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '65';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('479f753ad466fd7aaff77d4f54045fcf'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('479f753ad466fd7aaff77d4f54045fcf'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c2646138c9ad7936e699a6df6c883abd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(65);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6f2598669c39d7ddcd93d7ff16256cde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '66';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b07172fa1337260ece5b0c738658bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '66';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07172fa1337260ece5b0c738658bcd8'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b07172fa1337260ece5b0c738658bcd8'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/281d89fd04a869b89f4de70562942c7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(66);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/fb363e21b0cb6f7eb845d989ea5ce8be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '67';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ce037756d29659e6fe9c64ac278f7c38/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '67';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce037756d29659e6fe9c64ac278f7c38'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce037756d29659e6fe9c64ac278f7c38'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/68aa7a476f0cb45b406e02e93d0510ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(67);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/293faf861ce7e36187e4e8530f4dcb23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '68';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/d5af7e9b448c2f6d5428db2a4daad7e9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '68';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5af7e9b448c2f6d5428db2a4daad7e9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d5af7e9b448c2f6d5428db2a4daad7e9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/aa3f91298d8f3979f79febd1b04409d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(68);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/4a2bde8b8092e135ad419bdd5637e127/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '69';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/88830ed8d62b90c3b9a83e81f6ab948e/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '69';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('88830ed8d62b90c3b9a83e81f6ab948e'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('88830ed8d62b90c3b9a83e81f6ab948e'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/62781d9babf34e92724783277d22a52f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(69);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/4bef6676b6cc48126e427481c3764c98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '70';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/736553e89eafcd18f599ae9ba5231112/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '70';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('736553e89eafcd18f599ae9ba5231112'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('736553e89eafcd18f599ae9ba5231112'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8edbf59eb8c42b91e3087fe81c4122f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(70);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8484e4faa9650f0cbb879162b1ffe362/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '71';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1c5b4141bef5007bc212c0ab0f12161c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '71';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c5b4141bef5007bc212c0ab0f12161c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1c5b4141bef5007bc212c0ab0f12161c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6a5ca6cf7ed151a268a90e98d9a36772/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(70);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/87edbc05922a5145e0a76d1cc33f88d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '72';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/85f8472e82374b7cefcaeeeeb6976c52/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '72';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85f8472e82374b7cefcaeeeeb6976c52'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85f8472e82374b7cefcaeeeeb6976c52'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/d6f5a4e1c93e14f11b3a63313e6b8a76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(72);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c2fe2943173910168c2b04faf5ef23f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '73';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/363f877733d2bd2d1da4c71961aa4ac4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '73';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('363f877733d2bd2d1da4c71961aa4ac4'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('363f877733d2bd2d1da4c71961aa4ac4'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b4cd159324f73accb2742dd14f2a7128/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(73);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3bf5d8f14c85b867d79ba21cbf7f1785/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '74';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b802ca84d595b107703ab57436fdbab7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '74';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b802ca84d595b107703ab57436fdbab7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b802ca84d595b107703ab57436fdbab7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/4fbdcd2ed0326fef3a5625873469447d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(74);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9b7444758c0edd6f67f20523bffc55f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '75';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ddd76116c489180cb0b4ff7c6fb4e77f/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '75';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ddd76116c489180cb0b4ff7c6fb4e77f'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ddd76116c489180cb0b4ff7c6fb4e77f'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6521497a4628dacef475cd666a56582d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(75);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/930f401dd61dc71ed37530f702a5b683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '76';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b592cf24e3d4754c20bcc5064685b4cf/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '76';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b592cf24e3d4754c20bcc5064685b4cf'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b592cf24e3d4754c20bcc5064685b4cf'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0b0bea63cacf0e892762cc9908f4c2f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(76);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f24e22a86af77c42fbd657f34959c29a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '77';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/efd6bc2ae7cad2a7b2cc864c9429ab96/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '77';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('efd6bc2ae7cad2a7b2cc864c9429ab96'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('efd6bc2ae7cad2a7b2cc864c9429ab96'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/661234ba0cdd60857e95b86a0973e7e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(77);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/55dd8e296427dece02ed0367afb804a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '78';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6689939dda3b9e55c86ee943699d62b7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '78';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6689939dda3b9e55c86ee943699d62b7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6689939dda3b9e55c86ee943699d62b7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c618b28d4845ffa3721d40e56ffc3976/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(78);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0d3bc94ce137a9621afa3c3b79f1c9fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '79';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/98c6f618d7c9731244990979da111a6a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '79';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('98c6f618d7c9731244990979da111a6a'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('98c6f618d7c9731244990979da111a6a'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0d7c9f065d1311c64e71cf4a80b532b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(79);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9e642f5d403eb45bd5e137d261a33c14/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '80';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/5b77e3276116a97466515c21c6d4dfbb/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '80';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5b77e3276116a97466515c21c6d4dfbb'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5b77e3276116a97466515c21c6d4dfbb'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/5ceabb7129dacb811c2f2d54ad637c44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(79);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b89f7d1648bce0e4c65e1cc1a0dce555/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '81';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/31de661941b80e9868242db474dc2fab/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '81';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('31de661941b80e9868242db474dc2fab'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('31de661941b80e9868242db474dc2fab'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c939f0f236ba4e99336e86cfe7532de4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(81);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b94a62e158a30a6a64933f5225829022/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '82';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/83451da6780364721c514f3e00bba1d6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '82';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83451da6780364721c514f3e00bba1d6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('83451da6780364721c514f3e00bba1d6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/063ca043fc86eb3c5b48708c276e0566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(81);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/d92d9496586f792921095014b27bf264/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '83';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a591dbef207b0b3aceba585b0daa0cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '83';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a591dbef207b0b3aceba585b0daa0cd9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a591dbef207b0b3aceba585b0daa0cd9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/81316ed699c1425cd728c85beef228d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(83);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/87e52a732ff8861892ba2f0482337847/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '84';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/53dd21dae67bf089258c75fe700a827c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '84';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53dd21dae67bf089258c75fe700a827c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53dd21dae67bf089258c75fe700a827c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/02e9664a72692a620f4ac4c2b35354e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(84);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/478cd98fe7767aecc3998d259f121df2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '85';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/7b4e2deb9743379946573f080d73cdd5/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '85';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7b4e2deb9743379946573f080d73cdd5'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7b4e2deb9743379946573f080d73cdd5'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a71ccf033176d12d9c24b42a85bad016/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(85);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/720587f922ea18484a1be8862eafd237/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '86';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f64c7c7498da39de5a3e4c0fba6b2665/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '86';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f64c7c7498da39de5a3e4c0fba6b2665'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f64c7c7498da39de5a3e4c0fba6b2665'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e9e1b2bc4a439a22574fe31c18690463/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(86);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8ad10da74f5dbb21de013d82e0920fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '87';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8f2c5f2361e8b2db5465191eceaabf9b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '87';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2c5f2361e8b2db5465191eceaabf9b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8f2c5f2361e8b2db5465191eceaabf9b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/27c40a710f7a5778fd9caea948a14e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(86);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/45b84948e0c516879f1fe89f462324a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '88';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/311ccd5aabe464a3939e929e0e493c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '88';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('311ccd5aabe464a3939e929e0e493c7a'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('311ccd5aabe464a3939e929e0e493c7a'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/caa857384acd20d47be6f1f67a5e49f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(88);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/79ede9c195ee7dc2cbbbcc0187fac85f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '89';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/aa1d14e86809a8469d679d8b63c9777e/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '89';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa1d14e86809a8469d679d8b63c9777e'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa1d14e86809a8469d679d8b63c9777e'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/46a184945797ea038017f26dd2292ef7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(89);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e3e6d968aefaa7a8f722269359c62b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '90';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/54225e4b1f250593c5b17815c3250b2b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '90';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('54225e4b1f250593c5b17815c3250b2b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('54225e4b1f250593c5b17815c3250b2b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/99242ed87d4d8e920693bce2b34b274a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(89);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/23cf9311c0bb891685fcafa33a060b3c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '91';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ffcb750d949636023d7576a505e28942/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '91';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffcb750d949636023d7576a505e28942'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ffcb750d949636023d7576a505e28942'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/09dfa7cdc3e9c10cf055a7713fdbfc2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(91);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/54a364e8cac5f88691a31d07a6c4b23c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '92';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/d127635d9d5e3ce5154a17c326b18832/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '92';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d127635d9d5e3ce5154a17c326b18832'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d127635d9d5e3ce5154a17c326b18832'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/bc81f24ffbd2f1860ea95911837eda66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(92);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2b3dad29fbeead8e8fa4666a1daae105/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '93';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/92f28ea5389453c3219e18158c117b6b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '93';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92f28ea5389453c3219e18158c117b6b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('92f28ea5389453c3219e18158c117b6b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ed68ac316583cab58a7ec0f71dc64339/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(93);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3f66bf332f654857178e5c3f416dd3b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '94';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/50e5d98e8c4af7bf74d19b393009f488/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '94';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50e5d98e8c4af7bf74d19b393009f488'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50e5d98e8c4af7bf74d19b393009f488'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/61e266285bbb6d792acb7c78a0b620a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(93);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/fccda592b76d2e066b6c807d5f1a5e1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '95';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8677542390c5efbb98cff2e461c8cc72/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '95';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8677542390c5efbb98cff2e461c8cc72'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8677542390c5efbb98cff2e461c8cc72'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2269bfba9569f07788a837f3fc77d661/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(95);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3bc1724ebf08c4f463ac439accfc9b3a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '96';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2158025de73c5bffb9b9c63b061ead45/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '96';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2158025de73c5bffb9b9c63b061ead45'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2158025de73c5bffb9b9c63b061ead45'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/bffb8e56ab8e76776c26b73e6b342a35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(96);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/07d5993d24cfd6ae29fd6ccf9ab22635/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '97';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e00fbf0410e7ed8ab636b871303b7a4b/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '97';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e00fbf0410e7ed8ab636b871303b7a4b'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e00fbf0410e7ed8ab636b871303b7a4b'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6221bfdc64afb7e93f1f0df561ec5698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(97);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/7463f55c3bd5e14bda2db2ac9824fa97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '98';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/84af86a644669b8c1b3724dae792bdda/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '98';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('84af86a644669b8c1b3724dae792bdda'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('84af86a644669b8c1b3724dae792bdda'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/614cdcd82ce306ef56652143796aa9c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(98);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0d4b0f289a11947e46482148ab0d9fdc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '99';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ce070a4342b861db119ee092d839dba9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '99';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce070a4342b861db119ee092d839dba9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ce070a4342b861db119ee092d839dba9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/48ad1a45976fd4b2392cd6072587f4d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(99);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1d63082cf7a7c6e1074aaff7d1c17e94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '100';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ebbaa10416af816fb7d176551a5e22ef/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '100';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ebbaa10416af816fb7d176551a5e22ef'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ebbaa10416af816fb7d176551a5e22ef'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/70556edd9da5d197ccc7e35306987bf6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(100);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/066689f96394dcc8561792ee5c54ae7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '101';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0049ce3f16a1f8d101c483cab499411c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '101';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0049ce3f16a1f8d101c483cab499411c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0049ce3f16a1f8d101c483cab499411c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b8c20c086e993237c93eb4aa58cbbf71/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(101);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/01a6f213a47d006800b135250bbad6ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '102';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0aa5238a2179ec6916d3514bfe66bac6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '102';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0aa5238a2179ec6916d3514bfe66bac6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0aa5238a2179ec6916d3514bfe66bac6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/bdb1c68b7b98106df0b2076e6a137387/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(102);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/03627e752fa49cf53ff799dff2f6675a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '103';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b8c3ff18bd730d9f7d86917caabc7ebd/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '103';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8c3ff18bd730d9f7d86917caabc7ebd'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8c3ff18bd730d9f7d86917caabc7ebd'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/34c58792dd74e92139d7d611dcb55b98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(102);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3aa2b95598781c7b940fe01988eb3d5c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '104';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/afd28a6359de06cacd85ffa86fb3a748/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '104';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('afd28a6359de06cacd85ffa86fb3a748'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('afd28a6359de06cacd85ffa86fb3a748'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6b4ba4fef8cf0e72c0e50b63791d3f0d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(104);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a33d790d051e5ef7eba81b1b58a1717c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '105';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/acdb7ae7620c02014416fe5ba82481c5/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '105';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('acdb7ae7620c02014416fe5ba82481c5'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('acdb7ae7620c02014416fe5ba82481c5'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b135f8ca3fff5df1486a575a430423eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(104);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/043e7057eba3b98fb612aaedf4bd7d14/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '106';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/bffb88532e8219d1591dbbf96fd69fa2/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '106';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bffb88532e8219d1591dbbf96fd69fa2'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bffb88532e8219d1591dbbf96fd69fa2'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f35bfd1c96c4b91e0b788a17c5d6d0ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(106);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/0607d2b957250a9c49a5fc41f7bbadf1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '107';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/340c9d7aabebba3d843be4e26f516187/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '107';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('340c9d7aabebba3d843be4e26f516187'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('340c9d7aabebba3d843be4e26f516187'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f472f4a8fd4c1664bd156391ef7ed1c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(107);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/13e8570345215a164ff66664b948b313/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '108';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/fa431a4fdd617c4f419c20fe9a6bacfa/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '108';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fa431a4fdd617c4f419c20fe9a6bacfa'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fa431a4fdd617c4f419c20fe9a6bacfa'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/7086db3f1e7e7eb2d83cf30901618d1a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(108);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/67e1c806354e17f77f1e99c24813f8fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '109';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/c4f56f17ed957e8796232a01af3ff80d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '109';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4f56f17ed957e8796232a01af3ff80d'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c4f56f17ed957e8796232a01af3ff80d'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/35d292753eaafc45f5f501aa60d3866b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(109);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/87fd976d706d2a2a56e88731fe6e2f98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '110';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/62962d75be11bb56e409d109793b8521/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '110';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('62962d75be11bb56e409d109793b8521'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('62962d75be11bb56e409d109793b8521'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/5b2bb21ed22aa19b13acaff278391a07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(110);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/bc2a1ae4b5767b2e07bbb7e3ed36b66b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '111';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/20a1511db9a1fd2c65e40c46eece4265/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '111';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20a1511db9a1fd2c65e40c46eece4265'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20a1511db9a1fd2c65e40c46eece4265'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a672af57cae617166e0b44ea5831eeb1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(111);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3afdf265f096219e59db2794a74edb73/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '112';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/02877b65895656b1f02cfc8a85e297e3/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '112';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('02877b65895656b1f02cfc8a85e297e3'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('02877b65895656b1f02cfc8a85e297e3'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/86535732d8af775a8c6f8f959c6edf68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(112);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/be8f8f08d7fec88faa0c8ede1df7012c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '113';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/948269140539c0ca8bb87e3598bf5853/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '113';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('948269140539c0ca8bb87e3598bf5853'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('948269140539c0ca8bb87e3598bf5853'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/5fb2ad32a42627537dc328bdbe97a67d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(113);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8169e516c282e1ac84e215a8aae33664/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '114';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/948814d63627a3e111ecf635a87e6792/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '114';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('948814d63627a3e111ecf635a87e6792'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('948814d63627a3e111ecf635a87e6792'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f3fb89459f231d551e7c7ff18956a7d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(113);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/8d56ea8232b2dcea51c7aa31b42dfdc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '115';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/1cef5e84706a117c087aa3477ae133b7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '115';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cef5e84706a117c087aa3477ae133b7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1cef5e84706a117c087aa3477ae133b7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9554e8fa65fac02e76e614920c0ce6cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(115);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/a7f13d22c8e725eebfb36ec3dfcaf36f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '116';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ea3401eb940ed435718c8d66e62c03be/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '116';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ea3401eb940ed435718c8d66e62c03be'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ea3401eb940ed435718c8d66e62c03be'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/bebd26ff86ddf39484efbe6505183ea4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(116);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/db7a41aa7369e69e0f7f7feed6761ce4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '117';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/56181694695c889cc94f6e4891a882e7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '117';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('56181694695c889cc94f6e4891a882e7'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('56181694695c889cc94f6e4891a882e7'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/90610558ea9f1b418807aa24e5d42858/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(117);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3531acb100f6305908fe5148b51843f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '118';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/9dc1888c40a4c7a2d0ce8cb1e60f4e5a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '118';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc1888c40a4c7a2d0ce8cb1e60f4e5a'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc1888c40a4c7a2d0ce8cb1e60f4e5a'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/156d100a36cbbf2f912c238a66d9dd27/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(118);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/5d45791fad99ac71360d085201e97fae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '119';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b08f28b607fcb658da3d018db02a2812/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '119';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b08f28b607fcb658da3d018db02a2812'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b08f28b607fcb658da3d018db02a2812'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6724704c5fc495570a7ad44bace26b02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(119);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/20119e471bd4e7fea1758a0121834a2f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '120';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/6e3485cdc3228f5cd9820fcdadc63dcd/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '120';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d00c7b975e442d262f468c0d764ab50c'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d00c7b975e442d262f468c0d764ab50c'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/241c5d473f5605df809a28df4f6c0842/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(120);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/cfaaaef520181d65dd34f6fa99bf717d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '121';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/12593b630b9f0d77961fe78d5d8ffa98/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '121';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12593b630b9f0d77961fe78d5d8ffa98'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('12593b630b9f0d77961fe78d5d8ffa98'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/51b7f05565dc74fe5e5c748967ca52bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(121);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2fd4a48c3c02ceeb4927b98db9f4be8f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '122';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/5a24f6e71aac11924294f0493d3264bb/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '122';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5a24f6e71aac11924294f0493d3264bb'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5a24f6e71aac11924294f0493d3264bb'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e12bb26e362d42b83892f7c77571d285/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(122);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/72a46485c3fa29645ac38403240a1595/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '123';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/42895a724fefc384af2e38b54b81b98f/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '123';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('42895a724fefc384af2e38b54b81b98f'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('42895a724fefc384af2e38b54b81b98f'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/5a97857e7113a427aa352725b47710f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(123);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/3d599871bd25da99ce6206d289888aeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '124';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2a23b1be0bf14597e6ae5136950b3ad9/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '124';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2a23b1be0bf14597e6ae5136950b3ad9'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2a23b1be0bf14597e6ae5136950b3ad9'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/dfebdc58c804e2d1b9de9ff66cefad8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(124);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/7266f79e80e7f5a4e2a7acb4c4adb938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '125';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f2ad7428b137c8e6a25b7c07eb12b611/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '125';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f2ad7428b137c8e6a25b7c07eb12b611'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f2ad7428b137c8e6a25b7c07eb12b611'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e248e51f190a0d22f651ab5602f23e43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(125);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b90783e82c51e4cbb7ed6317c683398a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '126';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/30c7c5b8a78a280d3ff987b53db67a27/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '126';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('30c7c5b8a78a280d3ff987b53db67a27'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('30c7c5b8a78a280d3ff987b53db67a27'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/979c80bd705414f7cda1f88db9b41104/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(126);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/43d7f7142f9dd1f83ca9c1d2ad6fe6cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '127';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e9f610a8d00452e98838117d3ef43764/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '127';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e9f610a8d00452e98838117d3ef43764'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e9f610a8d00452e98838117d3ef43764'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b06c277671058c1aeb72c99f682c7286/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(127);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/65e6cae82e79296380a19f9f4709ad95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '128';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/02591d43e8c5ad5e39fa8c5f9f06556d/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '128';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('02591d43e8c5ad5e39fa8c5f9f06556d'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('02591d43e8c5ad5e39fa8c5f9f06556d'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/2f9788b651ea144c5a390f8ba4b49e41/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(128);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/dbbae7f144b9c32e045204e580d29452/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '129';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/dd9d0fa96c62f28619273be72858cee2/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '129';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dd9d0fa96c62f28619273be72858cee2'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dd9d0fa96c62f28619273be72858cee2'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/d28322a940159bdc615bdcf3fc3f056c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(129);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/090431ade661920f54c9cfd605894efb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '130';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/b2b19327069e7967ae066e446712d1a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '130';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b2b19327069e7967ae066e446712d1a6'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b2b19327069e7967ae066e446712d1a6'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ede1822309469eeb60fc2b3c75776908/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(130);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/f27f7c2d8c6da75bb12a1348c6613d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '131';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/ee9e6646a8fc1b654fc4bf242ee85016/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '131';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee9e6646a8fc1b654fc4bf242ee85016'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ee9e6646a8fc1b654fc4bf242ee85016'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/df93babb83c4ef0e70eab9f6fb86462c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(131);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e48832abfb6be427655524493fbabeb5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = '132';
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = true;
  ___arguments.context.pageData['Tyre_Select_List'] = (await Promise.all((await Backendless.Data.of('Tyres').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')),'\' AND Warehouse = \'In\''].join(''))).setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Fleet_Brand')),'Serial_Number': (getObjectProperty(item, 'Serial_Number')) });})));
  ___arguments.context.pageData['Company_Brand'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'))[0]), 'label')).slice(0, 3));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/e8b2d736047d4c25fad6d511a9ba5f28/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Number2 = '132';
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) >= 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8b2d736047d4c25fad6d511a9ba5f28'))['backgroundColor'] = (['rgba(',(JSON.stringify(((100 - (getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life'))) * 5.1))),', 255, 1)'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) < 50) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e8b2d736047d4c25fad6d511a9ba5f28'))['backgroundColor'] = (['rgba(255, ',(JSON.stringify(((getObjectProperty((getObjectProperty(___arguments.context.pageData, (String('Selected_Tyre') + String(Number2)))), 'Life')) * 5.1))),', 1)'].join(''));
    }

  } catch (error) {

  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_3d8acbcb5f65c9f5497a409cb229106b/logic/df8df1428a2f4b3c65f8e51f4f693176/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = String('Selected_Tyre') + String(132);
  ___arguments.context.pageData['Viewed_Tyre'] = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, Number2)), 'objectId')), ));
  ___arguments.context.pageData['Tyre_Viewer'] = true;
  ___arguments.context.pageData['Tyre_Swap'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/be4f4caa0f1e53bb9bba6882d58222cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Selected_Tyre_132'] = null;
  ___arguments.context.pageData['Tyre_Viewer'] = false;
  ___arguments.context.pageData['Tyre_Swap'] = false;
  ___arguments.context.pageData['Tyre_Swap_2'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/40bee0f7016d72c45a5abc575f4cbc9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Tyre_Viewer')) == true && (getObjectProperty(___arguments.context.pageData, 'Tyre_Swap')) == false) {
    Result = true;
  } else {
    Result = false;
  }

  return Result

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/52f298462c15159de29a6a28c793d9cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Tyre_Swap_Edit_True'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False'] = true;
  ___arguments.context.pageData['Tyre_Edit_1'] = null;
  ___arguments.context.pageData['Tyre_Edit_2'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/af8836b912bd075fb17a1054b911d595/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Expected_Mileage')) === null) || (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Expected_Mileage')) === 'undefined')) {
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('81261c456bfff72600117f12981ff09a'))['marginTop'] = 175;
    ___arguments.context.pageData['Tyre_Swap_Edit_True'] = false;
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Edited')) <= 4) {
      (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Edited'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Edited')) + 1);
      ___arguments.context.pageData[(String('Selected_Tyre') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Tyre_Position')))] = (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'));
      await Backendless.Data.of('Tyres').save( (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')) );
    }
    ___arguments.context.pageData['Tyre_Swap_Edit_False'] = true;
    ___arguments.context.pageData['Tyre_Edit_1'] = null;
    ___arguments.context.pageData['Tyre_Edit_2'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/fcef828d5f1214149b768e5c974a10bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Tyre_Swap_Edit_True'] = true;
  console.log(getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'));
  ___arguments.context.pageData['Tyre_Swap_Edit_False'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/848baf04fbd3bc6a236f0161403da076/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Fleet_Brand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/9edd9101ba75a34b64b53d5342595abc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Currently_On'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/8ec2b4a804972e360c7b9128cb440a91/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Type'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/9a86c063efc9a04af3698a0f6ed29f3b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Make'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/115de4a2062f12af8593427b871ac4a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/220eceefdbed0f02577ba4519a09ad2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Serial_Number'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/928a53e164d1186356478cd323e87748/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Current_Cap_State'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/3d58d284f9a15de4db2e81571b388733/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Current_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/a1d91cc250f5344aa0dcd56a8b093e99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Remaining_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/6c1e0b5e3165de0d10bcce039d722038/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Make'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/65ea5b42d566ee9b1dd529951f917931/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Model'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/a22fa2e5acd22696174717ef0b090927/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Current_Cap_State'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/f1c9d3c26dae7c4e579c262d10440edf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Serial_Number'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/3f751e4d87cb00b8c38acfcc5adb15a1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Cost'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/5a1807f3eceabb8e5bcc918d0db5c848/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Tyre_Edit_2'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Current_Mileage'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Expected_Mileage')) - ___arguments.value);
  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Life'] = (100 - ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Current_Mileage')) / (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Expected_Mileage'))) * 100);
  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Remaining_Mileage'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Tyre_Edit_2'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/6467cdee6769d76d701fedba5e2a06fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Tyre_Swap_Edit_True')) == true) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Edited')) == 0) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Tyre_Edit_1'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Expected_Mileage'] = ___arguments.value;
  (getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre'))['Life'] = (100 - ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Current_Mileage')) / ___arguments.value) * 100);

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Tyre_Edit_1'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/50ecfe1e2fd5fe71adaead2c17afb548/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Life'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/b62e23c4cf94ccc593935b6e1e45ef1c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Tyre_Select_Input'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/2bb898cc316b560d9d05e486e3e4c225/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.pageData['New_Tyre'] = (await Backendless.Data.of('Tyres').findById(___arguments.value, ));
  ___arguments.context.pageData['Selected_Tyre_132'] = ___arguments.value;
  ___arguments.context.pageData['Tyre_Swap_2'] = true;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var List, Decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_Input')) == null) {
    List = (getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List'));
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_Input')).startsWith(((getObjectProperty(___arguments.context.pageData, 'Company_Brand')).slice(0, 2)))) {
      List = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List')), async (item) => {
         if (((getObjectProperty(item, 'label')).toLowerCase()).startsWith((String((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_Input')).toLowerCase())))) {
          Decision = true;
        } else {
          Decision = false;
        }


       return Decision;
      }));
    } else {
      List = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_List')), async (item) => {
         if (((getObjectProperty(item, 'Serial_Number')).toLowerCase()).startsWith((String((getObjectProperty(___arguments.context.pageData, 'Tyre_Select_Input')).toLowerCase())))) {
          Decision = true;
        } else {
          Decision = false;
        }


       return Decision;
      }));
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/8e154b7d9f9b2d1a68e3d7b8c554212b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2, New_Tyre, Replaced_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Tyre_Position'));
  Replaced_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'objectId')), ));
  Replaced_Tyre['Tyre_Position'] = null;
  Replaced_Tyre['Currently_On'] = null;
  await Backendless.Data.of('Tyres').save( Replaced_Tyre );
  New_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre_132')), ));
  New_Tyre['Tyre_Position'] = (Number2 * 1);
  New_Tyre['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Horse'));
  await Backendless.Data.of('Tyres').save( New_Tyre );
  ___arguments.context.pageData[(String('Selected_Tyre') + String(Number2))] = New_Tyre;
  ___arguments.context.pageData[(String('Tyre_Select_Input_') + String(Number2))] = null;
  ___arguments.context.pageData['Selected_Tyre_132'] = null;
  ___arguments.context.pageData['Tyre_Viewer'] = false;
  ___arguments.context.pageData['Tyre_Swap'] = false;
  ___arguments.context.pageData['Tyre_Swap_2'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('81261c456bfff72600117f12981ff09a'))['marginTop'] = 140;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/d1f506eeba3f99c820b5c2732dc5c0ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, Number2, Replaced_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Tyre_Position'));
  Replaced_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'objectId')), ));
  Replaced_Tyre['Tyre_Position'] = null;
  if ((getObjectProperty(Replaced_Tyre, 'Current_Cap_State')) == 'New') {
    Replaced_Tyre['New_Total_Mileage'] = (getObjectProperty(Replaced_Tyre, 'Current_Mileage'));
    Replaced_Tyre['Current_Cap_State'] = 'Cap 1';
    Replaced_Tyre['Expected_Mileage'] = 60000;
    Replaced_Tyre['Current_Mileage'] = 0;
  } else if ((getObjectProperty(Replaced_Tyre, 'Current_Cap_State')) == 'Cap 1') {
    Replaced_Tyre['Cap1_Total_Mileage'] = (getObjectProperty(Replaced_Tyre, 'Current_Mileage'));
    Replaced_Tyre['Current_Cap_State'] = 'Cap 2';
    Replaced_Tyre['Expected_Mileage'] = 60000;
    Replaced_Tyre['Current_Mileage'] = 0;
  } else if ((getObjectProperty(Replaced_Tyre, 'Current_Cap_State')) == 'Cap 2') {
    Replaced_Tyre['Cap2_Total_Mileage'] = (getObjectProperty(Replaced_Tyre, 'Current_Mileage'));
    Replaced_Tyre['Current_Cap_State'] = 'Cap 3';
    Replaced_Tyre['Expected_Mileage'] = 60000;
    Replaced_Tyre['Current_Mileage'] = 0;
  } else if ((getObjectProperty(Replaced_Tyre, 'Current_Cap_State')) == 'Cap 3') {
    Replaced_Tyre['Cap3_Total_Mileage'] = (getObjectProperty(Replaced_Tyre, 'Current_Mileage'));
    Replaced_Tyre['Current_Cap_State'] = null;
    Replaced_Tyre['Expected_Mileage'] = 60000;
    Replaced_Tyre['Current_Mileage'] = 0;
  }
  Replaced_Tyre['Retread_List'] = 'Yes';
  Replaced_Tyre['Currently_On'] = null;
  await Backendless.Data.of('Tyres').save( Replaced_Tyre );
  New_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre_132')), ));
  New_Tyre['Tyre_Position'] = (Number2 * 1);
  New_Tyre['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Horse'));
  await Backendless.Data.of('Tyres').save( New_Tyre );
  ___arguments.context.pageData[(String('Selected_Tyre') + String(Number2))] = New_Tyre;
  ___arguments.context.pageData[(String('Tyre_Select_Input_') + String(Number2))] = null;
  ___arguments.context.pageData['Selected_Tyre_132'] = null;
  ___arguments.context.pageData['Tyre_Viewer'] = false;
  ___arguments.context.pageData['Tyre_Swap'] = false;
  ___arguments.context.pageData['Tyre_Swap_2'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('81261c456bfff72600117f12981ff09a'))['marginTop'] = 140;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/5daa18e8a5eb42da648370a9ca346a77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Number2, New_Tyre, Replaced_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Number2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'Tyre_Position'));
  Replaced_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Viewed_Tyre')), 'objectId')), ));
  Replaced_Tyre['Tyre_Position'] = null;
  Replaced_Tyre['State'] = 'Scraped';
  Replaced_Tyre['Currently_On'] = 'Scraped';
  await Backendless.Data.of('Tyres').save( Replaced_Tyre );
  New_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty(___arguments.context.pageData, 'Selected_Tyre_132')), ));
  New_Tyre['Tyre_Position'] = (Number2 * 1);
  New_Tyre['Currently_On'] = (getObjectProperty(___arguments.context.pageData, 'Horse'));
  await Backendless.Data.of('Tyres').save( New_Tyre );
  ___arguments.context.pageData[(String('Selected_Tyre') + String(Number2))] = New_Tyre;
  ___arguments.context.pageData[(String('Tyre_Select_Input_') + String(Number2))] = null;
  ___arguments.context.pageData['Selected_Tyre_132'] = null;
  ___arguments.context.pageData['Tyre_Viewer'] = false;
  ___arguments.context.pageData['Tyre_Swap'] = false;
  ___arguments.context.pageData['Tyre_Swap_2'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('81261c456bfff72600117f12981ff09a'))['marginTop'] = 140;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/330af95aabeb98d509868e9d5cc1f1c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Tyre_Swap_Edit_True2'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False2'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/c022593d5b2c65c1a7896cd7ad21f911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Tyre_Swap_Edit_True2'] = false;
  ___arguments.context.pageData['Tyre_Swap_Edit_False2'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/4d188ed3cf94645e9285007fbe7a38df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Tyre_Swap_Edit_True2'] = true;
  ___arguments.context.pageData['Tyre_Swap_Edit_False2'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/12eb81bdb9ac4dd8833f1c5f8e8c843c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Fleet_Brand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/515fce8f19c4732b90725423908a9e8b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Type'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/94b7774aced2dbe7ef7cc0b5d0c71bc2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Type'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/e3b181becb16fd6dc56e64aeaff81116/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Model'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/46c83cbccf7971cd2d039f599fad717f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Serial_Number'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/62fbf197e8ea5f2d77857546e31952cb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Current_Cap_State'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/f0d12a01a1ff3287a8cab0c856280dec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Current_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/d8a4829b96016e59c7ff0594c04ea247/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Remaining_Mileage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_57f2226285145b0faba9511661f46085/logic/1d93125ea9b2c0620986dde3079495ac/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New_Tyre')), 'Life'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_0799a35d8a4d4ed5063228271ba9ca4e/logic/98597a84f7e11c176c3327e33b3ce0a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Add_Location'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_67ec8a026efcc0b4f10e038a64214dd6/logic/3dd66d0831e5185d2d757f66ba39fe9d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('3dd66d0831e5185d2d757f66ba39fe9d', -30, 25);
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('3dd66d0831e5185d2d757f66ba39fe9d', 6);
  (function (componentUid, traffic) { ___arguments.context.getComponentByUid(componentUid).traffic = traffic })('3dd66d0831e5185d2d757f66ba39fe9d', true);
  (function (componentUid, scrollWheel) { ___arguments.context.getComponentByUid(componentUid).scrollWheel = scrollWheel })('3dd66d0831e5185d2d757f66ba39fe9d', true);

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_67ec8a026efcc0b4f10e038a64214dd6/logic/f818f529205c044bbf688f576c27f5af/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Changed Value'] = ___arguments.value;
  Data = (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/PlaceDetails`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'placeId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8'), 'Changed Value')), 'place_id'))) }).send());
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('3dd66d0831e5185d2d757f66ba39fe9d', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Data, 'result')), 'geometry')), 'location')), 'lat')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Data, 'result')), 'geometry')), 'location')), 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('3dd66d0831e5185d2d757f66ba39fe9d', 20);

  },
  /* handler:onChange */
  /* handler:onPlacesPredictionsAssignment */
  ['onPlacesPredictionsAssignment'](___arguments) {
      return ({ 'componentRestrictions': ({ 'country': ['za'] }) })

  },
  /* handler:onPlacesPredictionsAssignment */
  /* content */
}))

define('./components/reusable/r_67ec8a026efcc0b4f10e038a64214dd6/logic/18e9124127aa0a6de1f53377c584a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Nearest_Location, Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['No_Point'] = false;
  ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Point'] = (new Backendless.Data.Point().setX((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('3dd66d0831e5185d2d757f66ba39fe9d')), 'lat'))).setY((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('3dd66d0831e5185d2d757f66ba39fe9d')), 'lng'))));
  Location = (await Backendless.Request.get(`${Backendless.appPath}/services/MapAPIServices/getLocationFromLngLt`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'currentPosition': JSON.stringify(([(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('3dd66d0831e5185d2d757f66ba39fe9d')), 'lat')),',',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('3dd66d0831e5185d2d757f66ba39fe9d')), 'lng'))].join(''))) }).send());
  Nearest_Location = (getObjectProperty(Location, 'results'))[0];
  ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Address'] = (getObjectProperty(Nearest_Location, 'formatted_address'));
  ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['PlaceID'] = (getObjectProperty(Nearest_Location, 'place_id'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_67ec8a026efcc0b4f10e038a64214dd6/logic/4725bb8893c11a063f0629adbc070783/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8'), 'No_Point')) == true) {
    viewer = true;
  } else {
    viewer = false;
  }

  return viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_67ec8a026efcc0b4f10e038a64214dd6/logic/813d2a7b33f6f223b451e631166b16d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Preformated_Text;


  if (___arguments.value.startsWith('0')) {
    Preformated_Text = (await BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2'](___arguments.value));
    if (Preformated_Text.length != 10) {
      ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Invalid_Number'] = true;
    } else {
      ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Invalid_Number'] = false;
      ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Location_Cellphone'] = ___arguments.value;
    }
  } else if (___arguments.value.startsWith('+27')) {
    Preformated_Text = (await BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2'](___arguments.value));
    if (Preformated_Text.length != 12) {
      ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Invalid_Number'] = true;
    } else {
      ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Invalid_Number'] = false;
      ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Location_Cellphone'] = ___arguments.value;
    }
  } else if (___arguments.value.startsWith('27')) {
    Preformated_Text = (await BackendlessUI.Functions.Custom['fn_d96847d1093fd875b491b9b680ebf2a2'](___arguments.value));
    if (Preformated_Text.length != 11) {
      ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Invalid_Number'] = true;
    } else {
      ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Invalid_Number'] = false;
      ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Location_Cellphone'] = ___arguments.value;
    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Invalid_Number'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_67ec8a026efcc0b4f10e038a64214dd6/logic/e19c7683ac08a721f9b27dbbd229b80f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8'), 'Invalid_Number')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_67ec8a026efcc0b4f10e038a64214dd6/logic/126cb661735b828a82b2efd26ccf19ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var x, Test;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Data_Clear() {
  ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Reference'] = null;
  ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Name'] = null;
  ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Contact'] = null;
  ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Cellphone'] = null;
  ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['Address'] = null;
  ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['PlaceId'] = null;
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('688173cb5d9cb8e680868966671d8bf8', null);
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8'), 'Point')) == null) {
    ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['No_Point'] = true;
  } else {
    ___arguments.context.getComponentDataStoreByUid('688173cb5d9cb8e680868966671d8bf8')['ownerId'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId'));
    await Backendless.Data.of('Locations').save( ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('688173cb5d9cb8e680868966671d8bf8')) );
    await Data_Clear();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_caf77e9ca26c5f7b4f3952b23a2d9b72/logic/4e98c525428e65f29aac6cc98a1b2dbd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NewJob - View')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_caf77e9ca26c5f7b4f3952b23a2d9b72/logic/928735f5c04993fdd92b6ba83d46797c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['NewJob - View'] = false;
  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Driver'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Field'] = undefined;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('81590f8bda445fb6adcd5f84c5ec28c6', '0');
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('067de303ac1732acd194b2c1c74a1f5e', undefined);
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('27798fcc551708a11664a57df5c1b148', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_caf77e9ca26c5f7b4f3952b23a2d9b72/logic/067de303ac1732acd194b2c1c74a1f5e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Contractor Data'] = (await Backendless.Data.of('Customers').findById(___arguments.value, ));
  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Contractor_Vehicles'] = (await Backendless.Data.of('AGRI_Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Contractor Data')), 'ownerId')),'\''].join(''))).setPageSize(100)));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('27798fcc551708a11664a57df5c1b148', (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Contractor_Vehicles')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Registration')) });}))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'AGRI_Contractors')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'Company')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_caf77e9ca26c5f7b4f3952b23a2d9b72/logic/987ad038cab2442f529b57a21b6dbfb4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Applications'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_caf77e9ca26c5f7b4f3952b23a2d9b72/logic/81590f8bda445fb6adcd5f84c5ec28c6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Product_List;

function listsRepeat(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Product_List = listsRepeat('New Product', (Number(___arguments.value)));
  ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Product List'] = (await Promise.all(Product_List.map(async item => {; return ({ 'Product': undefined,'Rate': undefined });})));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('223a0d19fbc472363b7b7532ba8a47be', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Product List')));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_caf77e9ca26c5f7b4f3952b23a2d9b72/logic/242bc10de31d43a986e9a431f92c55bb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var item;


  ___arguments.context.getComponentDataStoreByUid('73dd3cd1a687a461e89e0641c5984b1d')['Product'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_caf77e9ca26c5f7b4f3952b23a2d9b72/logic/5e39f43e0682ac549d0e149bfeba091f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('73dd3cd1a687a461e89e0641c5984b1d')['Rate'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_caf77e9ca26c5f7b4f3952b23a2d9b72/logic/0c9c8e5e28339d88b9bc8cf53c7c3782/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Incomplete Fields')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_caf77e9ca26c5f7b4f3952b23a2d9b72/logic/2bc59766a90a9a8fa78d9e5cef7f4824/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, PDF, Client, Contractor, Data, item, UUID;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2bc59766a90a9a8fa78d9e5cef7f4824', false);
  try {
    if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Hectares')) === 'undefined') == true || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Field')) === 'undefined') == true || (typeof ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('987ad038cab2442f529b57a21b6dbfb4')) === 'undefined') == true || (typeof (getObjectProperty(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('067de303ac1732acd194b2c1c74a1f5e')), async (item) => {


     return ((getObjectProperty(item, 'value')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('067de303ac1732acd194b2c1c74a1f5e')));
    }))[0]), 'label')) === 'undefined') == true) {
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Incomplete Fields'] = true;
    } else {
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Incomplete Fields'] = false;
      Contractor = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Contractor Data')), 'Company'));
      Client = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer'));
      UUID = (generateUUID().short());
      Data = (await Backendless.Data.of('AGRI_Farming_Job_Card').save( ({ 'Application': ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('987ad038cab2442f529b57a21b6dbfb4')),'Card': ['Job(',' ',UUID,' )'].join(''),'Company': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),'Client': Client,'Contractor': Contractor,'Hectares': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Hectares')),'Notes': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Notes')),'Field': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Field')),'File': ['https://backendlessappcontent.com/CB411F83-2292-179C-FF6B-D25974153100/41B761B3-CE6D-4001-B01B-7353FAA89118/files/https:/develop.backendless.com/app/Dash/files/PDF_Storage/Job%28+',UUID,'+%29.pdf'].join(''),'Products': (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('223a0d19fbc472363b7b7532ba8a47be')).map(async item => {; return ([' (Product: ',(getObjectProperty(item, 'Product')),' , Rate: ',(getObjectProperty(item, 'Rate')),') '].join(''));}))).join('\n'),'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')) }) ));
      console.log(Data);
      Data['Date'] = ((new Date()).toDateString());
      try {
        PDF = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'606043'}/data-output/${(getObjectProperty(Data, 'Card'))}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': Data }));

      } catch (error) {
        console.log(error);

      }
      await Backendless.Request.post(`${Backendless.appPath}/services/Twilio_WhatsApp/Send_WhatsApp`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'To': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd'), 'Contractor Data')), 'Mobile')),'Body': (['Dear ',Contractor,' \n\n','A new job request has been sent.',' \n\n','Click the following link to open the job card.',' \n\n',(getObjectProperty(PDF, 'fileUrl')),' \n\n','Kind Regards,\n\n','The Fleet In Form Team'].join('')) });
      try {
        await Backendless.Request.post(`${Backendless.appPath}/services/Twilio_WhatsApp/Send_WhatsApp`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'To': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Cellphone')),'Body': (['Dear ',Client,' \n\n','A new job request has been sent.',' \n\n','Click the following link to open the job card.',' \n\n',(getObjectProperty(PDF, 'fileUrl')),' \n\n','Kind Regards,\n\n','The Fleet In Form Team'].join('')) });

      } catch (error) {
        console.log(error);

      }
      ___arguments.context.pageData['NewJob - View'] = false;
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Farm Log Contractor Check'] = false;
      try {
        ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Field'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Hectares'] = undefined;
        (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('067de303ac1732acd194b2c1c74a1f5e', undefined);
        (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('987ad038cab2442f529b57a21b6dbfb4', undefined);
        (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('81590f8bda445fb6adcd5f84c5ec28c6', undefined);

      } catch (error) {
        console.log(error);

      }
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2bc59766a90a9a8fa78d9e5cef7f4824', true);
    } else {
      ___arguments.context.pageData['NewJob - View'] = false;
      ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Farm Log Contractor Check'] = false;
      try {
        ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Driver'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('4e98c525428e65f29aac6cc98a1b2dbd')['Field'] = undefined;
        (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('81590f8bda445fb6adcd5f84c5ec28c6', '0');
        (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('067de303ac1732acd194b2c1c74a1f5e', undefined);
        (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('987ad038cab2442f529b57a21b6dbfb4', undefined);

      } catch (error) {
        console.log(error);

      }
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/3662d62516bd17b23982fb37c3e38543/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Off_Farm_Fill'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Description'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Bowser'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Registration'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Application'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Driver'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Mileage'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Litres'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Meter'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Cost'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Fuel Station'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Incomplete Fields'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Farm Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Other Check'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/b822e2cb5028399f88bdf8eed2c41eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Check')) == true || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Other Check')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Farm Check')) == true) {
    ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = 'Farm';
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('5f923ba789d4a31b9276eb3417115c67', (await asyncListSort((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    })));
    ___arguments.context.pageData['Bowser_List'] = (await asyncListSort((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Bowsers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    }));
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fa0dd2652d1a90aa5fe5e6873644ce4f', (getObjectProperty(___arguments.context.pageData, 'Bowser_List')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/946490c5cd0c6febe4d3ed9fe7da9f6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Farm Check')) == true || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Other Check')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Check')) == true) {
    ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = 'Contractor';
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('7dc5f35624964221c7b7e4bdb8fee491', (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'AGRI_Contractors')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Company')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    })));
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('80ebabf54a12d1a22b5867fad81297d2', [({ [`value`]: 'Select Contractor',[`label`]: 'Select Contractor' })]);
    ___arguments.context.pageData['Bowser_List'] = (await asyncListSort((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Bowsers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    }));
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fa0dd2652d1a90aa5fe5e6873644ce4f', (getObjectProperty(___arguments.context.pageData, 'Bowser_List')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/7dc5f35624964221c7b7e4bdb8fee491/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Client Check')) == true) {
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('80ebabf54a12d1a22b5867fad81297d2', (await asyncListSort((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    })));
  } else {
    ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor Data'] = (await Backendless.Data.of('Customers').findById(___arguments.value, ));
    ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor_Vehicles'] = (await Backendless.Data.of('AGRI_Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Data')), 'ownerId')),'\''].join(''))).setPageSize(100)));
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('80ebabf54a12d1a22b5867fad81297d2', (await asyncListSort((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor_Vehicles')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    })));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/d42c08ff53caef2e9a94ba815e55e5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Farm Check')) == true || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Check')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Other Check')) == true) {
    ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = 'Other';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/f6163cce1d1cb0a6d19847b2448dae56/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}



  return (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Applications')), 1, async (item) => {


 return (getObjectProperty(item, 'label'));
}))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/70c123b36aa52b8b06b5b1f4a294c24b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}



  return (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Applications')), 1, async (item) => {


 return (getObjectProperty(item, 'label'));
}))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/48faf34a81fa25c9dac776c21ac2dbb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter Error')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/90ba7352f05c9b3be5469ef6df1ec3db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Incomplete Error')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/33e5882ed94b4a72af38520b877f513e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Fill, Mileage_Diff, Contractor, Registration, Client, item, Last_Fuel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e5882ed94b4a72af38520b877f513e', false);
  if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')) === 'undefined') || ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')) === 'undefined')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e5882ed94b4a72af38520b877f513e', true);
  } else {
    try {
      try {
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Mileage Error'] = false;

      } catch (error) {
        console.log(error);

      }
      try {
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Incomplete Fields'] = false;

      } catch (error) {
        console.log(error);

      }
      try {
        Contractor = (getObjectProperty(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('7dc5f35624964221c7b7e4bdb8fee491')), async (item) => {


         return ((getObjectProperty(item, 'value')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('7dc5f35624964221c7b7e4bdb8fee491')));
        }))[0]), 'label'));

      } catch (error) {

      }
      try {
        Registration = (await Backendless.Data.of('AGRI_Vehicles').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Registration')), ));

      } catch (error) {

      }
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Type')) == 'Contractor' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Type')) == 'Farm') {
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Fuel Station')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Application')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')) === 'undefined') || (typeof (getObjectProperty(Registration, 'Registration')) === 'undefined')) {
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Incomplete Fields'] = true;
        } else {
          if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')) < (getObjectProperty(Registration, 'Current_Mileage')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')) - (getObjectProperty(Registration, 'Current_Mileage')) > (getObjectProperty(Registration, 'Range'))) {
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Mileage Error'] = true;
          } else {
            try {
              Last_Fuel = (await Backendless.Data.of('Agri_Fuel_Log_Off_Farm').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' AND Registration = \'',(getObjectProperty(Registration, 'Registration')),'\''].join(''))).setSortBy('created DESC').setPageSize(10)))[0];

            } catch (error) {
              console.log(error);

            }
            try {
              Mileage_Diff = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')) - (getObjectProperty(Last_Fuel, 'Mileage'));

            } catch (error) {

            }
            try {
              Client = (getObjectProperty(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('40d85b79a9259aef1088585411db99f3')), async (item) => {


               return ((getObjectProperty(item, 'value')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('40d85b79a9259aef1088585411db99f3')));
              }))[0]), 'label'));

            } catch (error) {
              console.log(error);

            }
            Fill = ({ [`Bowser`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Fuel Station')),[`Application`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Application')),[`Attendant`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'displayName')),[`Client`]: Client,[`Company`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),[`Compliance`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Compliance')),[`Contractor`]: Contractor,[`Description`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Description')),[`Driver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Driver')),[`Litres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')),[`Registration`]: (getObjectProperty(Registration, 'Registration')),[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Type')),[`Mileage_Diff`]: Mileage_Diff,[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Cost')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')) });
            Registration['Current_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage'));
            await Backendless.Data.of('Agri_Fuel_Log_Off_Farm').save( Fill );
            await Backendless.Data.of('AGRI_Vehicles').save( Registration );
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor'] = undefined;
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Description'] = undefined;
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Registration'] = undefined;
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Application'] = undefined;
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Cost'] = undefined;
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Driver'] = undefined;
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Mileage'] = undefined;
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Litres'] = undefined;
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Meter'] = undefined;
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = undefined;
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Fuel Station'] = undefined;
            ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Incomplete Fields'] = false;
          }
        }
      } else {
        if ((typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Fuel Station')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Description')) === 'undefined')) {
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Incomplete Fields'] = true;
        } else {
          Fill = ({ [`Bowser`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Fuel Station')),[`Application`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Application')),[`Attendant`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'displayName')),[`Company`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),[`Contractor`]: Contractor,[`Description`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Description')),[`Driver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Driver')),[`Litres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')),[`Registration`]: undefined,[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Type')),[`Mileage_Diff`]: Mileage_Diff,[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Cost')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')) });
          await Backendless.Data.of('Agri_Fuel_Log_Off_Farm').save( Fill );
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Description'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Bowser'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Registration'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Application'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Driver'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Cost'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Mileage'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Litres'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Meter'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Fuel Station'] = undefined;
          ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Incomplete Fields'] = false;
        }
      }
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Farm Check'] = false;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor Check'] = false;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Other Check'] = false;
      console.log('123');

    } catch (error) {
      console.log(error);

    } finally {
      console.log('abc');
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e5882ed94b4a72af38520b877f513e', true);
      } else {
        ___arguments.context.pageData['Off_Farm_Fill'] = false;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Description'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Bowser'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Registration'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Application'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Driver'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Mileage'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Litres'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Meter'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Cost'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Fuel Station'] = undefined;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Incomplete Fields'] = false;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Farm Check'] = false;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor Check'] = false;
        ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Other Check'] = false;
      }

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/b143728c3eb6dddaea6db69b940838ad/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Client Check')) == true) {
    ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = 'Contractor';
    ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor Check'] = true;
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('40d85b79a9259aef1088585411db99f3', (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'AGRI_Clients')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Company')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    })));
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('7dc5f35624964221c7b7e4bdb8fee491', (await asyncListSort([({ [`value`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Company')),[`label`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Company')) })], 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    })));
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('7dc5f35624964221c7b7e4bdb8fee491', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Company')));
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('80ebabf54a12d1a22b5867fad81297d2', (await asyncListSort((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    })));
  } else {
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_2ffc2da32bada40282e37c6e0cb66abf/logic/ef9bec7ec0949727fef81c48c4f57228/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}



  return (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Drivers')), 1, async (item) => {


 return (getObjectProperty(item, 'label'));
}))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/8ea76c03dc73d084a988e677d61cc3f3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Fuel_Log')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/3662d62516bd17b23982fb37c3e38543/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var Registration, Bowser, Fill, Contractor;


  ___arguments.context.pageData['Fuel_Log'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Description'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Bowser'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Registration'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Application'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Driver'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Mileage'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Litres'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Meter'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = undefined;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Incomplete Fields'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Farm Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Other Check'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/b822e2cb5028399f88bdf8eed2c41eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Check')) == true || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Other Check')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Farm Check')) == true) {
    ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = 'Farm';
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('5f923ba789d4a31b9276eb3417115c67', (await asyncListSort((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Vehicles')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    })));
    ___arguments.context.pageData['Bowser_List'] = (await asyncListSort((await Promise.all((getObjectProperty(___arguments.context.pageData, 'Bowsers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    }));
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fa0dd2652d1a90aa5fe5e6873644ce4f', (getObjectProperty(___arguments.context.pageData, 'Bowser_List')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/946490c5cd0c6febe4d3ed9fe7da9f6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Farm Check')) == true || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Other Check')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Check')) == true) {
    ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = 'Contractor';
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('7dc5f35624964221c7b7e4bdb8fee491', (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'AGRI_Contractors')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Company')) });}))), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    })));
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('80ebabf54a12d1a22b5867fad81297d2', [({ [`value`]: 'Select Contractor',[`label`]: 'Select Contractor' })]);
    ___arguments.context.pageData['Bowser_List'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'Bowsers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fa0dd2652d1a90aa5fe5e6873644ce4f', (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'Bowser_List')), 1, async (item) => {


     return (getObjectProperty(item, 'label'));
    })));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/7dc5f35624964221c7b7e4bdb8fee491/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor Data'] = (await Backendless.Data.of('Customers').findById(___arguments.value, ));
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor Applications'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Data')), 'Agri_Applications'));
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor_Vehicles'] = (await Backendless.Data.of('AGRI_Vehicles').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Data')), 'ownerId')),'\''].join(''))).setPageSize(100)));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('80ebabf54a12d1a22b5867fad81297d2', (await asyncListSort((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor_Vehicles')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), 1, async (item) => {


   return (getObjectProperty(item, 'label'));
  })));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/d42c08ff53caef2e9a94ba815e55e5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Farm Check')) == true || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Check')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Other Check')) == true) {
    ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = 'Other';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/8527da164b3170768b992d0be7bea872/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Bowser_List'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/f6163cce1d1cb0a6d19847b2448dae56/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}



  return (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Applications')), 1, async (item) => {


 return (getObjectProperty(item, 'label'));
}))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/70c123b36aa52b8b06b5b1f4a294c24b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Applications')) == null || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Applications')) === 'undefined')) {
    List = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Applications'));
  } else {
    List = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Applications')).concat(([({ [`value`]: '               ',[`label`]: '               ' })].concat((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor Applications'))))));
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/b076a6f3c9e6196b924421210c7e8341/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Bowser_List'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/48fd8474706e67c59d4f8a4271df617a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter Error')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/48faf34a81fa25c9dac776c21ac2dbb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage Error')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/90ba7352f05c9b3be5469ef6df1ec3db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Incomplete Fields')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/33e5882ed94b4a72af38520b877f513e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Boswer_Price, Bowser, Contractor, error, Fill, item, Last_Fuel, Mileage_Diff, Registration, Vehicle_Owner;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function Data_Retrieval() {
  try {
    Contractor = (getObjectProperty((await Backendless.Data.of('Customers').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Contractor')), )), 'Company'));

  } catch (error) {

  }
  try {
    Registration = (await Backendless.Data.of('AGRI_Vehicles').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Registration')), ));

  } catch (error) {

  }
  try {
    Bowser = (await Backendless.Data.of('AGRI_Bowsers').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Bowser')), ));

  } catch (error) {
    console.log(error);

  }
  try {
    Vehicle_Owner = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Registration, 'ownerId')),'\''].join(''))).setPageSize(10)))[0];

  } catch (error) {
    console.log(error);

  }
  try {
    Last_Fuel = (await Backendless.Data.of('AGRI_Fuel_Log').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' AND Registration = \'',(getObjectProperty(Registration, 'Registration')),'\''].join(''))).setSortBy('created DESC').setPageSize(10)))[0];

  } catch (error) {
    console.log(error);

  }
  console.log(Bowser);
  try {
    Boswer_Price = (getObjectProperty(((await Backendless.Data.of('AGRI_Bowser_Fills').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')),'\' AND Bowser = \'',(getObjectProperty(Bowser, 'Name')),'\''].join(''))).setSortBy('created desc').setPageSize(10)))[0]), 'R_Per_Litre'));

  } catch (error) {
    console.log(error);

  }
  if ((Last_Fuel === null) || (typeof Last_Fuel === 'undefined')) {
    Last_Fuel = ({ [`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')) });
  }
  try {
    Mileage_Diff = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')) - (getObjectProperty(Last_Fuel, 'Mileage'));

  } catch (error) {
    console.log(error);

  }
  try {
    if ((getObjectProperty(Registration, 'Service_Status')) == '!!!Service Due!!!') {
      console.log(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), ' Email'));
      console.log(getObjectProperty(Registration, 'Service Provider Email'));
      console.log(await asyncListFilter([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Email')), (getObjectProperty(Registration, 'Service Provider Email')), 'raymondewoodley@gmail.com'], async (item) => {


       return (!(item === null));
      }));
      console.log((await Backendless.Messaging.sendEmail((['Service Notice for (',(getObjectProperty(Registration, 'Registration')),')'].join('')), new Backendless.Bodyparts({ textmessage: (['Dear ',(getObjectProperty(___arguments.context.appData, 'Name')),'\n\nPlease note Vehicle (',(getObjectProperty(Registration, 'Registration')),') is due for service. \n \nThe current mileage/hours is ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')),'.','\n\nCompany:\t\t',(getObjectProperty(Vehicle_Owner, 'Customer')),'\nContact:\t\t',(getObjectProperty(Vehicle_Owner, 'displayName')),'\nNumber:\t\t',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Mobile')),'\n\nMake:\t\t',(getObjectProperty(Registration, 'Make')),'\nModel:\t\t',(getObjectProperty(Registration, 'Model')),'\nVIN:\t\t',(getObjectProperty(Registration, 'VIN')),'\n\nKind Regards, \nThe Fleet In Form Team','\n\nPlease note this email address is not attended.'].join('')) }), ensureArray((await asyncListFilter([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Email')), (getObjectProperty(Registration, 'Service Provider Email')), 'raymondewoodley@gmail.com'], async (item) => {


       return (!(item === null));
      }))), undefined)));
    }

  } catch (error) {
    console.log(error);

  }
  try {
    if ((getObjectProperty(Bowser, 'Litres')) <= (getObjectProperty(Bowser, 'Minimum Level'))) {
      console.log((await Backendless.Messaging.sendEmail('Bowser Level Warning', new Backendless.Bodyparts({ textmessage: (['Dear ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'displayName')),'\n\nPlease note bowser (',(getObjectProperty(Bowser, 'Name')),') is below the set minimum level. \n \nThe current level is ',(getObjectProperty(Bowser, 'Litres')),' litres.','\n\nKind Regards, \nThe Fleet In Form Team','\n\nPlease note this email address is not attended.'].join('')) }), ensureArray([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Email')), 'raymondewoodley@gmail.com']), undefined)));
    }

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function Comtractor_Farm_Function() {
  console.log(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage'));
  Fill = ({ [`Application`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Application')),[`Attendant`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'displayName')),[`Bowser`]: (getObjectProperty(Bowser, 'Name')),[`Company`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),[`Compliance`]: (getObjectProperty(Registration, 'Compliance')),[`Contractor`]: Contractor,[`Description`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Description')),[`Driver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Driver')),[`Litres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')),[`Meter`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')),[`Registration`]: (getObjectProperty(Registration, 'Registration')),[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Type')),[`Meter_Diff`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')) - (getObjectProperty(Bowser, 'Meter'))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')),[`Mileage_Diff`]: Mileage_Diff,[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')) * Boswer_Price,[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')) });
  Registration['Current_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage'));
  Bowser['Litres'] = ((getObjectProperty(Bowser, 'Litres')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')));
  Bowser['Meter'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter'));
  Fill['Bowser_Level'] = (getObjectProperty(Bowser, 'Litres'));
  await Backendless.Data.of('AGRI_Fuel_Log').save( Fill );
  await Backendless.Data.of('AGRI_Bowsers').save( Bowser );
  await Backendless.Data.of('AGRI_Vehicles').save( Registration );
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Farm Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Other Check'] = false;
  await Form_Reset();
  ___arguments.context.pageData['Farming_Log'] = false;
  ___arguments.context.pageData['Fuel_Log'] = false;
  ___arguments.context.pageData['Bowser_Fill'] = false;
  ___arguments.context.pageData['Off_Farm_Fill'] = false;
}

/**
 * Describe this function...
 */
async function Error_Reset() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e5882ed94b4a72af38520b877f513e', false);
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Meter Error'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Mileage Error'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Incomplete Fields'] = false;
}

/**
 * Describe this function...
 */
async function Mileage_Error() {
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Mileage Error'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e5882ed94b4a72af38520b877f513e', true);
}

/**
 * Describe this function...
 */
async function Meter_Error() {
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Meter Error'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e5882ed94b4a72af38520b877f513e', true);
}

/**
 * Describe this function...
 */
async function Form_Reset() {
  try {

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33e5882ed94b4a72af38520b877f513e', true);
    } else {
      ___arguments.context.pageData['Fuel_Log'] = false;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Description'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Bowser'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Registration'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Application'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Driver'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Mileage'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Litres'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Meter'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Type'] = undefined;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Incomplete Fields'] = false;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Farm Check'] = false;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor Check'] = false;
      ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Other Check'] = false;
    }

  }
}

/**
 * Describe this function...
 */
async function Else_Function() {
  console.log(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage'));
  Bowser['Litres'] = ((getObjectProperty(Bowser, 'Litres')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')));
  Fill = ({ [`Bowser_Level`]: (getObjectProperty(Bowser, 'Litres')),[`Application`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Application')),[`Attendant`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'displayName')),[`Bowser`]: (getObjectProperty(Bowser, 'Name')),[`Company`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'Customer')),[`Contractor`]: Contractor,[`Description`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Description')),[`Driver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Driver')),[`Litres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')),[`Meter`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')),[`Mileage`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')) === null) || (typeof (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')) === 'undefined') ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')),[`Registration`]: undefined,[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Type')),[`Meter_Diff`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')) - (getObjectProperty(Bowser, 'Meter'))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')),[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')) * Boswer_Price,[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'User')), 'ownerId')) });
  Bowser['Meter'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter'));
  await Backendless.Data.of('AGRI_Fuel_Log').save( Fill );
  await Backendless.Data.of('AGRI_Bowsers').save( Bowser );
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Farm Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Contractor Check'] = false;
  ___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3')['Other Check'] = false;
  await Form_Reset();
  ___arguments.context.pageData['Farming_Log'] = false;
  ___arguments.context.pageData['Fuel_Log'] = false;
  ___arguments.context.pageData['Bowser_Fill'] = false;
  ___arguments.context.pageData['Off_Farm_Fill'] = false;
}


  await Error_Reset();
  await Data_Retrieval();
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Type')) == 'Other') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')) - (getObjectProperty(Bowser, 'Meter')) <= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')) * 0.95 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')) - (getObjectProperty(Bowser, 'Meter')) >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')) * 1.05 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')) < (getObjectProperty(Bowser, 'Meter'))) {
      await Meter_Error();
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Type')) == 'Contractor' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Type')) == 'Farm') {
        await Comtractor_Farm_Function();
      } else {
        await Else_Function();
      }
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Mileage')) < (getObjectProperty(Last_Fuel, 'Mileage')) || Mileage_Diff > (getObjectProperty(Registration, 'Range'))) {
      await Mileage_Error();
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')) - (getObjectProperty(Bowser, 'Meter')) <= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')) * 0.95 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')) - (getObjectProperty(Bowser, 'Meter')) >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Litres')) * 1.05 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Meter')) < (getObjectProperty(Bowser, 'Meter'))) {
        await Meter_Error();
      } else {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Type')) == 'Contractor' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8ea76c03dc73d084a988e677d61cc3f3'), 'Type')) == 'Farm') {
          await Comtractor_Farm_Function();
        } else {
          await Else_Function();
        }
      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ee82cf85fc68cd7f54f37ddcfa0aa5c2/logic/b508709ce858ed083978c4c95e78d1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}



  return (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Company')), 'Agri_Drivers')), 1, async (item) => {


 return (getObjectProperty(item, 'label'));
}))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/c2bf25e11a879218ec9bf2cee348a63f/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Payload_Gauge')) >= 200 ? 200 : ((getObjectProperty(___arguments.context.appData, 'Payload_Gauge')) <= 0 ? 0 : (getObjectProperty(___arguments.context.appData, 'Payload_Gauge')))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/c72ae3e67b38bf6fbb14500a6c87bb2c/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Tonnage_Completion_Gauge')) >= 200 ? 200 : ((getObjectProperty(___arguments.context.appData, 'Tonnage_Completion_Gauge')) <= 0 ? 0 : (getObjectProperty(___arguments.context.appData, 'Tonnage_Completion_Gauge')))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/ef1f68efbb7706b89ee94343390efbbe/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Profit/Loss_Gauge')) >= 200 ? 200 : ((getObjectProperty(___arguments.context.appData, 'Profit/Loss_Gauge')) <= 0 ? 0 : (getObjectProperty(___arguments.context.appData, 'Profit/Loss_Gauge')))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/e46a800577fea74fb63df1c9763b9dfa/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Consumption_Status_Gauge')) >= 200 ? 200 : ((getObjectProperty(___arguments.context.appData, 'Consumption_Status_Gauge')) <= 0 ? 0 : (getObjectProperty(___arguments.context.appData, 'Consumption_Status_Gauge')))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/9c7b120960da2289f66f95a8bb4f4fc6/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Mileage_Completion_Gauge')) >= 200 ? 200 : ((getObjectProperty(___arguments.context.appData, 'Mileage_Completion_Gauge')) <= 0 ? 0 : (getObjectProperty(___arguments.context.appData, 'Mileage_Completion_Gauge')))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/76d426f4c1e624ea72cbf781a0320ae9/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Diesel_Vs_Turnover_Gauge')) >= 100 ? 100 : ((getObjectProperty(___arguments.context.appData, 'Diesel_Vs_Turnover_Gauge')) <= 0 ? 0 : (getObjectProperty(___arguments.context.appData, 'Diesel_Vs_Turnover_Gauge')))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/972e538d3119fa9f52ea0ec5370af36f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.appData, 'Total_Gain/Loss_Loading')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/2c791a0d52449237887c17bbbdf96b03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.appData, 'Total_Gain/Loss_Driving_style')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/edafc35a25c683bae9acade3bafc9d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'Vehicles_Of_Concern'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/b70f244a1fceac927d4bf34c8126b7d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Payload_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Payload_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Payload_Gauge')))) : 0,'%) Payload Gauge (100% is Target)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/e80fae4eb502b76f685122f3e3efc024/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Tonnage_Completion_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Tonnage_Completion_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Tonnage_Completion_Gauge')))) : 0,'%) Load Completion (100% is Target)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/dcb1d4054524a9db188a7ef134dca4ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Profit/Loss_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Profit/Loss_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Profit/Loss_Gauge')))) : 0,'%) Profit/Loss Status (100% is Target)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/6e6b529d6294aaa6024c995ec7077847/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Consumption_Status_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Consumption_Status_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Consumption_Status_Gauge')))) : 0,'%) Consumption Status (100% is Target)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/930660a1fc5c6bd405e4bee561633915/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Mileage_Completion_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Mileage_Completion_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Mileage_Completion_Gauge')))) : 0,'%) Mileage Completion (100% is Target)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_de469ab69424dc3ccbcc315bff52cfbd/logic/d684f4f5d345180ac70e85958da24231/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Diesel_Vs_Turnover_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Diesel_Vs_Turnover_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Diesel_Vs_Turnover_Gauge')))) : 0,') Diesel vs Turnover'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/c2bf25e11a879218ec9bf2cee348a63f/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Payload_Gauge'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/c72ae3e67b38bf6fbb14500a6c87bb2c/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Tonnage_Completion_Gauge'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/ef1f68efbb7706b89ee94343390efbbe/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Profit/Loss_Gauge'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/e46a800577fea74fb63df1c9763b9dfa/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Consumption_Status_Gauge'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/9c7b120960da2289f66f95a8bb4f4fc6/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Mileage_Completion_Gauge'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/76d426f4c1e624ea72cbf781a0320ae9/bundle.js', [], () => ({
  /* content */
  /* handler:dataLogic */
  ['dataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [(getObjectProperty(___arguments.context.appData, 'Diesel_Vs_Turnover_Gauge'))]

  },
  /* handler:dataLogic */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/972e538d3119fa9f52ea0ec5370af36f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.appData, 'Total_Gain/Loss_Loading')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/2c791a0d52449237887c17bbbdf96b03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String(await BackendlessUI.Functions.Custom['fn_33cce918875b0e28ea229e91af2ba0ad']((getObjectProperty(___arguments.context.appData, 'Total_Gain/Loss_Driving_style')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/edafc35a25c683bae9acade3bafc9d3e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'Vehicles_Of_Concern')) == null ? 'None' : (getObjectProperty(___arguments.context.appData, 'Vehicles_Of_Concern')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/b70f244a1fceac927d4bf34c8126b7d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Payload_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Payload_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Payload_Gauge')))) : 0,'%) Payload Gauge (100% is Target)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/e80fae4eb502b76f685122f3e3efc024/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Tonnage_Completion_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Tonnage_Completion_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Tonnage_Completion_Gauge')))) : 0,'%) Load Completion (100% is Target)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/dcb1d4054524a9db188a7ef134dca4ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Profit/Loss_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Profit/Loss_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Profit/Loss_Gauge')))) : 0,'%) Profit/Loss Status (100% is Target)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/6e6b529d6294aaa6024c995ec7077847/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Consumption_Status_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Consumption_Status_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Consumption_Status_Gauge')))) : 0,'%) Consumption Status (100% is Target)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/930660a1fc5c6bd405e4bee561633915/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Mileage_Completion_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Mileage_Completion_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Mileage_Completion_Gauge')))) : 0,'%) Mileage Completion (100% is Target)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/d684f4f5d345180ac70e85958da24231/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['(',(typeof (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Diesel_Vs_Turnover_Gauge')))) === 'number' && !isNaN((await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Diesel_Vs_Turnover_Gauge')))))) ? (await BackendlessUI.Functions.Custom['fn_aefda8814882c0a621c48f6e160c7939']((getObjectProperty(___arguments.context.appData, 'Diesel_Vs_Turnover_Gauge')))) : 0,') Diesel vs Turnover'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/91bf9ba2dc346297b823eb3f1a39f8af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Gauge_Slider')) == 1) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/93b7076c8e5693916d293292c5b9e23c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Gauge_Slider')) == 2) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/a19625f958e9f634c1e5c7623ba9b5d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Gauge_Slider')) == 3) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/bafb021b00bc727e9dfcc04340794558/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Gauge_Slider')) == 4) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/75fe8ce7f423dbb1d7cf1b4c7b23225c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Gauge_Slider')) == 5) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/0134d2087973d976963501d408a4c663/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Gauge_Slider')) == 6) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.pageData['Gauge_Slider'] = 1;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/95ed37de30612b29f285dd192ec25472/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Gauge_Slider')) == 1) {
    ___arguments.context.pageData['Gauge_Slider'] = 6;
  } else {
    ___arguments.context.pageData['Gauge_Slider'] = ((getObjectProperty(___arguments.context.pageData, 'Gauge_Slider')) - 1);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3b19b327a5342679e08bd3df068d1f7a/logic/ea7c6dbdb58cb117949e9ad392ae6e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Gauge_Slider')) == 6) {
    ___arguments.context.pageData['Gauge_Slider'] = 1;
  } else {
    ___arguments.context.pageData['Gauge_Slider'] = ((getObjectProperty(___arguments.context.pageData, 'Gauge_Slider')) + 1);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9639147d71828b5b936304460beaf0f3/logic/fafec3f7447d185edab64b9688756208/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Add_Loads_Office', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Add_Loads_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_6e347923377a4c1df26e67c6dd73b8b7/logic/2d9a9a72ae82ca626bdc348c8e6586d7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_563cfd7972fc898993eff99c8bed6189']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current_User')), 'AP_Add_Fuel_Office'))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('Add_Fuel_Office', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_fe37361534e5bde7fd285f4ab396dacc/logic/8b63dc07292102b2780926ff73fbf27b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

